webpackJsonp([1],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1497);


/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Backbone, Marionette) {'use strict';
	
	__webpack_require__(26);
	__webpack_require__(12);
	var DateUtils = __webpack_require__(10);
	var StringUtils = __webpack_require__(9);
	var commonInterfaceMixin = {
	    validatedFields: [],
	    // A list of the fields that have received focus
	    _visitedFields: [],
	    validateVisitedFieldsOnly: true,
	    _addVisitedField: function _addVisitedField(fieldName) {
	        if (!fieldName) {
	            return;
	        }
	        if (this._visitedFields.indexOf(fieldName) === -1) {
	            this._visitedFields.push(fieldName);
	        }
	    },
	    _setElementAsVisited: function _setElementAsVisited($visitedElement) {
	        this._addVisitedField($visitedElement.attr('name'));
	        $visitedElement.attr('focused', true);
	    },
	    _isVisitedField: function _isVisitedField(fieldName) {
	        return this._visitedFields.indexOf(fieldName) !== -1;
	    },
	    toggleElementValidationError: function toggleElementValidationError($el, on, error) {
	        var $group = $el.closest('.form-group');
	        if (on) {
	            $group.addClass('has-error');
	            if (error) {
	                $group.find('.help-block').html(error).removeClass('hidden');
	            }
	            $group.find('.form-control-feedback').removeClass('hidden');
	        } else {
	            $group.removeClass('has-error');
	            $group.find('.help-block').html('').addClass('hidden');
	            $group.find('.form-control-feedback').addClass('hidden');
	        }
	    },
	    modelEvents: {
	        'before:validation': function beforeValidation() {
	            var self = this;
	            var validatedFields = _.result(this, 'validatedFields');
	            _.each(validatedFields, function (element, index, list) {
	                self._addVisitedField(element);
	            });
	        }
	    },
	    onModelAttributeValid: function onModelAttributeValid(attr, selector) {
	        if (!this.isRendered) {
	            return false;
	        }
	        this.toggleElementValidationError(this.$('[name=' + attr + ']'), false);
	        return true;
	    },
	    onModelAttributeInvalid: function onModelAttributeInvalid(attr, error, selector) {
	        if (!this.isRendered) {
	            return false;
	        }
	        var $el = this.$('[name=' + attr + ']');
	        if (!this.validateVisitedFieldsOnly || this.validateVisitedFieldsOnly && this._isVisitedField($el.attr('name'))) {
	            // Only inputs that have received focus should show the error.
	            this.toggleElementValidationError($el, true, error);
	        }
	        return true;
	    },
	    onRender: function onRender() {
	        if (this.model || this.collection) {
	            Backbone.Validation.bind(this);
	        }
	        if (this.bindings) {
	            this.stickit();
	        }
	    },
	    onDestroy: function onDestroy() {
	        if (this.model || this.collection) {
	            Backbone.Validation.unbind(this);
	        }
	        if (this.bindings) {
	            this.unstickit();
	        }
	    },
	    _bindModelAttrToDomAttribute: function _bindModelAttrToDomAttribute(model, modelAttr, domAttr, valueCallback) {
	        var self = this;
	
	        function getAttrValue(model) {
	            if (valueCallback) {
	                return valueCallback.call(self, model.get(modelAttr));
	            } else {
	                return model.get(modelAttr) || '';
	            }
	        }
	
	        self.$el.attr(domAttr, getAttrValue(model));
	        model.on('change:' + modelAttr, function (model, value, options) {
	            self.$el.attr(domAttr, getAttrValue(model));
	        });
	    },
	    templateHelpers: function templateHelpers() {
	        return {
	            viewId: this.viewId(),
	            DateUtils: DateUtils,
	            StringUtils: StringUtils
	        };
	    },
	    viewId: function viewId() {
	        return this.cid;
	    }
	};
	
	_.extend(Backbone.Validation.callbacks, {
	    valid: function valid(view, attr, selector) {
	        var validatedFields = _.result(view, 'validatedFields');
	        if (validatedFields && validatedFields.indexOf(attr) === -1) {
	            return;
	        }
	        view.onModelAttributeValid(attr, selector);
	    },
	    invalid: function invalid(view, attr, error, selector) {
	        var validatedFields = _.result(view, 'validatedFields');
	        if (validatedFields && validatedFields.indexOf(attr) === -1) {
	            return;
	        }
	        view.onModelAttributeInvalid(attr, error, selector);
	    }
	});
	
	var ItemView = Marionette.ItemView.extend({});
	_.extend(ItemView.prototype, commonInterfaceMixin);
	
	var LayoutView = Marionette.LayoutView.extend({});
	_.extend(LayoutView.prototype, commonInterfaceMixin);
	
	var CollectionView = Marionette.CollectionView.extend({});
	
	module.exports = {
	    CollectionView: CollectionView,
	    LayoutView: LayoutView,
	    ItemView: ItemView
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(15)))

/***/ },
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var underscoreString = __webpack_require__(28);
	var Dinero = __webpack_require__(27);
	
	module.exports = {
	  capitalize: underscoreString.capitalize,
	  isBlank: underscoreString.isBlank,
	  trim: underscoreString.trim,
	  currency: function currency(value) {
	    // dinero deals in cents hence the * 100, also using the USD formatting.
	    if (value) {
	      return Dinero({ amount: Math.round(parseFloat(value) * 100), currency: 'USD' }).toFormat();
	    } else {
	      return '$0.00';
	    }
	  },
	  num_cond: function num_cond($var1, $op, $var2) {
	    switch ($op) {
	      case "=":
	        return $var1 == $var2;
	      case "!=":
	        return $var1 != $var2;
	      case ">=":
	        return $var1 >= $var2;
	      case "<=":
	        return $var1 <= $var2;
	      case ">":
	        return $var1 > $var2;
	      case "<":
	        return $var1 < $var2;
	      default:
	        return true;
	    }
	  },
	  matchWildCard: function matchWildCard(str, rule) {
	    var escapeRegex = function escapeRegex(str) {
	      return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
	    };
	    return new RegExp("^" + rule.split("*").map(escapeRegex).join(".*") + "$").test(str);
	  },
	  decimalToPercentage: function decimalToPercentage(decimal) {
	    return Math.round(decimal * 100) + '%';
	  },
	  stripSlashes: function stripSlashes(str) {
	    return (str + '').replace(/\\(.?)/g, function (s, n1) {
	      switch (n1) {
	        case '\\':
	          return '\\';
	        case '0':
	          return '\0';
	        case '':
	          return '';
	        default:
	          return n1;
	      }
	    });
	  }
	};

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var _from = __webpack_require__(24);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Constants = __webpack_require__(13);
	var Moment = __webpack_require__(8);
	var MomentRange = __webpack_require__(22);
	var moment = MomentRange.extendMoment(Moment);
	var humanizeDuration = __webpack_require__(25);
	__webpack_require__(23);
	module.exports = {
	    getGuessedTimezone: function getGuessedTimezone() {
	        var timezone = Constants.DEFAULT_TIME_ZONE;
	        try {
	            timezone = moment.tz.guess();
	        } catch (e) {}
	        return timezone;
	    },
	    // Returns the current client time in UTC seconds
	    getNowTimestampSeconds: function getNowTimestampSeconds() {
	        return Math.round(moment.utc().valueOf() / 1000);
	    },
	    getNowTimestampMs: function getNowTimestampMs() {
	        return moment.utc().valueOf();
	    },
	    getFromNow: function getFromNow(timestampSec) {
	        return moment.unix(timestampSec).local().fromNow();
	    },
	    getFormattedTimestamp: function getFormattedTimestamp(timestampSec, options) {
	        if (!timestampSec) {
	            return '';
	        }
	
	        options = _.defaults(options || {}, {
	            displayTimezone: null,
	            format: Constants.DEFAULT_DATE_TIME_DISPLAY_FORMAT
	        });
	
	        if (options.displayTimezone) {
	            var timezoneTime = moment.tz(timestampSec * 1000, options.displayTimezone);
	            return timezoneTime.format(options.format);
	        } else {
	            return moment.unix(timestampSec).local().format(options.format);
	        }
	    },
	    // Returns duration (in seconds by default) from compareToMomentUTC to now
	    getTimeDiffFromNowUTC: function getTimeDiffFromNowUTC(compareToMomentUTC, unit) {
	        var unit = unit || 'seconds';
	        var nowMoment = moment.utc();
	        return nowMoment.diff(compareToMomentUTC, unit);
	    },
	
	    // Turn millisecond duration into human-readable string
	    getHumantizedDuration: function getHumantizedDuration(durationMs) {
	        try {
	            return humanizeDuration(durationMs);
	        } catch (e) {
	            return '';
	        }
	    },
	    isOverlappingDateRanges: function isOverlappingDateRanges(range1FromTo, range2FromTo) {
	        var range1 = moment.range(range1FromTo.from, range1FromTo.to);
	        var range2 = moment.range(range2FromTo.from, range2FromTo.to);
	        return range1.overlaps(range2);
	    },
	    convertTwelveHourTo24Hour: function convertTwelveHourTo24Hour(stringWithAmPm) {
	        var amPm = stringWithAmPm.slice(stringWithAmPm.length - 2);
	        var time = stringWithAmPm.replace(amPm, '');
	        if (amPm == 'pm') {
	            var hourArray = time.split(':');
	            time = parseInt(hourArray[0]) + 12 + ':' + hourArray[1];
	        }
	        return time;
	    },
	    getTimeSlots: function getTimeSlots(day, dayStartTime24Hour, dayEndTime24Hour, dayStartTimeAdjustment, dayEndTimeAdjustment, steps) {
	        var dayStartTime24HourArray = dayStartTime24Hour.split(':');
	        var dayEndTime24HourArray = dayEndTime24Hour.split(':');
	        var day_start = moment(day, 'yyyy-mm-dd').startOf('day').hours(parseInt(dayStartTime24HourArray[0]) + dayStartTimeAdjustment).minutes(dayStartTime24HourArray[1]);
	        var day_end = moment(day, 'yyyy-mm-dd').startOf('day').hours(parseInt(dayEndTime24HourArray[0]) + dayEndTimeAdjustment).minutes(dayEndTime24HourArray[1]);
	        var day = moment.range(day_start, day_end);
	        var time_slots = (0, _from2.default)(day.by('minutes', { step: steps }));
	
	        return time_slots;
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 11 */,
/* 12 */,
/* 13 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	    ACUITY_DATE_TIME_FORMAT: 'YYYY-MM-DDThh:mm:ssZ',
	    DEFAULT_TIME_ZONE: 'America/Vancouver',
	    DEFAULT_DATE_TIME_DISPLAY_FORMAT: 'YYYY-MM-DD hh:mm a',
	    PRETTY_DATE_TIME_DISPLAY_FORMAT: 'MMMM Do YYYY, h:mm a'
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	__webpack_require__(31);
	__webpack_require__(12);
	__webpack_require__(32);
	Backbone.Validation.configure({
	    forceUpdate: true
	});
	
	var EntitiesBase = __webpack_require__(17);
	
	var ModelBase = Backbone.Model.extend({
	    initialize: function initialize(attrs, options) {
	        var self = this;
	        self.options = _.defaults(options || {}, {
	            tracking: options && options.tracking ? options.tracking : self.collection && self.collection._trackingChanges
	        });
	
	        self._trackingChanges = self.options.tracking;
	        if (self._trackingChanges) {
	            self.startTracking();
	        }
	        this.on('error', this.handleError.bind(this));
	    },
	    sync: function sync(method, model, options) {
	        var beforeSend;
	        var self = this;
	
	        options = options || {};
	
	        options.beforeSend = function (xhr) {
	
	            if (method === 'read') {
	
	                var fetchEnded = function fetchEnded() {
	                    self.fetching = false;
	                    self.trigger('fetch:end', self);
	                    self.off('sync error', fetchEnded);
	                    self.off('request', fetchStarted);
	                };
	
	                var fetchStarted = function fetchStarted(model, xhr) {
	                    self.fetching = true;
	                    self.trigger('fetch:start', self);
	                };
	
	                self.on('request', fetchStarted);
	                self.on('sync error', fetchEnded);
	                self.on('sync error', fetchEnded);
	            }
	
	            if (farmacy.settings.restAPI.nonce) {
	                xhr.setRequestHeader('X-WP-Nonce', farmacy.settings.restAPI.nonce);
	            }
	
	            if (beforeSend) {
	                return beforeSend.apply(self, arguments);
	            }
	        };
	
	        // backbone.trackit changes added here because we're overriding sync
	        // and so do they.
	        // backbone.trackit changes start
	        if (method == 'update' || method == 'create' || method == 'patch') {
	            options.success = _.wrap(options.success, _.bind(function (oldSuccess, data, textStatus, jqXHR) {
	                var ret;
	                if (oldSuccess) ret = oldSuccess.call(this, data, textStatus, jqXHR);
	                if (model._trackingChanges) {
	                    model._resetTracking();
	                    model._triggerUnsavedChanges();
	                }
	                return ret;
	            }, this));
	        }
	        // backbone.trackit changes end
	
	        // Update the nonce when a new nonce is returned with the response.
	        options.complete = function (xhr) {
	            var returnedNonce = xhr.getResponseHeader('X-WP-Nonce');
	
	            if (returnedNonce && farmacy.settings.restAPI.nonce !== returnedNonce) {
	                farmacy.settings.restAPI.nonce = returnedNonce;
	            }
	        };
	        return Backbone.sync(method, model, options);
	    },
	    handleError: function handleError(model, resp, options) {
	        var self = this;
	        try {
	            var errors = resp.validation;
	            if (!errors) {
	                return;
	            }
	            _.each(errors, function (val, attr) {
	                _.each(model.associatedViews, function (view) {
	                    Backbone.Validation.callbacks.invalid(view, attr, val.message, 'name');
	                });
	            });
	            _.defer(function () {
	                model.trigger('validated', false, model, errors);
	                model.trigger('validated:invalid', model, errors);
	            });
	        } catch (error) {}
	    },
	    suppressValidationForAttribute: function suppressValidationForAttribute(attr) {
	        if (this.validation) {
	            this.validation[attr] = false;
	        }
	    }
	});
	_.extend(ModelBase.prototype, EntitiesBase.UnsavedChangesHandlingMixin);
	_.extend(ModelBase.prototype, EntitiesBase.NestedEntitiesHandlingMixin);
	
	var PageableCollectionBase = Backbone.PageableCollection.extend({
	    constructor: function constructor(models, options) {
	        this.cid = _.uniqueId('c');
	        Backbone.PageableCollection.prototype.constructor.call(this, models, options);
	    },
	    setQueryParam: function setQueryParam(keysOrObj, value) {
	        var self = this;
	        function setKey(key, value) {
	            if (_.isUndefined(value) || _.isNull(value)) {
	                delete self.queryParams[key];
	            } else {
	                self.queryParams[key] = value;
	            }
	        }
	        if (_.isObject(keysOrObj)) {
	            _.each(keysOrObj, function (value, key, list) {
	                setKey(key, value);
	            });
	        } else {
	            setKey(keysOrObj, value);
	        }
	    },
	    _prepareModel: function _prepareModel(attrs, options) {
	        if (attrs instanceof Backbone.Model) return attrs;
	        options = options ? _.clone(options) : {};
	        options.collection = this;
	        var model;
	        if (_.isFunction(this.createModel)) {
	            model = this.createModel.call(this, attrs, options);
	        } else {
	            model = new this.model(attrs, options);
	        }
	        if (!model.validationError) return model;
	        this.trigger('invalid', this, model.validationError, options);
	        return false;
	    },
	    queryParams: {
	        pageSize: 'per_page',
	        currentPage: 'page',
	        sortKey: 'orderby',
	        order: 'order'
	    },
	    state: {
	        pageSize: 50,
	        order: EntitiesBase.SORT_DIRECTIONS.DESC
	    },
	    parseState: function parseState(resp, queryParams, state, options) {
	        function getValueFromResponseHeader(keyName) {
	            if (options.xhr) {
	                var parsed = parseInt(options.xhr.getResponseHeader(keyName), 10);
	                if (isNaN(parsed)) {
	                    return 0;
	                } else {
	                    return parsed;
	                }
	            } else {
	                return 0;
	            }
	        }
	        return {
	            totalRecords: getValueFromResponseHeader('X-WP-Total'),
	            totalPages: getValueFromResponseHeader('X-WP-TotalPages')
	        };
	    },
	    sync: function sync(method, model, options) {
	        var beforeSend,
	            success,
	            self = this;
	
	        options = options || {};
	        beforeSend = options.beforeSend;
	        options.beforeSend = function (xhr) {
	
	            if (method === 'read') {
	
	                var fetchEnded = function fetchEnded() {
	                    self.fetching = false;
	                    self.trigger('fetch:end', self);
	                    self.off('sync error', fetchEnded);
	                    self.off('request', fetchStarted);
	                };
	
	                var fetchStarted = function fetchStarted(model, xhr) {
	                    self.fetching = true;
	                    self.trigger('fetch:start', self);
	                };
	
	                self.on('request', fetchStarted);
	                self.on('sync error', fetchEnded);
	                self.on('sync error', fetchEnded);
	            }
	
	            if (!_.isUndefined(farmacy.settings.restAPI.nonce)) {
	                xhr.setRequestHeader('X-WP-Nonce', farmacy.settings.restAPI.nonce);
	            }
	
	            if (beforeSend) {
	                return beforeSend.apply(self, arguments);
	            }
	        };
	        return Backbone.PageableCollection.prototype.sync(method, model, options);
	    }
	});
	_.extend(PageableCollectionBase.prototype, EntitiesBase.CollectionNavigationMixin);
	_.extend(PageableCollectionBase.prototype, EntitiesBase.MoveableItemsMixin);
	_.extend(PageableCollectionBase.prototype, EntitiesBase.CollectionChangesTrackingMixin);
	module.exports = {
	    CollectionBase: EntitiesBase.CollectionBase,
	    PageableCollectionBase: PageableCollectionBase,
	    ModelBase: ModelBase,
	    SORT_DIRECTIONS: EntitiesBase.SORT_DIRECTIONS
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(1)))

/***/ },
/* 15 */,
/* 16 */,
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var _stringify = __webpack_require__(46);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(31);
	__webpack_require__(12);
	__webpack_require__(32);
	Backbone.Validation.configure({
	    forceUpdate: true
	});
	
	var CollectionChangesTrackingMixin = {
	    hasUnsavedChanges: function hasUnsavedChanges() {
	        var hasUnsavedChanges = false;
	        var self = this;
	        self.each(function (model) {
	            if (model.hasUnsavedChanges()) {
	                hasUnsavedChanges = true;
	            }
	        });
	        return hasUnsavedChanges;
	    },
	    toggleTracking: function toggleTracking(on) {
	        this._trackingChanges = on;
	        this.each(function (model) {
	            model[on ? 'startTracking' : 'stopTracking']();
	        });
	    },
	    stopTracking: function stopTracking() {
	        this.toggleTracking(false);
	    },
	    startTracking: function startTracking() {
	        this.toggleTracking(true);
	    }
	};
	
	var MoveableItemsMixin = {
	    moveUp: function moveUp(model) {
	        var index = this.indexOf(model);
	        if (index > 0) {
	            this._swap(index, index - 1);
	        }
	    },
	    moveDown: function moveDown(model) {
	        var index = this.indexOf(model);
	        if (index + 1 < this.models.length) {
	            this._swap(index, index + 1);
	        }
	    },
	    moveTo: function moveTo(model, moveToIndex) {
	        var index = this.indexOf(model);
	        if (moveToIndex >= 0 && moveToIndex <= this.models.length - 1) {
	            if (Math.abs(index - moveToIndex) > 1) {
	                this._inject(index, moveToIndex);
	            } else {
	                this._swap(index, moveToIndex);
	            }
	        }
	    },
	    _inject: function _inject(indexA, indexB) {
	        this.models.splice(indexB, 0, this.models.splice(indexA, 1)[0]);
	        this.trigger('item:moved', this.models[indexB], this);
	    },
	    _swap: function _swap(indexA, indexB) {
	        this.models[indexA] = this.models.splice(indexB, 1, this.models[indexA])[0];
	        this.trigger('item:moved', this.models[indexA], this);
	    }
	};
	
	var commonFunctionsMixin = {
	    url: function url() {
	        return FarmacyPluginAjax.ajaxurl;
	    },
	    sync: function sync(method, model, options) {
	        var self = this;
	        var methodMap = {
	            'create': 'POST',
	            'update': 'POST',
	            'patch': 'POST',
	            'delete': 'POST',
	            'read': 'GET'
	        };
	
	        var noXhrPatch = typeof window !== 'undefined' && !!window.ActiveXObject && !(window.XMLHttpRequest && new XMLHttpRequest().dispatchEvent);
	
	        var type = methodMap[method];
	        var methodToActionMap = this.methodToActionMap || this.model.prototype.methodToActionMap;
	
	        if (!methodToActionMap) {
	            throw new Error('methodToActionMap not configured');
	        }
	
	        var action = methodToActionMap[method];
	        if (!action) {
	            throw new Error('action not found in methodToActionMap');
	        }
	
	        // Default options, unless specified.
	        _.defaults(options || (options = {}), {
	            emulateHTTP: Backbone.emulateHTTP,
	            emulateJSON: Backbone.emulateJSON
	        });
	
	        // Default JSON-request options.
	        var params = {
	            type: type,
	            dataType: 'json'
	        };
	        options = options || {};
	        options.data = options.data || {};
	        options.data.security = FarmacyPluginAjax.FarmacyNonce;
	        if (Backbone.Radio) {
	            options.data.pubnubuuid = Backbone.Radio.channel('pubsub').request('getUUID');
	        }
	
	        options.data.action = action;
	        options.emulateJSON = true;
	
	        // Ensure that we have a URL.
	        if (!options.url) {
	            params.url = _.result(model, 'url') || urlError();
	        }
	
	        // Ensure that we have the appropriate request data.
	        if (model && (method === 'create' || method === 'update' || method === 'patch' || method === 'delete')) {
	            params.contentType = 'application/x-www-form-urlencoded';
	            _.extend(options.data, {
	                entity: (0, _stringify2.default)(options.attrs || model.toJSON(options))
	            });
	        }
	
	        // backbone.trackit changes added here because we're overriding sync
	        // and so do they.
	        // backbone.trackit changes start
	        if (method == 'update' || method == 'create' || method == 'patch') {
	            options.success = _.wrap(options.success, _.bind(function (oldSuccess, data, textStatus, jqXHR) {
	                var ret;
	                if (oldSuccess) ret = oldSuccess.call(this, data, textStatus, jqXHR);
	                if (model._trackingChanges) {
	                    model._resetTracking();
	                    model._triggerUnsavedChanges();
	                }
	                return ret;
	            }, this));
	        }
	        // backbone.trackit changes end
	
	        // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
	        // And an `X-HTTP-Method-Override` header.
	        if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
	            params.type = 'POST';
	            if (options.emulateJSON) params.data._method = type;
	            var beforeSend = options.beforeSend;
	            options.beforeSend = function (xhr) {
	                xhr.setRequestHeader('X-HTTP-Method-Override', type);
	                if (beforeSend) return beforeSend.apply(this, arguments);
	            };
	        }
	
	        // Don't process data on a non-GET request.
	        if (params.type !== 'GET' && !options.emulateJSON) {
	            params.processData = false;
	        }
	
	        // If we're sending a `PATCH` request, and we're in an old Internet Explorer
	        // that still has ActiveX enabled by default, override jQuery to use that
	        // for XHR instead. Remove this line when jQuery supports `PATCH` on IE8.
	        if (params.type === 'PATCH' && noXhrPatch) {
	            params.xhr = function () {
	                return new ActiveXObject("Microsoft.XMLHTTP");
	            };
	        }
	
	        // Make the request, allowing the user to override any Ajax options.
	        var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
	        if (method === 'read') {
	
	            var fetchEnded = function fetchEnded() {
	                self.fetching = false;
	                self.trigger('fetch:end', self);
	            };
	
	            var fetchStarted = function fetchStarted(model, xhr) {
	                self.fetching = true;
	                xhr.fail(fetchEnded.bind(self));
	                self.trigger('fetch:start', self);
	            };
	
	            self.on('request', fetchStarted);
	            self.on('sync error', fetchEnded);
	            xhr.always(function () {
	                self.off('sync error', fetchEnded);
	                self.off('request', fetchStarted);
	            });
	        }
	        xhr.then(function () {
	            var nonce = xhr.getResponseHeader('X-WP-FarmacyNonce');
	            if (nonce) {
	                console.log('new nonce passed: ' + nonce);
	                FarmacyPluginAjax.FarmacyNonce = nonce;
	            }
	        });
	        model.trigger('request', model, xhr, options);
	        return xhr;
	    }
	};
	
	var CollectionNavigationMixin = {
	    next: function next(model) {
	        var i = this.at(this.indexOf(model));
	        if (undefined === i || i < 0) return false;
	        return this.at(this.indexOf(model) + 1);
	    },
	    prev: function prev(model) {
	        var i = this.at(this.indexOf(model));
	        if (undefined === i || i < 1) return false;
	        return this.at(this.indexOf(model) - 1);
	    }
	};
	
	var UnsavedChangesHandlingMixin = {
	    unsavedChangesIgnoredAttributes: [],
	    // unsaved is the backbone.trackit configuration key.
	    // We handle route based prompts but use backbone-trackit for
	    // the window prompts.
	    unsaved: {
	        unloadWindowPrompt: function unloadWindowPrompt() {
	            return this.hasUnsavedChanges();
	        }
	    },
	    hasUnsavedChanges: function hasUnsavedChanges(attr) {
	        var hasUnsavedChanges = false;
	        var self = this;
	        if (attr) {
	            hasUnsavedChanges = _.has(this.unsavedAttributes(), attr);
	        } else {
	            _.each(this.unsavedAttributes(), function (value, key, list) {
	                if (self.unsavedChangesIgnoredAttributes.indexOf(key) === -1) {
	                    hasUnsavedChanges = true;
	                }
	            });
	        }
	
	        return hasUnsavedChanges;
	    }
	};
	
	var NestedEntitiesHandlingMixin = {
	    nestedEntities: {
	        // Key of attribute that will hold the entity
	        // with entity type to create. For example:
	        // tag_set: Collections.CollectionBase,
	    },
	    createNestedEntityClass: function createNestedEntityClass(entityKey, entityData) {
	        var entityClass = this.nestedEntities[entityKey];
	        return new entityClass(entityData, {
	            parse: true
	        });
	    },
	    setNestedEntityClass: function setNestedEntityClass(entityKey, entityData) {
	        var entity = this.get(entityKey);
	
	        if (entity instanceof Backbone.Collection) {
	            entity.reset(entityData, { parse: true });
	        } else {
	            entity.set(entity.parse(entityData || {}));
	        }
	    },
	    parse: function parse(response) {
	        var self = this;
	        for (var key in self.nestedEntities) {
	            if (!self.nestedEntities.hasOwnProperty(key)) {
	                continue;
	            }
	            var existingEntity = self.get(key);
	            if (existingEntity instanceof Backbone.Model || existingEntity instanceof Backbone.Collection) {
	                // TODO rtomaselli the problem with setting here is
	                // that any events fired during the set will be
	                // fired before the parent entities events get fired
	                // which could be problematic. Really we should be
	                // overriding the set method for nested entity
	                // handling.
	                // For an example see: https://github.com/blittle/backbone-nested-models
	                self.setNestedEntityClass(key, response[key]);
	                response[key] = existingEntity;
	                continue;
	            }
	
	            var entityData = response[key];
	            if (entityData instanceof Backbone.Model || entityData instanceof Backbone.Collection) {
	                // Attribute previously set to an entity instance
	                // so no more to do.
	                continue;
	            }
	
	            response[key] = self.createNestedEntityClass(key, response[key]);
	        }
	        return Backbone.Model.prototype.parse.call(this, response);
	    },
	    toJSON: function toJSON() {
	        var json = _.clone(this.attributes);
	        if (this.nestedEntities) {
	            for (var key in this.nestedEntities) {
	                if (json[key] && json[key].toJSON) {
	                    json[key] = json[key].toJSON();
	                }
	            }
	        }
	        for (var attr in json) {
	            if (json[attr] instanceof Backbone.Model || json[attr] instanceof Backbone.Collection) {
	                json[attr] = json[attr].toJSON();
	            }
	        }
	        return json;
	    }
	};
	
	var ModelBase = Backbone.Model.extend({
	    initialize: function initialize(attrs, options) {
	        var self = this;
	        self.options = _.defaults(options || {}, {
	            tracking: options && options.tracking ? options.tracking : self.collection && self.collection._trackingChanges
	        });
	
	        self._trackingChanges = self.options.tracking;
	        if (self._trackingChanges) {
	            self.startTracking();
	        }
	        self.on('error', self.handleError.bind(self));
	    },
	    handleError: function handleError(model, resp, options) {
	        var self = this;
	        try {
	            var errors = resp.validation;
	            if (!errors) {
	                return;
	            }
	            _.each(errors, function (val, attr) {
	                _.each(model.associatedViews, function (view) {
	                    Backbone.Validation.callbacks.invalid(view, attr, val.message, 'name');
	                });
	            });
	            _.defer(function () {
	                model.trigger('validated', false, model, errors);
	                model.trigger('validated:invalid', model, errors);
	            });
	        } catch (error) {}
	    },
	    fetchParams: function fetchParams() {
	        return {
	            id: this.id
	        };
	    },
	    fetch: function fetch(options) {
	        var opts = _.defaults(options || {});
	        opts.data = _.defaults(opts.data || {}, this.fetchParams());
	
	        return Backbone.Model.prototype.fetch.call(this, opts);
	    },
	    suppressValidationForAttribute: function suppressValidationForAttribute(attr) {
	        if (this.validation) {
	            this.validation[attr] = false;
	        }
	    }
	});
	_.extend(ModelBase.prototype, NestedEntitiesHandlingMixin);
	_.extend(ModelBase.prototype, commonFunctionsMixin);
	_.extend(ModelBase.prototype, UnsavedChangesHandlingMixin);
	
	var CollectionBase = Backbone.Collection.extend({
	    constructor: function constructor(models, options) {
	        this.cid = _.uniqueId('c');
	        Backbone.Collection.prototype.constructor.call(this, models, options);
	    },
	    fetchParams: function fetchParams() {
	        return {};
	    },
	    fetch: function fetch(options) {
	        var opts = _.defaults(options || {});
	        opts.data = _.defaults(opts.data || {}, this.fetchParams());
	
	        return Backbone.Collection.prototype.fetch.call(this, opts);
	    }
	});
	_.extend(CollectionBase.prototype, MoveableItemsMixin);
	_.extend(CollectionBase.prototype, commonFunctionsMixin);
	_.extend(CollectionBase.prototype, CollectionNavigationMixin);
	
	var SORT_DIRECTIONS = {
	    ASC: -1,
	    DESC: 1,
	    NATURAL: 0
	};
	
	var PageableCollectionBase = Backbone.PageableCollection.extend({
	    constructor: function constructor(models, options) {
	        this.cid = _.uniqueId('c');
	        Backbone.PageableCollection.prototype.constructor.call(this, models, options);
	    },
	    setQueryParam: function setQueryParam(keysOrObj, value) {
	        var self = this;
	        function setKey(key, value) {
	            if (_.isUndefined(value) || _.isNull(value)) {
	                delete self.queryParams[key];
	            } else {
	                self.queryParams[key] = value;
	            }
	        }
	        if (_.isObject(keysOrObj)) {
	            _.each(keysOrObj, function (value, key, list) {
	                setKey(key, value);
	            });
	        } else {
	            setKey(keysOrObj, value);
	        }
	    },
	    _prepareModel: function _prepareModel(attrs, options) {
	        if (attrs instanceof Backbone.Model) return attrs;
	        options = options ? _.clone(options) : {};
	        options.collection = this;
	        var model;
	        if (_.isFunction(this.createModel)) {
	            model = this.createModel.call(this, attrs, options);
	        } else {
	            model = new this.model(attrs, options);
	        }
	        if (!model.validationError) return model;
	        this.trigger('invalid', this, model.validationError, options);
	        return false;
	    },
	    queryParams: {
	        pageSize: 'per_page'
	    },
	    parseState: function parseState(resp, queryParams, state, options) {
	        function getValueFromResponseHeader(keyName) {
	            if (options.xhr) {
	                var parsed = parseInt(options.xhr.getResponseHeader(keyName), 10);
	                if (isNaN(parsed)) {
	                    return 0;
	                } else {
	                    return parsed;
	                }
	            } else {
	                return 0;
	            }
	        }
	
	        return {
	            totalRecords: getValueFromResponseHeader('X-WP-Total'),
	            totalPages: getValueFromResponseHeader('X-WP-TotalPages')
	        };
	    },
	    state: {
	        pageSize: 50,
	        order: SORT_DIRECTIONS.DESC
	    }
	});
	_.extend(PageableCollectionBase.prototype, MoveableItemsMixin);
	_.extend(PageableCollectionBase.prototype, commonFunctionsMixin);
	_.extend(PageableCollectionBase.prototype, CollectionChangesTrackingMixin);
	
	module.exports = {
	    CollectionNavigationMixin: CollectionNavigationMixin,
	    MoveableItemsMixin: MoveableItemsMixin,
	    CollectionBase: CollectionBase,
	    UnsavedChangesHandlingMixin: UnsavedChangesHandlingMixin,
	    NestedEntitiesHandlingMixin: NestedEntitiesHandlingMixin,
	    CollectionChangesTrackingMixin: CollectionChangesTrackingMixin,
	    PageableCollectionBase: PageableCollectionBase,
	    ModelBase: ModelBase,
	    SORT_DIRECTIONS: SORT_DIRECTIONS
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(1)))

/***/ },
/* 18 */,
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $, Marionette, Backbone) {__webpack_require__(6);
	__webpack_require__(35);
	
	var SIZES = {
	    NONE: 'NONE',
	    DEFAULT: 'DEFAULT',
	    SMALL: 'SMALL',
	    LARGE: 'LARGE'
	};
	
	var SIZE_CLASSNAMES = {
	    NONE: '',
	    DEFAULT: '',
	    SMALL: 'btn-sm',
	    LARGE: 'btn-lg'
	};
	
	var THEMES = {
	    NONE: 'NONE',
	    DEFAULT: 'DEFAULT',
	    WARNING: 'WARNING',
	    DANGER: 'DANGER',
	    PRIMARY: 'PRIMARY',
	    SUCCESS: 'SUCCESS'
	};
	
	var THEME_CLASSNAMES = {
	    NONE: '',
	    DEFAULT: 'btn btn-default',
	    WARNING: 'btn btn-warning',
	    DANGER: 'btn btn-danger',
	    PRIMARY: 'btn btn-primary',
	    SUCCESS: 'btn btn-success'
	};
	
	function LoadingSpinner($container, options) {
	    var self = this;
	    self.options = _.defaults(
	        options || {},
	        {
	            fadeDuration: 300
	        }
	    );
	
	    self.$spinner = $('<div>')
	        .addClass('loadingSpinner');
	    $container.append(self.$spinner);
	    self.$spinner.hide().fadeIn(self.options.fadeDuration);
	}
	
	LoadingSpinner.prototype.destroy = function () {
	    return this.$spinner.fadeOut(this.options.fadeDuration, (function (_this) {
	        return function () {
	            _this.$spinner.remove();
	            return _this.$spinner = null;
	        };
	    })(this));
	};
	
	var SpinnerButton = Marionette.ItemView.extend({
	    template: __webpack_require__(36),
	    tagName: 'button',
	    className: function () {
	        var classNames = ['tl-spinner-button'];
	        var sizeClassName = SIZE_CLASSNAMES[this.options.size];
	        if (sizeClassName) {
	            classNames.push(sizeClassName);
	        }
	        var themeClassName = THEME_CLASSNAMES[
	            this.state &&
	            this.state.get('theme') ||
	            this.options.theme
	        ];
	        if (themeClassName) {
	            classNames.push(themeClassName);
	        }
	        if (this.options.classNames) {
	            classNames = classNames.concat(this.options.classNames);
	        }
	
	        if (this.state && this.state.get('label')) {
	            classNames.push('tl-spinner-button-showing-label');
	        }
	
	        return classNames.join(' ');
	    },
	    ui: {
	        label: '.tl-label'
	    },
	    initialize: function (options) {
	        var self = this;
	        this.options = _.defaults(
	            options || {},
	            {
	
	                enabled: true,
	                label: '',
	                theme: THEMES.DEFAULT,
	                size: SIZES.DEFAULT,
	                classNames: '',
	                multiClick: true,
	                onClickedCallback: function () { },
	                fadeDuration: 300,
	                spinnerOn: false,
	                classDuringLoading: 'spinning',
	                glyphiconClassName: null
	            }
	        );
	
	        this.state = new Backbone.Model({
	            enabled: this.options.enabled,
	            label: this.options.label,
	            theme: this.options.theme,
	            spinnerOn: this.options.spinnerOn
	        });
	        this.listenTo(this.state, 'change:theme', this.render);
	    },
	    events: {
	        'click': '_onClicked',
	    },
	    _onClicked: function (e) {
	        var isEnabled = this.state.get('enabled');
	        if (!this.options.multiClick) {
	            this.toggledEnabledState(false);
	        }
	        if (isEnabled) {
	            if (this.options.onClickedCallback) {
	                this.options.onClickedCallback(this, e);
	            }
	            this.trigger('clicked');
	        }
	    },
	    toggleSpinner: function (on) {
	        if (!this.isRendered) {
	            return;
	        }
	        if (on) {
	            this.$el.addClass(this.options.classDuringLoading);
	            this.$childContent.animate({
	                opacity: 0
	            }, this.options.fadeDuration);
	
	            if (!this.spinner) {
	                this.spinner = new LoadingSpinner(this.$el, {
	                    fadeDuration: this.options.fadeDuration
	                });
	            }
	            this.toggledEnabledState(false);
	            return this.$el.prop('disabled', 'true');
	        } else {
	            if (this.spinner) {
	                this.$childContent.animate({
	                    opacity: 1
	                }, this.options.fadeDuration);
	                this.spinner.destroy();
	                this.spinner = null;
	                this.$el.prop('disabled', '');
	                this.toggledEnabledState(true);
	                return this.$el.removeClass(this.options.classDuringLoading);
	            }
	        }
	    },
	    isEnabled: function () {
	        return this.state.get('enabled');
	    },
	    setLabel: function (val) {
	        this.state.set('label', val);
	        this.ui.label.text(val);
	    },
	    setTheme: function (val) {
	        this.state.set('theme', val);
	    },
	    toggledEnabledState: function (enabled) {
	        if (enabled) {
	            this.state.set('enabled', true);
	            this.$el.removeClass('disabled');
	        } else {
	            this.state.set('enabled', false);
	            this.$el.addClass('disabled');
	        }
	    },
	    serializeData: function () {
	        return {
	            state: this.state.toJSON(),
	            options: this.options
	        };
	    },
	    onRender: function () {
	
	        if (this.$el.children().length === 1) {
	            this.$childContent = $(this.$el.children()[0]);
	        } else {
	            this.$childContent = $('<span></span>');
	            if (this.$el.children().length > 1) {
	                this.$childContent.append(this.$el.children());
	            } else {
	                this.$childContent.text(this.state.get('label'));
	            }
	            this.$el.append(this.$childContent);
	        }
	
	        // Calling this here because when backbone calls it
	        // the options hash has not been set yet (i.e.
	        // initialize has not been called at the time that
	        // backbone calls className function)
	        this.$el.attr('class', this.className());
	        this.toggledEnabledState(this.state.get('enabled'));
	        this.toggleSpinner(this.state.get('spinningOn'));
	    }
	});
	
	module.exports = {
	    SpinnerButton: SpinnerButton,
	    THEMES: THEMES,
	    SIZES: SIZES
	};
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(18), __webpack_require__(6), __webpack_require__(16)))

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette, _, Backbone) {__webpack_require__(6);
	__webpack_require__(40);
	var Spinner = Marionette.ItemView.extend({
	    template: __webpack_require__(41),
	    className: 'tl-spinner',
	    modelEvents: {
	        'change:message': 'render'
	    },
	    initialize: function (options) {
	        var self = this;
	        this.options = _.defaults(
	            options || {},
	            {
	                message: 'Loading'
	            }
	        );
	        this.model = new Backbone.Model({
	            message: this.options.message
	        });
	    },
	    serializeData: function () {
	        return {
	            options: this.options,
	            model: this.model.toJSON()
	        };
	    },
	    setMessage: function (message) {
	        this.model.set('message', message);
	    },
	    onRender: function () {
	        this.$el.attr(
	            'showing-message',
	            !_.isEmpty(this.model.get('message'))
	        );
	    }
	});
	module.exports = Spinner;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(7), __webpack_require__(16)))

/***/ },
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Backbone) {'use strict';
	
	__webpack_require__(12);
	
	var LAT_MIN = -90;
	var LAT_MAX = 90;
	var LONG_MIN = -180;
	var LONG_MAX = 180;
	
	_.extend(Backbone.Validation.validators, {
	    longitude: function longitude(value, attr, validatorVal, model, computed) {
	        return this.range(value, attr, [LONG_MIN, LONG_MAX]);
	    },
	    latitude: function latitude(value, attr, validatorVal, model, computed) {
	        return this.range(value, attr, [LAT_MIN, LAT_MAX]);
	    }
	});
	
	module.exports = {
	    getIsRequiredMessageForFieldName: function getIsRequiredMessageForFieldName(fieldName) {
	        return _.template('<%= fieldName %> is required')({
	            fieldName: fieldName
	        });
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette, _, $) {__webpack_require__(71);
	__webpack_require__(6);
	__webpack_require__(47);
	__webpack_require__(76);
	__webpack_require__(47);
	var DropdownListInner = Marionette.ItemView.extend({
	    _currentSelectedModel: null,
	    template: __webpack_require__(44),
	    className: 'tl-dropdown-list-inner',
	    ui: {
	        select: 'select'
	    },
	    events: {
	        'select2:unselecting': function () {
	            this._currentSelectedModel = null;
	
	            if (this.model && this.options.modelValueAttr) {
	                this.model.set(this.options.modelValueAttr, null);
	            }
	
	            this.trigger('selected', null);
	            if (this.options.onSelectedCallback) {
	                this.options.onSelectedCallback(
	                    null,
	                    null
	                );
	            }
	        },
	        'select2:select select': function (evtObj) {
	            if (evtObj.params.data.model) {
	                this._currentSelectedModel = evtObj.params.data.model;
	            } else {
	                this._currentSelectedModel = this._getModelByValueAttrValue(evtObj.params.data.id);
	            }
	
	            if (this.model && this.options.modelValueAttr) {
	                this.model.set(this.options.modelValueAttr, evtObj.params.data.id);
	            }
	
	            this.trigger('selected', evtObj.params.data.id);
	            if (this.options.onSelectedCallback) {
	                this.options.onSelectedCallback(
	                    evtObj.params.data.id,
	                    this._currentSelectedModel
	                );
	            }
	        },
	        'select2:selecting': function (e) {
	            var selectingValue = e.params.args.data.id;
	            // preventSelection is a way for callers to prevent a selection
	            // from being made but still react to it by listening to the
	            // "clicked" event
	            if (this.options.preventSelection &&
	                this.options.preventSelection(selectingValue))
	            {
	                e.preventDefault();
	                this.trigger('clicked', selectingValue);
	                this.ui.select.select2('close');
	            }
	        }
	    },
	    _getModelByValueAttrValue: function (val) {
	        var self = this;
	        return self.collection.find(function (item) {
	            return item.get(self.options.valueAttr) == val;
	        });
	    },
	    val: function (val) {
	        if (_.isUndefined(val)) {
	            return this.ui.select.val();
	        } else {
	            this.ui.select.val(val).trigger('change');
	        }
	    },
	    initialize: function (options) {
	        var self = this;
	        this.options = _.defaults(
	            options || {},
	            {
	                dropdownParent: null,
	                customClassName: '',
	                closeOnSelect: true,
	                dropdownCssClass: '',
	                suppressSearch: false,
	                minimumResultsForSearch: 5,
	                placeholder: undefined,
	                allowClear: false,
	                preventSelection: null,
	                width: undefined,
	                modelAttr: 'dummy',
	                modelValueAttr: undefined,
	                displayAttr: undefined,
	                valueAttr: undefined,
	                iconURLAttr: undefined,
	                openAndFocused: false,
	                inputFocused: true,
	                noIconURLAttr: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/2000px-No_image_available.svg.png',
	                disabled: false,
	                initialValue: undefined,
	                onSelectedCallback: undefined,
	                minimumInputLength: 0,
	                formatResult: function (model, options) {
	                    var template;
	                    var templateVars = {
	                        name: model.get(options.displayAttr)
	                    };
	                    if (options.iconURLAttr) {
	                        template = _.template(
	                            '<div class="tl-wrapper tl-show-icon"><div class="tl-icon-wrapper"><img src="<%= thumbnail %>"></div><div  class="tl-text-wrapper"><%= name %></div></div>'
	                        );
	                        return $(template(
	                            _.extend(
	                                templateVars,
	                                { thumbnail: model.get(options.iconURLAttr) || options.noIconURLAttr }
	                            )
	                        ));
	                    } else {
	                        template = _.template(
	                            '<div class="tl-wrapper"><div class="tl-text-wrapper"><%= name %></div></div>'
	                        );
	                        return $(template(templateVars));
	                    }
	                }
	            }
	        );
	    },
	    onDestroy: function () {
	        if (this.ui.select.data('select2')) {
	            this.ui.select.select2('destroy');
	        }
	    },
	    onShow: function () {
	        if (this.options.initialValue) {
	            this.val(this.options.initialValue);
	        }
	    },
	    _maybeSetSelectedItem: function () {
	      var self = this;
	        if (!self.model ||
	            !self.options.modelValueAttr ||
	            !self.model.get(self.options.modelValueAttr))
	        {
	            return;
	        }
	        function appendSelectedOption (selectedModel) {
	            var selectedOption = new Option(
	                selectedModel.get(self.options.displayAttr),
	                selectedModel.get(self.options.valueAttr),
	                true,
	                true
	            );
	            self.ui.select.append(selectedOption).trigger('change');
	
	            self.ui.select.trigger({
	                type: 'select2:select',
	                params: {
	                    data: _.extend(selectedModel.toJSON(), { model: selectedModel })
	                }
	            });
	        }
	        var selected = self.collection.get(self.model.get(self.options.modelValueAttr));
	        if (selected) {
	            appendSelectedOption(selected);
	        } else if (self._currentSelectedModel &&
	            self._currentSelectedModel.get(self.options.valueAttr) == self.model.get(self.options.modelValueAttr))
	        {
	            appendSelectedOption(self._currentSelectedModel);
	        } else {
	            if (self.options.provideSingleListItemById) {
	                self._setPlaceholderText('Loading...');
	                self.options.provideSingleListItemById(
	                    self.model.get(self.options.modelValueAttr)
	                ).then(function (providedModel) {
	                    appendSelectedOption(providedModel);
	                }).fail(function () {
	                    console.warn('dropdown-list-inner: failed to fetch selected item');
	                }).always(function () {
	                    if (self.options.placeholder) {
	                        self._setPlaceholderText(self.options.placeholder);
	                    } else {
	                        self._setPlaceholderText('');
	                    }
	                });
	            } else {
	                console.warn('dropdown-list-inner: provideSingleListItemById option was not provided');
	            }
	        }
	    },
	    _setPlaceholderText: function (text) {
	        this.$el.find('.select2-selection__placeholder').text(text);
	    },
	    onRender: function () {
	        var self = this;
	
	        // Add a special class to the drop down list flyout if
	        // this drop down list is a child of a modal to ensure
	        // proper z-index.
	        self.ui.select.on('select2:open', function () {
	            if (self.$el.parents('.modal').length) {
	                $('.select2-container.select2-container--open')
	                    .addClass('modal-select2-container');
	            }
	            if (!self.options.inputFocused) {
	              $('.select2-search input').prop('focus', 0);
	            }
	        });
	
	        function formatState (state) {
	            if (!state.id) {
	                return state.text;
	            }
	            if (self.options.formatResult) {
	                return self.options.formatResult(
	                    self._getModelByValueAttrValue(state.id),
	                    self.options
	                );
	            }
	            return state.text;
	        }
	
	        var select2Options = {
	            minimumResultsForSearch:
	                self.options.suppressSearch ?
	                Infinity :
	                self.options.minimumResultsForSearch,
	            placeholder: self.options.placeholder,
	            allowClear: self.options.allowClear,
	            closeOnSelect: self.options.closeOnSelect,
	            minimumInputLength: self.options.minimumInputLength,
	            inputTooShortMessage: null,
	            width: self.options.width,
	            dropdownCssClass: 'tl-dropdown-list-inner-select2-container ' + self.options.dropdownCssClass,
	            ajax: {
	                delay: 250,
	                transport: function (params, success, failure) {
	                    var page = params.data.page || 1;
	                    var remove = page === 1 ? true : false;
	                    var $request = self.collection.fetch(
	                        {
	                            remove: remove,
	                            data: {
	                                page: page,
	                                search_term: params.data.term || ''
	                            },
	                            success: function (collection, response, options) {
	
	                                if (response) {
	                                    var numPages =
	                                        parseInt(options.xhr.getResponseHeader('X-WP-TotalPages'), 10);
	                                    var processed = {
	                                        results: [],
	                                        pagination: {}
	                                    };
	                                    _.each(response, function (item) {
	                                        processed.results.push({
	                                            id: item[self.options.valueAttr],
	                                            text: item[self.options.displayAttr]
	                                        });
	                                    });
	                                    processed.pagination.more = page < numPages;
	                                    success(processed);
	
	                                } else {
	                                    failure();
	                                }
	                            }
	                    });
	
	                    return $request;
	                  }
	            },
	            dropdownAutoWidth: 'true',
	            disabled: self.options.disabled,
	            templateResult: formatState
	        };
	
	        if (self.options.inputTooShortMessage) {
	            select2Options.language = {
	                inputTooShort: function () {
	                    return self.options.inputTooShortMessage;
	                }
	            };
	        }
	
	        if (self.options.dropdownParent) {
	            select2Options.dropdownParent = self.options.dropdownParent;
	        }
	
	        self.ui.select.select2(select2Options);
	
	        self._maybeSetSelectedItem();
	
	        self.$el.addClass(self.options.customClassName);
	
	        if (self.options.modelValueAttr) {
	            self.$el.attr('name', self.options.modelValueAttr);
	        }
	
	        self.ui.select.data('select2').on('results:message', function (evtObj) {
	            // Reposition the dropdown when the inputTooShort message is shown as
	            // without this the dropdown does not get re-positioned and
	            // sits disconnected from the search entry box.
	            if (evtObj.message === 'inputTooShort') {
	                this.dropdown._positionDropdown();
	            }
	        });
	
	        if (this.options.openAndFocused) {
	          _.delay(function () {
	            self.ui.select.select2('open');
	            $('.select2-container.select2-container--open')
	                .addClass('modal-select2-container');
	          }, 100);
	        }
	
	    },
	    serializeData: function () {
	        return {
	            options: this.options
	        };
	    }
	});
	module.exports = DropdownListInner;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(7), __webpack_require__(18)))

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".tl-spinner-button {\n  display: block;\n  position: relative;\n  text-transform: uppercase;\n  cursor: pointer; }\n  .tl-spinner-button.tl-spinner-button-showing-label .glyphicon {\n    margin-right: 5px; }\n  .tl-spinner-button:disabled {\n    cursor: default; }\n  .tl-spinner-button span {\n    white-space: normal; }\n  .tl-spinner-button .loadingSpinner {\n    border-width: 4px;\n    border-style: solid;\n    border-top-color: transparent;\n    border-left-color: transparent;\n    border-bottom-color: #FFFFFF;\n    border-right-color: #FFFFFF;\n    width: 20px;\n    height: 20px;\n    opacity: 0.8;\n    border-radius: 50%;\n    animation: loadingSpinner 0.7s infinite linear;\n    -webkit-animation: loadingSpinner 0.7s infinite linear; }\n  .tl-spinner-button .loadingSpinner {\n    margin-top: -10px;\n    margin-left: -10px;\n    position: absolute;\n    top: 50%;\n    left: 50%; }\n\n@keyframes loadingSpinner {\n  from {\n    transform: rotate(0deg); }\n  to {\n    transform: rotate(360deg); } }\n\n@-webkit-keyframes loadingSpinner {\n  from {\n    -webkit-transform: rotate(0deg); }\n  to {\n    -webkit-transform: rotate(360deg); } }\n  .tl-spinner-button.btn-default .loadingSpinner {\n    border-bottom-color: #808080;\n    border-right-color: #808080; }\n", ""]);
	
	// exports


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(34);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./spinner-button.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./spinner-button.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 36 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	 if (options.glyphiconClassName) { 
	__p+='\n<i class="glyphicon '+
	((__t=( options.glyphiconClassName ))==null?'':__t)+
	'"></i>\n';
	 } 
	__p+='\n';
	 if (state.label) { 
	__p+='\n<span class="tl-label">'+
	((__t=( state.label ))==null?'':__t)+
	'</span>\n';
	 } 
	__p+='';
	}
	return __p;
	};


/***/ },
/* 37 */,
/* 38 */,
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".tl-spinner {\n  text-align: center;\n  height: 100%; }\n  .tl-spinner[showing-message=\"true\"] .tl-message {\n    display: inline-block; }\n  .tl-spinner[showing-message=\"true\"] .tl-spinner-inner-4 {\n    background-color: white;\n    border-radius: 5px;\n    padding: 10px; }\n  .tl-spinner .tl-message {\n    display: none;\n    vertical-align: middle;\n    margin-left: 5px; }\n  .tl-spinner .tl-spinner-inner {\n    display: inline-block;\n    height: 100%; }\n    .tl-spinner .tl-spinner-inner .tl-spinner-inner-2 {\n      display: table;\n      height: 100%; }\n      .tl-spinner .tl-spinner-inner .tl-spinner-inner-2 .tl-spinner-inner-3 {\n        display: table-cell;\n        vertical-align: middle; }\n  .tl-spinner .sk-fading-circle {\n    display: inline-block;\n    vertical-align: middle;\n    width: 40px;\n    height: 40px;\n    position: relative; }\n  .tl-spinner .sk-fading-circle .sk-circle {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    top: 0; }\n  .tl-spinner .sk-fading-circle .sk-circle:before {\n    content: '';\n    display: block;\n    margin: 0 auto;\n    width: 15%;\n    height: 15%;\n    background-color: #333;\n    border-radius: 100%;\n    -webkit-animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;\n    animation: sk-circleFadeDelay 1.2s infinite ease-in-out both; }\n  .tl-spinner .sk-fading-circle .sk-circle2 {\n    -webkit-transform: rotate(30deg);\n    -ms-transform: rotate(30deg);\n    transform: rotate(30deg); }\n  .tl-spinner .sk-fading-circle .sk-circle3 {\n    -webkit-transform: rotate(60deg);\n    -ms-transform: rotate(60deg);\n    transform: rotate(60deg); }\n  .tl-spinner .sk-fading-circle .sk-circle4 {\n    -webkit-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    transform: rotate(90deg); }\n  .tl-spinner .sk-fading-circle .sk-circle5 {\n    -webkit-transform: rotate(120deg);\n    -ms-transform: rotate(120deg);\n    transform: rotate(120deg); }\n  .tl-spinner .sk-fading-circle .sk-circle6 {\n    -webkit-transform: rotate(150deg);\n    -ms-transform: rotate(150deg);\n    transform: rotate(150deg); }\n  .tl-spinner .sk-fading-circle .sk-circle7 {\n    -webkit-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    transform: rotate(180deg); }\n  .tl-spinner .sk-fading-circle .sk-circle8 {\n    -webkit-transform: rotate(210deg);\n    -ms-transform: rotate(210deg);\n    transform: rotate(210deg); }\n  .tl-spinner .sk-fading-circle .sk-circle9 {\n    -webkit-transform: rotate(240deg);\n    -ms-transform: rotate(240deg);\n    transform: rotate(240deg); }\n  .tl-spinner .sk-fading-circle .sk-circle10 {\n    -webkit-transform: rotate(270deg);\n    -ms-transform: rotate(270deg);\n    transform: rotate(270deg); }\n  .tl-spinner .sk-fading-circle .sk-circle11 {\n    -webkit-transform: rotate(300deg);\n    -ms-transform: rotate(300deg);\n    transform: rotate(300deg); }\n  .tl-spinner .sk-fading-circle .sk-circle12 {\n    -webkit-transform: rotate(330deg);\n    -ms-transform: rotate(330deg);\n    transform: rotate(330deg); }\n  .tl-spinner .sk-fading-circle .sk-circle2:before {\n    -webkit-animation-delay: -1.1s;\n    animation-delay: -1.1s; }\n  .tl-spinner .sk-fading-circle .sk-circle3:before {\n    -webkit-animation-delay: -1s;\n    animation-delay: -1s; }\n  .tl-spinner .sk-fading-circle .sk-circle4:before {\n    -webkit-animation-delay: -0.9s;\n    animation-delay: -0.9s; }\n  .tl-spinner .sk-fading-circle .sk-circle5:before {\n    -webkit-animation-delay: -0.8s;\n    animation-delay: -0.8s; }\n  .tl-spinner .sk-fading-circle .sk-circle6:before {\n    -webkit-animation-delay: -0.7s;\n    animation-delay: -0.7s; }\n  .tl-spinner .sk-fading-circle .sk-circle7:before {\n    -webkit-animation-delay: -0.6s;\n    animation-delay: -0.6s; }\n  .tl-spinner .sk-fading-circle .sk-circle8:before {\n    -webkit-animation-delay: -0.5s;\n    animation-delay: -0.5s; }\n  .tl-spinner .sk-fading-circle .sk-circle9:before {\n    -webkit-animation-delay: -0.4s;\n    animation-delay: -0.4s; }\n  .tl-spinner .sk-fading-circle .sk-circle10:before {\n    -webkit-animation-delay: -0.3s;\n    animation-delay: -0.3s; }\n  .tl-spinner .sk-fading-circle .sk-circle11:before {\n    -webkit-animation-delay: -0.2s;\n    animation-delay: -0.2s; }\n  .tl-spinner .sk-fading-circle .sk-circle12:before {\n    -webkit-animation-delay: -0.1s;\n    animation-delay: -0.1s; }\n\n@-webkit-keyframes sk-circleFadeDelay {\n  0%,\n  39%,\n  100% {\n    opacity: 0; }\n  40% {\n    opacity: 1; } }\n\n@keyframes sk-circleFadeDelay {\n  0%,\n  39%,\n  100% {\n    opacity: 0; }\n  40% {\n    opacity: 1; } }\n", ""]);
	
	// exports


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(39);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./spinner.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./spinner.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="tl-spinner-inner">\n    <div class="tl-spinner-inner-2">\n        <div class="tl-spinner-inner-3">\n            <div class="tl-spinner-inner-4">\n                <div class="sk-fading-circle">\n                    <div class="sk-circle1 sk-circle"></div>\n                    <div class="sk-circle2 sk-circle"></div>\n                    <div class="sk-circle3 sk-circle"></div>\n                    <div class="sk-circle4 sk-circle"></div>\n                    <div class="sk-circle5 sk-circle"></div>\n                    <div class="sk-circle6 sk-circle"></div>\n                    <div class="sk-circle7 sk-circle"></div>\n                    <div class="sk-circle8 sk-circle"></div>\n                    <div class="sk-circle9 sk-circle"></div>\n                    <div class="sk-circle10 sk-circle"></div>\n                    <div class="sk-circle11 sk-circle"></div>\n                    <div class="sk-circle12 sk-circle"></div>\n                </div>\n                <div class="tl-message">'+
	((__t=( model.message ))==null?'':_.escape(__t))+
	'</div>\n            </div>\n        </div>\n    </div>\n</div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Backbone) {var validationUtils = __webpack_require__(29);
	var EntitiesBase = __webpack_require__(14);
	var ProductVendorModel = EntitiesBase.ModelBase.extend({
	    constructor: function(attrs, options) {
	        EntitiesBase.ModelBase.prototype.constructor.call(this, attrs, options);
	    },
	    urlRoot: function () {
	        return farmacy.settings.restAPI.root + 'wp/v3/product-vendors';
	    },
	    validation: {
	        name: {
	            required: true
	        },
	        code: {
	            required: true
	        },
	        lat: {
	            required: false,
	            latitude: true
	        },
	        lng: {
	            required: false,
	            longitude: true
	        }
	    }
	});
	_.extend(ProductVendorModel.prototype, Backbone.Validation.mixin);
	
	var PageableProductVendorsCollection = EntitiesBase.PageableCollectionBase.extend({
	    constructor: function(models, options) {
	        EntitiesBase.PageableCollectionBase.prototype.constructor.call(this, models, options);
	    },
	    url: function () {
	        return farmacy.settings.restAPI.root + 'wp/v3/product-vendors';
	    },
	    state: _.extend({},
	        EntitiesBase.PageableCollectionBase.prototype.state, {
	            sortKey: 'code',
	            order: EntitiesBase.SORT_DIRECTIONS.ASC,
	            filterHideOnMenuFilter: true
	        }
	    ),
	    model: ProductVendorModel,
	});
	
	module.exports = {
	    ProductVendorModel: ProductVendorModel,
	    PageableProductVendorsCollection: PageableProductVendorsCollection
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, Marionette, _, $) {__webpack_require__(71);
	__webpack_require__(60);
	__webpack_require__(6);
	__webpack_require__(47);
	__webpack_require__(52);
	Backbone.Stickit.addHandler({
	    selector: 'select.select2',
	    initialize: function($el, model, opt) {
	        var e = 'change:' + opt.observe, self = this;
	        function formatState (state) {
	            if (!state.id) {
	                return state.text;
	            }
	            if (self.options.formatResult) {
	                return self.options.formatResult(
	                    self._getModelByValueAttrValue(state.element.value)
	                );
	            }
	            return state.text;
	        }
	
	        $el.select2({
	            dropdownCssClass: 'tl-dropdown-list-select2-container ' + this.options.dropdownCssClass,
	            minimumResultsForSearch:
	                this.options.suppressSearch ?
	                Infinity :
	                this.options.minimumResultsForSearch,
	            placeholder: this.options.placeholder,
	            allowClear: this.options.allowClear,
	            width: this.options.width,
	            dropdownAutoWidth: 'true',
	            disabled: this.options.disabled,
	            templateResult: formatState,
	            dropdownParent: this.options.dropdownParent
	        });
	        var up = function(m, v, o) {
	            if (!o.stickitChange) {
	                $el.trigger('change');
	            }
	        };
	        this.listenTo(model, e, up);
	        this.listenTo(model, 'stickit:unstuck', function() {
	            self.stopListening(model, e, up);
	        });
	    }
	});
	
	var DropdownList = Marionette.ItemView.extend({
	    template: __webpack_require__(44),
	    className: 'tl-dropdown-list',
	    ui: {
	        select: 'select'
	    },
	    bindings: function () {
	        var bindings = {};
	        bindings.select = {};
	        bindings.select.observe = this.options.modelAttr;
	        bindings.select.setOptions = {
	            validate: this.options.validateOnSet
	        };
	        bindings.select.selectOptions = {
	            collection: this.collection,
	            labelPath: this.options.displayAttr,
	            valuePath: this.options.valueAttr
	        };
	        if (this.options.placeholder) {
	            bindings.select.selectOptions =
	                _.extend(
	                    bindings.select.selectOptions,
	                    {
	                        defaultOption: {
	                            label: this.options.placeholder,
	                            value: null
	                        }
	                    }
	                );
	        }
	        return bindings;
	    },
	    events: {
	        'select2:unselect': function () {
	            if (this.options.multipleSelectionsAllowed) {
	                this.trigger('selected', this.val());
	                if (this.options.onSelectedCallback) {
	                    this.options.onSelectedCallback(
	                        this.val()
	                    );
	                }
	            } else {
	                this.trigger('selected', null);
	                if (this.options.onSelectedCallback) {
	                    this.options.onSelectedCallback(
	                        null,
	                        null
	                    );
	                }
	            }
	        },
	        'select2:select select': function () {
	            this.trigger('selected', this.val());
	            if (this.options.multipleSelectionsAllowed) {
	                if (this.options.onSelectedCallback) {
	                    this.options.onSelectedCallback(
	                        this.val()
	                    );
	                }
	            } else {
	                if (this.options.onSelectedCallback) {
	                    this.options.onSelectedCallback(
	                        this.val(),
	                        this._getModelByValueAttrValue(this.val())
	                    );
	                }
	            }
	        },
	        'select2:selecting': function (e) {
	            var selectingValue = e.params.args.data.id;
	            // preventSelection is a way for callers to prevent a selection
	            // from being made but still react to it by listening to the
	            // "clicked" event
	            if (this.options.preventSelection &&
	                this.options.preventSelection(selectingValue))
	            {
	                e.preventDefault();
	                this.trigger('clicked', selectingValue);
	                this.ui.select.select2('close');
	            }
	        }
	    },
	    _getModelByValueAttrValue: function (val) {
	        var self = this;
	        return _.find(self.collection, function (item) {
	            return item[self.options.valueAttr] == val;
	        });
	    },
	    val: function (val) {
	        if (_.isUndefined(val)) {
	            return this.ui.select.val();
	        } else {
	            this.ui.select.val(val).trigger('change');
	        }
	    },
	    initialize: function (options) {
	        var that = this;
	        this.options = _.defaults(
	            options || {},
	            {
	                customClassName: '',
	                dropdownParent: null,
	                dropdownCssClass: '',
	                suppressSearch: false,
	                minimumResultsForSearch: 5,
	                placeholder: undefined,
	                allowClear: false,
	                preventSelection: null,
	                width: undefined,
	                modelAttr: 'dummy',
	                displayAttr: undefined,
	                valueAttr: undefined,
	                disabled: false,
	                initialValue: undefined,
	                onSelectedCallback: undefined,
	                validateOnSet: false,
	                multipleSelectionsAllowed: false
	            }
	        );
	        this.model = this.options.model || new Backbone.Model();
	    },
	    onDestroy: function () {
	        if (this.ui.select.data('select2')) {
	            this.ui.select.select2('destroy');
	        }
	        this.unstickit();
	    },
	    onShow: function () {
	        if (this.options.initialValue) {
	            this.val(this.options.initialValue);
	        }
	    },
	    onRender: function () {
	        var that = this;
	
	        // Add a special class to the drop down list flyout if
	        // this drop down list is a child of a modal to ensure
	        // proper z-index.
	        this.ui.select.on('select2:open', function () {
	            if (that.$el.parents('.modal').length) {
	                $('.select2-container.select2-container--open')
	                    .addClass('modal-select2-container');
	            }
	        });
	
	        this.$el.addClass(this.options.customClassName);
	
	        this.stickit();
	    },
	    serializeData: function () {
	        return {
	            options: this.options
	        };
	    }
	});
	module.exports = DropdownList;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16), __webpack_require__(6), __webpack_require__(7), __webpack_require__(18)))

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<select class="select2"\n    ';
	 if (options.multipleSelectionsAllowed) { 
	__p+='\n    multiple="multiple"\n    ';
	 } 
	__p+='\n    name="'+
	((__t=( options.modelAttr ))==null?'':_.escape(__t))+
	'"\n    style="width: '+
	((__t=( options.width ))==null?'':_.escape(__t))+
	'"></select>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Backbone) {'use strict';
	
	var EntitiesBase = __webpack_require__(14);
	var StrainGroupModel = EntitiesBase.ModelBase.extend({
	    validation: {
	        code: {
	            required: true
	        },
	        name: {
	            required: true
	        }
	    },
	    constructor: function constructor(attrs, options) {
	        EntitiesBase.ModelBase.prototype.constructor.call(this, attrs, options);
	    },
	    urlRoot: function urlRoot() {
	        return farmacy.settings.restAPI.root + 'wp/v3/strain-groups';
	    }
	});
	_.extend(StrainGroupModel.prototype, Backbone.Validation.mixin);
	
	var PageableStrainGroupsCollection = EntitiesBase.PageableCollectionBase.extend({
	    url: function url() {
	        return farmacy.settings.restAPI.root + 'wp/v3/strain-groups';
	    },
	    constructor: function constructor(models, options) {
	        EntitiesBase.PageableCollectionBase.prototype.constructor.call(this, models, options);
	    },
	    state: _.extend({}, EntitiesBase.PageableCollectionBase.prototype.state, {
	        sortKey: 'name',
	        order: EntitiesBase.SORT_DIRECTIONS.ASC
	    }),
	    model: StrainGroupModel
	});
	
	module.exports = {
	    StrainGroupModel: StrainGroupModel,
	    PageableStrainGroupsCollection: PageableStrainGroupsCollection
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 46 */,
/* 47 */,
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	module.exports = {
	    isOnSale: function isOnSale() {
	        var hasVariantOnSale = this.get('variants').findWhere({ on_sale: true });
	        if (hasVariantOnSale) {
	            return true;
	        } else {
	            return false;
	        }
	    },
	    isOnClearance: function isOnClearance() {
	        var hasVariantOnClearance = this.get('variants').findWhere({ on_clearance: true });
	        if (hasVariantOnClearance) {
	            return true;
	        } else {
	            return false;
	        }
	    },
	    isFarmExclusive: function isFarmExclusive() {
	        return this.get('is_farm_exclusive') == 1;
	    },
	    isBCGrown: function isBCGrown() {
	        return this.get('is_bc_grown') == 1;
	    },
	    isOrganic: function isOrganic() {
	        return this.get('is_organic') == 1;
	    },
	    isVegan: function isVegan() {
	        return this.get('is_vegan') == 1;
	    },
	    isSeasonal: function isSeasonal() {
	        return this.get('is_seasonal') == 1;
	    },
	    isHighCBD: function isHighCBD() {
	        return this.get('is_high_cbd') == 1;
	    },
	    isHighCBNCBG: function isHighCBNCBG() {
	        return this.get('is_high_cbn_cbg') == 1;
	    },
	    getStrainGroupCode: function getStrainGroupCode() {
	        var strainGroup = this.get('strain_group');
	        if (strainGroup) {
	            return strainGroup.get('code');
	        }
	        return '';
	    },
	    getProductImage: function getProductImage(useFirstWhenNoPrimary) {
	        useFirstWhenNoPrimary = _.isUndefined(useFirstWhenNoPrimary) ? useFirstWhenNoPrimary : true;
	        var images = this.get('images');
	        if (images) {
	            var primaryImage = images.findWhere({ is_primary: '1' });
	            if (primaryImage) {
	                return primaryImage;
	            } else if (useFirstWhenNoPrimary && images.size()) {
	                return images.at(0);
	            } else {
	                return null;
	            }
	        } else {
	            return null;
	        }
	    },
	    getProductImageURL: function getProductImageURL(sizeName, useFirstWhenNoPrimary) {
	        useFirstWhenNoPrimary = _.isUndefined(useFirstWhenNoPrimary) ? useFirstWhenNoPrimary : true;
	        var productImage = this.getProductImage(useFirstWhenNoPrimary);
	        if (productImage) {
	            return productImage.get(sizeName + '_url');
	        }
	        return '';
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 49 */,
/* 50 */,
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".tl-dropdown-list .select2-selection {\n  outline: none; }\n", ""]);
	
	// exports


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(51);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./dropdown-list.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./dropdown-list.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment, _, Backbone) {'use strict';
	
	var EntitiesBase = __webpack_require__(14);
	var lsCache = __webpack_require__(77);
	var Moment = __webpack_require__(8);
	var validationUtils = __webpack_require__(29);
	var DateUtils = __webpack_require__(10);
	
	var LAT_MIN = -90;
	var LAT_MAX = 90;
	var LONG_MIN = -180;
	var LONG_MAX = 180;
	
	var LOCATION_TYPES = {
	    STORE: 'store', // Physical store
	    ONLINE: 'online' // Mail order
	};
	
	var LocationModel = EntitiesBase.ModelBase.extend({
	    validation: {
	        name: {
	            required: true
	        },
	        slug: {
	            required: true
	        },
	        type: {
	            required: true
	        },
	        phone: {
	            required: true
	        },
	        email: {
	            required: true,
	            pattern: 'email'
	        },
	        line_1: {
	            required: true
	        },
	        city: {
	            required: true
	        },
	        postal_code: {
	            required: true,
	            msg: validationUtils.getIsRequiredMessageForFieldName('Postal Code')
	        },
	        province: {
	            required: true
	        },
	        lat: {
	            required: function required() {
	                return this.get('type') === LOCATION_TYPES.STORE;
	            },
	            latitude: true
	        },
	        lng: {
	            required: function required() {
	                return this.get('type') === LOCATION_TYPES.STORE;
	            },
	            longitude: true
	        },
	        map_url: {
	            required: function required() {
	                return this.get('type') === LOCATION_TYPES.STORE;
	            }
	        },
	        delivery_hours_monday_start_time: function delivery_hours_monday_start_time(value) {
	            if (this.validateDeliveryStartEndTime(value, 'monday')) {
	                return 'Error';
	            }
	        },
	        delivery_hours_monday_end_time: function delivery_hours_monday_end_time(value) {
	            if (this.validateDeliveryStartEndTime(value, 'monday')) {
	                return 'Error';
	            }
	        },
	        delivery_hours_tuesday_start_time: function delivery_hours_tuesday_start_time(value) {
	            if (this.validateDeliveryStartEndTime(value, 'tuesday')) {
	                return 'Error';
	            }
	        },
	        delivery_hours_tuesday_end_time: function delivery_hours_tuesday_end_time(value) {
	            if (this.validateDeliveryStartEndTime(value, 'tuesday')) {
	                return 'Error';
	            }
	        },
	        delivery_hours_wednesday_start_time: function delivery_hours_wednesday_start_time(value) {
	            if (this.validateDeliveryStartEndTime(value, 'wednesday')) {
	                return 'Error';
	            }
	        },
	        delivery_hours_wednesday_end_time: function delivery_hours_wednesday_end_time(value) {
	            if (this.validateDeliveryStartEndTime(value, 'wednesday')) {
	                return 'Error';
	            }
	        },
	        delivery_hours_thursday_start_time: function delivery_hours_thursday_start_time(value) {
	            if (this.validateDeliveryStartEndTime(value, 'thursday')) {
	                return 'Error';
	            }
	        },
	        delivery_hours_thursday_end_time: function delivery_hours_thursday_end_time(value) {
	            if (this.validateDeliveryStartEndTime(value, 'thursday')) {
	                return 'Error';
	            }
	        },
	        delivery_hours_friday_start_time: function delivery_hours_friday_start_time(value) {
	            if (this.validateDeliveryStartEndTime(value, 'friday')) {
	                return 'Error';
	            }
	        },
	        delivery_hours_friday_end_time: function delivery_hours_friday_end_time(value) {
	            if (this.validateDeliveryStartEndTime(value, 'friday')) {
	                return 'Error';
	            }
	        },
	        delivery_hours_saturday_start_time: function delivery_hours_saturday_start_time(value) {
	            if (this.validateDeliveryStartEndTime(value, 'saturday')) {
	                return 'Error';
	            }
	        },
	        delivery_hours_saturday_end_time: function delivery_hours_saturday_end_time(value) {
	            if (this.validateDeliveryStartEndTime(value, 'saturday')) {
	                return 'Error';
	            }
	        },
	        delivery_hours_sunday_start_time: function delivery_hours_sunday_start_time(value) {
	            if (this.validateDeliveryStartEndTime(value, 'sunday')) {
	                return 'Error';
	            }
	        },
	        delivery_hours_sunday_end_time: function delivery_hours_sunday_end_time(value) {
	            if (this.validateDeliveryStartEndTime(value, 'sunday')) {
	                return 'Error';
	            }
	        },
	        default_tip: {
	            required: true
	        }
	    },
	    validateDeliveryStartEndTime: function validateDeliveryStartEndTime(value, index) {
	        var open = parseInt(this.get('delivery_hours_' + index + '_open')) == 1 || this.get('delivery_hours_' + index + '_open') == true;
	        if ((!value || value == '') && open) {
	            return true;
	        }
	    },
	    LOCATION_TYPES: LOCATION_TYPES,
	    urlRoot: function urlRoot() {
	        return farmacy.settings.restAPI.root + 'wp/v3/locations';
	    },
	    defaults: {
	        'type': LOCATION_TYPES.STORE
	    },
	    deliveryNextAvailable: function deliveryNextAvailable() {
	
	        var serverUnixTime = moment().unix() + this.get('server_client_time_offset');
	        var days_of_the_week = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
	
	        var today_lower = DateUtils.getFormattedTimestamp(serverUnixTime, {
	            format: 'dddd'
	        }).toLowerCase();
	        var open = 0;
	        var loop_count = 0;
	
	        var today_open = this.get('delivery_hours_' + today_lower + '_open');
	        var today_start_time = this.get('delivery_hours_' + today_lower + '_start_time');
	        var today_end_time = this.get('delivery_hours_' + today_lower + '_end_time');
	        var dayOffset = 0;
	        //determine its before opening, or after closing on the current day
	        //-1 is before, 0 is after
	
	        if (today_open == '1' && today_start_time !== null && today_start_time !== '' && today_end_time !== null && today_end_time !== '') {
	            var dateString = DateUtils.getFormattedTimestamp(serverUnixTime, {
	                format: 'YYYY-MM-DD'
	            });
	            var startTimeUnixTime = moment(dateString + ' ' + today_start_time, 'YYYY-MM-DD H:mmA').unix() + this.get('server_client_time_offset');
	            var endTimeUnixTime = moment(dateString + ' ' + today_end_time, 'YYYY-MM-DD H:mmA').unix() + this.get('server_client_time_offset');
	            if (serverUnixTime <= startTimeUnixTime || serverUnixTime <= endTimeUnixTime) {
	                dayOffset = 1;
	            }
	        }
	        var day_array_key = days_of_the_week.indexOf(today_lower) - dayOffset;
	
	        while (open == 0) {
	            if (day_array_key == days_of_the_week.length - 1) {
	                day_array_key = 0;
	            } else {
	                day_array_key += 1;
	            }
	
	            var day_lower = days_of_the_week[day_array_key];
	            var open_day = this.get('delivery_hours_' + day_lower + '_open');
	            var day_start_time = this.get('delivery_hours_' + day_lower + '_start_time');
	            var day_end_time = this.get('delivery_hours_' + day_lower + '_end_time');
	            if (open_day == '1' && day_start_time !== null && day_start_time !== '' && day_end_time !== null && day_end_time !== '') {
	                open = true;
	            }
	
	            loop_count += 1;
	            if (loop_count >= 6) {
	                break;
	            }
	        }
	        if (open == 0) {
	            return {
	                day: null,
	                available: false,
	                startTime: null,
	                endTime: null
	            };
	        } else {
	            var isToday = false;
	            if (today_lower == day_lower) {
	                isToday = true;
	            }
	            return {
	                isToday: isToday,
	                day: day_lower,
	                available: open,
	                startTime: day_start_time,
	                endTime: day_end_time
	            };
	        }
	    },
	    isDeliveryAvailableAtCurrentTime: function isDeliveryAvailableAtCurrentTime() {
	        var deliveryAvailable = false;
	        var serverUnixTime = moment().unix() + this.get('server_client_time_offset');
	
	        // server day of the week, ie: tuesday...
	        var dayOfTheWeek = DateUtils.getFormattedTimestamp(serverUnixTime, {
	            format: 'dddd'
	        }).toLowerCase();
	
	        var dateString = DateUtils.getFormattedTimestamp(serverUnixTime, {
	            format: 'YYYY-MM-DD'
	        });
	
	        var isDeliveryOpen = this.get('delivery_hours_' + dayOfTheWeek + '_open');
	        var startTime = this.get('delivery_hours_' + dayOfTheWeek + '_start_time');
	        var endTime = this.get('delivery_hours_' + dayOfTheWeek + '_end_time');
	
	        if (isDeliveryOpen == '1' && startTime !== null && startTime !== '' && endTime !== null && endTime !== '') {
	            var startTimeUnixTime = moment(dateString + ' ' + startTime, 'YYYY-MM-DD H:mmA').unix() + this.get('server_client_time_offset');
	            var endTimeUnixTime = moment(dateString + ' ' + endTime, 'YYYY-MM-DD H:mmA').unix() + this.get('server_client_time_offset');
	            if (serverUnixTime >= startTimeUnixTime && serverUnixTime < endTimeUnixTime) {
	                deliveryAvailable = true;
	            }
	        }
	        return {
	            available: deliveryAvailable,
	            startTime: startTime,
	            endTime: endTime
	        };
	    },
	    parse: function parse(response) {
	        response.server_client_time_offset = response.server_time - moment().unix();
	        response.is_active = response.is_active === "1" ? true : false;
	        response.temp_closed = response.temp_closed === "1" ? true : false;
	        response.delivery_active = response.delivery_active === "1" ? true : false;
	        response.payments_allow_online = response.payments_allow_online === "1" ? true : false;
	        response.default_tip = parseFloat(response.default_tip);
	        return EntitiesBase.ModelBase.prototype.parse.call(this, response);
	    }
	});
	_.extend(LocationModel.prototype, Backbone.Validation.mixin);
	
	var PageableLocationCollection = EntitiesBase.PageableCollectionBase.extend({
	    url: function url() {
	        return farmacy.settings.restAPI.root + 'wp/v3/locations';
	    },
	    initialize: function initialize(models) {
	        _.each(models, function (model) {
	            model.server_client_time_offset = model.server_time - moment().unix();
	        });
	    },
	    model: LocationModel,
	    state: _.extend({}, EntitiesBase.PageableCollectionBase.prototype.state, {
	        sortKey: 'name'
	    })
	});
	
	var ProductLocationsCollection = PageableLocationCollection.extend({
	    productId: null,
	    initialize: function initialize(models, options) {
	        this.productId = options.productId;
	    },
	    fetchParams: function fetchParams() {
	        return _.extend({}, EntitiesBase.CollectionBase.prototype.fetchParams.call(this), {
	            product_id: this.productId
	        });
	    }
	});
	
	function getLocationTypes() {
	    var col = new EntitiesBase.CollectionBase([{
	        label: 'Store',
	        id: LOCATION_TYPES.STORE
	    }, {
	        label: 'Online',
	        id: LOCATION_TYPES.ONLINE
	    }]);
	
	    return col;
	}
	
	function getUserSavedLocation() {
	    return lsCache.get('farmUserSavedLocation');
	}
	
	function saveUserLocation(slug) {
	    // expire in a year....
	    lsCache.set('farmUserSavedLocation', slug, 31556952000);
	    return true;
	}
	
	module.exports = {
	    LOCATION_TYPES: LOCATION_TYPES,
	    getLocationTypes: getLocationTypes,
	    LocationModel: LocationModel,
	    getUserSavedLocation: getUserSavedLocation,
	    saveUserLocation: saveUserLocation,
	    PageableLocationCollection: PageableLocationCollection,
	    ProductLocationsCollection: ProductLocationsCollection
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8), __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 60 */,
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {'use strict';
	
	var MenuProductEntities = __webpack_require__(85);
	var EntitiesBase = __webpack_require__(17);
	var LocationEntities = __webpack_require__(59);
	var StrainGroupEntities = __webpack_require__(45);
	var ProductVendorEntities = __webpack_require__(42);
	var VariantsCollection = Backbone.Collection.extend({
	    constructor: function constructor(models, options) {
	        Backbone.Collection.prototype.constructor.call(this, models, options);
	    },
	    comparator: function comparator(variant1, variant2) {
	        var variant1Price = !isNaN(variant1.get('price')) ? parseFloat(variant1.get('price')) : 0;
	        var variant2Price = !isNaN(variant2.get('price')) ? parseFloat(variant2.get('price')) : 0;
	        if (variant1Price < variant2Price) {
	            return -1;
	        } else if (variant2Price < variant1Price) {
	            return 1;
	        }
	    }
	});
	var PRODUCT_IMAGE_SIZES = {
	    THUMB: 'thumb',
	    MEDIUM: 'medium',
	    LARGE: 'large',
	    XLARGE: 'xlarge'
	};
	
	var MenuProductModel = MenuProductEntities.MenuProductModel.extend({
	    PRODUCT_IMAGE_SIZES: PRODUCT_IMAGE_SIZES,
	    constructor: function constructor(attrs, options) {
	        this.productCategories = options.productCategories;
	        this.locationId = options.locationId;
	        MenuProductEntities.MenuProductModel.prototype.constructor.call(this, attrs, options);
	    },
	    nestedEntities: {
	        categories: Backbone.Collection,
	        locations: Backbone.Collection,
	        variants: VariantsCollection,
	        images: Backbone.Collection,
	        videos: Backbone.Collection,
	        strain_group: StrainGroupEntities.StrainGroupModel,
	        vendor: ProductVendorEntities.ProductVendorModel
	    },
	    setNestedEntityClass: function setNestedEntityClass(entityKey, entityData) {
	        var self = this;
	        var entity = self.get(entityKey);
	        switch (entityKey) {
	            case 'categories':
	            case 'locations':
	            case 'images':
	                entity.reset(entityData);
	                break;
	            case 'videos':
	                entity.reset(entityData);
	                break;
	            case 'variants':
	                entity.reset(entityData);
	                break;
	            case 'strain_group':
	            case 'vendor':
	                entity.set(entity.parse(entityData || {}));
	                break;
	        }
	        return entityData;
	    },
	    createNestedEntityClass: function createNestedEntityClass(entityKey, entityData) {
	        var self = this;
	        switch (entityKey) {
	            case 'categories':
	            case 'locations':
	            case 'images':
	                return new Backbone.Collection(entityData);
	            case 'videos':
	                return new Backbone.Collection(entityData);
	            case 'variants':
	            case 'strain_group':
	            case 'vendor':
	                return new this.nestedEntities[entityKey](entityData);
	        }
	        return entityData;
	    },
	    parse: function parse(productAttrs) {
	        var self = this;
	
	        productAttrs.priceGram = null;
	        productAttrs.priceGramSale = null;
	        productAttrs.priceTankHalfGram = null;
	        productAttrs.priceTankHalfGramSale = null;
	        productAttrs.priceTankGram = null;
	        productAttrs.priceTankGramSale = null;
	        productAttrs.priceEighth = null;
	        productAttrs.priceEighthSale = null;
	        productAttrs.priceQuarter = null;
	        productAttrs.priceQuarterSale = null;
	        productAttrs.priceOunce = null;
	        productAttrs.priceOunceSale = null;
	        productAttrs.priceHalf = null;
	        productAttrs.priceHalfSale = null;
	        productAttrs.lowTHC = null;
	        productAttrs.highTHC = null;
	
	        if (productAttrs.variants) {
	
	            var variantSalePriceMin = null;
	            var variantSalePriceMax = null;
	            var variantRegularPriceMin = null;
	            var variantRegularPriceMax = null;
	
	            _.each(productAttrs.variants, function (variationAttrs) {
	                // Set the item id so that the variation has access to it.
	                variationAttrs.itemId = productAttrs.id;
	                var variationInStockAtLocation = true;
	                if (self.locationId) {
	                    _.each(variationAttrs.locations, function (location) {
	                        if (self.locationId == location.location_id) {
	                            if (location.quantity <= 0) {
	                                variationInStockAtLocation = false;
	                            }
	                        }
	                    });
	                }
	
	                if (variationInStockAtLocation) {
	                    if (variationAttrs.on_sale) {
	                        var variantSalePrice = parseFloat(variationAttrs.sale_price);
	
	                        if (variantSalePriceMax == null && variantSalePrice) {
	                            variantSalePriceMax = variantSalePrice;
	                        }
	                        if (variantSalePrice > variantSalePriceMax) {
	                            variantSalePriceMax = variantSalePrice;
	                        }
	
	                        if (variantSalePriceMin == null && variantSalePrice) {
	                            variantSalePriceMin = variantSalePrice;
	                        }
	                        if (variantSalePrice < variantSalePriceMin) {
	                            variantSalePriceMin = variantSalePrice;
	                        }
	                    }
	                    var variantRegularPrice = parseFloat(variationAttrs.price);
	
	                    if (variantRegularPriceMax == null && variantRegularPrice) {
	                        variantRegularPriceMax = variantRegularPrice;
	                    }
	                    if (variantRegularPrice > variantRegularPriceMax) {
	                        variantRegularPriceMax = variantRegularPrice;
	                    }
	
	                    if (variantRegularPriceMin == null && variantRegularPrice) {
	                        variantRegularPriceMin = variantRegularPrice;
	                    }
	                    if (variantRegularPrice < variantRegularPriceMin) {
	                        variantRegularPriceMin = variantRegularPrice;
	                    }
	
	                    // any cats that rely on the variation being in stock...
	                    if (productAttrs.categories) {
	                        variationAttrs.isPreRoll = false;
	                        variationAttrs.is510Vaping = false;
	                        variationAttrs.isEraVaping = false;
	                        variationAttrs.isDosistVaping = false;
	                        variationAttrs.isCo2Vaping = false;
	                        variationAttrs.isHoneyOilVaping = false;
	                        variationAttrs.isDistilliteVaping = false;
	                        variationAttrs.isDisposableVaping = false;
	                        variationAttrs.isLiveResinVaping = false;
	                        variationAttrs.isSativaVaping = false;
	                        variationAttrs.isIndicaVaping = false;
	                        variationAttrs.isHybridVaping = false;
	                        variationAttrs.isTankHalfGram = false;
	                        variationAttrs.isTankGram = false;
	                        variationAttrs.isEdiblesBaked = false;
	                        variationAttrs.isEdiblesBeverages = false;
	                        variationAttrs.isEdiblesCooking = false;
	                        variationAttrs.isEdiblesCandy = false;
	                        variationAttrs.isEdiblesChocolate = false;
	                        variationAttrs.preRollSingle = false;
	                        variationAttrs.preRollInfused = false;
	                        variationAttrs.preRollBlunt = false;
	                        variationAttrs.preRollMultiPack = false;
	                        variationAttrs.preRollMultiPackQty2 = false;
	                        variationAttrs.preRollMultiPackQty3 = false;
	                        variationAttrs.preRollMultiPackQty4 = false;
	                        variationAttrs.preRollMultiPackQty5 = false;
	                        variationAttrs.preRollMultiPackQty10 = false;
	                        variationAttrs.preRollGram = false;
	                        variationAttrs.preRollHalfGram = false;
	                        variationAttrs.preRollSativa = false;
	                        variationAttrs.preRollIndica = false;
	                        variationAttrs.preRollHybrid = false;
	                        _.each(variationAttrs.categories, function (variationCategoryAttrs) {
	                            var catModel = self.productCategories.findWhere({
	                                slug: variationCategoryAttrs.slug
	                            });
	
	                            if (catModel && catModel.get('slug') == 'flower-1g') {
	                                productAttrs.hasGram = true;
	                                productAttrs.priceGram = parseFloat(variationAttrs.price);
	                                if (variationAttrs.on_sale) {
	                                    productAttrs.priceGramSale = parseFloat(variationAttrs.sale_price);
	                                }
	                            }
	
	                            if (catModel && catModel.get('slug') == 'flower-3-5g') {
	                                productAttrs.hasEighth = true;
	                                productAttrs.priceEighth = parseFloat(variationAttrs.price);
	                                if (variationAttrs.on_sale) {
	                                    productAttrs.priceEighthSale = parseFloat(variationAttrs.sale_price);
	                                }
	                            }
	
	                            if (catModel && catModel.get('slug') == 'flowers-7g') {
	                                productAttrs.hasQuarter = true;
	                                productAttrs.priceQuarter = parseFloat(variationAttrs.price);
	                                if (variationAttrs.on_sale) {
	                                    productAttrs.priceQuarterSale = parseFloat(variationAttrs.sale_price);
	                                }
	                            }
	
	                            if (catModel && catModel.get('slug') == 'flowers-half-ounce') {
	                                productAttrs.hasHalf = true;
	                                productAttrs.priceHalf = parseFloat(variationAttrs.price);
	                                if (variationAttrs.on_sale) {
	                                    productAttrs.priceHalfSale = parseFloat(variationAttrs.sale_price);
	                                }
	                            }
	
	                            if (catModel && catModel.get('slug') == 'flower-ounce') {
	                                productAttrs.hasOunce = true;
	                                productAttrs.priceOunce = parseFloat(variationAttrs.price);
	                                if (variationAttrs.on_sale) {
	                                    productAttrs.priceOunceSale = parseFloat(variationAttrs.sale_price);
	                                }
	                            }
	
	                            if (catModel && catModel.get('slug') == 'tanks-half-gram') {
	                                variationAttrs.isTankHalfGram = true;
	                                productAttrs.priceTankHalfGram = parseFloat(variationAttrs.price);
	                                if (variationAttrs.on_sale) {
	                                    productAttrs.priceTankHalfGramSale = parseFloat(variationAttrs.sale_price);
	                                }
	                            }
	                            if (catModel && catModel.get('slug') == 'tanks-gram') {
	                                variationAttrs.isTankGram = true;
	                                productAttrs.priceTankGram = parseFloat(variationAttrs.price);
	                                if (variationAttrs.on_sale) {
	                                    productAttrs.priceTankGramSale = parseFloat(variationAttrs.sale_price);
	                                }
	                            }
	                            if (catModel && catModel.get('slug') == 'prerolls') {
	                                variationAttrs.isPreRoll = true;
	                            }
	
	                            if (catModel && catModel.get('slug') == 'preroll-one-pack') {
	                                variationAttrs.preRollSingle = true;
	                            }
	
	                            if (catModel && catModel.get('slug') == 'preroll-infused') {
	                                variationAttrs.preRollInfused = true;
	                            }
	
	                            if (catModel && catModel.get('slug') == 'preroll-blunt') {
	                                variationAttrs.preRollBlunt = true;
	                            }
	
	                            if (catModel && catModel.get('slug') == 'preroll-two-pack') {
	                                variationAttrs.preRollMultiPackQty2 = true;
	                            }
	
	                            if (catModel && catModel.get('slug') == 'preroll-three-pack') {
	                                variationAttrs.preRollMultiPackQty3 = true;
	                            }
	
	                            if (catModel && catModel.get('slug') == 'preroll-four-pack') {
	                                variationAttrs.preRollMultiPackQty4 = true;
	                            }
	
	                            if (catModel && catModel.get('slug') == 'preroll-five-pack') {
	                                variationAttrs.preRollMultiPackQty5 = true;
	                            }
	
	                            if (catModel && catModel.get('slug') == 'preroll-ten-pack') {
	                                variationAttrs.preRollMultiPackQty10 = true;
	                            }
	
	                            if (catModel && catModel.get('slug') == 'preroll-gram-joint') {
	                                variationAttrs.preRollGram = true;
	                            }
	
	                            if (catModel && catModel.get('slug') == 'preroll-half-gram-joint') {
	                                variationAttrs.preRollHalfGram = true;
	                            }
	
	                            if (catModel && catModel.get('slug') == 'preroll-sativa') {
	                                variationAttrs.preRollSativa = true;
	                            }
	
	                            if (catModel && catModel.get('slug') == 'preroll-indica') {
	                                variationAttrs.preRollIndica = true;
	                            }
	
	                            if (catModel && catModel.get('slug') == 'preroll-hybrid') {
	                                variationAttrs.preRollHybrid = true;
	                            }
	
	                            if (catModel && catModel.get('slug') == '510-vaping') {
	                                variationAttrs.is510Vaping = true;
	                            }
	                            if (catModel && catModel.get('slug') == 'vaping-pax-era') {
	                                variationAttrs.isEraVaping = true;
	                            }
	                            if (catModel && catModel.get('slug') == 'vaping-dosist') {
	                                variationAttrs.isDosistVaping = true;
	                            }
	                            if (catModel && catModel.get('slug') == 'vaping-co2') {
	                                variationAttrs.isCo2Vaping = true;
	                            }
	                            if (catModel && catModel.get('slug') == 'vaping-honey-oil') {
	                                variationAttrs.isHoneyOilVaping = true;
	                            }
	                            if (catModel && catModel.get('slug') == 'vaping-distillate') {
	                                variationAttrs.isDistilliteVaping = true;
	                            }
	                            if (catModel && catModel.get('slug') == 'disposable') {
	                                variationAttrs.isDisposableVaping = true;
	                            }
	                            if (catModel && catModel.get('slug') == 'vaping-liveresin') {
	                                variationAttrs.isLiveResinVaping = true;
	                            }
	
	                            if (catModel && catModel.get('slug') == 'vaping-indica') {
	                                variationAttrs.isIndicaVaping = true;
	                            }
	
	                            if (catModel && catModel.get('slug') == 'vaping-sativa') {
	                                variationAttrs.isSativaVaping = true;
	                            }
	
	                            if (catModel && catModel.get('slug') == 'vaping-hybrid') {
	                                variationAttrs.isHybridVaping = true;
	                            }
	
	                            if (catModel && catModel.get('slug') == 'edibles-baked') {
	                                variationAttrs.isEdiblesBaked = true;
	                            }
	                            if (catModel && catModel.get('slug') == 'beverages') {
	                                variationAttrs.isEdiblesBeverages = true;
	                            }
	                            if (catModel && catModel.get('slug') == 'cooking') {
	                                variationAttrs.isEdiblesCooking = true;
	                            }
	                            if (catModel && catModel.get('slug') == 'candy') {
	                                variationAttrs.isEdiblesCandy = true;
	                            }
	                            if (catModel && catModel.get('slug') == 'chocolate') {
	                                variationAttrs.isEdiblesChocolate = true;
	                            }
	                        });
	                    }
	
	                    if (productAttrs.isPreRoll && productAttrs.preRollSingle == false) {
	                        productAttrs.preRollMultiPack = true;
	                    }
	                } // end variation in stock at location...
	            });
	        }
	
	        if (productAttrs.categories) {
	            _.each(productAttrs.categories, function (productCategoryAttrs) {
	                var catModel = self.productCategories.findWhere({
	                    slug: productCategoryAttrs.slug
	                });
	                if (catModel && !catModel.get('parent_id')) {
	                    productAttrs.category = productCategoryAttrs.name;
	                } else {
	                    productAttrs.subCategory = productCategoryAttrs.name;
	                }
	            });
	        }
	
	        if (productAttrs.is_high_cbd == 1) {
	            productAttrs.hasHighCBD = true;
	        }
	
	        if (productAttrs.is_organic == 1) {
	            productAttrs.isOrganic = true;
	        }
	
	        if (productAttrs.is_high_cbn_cbg == 1) {
	            productAttrs.hasHighCBNCBG = true; // filter....
	        }
	
	        if (productAttrs.is_farm_exclusive == 1) {
	            productAttrs.isFarmExclusive = true;
	        }
	
	        if (productAttrs.is_seasonal == 1) {
	            productAttrs.isSeasonal = true;
	        }
	
	        if (productAttrs.is_bc_grown == 1) {
	            productAttrs.isBCGrown = true;
	        }
	
	        self.potency_max_cbd = null;
	        self.potency_max_thc = null;
	        self.potency_mg_pct = null;
	        self.potency_min_cbd = null;
	        self.potency_min_thc = null;
	
	        _.each(productAttrs.variants, function (attr) {
	            _.each(attr.locations, function (location) {
	                if (location.location_id === self.locationId) {
	                    if (location.potency_mg_pct == 'M' || location.potency_mg_pct == 'P') {
	                        self.potency_mg_pct = location.potency_mg_pct;
	                    }
	
	                    // set min THC
	                    if (self.potency_min_thc == null || self.potency_min_thc == 0) {
	                        self.potency_min_thc = parseFloat(location.potency_min_thc);
	                    } else {
	                        // is the potency less then current min set it lower...
	                        if (parseFloat(location.potency_min_thc) > 0 && self.potency_min_thc > parseFloat(location.potency_min_thc)) {
	                            self.potency_min_thc = parseFloat(location.potency_min_thc);
	                        }
	                    }
	
	                    // set max THC
	                    if (self.potency_max_thc == null || self.potency_max_thc == 0) {
	                        self.potency_max_thc = parseFloat(location.potency_max_thc);
	                    } else {
	                        // is the potency more then current max set it higher...
	                        if (self.potency_max_thc < parseFloat(location.potency_max_thc)) {
	                            self.potency_max_thc = parseFloat(location.potency_max_thc);
	                        }
	                    }
	
	                    // set min CBD
	                    if (self.potency_min_cbd == null || self.potency_min_cbd == 0) {
	                        self.potency_min_cbd = parseFloat(location.potency_min_cbd);
	                    } else {
	                        // is the potency less then current min set it lower...
	                        if (parseFloat(location.potency_min_cbd) > 0 && self.potency_min_cbd > parseFloat(location.potency_min_cbd)) {
	                            self.potency_min_cbd = parseFloat(location.potency_min_cbd);
	                        }
	                    }
	
	                    // set max CBD
	                    if (self.potency_max_cbd == null || self.potency_max_cbd == 0) {
	                        self.potency_max_cbd = parseFloat(location.potency_max_cbd);
	                    } else {
	                        // is the potency more then current max set it higher...
	                        if (self.potency_max_cbd < parseFloat(location.potency_max_cbd)) {
	                            self.potency_max_cbd = parseFloat(location.potency_max_cbd);
	                        }
	                    }
	                }
	            });
	        });
	
	        productAttrs.potency_max_cbd = self.potency_max_cbd;
	        productAttrs.potency_max_thc = self.potency_max_thc;
	        productAttrs.potency_mg_pct = self.potency_mg_pct;
	        productAttrs.potency_min_cbd = self.potency_min_cbd;
	        productAttrs.potency_min_thc = self.potency_min_thc;
	
	        if (productAttrs.potency_min_thc !== null && productAttrs.potency_min_thc >= 27 && productAttrs.hasHighCBD !== true) {
	            productAttrs.hasHighTHC = true;
	        }
	
	        if (productAttrs.potency_max_thc !== null && productAttrs.potency_max_thc !== 0 && productAttrs.potency_max_thc <= 19) {
	            productAttrs.hasLowTHC = true;
	        }
	
	        productAttrs.sortPrice = variantRegularPriceMin;
	        productAttrs.variantRegularPriceMin = variantRegularPriceMin;
	        productAttrs.variantRegularPriceMax = variantRegularPriceMax;
	
	        productAttrs.variantSalePriceMin = variantSalePriceMin;
	        productAttrs.variantSalePriceMax = variantSalePriceMax;
	
	        productAttrs.itemName = productAttrs.title;
	
	        if (productAttrs.description !== null && productAttrs.description !== undefined) {
	            productAttrs.itemDescription = productAttrs.description.trim();
	            productAttrs.itemDescriptionHtml = productAttrs.itemDescription.replace(new RegExp('\r?\n', 'g'), '<br />');
	        }
	
	        productAttrs.searchTitle = productAttrs.vendor_name + ' - ' + productAttrs.itemName;
	
	        return MenuProductEntities.MenuProductModel.prototype.parse.call(this, productAttrs);
	    }
	});
	_.extend(MenuProductModel.prototype, __webpack_require__(48));
	
	function isAvailableInOnlineStore() {
	    return this.get('locations').find(function (productLocation) {
	        return productLocation.get('type') === LocationEntities.LOCATION_TYPES.ONLINE;
	    });
	}
	
	var PageableMenuProductsCollection = MenuProductEntities.PageableMenuProductsCollection.extend({
	    productCategories: null,
	    locationId: null,
	    model: MenuProductModel,
	    state: _.extend({}, MenuProductEntities.PageableMenuProductsCollection.prototype.state, {
	        sortKey: 'title'
	    }),
	    constructor: function constructor(models, options) {
	        this.productCategories = options.productCategories;
	        this.locationId = options.locationId;
	        MenuProductEntities.PageableMenuProductsCollection.prototype.constructor.call(this, models, options);
	    },
	    createModel: function createModel(attrs, options) {
	        return new MenuProductModel(attrs, _.defaults(options || {}, {
	            productCategories: this.productCategories,
	            parse: true,
	            locationId: this.locationId
	        }));
	    }
	});
	
	var MenuProductModelLegacy = MenuProductModel.extend({
	    PRODUCT_LOCATION_TYPES: LocationEntities.LOCATION_TYPES,
	    isAvailableInOnlineStore: isAvailableInOnlineStore,
	    parse: function parse(response) {
	        if (response.length) {
	            return MenuProductModel.prototype.parse.call(this, response[0]);
	        } else {
	            return MenuProductModel.prototype.parse.call(this, response);
	        }
	    }
	});
	
	var pageableProductsCollectionLegacyOnSaleAlphaComparator = function pageableProductsCollectionLegacyOnSaleAlphaComparator(model1, model2) {
	    if (model1.get('on_sale') && !model2.get('on_sale')) {
	        return -1;
	    } else if (!model1.get('on_sale') && model2.get('on_sale')) {
	        return 1;
	    } else {
	        var model1itemName = model1.get('itemName').toUpperCase();
	        var model2itemName = model2.get('itemName').toUpperCase();
	        if (model1itemName < model2itemName) {
	            return -1;
	        }
	        if (model1itemName > model2itemName) {
	            return 1;
	        }
	        return 0;
	    }
	};
	
	var PageableMenuProductsCollectionLegacy = PageableMenuProductsCollection.extend({
	    createModel: function createModel(attrs, options) {
	        return new MenuProductModelLegacy(attrs, _.defaults(options || {}, {
	            productCategories: this.productCategories,
	            parse: true,
	            locationId: this.locationId
	        }));
	    }
	});
	
	module.exports = {
	    PRODUCT_IMAGE_SIZES: PRODUCT_IMAGE_SIZES,
	    MenuProductModel: MenuProductModel,
	    PageableMenuProductsCollection: PageableMenuProductsCollection,
	    MenuProductModelLegacy: MenuProductModelLegacy,
	    PageableMenuProductsCollectionLegacy: PageableMenuProductsCollectionLegacy,
	    pageableProductsCollectionLegacyOnSaleAlphaComparator: pageableProductsCollectionLegacyOnSaleAlphaComparator
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(1)))

/***/ },
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	__webpack_require__(83);
	var BaseViews = __webpack_require__(5);
	var View = BaseViews.LayoutView.extend({
	  template: __webpack_require__(84),
	  className: 'fmcy-image-display',
	  imageLoaded: false,
	  afterImageLoaded: false,
	  ui: {
	    image: '.fmcy-image',
	    imageLarge: '.fmcy-large-image'
	  },
	  regions: {
	    loaderRegion: '.fmcy-loader-region'
	  },
	  initialize: function initialize(options) {
	    var self = this;
	    self.options = _.defaults(options || {}, {
	      noImageAvailableIcon: __webpack_require__(82),
	      displayNoImageAvailableIcon: true,
	      imageURL: null,
	      afterLoadImageURL: null,
	      displayImagePreloadingEffects: true,
	      imagePreloadTimeout: 60000 // 1 minute in msx
	    });
	
	    if (self.options.displayImagePreloadingEffects || self.afterLoadImageURL !== null) {
	      var createjs = __webpack_require__(74);
	      createjs.LoadQueue.loadTimeout = self.options.imagePreloadTimeout;
	      self._preloadThumbsQueue = new createjs.LoadQueue(false);
	      self._preloadLargeQueue = new createjs.LoadQueue(false);
	    }
	  },
	  hideLargerImage: function hideLargerImage() {
	    this.ui.imageLarge.hide();
	    this.ui.imageLarge.css('background-image', 'none');
	  },
	  resizeImageHeight: function resizeImageHeight(height) {
	    this.ui.imageLarge.css('height', height + 'px');
	    this.ui.image.css('height', height + 'px');
	  },
	  loadLargerImage: function loadLargerImage() {
	    var self = this;
	    var viewId = self.viewId();
	    var imageURL = self.options.afterLoadImageURL;
	    if (imageURL === null) {
	      return;
	    }
	
	    function setImage(imageURL) {
	      self.ui.imageLarge.css('background-image', 'url(' + imageURL + ')');
	      self.imageLoaded = true;
	      self.ui.imageLarge.show();
	      self.trigger('image:display:large:image:loaded', viewId);
	    }
	
	    var handleFileLoadError = function handleFileLoadError(event) {
	      if (!self.isRendered) {
	        return false;
	      }
	      if (event.item.id === viewId) {
	        console.log('File load error occurred: ', event);
	        self._preloadLargeQueue.removeAllEventListeners('fileload');
	        self._preloadLargeQueue.removeAllEventListeners('error');
	      }
	    };
	
	    var handleFileLoaded = function handleFileLoaded(event) {
	      if (!self.isRendered) {
	        return false;
	      }
	      if (event.item.id === viewId) {
	        self._preloadLargeQueue.removeAllEventListeners('fileload');
	        self._preloadLargeQueue.removeAllEventListeners('error');
	        setImage(event.item.src);
	      }
	    };
	
	    self._preloadLargeQueue.on('error', handleFileLoadError);
	    self._preloadLargeQueue.on('fileload', handleFileLoaded);
	    self._preloadLargeQueue.loadFile({
	      id: viewId,
	      src: imageURL
	    });
	  },
	  _renderImage: function _renderImage() {
	    var self = this;
	    var viewId = self.viewId();
	
	    function setImage(imageURL) {
	      self.ui.image.css('background-image', 'url(' + imageURL + ')');
	      self.imageLoaded = true;
	    }
	
	    var imageURL = self.options.imageURL;
	
	    if (!self.options.displayNoImageAvailableIcon && !imageURL) {
	      return;
	    } else if (!imageURL) {
	      imageURL = self.options.noImageAvailableIcon;
	    }
	
	    if (!self.options.displayImagePreloadingEffects) {
	      setImage(imageURL);
	      self.trigger('image:display:image:loaded', viewId);
	    } else {
	      self.loaderRegion.show(new (__webpack_require__(20))({
	        message: ''
	      }));
	      var handleFileLoadError = function handleFileLoadError(event) {
	        if (!self.isRendered) {
	          return false;
	        }
	        if (event.item.id === viewId) {
	          console.log('File load error occurred: ', event);
	          self._preloadThumbsQueue.removeAllEventListeners('fileload');
	          self._preloadThumbsQueue.removeAllEventListeners('error');
	          self.loaderRegion.empty();
	          setImage(self.options.noImageAvailableIcon);
	          self.trigger('image:display:image:loaded', viewId);
	        }
	      };
	
	      var handleFileLoaded = function handleFileLoaded(event) {
	        if (!self.isRendered) {
	          return false;
	        }
	        if (event.item.id === viewId) {
	          self._preloadThumbsQueue.removeAllEventListeners('fileload');
	          self._preloadThumbsQueue.removeAllEventListeners('error');
	          self.loaderRegion.empty();
	          setImage(event.item.src);
	          self.trigger('image:display:image:loaded', viewId);
	        }
	      };
	
	      self._preloadThumbsQueue.on('error', handleFileLoadError);
	      self._preloadThumbsQueue.on('fileload', handleFileLoaded);
	      self._preloadThumbsQueue.loadFile({
	        id: viewId,
	        src: imageURL
	      });
	    }
	  },
	  onRender: function onRender() {
	    this._renderImage();
	  },
	  onDestroy: function onDestroy() {
	    this._preloadThumbsQueue.removeAllEventListeners('fileload');
	    this._preloadThumbsQueue.removeAllEventListeners('error');
	    this._preloadThumbsQueue.reset();
	    this._preloadThumbsQueue.removeAll();
	
	    this._preloadLargeQueue.removeAllEventListeners('fileload');
	    this._preloadLargeQueue.removeAllEventListeners('error');
	    this._preloadLargeQueue.reset();
	    this._preloadLargeQueue.removeAll();
	  }
	});
	module.exports = View;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette, _, Backbone) {__webpack_require__(87);
	var SIZES = {
	    NONE: 'NONE',
	    DEFAULT: 'DEFAULT',
	    SMALL: 'SMALL',
	    LARGE: 'LARGE'
	};
	
	var SIZE_CLASSNAMES = {
	    NONE: '',
	    DEFAULT: '',
	    SMALL: 'btn-sm',
	    LARGE: 'btn-lg'
	};
	
	var THEMES = {
	    NONE: 'NONE',
	    DEFAULT: 'DEFAULT',
	    WARNING: 'WARNING',
	    DANGER: 'DANGER',
	    PRIMARY: 'PRIMARY',
	    SUCCESS: 'SUCCESS'
	};
	
	var THEME_CLASSNAMES = {
	    NONE: '',
	    DEFAULT: 'btn btn-default',
	    WARNING: 'btn btn-warning',
	    DANGER: 'btn btn-danger',
	    PRIMARY: 'btn btn-primary',
	    SUCCESS: 'btn btn-success'
	};
	
	var ICON_THEMES = {
	    NONE: 'NONE',
	    PLUS: 'PLUS'
	};
	
	var ICON_THEME_CLASSNAMES = {
	    NONE: '',
	    PLUS: 'glyphicon glyphicon-plus-sign'
	};
	
	var Button = Marionette.ItemView.extend({
	    template: __webpack_require__(88),
	    className: function () {
	        var classNames = ['tl-button'];
	        var sizeClassName = SIZE_CLASSNAMES[this.options.size];
	        if (sizeClassName) {
	            classNames.push(sizeClassName);
	        }
	        var themeClassName = THEME_CLASSNAMES[
	            this.state &&
	            this.state.get('theme') ||
	            this.options.theme
	        ];
	        if (themeClassName) {
	            classNames.push(themeClassName);
	        }
	        if (this.options.classNames) {
	            classNames = classNames.concat(this.options.classNames);
	        }
	        return classNames.join(' ');
	    },
	    iconClassName: function () {
	        var classNames = ['tl-icon'];
	        var themeClassName = ICON_THEME_CLASSNAMES[this.options.iconTheme];
	        if (themeClassName) {
	            classNames.push(themeClassName);
	        }
	        if (this.options.iconClassNames) {
	            classNames = classNames.concat(this.options.iconClassNames);
	        }
	        return classNames.join(' ');
	    },
	    ui: {
	        icon: '.tl-icon'
	    },
	    events: {
	        'click': '_onClicked'
	    },
	    tagName: 'button',
	    _onClicked: function (e) {
	        var isEnabled = this.state.get('enabled');
	        if (!this.options.multiClick) {
	            this.toggledEnabledState(false);
	        }
	        if (isEnabled) {
	            if (this.options.onClickedCallback) {
	                this.options.onClickedCallback(this, e);
	            }
	            this.trigger('clicked');
	        }
	    },
	    initialize: function (options) {
	        this.options = _.defaults(
	            options || {},
	            {
	                enabled: true,
	                label: '',
	                theme: THEMES.DEFAULT,
	                size: SIZES.DEFAULT,
	                classNames: '',
	                showIcon: false,
	                iconTheme: ICON_THEMES.NONE,
	                iconClassNames: '',
	                multiClick: true,
	                onClickedCallback: null
	            }
	        );
	        this.state = new Backbone.Model({
	            enabled: this.options.enabled,
	            label: this.options.label,
	            showIcon: this.options.showIcon,
	            iconClassNames: this.options.iconClassNames,
	            theme: this.options.theme
	        });
	        this.listenTo(this.state, 'change:theme', this.render);
	    },
	    isEnabled: function () {
	        return this.state.get('enabled');
	    },
	    setLabel: function (val) {
	        this.state.set('label', val);
	        this.$el.text(val);
	    },
	    setTheme: function (val) {
	        this.state.set('theme', val);
	    },
	    toggledEnabledState: function (enabled) {
	        if (enabled) {
	            this.state.set('enabled', true);
	            this.$el.removeClass('disabled');
	        } else {
	            this.state.set('enabled', false);
	            this.$el.addClass('disabled');
	        }
	    },
	    onRender: function () {
	        // Calling this here because when backbone calls it
	        // the options hash has not been set yet (i.e.
	        // initialize has not been called at the time that
	        // backbone calls className function)
	        this.$el.attr('class', this.className());
	        if (this.options.showIcon) {
	            this.ui.icon.attr('class', this.iconClassName());
	        }
	        this.toggledEnabledState(this.state.get('enabled'));
	    },
	    serializeData: function () {
	        return {
	            state: this.state.toJSON(),
	            theme: THEME_CLASSNAMES[this.options.theme]
	        };
	    }
	});
	
	module.exports = {
	    Button: Button,
	    THEMES: THEMES,
	    ICON_THEMES: ICON_THEMES,
	    SIZES: SIZES
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(7), __webpack_require__(16)))

/***/ },
/* 71 */,
/* 72 */,
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette, _, Backbone) {__webpack_require__(60);
	var ValidationBehavioursMixin = __webpack_require__(102);
	var Textbox = Marionette.ItemView.extend({
	template: function () {
	    return '';
	},
	className: function () {
	    var classNames = ['tl-textbox', 'form-control'];
	    if (this.options.classNames) {
	        classNames = classNames.concat(this.options.classNames);
	    }
	    return classNames.join(' ');
	},
	tagName: function () {
	    if (this.options.multiLine) {
	        return 'textarea';
	    }
	    return 'input';
	},
	attributes: function () {
	    return {
	        type: this.options.password ? 'password' : 'text',
	        placeholder: this.options.placeholder
	    };
	},
	events: function () {
	    return {
	        'input': _.debounce(this.clearErrorState, 10),
	        'focus': _.debounce(this.clearErrorState, 10),
	        'keypress': '_checkKeyPressForEnter'
	    };
	},
	bindings: function () {
	    if (!this.options.modelAttr) {
	        return null;
	    }
	    return {
	        ':el': {
	            observe: this.options.modelAttr
	        }
	    };
	},
	val: function (val) {
	    if (_.isUndefined(val)) {
	        return this.$el.val();
	    }
	    this.$el.val(val);
	},
	_checkKeyPressForEnter: function (e) {
	    if (e.which === 13) {
	        if (e.preventDefault) {
	            e.preventDefault();
	        }
	        if (e.stopPropagation) {
	            e.stopPropagation();
	        }
	        if (this.options.enterPressedCallback) {
	            this.options.enterPressedCallback();
	        }
	        this.trigger('enter:pressed');
	    }
	},
	initialize: function (options) {
	    var that = this;
	    this.options = _.defaults(
	        options || {},
	        {
	            enabled: true,
	            placeholder: '',
	            classNames: '',
	            modelAttr: null,
	            useValidationBehaviours: false,
	            multiLine: false,
	            password: false,
	            focused: false
	        }
	    );
	
	    this.state = new Backbone.Model({
	        enabled: this.options.enabled,
	        placeholder: this.options.placeholder,
	        popoverActivated: false,
	        invalid: false
	    });
	
	    if (this.options.useValidationBehaviours && this.options.modelAttr) {
	        this.listenTo(this.model, 'validated', function(isValid, model, errors) {
	            if (isValid) {
	                that.clearErrorState();
	            } else {
	                if (_.has(errors, that.options.modelAttr)) {
	                    that.setErrorState(errors[that.options.modelAttr]);
	                }
	            }
	        });
	    }
	
	
	},
	isEnabled: function () {
	    return this.state.get('enabled');
	},
	setPlaceholder: function (val) {
	    this.state.set('placeholder', val);
	    this.$el.attr('placeholder', val);
	},
	toggledEnabledState: function (enabled) {
	    if (enabled) {
	        this.state.set('enabled', true);
	        this.$el.removeClass('disabled');
	    } else {
	        this.state.set('enabled', false);
	        this.$el.addClass('disabled');
	    }
	},
	focus: function () {
	    var that = this;
	    setTimeout(function () {
	        that.$el.trigger('focus');
	    }, 0);
	},
	onDestroy: function () {
	    if (this.options.useValidationBehaviours) {
	        this.hidePopover();
	    }
	    if (this.bindings()) {
	        this.unstickit();
	    }
	},
	onRender: function () {
	    if (this.bindings()) {
	        this.stickit();
	    }
	    if (this.options.focused) {
	        this.focus();
	    }
	    if (this.options.modelAttr) {
	        this.$el.attr('name', this.options.modelAttr);
	    }
	},
	serializeData: function () {
	    return {
	        state: this.state.toJSON()
	    };
	}
	});
	
	_.extend(Textbox.prototype, ValidationBehavioursMixin);
	
	module.exports = Textbox;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(7), __webpack_require__(16)))

/***/ },
/* 74 */,
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".select2-results .tl-wrapper.tl-show-icon .tl-text-wrapper {\n  padding-left: 5px; }\n\n.select2-results .tl-icon-wrapper {\n  height: 30px;\n  width: 30px;\n  display: inline-block;\n  vertical-align: middle; }\n  .select2-results .tl-icon-wrapper img {\n    max-width: 100%;\n    max-height: 100%; }\n\n.select2-results .tl-text-wrapper {\n  display: inline-block;\n  vertical-align: middle; }\n\n.tl-dropdown-list-inner .select2-selection {\n  outline: none; }\n", ""]);
	
	// exports


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(75);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./dropdown-list-inner.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./dropdown-list-inner.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 77 */,
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(107);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./menu-item-price.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./menu-item-price.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	__webpack_require__(97);
	var PotencyDisplayView = BaseViews.LayoutView.extend({
	  className: 'fmcy-potency-display',
	  template: __webpack_require__(99),
	  initialize: function initialize(options) {
	    this.options = _.defaults(options || {}, {
	      size: 'small',
	      filterLocation: null //'hillsidevictoria'
	    });
	  },
	  serializeData: function serializeData() {
	    var self = this;
	
	    this.potency_max_cbd = null;
	    this.potency_max_thc = null;
	    this.potency_mg_pct = null;
	    this.potency_min_cbd = null;
	    this.potency_min_thc = null;
	
	    //TODO...
	    this.model.get('variants').each(function (model) {
	      _.each(model.get('locations'), function (location) {
	        if (location.slug === self.options.filterLocation) {
	          if (location.potency_mg_pct == 'M' || location.potency_mg_pct == 'P') {
	            self.potency_mg_pct = location.potency_mg_pct;
	          }
	
	          // set min THC
	          if (self.potency_min_thc == null || self.potency_min_thc == 0) {
	            self.potency_min_thc = parseFloat(location.potency_min_thc);
	          } else {
	            // is the potency less then current min set it lower...
	            if (parseFloat(location.potency_min_thc) > 0 && self.potency_min_thc > parseFloat(location.potency_min_thc)) {
	              self.potency_min_thc = parseFloat(location.potency_min_thc);
	            }
	          }
	
	          // set max THC
	          if (self.potency_max_thc == null || self.potency_max_thc == 0) {
	            self.potency_max_thc = parseFloat(location.potency_max_thc);
	          } else {
	            // is the potency more then current max set it higher...
	            if (self.potency_max_thc < parseFloat(location.potency_max_thc)) {
	              self.potency_max_thc = parseFloat(location.potency_max_thc);
	            }
	          }
	
	          // set min CBD
	          if (self.potency_min_cbd == null || self.potency_min_cbd == 0) {
	            self.potency_min_cbd = parseFloat(location.potency_min_cbd);
	          } else {
	            // is the potency less then current min set it lower...
	            if (parseFloat(location.potency_min_cbd) > 0 && self.potency_min_cbd > parseFloat(location.potency_min_cbd)) {
	              self.potency_min_cbd = parseFloat(location.potency_min_cbd);
	            }
	          }
	
	          // set max CBD
	          if (self.potency_max_cbd == null || self.potency_max_cbd == 0) {
	            self.potency_max_cbd = parseFloat(location.potency_max_cbd);
	          } else {
	            // is the potency more then current max set it higher...
	            if (self.potency_max_cbd < parseFloat(location.potency_max_cbd)) {
	              self.potency_max_cbd = parseFloat(location.potency_max_cbd);
	            }
	          }
	        } // end if slug == filter location
	      }); // end each model get locations
	    });
	
	    var potencyText = '';
	    var potencyTHCText = '';
	    var potencyCBDText = '';
	
	    if (this.potency_min_thc !== 0 && this.potency_max_thc !== 0) {
	      potencyTHCText = 'THC ';
	
	      if (this.potency_min_thc == this.potency_max_thc) {
	        potencyTHCText += this.potency_max_thc;
	      } else {
	        potencyTHCText += this.potency_min_thc + ' - ' + this.potency_max_thc;
	      }
	
	      if (this.potency_mg_pct == 'P') {
	        potencyTHCText += '%';
	      } else {
	        potencyTHCText += 'mg';
	      }
	    }
	
	    if (this.potency_min_cbd !== 0 && this.potency_max_cbd !== 0 && parseFloat(this.potency_max_cbd) >= 1) {
	      potencyCBDText = 'CBD ';
	      if (this.potency_min_cbd == this.potency_max_cbd) {
	        potencyCBDText += this.potency_max_cbd;
	      } else {
	        potencyCBDText += this.potency_min_cbd + ' - ' + this.potency_max_cbd;
	      }
	      if (this.potency_mg_pct == 'P') {
	        potencyCBDText += '%';
	      } else {
	        potencyCBDText += 'mg';
	      }
	    }
	
	    if (potencyTHCText != '') {
	      potencyText += potencyTHCText;
	    }
	
	    if (potencyTHCText != '' && potencyCBDText != '') {
	      potencyText += ' | ';
	    }
	
	    if (potencyCBDText != '') {
	      potencyText += potencyCBDText;
	    }
	
	    return {
	      potencyText: potencyText
	    };
	  }
	});
	
	module.exports = PotencyDisplayView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	__webpack_require__(98);
	var View = BaseViews.LayoutView.extend({
	  template: __webpack_require__(100),
	  className: 'fmcy-tag-bar fmcy-tag-bar-pinned-right',
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      showOnSaleTag: false,
	      showOnClearanceTag: false,
	      showOrganicTag: false,
	      showVeganTag: false,
	      showCBDTag: false,
	      showCBNCBGTag: false,
	      showBcGrownTag: false,
	      showFarmExclusiveTag: false,
	      productTagText: ''
	    });
	  },
	  serializeData: function serializeData() {
	    if (this.options.productTagText) {
	      this.$el.addClass('fmcy-showing-product-tag');
	    }
	    return {
	      options: this.options
	    };
	  }
	});
	module.exports = View;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-image-display .fmcy-image {\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center center;\n  margin: auto; }\n\n.fmcy-image-display .fmcy-large-image {\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center center;\n  position: absolute;\n  margin: auto;\n  left: 10px;\n  right: 10px;\n  top: 10px;\n  bottom: 10px; }\n", ""]);
	
	// exports


/***/ },
/* 82 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/no-image-available-62d2473f8e8ad88e087ff5ccd7eb83ed.png";

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(81);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./image-display.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./image-display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 84 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-image fmcy-loader-region"></div>\n<div class="fmcy-large-image"></div>\n';
	}
	return __p;
	};


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Backbone) {'use strict';
	
	var EntitiesBase = __webpack_require__(14);
	var MenuProductModel = EntitiesBase.ModelBase.extend({
	    constructor: function constructor(attrs, options) {
	        EntitiesBase.ModelBase.prototype.constructor.call(this, attrs, options);
	    },
	    urlRoot: function urlRoot() {
	        return farmacy.settings.restAPI.root + 'wp/v3/menu-products';
	    }
	});
	_.extend(MenuProductModel.prototype, Backbone.Validation.mixin);
	
	var PageableMenuProductsCollection = EntitiesBase.PageableCollectionBase.extend({
	    url: function url() {
	        return farmacy.settings.restAPI.root + 'wp/v3/menu-products';
	    },
	    constructor: function constructor(models, options) {
	        EntitiesBase.PageableCollectionBase.prototype.constructor.call(this, models, options);
	    },
	    state: _.extend({}, EntitiesBase.PageableCollectionBase.prototype.state, {
	        sortKey: 'title',
	        order: EntitiesBase.SORT_DIRECTIONS.ASC
	    }),
	    model: MenuProductModel
	});
	
	module.exports = {
	    MenuProductModel: MenuProductModel,
	    PageableMenuProductsCollection: PageableMenuProductsCollection
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".tl-button {\n  display: inherit;\n  padding-left: 15px;\n  padding-right: 15px; }\n  .tl-button:focus {\n    outline: none; }\n", ""]);
	
	// exports


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(86);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./button.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./button.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	 if (state.showIcon) {
	__p+='\n	<span class="vap-icon '+
	((__t=( state.iconClassNames ))==null?'':_.escape(__t))+
	'"></span>\n';
	 } 
	__p+='\n'+
	((__t=( state.label ))==null?'':_.escape(__t))+
	'';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ },
/* 89 */,
/* 90 */,
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, moment) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	var SpinnerButton = __webpack_require__(19);
	
	__webpack_require__(147);
	
	var CartLocationDisplay = BaseViews.LayoutView.extend({
	  className: 'fmcy-cart-location-display',
	  template: __webpack_require__(148),
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      theme: 'dark',
	      alignment: 'horizontal',
	      _appChannel: null,
	      hidePhotoSmallScreen: true,
	      model: null,
	      actionButton: false,
	      buttonText: 'Select',
	      clickableLocationInfo: false
	    });
	  },
	  events: {
	    'click': 'onClicked'
	  },
	  onClicked: function onClicked() {
	    if (this.options.clickableLocationInfo == true) {
	      this.trigger('info:clicked', this.model);
	    }
	  },
	  regions: {
	    buttonRegion: '.fmcy-cart-location-display-button-region'
	  },
	  serializeData: function serializeData() {
	    // if a location model is passed in, used it.
	    if (this.options.model) {
	      this.model = this.options.model;
	    } else {
	      // no model check for current filtered location
	      this.model = this.options._appChannel.request('get:filter:location:details');
	    }
	    var dayOfTheWeek = moment().format('dddd').toLowerCase();
	    var isOpen = this.model.get('hours_' + dayOfTheWeek + '_open');
	    var startTime = this.model.get('hours_' + dayOfTheWeek + '_start_time');
	    var endTime = this.model.get('hours_' + dayOfTheWeek + '_end_time');
	
	    var hours;
	
	    if (isOpen === '1' && startTime !== null && startTime !== '' && endTime !== null && endTime !== '') {
	      hours = startTime.replace(':00', '') + ' to ' + endTime.replace(':00', '');
	    } else {
	      hours = 'Closed';
	    }
	
	    if (parseInt(this.model.get('temp_closed')) === 1 || this.model.get('temp_closed') == true) {
	      if (this.model.get('temp_closed_message') && this.model.get('temp_closed_message') !== '') {
	        hours = this.model.get('temp_closed_message');
	      } else {
	        hours = 'Temporarily closed';
	      }
	    }
	
	    return {
	      name: this.model.get('name'),
	      line_1: this.model.get('line_1'),
	      city: this.model.get('city'),
	      imageUrl: this.model.get('image_medium_url'),
	      hours: hours
	    };
	  },
	  _renderActionButton: function _renderActionButton() {
	    var self = this;
	    var selectButton = new SpinnerButton.SpinnerButton({
	      label: this.options.buttonText,
	      enabled: true,
	      theme: SpinnerButton.THEMES.PRIMARY,
	      onClickedCallback: function onClickedCallback() {
	        self.trigger('item:clicked', self.model);
	      }
	    });
	    this.buttonRegion.show(selectButton);
	  },
	  onRender: function onRender() {
	    var self = this;
	    this.$el.addClass('farm-cart-location-thumb-alignment-' + this.options.alignment);
	
	    if (this.options.hidePhotoSmallScreen) {
	      this.$el.addClass('farm-location-hide-photo-small-size');
	    }
	
	    if (this.options.actionButton && this.model.get('temp_closed') !== '1') {
	      this._renderActionButton();
	    }
	
	    BaseViews.LayoutView.prototype.onRender.call(self);
	  },
	  onDestroy: function onDestroy() {
	    BaseViews.LayoutView.prototype.onDestroy.call(self);
	  }
	});
	
	module.exports = CartLocationDisplay;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(8)))

/***/ },
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-tag-bar {\n  color: #ffffff;\n  font-family: \"bebasneue\", \"Arial\", sans-serif;\n  font-size: 100%;\n  line-height: 100%;\n  display: flex;\n  text-transform: uppercase; }\n  .fmcy-tag-bar.fmcy-tag-bar-pinned-right {\n    flex-direction: row-reverse; }\n    .fmcy-tag-bar.fmcy-tag-bar-pinned-right .fmcy-pointy::after {\n      -webkit-transform: skew(35deg);\n      -ms-transform: skew(35deg);\n      transform: skew(35deg);\n      left: -45px;\n      right: auto; }\n  .fmcy-tag-bar .fmcy-sale-tag,\n  .fmcy-tag-bar .fmcy-cbd-tag,\n  .fmcy-tag-bar .fmcy-cbn-cbg-tag,\n  .fmcy-tag-bar .fmcy-organic-tag,\n  .fmcy-tag-bar .fmcy-vegan-tag,\n  .fmcy-tag-bar .fmcy-bc-grown-tag,\n  .fmcy-tag-bar .fmcy-is-farm-exclusive,\n  .fmcy-tag-bar .fmcy-inner-tag {\n    display: inline-block;\n    vertical-align: middle;\n    padding: 5px 5px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    max-width: 100%;\n    display: block; }\n  .fmcy-tag-bar .fmcy-sale-tag {\n    background-color: #A71C21; }\n  .fmcy-tag-bar .fmcy-clearance-tag {\n    background-color: #A71C21; }\n  .fmcy-tag-bar .fmcy-cbd-tag {\n    background-color: #52b7be; }\n  .fmcy-tag-bar .fmcy-cbn-cbg-tag {\n    background-color: #A28DB3; }\n  .fmcy-tag-bar .fmcy-organic-tag {\n    background-color: #56b593; }\n  .fmcy-tag-bar .fmcy-bc-grown-tag {\n    background-color: #001a70; }\n  .fmcy-tag-bar .fmcy-is-farm-exclusive {\n    background-color: #221F20; }\n  .fmcy-tag-bar .fmcy-vegan-tag {\n    background-color: #14b47b; }\n  .fmcy-tag-bar .fmcy-inner-tag {\n    background-color: #1b1b1b;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    max-width: 100%;\n    display: block; }\n  .fmcy-tag-bar.fmcy-showing-product-tag .fmcy-pointy::after {\n    background: #1b1b1b; }\n  .fmcy-tag-bar .fmcy-pointy::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    z-index: -1;\n    background: #A71C21;\n    -webkit-transform-origin: 100% 0;\n    -ms-transform-origin: 100% 0;\n    transform-origin: 100% 0;\n    -webkit-transform: skew(-35deg);\n    -ms-transform: skew(-35deg);\n    transform: skew(-35deg);\n    width: 45px;\n    right: -45px;\n    left: auto; }\n", ""]);
	
	// exports


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(95);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./potency-display.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./potency-display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(96);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./tag-bar.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./tag-bar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 99 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+=''+
	((__t=(potencyText))==null?'':__t)+
	'\n';
	}
	return __p;
	};


/***/ },
/* 100 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	 if (options.showOnSaleTag && !options.showOnClearanceTag) { 
	__p+='\n<div class="fmcy-sale-tag fmcy-product-tag">\n    sale\n</div>\n';
	 } 
	__p+='\n';
	 if (options.showOnSaleTag && options.showOnClearanceTag) { 
	__p+='\n<div class="fmcy-sale-tag fmcy-clearance-tag fmcy-product-tag">\n    clearance\n</div>\n';
	 } 
	__p+='\n';
	 if (options.showCBDTag) { 
	__p+='\n<div class="fmcy-cbd-tag fmcy-product-tag">\n    cbd\n</div>\n';
	 } 
	__p+='\n';
	 if (options.showCBNCBGTag) { 
	__p+='\n<div class="fmcy-cbn-cbg-tag fmcy-product-tag">\n    cbn\n</div>\n';
	 } 
	__p+='\n';
	 if (options.showOrganicTag) { 
	__p+='\n<div class="fmcy-organic-tag fmcy-product-tag">\n    organic\n</div>\n';
	 } 
	__p+='\n';
	 if (options.showBcGrownTag) { 
	__p+='\n<div class="fmcy-bc-grown-tag fmcy-product-tag">\n    bc grown\n</div>\n';
	 } 
	__p+='\n';
	 if (options.showFarmExclusiveTag) { 
	__p+='\n<div class="fmcy-is-farm-exclusive fmcy-product-tag">\n    farm exclusive\n</div>\n';
	 } 
	__p+='\n';
	 if (options.showVeganTag) { 
	__p+='\n<div class="fmcy-vegan-tag fmcy-product-tag">\n    vegan\n</div>\n';
	 } 
	__p+='\n';
	 if (options.productTagText) { 
	__p+='\n<div class="fmcy-inner-tag fmcy-product-tag">\n    <span class="fmcy-inner-tag-text">'+
	((__t=( options.productTagText ))==null?'':__t)+
	'</span>\n</div>\n';
	 } 
	__p+='\n<div class="fmcy-pointy"></div>\n';
	}
	return __p;
	};


/***/ },
/* 101 */,
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var template = _.template(
	    '<div id="<%= id %>" class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
	);
	var ValidationBehavioursMixin = {
	    setErrorState: function (error) {
	        this.state.set('invalid', true);
	        this.showPopover(
	            { title: error, error: true }
	        );
	        this.$el.addClass('has-error');
	    },
	    clearErrorState: function () {
	        this.state.set('invalid', false);
	        this.hidePopover();
	        this.$el.removeClass('has-error');
	    },
	    hidePopover: function () {
	        if (this.state.get('popoverActivated')) {
	            this.getTooltipTargetEl().tooltip('destroy');
	            this.state.set('popoverActivated', false);
	        }
	    },
	    getTooltipTargetEl: function () {
	        return this.state.get('tooltipTargetEl') ?
	            this.$el.find(this.state.get('tooltipTargetEl')) :
	            this.$el;
	    },
	    showPopover: function (options) {
	        var ttipId = 'tl-tooltip-' + this.cid;
	        var that = this;
	        options = _.defaults(
	            options || {},
	            {
	                title: '',
	                placement: 'right',
	                error: false,
	                trigger: 'manual',
	                template: template({ id: ttipId })
	            }
	        );
	
	        var $tooltipTargetEl = this.getTooltipTargetEl();
	        $tooltipTargetEl.tooltip(options)
	            .off('shown.bs.tooltip')
	            .off('hidden.bs.tooltip')
	            .on('hidden.bs.tooltip', function () {
	                that.state.set('popoverActivated', false);
	            })
	            .on('shown.bs.tooltip', function () {
	                that.state.set('popoverActivated', true);
	                var $ttipEl = $('#' + ttipId);
	                if (options.error) {
	                    $ttipEl.addClass('has-error');
	                }
	             });
	        $tooltipTargetEl.tooltip('show');
	    }
	};
	
	module.exports = ValidationBehavioursMixin;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(18)))

/***/ },
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-menu-item-price {\n  display: inline-block;\n  padding: 5px;\n  position: relative;\n  text-transform: uppercase;\n  font-family: 'avril', 'Arial', sans-serif; }\n  .fmcy-menu-item-price .fmcy-menu-item-price-buy-button {\n    color: #ffffff;\n    border-color: #4cb8be;\n    letter-spacing: 1px;\n    background-color: #4cb8be;\n    position: relative;\n    border: 2px solid #4cb8be;\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 100%;\n    line-height: 1.7em;\n    text-align: center;\n    border-radius: 4px;\n    white-space: nowrap;\n    vertical-align: middle;\n    margin: auto;\n    margin-top: 2px; }\n  .fmcy-menu-item-price.fmcy-disable-mouse-event {\n    pointer-events: none; }\n  .fmcy-menu-item-price.fmcy-menu-item-price-check {\n    padding: 0px;\n    padding-left: 5px;\n    padding-right: 5px; }\n  .fmcy-menu-item-price.fmcy-menu-item-price-layout-promotion .fmcy-menu-item-price-label,\n  .fmcy-menu-item-price.fmcy-menu-item-price-layout-promotion .fmcy-menu-item-price-amount,\n  .fmcy-menu-item-price.fmcy-menu-item-price-layout-promotion .fmcy-menu-item-price-quantity {\n    display: inline-block;\n    vertical-align: middle; }\n  .fmcy-menu-item-price.fmcy-menu-item-price-layout-promotion .fmcy-menu-item-price-save,\n  .fmcy-menu-item-price.fmcy-menu-item-price-layout-promotion .fmcy-menu-item-price-amount {\n    font-size: 180%; }\n  .fmcy-menu-item-price.fmcy-menu-item-price-layout-promotion.fmcy-on-sale .fmcy-menu-item-price-label,\n  .fmcy-menu-item-price.fmcy-menu-item-price-layout-promotion.fmcy-on-sale .fmcy-menu-item-price-amount {\n    vertical-align: baseline; }\n  .fmcy-menu-item-price.fmcy-menu-item-price-layout-promotion.fmcy-on-sale .fmcy-menu-item-price-regular,\n  .fmcy-menu-item-price.fmcy-menu-item-price-layout-promotion.fmcy-on-sale .fmcy-menu-item-price-actual {\n    padding-right: 10px; }\n  .fmcy-menu-item-price.fmcy-menu-item-price-layout-promotion.fmcy-on-sale .fmcy-menu-item-price-quantity {\n    position: relative;\n    top: -3px; }\n  .fmcy-menu-item-price.fmcy-menu-item-price-layout-inline .fmcy-dollar-sign {\n    vertical-align: super;\n    font-size: 60%; }\n  .fmcy-menu-item-price.fmcy-menu-item-price-layout-inline .fmcy-menu-item-price-amount,\n  .fmcy-menu-item-price.fmcy-menu-item-price-layout-inline .fmcy-menu-item-price-quantity {\n    display: inline-block;\n    vertical-align: middle; }\n  .fmcy-menu-item-price.fmcy-on-sale .fmcy-menu-item-price-actual {\n    color: #A71C20; }\n  .fmcy-menu-item-price.fmcy-online-purchase-enabled {\n    cursor: pointer; }\n    .fmcy-menu-item-price.fmcy-online-purchase-enabled:hover .fmcy-menu-item-price-buy-button {\n      background-color: #5cd1d8;\n      border: 2px solid #5cd1d8;\n      border-color: #5cd1d8; }\n  .fmcy-menu-item-price .fmcy-menu-item-price-quantity {\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 100%;\n    line-height: 100%;\n    font-weight: bold;\n    border-style: solid;\n    border: 1px solid #666666;\n    color: #666666;\n    padding-left: 3px;\n    padding-right: 3px;\n    letter-spacing: 1px;\n    min-width: 40px;\n    text-align: center; }\n  .fmcy-menu-item-price .fmcy-menu-item-price-amount,\n  .fmcy-menu-item-price .fmcy-menu-item-price-label {\n    text-align: center;\n    font-size: 150%;\n    line-height: 100%;\n    position: relative; }\n  .fmcy-menu-item-price .fmcy-menu-item-price-regular {\n    text-decoration: line-through; }\n  .fmcy-menu-item-price .fmcy-menu-item-price-added {\n    width: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: none;\n    text-align: center; }\n    .fmcy-menu-item-price .fmcy-menu-item-price-added div {\n      display: inline-block;\n      border-radius: 10px;\n      color: #fff;\n      background-color: #4cb8be;\n      height: 20px;\n      width: 20px;\n      line-height: 125%; }\n", ""]);
	
	// exports


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette, _) {'use strict';
	
	__webpack_require__(109);
	var ShoppingCartMenu = __webpack_require__(114);
	var MenuItemPrice = __webpack_require__(113);
	var MenuItemPriceLocationCheck = __webpack_require__(112);
	
	var MenuItemPrices = Marionette.CollectionView.extend({
	  className: 'fmcy-menu-item-prices',
	  childView: MenuItemPrice,
	  childEvents: {
	    'price:clicked': 'onPriceClicked'
	  },
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      size: 'default', // default | large
	      onlinePurchaseEnabled: false,
	      variantShowInStockIfAtAnyLocation: false,
	      filterLocation: null,
	      hideOutOfStockVariation: true,
	      menuItemPriceLayout: undefined,
	      menuItemPriceLayoutSinglePrice: undefined,
	      align: 'center',
	      style: 'default', //default | checks
	      theme: 'default' // default | dark
	    });
	
	    var filterLocation = this.options.filterLocation;
	
	    var locations = self.options.appChannel.request('get:locations');
	
	    locations.each(function (location) {
	      if (location.get('slug') === filterLocation) {
	        self.options.locationId = location.get('id');
	      }
	    });
	  },
	  onPriceClicked: function onPriceClicked(view) {
	    if (!this.options.onlinePurchaseEnabled) {
	      return;
	    }
	
	    if (view.options.variantOutOfStockAtFilteredLocation !== true) {
	      this.itemAddToCart(view.model, view.options.menuItemModel);
	      if (this.options.appChannel.request('is:user:logged:in') == true) {
	        var childView = this.children.findByModel(view.model);
	        if (childView) {
	          childView.displayAddedAnimation();
	        }
	      }
	    }
	  },
	  itemAddToCart: function itemAddToCart(variantModel, menuItemModel) {
	    this.options.appChannel.trigger('cart:add:item', variantModel, menuItemModel);
	  },
	  onRender: function onRender() {
	    this.$el.addClass('fmcy-menu-item-prices-size-' + this.options.size);
	    this.$el.addClass('fmcy-menu-item-prices-theme-' + this.options.theme);
	    if (this.options.align === 'left') {
	      this.$el.addClass('fmy-menu-item-prices-align-left');
	    }
	    if (this.options.style === 'checks') {
	      this.$el.addClass('fmy-menu-item-prices-checks');
	    }
	  },
	  childViewOptions: function childViewOptions(model, index) {
	    var self = this;
	    var options = _.extend({ modelIndex: index }, this.options);
	    if (this.options.filterLocation !== null) {
	      if (this.options.locationId !== null) {
	        var variantOutOfStockAtFilteredLocation = false;
	        if (!model.get('locations')) {
	          variantOutOfStockAtFilteredLocation = true;
	        } else {
	          var variation_at_location = false;
	          _.each(model.get('locations'), function (location) {
	            if (self.options.variantShowInStockIfAtAnyLocation == true) {
	              if (parseInt(location.quantity) > 0) {
	                variation_at_location = true;
	              }
	            } else {
	
	              if (location.location_id == self.options.locationId && parseInt(location.quantity) > 0 && parseInt(location.quantity) >= parseInt(location.order_level_minimum)) {
	                variation_at_location = true;
	              }
	
	              if (location.location_id == self.options.locationId && location.out_of_stock_at_selected_location == true) {
	                variation_at_location = false;
	              }
	            }
	          });
	          if (!variation_at_location) {
	            variantOutOfStockAtFilteredLocation = true;
	          }
	        }
	
	        options = _.extend(options, {
	          variantOutOfStockAtFilteredLocation: variantOutOfStockAtFilteredLocation
	        });
	      }
	
	      if (this.collection.size() === 1) {
	        options = _.extend(options, { layout: this.options.menuItemPriceLayoutSinglePrice });
	      } else if (this.options.menuItemPriceLayout) {
	        options = _.extend(options, { layout: this.options.menuItemPriceLayout });
	      }
	    }
	
	    return options;
	  },
	  buildChildView: function buildChildView(model, ChildViewClass, childViewOptions) {
	    var self = this;
	
	    var options = _.extend({
	      model: model
	    }, childViewOptions);
	
	    var view;
	    switch (options.style) {
	      case 'checks':
	        view = new MenuItemPriceLocationCheck(options);
	        break;
	      default:
	        view = new MenuItemPrice(options);
	        break;
	    }
	
	    return view;
	  }
	});
	module.exports = MenuItemPrices;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15), __webpack_require__(1)))

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(128);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./menu-item-prices.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./menu-item-prices.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 110 */,
/* 111 */,
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	__webpack_require__(78);
	var LAYOUT_TYPES = {
	  STACKED: 'stacked',
	  INLINE: 'inline',
	  PROMOTION: 'promotion'
	};
	var OutOfStockSVG = BaseViews.ItemView.extend({
	  template: function template() {
	    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43.05 7.17"><title>Asset 1</title><g id="Layer_2" data-name="Layer 2"><g id="art"><path d="M0,1.76A1.55,1.55,0,0,1,1.67,0,1.55,1.55,0,0,1,3.34,1.76V5.4A1.55,1.55,0,0,1,1.67,7.16,1.55,1.55,0,0,1,0,5.4ZM1.1,5.47c0,.5.22.69.57.69s.57-.19.57-.69V1.69C2.24,1.19,2,1,1.67,1s-.57.19-.57.69Z"/><path d="M5.3.08v5.4c0,.5.22.68.57.68s.57-.18.57-.68V.08h1V5.41c0,1.12-.56,1.76-1.64,1.76S4.2,6.53,4.2,5.41V.08Z"/><path d="M8.11.08h3.4v1H10.36v6H9.26v-6H8.11Z"/><path d="M13.85,1.76A1.55,1.55,0,0,1,15.52,0a1.55,1.55,0,0,1,1.67,1.76V5.4a1.55,1.55,0,0,1-1.67,1.76A1.55,1.55,0,0,1,13.85,5.4ZM15,5.47c0,.5.22.69.57.69s.57-.19.57-.69V1.69c0-.5-.22-.69-.57-.69s-.57.19-.57.69Z"/><path d="M19.2,3.19h1.42v1H19.2V7.08H18.1v-7H21v1H19.2Z"/><path d="M25,0C26,0,26.59.64,26.59,1.76V2h-1V1.69c0-.5-.2-.69-.55-.69s-.55.19-.55.69.22.89.94,1.52A2.71,2.71,0,0,1,26.6,5.4C26.6,6.52,26,7.16,25,7.16s-1.64-.64-1.64-1.76V5h1v.5c0,.5.22.68.57.68s.57-.18.57-.68-.22-.89-.94-1.52a2.71,2.71,0,0,1-1.21-2.19C23.35.64,23.9,0,25,0Z"/><path d="M27.11.08h3.4v1H29.36v6h-1.1v-6H27.11Z"/><path d="M31.1,1.76a1.67,1.67,0,1,1,3.34,0V5.4a1.67,1.67,0,1,1-3.34,0Zm1.1,3.71c0,.5.22.69.57.69s.57-.19.57-.69V1.69c0-.5-.22-.69-.57-.69s-.57.19-.57.69Z"/><path d="M38.54,4.47V5.4c0,1.12-.56,1.76-1.64,1.76s-1.64-.64-1.64-1.76V1.76C35.26.64,35.82,0,36.9,0s1.64.64,1.64,1.76v.68h-1V1.69c0-.5-.22-.69-.57-.69s-.57.19-.57.69V5.47c0,.5.22.68.57.68s.57-.18.57-.68v-1Z"/><path d="M40.85,4.29l-.34.64V7.08h-1.1v-7h1.1v3h0L42,.08h1.1L41.52,3.2l1.53,3.88H41.92Z"/></g></g></svg>';
	  }
	});
	
	var OutOfStockLabel = BaseViews.ItemView.extend({
	  template: function template() {
	    return 'OUT OF STOCK';
	  },
	  className: 'fmy-menu-item-out-of-stock-variation-label'
	});
	
	var MenuItemPriceLocationCheck = BaseViews.LayoutView.extend({
	  className: 'fmcy-menu-item-price fmcy-menu-item-price-check',
	  template: function template(serializedData) {
	    return __webpack_require__(119)(serializedData);
	  },
	  ui: {
	    priceQuantity: '.fmcy-menu-item-price-quantity',
	    checkMark: '.fmcy-menu-item-price-quantity-check-mark'
	  },
	  regions: {
	    fmcyOutOfStockIconRegion: '.fmcy-menu-item-price-quantity-out-of-stock-icon-region'
	  },
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      onlinePurchaseEnabled: false,
	      layout: LAYOUT_TYPES.STACKED // stacked | inline | promotion
	    });
	  },
	  _isOnSale: function _isOnSale() {
	
	    if (this.model.get('sale_price') === "0.00") {
	      return false;
	    } else {
	      return !!this.model.get('sale_price') && this.model.get('on_sale');
	    }
	  },
	  serializeData: function serializeData() {
	    var onSale = this._isOnSale();
	    var price = this.model.get(onSale ? 'sale_price' : 'price');
	    var regularPrice = this.model.get(onSale ? 'price' : 'sale_price');
	    return {
	      options: this.options,
	      quantity: this.model.get('quantity'),
	      regularPrice: regularPrice,
	      price: price,
	      onSale: onSale,
	      saved: onSale ? (regularPrice - price).toFixed(2) : ''
	    };
	  },
	  _renderOutOfStockIcon: function _renderOutOfStockIcon() {
	    var outOfStockIcon = new OutOfStockLabel();
	    this.fmcyOutOfStockIconRegion.show(outOfStockIcon);
	  },
	  onRender: function onRender() {
	    var self = this;
	    if (this._isOnSale()) {
	      this.$el.addClass('fmcy-on-sale');
	    }
	    if (this.options.variantOutOfStockAtFilteredLocation === true) {
	      this.ui.checkMark.hide();
	      this._renderOutOfStockIcon();
	    }
	
	    var currentFilteredLocation = false;
	
	    _.each(this.model.get('locations'), function (location) {
	      if (location.location_id == self.options.locationId && self.options.appChannel.request('get:filter:location') === location.slug) {
	        currentFilteredLocation = true;
	      }
	    });
	
	    if (currentFilteredLocation === true) {
	      this.$el.addClass('fmcy-menu-item-price-check-selected-location');
	    }
	
	    this.$el.addClass('fmcy-menu-item-price-layout-' + this.options.layout);
	
	    BaseViews.ItemView.prototype.onRender.call(this);
	  }
	});
	module.exports = MenuItemPriceLocationCheck;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	
	__webpack_require__(78);
	var LAYOUT_TYPES = {
	    STACKED: 'stacked',
	    INLINE: 'inline',
	    PROMOTION: 'promotion'
	};
	var MenuItemPrice = BaseViews.ItemView.extend({
	    className: 'fmcy-menu-item-price',
	    template: function template(serializedData) {
	        if (serializedData.options.layout === LAYOUT_TYPES.PROMOTION) {
	            return __webpack_require__(120)(serializedData);
	        } else {
	            return __webpack_require__(121)(serializedData);
	        }
	    },
	    ui: {
	        addedIndicator: '.fmcy-menu-item-price-added',
	        priceQuantity: '.fmcy-menu-item-price-quantity',
	        buyButton: '.fmcy-menu-item-price-buy-button'
	    },
	    triggers: function triggers() {
	        return {
	            'click': {
	                event: 'price:clicked',
	                stopPropagation: this.options.onlinePurchaseEnabled
	            },
	            'mouseover': {
	                event: 'price:mouseover',
	                stopPropagation: true
	            }
	        };
	    },
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            onlinePurchaseEnabled: false,
	            hideOutOfStockVariation: true,
	            layout: LAYOUT_TYPES.STACKED // stacked | inline | promotion
	        });
	    },
	    displayAddedAnimation: function displayAddedAnimation() {
	        var self = this;
	        this.ui.addedIndicator.show();
	        window.gsap.fromTo(this.ui.addedIndicator, {
	            opacity: 1,
	            top: '0px'
	        }, {
	            opacity: 0,
	            top: '-50',
	            duration: 1
	        });
	    },
	    _isOnSale: function _isOnSale() {
	
	        if (this.model.get('sale_price') === "0.00") {
	            return false;
	        } else {
	            return !!this.model.get('sale_price') && this.model.get('on_sale');
	        }
	    },
	    serializeData: function serializeData() {
	        var onSale = this._isOnSale();
	        var price = this.model.get(onSale ? 'sale_price' : 'price');
	        var regularPrice = this.model.get(onSale ? 'price' : 'sale_price');
	        return {
	            options: this.options,
	            quantity: this.model.get('quantity'),
	            regularPrice: regularPrice,
	            price: price,
	            onSale: onSale,
	            saved: onSale ? (regularPrice - price).toFixed(2) : ''
	        };
	    },
	    onRender: function onRender() {
	        if (this.options.onlinePurchaseEnabled) {
	            this.$el.addClass('fmcy-online-purchase-enabled');
	        } else {
	            this.ui.buyButton.hide();
	        }
	        if (this._isOnSale()) {
	            this.$el.addClass('fmcy-on-sale');
	        }
	        if (this.model.get('quantity') === '1') {
	            this.ui.priceQuantity.hide();
	        }
	
	        if (this.options.variantOutOfStockAtFilteredLocation === true) {
	            if (this.options.hideOutOfStockVariation === true) {
	                this.$el.hide();
	            } else {
	                this.$el.addClass('fmcy-disable-mouse-event');
	                this.ui.buyButton.css('opacity', 0.10);
	                this.$el.css('cursor', 'default');
	            }
	        }
	        this.$el.addClass('fmcy-menu-item-price-layout-' + this.options.layout);
	
	        BaseViews.ItemView.prototype.onRender.call(this);
	    }
	});
	module.exports = MenuItemPrice;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var BaseViews = __webpack_require__(5);
	
	__webpack_require__(116);
	var ShoppingCartMenu = BaseViews.LayoutView.extend({
	    tagName: 'a',
	    className: 'fmcy-shopping-cart-menu wpmenucart-contents',
	    events: {
	        click: 'goToCartClicked'
	    },
	    template: __webpack_require__(122),
	    serializeData: function serializeData() {
	        return {
	            items: this.model.get('items'),
	            totalAmount: this.model.get('totalAmount')
	        };
	    },
	    onBeforeShow: function onBeforeShow() {
	        var hrefArray = window.location.href.split('/');
	        this.$el.attr('href', window.location.protocol + '//' + hrefArray[2] + '/cart');
	        this.$el.attr('title', 'View your shopping cart');
	    },
	    onShow: function onShow() {
	        window.gsap.to(this.$el, {
	            color: '#D09F19',
	            duration: 2
	        });
	    }
	});
	module.exports = ShoppingCartMenu;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(115);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./shopping-cart-menu.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./shopping-cart-menu.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 117 */,
/* 118 */,
/* 119 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-menu-item-price-quantity fmcy-menu-item-price-quantity-check">\n    ';
	 if (quantity !== '1') { 
	__p+='\n    '+
	((__t=( quantity ))==null?'':__t)+
	'\n    ';
	 } else { 
	__p+='\n      ONE\n    ';
	 } 
	__p+='\n    <div class="fmcy-menu-item-price-quantity-check-mark"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"/></svg></div>\n    <div class="fmcy-menu-item-price-quantity-out-of-stock-icon-region"></div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 120 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-menu-item-price-quantity">\n    '+
	((__t=( quantity ))==null?'':__t)+
	'\n</div>\n';
	 if (onSale) { 
	__p+='\n<div class="fmcy-menu-item-price-label">regular</div>\n<div class="fmcy-menu-item-price-regular fmcy-menu-item-price-amount">\n    <span class="fmcy-dollar-sign">$</span>'+
	((__t=( regularPrice ))==null?'':__t)+
	'\n</div>\n<div>\n  <div class="fmcy-menu-item-price-label-now fmcy-menu-item-price-label">now</div>\n  <div class="fmcy-menu-item-price-actual fmcy-menu-item-price-amount">\n      <span class="fmcy-dollar-sign">$</span>'+
	((__t=( price ))==null?'':__t)+
	'\n  </div>\n  <div class="fmcy-menu-item-price-label-save fmcy-menu-item-price-label">save</div>\n  <div class="fmcy-menu-item-price-save fmcy-menu-item-price-amount">\n      <span class="fmcy-dollar-sign">$</span>'+
	((__t=( saved ))==null?'':__t)+
	'\n  </div>\n</div>\n';
	 } else { 
	__p+='\n<div class="fmcy-menu-item-price-actual fmcy-menu-item-price-amount">\n    <span class="fmcy-dollar-sign">$</span>'+
	((__t=( price ))==null?'':__t)+
	'\n</div>\n';
	 } 
	__p+='\n<div class="fmcy-menu-item-price-added">\n    <div>+</div>\n</div>\n<div class="fmcy-menu-item-price-buy-button">\n    ADD\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 121 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-menu-item-price-actual fmcy-menu-item-price-amount">\n    <span class="fmcy-dollar-sign">$</span>'+
	((__t=( price ))==null?'':__t)+
	'\n</div>\n';
	 if (onSale) { 
	__p+='\n<div class="fmcy-menu-item-price-regular fmcy-menu-item-price-amount">\n    <span class="fmcy-dollar-sign">$</span>'+
	((__t=( regularPrice ))==null?'':__t)+
	'\n</div>\n';
	 } 
	__p+='\n<div class="fmcy-menu-item-price-quantity">\n    '+
	((__t=( quantity ))==null?'':__t)+
	'\n</div>\n<div class="fmcy-menu-item-price-added">\n    <div>+</div>\n</div>\n<div class="fmcy-menu-item-price-buy-button">\n    ADD\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 122 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<i class="wpmenucart-icon-shopping-cart-0"></i>\n<span class="cartcontents">\n    '+
	((__t=( items ))==null?'':__t)+
	'\n</span>\n<span class="amount">\n    '+
	((__t=( totalAmount ))==null?'':__t)+
	'\n</span>';
	}
	return __p;
	};


/***/ },
/* 123 */,
/* 124 */
/***/ function(module, exports) {

	/*!
	 * modernizr v3.6.0
	 * Build https://modernizr.com/download?-backgroundsize-bgpositionxy-cssanimations-flexbox-opacity-mq-setclasses-dontmin
	 *
	 * Copyright (c)
	 *  Faruk Ates
	 *  Paul Irish
	 *  Alex Sexton
	 *  Ryan Seddon
	 *  Patrick Kettner
	 *  Stu Cox
	 *  Richard Herrera
	
	 * MIT License
	 */
	
	/*
	 * Modernizr tests which native CSS3 and HTML5 features are available in the
	 * current UA and makes the results available to you in two ways: as properties on
	 * a global `Modernizr` object, and as classes on the `<html>` element. This
	 * information allows you to progressively enhance your pages with a granular level
	 * of control over the experience.
	*/
	
	;(function(window, document, undefined){
	  var classes = [];
	
	
	  var tests = [];
	
	
	  /**
	   *
	   * ModernizrProto is the constructor for Modernizr
	   *
	   * @class
	   * @access public
	   */
	
	  var ModernizrProto = {
	    // The current version, dummy
	    _version: '3.6.0',
	
	    // Any settings that don't work as separate modules
	    // can go in here as configuration.
	    _config: {
	      'classPrefix': '',
	      'enableClasses': true,
	      'enableJSClass': true,
	      'usePrefixes': true
	    },
	
	    // Queue of tests
	    _q: [],
	
	    // Stub these for people who are listening
	    on: function(test, cb) {
	      // I don't really think people should do this, but we can
	      // safe guard it a bit.
	      // -- NOTE:: this gets WAY overridden in src/addTest for actual async tests.
	      // This is in case people listen to synchronous tests. I would leave it out,
	      // but the code to *disallow* sync tests in the real version of this
	      // function is actually larger than this.
	      var self = this;
	      setTimeout(function() {
	        cb(self[test]);
	      }, 0);
	    },
	
	    addTest: function(name, fn, options) {
	      tests.push({name: name, fn: fn, options: options});
	    },
	
	    addAsyncTest: function(fn) {
	      tests.push({name: null, fn: fn});
	    }
	  };
	
	
	
	  // Fake some of Object.create so we can force non test results to be non "own" properties.
	  var Modernizr = function() {};
	  Modernizr.prototype = ModernizrProto;
	
	  // Leak modernizr globally when you `require` it rather than force it here.
	  // Overwrite name so constructor name is nicer :D
	  Modernizr = new Modernizr();
	
	
	
	  /**
	   * is returns a boolean if the typeof an obj is exactly type.
	   *
	   * @access private
	   * @function is
	   * @param {*} obj - A thing we want to check the type of
	   * @param {string} type - A string to compare the typeof against
	   * @returns {boolean}
	   */
	
	  function is(obj, type) {
	    return typeof obj === type;
	  }
	  ;
	
	  /**
	   * Run through all tests and detect their support in the current UA.
	   *
	   * @access private
	   */
	
	  function testRunner() {
	    var featureNames;
	    var feature;
	    var aliasIdx;
	    var result;
	    var nameIdx;
	    var featureName;
	    var featureNameSplit;
	
	    for (var featureIdx in tests) {
	      if (tests.hasOwnProperty(featureIdx)) {
	        featureNames = [];
	        feature = tests[featureIdx];
	        // run the test, throw the return value into the Modernizr,
	        // then based on that boolean, define an appropriate className
	        // and push it into an array of classes we'll join later.
	        //
	        // If there is no name, it's an 'async' test that is run,
	        // but not directly added to the object. That should
	        // be done with a post-run addTest call.
	        if (feature.name) {
	          featureNames.push(feature.name.toLowerCase());
	
	          if (feature.options && feature.options.aliases && feature.options.aliases.length) {
	            // Add all the aliases into the names list
	            for (aliasIdx = 0; aliasIdx < feature.options.aliases.length; aliasIdx++) {
	              featureNames.push(feature.options.aliases[aliasIdx].toLowerCase());
	            }
	          }
	        }
	
	        // Run the test, or use the raw value if it's not a function
	        result = is(feature.fn, 'function') ? feature.fn() : feature.fn;
	
	
	        // Set each of the names on the Modernizr object
	        for (nameIdx = 0; nameIdx < featureNames.length; nameIdx++) {
	          featureName = featureNames[nameIdx];
	          // Support dot properties as sub tests. We don't do checking to make sure
	          // that the implied parent tests have been added. You must call them in
	          // order (either in the test, or make the parent test a dependency).
	          //
	          // Cap it to TWO to make the logic simple and because who needs that kind of subtesting
	          // hashtag famous last words
	          featureNameSplit = featureName.split('.');
	
	          if (featureNameSplit.length === 1) {
	            Modernizr[featureNameSplit[0]] = result;
	          } else {
	            // cast to a Boolean, if not one already
	            if (Modernizr[featureNameSplit[0]] && !(Modernizr[featureNameSplit[0]] instanceof Boolean)) {
	              Modernizr[featureNameSplit[0]] = new Boolean(Modernizr[featureNameSplit[0]]);
	            }
	
	            Modernizr[featureNameSplit[0]][featureNameSplit[1]] = result;
	          }
	
	          classes.push((result ? '' : 'no-') + featureNameSplit.join('-'));
	        }
	      }
	    }
	  }
	  ;
	
	  /**
	   * docElement is a convenience wrapper to grab the root element of the document
	   *
	   * @access private
	   * @returns {HTMLElement|SVGElement} The root element of the document
	   */
	
	  var docElement = document.documentElement;
	
	
	  /**
	   * A convenience helper to check if the document we are running in is an SVG document
	   *
	   * @access private
	   * @returns {boolean}
	   */
	
	  var isSVG = docElement.nodeName.toLowerCase() === 'svg';
	
	
	  /**
	   * setClasses takes an array of class names and adds them to the root element
	   *
	   * @access private
	   * @function setClasses
	   * @param {string[]} classes - Array of class names
	   */
	
	  // Pass in an and array of class names, e.g.:
	  //  ['no-webp', 'borderradius', ...]
	  function setClasses(classes) {
	    var className = docElement.className;
	    var classPrefix = Modernizr._config.classPrefix || '';
	
	    if (isSVG) {
	      className = className.baseVal;
	    }
	
	    // Change `no-js` to `js` (independently of the `enableClasses` option)
	    // Handle classPrefix on this too
	    if (Modernizr._config.enableJSClass) {
	      var reJS = new RegExp('(^|\\s)' + classPrefix + 'no-js(\\s|$)');
	      className = className.replace(reJS, '$1' + classPrefix + 'js$2');
	    }
	
	    if (Modernizr._config.enableClasses) {
	      // Add the new classes
	      className += ' ' + classPrefix + classes.join(' ' + classPrefix);
	      if (isSVG) {
	        docElement.className.baseVal = className;
	      } else {
	        docElement.className = className;
	      }
	    }
	
	  }
	
	  ;
	
	  /**
	   * createElement is a convenience wrapper around document.createElement. Since we
	   * use createElement all over the place, this allows for (slightly) smaller code
	   * as well as abstracting away issues with creating elements in contexts other than
	   * HTML documents (e.g. SVG documents).
	   *
	   * @access private
	   * @function createElement
	   * @returns {HTMLElement|SVGElement} An HTML or SVG element
	   */
	
	  function createElement() {
	    if (typeof document.createElement !== 'function') {
	      // This is the case in IE7, where the type of createElement is "object".
	      // For this reason, we cannot call apply() as Object is not a Function.
	      return document.createElement(arguments[0]);
	    } else if (isSVG) {
	      return document.createElementNS.call(document, 'http://www.w3.org/2000/svg', arguments[0]);
	    } else {
	      return document.createElement.apply(document, arguments);
	    }
	  }
	
	  ;
	
	  /**
	   * List of property values to set for css tests. See ticket #21
	   * http://git.io/vUGl4
	   *
	   * @memberof Modernizr
	   * @name Modernizr._prefixes
	   * @optionName Modernizr._prefixes
	   * @optionProp prefixes
	   * @access public
	   * @example
	   *
	   * Modernizr._prefixes is the internal list of prefixes that we test against
	   * inside of things like [prefixed](#modernizr-prefixed) and [prefixedCSS](#-code-modernizr-prefixedcss). It is simply
	   * an array of kebab-case vendor prefixes you can use within your code.
	   *
	   * Some common use cases include
	   *
	   * Generating all possible prefixed version of a CSS property
	   * ```js
	   * var rule = Modernizr._prefixes.join('transform: rotate(20deg); ');
	   *
	   * rule === 'transform: rotate(20deg); webkit-transform: rotate(20deg); moz-transform: rotate(20deg); o-transform: rotate(20deg); ms-transform: rotate(20deg);'
	   * ```
	   *
	   * Generating all possible prefixed version of a CSS value
	   * ```js
	   * rule = 'display:' +  Modernizr._prefixes.join('flex; display:') + 'flex';
	   *
	   * rule === 'display:flex; display:-webkit-flex; display:-moz-flex; display:-o-flex; display:-ms-flex; display:flex'
	   * ```
	   */
	
	  // we use ['',''] rather than an empty array in order to allow a pattern of .`join()`ing prefixes to test
	  // values in feature detects to continue to work
	  var prefixes = (ModernizrProto._config.usePrefixes ? ' -webkit- -moz- -o- -ms- '.split(' ') : ['','']);
	
	  // expose these for the plugin API. Look in the source for how to join() them against your input
	  ModernizrProto._prefixes = prefixes;
	
	
	/*!
	{
	  "name": "CSS Opacity",
	  "caniuse": "css-opacity",
	  "property": "opacity",
	  "tags": ["css"]
	}
	!*/
	
	  // Browsers that actually have CSS Opacity implemented have done so
	  // according to spec, which means their return values are within the
	  // range of [0.0,1.0] - including the leading zero.
	
	  Modernizr.addTest('opacity', function() {
	    var style = createElement('a').style;
	    style.cssText = prefixes.join('opacity:.55;');
	
	    // The non-literal . in this regex is intentional:
	    // German Chrome returns this value as 0,55
	    // github.com/Modernizr/Modernizr/issues/#issue/59/comment/516632
	    return (/^0.55$/).test(style.opacity);
	  });
	
	
	  /**
	   * getBody returns the body of a document, or an element that can stand in for
	   * the body if a real body does not exist
	   *
	   * @access private
	   * @function getBody
	   * @returns {HTMLElement|SVGElement} Returns the real body of a document, or an
	   * artificially created element that stands in for the body
	   */
	
	  function getBody() {
	    // After page load injecting a fake body doesn't work so check if body exists
	    var body = document.body;
	
	    if (!body) {
	      // Can't use the real body create a fake one.
	      body = createElement(isSVG ? 'svg' : 'body');
	      body.fake = true;
	    }
	
	    return body;
	  }
	
	  ;
	
	  /**
	   * injectElementWithStyles injects an element with style element and some CSS rules
	   *
	   * @access private
	   * @function injectElementWithStyles
	   * @param {string} rule - String representing a css rule
	   * @param {function} callback - A function that is used to test the injected element
	   * @param {number} [nodes] - An integer representing the number of additional nodes you want injected
	   * @param {string[]} [testnames] - An array of strings that are used as ids for the additional nodes
	   * @returns {boolean}
	   */
	
	  function injectElementWithStyles(rule, callback, nodes, testnames) {
	    var mod = 'modernizr';
	    var style;
	    var ret;
	    var node;
	    var docOverflow;
	    var div = createElement('div');
	    var body = getBody();
	
	    if (parseInt(nodes, 10)) {
	      // In order not to give false positives we create a node for each test
	      // This also allows the method to scale for unspecified uses
	      while (nodes--) {
	        node = createElement('div');
	        node.id = testnames ? testnames[nodes] : mod + (nodes + 1);
	        div.appendChild(node);
	      }
	    }
	
	    style = createElement('style');
	    style.type = 'text/css';
	    style.id = 's' + mod;
	
	    // IE6 will false positive on some tests due to the style element inside the test div somehow interfering offsetHeight, so insert it into body or fakebody.
	    // Opera will act all quirky when injecting elements in documentElement when page is served as xml, needs fakebody too. #270
	    (!body.fake ? div : body).appendChild(style);
	    body.appendChild(div);
	
	    if (style.styleSheet) {
	      style.styleSheet.cssText = rule;
	    } else {
	      style.appendChild(document.createTextNode(rule));
	    }
	    div.id = mod;
	
	    if (body.fake) {
	      //avoid crashing IE8, if background image is used
	      body.style.background = '';
	      //Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible
	      body.style.overflow = 'hidden';
	      docOverflow = docElement.style.overflow;
	      docElement.style.overflow = 'hidden';
	      docElement.appendChild(body);
	    }
	
	    ret = callback(div, rule);
	    // If this is done after page load we don't want to remove the body so check if body exists
	    if (body.fake) {
	      body.parentNode.removeChild(body);
	      docElement.style.overflow = docOverflow;
	      // Trigger layout so kinetic scrolling isn't disabled in iOS6+
	      // eslint-disable-next-line
	      docElement.offsetHeight;
	    } else {
	      div.parentNode.removeChild(div);
	    }
	
	    return !!ret;
	
	  }
	
	  ;
	
	  /**
	   * Modernizr.mq tests a given media query, live against the current state of the window
	   * adapted from matchMedia polyfill by Scott Jehl and Paul Irish
	   * gist.github.com/786768
	   *
	   * @memberof Modernizr
	   * @name Modernizr.mq
	   * @optionName Modernizr.mq()
	   * @optionProp mq
	   * @access public
	   * @function mq
	   * @param {string} mq - String of the media query we want to test
	   * @returns {boolean}
	   * @example
	   * Modernizr.mq allows for you to programmatically check if the current browser
	   * window state matches a media query.
	   *
	   * ```js
	   *  var query = Modernizr.mq('(min-width: 900px)');
	   *
	   *  if (query) {
	   *    // the browser window is larger than 900px
	   *  }
	   * ```
	   *
	   * Only valid media queries are supported, therefore you must always include values
	   * with your media query
	   *
	   * ```js
	   * // good
	   *  Modernizr.mq('(min-width: 900px)');
	   *
	   * // bad
	   *  Modernizr.mq('min-width');
	   * ```
	   *
	   * If you would just like to test that media queries are supported in general, use
	   *
	   * ```js
	   *  Modernizr.mq('only all'); // true if MQ are supported, false if not
	   * ```
	   *
	   *
	   * Note that if the browser does not support media queries (e.g. old IE) mq will
	   * always return false.
	   */
	
	  var mq = (function() {
	    var matchMedia = window.matchMedia || window.msMatchMedia;
	    if (matchMedia) {
	      return function(mq) {
	        var mql = matchMedia(mq);
	        return mql && mql.matches || false;
	      };
	    }
	
	    return function(mq) {
	      var bool = false;
	
	      injectElementWithStyles('@media ' + mq + ' { #modernizr { position: absolute; } }', function(node) {
	        bool = (window.getComputedStyle ?
	                window.getComputedStyle(node, null) :
	                node.currentStyle).position == 'absolute';
	      });
	
	      return bool;
	    };
	  })();
	
	
	  ModernizrProto.mq = mq;
	
	
	
	  /**
	   * If the browsers follow the spec, then they would expose vendor-specific styles as:
	   *   elem.style.WebkitBorderRadius
	   * instead of something like the following (which is technically incorrect):
	   *   elem.style.webkitBorderRadius
	
	   * WebKit ghosts their properties in lowercase but Opera & Moz do not.
	   * Microsoft uses a lowercase `ms` instead of the correct `Ms` in IE8+
	   *   erik.eae.net/archives/2008/03/10/21.48.10/
	
	   * More here: github.com/Modernizr/Modernizr/issues/issue/21
	   *
	   * @access private
	   * @returns {string} The string representing the vendor-specific style properties
	   */
	
	  var omPrefixes = 'Moz O ms Webkit';
	
	
	  var cssomPrefixes = (ModernizrProto._config.usePrefixes ? omPrefixes.split(' ') : []);
	  ModernizrProto._cssomPrefixes = cssomPrefixes;
	
	
	  /**
	   * List of JavaScript DOM values used for tests
	   *
	   * @memberof Modernizr
	   * @name Modernizr._domPrefixes
	   * @optionName Modernizr._domPrefixes
	   * @optionProp domPrefixes
	   * @access public
	   * @example
	   *
	   * Modernizr._domPrefixes is exactly the same as [_prefixes](#modernizr-_prefixes), but rather
	   * than kebab-case properties, all properties are their Capitalized variant
	   *
	   * ```js
	   * Modernizr._domPrefixes === [ "Moz", "O", "ms", "Webkit" ];
	   * ```
	   */
	
	  var domPrefixes = (ModernizrProto._config.usePrefixes ? omPrefixes.toLowerCase().split(' ') : []);
	  ModernizrProto._domPrefixes = domPrefixes;
	
	
	
	  /**
	   * contains checks to see if a string contains another string
	   *
	   * @access private
	   * @function contains
	   * @param {string} str - The string we want to check for substrings
	   * @param {string} substr - The substring we want to search the first string for
	   * @returns {boolean}
	   */
	
	  function contains(str, substr) {
	    return !!~('' + str).indexOf(substr);
	  }
	
	  ;
	
	  /**
	   * cssToDOM takes a kebab-case string and converts it to camelCase
	   * e.g. box-sizing -> boxSizing
	   *
	   * @access private
	   * @function cssToDOM
	   * @param {string} name - String name of kebab-case prop we want to convert
	   * @returns {string} The camelCase version of the supplied name
	   */
	
	  function cssToDOM(name) {
	    return name.replace(/([a-z])-([a-z])/g, function(str, m1, m2) {
	      return m1 + m2.toUpperCase();
	    }).replace(/^-/, '');
	  }
	  ;
	
	  /**
	   * fnBind is a super small [bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind) polyfill.
	   *
	   * @access private
	   * @function fnBind
	   * @param {function} fn - a function you want to change `this` reference to
	   * @param {object} that - the `this` you want to call the function with
	   * @returns {function} The wrapped version of the supplied function
	   */
	
	  function fnBind(fn, that) {
	    return function() {
	      return fn.apply(that, arguments);
	    };
	  }
	
	  ;
	
	  /**
	   * testDOMProps is a generic DOM property test; if a browser supports
	   *   a certain property, it won't return undefined for it.
	   *
	   * @access private
	   * @function testDOMProps
	   * @param {array.<string>} props - An array of properties to test for
	   * @param {object} obj - An object or Element you want to use to test the parameters again
	   * @param {boolean|object} elem - An Element to bind the property lookup again. Use `false` to prevent the check
	   * @returns {false|*} returns false if the prop is unsupported, otherwise the value that is supported
	   */
	  function testDOMProps(props, obj, elem) {
	    var item;
	
	    for (var i in props) {
	      if (props[i] in obj) {
	
	        // return the property name as a string
	        if (elem === false) {
	          return props[i];
	        }
	
	        item = obj[props[i]];
	
	        // let's bind a function
	        if (is(item, 'function')) {
	          // bind to obj unless overriden
	          return fnBind(item, elem || obj);
	        }
	
	        // return the unbound function or obj or value
	        return item;
	      }
	    }
	    return false;
	  }
	
	  ;
	
	  /**
	   * Create our "modernizr" element that we do most feature tests on.
	   *
	   * @access private
	   */
	
	  var modElem = {
	    elem: createElement('modernizr')
	  };
	
	  // Clean up this element
	  Modernizr._q.push(function() {
	    delete modElem.elem;
	  });
	
	
	
	  var mStyle = {
	    style: modElem.elem.style
	  };
	
	  // kill ref for gc, must happen before mod.elem is removed, so we unshift on to
	  // the front of the queue.
	  Modernizr._q.unshift(function() {
	    delete mStyle.style;
	  });
	
	
	
	  /**
	   * domToCSS takes a camelCase string and converts it to kebab-case
	   * e.g. boxSizing -> box-sizing
	   *
	   * @access private
	   * @function domToCSS
	   * @param {string} name - String name of camelCase prop we want to convert
	   * @returns {string} The kebab-case version of the supplied name
	   */
	
	  function domToCSS(name) {
	    return name.replace(/([A-Z])/g, function(str, m1) {
	      return '-' + m1.toLowerCase();
	    }).replace(/^ms-/, '-ms-');
	  }
	  ;
	
	
	  /**
	   * wrapper around getComputedStyle, to fix issues with Firefox returning null when
	   * called inside of a hidden iframe
	   *
	   * @access private
	   * @function computedStyle
	   * @param {HTMLElement|SVGElement} - The element we want to find the computed styles of
	   * @param {string|null} [pseudoSelector]- An optional pseudo element selector (e.g. :before), of null if none
	   * @returns {CSSStyleDeclaration}
	   */
	
	  function computedStyle(elem, pseudo, prop) {
	    var result;
	
	    if ('getComputedStyle' in window) {
	      result = getComputedStyle.call(window, elem, pseudo);
	      var console = window.console;
	
	      if (result !== null) {
	        if (prop) {
	          result = result.getPropertyValue(prop);
	        }
	      } else {
	        if (console) {
	          var method = console.error ? 'error' : 'log';
	          console[method].call(console, 'getComputedStyle returning null, its possible modernizr test results are inaccurate');
	        }
	      }
	    } else {
	      result = !pseudo && elem.currentStyle && elem.currentStyle[prop];
	    }
	
	    return result;
	  }
	
	  ;
	
	  /**
	   * nativeTestProps allows for us to use native feature detection functionality if available.
	   * some prefixed form, or false, in the case of an unsupported rule
	   *
	   * @access private
	   * @function nativeTestProps
	   * @param {array} props - An array of property names
	   * @param {string} value - A string representing the value we want to check via @supports
	   * @returns {boolean|undefined} A boolean when @supports exists, undefined otherwise
	   */
	
	  // Accepts a list of property names and a single value
	  // Returns `undefined` if native detection not available
	  function nativeTestProps(props, value) {
	    var i = props.length;
	    // Start with the JS API: http://www.w3.org/TR/css3-conditional/#the-css-interface
	    if ('CSS' in window && 'supports' in window.CSS) {
	      // Try every prefixed variant of the property
	      while (i--) {
	        if (window.CSS.supports(domToCSS(props[i]), value)) {
	          return true;
	        }
	      }
	      return false;
	    }
	    // Otherwise fall back to at-rule (for Opera 12.x)
	    else if ('CSSSupportsRule' in window) {
	      // Build a condition string for every prefixed variant
	      var conditionText = [];
	      while (i--) {
	        conditionText.push('(' + domToCSS(props[i]) + ':' + value + ')');
	      }
	      conditionText = conditionText.join(' or ');
	      return injectElementWithStyles('@supports (' + conditionText + ') { #modernizr { position: absolute; } }', function(node) {
	        return computedStyle(node, null, 'position') == 'absolute';
	      });
	    }
	    return undefined;
	  }
	  ;
	
	  // testProps is a generic CSS / DOM property test.
	
	  // In testing support for a given CSS property, it's legit to test:
	  //    `elem.style[styleName] !== undefined`
	  // If the property is supported it will return an empty string,
	  // if unsupported it will return undefined.
	
	  // We'll take advantage of this quick test and skip setting a style
	  // on our modernizr element, but instead just testing undefined vs
	  // empty string.
	
	  // Property names can be provided in either camelCase or kebab-case.
	
	  function testProps(props, prefixed, value, skipValueTest) {
	    skipValueTest = is(skipValueTest, 'undefined') ? false : skipValueTest;
	
	    // Try native detect first
	    if (!is(value, 'undefined')) {
	      var result = nativeTestProps(props, value);
	      if (!is(result, 'undefined')) {
	        return result;
	      }
	    }
	
	    // Otherwise do it properly
	    var afterInit, i, propsLength, prop, before;
	
	    // If we don't have a style element, that means we're running async or after
	    // the core tests, so we'll need to create our own elements to use
	
	    // inside of an SVG element, in certain browsers, the `style` element is only
	    // defined for valid tags. Therefore, if `modernizr` does not have one, we
	    // fall back to a less used element and hope for the best.
	    // for strict XHTML browsers the hardly used samp element is used
	    var elems = ['modernizr', 'tspan', 'samp'];
	    while (!mStyle.style && elems.length) {
	      afterInit = true;
	      mStyle.modElem = createElement(elems.shift());
	      mStyle.style = mStyle.modElem.style;
	    }
	
	    // Delete the objects if we created them.
	    function cleanElems() {
	      if (afterInit) {
	        delete mStyle.style;
	        delete mStyle.modElem;
	      }
	    }
	
	    propsLength = props.length;
	    for (i = 0; i < propsLength; i++) {
	      prop = props[i];
	      before = mStyle.style[prop];
	
	      if (contains(prop, '-')) {
	        prop = cssToDOM(prop);
	      }
	
	      if (mStyle.style[prop] !== undefined) {
	
	        // If value to test has been passed in, do a set-and-check test.
	        // 0 (integer) is a valid property value, so check that `value` isn't
	        // undefined, rather than just checking it's truthy.
	        if (!skipValueTest && !is(value, 'undefined')) {
	
	          // Needs a try catch block because of old IE. This is slow, but will
	          // be avoided in most cases because `skipValueTest` will be used.
	          try {
	            mStyle.style[prop] = value;
	          } catch (e) {}
	
	          // If the property value has changed, we assume the value used is
	          // supported. If `value` is empty string, it'll fail here (because
	          // it hasn't changed), which matches how browsers have implemented
	          // CSS.supports()
	          if (mStyle.style[prop] != before) {
	            cleanElems();
	            return prefixed == 'pfx' ? prop : true;
	          }
	        }
	        // Otherwise just return true, or the property name if this is a
	        // `prefixed()` call
	        else {
	          cleanElems();
	          return prefixed == 'pfx' ? prop : true;
	        }
	      }
	    }
	    cleanElems();
	    return false;
	  }
	
	  ;
	
	  /**
	   * testPropsAll tests a list of DOM properties we want to check against.
	   * We specify literally ALL possible (known and/or likely) properties on
	   * the element including the non-vendor prefixed one, for forward-
	   * compatibility.
	   *
	   * @access private
	   * @function testPropsAll
	   * @param {string} prop - A string of the property to test for
	   * @param {string|object} [prefixed] - An object to check the prefixed properties on. Use a string to skip
	   * @param {HTMLElement|SVGElement} [elem] - An element used to test the property and value against
	   * @param {string} [value] - A string of a css value
	   * @param {boolean} [skipValueTest] - An boolean representing if you want to test if value sticks when set
	   * @returns {false|string} returns the string version of the property, or false if it is unsupported
	   */
	  function testPropsAll(prop, prefixed, elem, value, skipValueTest) {
	
	    var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
	      props = (prop + ' ' + cssomPrefixes.join(ucProp + ' ') + ucProp).split(' ');
	
	    // did they call .prefixed('boxSizing') or are we just testing a prop?
	    if (is(prefixed, 'string') || is(prefixed, 'undefined')) {
	      return testProps(props, prefixed, value, skipValueTest);
	
	      // otherwise, they called .prefixed('requestAnimationFrame', window[, elem])
	    } else {
	      props = (prop + ' ' + (domPrefixes).join(ucProp + ' ') + ucProp).split(' ');
	      return testDOMProps(props, prefixed, elem);
	    }
	  }
	
	  // Modernizr.testAllProps() investigates whether a given style property,
	  // or any of its vendor-prefixed variants, is recognized
	  //
	  // Note that the property names must be provided in the camelCase variant.
	  // Modernizr.testAllProps('boxSizing')
	  ModernizrProto.testAllProps = testPropsAll;
	
	
	
	  /**
	   * testAllProps determines whether a given CSS property is supported in the browser
	   *
	   * @memberof Modernizr
	   * @name Modernizr.testAllProps
	   * @optionName Modernizr.testAllProps()
	   * @optionProp testAllProps
	   * @access public
	   * @function testAllProps
	   * @param {string} prop - String naming the property to test (either camelCase or kebab-case)
	   * @param {string} [value] - String of the value to test
	   * @param {boolean} [skipValueTest=false] - Whether to skip testing that the value is supported when using non-native detection
	   * @example
	   *
	   * testAllProps determines whether a given CSS property, in some prefixed form,
	   * is supported by the browser.
	   *
	   * ```js
	   * testAllProps('boxSizing')  // true
	   * ```
	   *
	   * It can optionally be given a CSS value in string form to test if a property
	   * value is valid
	   *
	   * ```js
	   * testAllProps('display', 'block') // true
	   * testAllProps('display', 'penguin') // false
	   * ```
	   *
	   * A boolean can be passed as a third parameter to skip the value check when
	   * native detection (@supports) isn't available.
	   *
	   * ```js
	   * testAllProps('shapeOutside', 'content-box', true);
	   * ```
	   */
	
	  function testAllProps(prop, value, skipValueTest) {
	    return testPropsAll(prop, undefined, undefined, value, skipValueTest);
	  }
	  ModernizrProto.testAllProps = testAllProps;
	
	/*!
	{
	  "name": "CSS Animations",
	  "property": "cssanimations",
	  "caniuse": "css-animation",
	  "polyfills": ["transformie", "csssandpaper"],
	  "tags": ["css"],
	  "warnings": ["Android < 4 will pass this test, but can only animate a single property at a time"],
	  "notes": [{
	    "name" : "Article: 'Dispelling the Android CSS animation myths'",
	    "href": "https://goo.gl/OGw5Gm"
	  }]
	}
	!*/
	/* DOC
	Detects whether or not elements can be animated using CSS
	*/
	
	  Modernizr.addTest('cssanimations', testAllProps('animationName', 'a', true));
	
	/*!
	{
	  "name": "Background Size",
	  "property": "backgroundsize",
	  "tags": ["css"],
	  "knownBugs": ["This will false positive in Opera Mini - https://github.com/Modernizr/Modernizr/issues/396"],
	  "notes": [{
	    "name": "Related Issue",
	    "href": "https://github.com/Modernizr/Modernizr/issues/396"
	  }]
	}
	!*/
	
	  Modernizr.addTest('backgroundsize', testAllProps('backgroundSize', '100%', true));
	
	/*!
	{
	  "name": "Flexbox",
	  "property": "flexbox",
	  "caniuse": "flexbox",
	  "tags": ["css"],
	  "notes": [{
	    "name": "The _new_ flexbox",
	    "href": "http://dev.w3.org/csswg/css3-flexbox"
	  }],
	  "warnings": [
	    "A `true` result for this detect does not imply that the `flex-wrap` property is supported; see the `flexwrap` detect."
	  ]
	}
	!*/
	/* DOC
	Detects support for the Flexible Box Layout model, a.k.a. Flexbox, which allows easy manipulation of layout order and sizing within a container.
	*/
	
	  Modernizr.addTest('flexbox', testAllProps('flexBasis', '1px', true));
	
	/*!
	{
	  "name": "Background Position XY",
	  "property": "bgpositionxy",
	  "tags": ["css"],
	  "builderAliases": ["css_backgroundposition_xy"],
	  "authors": ["Allan Lei", "Brandom Aaron"],
	  "notes": [{
	    "name": "Demo",
	    "href": "https://jsfiddle.net/allanlei/R8AYS/"
	  }, {
	    "name": "Adapted From",
	    "href": "https://github.com/brandonaaron/jquery-cssHooks/blob/master/bgpos.js"
	  }]
	}
	!*/
	/* DOC
	Detects the ability to control an element's background position using css
	*/
	
	  Modernizr.addTest('bgpositionxy', function() {
	    return testAllProps('backgroundPositionX', '3px', true) && testAllProps('backgroundPositionY', '5px', true);
	  });
	
	
	  // Run each test
	  testRunner();
	
	  // Remove the "no-js" class if it exists
	  setClasses(classes);
	
	  delete ModernizrProto.addTest;
	  delete ModernizrProto.addAsyncTest;
	
	  // Run the things that are supposed to run after the tests
	  for (var i = 0; i < Modernizr._q.length; i++) {
	    Modernizr._q[i]();
	  }
	
	  // Leak Modernizr namespace
	  window.Modernizr = Modernizr;
	
	
	;
	
	})(window, document);

/***/ },
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-menu-item-prices {\n  text-align: center;\n  padding-left: 0px;\n  padding-right: 0px;\n  padding-bottom: 6px;\n  /*\n    @media only screen and (min-width: 2000px) {\n      &.fmy-menu-item-prices-align-left {\n        text-align: left;\n      }\n    }\n    */ }\n  .fmcy-menu-item-prices.fmy-menu-item-prices-checks {\n    padding-bottom: 0px; }\n  .fmcy-menu-item-prices.fmy-menu-item-prices-align-left {\n    text-align: left; }\n  .fmcy-menu-item-prices.fmcy-menu-item-prices-theme-dark {\n    background-color: #000000; }\n    .fmcy-menu-item-prices.fmcy-menu-item-prices-theme-dark .fmcy-menu-item-price-amount {\n      color: #949598; }\n  .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large .fmcy-menu-item-price:hover .fmcy-menu-item-price-quantity {\n    border-width: 2px; }\n  .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large .fmcy-menu-item-price .fmcy-menu-item-price-regular,\n  .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large .fmcy-menu-item-price .fmcy-menu-item-price-label {\n    font-size: 150%; }\n  .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large .fmcy-menu-item-price .fmcy-menu-item-price-actual {\n    font-size: 150%;\n    padding-top: 10px;\n    padding-bottom: 10px; }\n  .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large .fmcy-menu-item-price.fmcy-on-sale .fmcy-menu-item-price-actual {\n    padding-bottom: 0; }\n  .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large .fmcy-menu-item-price.fmcy-menu-item-price-check-selected-location .fmcy-menu-item-price-quantity.fmcy-menu-item-price-quantity-check {\n    border: 2px solid #000000 !important;\n    color: #ffffff !important;\n    background-color: #ffffff !important; }\n  .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large .fmcy-menu-item-price .fmcy-menu-item-price-quantity {\n    border: 2px solid #000;\n    border-width: 2px;\n    font-size: 140%;\n    color: #000;\n    font-weight: normal; }\n    .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large .fmcy-menu-item-price .fmcy-menu-item-price-quantity.fmcy-menu-item-price-quantity-check {\n      border: 2px solid #d7d8d9 !important;\n      color: #d7d8d9 !important;\n      background-color: #d7d8d9 !important;\n      position: relative; }\n      .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large .fmcy-menu-item-price .fmcy-menu-item-price-quantity.fmcy-menu-item-price-quantity-check .fmcy-menu-item-price-quantity-check-mark {\n        position: absolute;\n        top: 0px;\n        left: 0%;\n        margin-left: 0px;\n        width: 100%; }\n        .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large .fmcy-menu-item-price .fmcy-menu-item-price-quantity.fmcy-menu-item-price-quantity-check .fmcy-menu-item-price-quantity-check-mark svg {\n          width: 10px;\n          height: 10px; }\n  .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large .fmcy-menu-item-price.fmcy-menu-item-price-layout-promotion .fmcy-menu-item-price-actual,\n  .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large .fmcy-menu-item-price.fmcy-menu-item-price-layout-promotion .fmcy-menu-item-price-regular {\n    padding: 0;\n    padding-right: 5px; }\n\n/* Custom, iPhone Retina */\n/* Extra Small Devices, Phones */\n/* Small Devices, Tablets */\n@media only screen and (min-width: 1400px) {\n  .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large .fmcy-menu-item-price .fmcy-menu-item-price-amount,\n  .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large .fmcy-menu-item-price .fmcy-menu-item-price-label {\n    font-size: 240%; }\n  .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large .fmcy-menu-item-price .fmcy-menu-item-price-actual {\n    font-size: 260%; }\n  .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large .fmcy-menu-item-price .fmcy-menu-item-price-quantity {\n    padding: 0.25em 0.5em;\n    font-size: 200%;\n    font-weight: normal; }\n    .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large .fmcy-menu-item-price .fmcy-menu-item-price-quantity.fmcy-menu-item-price-quantity-check .fmcy-menu-item-price-quantity-check-mark {\n      position: absolute;\n      top: 5px;\n      left: 0%;\n      margin-left: 0px; }\n      .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large .fmcy-menu-item-price .fmcy-menu-item-price-quantity.fmcy-menu-item-price-quantity-check .fmcy-menu-item-price-quantity-check-mark svg {\n        width: 24px;\n        height: 24px; }\n  .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large .fmcy-menu-item-price.fmcy-menu-item-price-layout-promotion .fmcy-menu-item-price-actual,\n  .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large .fmcy-menu-item-price.fmcy-menu-item-price-layout-promotion .fmcy-menu-item-price-regular {\n    font-size: 260%;\n    padding: 0;\n    padding-right: 5px; } }\n\n/* Medium Devices, Desktops */\n@media only screen and (min-width: 2000px) {\n  .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large .fmcy-menu-item-price.fmcy-on-sale .fmcy-menu-item-price-regular {\n    padding-top: 0; }\n  .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large .fmcy-menu-item-price-regular {\n    padding-top: 10px;\n    padding-bottom: 5px; }\n  .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large .fmcy-menu-item-price-actual {\n    padding-top: 10px; }\n  .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large.fmcy-menu-item-price-layout-promotion .fmcy-menu-item-price-actual,\n  .fmcy-menu-item-prices.fmcy-menu-item-prices-size-large.fmcy-menu-item-price-layout-promotion .fmcy-menu-item-price-regular {\n    padding: 0;\n    padding-right: 5px; } }\n\n.fmcy-menu-item-prices-location-table {\n  border-collapse: collapse; }\n  .fmcy-menu-item-prices-location-table .location-table-available-at-title-column {\n    vertical-align: bottom; }\n  .fmcy-menu-item-prices-location-table .location-table-available-at-title {\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 110%;\n    color: #7b7c7f; }\n  .fmcy-menu-item-prices-location-table .fmcy-other-location-td-name-column {\n    position: relative;\n    vertical-align: middle;\n    min-width: 60px; }\n  @media only screen and (min-width: 345px) {\n    .fmcy-menu-item-prices-location-table .fmcy-other-location-td-name-column {\n      min-width: 80px; }\n      .fmcy-menu-item-prices-location-table .fmcy-other-location-td-name-column.fmcy-other-location-name {\n        max-width: 80px; } }\n  @media only screen and (min-width: 460px) {\n    .fmcy-menu-item-prices-location-table .fmcy-other-location-td-name-column {\n      min-width: 100px; }\n      .fmcy-menu-item-prices-location-table .fmcy-other-location-td-name-column.fmcy-other-location-name {\n        max-width: 100px; } }\n  @media only screen and (min-width: 560px) {\n    .fmcy-menu-item-prices-location-table .fmcy-other-location-td-name-column {\n      min-width: 120px; }\n      .fmcy-menu-item-prices-location-table .fmcy-other-location-td-name-column.fmcy-other-location-name {\n        max-width: 120px; } }\n  @media only screen and (min-width: 660px) {\n    .fmcy-menu-item-prices-location-table .fmcy-other-location-td-name-column {\n      min-width: 140px; }\n      .fmcy-menu-item-prices-location-table .fmcy-other-location-td-name-column.fmcy-other-location-name {\n        max-width: 140px; } }\n  @media only screen and (min-width: 760px) {\n    .fmcy-menu-item-prices-location-table .fmcy-other-location-td-name-column {\n      min-width: 160px; }\n      .fmcy-menu-item-prices-location-table .fmcy-other-location-td-name-column.fmcy-other-location-name {\n        max-width: 160px; } }\n  @media only screen and (min-width: 860px) {\n    .fmcy-menu-item-prices-location-table .fmcy-other-location-td-name-column {\n      min-width: 180px; }\n      .fmcy-menu-item-prices-location-table .fmcy-other-location-td-name-column.fmcy-other-location-name {\n        max-width: 180px; } }\n  @media only screen and (min-width: 1081px) {\n    .fmcy-menu-item-prices-location-table .fmcy-other-location-td-name-column {\n      min-width: 120px; }\n      .fmcy-menu-item-prices-location-table .fmcy-other-location-td-name-column.fmcy-other-location-name {\n        max-width: 120px; } }\n  @media only screen and (min-width: 1400px) {\n    .fmcy-menu-item-prices-location-table .fmcy-other-location-td-name-column {\n      min-width: 160px; }\n      .fmcy-menu-item-prices-location-table .fmcy-other-location-td-name-column.fmcy-other-location-name {\n        max-width: 160px; } }\n  @media only screen and (min-width: 2400px) {\n    .fmcy-menu-item-prices-location-table .fmcy-other-location-td-name-column {\n      min-width: 200px; }\n      .fmcy-menu-item-prices-location-table .fmcy-other-location-td-name-column.fmcy-other-location-name {\n        max-width: 200px; } }\n  @media only screen and (min-width: 3000px) {\n    .fmcy-menu-item-prices-location-table .fmcy-other-location-td-name-column {\n      min-width: 240px; }\n      .fmcy-menu-item-prices-location-table .fmcy-other-location-td-name-column.fmcy-other-location-name {\n        max-width: 240px; } }\n  .fmcy-menu-item-prices-location-table .fmy-menu-item-out-of-stock-variation-label {\n    color: #000;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    text-align: center;\n    font-size: 0.46em;\n    display: inline-block;\n    width: 100%;\n    font-weight: lighter;\n    letter-spacing: 0.01px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis; }\n  @media only screen and (min-width: 1400px) {\n    .fmcy-menu-item-prices-location-table .fmy-menu-item-out-of-stock-variation-label {\n      top: 18%;\n      font-size: 0.56em; } }\n  .fmcy-menu-item-prices-location-table .fmcy-menu-item-prices {\n    padding-bottom: 0px !important; }\n  .fmcy-menu-item-prices-location-table .fmcy-other-location-name {\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 90%;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    display: block;\n    text-align: center; }\n  .fmcy-menu-item-prices-location-table .container-fluid {\n    padding-left: 0px !important;\n    padding-right: 0px !important; }\n  .fmcy-menu-item-prices-location-table .row.no-gutter {\n    margin-right: 0;\n    margin-left: 0; }\n  .fmcy-menu-item-prices-location-table .row.no-gutter > [class*='col-'] {\n    padding-right: 0;\n    padding-left: 0; }\n  .fmcy-menu-item-prices-location-table .prices-location-table-selected .fmcy-other-location-td-name-column {\n    box-shadow: inset 0px 0px 0px 2px black; }\n  .fmcy-menu-item-prices-location-table .prices-location-table-selected .fmcy-other-location-name-wrapper {\n    background-color: #fff;\n    border: 1px solid #000;\n    position: absolute;\n    top: 1px;\n    bottom: 1px;\n    right: 1px;\n    left: 1px; }\n  .fmcy-menu-item-prices-location-table .prices-location-table-selected .fmcy-other-location-name {\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 90%;\n    color: #000;\n    text-align: center;\n    padding-left: 0px; }\n  @media only screen and (min-width: 1400px) {\n    .fmcy-menu-item-prices-location-table .fmcy-other-location-name {\n      font-size: 110%; }\n    .fmcy-menu-item-prices-location-table .prices-location-table-selected .fmcy-other-location-name {\n      font-size: 110%; } }\n\n.fmcy-product-tile-theme-dark .fmcy-menu-item-prices-location-table .fmcy-other-location-name {\n  color: #fff; }\n\n.fmcy-product-tile-theme-dark .fmcy-menu-item-prices-location-table .prices-location-table-selected .fmcy-other-location-td-name-column {\n  box-shadow: inset 0px 0px 0px 2px #f9f9f9; }\n\n.fmcy-product-tile-theme-dark .fmcy-menu-item-prices-location-table .prices-location-table-selected-title {\n  background-color: #565759 !important; }\n\n.fmcy-product-tile-theme-dark .fmcy-menu-item-prices-location-table .location-table-available-at-title {\n  color: #7b7c7f; }\n\n.fmcy-product-tile-theme-dark .fmcy-menu-item-prices-location-table .fmcy-menu-item-price.fmcy-menu-item-price-check-selected-location .fmcy-menu-item-price-quantity.fmcy-menu-item-price-quantity-check {\n  border: 2px solid #eee !important; }\n", ""]);
	
	// exports


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Backbone) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	var AvailableAtLocationView = BaseViews.ItemView.extend({
	    className: 'fmcy-available-at-location',
	    template: __webpack_require__(141),
	    tagName: 'li',
	    events: {
	        'click a': function clickA(e) {
	            if (e.stopPropagation) {
	                e.stopPropagation();
	            }
	            if (!this.options.loadHomePageURLOnClick) {
	                // If we're not loading the home page then we're loading the
	                // menu with location set so scroll to the top for the user.
	                this.options.appChannel.request('scroll:to:page:top');
	            }
	        }
	    },
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            loadHomePageURLOnClick: false
	        });
	    },
	    serializeData: function serializeData() {
	        return {
	            options: this.options,
	            location: this.model.toJSON()
	        };
	    }
	});
	
	__webpack_require__(139);
	var AvailableAtLocationsView = Backbone.Marionette.CompositeView.extend({
	    className: 'fmcy-available-at-locations',
	    template: __webpack_require__(142),
	    childView: AvailableAtLocationView,
	    childViewContainer: '.fmcy-locations-container',
	    childViewOptions: function childViewOptions(model, index) {
	        return {
	            loadHomePageURLOnClick: this.options.loadHomePageURLOnLocationLabelClick,
	            appChannel: this.options.appChannel
	        };
	    },
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            preLocationsListText: 'available at ',
	            postLocationsListText: '',
	            loadHomePageURLOnLocationLabelClick: true,
	            align: 'center'
	        });
	    },
	    onRender: function onRender() {
	        if (this.options.align == 'left') {
	            this.$el.addClass('fmcy-available-at-locations-align-left');
	        }
	    },
	    serializeData: function serializeData() {
	        return {
	            options: this.options
	        };
	    }
	});
	
	module.exports = AvailableAtLocationsView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Backbone) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	__webpack_require__(140);
	var FavouriteButtonView = BaseViews.LayoutView.extend({
	  className: 'fmcy-favourite-button',
	  template: __webpack_require__(143),
	  initialize: function initialize(options) {
	    this.options = _.defaults(options || {}, {
	      isFavourite: false,
	      appChannel: null
	    });
	  },
	  events: {
	    'click': 'onClick'
	  },
	  initialize: function initialize() {
	    var self = this;
	    this.model = new Backbone.Model({
	      isFavourite: this.options.isFavourite
	    });
	    var throttledRequest = _.debounce(_.bind(self._delayedRequest, self), 1000);
	    this.listenTo(this.model, 'change:isFavourite', function () {
	      self._toggleFavourite();
	      throttledRequest();
	    });
	  },
	  onClick: function onClick() {
	    var self = this;
	    if (this.model.get('isFavourite') === true) {
	      this.model.set('isFavourite', false);
	    } else {
	      this.model.set('isFavourite', true);
	    }
	  },
	  _delayedRequest: function _delayedRequest() {
	    this.trigger('toggle:favourite', this.model.get('isFavourite'));
	  },
	  _toggleFavourite: function _toggleFavourite() {
	    if (this.model.get('isFavourite') == true) {
	      this.$el.addClass('farm-favourited');
	    } else {
	      this.$el.removeClass('farm-favourited');
	    }
	  },
	  setFavourite: function setFavourite(isFavourite) {
	    this.model.set('isFavourite', isFavourite);
	  },
	  serializeData: function serializeData() {
	    var self = this;
	    return {
	      isFavourite: true,
	      size: this.options.size
	    };
	  },
	  onRender: function onRender() {
	    this._toggleFavourite();
	  }
	});
	
	module.exports = FavouriteButtonView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Backbone) {'use strict';
	
	module.exports = {
	    _DEFAULT_BANNER_PRIORITY_ORDER_FIELD_NAMES: ['on_clearance', 'on_sale', 'is_new'],
	    _BANNER_FIELD_NAME_TO_CLASS_NAME_MAP: {
	        on_sale: 'fmcy-menu-item-weekly-sale-banner',
	        is_new: 'fmcy-menu-item-is-new-banner',
	        on_clearance: 'fmcy-menu-item-clearance-banner'
	    },
	    _STRAINS_WITH_IMAGES: ['hybrid', 'indica', 'sativa'],
	    _CATEGORIES_WITH_IMAGES: ['concentrates', 'edibles', 'pre-rolls', 'other'],
	    getBannerClassName: function getBannerClassName() {
	        var self = this;
	        var bannerClassName;
	        _.each(self.options.bannerPriority, function (bannerFieldName) {
	            if (!bannerClassName) {
	                if (bannerFieldName === 'on_sale') {
	                    if (self.model.isOnSale()) {
	                        bannerClassName = self._BANNER_FIELD_NAME_TO_CLASS_NAME_MAP[bannerFieldName];
	                    }
	                } else if (self.model.get(bannerFieldName)) {
	                    bannerClassName = self._BANNER_FIELD_NAME_TO_CLASS_NAME_MAP[bannerFieldName];
	                }
	            }
	        });
	        return bannerClassName;
	    },
	    getStrainTitleImageClassName: function getStrainTitleImageClassName() {
	        var strainTitleImgClass = '';
	        var strainGroup = this.model.getStrainGroupCode();
	        if (strainGroup && this._STRAINS_WITH_IMAGES.indexOf(strainGroup) !== -1) {
	            strainTitleImgClass = 'fmcy-menu-item-thumb-category-' + strainGroup + '-title';
	        } else if (this.model.get('category') && this._CATEGORIES_WITH_IMAGES.indexOf(this.model.get('category')) !== -1) {
	            strainTitleImgClass = 'fmcy-menu-item-thumb-category-' + this.model.get('category').toLowerCase() + '-title';
	        }
	        return strainTitleImgClass;
	    },
	    getEffectsAttrsString: function getEffectsAttrsString() {
	        var effectsAttrs = '';
	        if (this.model.get('menu_headline')) {
	            effectsAttrs = this.model.get('menu_headline');
	        } else {
	            effectsAttrs = this.model.get('menu_effects_general');
	        }
	        return effectsAttrs;
	    },
	    getMedicalAttrsString: function getMedicalAttrsString() {
	        var medicalAttrs = '';
	        if (this.model.get('menu_sub_headline')) {
	            medicalAttrs = this.model.get('menu_sub_headline');
	        } else {
	            medicalAttrs = this.model.get('menu_effects_medical');
	        }
	        return medicalAttrs;
	    },
	    _getProductLocations: function _getProductLocations(includeOutOfStock) {
	        var self = this;
	        var allLocations = self.options.locations;
	        if (includeOutOfStock == true) {
	            return allLocations;
	        }
	        var productVariants = self.model.get('variants');
	        var productLocations = new Backbone.Collection();
	        productVariants.each(function (productVariant) {
	            _.each(productVariant.get('locations'), function (pvl) {
	                if (pvl.quantity && pvl.quantity > 0 && !pvl.temp_removed) {
	                    var location = allLocations.get(pvl.location_id);
	                    if (self.options.showOnlineProductLocations || location && location.get('type') === self.model.PRODUCT_LOCATION_TYPES.STORE) {
	                        productLocations.add(location);
	                    }
	                }
	            });
	        });
	        return productLocations;
	    },
	    _shouldRenderProductLocations: function _shouldRenderProductLocations() {
	        if (this.options.showProductLocations) {
	            return this._getProductLocations().size() > 0;
	        }
	        return false;
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Backbone) {'use strict';
	
	/*
	
	    Dev notes:
	    The showPricesPinned option renders the prices pinned to the bottom
	    of the thumb container. We still render the inline positioned prices
	    to make space for the absolute position prices.
	
	    Features:
	        - display the product image
	        - display product tag (for example sativa, indica has or whatever) in the top left corner
	        - display the locations
	        - display prices
	            - option to pin the prices to the bottom of the menu card
	        - display promotional headline
	        - display effects
	        - display medical attributes
	        - display the new|on sale\ on clearance banner in the top right corner
	*/
	
	var BaseViews = __webpack_require__(5);
	__webpack_require__(162);
	var MenuItemPrices = __webpack_require__(108);
	var AvailableAtLocations = __webpack_require__(129);
	var PotencyDisplay = __webpack_require__(79);
	var FavouriteButton = __webpack_require__(130);
	
	var DropdownList = __webpack_require__(43);
	var MenuItemThumb = BaseViews.LayoutView.extend({
	    // Only display a product tag for a product with a
	    // category in _DISPLAY_PRODUCT_TAG_FOR_CATEGORIES
	    _DISPLAY_PRODUCT_TAG_FOR_CATEGORIES: ['hash', 'cbd'],
	    _preloadQueue: null,
	    _menuState: null,
	    className: 'fmcy-menu-item-thumb hidden',
	    template: __webpack_require__(163),
	    regions: {
	        pricesRegion: '.fmcy-item-prices-region',
	        pricesPinnnedRegion: '.fmcy-item-prices-pinned-region',
	        thumbImageRegion: '.fmcy-menu-item-thumb-image-region',
	        availableAtLocationsRegion: '.fmcy-available-at-locations-region',
	        vendorIconRegion: '.fmcy-vendor-icon-region',
	        favouriteButtonRegion: '.fmcy-favourite-button-region',
	        tagBarRegion: '.fmcy-tag-bar-region',
	        locationsDdlRegion: '.fmcy-location-change-drop-down-region',
	        potencyRegion: '.fmcy-potency-region'
	    },
	    events: {
	        'click .fmcy-thumb-item-click-area': 'onClick',
	        'click .fmcy-menu-item-banner': 'onClick',
	        'click @ui.vendorIcon': 'onVendorClick'
	    },
	    ui: {
	        thumbTitle: '.fmcy-menu-item-thumb-title',
	        thumbInner: '.fmcy-menu-item-thumb-inner',
	        thumbImage: '.fmcy-menu-item-thumb-image',
	        strainTitleRow: '.fmcy-menu-item-strain-title-row',
	        effectsRow: '.fmcy-menu-item-thumb-effects-row',
	        medicalRow: '.fmcy-menu-item-thumb-medical-row',
	        headLineRow: '.fmcy-menu-item-promotion-headline-row',
	        pricesRow: '.fmcy-menu-item-thumb-prices-row',
	        vendorIcon: '.fmcy-vendor-icon-region',
	        clickOverlay: '.fmcy-thumb-item-click-area'
	    },
	    onClick: function onClick() {
	        this.trigger('thumb:clicked');
	    },
	    initialize: function initialize(options) {
	        var self = this;
	        self.options = _.defaults(options || {}, {
	            theme: 'default', // default || alpha
	            extraClassName: null,
	            _menuState: null,
	            animationStyleShow: 'long',
	            animate: false,
	            showProductImage: true,
	            noImageAvailableIcon: __webpack_require__(158),
	            imagePreloading: true,
	            imagePreloadTimeout: 60000, // 1 minute in ms
	            onlinePurchaseEnabled: false,
	            bannerPriority: self._DEFAULT_BANNER_PRIORITY_ORDER_FIELD_NAMES,
	            showEffects: true,
	            showMedicalAttrs: true,
	            showStrainIcon: true,
	            showStrainInEffectsRow: false,
	            showPromotionHeadline: true,
	            showPricesLast: false,
	            showPricesPinned: false,
	            menuItemPriceLayoutSinglePrice: undefined,
	            menuItemPriceLayout: undefined,
	            menuItemPricesTheme: undefined,
	            showTitleOverProductImage: false,
	            showProductLocations: false,
	            showOnlineProductLocations: false,
	            showTopRightBanners: true,
	            showProductTag: false,
	            locationSwitchingEnabled: true,
	            productTagClassName: '',
	            productTag: '',
	            showInStoreOnlyIcon: true,
	            showTopLeftSaleBanner: false
	        });
	
	        if (self.options.imagePreloading) {
	            var createjs = __webpack_require__(74);
	            createjs.LoadQueue.loadTimeout = self.options.imagePreloadTimeout;
	            self._preloadQueue = new createjs.LoadQueue(false);
	        }
	        this._menuState = this.options._menuState;
	    },
	    _getProductTag: function _getProductTag() {
	
	        var strainGroup = this.model.getStrainGroupCode();
	        if (this.options.productTag) {
	            return this.options.productTag;
	        } else if (this.model.get('promotion_headline') && !this.model.isOnClearance() && this.model.get('promotion_headline').toLowerCase() !== 'clearance' && this.model.get('promotion_headline').toLowerCase() !== 'weekly') {
	            return this.model.get('promotion_headline');
	        } else if (strainGroup) {
	            return strainGroup;
	        } else {
	            var productTag = '';
	            var categorySlug;
	            var x = 0;
	            var categories = this.model.get('categories');
	            var categoriesArr;
	            if (categories instanceof Backbone.Collection) {
	                categoriesArr = categories.toJSON();
	            } else {
	                categoriesArr = categories;
	            }
	            while (x <= this._DISPLAY_PRODUCT_TAG_FOR_CATEGORIES.length - 1 && !productTag) {
	                categorySlug = this._DISPLAY_PRODUCT_TAG_FOR_CATEGORIES[x];
	                if (_.findWhere(categoriesArr, { slug: categorySlug })) {
	                    productTag = categorySlug;
	                }
	                x++;
	            }
	            return productTag;
	        }
	    },
	    serializeData: function serializeData() {
	        var self = this;
	        var productTag = self._getProductTag();
	        var productTagClassName;
	        if (this.options.productTagClassName) {
	            productTagClassName = this.options.productTagClassName;
	        } else if (productTag) {
	            productTagClassName = productTag;
	        }
	
	        var strain = this.model.get('strain');
	        if (strain) {
	            strain = strain.toUpperCase();
	        }
	
	        var nameContainsStrainName = false;
	        if (this.model.get('itemName').toUpperCase().indexOf(strain) !== -1) {
	            nameContainsStrainName = true;
	            // hide strain if the strain name is alread within the title...
	            strain = false;
	        }
	
	        return {
	            options: this.options,
	            itemName: self.model.get('itemName'),
	            itemDescription: self.model.get('itemDescriptionHtml') || self.model.get('itemDescription') || '',
	            strain: self.model.getStrainGroupCode() || '',
	            productTag: productTag,
	            productTagClassName: productTagClassName,
	            rating: self.model.get('rating') || 0,
	            productLabResults: this.model.get('lab_results'),
	            strainName: strain,
	            effectsAttrs: this.getEffectsAttrsString(),
	            medicalAttrs: this.getMedicalAttrsString(),
	            strainTitleImgClass: this.getStrainTitleImageClassName(),
	            onSale: self.onSale,
	            isNew: self.model.get('is_new') === true,
	            bannerClassName: self.options.showTopRightBanners ? self.getBannerClassName() : '',
	            shouldRenderProductLocations: this._shouldRenderProductLocations(),
	            shouldRenderPromotionHeadline: this.options.showPromotionHeadline,
	            headlineText: self.model.get('promotion_headline')
	        };
	    },
	    onVendorClick: function onVendorClick() {
	        if (this._menuState.get('mode') === 'menu') {
	            this.options.appChannel.trigger('search:options:changed', {
	                filterVendor: this.model.get('vendor').get('id')
	            });
	        }
	    },
	    onRender: function onRender() {
	        var self = this;
	
	        if (self.options.extraClassName) {
	            self.$el.addClass(self.options.extraClassName);
	        }
	
	        if (self.model.isOrganic()) {
	            self.$el.addClass('fmcy-product-is-organic');
	        }
	
	        if (self.model.isBCGrown()) {
	            self.$el.addClass('fmcy-product-is-bc-grown');
	        }
	
	        if (self.model.isFarmExclusive()) {
	            self.$el.addClass('fmcy-product-is-farm-exclusive');
	        }
	
	        if (self.model.isVegan()) {
	            self.$el.addClass('fmcy-product-is-vegan');
	        }
	
	        if (self.model.isHighCBD()) {
	            self.$el.addClass('fmcy-product-high-cbd');
	        }
	
	        if (self.model.isHighCBNCBG()) {
	            self.$el.addClass('fmcy-product-high-cbn-cbg');
	        }
	
	        var strain = self.model.getStrainGroupCode();
	        if (strain) {
	            self.$el.addClass(strain);
	        }
	
	        if (self.options.showPricesPinned) {
	            self.$el.addClass('fmcy-menu-item-thumb-prices-pinned');
	        }
	
	        if (self.options.showTitleOverProductImage) {
	            self.$el.addClass('fmcy-menu-item-thumb-title-displayed-over-product-image');
	        }
	
	        self.$el.addClass('fmcy-menu-item-thumb-theme-' + self.options.theme);
	
	        if (self.model.isOnSale()) {
	            self.$el.addClass('fmcy-menu-item-thumb-on-sale');
	        }
	
	        if (this.model.get('itemName')) {
	            this.$el.removeClass('hidden');
	        }
	
	        var vendor = this.model.get('vendor');
	
	        if (vendor) {
	            var brandIcon = new (__webpack_require__(65))({
	                imageURL: vendor.get('image_medium_url_' + this.model.get('theme') + '_theme'),
	                displayNoImageAvailableIcon: false
	            });
	            brandIcon.$el.addClass('fmcy-vendor-icon');
	            this.vendorIconRegion.show(brandIcon);
	        }
	
	        if (this._menuState.get('mode') !== 'menu') {
	            this.ui.vendorIcon.css('pointer-events', 'none');
	        }
	
	        if (this._menuState.get('mode') == 'menu' && this._menuState.get('isUserLoggedIn') || this._menuState.get('mode') == 'embedded' && this._menuState.get('isUserLoggedIn')) {
	            self.options.appChannel.request('is:favourite', self.model).then(function (response) {
	                self.favouriteButton = new FavouriteButton({
	                    isFavourite: response
	                });
	                self.favouriteButton.on('toggle:favourite', function (isFavourite) {
	                    self.model.set('isFavourite', isFavourite);
	                    self.options.appChannel.request('toggle:favourite', self.model, isFavourite).then(function (response) {
	                        //do nothing for now? Show loader?
	                    });
	                });
	                self.favouriteButtonRegion.show(self.favouriteButton);
	            });
	            this.listenTo(this.options.appChannel, 'update:favourite:' + this.model.get('id'), function (isFavourite) {
	                if (self.favouriteButton) {
	                    self.favouriteButton.setFavourite(isFavourite);
	                }
	            });
	        }
	
	        if (this.model.get('theme') === 'dark') {
	            this.$el.addClass('fmcy-product-tile-theme-dark');
	        }
	        this.ui.strainTitleRow.hide();
	        this.ui.effectsRow.hide();
	        this.ui.medicalRow.hide();
	        this.ui.headLineRow.hide();
	
	        this._renderPrices();
	        this._maybeRenderThumbImage();
	        this._maybeRenderAvailableAtLocations();
	        this._maybeRenderLocationsDropdownList();
	        this._renderPotency();
	
	        if (this._shouldRenderTagBar()) {
	            this.$el.addClass('fmcy-product-tile-showing-tag-bar');
	            this.tagBarRegion.show(new (__webpack_require__(80))({
	                showOnSaleTag: this.model.isOnSale(),
	                showOnClearanceTag: this.model.isOnClearance(),
	                productTagText: this._getProductTag(),
	                showCBDTag: this.model.isHighCBD(),
	                showCBNCBGTag: this.model.isHighCBNCBG(),
	                showBcGrownTag: this.model.isBCGrown(),
	                showFarmExclusiveTag: this.model.isFarmExclusive(),
	                showOrganicTag: this.model.isOrganic(),
	                showVeganTag: this.model.isVegan()
	            }));
	        }
	
	        this.showThumb();
	
	        if (!this.options.onlinePurchaseEnabled) {
	            this.ui.clickOverlay.css('bottom', '0px');
	        }
	    },
	    _shouldRenderTagBar: function _shouldRenderTagBar() {
	        return this.model.isOnSale() || this.model.isOnClearance() || this.model.isOrganic() || this.model.isVegan() || this.model.isBCGrown() || this.model.isFarmExclusive() || this.model.isHighCBD() || this.model.isHighCBNCBG() || this._getProductTag();
	    },
	    _renderPotency: function _renderPotency() {
	        this.potencyRegion.show(new PotencyDisplay({
	            model: this.model,
	            filterLocation: this.options.appChannel.request('get:filter:location')
	        }));
	    },
	    _renderPrices: function _renderPrices() {
	        var hideOutOfStockVariations = true;
	        if (this.options.onlinePurchaseEnabled) {
	            hideOutOfStockVariations = false;
	        }
	        var pricesOptions = {
	            onlinePurchaseEnabled: this.options.onlinePurchaseEnabled,
	            menuItemModel: this.model,
	            collection: this.model.get('variants'),
	            hideDoubleZeros: false,
	            hideOutOfStockVariation: hideOutOfStockVariations,
	            filterLocation: this.options.appChannel.request('get:filter:location'),
	            onSale: this.model.isOnSale(),
	            appChannel: this.options.appChannel
	        };
	
	        if (this.options.menuItemPriceLayout) {
	            pricesOptions.menuItemPriceLayout = this.options.menuItemPriceLayout;
	        }
	
	        if (this.options.menuItemPriceLayoutSinglePrice) {
	            pricesOptions.menuItemPriceLayoutSinglePrice = this.options.menuItemPriceLayoutSinglePrice;
	        }
	
	        if (this.options.menuItemPricesTheme) {
	            pricesOptions.theme = this.options.menuItemPricesTheme;
	            this.$el.addClass('fmcy-menu-item-thumb-prices-theme-' + this.options.menuItemPricesTheme);
	        }
	        this.showChildView('pricesRegion', new MenuItemPrices(pricesOptions));
	
	        if (this.options.showPricesPinned) {
	            this.showChildView('pricesPinnnedRegion', new MenuItemPrices(pricesOptions));
	        }
	    },
	    _maybeRenderLocationsDropdownList: function _maybeRenderLocationsDropdownList() {
	        if (this.options.locationSwitchingEnabled === false) {
	            return;
	        }
	        var self = this;
	        var filterLocation = this.options.appChannel.request('get:filter:location');
	        var locations = self.options.appChannel.request('get:locations');
	        var selectedLocationModel = locations.findWhere({ slug: filterLocation });
	
	        locations = new Backbone.Collection(locations.filter(function (model) {
	            if (model.get('slug') === filterLocation || parseInt(model.get('temp_closed')) === 1 || model.get('temp_closed') == true) {
	                return false;
	            } else {
	                return true;
	            }
	        }));
	
	        self.locationsDdlRegion.show(new DropdownList({
	            customClassName: 'fmcy-sort-options',
	            dropdownCssClass: 'fmcy-sort-options-dropdown',
	            collection: locations.toJSON(),
	            displayAttr: 'name',
	            placeholder: 'VIEWING ' + selectedLocationModel.get('name'),
	            valueAttr: 'slug',
	            suppressSearch: true,
	            onSelectedCallback: function onSelectedCallback(val) {
	                if (self._menuState.get('filterLocation') === val) {
	                    return;
	                }
	                //self._menuState.set('preSearch', true);
	                self.options.appChannel.trigger('search:options:changed', {
	                    location: val
	                });
	            }
	        }));
	    },
	    _maybeRenderThumbImage: function _maybeRenderThumbImage() {
	        var self = this;
	
	        if (!self.options.showProductImage) {
	            return;
	        }
	
	        function setThumbImage(imageURL) {
	            self.ui.thumbImage.css('background-image', 'url(' + imageURL + ')');
	        }
	
	        var displayImageURL = self.options.displayImageURL;
	        if (!displayImageURL) {
	            displayImageURL = self.options.noImageAvailableIcon;
	        }
	
	        if (self.options.imagePreloading) {
	
	            self.thumbImageRegion.show(new (__webpack_require__(20))({
	                message: ''
	            }));
	
	            var handleFileLoadError = function handleFileLoadError(event) {
	                if (!self.isRendered) {
	                    return false;
	                }
	                if (event.item.id === self.model.id) {
	                    console.log('File load error occurred: ', event);
	                    self._preloadQueue.removeAllEventListeners('fileload');
	                    self._preloadQueue.removeAllEventListeners('error');
	                    self.thumbImageRegion.empty();
	                    setThumbImage(self.options.noImageAvailableIcon);
	                }
	            };
	
	            var handleFileLoaded = function handleFileLoaded(event) {
	                if (!self.isRendered) {
	                    return false;
	                }
	                if (event.item.id === self.model.id) {
	                    self._preloadQueue.removeAllEventListeners('fileload');
	                    self._preloadQueue.removeAllEventListeners('error');
	                    self.thumbImageRegion.empty();
	                    setThumbImage(event.item.src);
	                }
	            };
	
	            self._preloadQueue.on('error', handleFileLoadError);
	            self._preloadQueue.on('fileload', handleFileLoaded);
	            self._preloadQueue.loadFile({
	                id: self.model.id,
	                src: displayImageURL
	            });
	        } else {
	            setThumbImage(displayImageURL);
	        }
	    },
	    _maybeRenderAvailableAtLocations: function _maybeRenderAvailableAtLocations() {
	        if (!this._shouldRenderProductLocations()) {
	            return;
	        }
	        this.availableAtLocationsRegion.show(new AvailableAtLocations({
	            collection: this._getProductLocations(),
	            preLocationsListText: 'available at ',
	            postLocationsListText: '',
	            appChannel: this.options.appChannel
	        }));
	    },
	    hideThumb: function hideThumb() {
	        if (this.options.animate) {
	            if (this.options.animationStyleShow === 'long') {
	                this.$el.css({ opacity: 1 });
	                window.gsap.to(this.$el, {
	                    opacity: 0,
	                    duration: 1
	                });
	            } else {
	                window.gsap.to(this.$el, {
	                    opacity: 0,
	                    translateY: 50,
	                    duration: 0.5
	                });
	            }
	        } else {
	            this.$el.css({ opacity: 0 });
	        }
	    },
	    showThumb: function showThumb() {
	        if (this.options.animate) {
	            switch (this.options.animationStyleShow) {
	                case 'long':
	                    this.$el.css({ opacity: 0 });
	                    window.gsap.to(this.$el, {
	                        opacity: 1,
	                        duration: 1
	                    });
	                    break;
	                default:
	                    this.$el.css({ opacity: 0 });
	                    window.gsap.to(this.$el, {
	                        opacity: 1,
	                        duration: 1
	                    }).delay(0.25);
	                    break;
	            }
	        } else {
	            this.$el.css({ opacity: 1 });
	        }
	    }
	});
	_.extend(MenuItemThumb.prototype, __webpack_require__(131));
	module.exports = MenuItemThumb;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 133 */,
/* 134 */,
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-available-at-locations {\n  font-family: 'bebasneue', 'Arial', sans-serif;\n  text-align: center;\n  color: #979696; }\n  @media only screen and (min-width: 991px) {\n    .fmcy-available-at-locations.fmcy-available-at-locations-align-left {\n      text-align: left; } }\n  .fmcy-available-at-locations .fmcy-pre-locations-list-text,\n  .fmcy-available-at-locations .fmcy-post-locations-list-text {\n    display: block; }\n  .fmcy-available-at-locations .fmcy-locations-container {\n    display: block;\n    margin: 0;\n    padding: 0; }\n    .fmcy-available-at-locations .fmcy-locations-container li {\n      line-height: 18px;\n      margin-bottom: 5px;\n      display: block; }\n      .fmcy-available-at-locations .fmcy-locations-container li a {\n        display: inline-block;\n        background-color: #979696;\n        color: #FFFFFF !important;\n        border-radius: 2px;\n        padding: 2px 5px;\n        line-height: 1em; }\n\n/* Custom, iPhone Retina */\n/* Extra Small Devices, Phones */\n/* Small Devices, Tablets */\n@media only screen and (min-width: 768px) {\n  .fmcy-available-at-locations .fmcy-pre-locations-list-text,\n  .fmcy-available-at-locations .fmcy-post-locations-list-text {\n    display: inline; }\n  .fmcy-available-at-locations .fmcy-locations-container {\n    display: inline;\n    margin-left: 5px;\n    margin-right: 5px; }\n    .fmcy-available-at-locations .fmcy-locations-container li {\n      display: inline-block;\n      margin: 0;\n      margin-right: 5px; }\n      .fmcy-available-at-locations .fmcy-locations-container li:last-child {\n        margin-right: 0; } }\n\n/* Medium Devices, Desktops */\n/* Large Devices, Wide Screens */\n", ""]);
	
	// exports


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-favourite-button {\n  cursor: pointer; }\n  .fmcy-favourite-button .farm-favourite-button-inner {\n    background-image: url(" + escape(__webpack_require__(138)) + ");\n    width: 120px;\n    height: 106px;\n    background-size: cover; }\n  .fmcy-favourite-button.farm-favourited .farm-favourite-button-inner {\n    background-image: url(" + escape(__webpack_require__(137)) + "); }\n", ""]);
	
	// exports


/***/ },
/* 137 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/heart_filled-f156eb84f01042521d07599669ff3c37.png";

/***/ },
/* 138 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/heart_outlined-d144008a2c220adc6ec20c56bbd5c09c.png";

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(135);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./available-at-locations.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./available-at-locations.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(136);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./favourite-button.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./favourite-button.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 141 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n';
	 if (options.loadHomePageURLOnClick) { 
	__p+='\n    <a href="'+
	((__t=( location.home_page_url ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( location.name ))==null?'':__t)+
	'</a>\n';
	 } else { 
	__p+='\n    <a href="#/all/location/'+
	((__t=( location.slug ))==null?'':__t)+
	'">'+
	((__t=( location.name ))==null?'':__t)+
	'</a>\n';
	 } 
	__p+='';
	}
	return __p;
	};


/***/ },
/* 142 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	 if (options.preLocationsListText) { 
	__p+='<span class="fmcy-pre-locations-list-text">'+
	((__t=( options.preLocationsListText ))==null?'':__t)+
	'</span>';
	 } 
	__p+='<ul class="fmcy-locations-container"></ul>';
	 if (options.postLocationsListText) { 
	__p+='<span class="fmcy-post-locations-list-text">'+
	((__t=( options.postLocationsListText ))==null?'':__t)+
	'</span>';
	 } 
	__p+='';
	}
	return __p;
	};


/***/ },
/* 143 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="farm-favourite-button-inner"></div>\n';
	}
	return __p;
	};


/***/ },
/* 144 */,
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	__webpack_require__(124);
	__webpack_require__(268);
	
	function visible(el, partial, hidden, direction, container) {
	    var $t = $(el),
	        isContained = typeof container !== "undefined" && container !== null,
	        $w = isContained ? $(container) : $(window),
	        wPosition = isContained ? $w.position() : 0,
	        t = $t.get(0),
	        vpWidth = $w.outerWidth(),
	        vpHeight = $w.outerHeight(),
	        direction = direction ? direction : "both",
	        clientSize = hidden === true ? t.offsetWidth * t.offsetHeight : true;
	
	    if (typeof t.getBoundingClientRect === "function") {
	        // Use this native browser method, if available.
	        var rec = t.getBoundingClientRect(),
	            tViz = isContained ? rec.top - wPosition.top >= 0 && rec.top < vpHeight + wPosition.top : rec.top >= 0 && rec.top < vpHeight,
	            bViz = isContained ? rec.bottom - wPosition.top > 0 && rec.bottom <= vpHeight + wPosition.top : rec.bottom > 0 && rec.bottom <= vpHeight,
	            lViz = isContained ? rec.left - wPosition.left >= 0 && rec.left < vpWidth + wPosition.left : rec.left >= 0 && rec.left < vpWidth,
	            rViz = isContained ? rec.right - wPosition.left > 0 && rec.right < vpWidth + wPosition.left : rec.right > 0 && rec.right <= vpWidth,
	            vVisible = partial ? tViz || bViz : tViz && bViz,
	            hVisible = partial ? lViz || rViz : lViz && rViz;
	
	        if (direction === "both") return clientSize && vVisible && hVisible;else if (direction === "vertical") return clientSize && vVisible;else if (direction === "horizontal") return clientSize && hVisible;
	    } else {
	        var viewTop = isContained ? 0 : wPosition,
	            viewBottom = viewTop + vpHeight,
	            viewLeft = $w.scrollLeft(),
	            viewRight = viewLeft + vpWidth,
	            position = $t.position(),
	            _top = position.top,
	            _bottom = _top + $t.height(),
	            _left = position.left,
	            _right = _left + $t.width(),
	            compareTop = partial === true ? _bottom : _top,
	            compareBottom = partial === true ? _top : _bottom,
	            compareLeft = partial === true ? _right : _left,
	            compareRight = partial === true ? _left : _right;
	
	        if (direction === "both") return !!clientSize && compareBottom <= viewBottom && compareTop >= viewTop && compareRight <= viewRight && compareLeft >= viewLeft;else if (direction === "vertical") return !!clientSize && compareBottom <= viewBottom && compareTop >= viewTop;else if (direction === "horizontal") return !!clientSize && compareRight <= viewRight && compareLeft >= viewLeft;
	    }
	}
	
	module.exports = {
	    matchHeight: function matchHeight($els, options) {
	        return $.fn.matchHeight.call($els, options);
	    },
	    scrollToPageTop: function scrollToPageTop($el) {
	        if ($el) {
	            $($el).animate({
	                scrollTop: '0px'
	            }, 300);
	        } else {
	            $('html, body').animate({
	                scrollTop: '0px'
	            }, 300);
	        }
	    },
	    isAnyPartElementVisible: function isAnyPartElementVisible(el) {
	        return visible(el, true);
	    },
	    isAllElementVisible: function isAllElementVisible(el) {
	        return visible(el, false);
	    },
	    isElementVisible: function isElementVisible(el) {
	        return visible(el);
	    },
	    isPhone: function isPhone() {
	        return Modernizr.mq('screen and (max-width: 767px)');
	    },
	    isTablet: function isTablet() {
	        return Modernizr.mq('screen and (min-width: 768px) and (max-width: 991px)') || !Modernizr.mq('only all');
	    },
	    isAccessoriesKioskWidth: function isAccessoriesKioskWidth() {
	        return Modernizr.mq('screen and (min-width: 992px) and (max-width: 1080px)') || !Modernizr.mq('only all');
	    },
	    isAccessoriesKioskHeight: function isAccessoriesKioskHeight() {
	        return Modernizr.mq('screen and (min-height: 1600px) and (max-height: 1920px)');
	    },
	    isDesktop: function isDesktop() {
	        return Modernizr.mq('screen and (min-width: 1082px) and (max-width: 1199px)') || !Modernizr.mq('only all');
	    },
	    isLargeDesktop: function isLargeDesktop() {
	        return Modernizr.mq('screen and (min-width: 1200px) and (max-width: 1599px)') || !Modernizr.mq('only all');
	    },
	    isExtraLargeDesktop: function isExtraLargeDesktop() {
	        return Modernizr.mq('screen and (min-width: 1600px)') || !Modernizr.mq('only all');
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-cart-location-display {\n  position: relative; }\n  .fmcy-cart-location-display.farm-cart-location-thumb-alignment-horizontal {\n    font-size: 14px;\n    text-align: left; }\n    .fmcy-cart-location-display.farm-cart-location-thumb-alignment-horizontal .fmcy-cart-location-display-content-wrapper {\n      padding-left: 83px;\n      padding-top: 7px;\n      font-family: 'droid_serif' !important; }\n    .fmcy-cart-location-display.farm-cart-location-thumb-alignment-horizontal .fmcy-cart-location-display-image {\n      max-width: 70px;\n      padding-top: 13px;\n      position: absolute; }\n  .fmcy-cart-location-display .fmcy-cart-location-display-button-region {\n    position: absolute;\n    top: 15px;\n    right: 15px; }\n  .fmcy-cart-location-display.farm-cart-location-thumb-alignment-vertical {\n    font-size: 14px;\n    text-align: left; }\n    .fmcy-cart-location-display.farm-cart-location-thumb-alignment-vertical .fmcy-cart-location-display-image {\n      max-width: 178px; }\n      .fmcy-cart-location-display.farm-cart-location-thumb-alignment-vertical .fmcy-cart-location-display-image .img-responsive {\n        width: 178px; }\n  .fmcy-cart-location-display.farm-location-hide-photo-small-size.farm-cart-location-thumb-alignment-horizontal .fmcy-cart-location-display-content-wrapper {\n    padding-left: 0px;\n    padding-top: 0px; }\n  .fmcy-cart-location-display.farm-location-hide-photo-small-size.farm-cart-location-thumb-alignment-horizontal .fmcy-cart-location-display-image {\n    display: none; }\n  @media only screen and (min-width: 620px) {\n    .fmcy-cart-location-display.farm-location-hide-photo-small-size.farm-cart-location-thumb-alignment-horizontal .fmcy-cart-location-display-content-wrapper {\n      padding-left: 83px;\n      padding-top: 7px; }\n    .fmcy-cart-location-display.farm-location-hide-photo-small-size.farm-cart-location-thumb-alignment-horizontal .fmcy-cart-location-display-image {\n      display: block; } }\n  .fmcy-cart-location-display .fmcy-cart-location-display-inner {\n    margin: auto !important;\n    font-size: 90%;\n    color: #fff; }\n    @media only screen and (max-width: 400px) {\n      .fmcy-cart-location-display .fmcy-cart-location-display-inner .fmcy-cart-location-display-content-wrapper {\n        max-width: 190px; } }\n    @media only screen and (min-width: 760px) {\n      .fmcy-cart-location-display .fmcy-cart-location-display-inner {\n        padding-top: 0px; } }\n    .fmcy-cart-location-display .fmcy-cart-location-display-inner .fmcy-cart-location-display-content-wrapper {\n      font-family: 'droid_serif' !important; }\n    .fmcy-cart-location-display .fmcy-cart-location-display-inner .fmcy-cart-location-display-inner-title {\n      font-family: \"bebasneue\", \"Arial\", sans-serif;\n      font-size: 160%;\n      line-height: 100%;\n      padding-top: 5px;\n      padding-bottom: 3px; }\n    .fmcy-cart-location-display .fmcy-cart-location-display-inner .fmcy-cart-location-display-inner-address {\n      font-size: 90%;\n      line-height: 16px;\n      font-weight: bold; }\n    .fmcy-cart-location-display .fmcy-cart-location-display-inner .fmcy-cart-location-display-inner-hours {\n      font-size: 90%;\n      line-height: 20px;\n      font-weight: bold; }\n", ""]);
	
	// exports


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(146);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-location-display.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-location-display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 148 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-cart-location-display-inner">\n  <div class="fmcy-cart-location-display-image">\n    <img class="img-responsive" src="'+
	((__t=( imageUrl ))==null?'':__t)+
	'">\n  </div>\n  <div class="fmcy-cart-location-display-content-wrapper">\n    <div class="fmcy-cart-location-display-inner-title">'+
	((__t=(name))==null?'':__t)+
	'</div>\n    <div class="fmcy-cart-location-display-inner-address">'+
	((__t=(line_1))==null?'':__t)+
	', '+
	((__t=(city))==null?'':__t)+
	'</div>\n    <div class="fmcy-cart-location-display-inner-hours">'+
	((__t=(hours))==null?'':__t)+
	'</div>\n  </div>\n  <div class="fmcy-cart-location-display-button-region"></div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	__webpack_require__(289);
	
	var VideoJS = __webpack_require__(290);
	var BaseViews = __webpack_require__(5);
	var VideoPlayer = BaseViews.ItemView.extend({
	  template: __webpack_require__(196),
	  className: 'container-fluid feature-popup-video-container',
	  initialize: function initialize(options) {
	    this.options = _.defaults(options || {}, {
	      autoPlay: true,
	      videoControls: true,
	      videoUrl: null,
	      width: 300,
	      height: 300,
	      muted: false,
	      size: 'static' //static, scale
	    });
	  },
	  ui: {
	    videoPlayer: '#video-player'
	  },
	  serializeData: function serializeData() {
	    return {
	      videoUrl: this.options.videoUrl
	    };
	  },
	  setWidth: function setWidth(width) {
	    if (this._videoPlayer !== null) {
	      this._videoPlayer.width(width);
	    }
	  },
	  setHeight: function setHeight(height) {
	    if (this._videoPlayer !== null) {
	      this._videoPlayer.height(height);
	    }
	  },
	  _destroyVideoPlayer: function _destroyVideoPlayer() {
	    this._videoPlayer.dispose();
	  },
	  _setupVideoPlayer: function _setupVideoPlayer() {
	    var self = this;
	    var videoWidth;
	    var videoHeight;
	
	    if (this.options.size == 'scale') {
	      videoWidth = $(window).width();
	      videoHeight = $(window).height();
	    } else {
	      videoWidth = this.options.width;
	      videoHeight = this.options.height;
	    }
	
	    var options = {
	      width: videoWidth,
	      height: videoHeight,
	      controls: this.options.videoControls,
	      muted: this.options.muted,
	      controlBar: {
	        children: {
	          PlayToggle: true,
	          muteToggle: true,
	          VolumeControl: true,
	          ProgressControl: true,
	          RemainingTimeDisplay: true,
	          FullscreenToggle: true
	        }
	      }
	    };
	    this._videoPlayer = new VideoJS(this.ui.videoPlayer[0], options, function onPlayerReady() {
	      if (self.options.autoPlay == true) {
	        this.play();
	      }
	      this.on('ended', function () {
	        self.trigger('videoplayer:ended');
	      });
	    });
	  },
	  onRender: function onRender() {
	    this._setupVideoPlayer();
	    BaseViews.ItemView.prototype.onRender.call(this);
	  },
	  onDestroy: function onDestroy() {
	    this._destroyVideoPlayer();
	    BaseViews.LayoutView.prototype.onDestroy.call(self);
	  }
	});
	
	module.exports = VideoPlayer;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, "/* Custom, iPhone Retina */\n/* Top left tag | on sale */\n.fmcy-menu-item-thumb {\n  font-size: 16px;\n  display: flex;\n  /* Content layout */\n  /* Top left banner */\n  /* Top right banner */\n  /* Strain Row */ }\n  .fmcy-menu-item-thumb .fmcy-strain-name {\n    font-family: 'vastshadow';\n    color: #ffffff;\n    text-transform: uppercase; }\n  .fmcy-menu-item-thumb.fmcy-product-high-cbd .fmcy-pointy::after {\n    background: #52b7be; }\n  .fmcy-menu-item-thumb.fmcy-product-high-cbn-cbg .fmcy-pointy::after {\n    background: #A28DB3; }\n  .fmcy-menu-item-thumb.fmcy-product-is-organic .fmcy-pointy::after {\n    background: #56b593; }\n  .fmcy-menu-item-thumb.fmcy-product-is-bc-grown .fmcy-pointy::after {\n    background: #001a70; }\n  .fmcy-menu-item-thumb.fmcy-product-is-farm-exclusive .fmcy-pointy::after {\n    background: #221F20; }\n  .fmcy-menu-item-thumb.fmcy-product-is-vegan .fmcy-pointy::after {\n    background: #14b47b; }\n  .fmcy-menu-item-thumb.indica .fmcy-top-border-line {\n    background-color: #0080FF; }\n  .fmcy-menu-item-thumb.indica .fmcy-tag-bar .fmcy-inner-tag {\n    background-color: #0080FF; }\n  .fmcy-menu-item-thumb.indica .fmcy-tag-bar .fmcy-pointy::after {\n    background: #0080FF; }\n  .fmcy-menu-item-thumb.sativa .fmcy-top-border-line {\n    background-color: #93753E; }\n  .fmcy-menu-item-thumb.sativa .fmcy-tag-bar .fmcy-inner-tag {\n    background-color: #93753E; }\n  .fmcy-menu-item-thumb.sativa .fmcy-tag-bar .fmcy-pointy::after {\n    background: #93753E; }\n  .fmcy-menu-item-thumb.hybrid .fmcy-top-border-line {\n    background-color: #818285; }\n  .fmcy-menu-item-thumb.hybrid .fmcy-tag-bar .fmcy-inner-tag {\n    background-color: #818285; }\n  .fmcy-menu-item-thumb.hybrid .fmcy-tag-bar .fmcy-pointy::after {\n    background: #818285; }\n  .fmcy-menu-item-thumb.fmcy-product-tile-theme-dark .fmcy-menu-item-thumb-inner {\n    background-color: #000000; }\n  .fmcy-menu-item-thumb.fmcy-product-tile-theme-dark .fmcy-menu-item-thumb-prices-row {\n    background-color: #000000;\n    color: #979696; }\n  .fmcy-menu-item-thumb.fmcy-product-tile-theme-dark .fmcy-menu-item-select-price-to-add-to-cart-row {\n    background-color: #000000;\n    color: #fff; }\n  .fmcy-menu-item-thumb.fmcy-product-tile-theme-dark .fmcy-menu-item-thumb-title-row {\n    background-color: #000000; }\n    .fmcy-menu-item-thumb.fmcy-product-tile-theme-dark .fmcy-menu-item-thumb-title-row .fmcy-menu-item-thumb-title {\n      color: #ffffff; }\n  .fmcy-menu-item-thumb.fmcy-product-tile-theme-dark .fmcy-menu-item-row {\n    background-color: #000000; }\n  .fmcy-menu-item-thumb.fmcy-menu-item-thumb-theme-alpha .fmcy-menu-item-thumb-inner {\n    height: 100%; }\n    .fmcy-menu-item-thumb.fmcy-menu-item-thumb-theme-alpha .fmcy-menu-item-thumb-inner .fmcy-menu-item-thumb-image {\n      flex: 0 1 auto; }\n    .fmcy-menu-item-thumb.fmcy-menu-item-thumb-theme-alpha .fmcy-menu-item-thumb-inner .fmcy-menu-item-thumb-prices-row {\n      flex: 1 1 auto;\n      display: flex;\n      align-items: center;\n      justify-content: center; }\n  .fmcy-menu-item-thumb.fmcy-menu-item-thumb-theme-alpha.fmcy-menu-item-thumb-on-sale {\n    border: 1px solid #A71C21;\n    color: #ffffff; }\n    .fmcy-menu-item-thumb.fmcy-menu-item-thumb-theme-alpha.fmcy-menu-item-thumb-on-sale .fmcy-menu-item-thumb-prices-row {\n      background-color: #A71C21;\n      color: #ffffff; }\n    .fmcy-menu-item-thumb.fmcy-menu-item-thumb-theme-alpha.fmcy-menu-item-thumb-on-sale .fmcy-menu-item-prices {\n      background-color: #A71C21; }\n    .fmcy-menu-item-thumb.fmcy-menu-item-thumb-theme-alpha.fmcy-menu-item-thumb-on-sale .fmcy-menu-item-thumb-title {\n      color: #A71C21;\n      padding-bottom: 5px; }\n    .fmcy-menu-item-thumb.fmcy-menu-item-thumb-theme-alpha.fmcy-menu-item-thumb-on-sale .fmcy-menu-item-price-amount,\n    .fmcy-menu-item-thumb.fmcy-menu-item-thumb-theme-alpha.fmcy-menu-item-thumb-on-sale .fmcy-menu-item-price-label {\n      color: #ffffff; }\n    .fmcy-menu-item-thumb.fmcy-menu-item-thumb-theme-alpha.fmcy-menu-item-thumb-on-sale .fmcy-menu-item-price-quantity {\n      border-color: #ffffff;\n      color: #ffffff; }\n  .fmcy-menu-item-thumb.fmcy-menu-item-thumb-prices-pinned {\n    position: relative; }\n    .fmcy-menu-item-thumb.fmcy-menu-item-thumb-prices-pinned .fmcy-menu-item-prices {\n      padding-top: 5px;\n      padding-bottom: 5px; }\n    .fmcy-menu-item-thumb.fmcy-menu-item-thumb-prices-pinned .fmcy-item-prices-pinned-region {\n      position: absolute;\n      bottom: 0;\n      width: 100%; }\n    .fmcy-menu-item-thumb.fmcy-menu-item-thumb-prices-pinned .fmcy-item-prices-region {\n      visibility: hidden; }\n  .fmcy-menu-item-thumb.fmcy-menu-item-thumb-title-displayed-over-product-image .fmcy-menu-item-thumb-image {\n    position: relative;\n    margin-bottom: 2px; }\n    .fmcy-menu-item-thumb.fmcy-menu-item-thumb-title-displayed-over-product-image .fmcy-menu-item-thumb-image .fmcy-menu-item-thumb-title {\n      width: 100%;\n      background: rgba(255, 255, 255, 0.6);\n      position: absolute;\n      bottom: 0; }\n  .fmcy-menu-item-thumb .fmcy-menu-item-thumb-inner {\n    cursor: pointer;\n    background-color: #ffffff;\n    position: relative;\n    border: 1px solid #cccccc;\n    width: 100%; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-thumb-inner .fmcy-thumb-item-click-area {\n      position: absolute;\n      top: 0px;\n      bottom: 42px;\n      right: 0px;\n      left: 0px; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-thumb-inner .fmcy-tag-bar-region {\n      position: absolute;\n      right: 0;\n      top: 0;\n      z-index: 1000;\n      left: 0; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-thumb-inner .fmcy-tag-bar {\n      position: absolute;\n      right: 0;\n      max-width: 70%; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-thumb-inner .fmcy-vendor-icon-region {\n      position: absolute;\n      top: 0px;\n      left: 10px; }\n      .fmcy-menu-item-thumb .fmcy-menu-item-thumb-inner .fmcy-vendor-icon-region .fmcy-vendor-icon .fmcy-image {\n        height: 20vw;\n        width: 20vw; }\n      @media only screen and (min-width: 768px) {\n        .fmcy-menu-item-thumb .fmcy-menu-item-thumb-inner .fmcy-vendor-icon-region .fmcy-vendor-icon .fmcy-image {\n          height: 6vw;\n          width: 6vw; } }\n    .fmcy-menu-item-thumb .fmcy-menu-item-thumb-inner .fmcy-favourite-button-region {\n      position: absolute;\n      top: 40px;\n      right: 10px; }\n      .fmcy-menu-item-thumb .fmcy-menu-item-thumb-inner .fmcy-favourite-button-region .fmcy-favourite-button .farm-favourite-button-inner {\n        width: 30px;\n        height: 26px; }\n    @media only screen and (min-width: 768px) {\n      .fmcy-menu-item-thumb .fmcy-menu-item-thumb-inner .fmcy-favourite-button-region {\n        top: 40px;\n        right: 10px; }\n        .fmcy-menu-item-thumb .fmcy-menu-item-thumb-inner .fmcy-favourite-button-region .fmcy-favourite-button .farm-favourite-button-inner {\n          width: 30px;\n          height: 26px; } }\n  .fmcy-menu-item-thumb.indica .fmcy-menu-item-thumb-inner {\n    border: 1px solid #0080FF; }\n  .fmcy-menu-item-thumb.sativa .fmcy-menu-item-thumb-inner {\n    border: 1px solid #93753E; }\n  .fmcy-menu-item-thumb.hybrid .fmcy-menu-item-thumb-inner {\n    border: 1px solid #818285; }\n  .fmcy-menu-item-thumb.fmcy-menu-item-thumb-on-sale .fmcy-menu-item-thumb-inner {\n    border: 1px solid #A71C21; }\n  .fmcy-menu-item-thumb .fmcy-menu-item-thumb-inner {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n    align-content: stretch;\n    align-items: stretch; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-thumb-inner .fmcy-menu-item-row {\n      order: 0;\n      flex: 0 1 auto;\n      align-self: auto; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-thumb-inner .fmcy-menu-item-thumb-image {\n      flex: 1 1 auto; }\n  .fmcy-menu-item-thumb .fmcy-menu-item-row {\n    padding-left: 15px;\n    padding-right: 15px; }\n  .fmcy-menu-item-thumb .fmcy-menu-item-top-left-banner-wrapper {\n    position: absolute;\n    left: 0;\n    z-index: 1000;\n    top: 0;\n    color: #ffffff;\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 110%; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-top-left-banner-wrapper .fmcy-menu-item-top-left-banner-inner-wrapper {\n      display: flex;\n      text-transform: uppercase; }\n      .fmcy-menu-item-thumb .fmcy-menu-item-top-left-banner-wrapper .fmcy-menu-item-top-left-banner-inner-wrapper > div {\n        display: inline-block;\n        vertical-align: middle;\n        padding: 0 5px; }\n      .fmcy-menu-item-thumb .fmcy-menu-item-top-left-banner-wrapper .fmcy-menu-item-top-left-banner-inner-wrapper .fmcy-top-left-sale-banner {\n        background-color: #A71C21; }\n      .fmcy-menu-item-thumb .fmcy-menu-item-top-left-banner-wrapper .fmcy-menu-item-top-left-banner-inner-wrapper .fmcy-product-tag {\n        position: relative; }\n        .fmcy-menu-item-thumb .fmcy-menu-item-top-left-banner-wrapper .fmcy-menu-item-top-left-banner-inner-wrapper .fmcy-product-tag::after {\n          content: '';\n          position: absolute;\n          top: 0;\n          width: 100%;\n          height: 100%;\n          background: #000;\n          -webkit-transform-origin: 100% 0;\n          -ms-transform-origin: 100% 0;\n          transform-origin: 100% 0;\n          -webkit-transform: skew(-45deg);\n          -ms-transform: skew(-45deg);\n          transform: skew(-45deg);\n          z-index: -1;\n          right: -23px; }\n  .fmcy-menu-item-thumb .fmcy-menu-item-top-left-banner-wrapper .fmcy-product-tag .fmcy-product-tag-text {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    max-width: 6vw;\n    display: block; }\n  .fmcy-menu-item-thumb .fmcy-menu-item-top-left-banner-wrapper .fmcy-product-tag.indica {\n    background-color: #0080FF; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-top-left-banner-wrapper .fmcy-product-tag.indica::after {\n      background-color: #0080FF; }\n  .fmcy-menu-item-thumb .fmcy-menu-item-top-left-banner-wrapper .fmcy-product-tag.hybrid {\n    background-color: #818285; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-top-left-banner-wrapper .fmcy-product-tag.hybrid::after {\n      background-color: #818285; }\n  .fmcy-menu-item-thumb .fmcy-menu-item-top-left-banner-wrapper .fmcy-product-tag.sativa {\n    background-color: #93753E; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-top-left-banner-wrapper .fmcy-product-tag.sativa::after {\n      background-color: #93753E; }\n  .fmcy-menu-item-thumb .fmcy-menu-item-top-left-banner-wrapper .fmcy-product-tag.hash {\n    background-color: #66513E; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-top-left-banner-wrapper .fmcy-product-tag.hash::after {\n      background-color: #66513E; }\n  .fmcy-menu-item-thumb .fmcy-menu-item-top-left-banner-wrapper .fmcy-product-tag.cbd {\n    background-color: #88D2D9; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-top-left-banner-wrapper .fmcy-product-tag.cbd::after {\n      background-color: #88D2D9; }\n  .fmcy-menu-item-thumb .fmcy-menu-item-banner-wrapper {\n    position: absolute;\n    right: 0;\n    z-index: 1000;\n    top: 0;\n    width: 40%; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-banner-wrapper .fmcy-menu-item-banner-inner-wrapper {\n      position: relative;\n      width: 100%;\n      padding-bottom: 56.25%;\n      height: 0; }\n  .fmcy-menu-item-thumb .fmcy-menu-item-banner {\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: top right;\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0; }\n  .fmcy-menu-item-thumb .fmcy-menu-item-weekly-sale-banner {\n    background-image: url(" + escape(__webpack_require__(153)) + "); }\n  .fmcy-menu-item-thumb .fmcy-menu-item-is-new-banner {\n    background-image: url(" + escape(__webpack_require__(152)) + "); }\n  .fmcy-menu-item-thumb .fmcy-menu-item-clearance-banner {\n    background-image: url(" + escape(__webpack_require__(151)) + "); }\n  .fmcy-menu-item-thumb .fmcy-menu-item-thumb-image {\n    background-color: #fff;\n    height: 170px;\n    height: 60vw;\n    text-align: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: 50%; }\n  .fmcy-menu-item-thumb.fmcy-product-tile-theme-dark .fmcy-menu-item-thumb-image {\n    background-color: #000; }\n  .fmcy-menu-item-thumb .fmcy-menu-item-thumb-title-row {\n    background-color: #ffffff; }\n  .fmcy-menu-item-thumb .fmcy-product-strain-name {\n    font-size: 60%;\n    line-height: 140%;\n    max-width: 80%;\n    margin: 0 auto;\n    text-align: center; }\n  .fmcy-menu-item-thumb .fmcy-potency-display {\n    font-size: 60%;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    max-width: 80%;\n    margin: 0 auto;\n    white-space: nowrap;\n    line-height: 110%;\n    margin-top: 1%;\n    text-align: center;\n    font-weight: 600; }\n  .fmcy-menu-item-thumb .fmcy-menu-item-strain-title-row {\n    background-color: #000000;\n    height: 38px;\n    padding-top: 13px; }\n  .fmcy-menu-item-thumb .fmcy-menu-item-strain-title {\n    background-repeat: no-repeat;\n    height: 12px;\n    background-size: contain;\n    background-position: center;\n    text-align: center; }\n  .fmcy-menu-item-thumb .fmcy-menu-item-thumb-category-indica-title {\n    background-image: url(" + escape(__webpack_require__(160)) + "); }\n  .fmcy-menu-item-thumb .fmcy-menu-item-thumb-category-sativa-title {\n    background-image: url(" + escape(__webpack_require__(161)) + "); }\n  .fmcy-menu-item-thumb .fmcy-menu-item-thumb-category-hybrid-title {\n    background-image: url(" + escape(__webpack_require__(159)) + "); }\n  .fmcy-menu-item-thumb .fmcy-menu-item-thumb-category-concentrates-title {\n    background-image: url(" + escape(__webpack_require__(154)) + "); }\n  .fmcy-menu-item-thumb .fmcy-menu-item-thumb-category-other-title {\n    background-image: url(" + escape(__webpack_require__(156)) + "); }\n  .fmcy-menu-item-thumb .fmcy-menu-item-thumb-category-edibles-title {\n    background-image: url(" + escape(__webpack_require__(155)) + "); }\n  .fmcy-menu-item-thumb .fmcy-menu-item-thumb-category-pre-rolls-title {\n    background-image: url(" + escape(__webpack_require__(157)) + "); }\n  .fmcy-menu-item-thumb .fmcy-menu-item-thumb-title {\n    text-align: center;\n    padding-top: 5px;\n    padding-bottom: 0px;\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    line-height: 100%;\n    font-size: 175%;\n    color: #23282d;\n    font-weight: normal;\n    font-style: normal;\n    text-transform: none;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    speak: none; }\n  .fmcy-menu-item-thumb .fmcy-available-at-locations-region {\n    margin: 5px 0; }\n  .fmcy-menu-item-thumb .fmcy-menu-item-thumb-effects-row,\n  .fmcy-menu-item-thumb .fmcy-menu-item-thumb-medical-row {\n    font-family: \"droid_serif\", \"times\", serif;\n    min-height: 30px;\n    text-align: center; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-thumb-effects-row .fmcy-strain-name,\n    .fmcy-menu-item-thumb .fmcy-menu-item-thumb-medical-row .fmcy-strain-name {\n      font-size: 300%;\n      line-height: 100%; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-thumb-effects-row > div,\n    .fmcy-menu-item-thumb .fmcy-menu-item-thumb-medical-row > div {\n      display: inline-block;\n      text-align: center;\n      vertical-align: middle;\n      line-height: 258%;\n      font-size: 75%;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis; }\n  .fmcy-menu-item-thumb .fmcy-menu-item-thumb-effects-row {\n    background-color: #93743f;\n    color: #fff; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-thumb-effects-row.indica {\n      background-color: #0080FF; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-thumb-effects-row.hybrid {\n      background-color: #818285; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-thumb-effects-row.sativa {\n      background-color: #93753E; }\n  .fmcy-menu-item-thumb .fmcy-menu-item-thumb-medical-row {\n    background-color: #fff;\n    background-color: #6f5830; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-thumb-medical-row.indica {\n      background-color: #0066cc; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-thumb-medical-row.hybrid {\n      background-color: #68696b; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-thumb-medical-row.sativa {\n      background-color: #6f582f; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-thumb-medical-row .fmcy-menu-item-thumb-medical-row-text {\n      color: #fff; }\n  .fmcy-menu-item-thumb .fmcy-menu-item-promotion-headline-row {\n    color: #ffffff;\n    background-color: #000000;\n    text-align: center; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-promotion-headline-row .fmcy-menu-item-headline {\n      padding-top: 10px; }\n      .fmcy-menu-item-thumb .fmcy-menu-item-promotion-headline-row .fmcy-menu-item-headline .fmcy-menu-headline-text {\n        width: 100%;\n        font-size: 125%;\n        font-family: \"bebasneue\", \"Arial\", sans-serif; }\n  .fmcy-menu-item-thumb .fmcy-menu-item-thumb-prices-row {\n    color: #333333;\n    background-color: #FFFFFF; }\n  .fmcy-menu-item-thumb .fmcy-menu-item-select-price-to-add-to-cart-row {\n    color: #7b7c7f;\n    flex: 1 1 auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-top: 5px;\n    padding-bottom: 10px;\n    font-size: 60%; }\n  .fmcy-menu-item-thumb .fmcy-menu-item-filter-location-row {\n    flex: 1 1 auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-top: 5px;\n    padding-bottom: 10px;\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 80%; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-filter-location-row .select2-selection__rendered {\n      color: #7b7c7f;\n      line-height: 22px; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-filter-location-row .select2-selection--single {\n      height: 22px;\n      border: 1px solid #7b7c7f; }\n    .fmcy-menu-item-thumb .fmcy-menu-item-filter-location-row .select2-selection__arrow b {\n      margin-top: -5px; }\n", ""]);
	
	// exports


/***/ },
/* 151 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/banner_clearance_item-346424fc93aedafcc680b86bace1f9f0.png";

/***/ },
/* 152 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/banner_new_item-f0ce83ce1a87ce1b941207d1e22a7da7.png";

/***/ },
/* 153 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/banner_weekly_sale-c3f4ad7685b7d83bcd7ee4cc37fce449.png";

/***/ },
/* 154 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/cat_concentrates_label-5d86a523ba867545b7387660beb8e952.png";

/***/ },
/* 155 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/cat_edible_label-0bbe884977fa029aea4a653d34de4cb2.png";

/***/ },
/* 156 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/cat_other_label-538488428ac510d307a22a7fff62bb2a.png";

/***/ },
/* 157 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/cat_pre_rolls_label-273a5ddd36961a0b01cf60498fac9ce3.png";

/***/ },
/* 158 */
82,
/* 159 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/strains-hybrid-f6d958692a39c852d5ef59ed01c9b93f.png";

/***/ },
/* 160 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/strains-indica-49d904faaba895d9a35a0f555f351799.png";

/***/ },
/* 161 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/strains-sativa-35da51ac74f5db22890a0194a72713a8.png";

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(150);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./menu-item-thumb.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./menu-item-thumb.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 163 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-menu-item-thumb-inner">\n    <div class="fmcy-thumb-item-click-area"></div>\n    <div class="fmcy-vendor-icon-region"></div>\n    <div class="fmcy-favourite-button-region"></div>\n    <div class="fmcy-tag-bar-region"></div>\n    ';
	 if (options.showProductImage) { 
	__p+='\n    <div class="fmcy-menu-item-row fmcy-menu-item-thumb-image fmcy-menu-item-thumb-image-region">\n        ';
	 if (options.showTitleOverProductImage) { 
	__p+='\n        <div class="fmcy-menu-item-thumb-title">\n                '+
	((__t=( itemName ))==null?'':__t)+
	'\n        </div>\n        ';
	 } 
	__p+='\n    </div>\n    ';
	 } 
	__p+='\n    ';
	 if (!options.showTitleOverProductImage) { 
	__p+='\n    <div class="fmcy-menu-item-row fmcy-menu-item-thumb-title-row">\n        <div class="fmcy-menu-item-thumb-title">\n            '+
	((__t=( itemName ))==null?'':__t)+
	'\n        </div>\n    </div>\n    ';
	 } 
	__p+='\n    ';
	 if (strainName) { 
	__p+='\n    <div class="fmcy-product-strain-name">\n        '+
	((__t=( strainName ))==null?'':__t)+
	'\n    </div>\n    ';
	 } 
	__p+='\n    <div class="fmcy-potency-region"></div>\n    ';
	 if (!options.showPricesLast) { 
	__p+='\n    <div class="fmcy-menu-item-row fmcy-menu-item-thumb-prices-row '+
	((__t=( strain ))==null?'':__t)+
	'">\n        <div class="fmcy-item-prices-region"></div>\n    </div>\n    ';
	 } 
	__p+='\n    ';
	 if (shouldRenderProductLocations) { 
	__p+='\n    <div class="fmcy-menu-item-row">\n        <div class="fmcy-available-at-locations-region"></div>\n    </div>\n    ';
	 } 
	__p+='\n    ';
	 if (options.showEffects) { 
	__p+='\n    <div class="fmcy-menu-item-row fmcy-menu-item-thumb-effects-row '+
	((__t=( strain ))==null?'':__t)+
	'">\n        ';
	 if (options.showStrainInEffectsRow && strain) { 
	__p+='\n            <div class="fmcy-strain-name">'+
	((__t=( strain ))==null?'':__t)+
	'</div>\n            ';
	 if (effectsAttrs) { 
	__p+='\n                |\n            ';
	 } 
	__p+='\n        ';
	 } 
	__p+='\n        <div class="fmcy-menu-item-thumb-effects-row-text" title="'+
	((__t=( effectsAttrs ))==null?'':__t)+
	'">\n            '+
	((__t=( effectsAttrs ))==null?'':__t)+
	'\n        </div>\n    </div>\n    ';
	 } 
	__p+='\n    ';
	 if (options.showMedicalAttrs) { 
	__p+='\n    <div class="fmcy-menu-item-row fmcy-menu-item-thumb-medical-row '+
	((__t=( strain ))==null?'':__t)+
	'">\n        <div class="fmcy-menu-item-thumb-medical-row-text" title="'+
	((__t=( medicalAttrs ))==null?'':__t)+
	'">\n            '+
	((__t=( medicalAttrs ))==null?'':__t)+
	'\n        </div>\n    </div>\n    ';
	 } 
	__p+='\n    ';
	 if (shouldRenderPromotionHeadline) { 
	__p+='\n    <div class="fmcy-menu-item-row fmcy-menu-item-promotion-headline-row '+
	((__t=( strain ))==null?'':__t)+
	'">\n        <div class="fmcy-menu-item-headline">\n            <span class="fmcy-menu-headline-text">\n                '+
	((__t=( headlineText ))==null?'':__t)+
	'\n            </span>\n        </div>\n    </div>\n    ';
	 } 
	__p+='\n    ';
	 if (options.showStrainIcon) { 
	__p+='\n    <div class="fmcy-menu-item-row fmcy-menu-item-strain-title-row">\n        <div class="fmcy-menu-item-strain-title '+
	((__t=( strainTitleImgClass ))==null?'':__t)+
	'"></div>\n    </div>\n    ';
	 } 
	__p+='\n    ';
	 if (options.showPricesLast) { 
	__p+='\n    <div class="fmcy-menu-item-row fmcy-menu-item-thumb-prices-row '+
	((__t=( strain ))==null?'':__t)+
	'">\n        <div class="fmcy-item-prices-region"></div>\n    </div>\n    ';
	 } 
	__p+='\n    ';
	 if (options.onlinePurchaseEnabled) { 
	__p+='\n    <div class="fmcy-menu-item-row fmcy-menu-item-select-price-to-add-to-cart-row">\n      <div class="fmcy-menu-item-select-price-to-add-to-cart-">- SELECT PRICE TO ADD TO CART -</div>\n    </div>\n    ';
	 } 
	__p+='\n    <div class="fmcy-menu-item-row fmcy-menu-item-filter-location-row">\n      <div class="fmcy-location-change-drop-down-region"></div>\n    </div>\n</div>\n<div class="fmcy-item-prices-pinned-region"></div>\n<div class="fmcy-bottom-border"></div>\n';
	}
	return __p;
	};


/***/ },
/* 164 */,
/* 165 */,
/* 166 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/fonts/glyphicons-halflings-regular-f4769f9bdb7466be65088239c12046d1.eot";

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	__webpack_require__(211);
	var BaseViews = __webpack_require__(5);
	var FarmBrandingF = BaseViews.ItemView.extend({
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            clickUrl: null,
	            size: 'full', // full, half
	            color: 'white' // white, black
	        });
	    },
	    template: function template() {
	        return '<div class="fmy-branding-f"></div>';
	    },
	    className: 'fmy-branding-f'
	});
	
	var FarmBrandingFull = BaseViews.ItemView.extend({
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            size: 'full', // full, half
	            color: 'white' // white, black
	        });
	    },
	    template: function template() {
	        return '<div class="fmy-branding-logo-full"></div>';
	    },
	    className: 'fmy-branding-logo-full-wrapper'
	});
	
	var FarmBranding = BaseViews.LayoutView.extend({
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            style: 'f', // f, full
	            color: 'white'
	        });
	    },
	    className: 'fmcy-branding',
	    template: __webpack_require__(214),
	    regions: {
	        logoRegion: '.farm-branding-region'
	    },
	    events: {
	        'click': 'onClick'
	    },
	    onClick: function onClick() {
	        this.trigger('clicked');
	    },
	    _renderFLogo: function _renderFLogo() {
	        this._logo = new FarmBrandingF();
	        this.logoRegion.show(this._logo);
	    },
	    _renderFullLogo: function _renderFullLogo() {
	        this._logo = new FarmBrandingFull();
	        this.logoRegion.show(this._logo);
	    },
	    onRender: function onRender() {
	        var self = this;
	        switch (this.options.style) {
	            case 'f':
	                this._renderFLogo();
	                break;
	            default:
	                this._renderFullLogo();
	                break;
	        }
	    }
	});
	module.exports = FarmBranding;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/btn-close-7eea95acd0e8f0674f7f66d5a8cb1065.png";

/***/ },
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="row no-gutters feature-popup-video-row">\n<video id="video-player"\n      class="video-js"\n      controls\n      autoplay\n      preload="auto"\n      data-setup=\'{}\'>\n      <source src="'+
	((__t=( videoUrl ))==null?'':__t)+
	'" type="video/mp4"></source>\n      <p class="vjs-no-js">\n      To view this video please enable JavaScript, and consider upgrading to a\n      web browser that\n      <a href="http://videojs.com/html5-video-support/" target="_blank">\n        supports HTML5 video\n      </a>\n      </p>\n</video>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 197 */,
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(218);
	$.payment.cards.push({
	  type: 'discover',
	  patterns: [60, 64, 65, 622],
	  format: /(\d{1,4})(\d{1,4})?(\d{1,4})?(\d{1,4})?(\d{1,3})?/,
	  length: [16, 17, 18, 19],
	  cvcLength: [3],
	  luhn: true
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ },
/* 199 */,
/* 200 */,
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Backbone) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	
	__webpack_require__(212);
	var Slider = BaseViews.LayoutView.extend({
	    _preloadQueue: null,
	    _playingTimeoutID: null,
	    _currentSlideModel: null,
	    _stopped: null,
	    template: __webpack_require__(215),
	    className: 'fmcy-slider full',
	    ui: {
	        previousBtn: '.fmcy-slider-control-prev',
	        nextBtn: '.fmcy-slider-control-next'
	    },
	    events: {
	        'click @ui.previousBtn': 'previousClicked',
	        'click @ui.nextBtn': 'nextClicked'
	    },
	    regions: {
	        loaderRegion: '.fmcy-loader-region',
	        slideLayerARegion: '.fmcy-slide-layer-a-region',
	        slideLayerBRegion: '.fmcy-slide-layer-b-region'
	    },
	    initialize: function initialize(options) {
	        var self = this;
	        self.options = _.defaults(options || {}, {
	            animationStyleShow: 'long',
	            pauseOnHover: true,
	            showSlideDuration: 8000,
	            imagePreloadTimeout: 60000,
	            fullScreen: true,
	            showNavigationButtons: false,
	            menuItemThumbOptions: {}
	        });
	
	        _.bindAll(this, '_displaySlide');
	
	        var createjs = __webpack_require__(74);
	        createjs.LoadQueue.loadTimeout = self.options.imagePreloadTimeout;
	        self._preloadQueue = new createjs.LoadQueue(false);
	        self._stopped = true;
	
	        self._state = new Backbone.Model({
	            paused: false
	        });
	    },
	    serializeData: function serializeData() {
	        return {
	            options: this.options
	        };
	    },
	    nextClicked: function nextClicked(e) {
	        e.preventDefault();
	        var nextSlide = this.collection.next(this._currentSlideModel);
	        if (nextSlide) {
	            this._currentSlideModel = nextSlide;
	        } else {
	            this._currentSlideModel = this.collection.at(0);
	        }
	        this._displaySlide(this._currentSlideModel);
	    },
	    previousClicked: function previousClicked(e) {
	        e.preventDefault();
	        var prevSlide = this.collection.prev(this._currentSlideModel);
	        if (prevSlide) {
	            this._currentSlideModel = prevSlide;
	        } else {
	            this._currentSlideModel = this.collection.at(0);
	        }
	        this._displaySlide(this._currentSlideModel);
	    },
	    onBeforeShow: function onBeforeShow() {
	        var self = this;
	
	        self._toggleLoader(true);
	        var maybeStartSliding = function maybeStartSliding() {
	            if (!self.options.showNavigationButtons) {
	                if (self._stopped) {
	                    self._stopped = false;
	                    self._cycle(true);
	                }
	            } else if (!self._currentSlideModel) {
	                self._currentSlideModel = self.collection.at(0);
	                self._displaySlide(self._currentSlideModel);
	            }
	        };
	        self.collection.on('add reset', maybeStartSliding);
	
	        if (self.options.pauseOnHover) {
	            self.$el.hover(self.pause.bind(self), self.play.bind(self));
	        }
	
	        if (self.collection.size()) {
	            maybeStartSliding();
	        }
	        if (self.options.fullScreen) {
	            self.$el.addClass('fmcy-full-screen');
	        }
	    },
	    _toggleLoader: function _toggleLoader(on) {
	        if (on) {
	            this.loaderRegion.show(new (__webpack_require__(20))({
	                message: ''
	            }));
	        } else {
	            this.loaderRegion.empty();
	        }
	    },
	    _cycle: function _cycle(firstSlide) {
	        var self = this;
	
	        if (self._playingTimeoutID) {
	            clearTimeout(self._playingTimeoutID);
	            self._playingTimeoutID = null;
	        }
	
	        if (self._state.get('paused')) {
	            return;
	        }
	
	        function nextSlide() {
	            if (!self.isRendered) {
	                return;
	            }
	
	            if (!self.collection.size()) {
	                self._stopped = true;
	                return;
	            }
	
	            var nextSlideModel;
	            if (!self._currentSlideModel) {
	                nextSlideModel = self.collection.at(0);
	            } else {
	                nextSlideModel = self.collection.next(self._currentSlideModel);
	                if (!nextSlideModel) {
	                    nextSlideModel = self.collection.at(0);
	                }
	            }
	
	            if (!nextSlideModel || nextSlideModel === self._currentSlideModel) {
	                self._stopped = true;
	                return;
	            }
	
	            self._currentSlideModel = nextSlideModel;
	
	            self._displaySlide(nextSlideModel, function () {
	                self._cycle();
	            });
	            var nextItem = self.collection.next(nextSlideModel);
	            if (nextItem) {
	                self._preloadQueue.loadFile({
	                    id: nextItem.id,
	                    src: self.options.getItemDisplayImageURL(nextItem, 'large')
	                });
	            }
	        }
	
	        if (firstSlide) {
	            nextSlide();
	            return;
	        }
	
	        if (self._currentSlideModel.get('type') == 'video') {
	            var slide;
	            if (self.slideViewA == null) {
	                slide = self.slideViewB;
	            } else {
	                slide = self.slideViewA;
	            }
	            slide.on('videoplayer:ended', function () {
	                nextSlide();
	            });
	        } else {
	            self._playingTimeoutID = setTimeout(function () {
	                nextSlide();
	            }, self.options.showSlideDuration);
	        }
	    },
	    pause: function pause() {
	        this._state.set('paused', true);
	        if (this._playingTimeoutID) {
	            clearTimeout(this._playingTimeoutID);
	            this._playingTimeoutID = null;
	        }
	    },
	    play: function play() {
	        this._state.set('paused', false);
	        if (!this._stopped) {
	            this._cycle();
	        }
	    },
	    _displaySlide: function _displaySlide(slideModel, displayedCallback) {
	        var self = this;
	
	        function createSlide(item, callback) {
	            var handleFileLoaded;
	            var handleFileLoadError;
	
	            function callbackWithView(displayImageURL) {
	                self.createSlide(item, displayImageURL).then(function (slide) {
	                    slide.$el.addClass('fmcy-slider-slide');
	                    callback(slide);
	                });
	            }
	            handleFileLoadError = function handleFileLoadError(event) {
	                if (!self.isRendered) {
	                    return;
	                }
	                if (event.item.id === item.id) {
	                    console.log('File load error occurred: ', event);
	                    self._preloadQueue.removeAllEventListeners('fileload');
	                    self._preloadQueue.removeAllEventListeners('error');
	                    callbackWithView(null);
	                }
	            };
	
	            handleFileLoaded = function handleFileLoaded(event) {
	                if (!self.isRendered) {
	                    return;
	                }
	                if (event.item.id === item.id) {
	                    self._preloadQueue.removeAllEventListeners('fileload');
	                    self._preloadQueue.removeAllEventListeners('error');
	                    callbackWithView(event.item.src);
	                }
	            };
	
	            self._preloadQueue.on('error', handleFileLoadError);
	            self._preloadQueue.on('fileload', handleFileLoaded);
	            self._preloadQueue.loadFile({
	                id: item.id,
	                src: self.options.getItemDisplayImageURL(item, 'large')
	            });
	        }
	
	        if (self.slideViewA) {
	            createSlide(slideModel, function (slideView) {
	                self._toggleLoader(false);
	                self.slideViewB = slideView;
	                if (self.slideViewA) {
	                    self.hideSlide(self.slideViewA, function () {
	                        if (!self.isRendered) {
	                            return false;
	                        }
	                        self.slideLayerARegion.empty();
	                    });
	                }
	                self.slideViewA = null;
	                self.slideViewB.on('show', function () {
	                    self.showSlide(self.slideViewB);
	                });
	                self.slideLayerBRegion.show(self.slideViewB);
	                if (displayedCallback) {
	                    displayedCallback();
	                }
	            });
	        } else {
	            createSlide(slideModel, function (slideView) {
	                self._toggleLoader(false);
	                self.slideViewA = slideView;
	                if (self.slideViewB) {
	                    self.hideSlide(self.slideViewB, function () {
	                        if (!self.isRendered) {
	                            return false;
	                        }
	                        self.slideLayerBRegion.empty();
	                    });
	                }
	                self.slideViewB = null;
	                self.slideViewA.on('show', function () {
	                    self.showSlide(self.slideViewA);
	                });
	                self.slideLayerARegion.show(self.slideViewA);
	                if (displayedCallback) {
	                    displayedCallback();
	                }
	            });
	        }
	    },
	    hideSlide: function hideSlide(slideView, completedCallback) {
	        window.gsap.fromTo(slideView.$el, {
	            opacity: 1
	        }, {
	            opacity: 0,
	            duration: 2,
	            onComplete: function onComplete() {
	                if (completedCallback) {
	                    completedCallback();
	                }
	            }
	        });
	    },
	    showSlide: function showSlide(slideView, completedCallback) {
	        window.gsap.fromTo(slideView.$el, {
	            opacity: 0
	        }, {
	            opacity: 1,
	            duration: 2,
	            onComplete: function onComplete() {
	                if (completedCallback) {
	                    completedCallback();
	                }
	            }
	        });
	    }
	});
	module.exports = Slider;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 202 */,
/* 203 */,
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-branding {\n  width: 100%;\n  text-align: center;\n  margin: auto;\n  cursor: pointer; }\n  .fmcy-branding .fmy-branding-f {\n    background-image: url(" + escape(__webpack_require__(206)) + ");\n    width: 53px;\n    height: 142px;\n    background-size: contain;\n    background-repeat: no-repeat; }\n  .fmcy-branding .fmy-branding-logo-full {\n    background-image: url(" + escape(__webpack_require__(207)) + ");\n    background: url(" + escape(__webpack_require__(208)) + "), linear-gradient(transparent, transparent);\n    height: 52px;\n    width: 148px;\n    background-repeat-x: no-repeat;\n    background-repeat-y: no-repeat;\n    background-repeat: no-repeat;\n    background-size: contain; }\n", ""]);
	
	// exports


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-slider {\n  position: relative;\n  padding: 0px;\n  padding: 2% 2% 0;\n  display: -webkit-flex;\n  -webkit-flex-flow: row wrap;\n  -webkit-justify-content: space-between;\n  -webkit-align-content: flex-start; }\n  .fmcy-slider:after {\n    content: '';\n    display: inline-block;\n    width: 100%; }\n  .fmcy-slider .fmcy-slider-control-prev {\n    left: 0; }\n  .fmcy-slider .fmcy-slider-control-next {\n    right: 0; }\n  .fmcy-slider:hover .fmcy-slider-control-prev,\n  .fmcy-slider:hover .fmcy-slider-control-next {\n    display: flex; }\n  .fmcy-slider .fmcy-slider-control-prev,\n  .fmcy-slider .fmcy-slider-control-next {\n    position: absolute;\n    display: none;\n    z-index: 1;\n    background-color: lightgray;\n    top: 0;\n    bottom: 0;\n    align-items: center;\n    justify-content: center;\n    width: 15%;\n    color: #fff;\n    text-align: center;\n    opacity: 0.5; }\n  .fmcy-slider .fmcy-slider-control-prev-icon,\n  .fmcy-slider .fmcy-slider-control-next-icon {\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    background: transparent no-repeat center center;\n    background-size: 100% 100%; }\n  .fmcy-slider .fmcy-slider-control-prev-icon {\n    background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E\"); }\n  .fmcy-slider .fmcy-slider-control-next-icon {\n    background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E\"); }\n  .fmcy-slider .fmcy-loader-wrapper {\n    display: table;\n    width: 100%;\n    height: 100%; }\n    .fmcy-slider .fmcy-loader-wrapper .fmcy-loader-region {\n      display: table-cell;\n      vertical-align: middle; }\n  .fmcy-slider .fmcy-slide-layer-a-region,\n  .fmcy-slider .fmcy-slide-layer-b-region {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0; }\n  .fmcy-slider.fmcy-full-screen {\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0; }\n", ""]);
	
	// exports


/***/ },
/* 206 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/f_logo_white-21d12019384434f8790952f2058af779.png";

/***/ },
/* 207 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/the_original_farm_logo_white-bfb92d8060c066c4f6fd169cdd91798e.png";

/***/ },
/* 208 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/the_original_farm_logo_white-baceab761be19cafa58c8371df4f16db.svg";

/***/ },
/* 209 */,
/* 210 */,
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(204);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./farm-branding.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./farm-branding.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(205);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./slider.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./slider.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 213 */,
/* 214 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="farm-branding-region"></div>\n';
	}
	return __p;
	};


/***/ },
/* 215 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	 if (options.showNavigationButtons) { 
	__p+='\n<a class="fmcy-slider-control-prev" href="#" role="button">\n    <span class="fmcy-slider-control-prev-icon" aria-hidden="true"></span>\n    <span class="sr-only">Previous</span>\n</a>\n<a class="fmcy-slider-control-next" href="#" role="button">\n    <span class="fmcy-slider-control-next-icon" aria-hidden="true"></span>\n    <span class="sr-only">Next</span>\n</a>\n';
	 } 
	__p+='\n<div class="fmcy-loader-wrapper">\n    <div class="fmcy-loader-region"></div>\n</div>\n<div class="fmcy-slide-layer-a-region"></div>\n<div class="fmcy-slide-layer-b-region"></div>';
	}
	return __p;
	};


/***/ },
/* 216 */,
/* 217 */,
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (factory, jQuery, Zepto) {
	
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object' && typeof Meteor === 'undefined') {
	        module.exports = factory(require('jquery'));
	    } else {
	        factory(jQuery || Zepto);
	    }
	
	}(function($) {
	  var cardFromNumber, cardFromType, cards, defaultFormat, formatBackCardNumber, formatBackExpiry, formatCardNumber, formatExpiry, formatForwardExpiry, formatForwardSlashAndSpace, hasTextSelected, luhnCheck, reFormatCVC, reFormatCardNumber, reFormatExpiry, reFormatNumeric, replaceFullWidthChars, restrictCVC, restrictCardNumber, restrictExpiry, restrictNumeric, safeVal, setCardType,
	    __slice = [].slice,
	    __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	  $.payment = {};
	
	  $.payment.fn = {};
	
	  $.fn.payment = function() {
	    var args, method;
	    method = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
	    return $.payment.fn[method].apply(this, args);
	  };
	
	  defaultFormat = /(\d{1,4})/g;
	
	  $.payment.cards = cards = [
	    {
	      type: 'visa',
	      patterns: [4],
	      format: defaultFormat,
	      length: [13, 16],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'mastercard',
	      patterns: [51, 52, 53, 54, 55, 22, 23, 24, 25, 26, 27],
	      format: defaultFormat,
	      length: [16],
	      cvcLength: [3],
	      luhn: true
	    }, {
	      type: 'amex',
	      patterns: [34, 37],
	      format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
	      length: [15],
	      cvcLength: [3, 4],
	      luhn: true
	    }
	  ];
	
	  cardFromNumber = function(num) {
	    var card, p, pattern, _i, _j, _len, _len1, _ref;
	    num = (num + '').replace(/\D/g, '');
	    for (_i = 0, _len = cards.length; _i < _len; _i++) {
	      card = cards[_i];
	      _ref = card.patterns;
	      for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
	        pattern = _ref[_j];
	        p = pattern + '';
	        if (num.substr(0, p.length) === p) {
	          return card;
	        }
	      }
	    }
	  };
	
	  cardFromType = function(type) {
	    var card, _i, _len;
	    for (_i = 0, _len = cards.length; _i < _len; _i++) {
	      card = cards[_i];
	      if (card.type === type) {
	        return card;
	      }
	    }
	  };
	
	  luhnCheck = function(num) {
	    var digit, digits, odd, sum, _i, _len;
	    odd = true;
	    sum = 0;
	    digits = (num + '').split('').reverse();
	    for (_i = 0, _len = digits.length; _i < _len; _i++) {
	      digit = digits[_i];
	      digit = parseInt(digit, 10);
	      if ((odd = !odd)) {
	        digit *= 2;
	      }
	      if (digit > 9) {
	        digit -= 9;
	      }
	      sum += digit;
	    }
	    return sum % 10 === 0;
	  };
	
	  hasTextSelected = function($target) {
	    var _ref;
	    if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== $target.prop('selectionEnd')) {
	      return true;
	    }
	    if ((typeof document !== "undefined" && document !== null ? (_ref = document.selection) != null ? _ref.createRange : void 0 : void 0) != null) {
	      if (document.selection.createRange().text) {
	        return true;
	      }
	    }
	    return false;
	  };
	
	  safeVal = function(value, $target) {
	    var currPair, cursor, digit, error, last, prevPair;
	    try {
	      cursor = $target.prop('selectionStart');
	    } catch (_error) {
	      error = _error;
	      cursor = null;
	    }
	    last = $target.val();
	    $target.val(value);
	    if (cursor !== null && $target.is(":focus")) {
	      if (cursor === last.length) {
	        cursor = value.length;
	      }
	      if (last !== value) {
	        prevPair = last.slice(cursor - 1, +cursor + 1 || 9e9);
	        currPair = value.slice(cursor - 1, +cursor + 1 || 9e9);
	        digit = value[cursor];
	        if (/\d/.test(digit) && prevPair === ("" + digit + " ") && currPair === (" " + digit)) {
	          cursor = cursor + 1;
	        }
	      }
	      $target.prop('selectionStart', cursor);
	      return $target.prop('selectionEnd', cursor);
	    }
	  };
	
	  replaceFullWidthChars = function(str) {
	    var chars, chr, fullWidth, halfWidth, idx, value, _i, _len;
	    if (str == null) {
	      str = '';
	    }
	    fullWidth = '\uff10\uff11\uff12\uff13\uff14\uff15\uff16\uff17\uff18\uff19';
	    halfWidth = '0123456789';
	    value = '';
	    chars = str.split('');
	    for (_i = 0, _len = chars.length; _i < _len; _i++) {
	      chr = chars[_i];
	      idx = fullWidth.indexOf(chr);
	      if (idx > -1) {
	        chr = halfWidth[idx];
	      }
	      value += chr;
	    }
	    return value;
	  };
	
	  reFormatNumeric = function(e) {
	    var $target;
	    $target = $(e.currentTarget);
	    return setTimeout(function() {
	      var value;
	      value = $target.val();
	      value = replaceFullWidthChars(value);
	      value = value.replace(/\D/g, '');
	      return safeVal(value, $target);
	    });
	  };
	
	  reFormatCardNumber = function(e) {
	    var $target;
	    $target = $(e.currentTarget);
	    return setTimeout(function() {
	      var value;
	      value = $target.val();
	      value = replaceFullWidthChars(value);
	      value = $.payment.formatCardNumber(value);
	      return safeVal(value, $target);
	    });
	  };
	
	  formatCardNumber = function(e) {
	    var $target, card, digit, length, re, upperLength, value;
	    digit = String.fromCharCode(e.which);
	    if (!/^\d+$/.test(digit)) {
	      return;
	    }
	    $target = $(e.currentTarget);
	    value = $target.val();
	    card = cardFromNumber(value + digit);
	    length = (value.replace(/\D/g, '') + digit).length;
	    upperLength = 16;
	    if (card) {
	      upperLength = card.length[card.length.length - 1];
	    }
	    if (length >= upperLength) {
	      return;
	    }
	    if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== value.length) {
	      return;
	    }
	    if (card && card.type === 'amex') {
	      re = /^(\d{4}|\d{4}\s\d{6})$/;
	    } else {
	      re = /(?:^|\s)(\d{4})$/;
	    }
	    if (re.test(value)) {
	      e.preventDefault();
	      return setTimeout(function() {
	        return $target.val(value + ' ' + digit);
	      });
	    } else if (re.test(value + digit)) {
	      e.preventDefault();
	      return setTimeout(function() {
	        return $target.val(value + digit + ' ');
	      });
	    }
	  };
	
	  formatBackCardNumber = function(e) {
	    var $target, value;
	    $target = $(e.currentTarget);
	    value = $target.val();
	    if (e.which !== 8) {
	      return;
	    }
	    if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== value.length) {
	      return;
	    }
	    if (/\d\s$/.test(value)) {
	      e.preventDefault();
	      return setTimeout(function() {
	        return $target.val(value.replace(/\d\s$/, ''));
	      });
	    } else if (/\s\d?$/.test(value)) {
	      e.preventDefault();
	      return setTimeout(function() {
	        return $target.val(value.replace(/\d$/, ''));
	      });
	    }
	  };
	
	  reFormatExpiry = function(e) {
	    var $target;
	    $target = $(e.currentTarget);
	    return setTimeout(function() {
	      var value;
	      value = $target.val();
	      value = replaceFullWidthChars(value);
	      value = $.payment.formatExpiry(value);
	      return safeVal(value, $target);
	    });
	  };
	
	  formatExpiry = function(e) {
	    var $target, digit, val;
	    digit = String.fromCharCode(e.which);
	    if (!/^\d+$/.test(digit)) {
	      return;
	    }
	    $target = $(e.currentTarget);
	    val = $target.val() + digit;
	    if (/^\d$/.test(val) && (val !== '0' && val !== '1')) {
	      e.preventDefault();
	      return setTimeout(function() {
	        return $target.val("0" + val + " / ");
	      });
	    } else if (/^\d\d$/.test(val)) {
	      e.preventDefault();
	      return setTimeout(function() {
	        var m1, m2;
	        m1 = parseInt(val[0], 10);
	        m2 = parseInt(val[1], 10);
	        if (m2 > 2 && m1 !== 0) {
	          return $target.val("0" + m1 + " / " + m2);
	        } else {
	          return $target.val("" + val + " / ");
	        }
	      });
	    }
	  };
	
	  formatForwardExpiry = function(e) {
	    var $target, digit, val;
	    digit = String.fromCharCode(e.which);
	    if (!/^\d+$/.test(digit)) {
	      return;
	    }
	    $target = $(e.currentTarget);
	    val = $target.val();
	    if (/^\d\d$/.test(val)) {
	      return $target.val("" + val + " / ");
	    }
	  };
	
	  formatForwardSlashAndSpace = function(e) {
	    var $target, val, which;
	    which = String.fromCharCode(e.which);
	    if (!(which === '/' || which === ' ')) {
	      return;
	    }
	    $target = $(e.currentTarget);
	    val = $target.val();
	    if (/^\d$/.test(val) && val !== '0') {
	      return $target.val("0" + val + " / ");
	    }
	  };
	
	  formatBackExpiry = function(e) {
	    var $target, value;
	    $target = $(e.currentTarget);
	    value = $target.val();
	    if (e.which !== 8) {
	      return;
	    }
	    if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== value.length) {
	      return;
	    }
	    if (/\d\s\/\s$/.test(value)) {
	      e.preventDefault();
	      return setTimeout(function() {
	        return $target.val(value.replace(/\d\s\/\s$/, ''));
	      });
	    }
	  };
	
	  reFormatCVC = function(e) {
	    var $target;
	    $target = $(e.currentTarget);
	    return setTimeout(function() {
	      var value;
	      value = $target.val();
	      value = replaceFullWidthChars(value);
	      value = value.replace(/\D/g, '').slice(0, 4);
	      return safeVal(value, $target);
	    });
	  };
	
	  restrictNumeric = function(e) {
	    var input;
	    if (e.metaKey || e.ctrlKey) {
	      return true;
	    }
	    if (e.which === 32) {
	      return false;
	    }
	    if (e.which === 0) {
	      return true;
	    }
	    if (e.which < 33) {
	      return true;
	    }
	    input = String.fromCharCode(e.which);
	    return !!/[\d\s]/.test(input);
	  };
	
	  restrictCardNumber = function(e) {
	    var $target, card, digit, value;
	    $target = $(e.currentTarget);
	    digit = String.fromCharCode(e.which);
	    if (!/^\d+$/.test(digit)) {
	      return;
	    }
	    if (hasTextSelected($target)) {
	      return;
	    }
	    value = ($target.val() + digit).replace(/\D/g, '');
	    card = cardFromNumber(value);
	    if (card) {
	      return value.length <= card.length[card.length.length - 1];
	    } else {
	      return value.length <= 16;
	    }
	  };
	
	  restrictExpiry = function(e) {
	    var $target, digit, value;
	    $target = $(e.currentTarget);
	    digit = String.fromCharCode(e.which);
	    if (!/^\d+$/.test(digit)) {
	      return;
	    }
	    if (hasTextSelected($target)) {
	      return;
	    }
	    value = $target.val() + digit;
	    value = value.replace(/\D/g, '');
	    if (value.length > 6) {
	      return false;
	    }
	  };
	
	  restrictCVC = function(e) {
	    var $target, digit, val;
	    $target = $(e.currentTarget);
	    digit = String.fromCharCode(e.which);
	    if (!/^\d+$/.test(digit)) {
	      return;
	    }
	    if (hasTextSelected($target)) {
	      return;
	    }
	    val = $target.val() + digit;
	    return val.length <= 4;
	  };
	
	  setCardType = function(e) {
	    var $target, allTypes, card, cardType, val;
	    $target = $(e.currentTarget);
	    val = $target.val();
	    cardType = $.payment.cardType(val) || 'unknown';
	    if (!$target.hasClass(cardType)) {
	      allTypes = (function() {
	        var _i, _len, _results;
	        _results = [];
	        for (_i = 0, _len = cards.length; _i < _len; _i++) {
	          card = cards[_i];
	          _results.push(card.type);
	        }
	        return _results;
	      })();
	      $target.removeClass('unknown');
	      $target.removeClass(allTypes.join(' '));
	      $target.addClass(cardType);
	      $target.toggleClass('identified', cardType !== 'unknown');
	      return $target.trigger('payment.cardType', cardType);
	    }
	  };
	
	  $.payment.fn.formatCardCVC = function() {
	    this.on('keypress', restrictNumeric);
	    this.on('keypress', restrictCVC);
	    this.on('paste', reFormatCVC);
	    this.on('change', reFormatCVC);
	    this.on('input', reFormatCVC);
	    return this;
	  };
	
	  $.payment.fn.formatCardExpiry = function() {
	    this.on('keypress', restrictNumeric);
	    this.on('keypress', restrictExpiry);
	    this.on('keypress', formatExpiry);
	    this.on('keypress', formatForwardSlashAndSpace);
	    this.on('keypress', formatForwardExpiry);
	    this.on('keydown', formatBackExpiry);
	    this.on('change', reFormatExpiry);
	    this.on('input', reFormatExpiry);
	    return this;
	  };
	
	  $.payment.fn.formatCardNumber = function() {
	    this.on('keypress', restrictNumeric);
	    this.on('keypress', restrictCardNumber);
	    this.on('keypress', formatCardNumber);
	    this.on('keydown', formatBackCardNumber);
	    this.on('keyup', setCardType);
	    this.on('paste', reFormatCardNumber);
	    this.on('change', reFormatCardNumber);
	    this.on('input', reFormatCardNumber);
	    this.on('input', setCardType);
	    return this;
	  };
	
	  $.payment.fn.restrictNumeric = function() {
	    this.on('keypress', restrictNumeric);
	    this.on('paste', reFormatNumeric);
	    this.on('change', reFormatNumeric);
	    this.on('input', reFormatNumeric);
	    return this;
	  };
	
	  $.payment.fn.cardExpiryVal = function() {
	    return $.payment.cardExpiryVal($(this).val());
	  };
	
	  $.payment.cardExpiryVal = function(value) {
	    var month, prefix, year, _ref;
	    _ref = value.split(/[\s\/]+/, 2), month = _ref[0], year = _ref[1];
	    if ((year != null ? year.length : void 0) === 2 && /^\d+$/.test(year)) {
	      prefix = (new Date).getFullYear();
	      prefix = prefix.toString().slice(0, 2);
	      year = prefix + year;
	    }
	    month = parseInt(month, 10);
	    year = parseInt(year, 10);
	    return {
	      month: month,
	      year: year
	    };
	  };
	
	  $.payment.validateCardNumber = function(num) {
	    var card, _ref;
	    num = (num + '').replace(/\s+|-/g, '');
	    if (!/^\d+$/.test(num)) {
	      return false;
	    }
	    card = cardFromNumber(num);
	    if (!card) {
	      return false;
	    }
	    return (_ref = num.length, __indexOf.call(card.length, _ref) >= 0) && (card.luhn === false || luhnCheck(num));
	  };
	
	  $.payment.validateCardExpiry = function(month, year) {
	    var currentTime, expiry, _ref;
	    if (typeof month === 'object' && 'month' in month) {
	      _ref = month, month = _ref.month, year = _ref.year;
	    }
	    if (!(month && year)) {
	      return false;
	    }
	    month = $.trim(month);
	    year = $.trim(year);
	    if (!/^\d+$/.test(month)) {
	      return false;
	    }
	    if (!/^\d+$/.test(year)) {
	      return false;
	    }
	    if (!((1 <= month && month <= 12))) {
	      return false;
	    }
	    if (year.length === 2) {
	      if (year < 70) {
	        year = "20" + year;
	      } else {
	        year = "19" + year;
	      }
	    }
	    if (year.length !== 4) {
	      return false;
	    }
	    expiry = new Date(year, month);
	    currentTime = new Date;
	    expiry.setMonth(expiry.getMonth() - 1);
	    expiry.setMonth(expiry.getMonth() + 1, 1);
	    return expiry > currentTime;
	  };
	
	  $.payment.validateCardCVC = function(cvc, type) {
	    var card, _ref;
	    cvc = $.trim(cvc);
	    if (!/^\d+$/.test(cvc)) {
	      return false;
	    }
	    card = cardFromType(type);
	    if (card != null) {
	      return _ref = cvc.length, __indexOf.call(card.cvcLength, _ref) >= 0;
	    } else {
	      return cvc.length >= 3 && cvc.length <= 4;
	    }
	  };
	
	  $.payment.cardType = function(num) {
	    var _ref;
	    if (!num) {
	      return null;
	    }
	    return ((_ref = cardFromNumber(num)) != null ? _ref.type : void 0) || null;
	  };
	
	  $.payment.formatCardNumber = function(num) {
	    var card, groups, upperLength, _ref;
	    num = num.replace(/\D/g, '');
	    card = cardFromNumber(num);
	    if (!card) {
	      return num;
	    }
	    upperLength = card.length[card.length.length - 1];
	    num = num.slice(0, upperLength);
	    if (card.format.global) {
	      return (_ref = num.match(card.format)) != null ? _ref.join(' ') : void 0;
	    } else {
	      groups = card.format.exec(num);
	      if (groups == null) {
	        return;
	      }
	      groups.shift();
	      groups = $.grep(groups, function(n) {
	        return n;
	      });
	      return groups.join(' ');
	    }
	  };
	
	  $.payment.formatExpiry = function(expiry) {
	    var mon, parts, sep, year;
	    parts = expiry.match(/^\D*(\d{1,2})(\D+)?(\d{1,4})?/);
	    if (!parts) {
	      return '';
	    }
	    mon = parts[1] || '';
	    sep = parts[2] || '';
	    year = parts[3] || '';
	    if (year.length > 0) {
	      sep = ' / ';
	    } else if (sep === ' /') {
	      mon = mon.substring(0, 1);
	      sep = '';
	    } else if (mon.length === 2 || sep.length > 0) {
	      sep = ' / ';
	    } else if (mon.length === 1 && (mon !== '0' && mon !== '1')) {
	      mon = "0" + mon;
	      sep = ' / ';
	    }
	    return mon + sep + year;
	  };
	
	}, window.jQuery, window.Zepto));


/***/ },
/* 219 */
/***/ function(module, exports) {

	// @class TileLayer
	
	L.TileLayer.mergeOptions({
		// @option keepBuffer
		// The amount of tiles outside the visible map area to be kept in the stitched
		// `TileLayer`.
	
		// @option dumpToCanvas: Boolean = true
		// Whether to dump loaded tiles to a `<canvas>` to prevent some rendering
		// artifacts. (Disabled by default in IE)
		dumpToCanvas: L.Browser.canvas && !L.Browser.ie,
	});
	
	L.TileLayer.include({
		_onUpdateLevel: function(z, zoom) {
			if (this.options.dumpToCanvas) {
				this._levels[z].canvas.style.zIndex =
					this.options.maxZoom - Math.abs(zoom - z);
			}
		},
	
		_onRemoveLevel: function(z) {
			if (this.options.dumpToCanvas) {
				L.DomUtil.remove(this._levels[z].canvas);
			}
		},
	
		_onCreateLevel: function(level) {
			if (this.options.dumpToCanvas) {
				level.canvas = L.DomUtil.create(
					"canvas",
					"leaflet-tile-container leaflet-zoom-animated",
					this._container
				);
				level.ctx = level.canvas.getContext("2d");
				this._resetCanvasSize(level);
			}
		},
	
		_removeTile: function(key) {
			if (this.options.dumpToCanvas) {
				var tile = this._tiles[key];
				var level = this._levels[tile.coords.z];
				var tileSize = this.getTileSize();
	
				if (level) {
					// Where in the canvas should this tile go?
					var offset = L.point(tile.coords.x, tile.coords.y)
						.subtract(level.canvasRange.min)
						.scaleBy(this.getTileSize());
	
					level.ctx.clearRect(offset.x, offset.y, tileSize.x, tileSize.y);
				}
			}
	
			L.GridLayer.prototype._removeTile.call(this, key);
		},
	
		_resetCanvasSize: function(level) {
			var buff = this.options.keepBuffer,
				pixelBounds = this._getTiledPixelBounds(this._map.getCenter()),
				tileRange = this._pxBoundsToTileRange(pixelBounds),
				tileSize = this.getTileSize();
	
			tileRange.min = tileRange.min.subtract([buff, buff]); // This adds the no-prune buffer
			tileRange.max = tileRange.max.add([buff + 1, buff + 1]);
	
			var pixelRange = L.bounds(
					tileRange.min.scaleBy(tileSize),
					tileRange.max.add([1, 1]).scaleBy(tileSize) // This prevents an off-by-one when checking if tiles are inside
				),
				mustRepositionCanvas = false,
				neededSize = pixelRange.max.subtract(pixelRange.min);
	
			// Resize the canvas, if needed, and only to make it bigger.
			if (
				neededSize.x > level.canvas.width ||
				neededSize.y > level.canvas.height
			) {
				// Resizing canvases erases the currently drawn content, I'm afraid.
				// To keep it, dump the pixels to another canvas, then display it on
				// top. This could be done with getImageData/putImageData, but that
				// would break for tainted canvases (in non-CORS tilesets)
				var oldSize = { x: level.canvas.width, y: level.canvas.height };
				// console.info('Resizing canvas from ', oldSize, 'to ', neededSize);
	
				var tmpCanvas = L.DomUtil.create("canvas");
				tmpCanvas.style.width = (tmpCanvas.width = oldSize.x) + "px";
				tmpCanvas.style.height = (tmpCanvas.height = oldSize.y) + "px";
				tmpCanvas.getContext("2d").drawImage(level.canvas, 0, 0);
				// var data = level.ctx.getImageData(0, 0, oldSize.x, oldSize.y);
	
				level.canvas.style.width = (level.canvas.width = neededSize.x) + "px";
				level.canvas.style.height = (level.canvas.height = neededSize.y) + "px";
				level.ctx.drawImage(tmpCanvas, 0, 0);
				// level.ctx.putImageData(data, 0, 0, 0, 0, oldSize.x, oldSize.y);
			}
	
			// Translate the canvas contents if it's moved around
			if (level.canvasRange) {
				var offset = level.canvasRange.min
					.subtract(tileRange.min)
					.scaleBy(this.getTileSize());
	
				// 			console.info('Offsetting by ', offset);
	
				if (!L.Browser.safari) {
					// By default, canvases copy things "on top of" existing pixels, but we want
					// this to *replace* the existing pixels when doing a drawImage() call.
					// This will also clear the sides, so no clearRect() calls are needed to make room
					// for the new tiles.
					level.ctx.globalCompositeOperation = "copy";
					level.ctx.drawImage(level.canvas, offset.x, offset.y);
					level.ctx.globalCompositeOperation = "source-over";
				} else {
					// Safari clears the canvas when copying from itself :-(
					if (!this._tmpCanvas) {
						var t = (this._tmpCanvas = L.DomUtil.create("canvas"));
						t.width = level.canvas.width;
						t.height = level.canvas.height;
						this._tmpContext = t.getContext("2d");
					}
					this._tmpContext.clearRect(
						0,
						0,
						level.canvas.width,
						level.canvas.height
					);
					this._tmpContext.drawImage(level.canvas, 0, 0);
					level.ctx.clearRect(0, 0, level.canvas.width, level.canvas.height);
					level.ctx.drawImage(this._tmpCanvas, offset.x, offset.y);
				}
	
				mustRepositionCanvas = true; // Wait until new props are set
			}
	
			level.canvasRange = tileRange;
			level.canvasPxRange = pixelRange;
			level.canvasOrigin = pixelRange.min;
	
			// console.log('Canvas tile range: ', level, tileRange.min, tileRange.max );
			// console.log('Canvas pixel range: ', pixelRange.min, pixelRange.max );
			// console.log('Level origin: ', level.origin );
	
			if (mustRepositionCanvas) {
				this._setCanvasZoomTransform(
					level,
					this._map.getCenter(),
					this._map.getZoom()
				);
			}
		},
	
		/// set transform/position of canvas, in addition to the transform/position of the individual tile container
		_setZoomTransform: function(level, center, zoom) {
			L.GridLayer.prototype._setZoomTransform.call(this, level, center, zoom);
			if (this.options.dumpToCanvas) {
				this._setCanvasZoomTransform(level, center, zoom);
			}
		},
	
		// This will get called twice:
		// * From _setZoomTransform
		// * When the canvas has shifted due to a new tile being loaded
		_setCanvasZoomTransform: function(level, center, zoom) {
			// console.log('_setCanvasZoomTransform', level, center, zoom);
			if (!level.canvasOrigin) {
				return;
			}
			var scale = this._map.getZoomScale(zoom, level.zoom),
				translate = level.canvasOrigin
					.multiplyBy(scale)
					.subtract(this._map._getNewPixelOrigin(center, zoom))
					.round();
	
			if (L.Browser.any3d) {
				L.DomUtil.setTransform(level.canvas, translate, scale);
			} else {
				L.DomUtil.setPosition(level.canvas, translate);
			}
		},
	
		_onOpaqueTile: function(tile) {
			if (!this.options.dumpToCanvas) {
				return;
			}
	
			// Guard against an NS_ERROR_NOT_AVAILABLE (or similar) exception
			// when a non-image-tile has been loaded (e.g. a WMS error).
			// Checking for tile.el.complete is not enough, as it has been
			// already marked as loaded and ready somehow.
			try {
				this.dumpPixels(tile.coords, tile.el);
			} catch (ex) {
				return this.fire("tileerror", {
					error: "Could not copy tile pixels: " + ex,
					tile: tile,
					coods: tile.coords,
				});
			}
	
			// If dumping the pixels was successful, then hide the tile.
			// Do not remove the tile itself, as it is needed to check if the whole
			// level (and its canvas) should be removed (via level.el.children.length)
			tile.el.style.display = "none";
		},
	
		// @section Extension methods
		// @uninheritable
	
		// @method dumpPixels(coords: Object, imageSource: CanvasImageSource): this
		// Dumps pixels from the given `CanvasImageSource` into the layer, into
		// the space for the tile represented by the `coords` tile coordinates (an object
		// like `{x: Number, y: Number, z: Number}`; the image source must have the
		// same size as the `tileSize` option for the layer. Has no effect if `dumpToCanvas`
		// is `false`.
		dumpPixels: function(coords, imageSource) {
			var level = this._levels[coords.z],
				tileSize = this.getTileSize();
	
			if (!level.canvasRange || !this.options.dumpToCanvas) {
				return;
			}
	
			// Check if the tile is inside the currently visible map bounds
			// There is a possible race condition when tiles are loaded after they
			// have been panned outside of the map.
			if (!level.canvasRange.contains(coords)) {
				this._resetCanvasSize(level);
			}
	
			// Where in the canvas should this tile go?
			var offset = L.point(coords.x, coords.y)
				.subtract(level.canvasRange.min)
				.scaleBy(this.getTileSize());
	
			level.ctx.drawImage(imageSource, offset.x, offset.y, tileSize.x, tileSize.y);
	
			// TODO: Clear the pixels of other levels' canvases where they overlap
			// this newly dumped tile.
			return this;
		},
	});


/***/ },
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, "@charset \"UTF-8\";\n.fmcy-plugin-bootstrap {\n  /*!\n * Bootstrap v3.3.7 (http://getbootstrap.com)\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n  /*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */\n  /*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */\n  /*!\r\n * Datetimepicker for Bootstrap 3\r\n * ! version : 4.7.14\r\n * https://github.com/Eonasdan/bootstrap-datetimepicker/\r\n */ }\n  .fmcy-plugin-bootstrap html {\n    font-family: sans-serif;\n    -ms-text-size-adjust: 100%;\n    -webkit-text-size-adjust: 100%; }\n  .fmcy-plugin-bootstrap body {\n    margin: 0; }\n  .fmcy-plugin-bootstrap article,\n  .fmcy-plugin-bootstrap aside,\n  .fmcy-plugin-bootstrap details,\n  .fmcy-plugin-bootstrap figcaption,\n  .fmcy-plugin-bootstrap figure,\n  .fmcy-plugin-bootstrap footer,\n  .fmcy-plugin-bootstrap header,\n  .fmcy-plugin-bootstrap hgroup,\n  .fmcy-plugin-bootstrap main,\n  .fmcy-plugin-bootstrap menu,\n  .fmcy-plugin-bootstrap nav,\n  .fmcy-plugin-bootstrap section,\n  .fmcy-plugin-bootstrap summary {\n    display: block; }\n  .fmcy-plugin-bootstrap audio,\n  .fmcy-plugin-bootstrap canvas,\n  .fmcy-plugin-bootstrap progress,\n  .fmcy-plugin-bootstrap video {\n    display: inline-block;\n    vertical-align: baseline; }\n  .fmcy-plugin-bootstrap audio:not([controls]) {\n    display: none;\n    height: 0; }\n  .fmcy-plugin-bootstrap [hidden],\n  .fmcy-plugin-bootstrap template {\n    display: none; }\n  .fmcy-plugin-bootstrap a {\n    background-color: transparent; }\n  .fmcy-plugin-bootstrap a:active,\n  .fmcy-plugin-bootstrap a:hover {\n    outline: 0; }\n  .fmcy-plugin-bootstrap abbr[title] {\n    border-bottom: 1px dotted; }\n  .fmcy-plugin-bootstrap b,\n  .fmcy-plugin-bootstrap strong {\n    font-weight: bold; }\n  .fmcy-plugin-bootstrap dfn {\n    font-style: italic; }\n  .fmcy-plugin-bootstrap h1 {\n    font-size: 2em;\n    margin: 0.67em 0; }\n  .fmcy-plugin-bootstrap mark {\n    background: #ff0;\n    color: #000; }\n  .fmcy-plugin-bootstrap small {\n    font-size: 80%; }\n  .fmcy-plugin-bootstrap sub,\n  .fmcy-plugin-bootstrap sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline; }\n  .fmcy-plugin-bootstrap sup {\n    top: -0.5em; }\n  .fmcy-plugin-bootstrap sub {\n    bottom: -0.25em; }\n  .fmcy-plugin-bootstrap img {\n    border: 0; }\n  .fmcy-plugin-bootstrap svg:not(:root) {\n    overflow: hidden; }\n  .fmcy-plugin-bootstrap figure {\n    margin: 1em 40px; }\n  .fmcy-plugin-bootstrap hr {\n    box-sizing: content-box;\n    height: 0; }\n  .fmcy-plugin-bootstrap pre {\n    overflow: auto; }\n  .fmcy-plugin-bootstrap code,\n  .fmcy-plugin-bootstrap kbd,\n  .fmcy-plugin-bootstrap pre,\n  .fmcy-plugin-bootstrap samp {\n    font-family: monospace, monospace;\n    font-size: 1em; }\n  .fmcy-plugin-bootstrap button,\n  .fmcy-plugin-bootstrap input,\n  .fmcy-plugin-bootstrap optgroup,\n  .fmcy-plugin-bootstrap select,\n  .fmcy-plugin-bootstrap textarea {\n    color: inherit;\n    font: inherit;\n    margin: 0; }\n  .fmcy-plugin-bootstrap button {\n    overflow: visible; }\n  .fmcy-plugin-bootstrap button,\n  .fmcy-plugin-bootstrap select {\n    text-transform: none; }\n  .fmcy-plugin-bootstrap button,\n  .fmcy-plugin-bootstrap html input[type=\"button\"],\n  .fmcy-plugin-bootstrap input[type=\"reset\"],\n  .fmcy-plugin-bootstrap input[type=\"submit\"] {\n    -webkit-appearance: button;\n    cursor: pointer; }\n  .fmcy-plugin-bootstrap button[disabled],\n  .fmcy-plugin-bootstrap html input[disabled] {\n    cursor: default; }\n  .fmcy-plugin-bootstrap button::-moz-focus-inner,\n  .fmcy-plugin-bootstrap input::-moz-focus-inner {\n    border: 0;\n    padding: 0; }\n  .fmcy-plugin-bootstrap input {\n    line-height: normal; }\n  .fmcy-plugin-bootstrap input[type=\"checkbox\"],\n  .fmcy-plugin-bootstrap input[type=\"radio\"] {\n    box-sizing: border-box;\n    padding: 0; }\n  .fmcy-plugin-bootstrap input[type=\"number\"]::-webkit-inner-spin-button,\n  .fmcy-plugin-bootstrap input[type=\"number\"]::-webkit-outer-spin-button {\n    height: auto; }\n  .fmcy-plugin-bootstrap input[type=\"search\"] {\n    -webkit-appearance: textfield;\n    box-sizing: content-box; }\n  .fmcy-plugin-bootstrap input[type=\"search\"]::-webkit-search-cancel-button,\n  .fmcy-plugin-bootstrap input[type=\"search\"]::-webkit-search-decoration {\n    -webkit-appearance: none; }\n  .fmcy-plugin-bootstrap fieldset {\n    border: 1px solid #c0c0c0;\n    margin: 0 2px;\n    padding: 0.35em 0.625em 0.75em; }\n  .fmcy-plugin-bootstrap legend {\n    border: 0;\n    padding: 0; }\n  .fmcy-plugin-bootstrap textarea {\n    overflow: auto; }\n  .fmcy-plugin-bootstrap optgroup {\n    font-weight: bold; }\n  .fmcy-plugin-bootstrap table {\n    border-collapse: collapse;\n    border-spacing: 0; }\n  .fmcy-plugin-bootstrap td,\n  .fmcy-plugin-bootstrap th {\n    padding: 0; }\n  @media print {\n    .fmcy-plugin-bootstrap *,\n    .fmcy-plugin-bootstrap *:before,\n    .fmcy-plugin-bootstrap *:after {\n      background: transparent !important;\n      color: #000 !important;\n      box-shadow: none !important;\n      text-shadow: none !important; }\n    .fmcy-plugin-bootstrap a,\n    .fmcy-plugin-bootstrap a:visited {\n      text-decoration: underline; }\n    .fmcy-plugin-bootstrap a[href]:after {\n      content: \" (\" attr(href) \")\"; }\n    .fmcy-plugin-bootstrap abbr[title]:after {\n      content: \" (\" attr(title) \")\"; }\n    .fmcy-plugin-bootstrap a[href^=\"#\"]:after,\n    .fmcy-plugin-bootstrap a[href^=\"javascript:\"]:after {\n      content: \"\"; }\n    .fmcy-plugin-bootstrap pre,\n    .fmcy-plugin-bootstrap blockquote {\n      border: 1px solid #999;\n      page-break-inside: avoid; }\n    .fmcy-plugin-bootstrap thead {\n      display: table-header-group; }\n    .fmcy-plugin-bootstrap tr,\n    .fmcy-plugin-bootstrap img {\n      page-break-inside: avoid; }\n    .fmcy-plugin-bootstrap img {\n      max-width: 100% !important; }\n    .fmcy-plugin-bootstrap p,\n    .fmcy-plugin-bootstrap h2,\n    .fmcy-plugin-bootstrap h3 {\n      orphans: 3;\n      widows: 3; }\n    .fmcy-plugin-bootstrap h2,\n    .fmcy-plugin-bootstrap h3 {\n      page-break-after: avoid; }\n    .fmcy-plugin-bootstrap .navbar {\n      display: none; }\n    .fmcy-plugin-bootstrap .btn > .caret,\n    .fmcy-plugin-bootstrap .dropup > .btn > .caret {\n      border-top-color: #000 !important; }\n    .fmcy-plugin-bootstrap .label {\n      border: 1px solid #000; }\n    .fmcy-plugin-bootstrap .table {\n      border-collapse: collapse !important; }\n      .fmcy-plugin-bootstrap .table td,\n      .fmcy-plugin-bootstrap .table th {\n        background-color: #fff !important; }\n    .fmcy-plugin-bootstrap .table-bordered th,\n    .fmcy-plugin-bootstrap .table-bordered td {\n      border: 1px solid #ddd !important; } }\n\n@font-face {\n  font-family: 'Glyphicons Halflings';\n  src: url(" + escape(__webpack_require__(166)) + ");\n  src: url(" + escape(__webpack_require__(166)) + "?#iefix) format(\"embedded-opentype\"), url(" + escape(__webpack_require__(230)) + ") format(\"woff2\"), url(" + escape(__webpack_require__(229)) + ") format(\"woff\"), url(" + escape(__webpack_require__(228)) + ") format(\"truetype\"), url(" + escape(__webpack_require__(231)) + "#glyphicons_halflingsregular) format(\"svg\"); }\n  .fmcy-plugin-bootstrap .glyphicon {\n    position: relative;\n    top: 1px;\n    display: inline-block;\n    font-family: 'Glyphicons Halflings';\n    font-style: normal;\n    font-weight: normal;\n    line-height: 1;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale; }\n  .fmcy-plugin-bootstrap .glyphicon-asterisk:before {\n    content: \"*\"; }\n  .fmcy-plugin-bootstrap .glyphicon-plus:before {\n    content: \"+\"; }\n  .fmcy-plugin-bootstrap .glyphicon-euro:before,\n  .fmcy-plugin-bootstrap .glyphicon-eur:before {\n    content: \"\\20AC\"; }\n  .fmcy-plugin-bootstrap .glyphicon-minus:before {\n    content: \"\\2212\"; }\n  .fmcy-plugin-bootstrap .glyphicon-cloud:before {\n    content: \"\\2601\"; }\n  .fmcy-plugin-bootstrap .glyphicon-envelope:before {\n    content: \"\\2709\"; }\n  .fmcy-plugin-bootstrap .glyphicon-pencil:before {\n    content: \"\\270F\"; }\n  .fmcy-plugin-bootstrap .glyphicon-glass:before {\n    content: \"\\E001\"; }\n  .fmcy-plugin-bootstrap .glyphicon-music:before {\n    content: \"\\E002\"; }\n  .fmcy-plugin-bootstrap .glyphicon-search:before {\n    content: \"\\E003\"; }\n  .fmcy-plugin-bootstrap .glyphicon-heart:before {\n    content: \"\\E005\"; }\n  .fmcy-plugin-bootstrap .glyphicon-star:before {\n    content: \"\\E006\"; }\n  .fmcy-plugin-bootstrap .glyphicon-star-empty:before {\n    content: \"\\E007\"; }\n  .fmcy-plugin-bootstrap .glyphicon-user:before {\n    content: \"\\E008\"; }\n  .fmcy-plugin-bootstrap .glyphicon-film:before {\n    content: \"\\E009\"; }\n  .fmcy-plugin-bootstrap .glyphicon-th-large:before {\n    content: \"\\E010\"; }\n  .fmcy-plugin-bootstrap .glyphicon-th:before {\n    content: \"\\E011\"; }\n  .fmcy-plugin-bootstrap .glyphicon-th-list:before {\n    content: \"\\E012\"; }\n  .fmcy-plugin-bootstrap .glyphicon-ok:before {\n    content: \"\\E013\"; }\n  .fmcy-plugin-bootstrap .glyphicon-remove:before {\n    content: \"\\E014\"; }\n  .fmcy-plugin-bootstrap .glyphicon-zoom-in:before {\n    content: \"\\E015\"; }\n  .fmcy-plugin-bootstrap .glyphicon-zoom-out:before {\n    content: \"\\E016\"; }\n  .fmcy-plugin-bootstrap .glyphicon-off:before {\n    content: \"\\E017\"; }\n  .fmcy-plugin-bootstrap .glyphicon-signal:before {\n    content: \"\\E018\"; }\n  .fmcy-plugin-bootstrap .glyphicon-cog:before {\n    content: \"\\E019\"; }\n  .fmcy-plugin-bootstrap .glyphicon-trash:before {\n    content: \"\\E020\"; }\n  .fmcy-plugin-bootstrap .glyphicon-home:before {\n    content: \"\\E021\"; }\n  .fmcy-plugin-bootstrap .glyphicon-file:before {\n    content: \"\\E022\"; }\n  .fmcy-plugin-bootstrap .glyphicon-time:before {\n    content: \"\\E023\"; }\n  .fmcy-plugin-bootstrap .glyphicon-road:before {\n    content: \"\\E024\"; }\n  .fmcy-plugin-bootstrap .glyphicon-download-alt:before {\n    content: \"\\E025\"; }\n  .fmcy-plugin-bootstrap .glyphicon-download:before {\n    content: \"\\E026\"; }\n  .fmcy-plugin-bootstrap .glyphicon-upload:before {\n    content: \"\\E027\"; }\n  .fmcy-plugin-bootstrap .glyphicon-inbox:before {\n    content: \"\\E028\"; }\n  .fmcy-plugin-bootstrap .glyphicon-play-circle:before {\n    content: \"\\E029\"; }\n  .fmcy-plugin-bootstrap .glyphicon-repeat:before {\n    content: \"\\E030\"; }\n  .fmcy-plugin-bootstrap .glyphicon-refresh:before {\n    content: \"\\E031\"; }\n  .fmcy-plugin-bootstrap .glyphicon-list-alt:before {\n    content: \"\\E032\"; }\n  .fmcy-plugin-bootstrap .glyphicon-lock:before {\n    content: \"\\E033\"; }\n  .fmcy-plugin-bootstrap .glyphicon-flag:before {\n    content: \"\\E034\"; }\n  .fmcy-plugin-bootstrap .glyphicon-headphones:before {\n    content: \"\\E035\"; }\n  .fmcy-plugin-bootstrap .glyphicon-volume-off:before {\n    content: \"\\E036\"; }\n  .fmcy-plugin-bootstrap .glyphicon-volume-down:before {\n    content: \"\\E037\"; }\n  .fmcy-plugin-bootstrap .glyphicon-volume-up:before {\n    content: \"\\E038\"; }\n  .fmcy-plugin-bootstrap .glyphicon-qrcode:before {\n    content: \"\\E039\"; }\n  .fmcy-plugin-bootstrap .glyphicon-barcode:before {\n    content: \"\\E040\"; }\n  .fmcy-plugin-bootstrap .glyphicon-tag:before {\n    content: \"\\E041\"; }\n  .fmcy-plugin-bootstrap .glyphicon-tags:before {\n    content: \"\\E042\"; }\n  .fmcy-plugin-bootstrap .glyphicon-book:before {\n    content: \"\\E043\"; }\n  .fmcy-plugin-bootstrap .glyphicon-bookmark:before {\n    content: \"\\E044\"; }\n  .fmcy-plugin-bootstrap .glyphicon-print:before {\n    content: \"\\E045\"; }\n  .fmcy-plugin-bootstrap .glyphicon-camera:before {\n    content: \"\\E046\"; }\n  .fmcy-plugin-bootstrap .glyphicon-font:before {\n    content: \"\\E047\"; }\n  .fmcy-plugin-bootstrap .glyphicon-bold:before {\n    content: \"\\E048\"; }\n  .fmcy-plugin-bootstrap .glyphicon-italic:before {\n    content: \"\\E049\"; }\n  .fmcy-plugin-bootstrap .glyphicon-text-height:before {\n    content: \"\\E050\"; }\n  .fmcy-plugin-bootstrap .glyphicon-text-width:before {\n    content: \"\\E051\"; }\n  .fmcy-plugin-bootstrap .glyphicon-align-left:before {\n    content: \"\\E052\"; }\n  .fmcy-plugin-bootstrap .glyphicon-align-center:before {\n    content: \"\\E053\"; }\n  .fmcy-plugin-bootstrap .glyphicon-align-right:before {\n    content: \"\\E054\"; }\n  .fmcy-plugin-bootstrap .glyphicon-align-justify:before {\n    content: \"\\E055\"; }\n  .fmcy-plugin-bootstrap .glyphicon-list:before {\n    content: \"\\E056\"; }\n  .fmcy-plugin-bootstrap .glyphicon-indent-left:before {\n    content: \"\\E057\"; }\n  .fmcy-plugin-bootstrap .glyphicon-indent-right:before {\n    content: \"\\E058\"; }\n  .fmcy-plugin-bootstrap .glyphicon-facetime-video:before {\n    content: \"\\E059\"; }\n  .fmcy-plugin-bootstrap .glyphicon-picture:before {\n    content: \"\\E060\"; }\n  .fmcy-plugin-bootstrap .glyphicon-map-marker:before {\n    content: \"\\E062\"; }\n  .fmcy-plugin-bootstrap .glyphicon-adjust:before {\n    content: \"\\E063\"; }\n  .fmcy-plugin-bootstrap .glyphicon-tint:before {\n    content: \"\\E064\"; }\n  .fmcy-plugin-bootstrap .glyphicon-edit:before {\n    content: \"\\E065\"; }\n  .fmcy-plugin-bootstrap .glyphicon-share:before {\n    content: \"\\E066\"; }\n  .fmcy-plugin-bootstrap .glyphicon-check:before {\n    content: \"\\E067\"; }\n  .fmcy-plugin-bootstrap .glyphicon-move:before {\n    content: \"\\E068\"; }\n  .fmcy-plugin-bootstrap .glyphicon-step-backward:before {\n    content: \"\\E069\"; }\n  .fmcy-plugin-bootstrap .glyphicon-fast-backward:before {\n    content: \"\\E070\"; }\n  .fmcy-plugin-bootstrap .glyphicon-backward:before {\n    content: \"\\E071\"; }\n  .fmcy-plugin-bootstrap .glyphicon-play:before {\n    content: \"\\E072\"; }\n  .fmcy-plugin-bootstrap .glyphicon-pause:before {\n    content: \"\\E073\"; }\n  .fmcy-plugin-bootstrap .glyphicon-stop:before {\n    content: \"\\E074\"; }\n  .fmcy-plugin-bootstrap .glyphicon-forward:before {\n    content: \"\\E075\"; }\n  .fmcy-plugin-bootstrap .glyphicon-fast-forward:before {\n    content: \"\\E076\"; }\n  .fmcy-plugin-bootstrap .glyphicon-step-forward:before {\n    content: \"\\E077\"; }\n  .fmcy-plugin-bootstrap .glyphicon-eject:before {\n    content: \"\\E078\"; }\n  .fmcy-plugin-bootstrap .glyphicon-chevron-left:before {\n    content: \"\\E079\"; }\n  .fmcy-plugin-bootstrap .glyphicon-chevron-right:before {\n    content: \"\\E080\"; }\n  .fmcy-plugin-bootstrap .glyphicon-plus-sign:before {\n    content: \"\\E081\"; }\n  .fmcy-plugin-bootstrap .glyphicon-minus-sign:before {\n    content: \"\\E082\"; }\n  .fmcy-plugin-bootstrap .glyphicon-remove-sign:before {\n    content: \"\\E083\"; }\n  .fmcy-plugin-bootstrap .glyphicon-ok-sign:before {\n    content: \"\\E084\"; }\n  .fmcy-plugin-bootstrap .glyphicon-question-sign:before {\n    content: \"\\E085\"; }\n  .fmcy-plugin-bootstrap .glyphicon-info-sign:before {\n    content: \"\\E086\"; }\n  .fmcy-plugin-bootstrap .glyphicon-screenshot:before {\n    content: \"\\E087\"; }\n  .fmcy-plugin-bootstrap .glyphicon-remove-circle:before {\n    content: \"\\E088\"; }\n  .fmcy-plugin-bootstrap .glyphicon-ok-circle:before {\n    content: \"\\E089\"; }\n  .fmcy-plugin-bootstrap .glyphicon-ban-circle:before {\n    content: \"\\E090\"; }\n  .fmcy-plugin-bootstrap .glyphicon-arrow-left:before {\n    content: \"\\E091\"; }\n  .fmcy-plugin-bootstrap .glyphicon-arrow-right:before {\n    content: \"\\E092\"; }\n  .fmcy-plugin-bootstrap .glyphicon-arrow-up:before {\n    content: \"\\E093\"; }\n  .fmcy-plugin-bootstrap .glyphicon-arrow-down:before {\n    content: \"\\E094\"; }\n  .fmcy-plugin-bootstrap .glyphicon-share-alt:before {\n    content: \"\\E095\"; }\n  .fmcy-plugin-bootstrap .glyphicon-resize-full:before {\n    content: \"\\E096\"; }\n  .fmcy-plugin-bootstrap .glyphicon-resize-small:before {\n    content: \"\\E097\"; }\n  .fmcy-plugin-bootstrap .glyphicon-exclamation-sign:before {\n    content: \"\\E101\"; }\n  .fmcy-plugin-bootstrap .glyphicon-gift:before {\n    content: \"\\E102\"; }\n  .fmcy-plugin-bootstrap .glyphicon-leaf:before {\n    content: \"\\E103\"; }\n  .fmcy-plugin-bootstrap .glyphicon-fire:before {\n    content: \"\\E104\"; }\n  .fmcy-plugin-bootstrap .glyphicon-eye-open:before {\n    content: \"\\E105\"; }\n  .fmcy-plugin-bootstrap .glyphicon-eye-close:before {\n    content: \"\\E106\"; }\n  .fmcy-plugin-bootstrap .glyphicon-warning-sign:before {\n    content: \"\\E107\"; }\n  .fmcy-plugin-bootstrap .glyphicon-plane:before {\n    content: \"\\E108\"; }\n  .fmcy-plugin-bootstrap .glyphicon-calendar:before {\n    content: \"\\E109\"; }\n  .fmcy-plugin-bootstrap .glyphicon-random:before {\n    content: \"\\E110\"; }\n  .fmcy-plugin-bootstrap .glyphicon-comment:before {\n    content: \"\\E111\"; }\n  .fmcy-plugin-bootstrap .glyphicon-magnet:before {\n    content: \"\\E112\"; }\n  .fmcy-plugin-bootstrap .glyphicon-chevron-up:before {\n    content: \"\\E113\"; }\n  .fmcy-plugin-bootstrap .glyphicon-chevron-down:before {\n    content: \"\\E114\"; }\n  .fmcy-plugin-bootstrap .glyphicon-retweet:before {\n    content: \"\\E115\"; }\n  .fmcy-plugin-bootstrap .glyphicon-shopping-cart:before {\n    content: \"\\E116\"; }\n  .fmcy-plugin-bootstrap .glyphicon-folder-close:before {\n    content: \"\\E117\"; }\n  .fmcy-plugin-bootstrap .glyphicon-folder-open:before {\n    content: \"\\E118\"; }\n  .fmcy-plugin-bootstrap .glyphicon-resize-vertical:before {\n    content: \"\\E119\"; }\n  .fmcy-plugin-bootstrap .glyphicon-resize-horizontal:before {\n    content: \"\\E120\"; }\n  .fmcy-plugin-bootstrap .glyphicon-hdd:before {\n    content: \"\\E121\"; }\n  .fmcy-plugin-bootstrap .glyphicon-bullhorn:before {\n    content: \"\\E122\"; }\n  .fmcy-plugin-bootstrap .glyphicon-bell:before {\n    content: \"\\E123\"; }\n  .fmcy-plugin-bootstrap .glyphicon-certificate:before {\n    content: \"\\E124\"; }\n  .fmcy-plugin-bootstrap .glyphicon-thumbs-up:before {\n    content: \"\\E125\"; }\n  .fmcy-plugin-bootstrap .glyphicon-thumbs-down:before {\n    content: \"\\E126\"; }\n  .fmcy-plugin-bootstrap .glyphicon-hand-right:before {\n    content: \"\\E127\"; }\n  .fmcy-plugin-bootstrap .glyphicon-hand-left:before {\n    content: \"\\E128\"; }\n  .fmcy-plugin-bootstrap .glyphicon-hand-up:before {\n    content: \"\\E129\"; }\n  .fmcy-plugin-bootstrap .glyphicon-hand-down:before {\n    content: \"\\E130\"; }\n  .fmcy-plugin-bootstrap .glyphicon-circle-arrow-right:before {\n    content: \"\\E131\"; }\n  .fmcy-plugin-bootstrap .glyphicon-circle-arrow-left:before {\n    content: \"\\E132\"; }\n  .fmcy-plugin-bootstrap .glyphicon-circle-arrow-up:before {\n    content: \"\\E133\"; }\n  .fmcy-plugin-bootstrap .glyphicon-circle-arrow-down:before {\n    content: \"\\E134\"; }\n  .fmcy-plugin-bootstrap .glyphicon-globe:before {\n    content: \"\\E135\"; }\n  .fmcy-plugin-bootstrap .glyphicon-wrench:before {\n    content: \"\\E136\"; }\n  .fmcy-plugin-bootstrap .glyphicon-tasks:before {\n    content: \"\\E137\"; }\n  .fmcy-plugin-bootstrap .glyphicon-filter:before {\n    content: \"\\E138\"; }\n  .fmcy-plugin-bootstrap .glyphicon-briefcase:before {\n    content: \"\\E139\"; }\n  .fmcy-plugin-bootstrap .glyphicon-fullscreen:before {\n    content: \"\\E140\"; }\n  .fmcy-plugin-bootstrap .glyphicon-dashboard:before {\n    content: \"\\E141\"; }\n  .fmcy-plugin-bootstrap .glyphicon-paperclip:before {\n    content: \"\\E142\"; }\n  .fmcy-plugin-bootstrap .glyphicon-heart-empty:before {\n    content: \"\\E143\"; }\n  .fmcy-plugin-bootstrap .glyphicon-link:before {\n    content: \"\\E144\"; }\n  .fmcy-plugin-bootstrap .glyphicon-phone:before {\n    content: \"\\E145\"; }\n  .fmcy-plugin-bootstrap .glyphicon-pushpin:before {\n    content: \"\\E146\"; }\n  .fmcy-plugin-bootstrap .glyphicon-usd:before {\n    content: \"\\E148\"; }\n  .fmcy-plugin-bootstrap .glyphicon-gbp:before {\n    content: \"\\E149\"; }\n  .fmcy-plugin-bootstrap .glyphicon-sort:before {\n    content: \"\\E150\"; }\n  .fmcy-plugin-bootstrap .glyphicon-sort-by-alphabet:before {\n    content: \"\\E151\"; }\n  .fmcy-plugin-bootstrap .glyphicon-sort-by-alphabet-alt:before {\n    content: \"\\E152\"; }\n  .fmcy-plugin-bootstrap .glyphicon-sort-by-order:before {\n    content: \"\\E153\"; }\n  .fmcy-plugin-bootstrap .glyphicon-sort-by-order-alt:before {\n    content: \"\\E154\"; }\n  .fmcy-plugin-bootstrap .glyphicon-sort-by-attributes:before {\n    content: \"\\E155\"; }\n  .fmcy-plugin-bootstrap .glyphicon-sort-by-attributes-alt:before {\n    content: \"\\E156\"; }\n  .fmcy-plugin-bootstrap .glyphicon-unchecked:before {\n    content: \"\\E157\"; }\n  .fmcy-plugin-bootstrap .glyphicon-expand:before {\n    content: \"\\E158\"; }\n  .fmcy-plugin-bootstrap .glyphicon-collapse-down:before {\n    content: \"\\E159\"; }\n  .fmcy-plugin-bootstrap .glyphicon-collapse-up:before {\n    content: \"\\E160\"; }\n  .fmcy-plugin-bootstrap .glyphicon-log-in:before {\n    content: \"\\E161\"; }\n  .fmcy-plugin-bootstrap .glyphicon-flash:before {\n    content: \"\\E162\"; }\n  .fmcy-plugin-bootstrap .glyphicon-log-out:before {\n    content: \"\\E163\"; }\n  .fmcy-plugin-bootstrap .glyphicon-new-window:before {\n    content: \"\\E164\"; }\n  .fmcy-plugin-bootstrap .glyphicon-record:before {\n    content: \"\\E165\"; }\n  .fmcy-plugin-bootstrap .glyphicon-save:before {\n    content: \"\\E166\"; }\n  .fmcy-plugin-bootstrap .glyphicon-open:before {\n    content: \"\\E167\"; }\n  .fmcy-plugin-bootstrap .glyphicon-saved:before {\n    content: \"\\E168\"; }\n  .fmcy-plugin-bootstrap .glyphicon-import:before {\n    content: \"\\E169\"; }\n  .fmcy-plugin-bootstrap .glyphicon-export:before {\n    content: \"\\E170\"; }\n  .fmcy-plugin-bootstrap .glyphicon-send:before {\n    content: \"\\E171\"; }\n  .fmcy-plugin-bootstrap .glyphicon-floppy-disk:before {\n    content: \"\\E172\"; }\n  .fmcy-plugin-bootstrap .glyphicon-floppy-saved:before {\n    content: \"\\E173\"; }\n  .fmcy-plugin-bootstrap .glyphicon-floppy-remove:before {\n    content: \"\\E174\"; }\n  .fmcy-plugin-bootstrap .glyphicon-floppy-save:before {\n    content: \"\\E175\"; }\n  .fmcy-plugin-bootstrap .glyphicon-floppy-open:before {\n    content: \"\\E176\"; }\n  .fmcy-plugin-bootstrap .glyphicon-credit-card:before {\n    content: \"\\E177\"; }\n  .fmcy-plugin-bootstrap .glyphicon-transfer:before {\n    content: \"\\E178\"; }\n  .fmcy-plugin-bootstrap .glyphicon-cutlery:before {\n    content: \"\\E179\"; }\n  .fmcy-plugin-bootstrap .glyphicon-header:before {\n    content: \"\\E180\"; }\n  .fmcy-plugin-bootstrap .glyphicon-compressed:before {\n    content: \"\\E181\"; }\n  .fmcy-plugin-bootstrap .glyphicon-earphone:before {\n    content: \"\\E182\"; }\n  .fmcy-plugin-bootstrap .glyphicon-phone-alt:before {\n    content: \"\\E183\"; }\n  .fmcy-plugin-bootstrap .glyphicon-tower:before {\n    content: \"\\E184\"; }\n  .fmcy-plugin-bootstrap .glyphicon-stats:before {\n    content: \"\\E185\"; }\n  .fmcy-plugin-bootstrap .glyphicon-sd-video:before {\n    content: \"\\E186\"; }\n  .fmcy-plugin-bootstrap .glyphicon-hd-video:before {\n    content: \"\\E187\"; }\n  .fmcy-plugin-bootstrap .glyphicon-subtitles:before {\n    content: \"\\E188\"; }\n  .fmcy-plugin-bootstrap .glyphicon-sound-stereo:before {\n    content: \"\\E189\"; }\n  .fmcy-plugin-bootstrap .glyphicon-sound-dolby:before {\n    content: \"\\E190\"; }\n  .fmcy-plugin-bootstrap .glyphicon-sound-5-1:before {\n    content: \"\\E191\"; }\n  .fmcy-plugin-bootstrap .glyphicon-sound-6-1:before {\n    content: \"\\E192\"; }\n  .fmcy-plugin-bootstrap .glyphicon-sound-7-1:before {\n    content: \"\\E193\"; }\n  .fmcy-plugin-bootstrap .glyphicon-copyright-mark:before {\n    content: \"\\E194\"; }\n  .fmcy-plugin-bootstrap .glyphicon-registration-mark:before {\n    content: \"\\E195\"; }\n  .fmcy-plugin-bootstrap .glyphicon-cloud-download:before {\n    content: \"\\E197\"; }\n  .fmcy-plugin-bootstrap .glyphicon-cloud-upload:before {\n    content: \"\\E198\"; }\n  .fmcy-plugin-bootstrap .glyphicon-tree-conifer:before {\n    content: \"\\E199\"; }\n  .fmcy-plugin-bootstrap .glyphicon-tree-deciduous:before {\n    content: \"\\E200\"; }\n  .fmcy-plugin-bootstrap .glyphicon-cd:before {\n    content: \"\\E201\"; }\n  .fmcy-plugin-bootstrap .glyphicon-save-file:before {\n    content: \"\\E202\"; }\n  .fmcy-plugin-bootstrap .glyphicon-open-file:before {\n    content: \"\\E203\"; }\n  .fmcy-plugin-bootstrap .glyphicon-level-up:before {\n    content: \"\\E204\"; }\n  .fmcy-plugin-bootstrap .glyphicon-copy:before {\n    content: \"\\E205\"; }\n  .fmcy-plugin-bootstrap .glyphicon-paste:before {\n    content: \"\\E206\"; }\n  .fmcy-plugin-bootstrap .glyphicon-alert:before {\n    content: \"\\E209\"; }\n  .fmcy-plugin-bootstrap .glyphicon-equalizer:before {\n    content: \"\\E210\"; }\n  .fmcy-plugin-bootstrap .glyphicon-king:before {\n    content: \"\\E211\"; }\n  .fmcy-plugin-bootstrap .glyphicon-queen:before {\n    content: \"\\E212\"; }\n  .fmcy-plugin-bootstrap .glyphicon-pawn:before {\n    content: \"\\E213\"; }\n  .fmcy-plugin-bootstrap .glyphicon-bishop:before {\n    content: \"\\E214\"; }\n  .fmcy-plugin-bootstrap .glyphicon-knight:before {\n    content: \"\\E215\"; }\n  .fmcy-plugin-bootstrap .glyphicon-baby-formula:before {\n    content: \"\\E216\"; }\n  .fmcy-plugin-bootstrap .glyphicon-tent:before {\n    content: \"\\26FA\"; }\n  .fmcy-plugin-bootstrap .glyphicon-blackboard:before {\n    content: \"\\E218\"; }\n  .fmcy-plugin-bootstrap .glyphicon-bed:before {\n    content: \"\\E219\"; }\n  .fmcy-plugin-bootstrap .glyphicon-apple:before {\n    content: \"\\F8FF\"; }\n  .fmcy-plugin-bootstrap .glyphicon-erase:before {\n    content: \"\\E221\"; }\n  .fmcy-plugin-bootstrap .glyphicon-hourglass:before {\n    content: \"\\231B\"; }\n  .fmcy-plugin-bootstrap .glyphicon-lamp:before {\n    content: \"\\E223\"; }\n  .fmcy-plugin-bootstrap .glyphicon-duplicate:before {\n    content: \"\\E224\"; }\n  .fmcy-plugin-bootstrap .glyphicon-piggy-bank:before {\n    content: \"\\E225\"; }\n  .fmcy-plugin-bootstrap .glyphicon-scissors:before {\n    content: \"\\E226\"; }\n  .fmcy-plugin-bootstrap .glyphicon-bitcoin:before {\n    content: \"\\E227\"; }\n  .fmcy-plugin-bootstrap .glyphicon-btc:before {\n    content: \"\\E227\"; }\n  .fmcy-plugin-bootstrap .glyphicon-xbt:before {\n    content: \"\\E227\"; }\n  .fmcy-plugin-bootstrap .glyphicon-yen:before {\n    content: \"\\A5\"; }\n  .fmcy-plugin-bootstrap .glyphicon-jpy:before {\n    content: \"\\A5\"; }\n  .fmcy-plugin-bootstrap .glyphicon-ruble:before {\n    content: \"\\20BD\"; }\n  .fmcy-plugin-bootstrap .glyphicon-rub:before {\n    content: \"\\20BD\"; }\n  .fmcy-plugin-bootstrap .glyphicon-scale:before {\n    content: \"\\E230\"; }\n  .fmcy-plugin-bootstrap .glyphicon-ice-lolly:before {\n    content: \"\\E231\"; }\n  .fmcy-plugin-bootstrap .glyphicon-ice-lolly-tasted:before {\n    content: \"\\E232\"; }\n  .fmcy-plugin-bootstrap .glyphicon-education:before {\n    content: \"\\E233\"; }\n  .fmcy-plugin-bootstrap .glyphicon-option-horizontal:before {\n    content: \"\\E234\"; }\n  .fmcy-plugin-bootstrap .glyphicon-option-vertical:before {\n    content: \"\\E235\"; }\n  .fmcy-plugin-bootstrap .glyphicon-menu-hamburger:before {\n    content: \"\\E236\"; }\n  .fmcy-plugin-bootstrap .glyphicon-modal-window:before {\n    content: \"\\E237\"; }\n  .fmcy-plugin-bootstrap .glyphicon-oil:before {\n    content: \"\\E238\"; }\n  .fmcy-plugin-bootstrap .glyphicon-grain:before {\n    content: \"\\E239\"; }\n  .fmcy-plugin-bootstrap .glyphicon-sunglasses:before {\n    content: \"\\E240\"; }\n  .fmcy-plugin-bootstrap .glyphicon-text-size:before {\n    content: \"\\E241\"; }\n  .fmcy-plugin-bootstrap .glyphicon-text-color:before {\n    content: \"\\E242\"; }\n  .fmcy-plugin-bootstrap .glyphicon-text-background:before {\n    content: \"\\E243\"; }\n  .fmcy-plugin-bootstrap .glyphicon-object-align-top:before {\n    content: \"\\E244\"; }\n  .fmcy-plugin-bootstrap .glyphicon-object-align-bottom:before {\n    content: \"\\E245\"; }\n  .fmcy-plugin-bootstrap .glyphicon-object-align-horizontal:before {\n    content: \"\\E246\"; }\n  .fmcy-plugin-bootstrap .glyphicon-object-align-left:before {\n    content: \"\\E247\"; }\n  .fmcy-plugin-bootstrap .glyphicon-object-align-vertical:before {\n    content: \"\\E248\"; }\n  .fmcy-plugin-bootstrap .glyphicon-object-align-right:before {\n    content: \"\\E249\"; }\n  .fmcy-plugin-bootstrap .glyphicon-triangle-right:before {\n    content: \"\\E250\"; }\n  .fmcy-plugin-bootstrap .glyphicon-triangle-left:before {\n    content: \"\\E251\"; }\n  .fmcy-plugin-bootstrap .glyphicon-triangle-bottom:before {\n    content: \"\\E252\"; }\n  .fmcy-plugin-bootstrap .glyphicon-triangle-top:before {\n    content: \"\\E253\"; }\n  .fmcy-plugin-bootstrap .glyphicon-console:before {\n    content: \"\\E254\"; }\n  .fmcy-plugin-bootstrap .glyphicon-superscript:before {\n    content: \"\\E255\"; }\n  .fmcy-plugin-bootstrap .glyphicon-subscript:before {\n    content: \"\\E256\"; }\n  .fmcy-plugin-bootstrap .glyphicon-menu-left:before {\n    content: \"\\E257\"; }\n  .fmcy-plugin-bootstrap .glyphicon-menu-right:before {\n    content: \"\\E258\"; }\n  .fmcy-plugin-bootstrap .glyphicon-menu-down:before {\n    content: \"\\E259\"; }\n  .fmcy-plugin-bootstrap .glyphicon-menu-up:before {\n    content: \"\\E260\"; }\n  .fmcy-plugin-bootstrap * {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box; }\n  .fmcy-plugin-bootstrap *:before,\n  .fmcy-plugin-bootstrap *:after {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box; }\n  .fmcy-plugin-bootstrap html {\n    font-size: 10px;\n    -webkit-tap-highlight-color: transparent; }\n  .fmcy-plugin-bootstrap body {\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    font-size: 14px;\n    line-height: 1.42857;\n    color: #333333;\n    background-color: #fff; }\n  .fmcy-plugin-bootstrap input,\n  .fmcy-plugin-bootstrap button,\n  .fmcy-plugin-bootstrap select,\n  .fmcy-plugin-bootstrap textarea {\n    font-family: inherit;\n    font-size: inherit;\n    line-height: inherit; }\n  .fmcy-plugin-bootstrap a {\n    color: #337ab7;\n    text-decoration: none; }\n    .fmcy-plugin-bootstrap a:hover, .fmcy-plugin-bootstrap a:focus {\n      color: #23527c;\n      text-decoration: underline; }\n    .fmcy-plugin-bootstrap a:focus {\n      outline: 5px auto -webkit-focus-ring-color;\n      outline-offset: -2px; }\n  .fmcy-plugin-bootstrap figure {\n    margin: 0; }\n  .fmcy-plugin-bootstrap img {\n    vertical-align: middle; }\n  .fmcy-plugin-bootstrap .img-responsive {\n    display: block;\n    max-width: 100%;\n    height: auto; }\n  .fmcy-plugin-bootstrap .img-rounded {\n    border-radius: 6px; }\n  .fmcy-plugin-bootstrap .img-thumbnail {\n    padding: 4px;\n    line-height: 1.42857;\n    background-color: #fff;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    -webkit-transition: all 0.2s ease-in-out;\n    -o-transition: all 0.2s ease-in-out;\n    transition: all 0.2s ease-in-out;\n    display: inline-block;\n    max-width: 100%;\n    height: auto; }\n  .fmcy-plugin-bootstrap .img-circle {\n    border-radius: 50%; }\n  .fmcy-plugin-bootstrap hr {\n    margin-top: 20px;\n    margin-bottom: 20px;\n    border: 0;\n    border-top: 1px solid #eeeeee; }\n  .fmcy-plugin-bootstrap .sr-only, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"incrementHours\"]::after, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"incrementMinutes\"]::after, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"decrementHours\"]::after, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"decrementMinutes\"]::after, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"showHours\"]::after, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"showMinutes\"]::after, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"togglePeriod\"]::after, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"clear\"]::after, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"today\"]::after, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .picker-switch::after, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table th.prev::after, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table th.next::after {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    margin: -1px;\n    padding: 0;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    border: 0; }\n  .fmcy-plugin-bootstrap .sr-only-focusable:active, .fmcy-plugin-bootstrap .sr-only-focusable:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    margin: 0;\n    overflow: visible;\n    clip: auto; }\n  .fmcy-plugin-bootstrap [role=\"button\"] {\n    cursor: pointer; }\n  .fmcy-plugin-bootstrap h1, .fmcy-plugin-bootstrap h2, .fmcy-plugin-bootstrap h3, .fmcy-plugin-bootstrap h4, .fmcy-plugin-bootstrap h5, .fmcy-plugin-bootstrap h6,\n  .fmcy-plugin-bootstrap .h1, .fmcy-plugin-bootstrap .h2, .fmcy-plugin-bootstrap .h3, .fmcy-plugin-bootstrap .h4, .fmcy-plugin-bootstrap .h5, .fmcy-plugin-bootstrap .h6 {\n    font-family: inherit;\n    font-weight: 500;\n    line-height: 1.1;\n    color: inherit; }\n    .fmcy-plugin-bootstrap h1 small,\n    .fmcy-plugin-bootstrap h1 .small, .fmcy-plugin-bootstrap h2 small,\n    .fmcy-plugin-bootstrap h2 .small, .fmcy-plugin-bootstrap h3 small,\n    .fmcy-plugin-bootstrap h3 .small, .fmcy-plugin-bootstrap h4 small,\n    .fmcy-plugin-bootstrap h4 .small, .fmcy-plugin-bootstrap h5 small,\n    .fmcy-plugin-bootstrap h5 .small, .fmcy-plugin-bootstrap h6 small,\n    .fmcy-plugin-bootstrap h6 .small,\n    .fmcy-plugin-bootstrap .h1 small,\n    .fmcy-plugin-bootstrap .h1 .small, .fmcy-plugin-bootstrap .h2 small,\n    .fmcy-plugin-bootstrap .h2 .small, .fmcy-plugin-bootstrap .h3 small,\n    .fmcy-plugin-bootstrap .h3 .small, .fmcy-plugin-bootstrap .h4 small,\n    .fmcy-plugin-bootstrap .h4 .small, .fmcy-plugin-bootstrap .h5 small,\n    .fmcy-plugin-bootstrap .h5 .small, .fmcy-plugin-bootstrap .h6 small,\n    .fmcy-plugin-bootstrap .h6 .small {\n      font-weight: normal;\n      line-height: 1;\n      color: #777777; }\n  .fmcy-plugin-bootstrap h1, .fmcy-plugin-bootstrap .h1,\n  .fmcy-plugin-bootstrap h2, .fmcy-plugin-bootstrap .h2,\n  .fmcy-plugin-bootstrap h3, .fmcy-plugin-bootstrap .h3 {\n    margin-top: 20px;\n    margin-bottom: 10px; }\n    .fmcy-plugin-bootstrap h1 small,\n    .fmcy-plugin-bootstrap h1 .small, .fmcy-plugin-bootstrap .h1 small,\n    .fmcy-plugin-bootstrap .h1 .small,\n    .fmcy-plugin-bootstrap h2 small,\n    .fmcy-plugin-bootstrap h2 .small, .fmcy-plugin-bootstrap .h2 small,\n    .fmcy-plugin-bootstrap .h2 .small,\n    .fmcy-plugin-bootstrap h3 small,\n    .fmcy-plugin-bootstrap h3 .small, .fmcy-plugin-bootstrap .h3 small,\n    .fmcy-plugin-bootstrap .h3 .small {\n      font-size: 65%; }\n  .fmcy-plugin-bootstrap h4, .fmcy-plugin-bootstrap .h4,\n  .fmcy-plugin-bootstrap h5, .fmcy-plugin-bootstrap .h5,\n  .fmcy-plugin-bootstrap h6, .fmcy-plugin-bootstrap .h6 {\n    margin-top: 10px;\n    margin-bottom: 10px; }\n    .fmcy-plugin-bootstrap h4 small,\n    .fmcy-plugin-bootstrap h4 .small, .fmcy-plugin-bootstrap .h4 small,\n    .fmcy-plugin-bootstrap .h4 .small,\n    .fmcy-plugin-bootstrap h5 small,\n    .fmcy-plugin-bootstrap h5 .small, .fmcy-plugin-bootstrap .h5 small,\n    .fmcy-plugin-bootstrap .h5 .small,\n    .fmcy-plugin-bootstrap h6 small,\n    .fmcy-plugin-bootstrap h6 .small, .fmcy-plugin-bootstrap .h6 small,\n    .fmcy-plugin-bootstrap .h6 .small {\n      font-size: 75%; }\n  .fmcy-plugin-bootstrap h1, .fmcy-plugin-bootstrap .h1 {\n    font-size: 36px; }\n  .fmcy-plugin-bootstrap h2, .fmcy-plugin-bootstrap .h2 {\n    font-size: 30px; }\n  .fmcy-plugin-bootstrap h3, .fmcy-plugin-bootstrap .h3 {\n    font-size: 24px; }\n  .fmcy-plugin-bootstrap h4, .fmcy-plugin-bootstrap .h4 {\n    font-size: 18px; }\n  .fmcy-plugin-bootstrap h5, .fmcy-plugin-bootstrap .h5 {\n    font-size: 14px; }\n  .fmcy-plugin-bootstrap h6, .fmcy-plugin-bootstrap .h6 {\n    font-size: 12px; }\n  .fmcy-plugin-bootstrap p {\n    margin: 0 0 10px; }\n  .fmcy-plugin-bootstrap .lead {\n    margin-bottom: 20px;\n    font-size: 16px;\n    font-weight: 300;\n    line-height: 1.4; }\n    @media (min-width: 768px) {\n      .fmcy-plugin-bootstrap .lead {\n        font-size: 21px; } }\n  .fmcy-plugin-bootstrap small,\n  .fmcy-plugin-bootstrap .small {\n    font-size: 85%; }\n  .fmcy-plugin-bootstrap mark,\n  .fmcy-plugin-bootstrap .mark {\n    background-color: #fcf8e3;\n    padding: .2em; }\n  .fmcy-plugin-bootstrap .text-left {\n    text-align: left; }\n  .fmcy-plugin-bootstrap .text-right {\n    text-align: right; }\n  .fmcy-plugin-bootstrap .text-center {\n    text-align: center; }\n  .fmcy-plugin-bootstrap .text-justify {\n    text-align: justify; }\n  .fmcy-plugin-bootstrap .text-nowrap {\n    white-space: nowrap; }\n  .fmcy-plugin-bootstrap .text-lowercase {\n    text-transform: lowercase; }\n  .fmcy-plugin-bootstrap .text-uppercase, .fmcy-plugin-bootstrap .initialism {\n    text-transform: uppercase; }\n  .fmcy-plugin-bootstrap .text-capitalize {\n    text-transform: capitalize; }\n  .fmcy-plugin-bootstrap .text-muted {\n    color: #777777; }\n  .fmcy-plugin-bootstrap .text-primary {\n    color: #337ab7; }\n  .fmcy-plugin-bootstrap a.text-primary:hover,\n  .fmcy-plugin-bootstrap a.text-primary:focus {\n    color: #286090; }\n  .fmcy-plugin-bootstrap .text-success {\n    color: #3c763d; }\n  .fmcy-plugin-bootstrap a.text-success:hover,\n  .fmcy-plugin-bootstrap a.text-success:focus {\n    color: #2b542c; }\n  .fmcy-plugin-bootstrap .text-info {\n    color: #31708f; }\n  .fmcy-plugin-bootstrap a.text-info:hover,\n  .fmcy-plugin-bootstrap a.text-info:focus {\n    color: #245269; }\n  .fmcy-plugin-bootstrap .text-warning {\n    color: #8a6d3b; }\n  .fmcy-plugin-bootstrap a.text-warning:hover,\n  .fmcy-plugin-bootstrap a.text-warning:focus {\n    color: #66512c; }\n  .fmcy-plugin-bootstrap .text-danger {\n    color: #a94442; }\n  .fmcy-plugin-bootstrap a.text-danger:hover,\n  .fmcy-plugin-bootstrap a.text-danger:focus {\n    color: #843534; }\n  .fmcy-plugin-bootstrap .bg-primary {\n    color: #fff; }\n  .fmcy-plugin-bootstrap .bg-primary {\n    background-color: #337ab7; }\n  .fmcy-plugin-bootstrap a.bg-primary:hover,\n  .fmcy-plugin-bootstrap a.bg-primary:focus {\n    background-color: #286090; }\n  .fmcy-plugin-bootstrap .bg-success {\n    background-color: #dff0d8; }\n  .fmcy-plugin-bootstrap a.bg-success:hover,\n  .fmcy-plugin-bootstrap a.bg-success:focus {\n    background-color: #c1e2b3; }\n  .fmcy-plugin-bootstrap .bg-info {\n    background-color: #d9edf7; }\n  .fmcy-plugin-bootstrap a.bg-info:hover,\n  .fmcy-plugin-bootstrap a.bg-info:focus {\n    background-color: #afd9ee; }\n  .fmcy-plugin-bootstrap .bg-warning {\n    background-color: #fcf8e3; }\n  .fmcy-plugin-bootstrap a.bg-warning:hover,\n  .fmcy-plugin-bootstrap a.bg-warning:focus {\n    background-color: #f7ecb5; }\n  .fmcy-plugin-bootstrap .bg-danger {\n    background-color: #f2dede; }\n  .fmcy-plugin-bootstrap a.bg-danger:hover,\n  .fmcy-plugin-bootstrap a.bg-danger:focus {\n    background-color: #e4b9b9; }\n  .fmcy-plugin-bootstrap .page-header {\n    padding-bottom: 9px;\n    margin: 40px 0 20px;\n    border-bottom: 1px solid #eeeeee; }\n  .fmcy-plugin-bootstrap ul,\n  .fmcy-plugin-bootstrap ol {\n    margin-top: 0;\n    margin-bottom: 10px; }\n    .fmcy-plugin-bootstrap ul ul,\n    .fmcy-plugin-bootstrap ul ol,\n    .fmcy-plugin-bootstrap ol ul,\n    .fmcy-plugin-bootstrap ol ol {\n      margin-bottom: 0; }\n  .fmcy-plugin-bootstrap .list-unstyled {\n    padding-left: 0;\n    list-style: none; }\n  .fmcy-plugin-bootstrap .list-inline {\n    padding-left: 0;\n    list-style: none;\n    margin-left: -5px; }\n    .fmcy-plugin-bootstrap .list-inline > li {\n      display: inline-block;\n      padding-left: 5px;\n      padding-right: 5px; }\n  .fmcy-plugin-bootstrap dl {\n    margin-top: 0;\n    margin-bottom: 20px; }\n  .fmcy-plugin-bootstrap dt,\n  .fmcy-plugin-bootstrap dd {\n    line-height: 1.42857; }\n  .fmcy-plugin-bootstrap dt {\n    font-weight: bold; }\n  .fmcy-plugin-bootstrap dd {\n    margin-left: 0; }\n  .fmcy-plugin-bootstrap .dl-horizontal dd:before, .fmcy-plugin-bootstrap .dl-horizontal dd:after {\n    content: \" \";\n    display: table; }\n  .fmcy-plugin-bootstrap .dl-horizontal dd:after {\n    clear: both; }\n  @media (min-width: 768px) {\n    .fmcy-plugin-bootstrap .dl-horizontal dt {\n      float: left;\n      width: 160px;\n      clear: left;\n      text-align: right;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap; }\n    .fmcy-plugin-bootstrap .dl-horizontal dd {\n      margin-left: 180px; } }\n  .fmcy-plugin-bootstrap abbr[title],\n  .fmcy-plugin-bootstrap abbr[data-original-title] {\n    cursor: help;\n    border-bottom: 1px dotted #777777; }\n  .fmcy-plugin-bootstrap .initialism {\n    font-size: 90%; }\n  .fmcy-plugin-bootstrap blockquote {\n    padding: 10px 20px;\n    margin: 0 0 20px;\n    font-size: 17.5px;\n    border-left: 5px solid #eeeeee; }\n    .fmcy-plugin-bootstrap blockquote p:last-child,\n    .fmcy-plugin-bootstrap blockquote ul:last-child,\n    .fmcy-plugin-bootstrap blockquote ol:last-child {\n      margin-bottom: 0; }\n    .fmcy-plugin-bootstrap blockquote footer,\n    .fmcy-plugin-bootstrap blockquote small,\n    .fmcy-plugin-bootstrap blockquote .small {\n      display: block;\n      font-size: 80%;\n      line-height: 1.42857;\n      color: #777777; }\n      .fmcy-plugin-bootstrap blockquote footer:before,\n      .fmcy-plugin-bootstrap blockquote small:before,\n      .fmcy-plugin-bootstrap blockquote .small:before {\n        content: '\\2014   \\A0'; }\n  .fmcy-plugin-bootstrap .blockquote-reverse,\n  .fmcy-plugin-bootstrap blockquote.pull-right {\n    padding-right: 15px;\n    padding-left: 0;\n    border-right: 5px solid #eeeeee;\n    border-left: 0;\n    text-align: right; }\n    .fmcy-plugin-bootstrap .blockquote-reverse footer:before,\n    .fmcy-plugin-bootstrap .blockquote-reverse small:before,\n    .fmcy-plugin-bootstrap .blockquote-reverse .small:before,\n    .fmcy-plugin-bootstrap blockquote.pull-right footer:before,\n    .fmcy-plugin-bootstrap blockquote.pull-right small:before,\n    .fmcy-plugin-bootstrap blockquote.pull-right .small:before {\n      content: ''; }\n    .fmcy-plugin-bootstrap .blockquote-reverse footer:after,\n    .fmcy-plugin-bootstrap .blockquote-reverse small:after,\n    .fmcy-plugin-bootstrap .blockquote-reverse .small:after,\n    .fmcy-plugin-bootstrap blockquote.pull-right footer:after,\n    .fmcy-plugin-bootstrap blockquote.pull-right small:after,\n    .fmcy-plugin-bootstrap blockquote.pull-right .small:after {\n      content: '\\A0   \\2014'; }\n  .fmcy-plugin-bootstrap address {\n    margin-bottom: 20px;\n    font-style: normal;\n    line-height: 1.42857; }\n  .fmcy-plugin-bootstrap code,\n  .fmcy-plugin-bootstrap kbd,\n  .fmcy-plugin-bootstrap pre,\n  .fmcy-plugin-bootstrap samp {\n    font-family: Menlo, Monaco, Consolas, \"Courier New\", monospace; }\n  .fmcy-plugin-bootstrap code {\n    padding: 2px 4px;\n    font-size: 90%;\n    color: #c7254e;\n    background-color: #f9f2f4;\n    border-radius: 4px; }\n  .fmcy-plugin-bootstrap kbd {\n    padding: 2px 4px;\n    font-size: 90%;\n    color: #fff;\n    background-color: #333;\n    border-radius: 3px;\n    box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.25); }\n    .fmcy-plugin-bootstrap kbd kbd {\n      padding: 0;\n      font-size: 100%;\n      font-weight: bold;\n      box-shadow: none; }\n  .fmcy-plugin-bootstrap pre {\n    display: block;\n    padding: 9.5px;\n    margin: 0 0 10px;\n    font-size: 13px;\n    line-height: 1.42857;\n    word-break: break-all;\n    word-wrap: break-word;\n    color: #333333;\n    background-color: #f5f5f5;\n    border: 1px solid #ccc;\n    border-radius: 4px; }\n    .fmcy-plugin-bootstrap pre code {\n      padding: 0;\n      font-size: inherit;\n      color: inherit;\n      white-space: pre-wrap;\n      background-color: transparent;\n      border-radius: 0; }\n  .fmcy-plugin-bootstrap .pre-scrollable {\n    max-height: 340px;\n    overflow-y: scroll; }\n  .fmcy-plugin-bootstrap .container {\n    margin-right: auto;\n    margin-left: auto;\n    padding-left: 15px;\n    padding-right: 15px; }\n    .fmcy-plugin-bootstrap .container:before, .fmcy-plugin-bootstrap .container:after {\n      content: \" \";\n      display: table; }\n    .fmcy-plugin-bootstrap .container:after {\n      clear: both; }\n    @media (min-width: 768px) {\n      .fmcy-plugin-bootstrap .container {\n        width: 750px; } }\n    @media (min-width: 992px) {\n      .fmcy-plugin-bootstrap .container {\n        width: 970px; } }\n    @media (min-width: 1200px) {\n      .fmcy-plugin-bootstrap .container {\n        width: 1170px; } }\n  .fmcy-plugin-bootstrap .container-fluid {\n    margin-right: auto;\n    margin-left: auto;\n    padding-left: 15px;\n    padding-right: 15px; }\n    .fmcy-plugin-bootstrap .container-fluid:before, .fmcy-plugin-bootstrap .container-fluid:after {\n      content: \" \";\n      display: table; }\n    .fmcy-plugin-bootstrap .container-fluid:after {\n      clear: both; }\n  .fmcy-plugin-bootstrap .row {\n    margin-left: -15px;\n    margin-right: -15px; }\n    .fmcy-plugin-bootstrap .row:before, .fmcy-plugin-bootstrap .row:after {\n      content: \" \";\n      display: table; }\n    .fmcy-plugin-bootstrap .row:after {\n      clear: both; }\n  .fmcy-plugin-bootstrap .col-xs-1, .fmcy-plugin-bootstrap .col-sm-1, .fmcy-plugin-bootstrap .col-md-1, .fmcy-plugin-bootstrap .col-lg-1, .fmcy-plugin-bootstrap .col-xs-2, .fmcy-plugin-bootstrap .col-sm-2, .fmcy-plugin-bootstrap .col-md-2, .fmcy-plugin-bootstrap .col-lg-2, .fmcy-plugin-bootstrap .col-xs-3, .fmcy-plugin-bootstrap .col-sm-3, .fmcy-plugin-bootstrap .col-md-3, .fmcy-plugin-bootstrap .col-lg-3, .fmcy-plugin-bootstrap .col-xs-4, .fmcy-plugin-bootstrap .col-sm-4, .fmcy-plugin-bootstrap .col-md-4, .fmcy-plugin-bootstrap .col-lg-4, .fmcy-plugin-bootstrap .col-xs-5, .fmcy-plugin-bootstrap .col-sm-5, .fmcy-plugin-bootstrap .col-md-5, .fmcy-plugin-bootstrap .col-lg-5, .fmcy-plugin-bootstrap .col-xs-6, .fmcy-plugin-bootstrap .col-sm-6, .fmcy-plugin-bootstrap .col-md-6, .fmcy-plugin-bootstrap .col-lg-6, .fmcy-plugin-bootstrap .col-xs-7, .fmcy-plugin-bootstrap .col-sm-7, .fmcy-plugin-bootstrap .col-md-7, .fmcy-plugin-bootstrap .col-lg-7, .fmcy-plugin-bootstrap .col-xs-8, .fmcy-plugin-bootstrap .col-sm-8, .fmcy-plugin-bootstrap .col-md-8, .fmcy-plugin-bootstrap .col-lg-8, .fmcy-plugin-bootstrap .col-xs-9, .fmcy-plugin-bootstrap .col-sm-9, .fmcy-plugin-bootstrap .col-md-9, .fmcy-plugin-bootstrap .col-lg-9, .fmcy-plugin-bootstrap .col-xs-10, .fmcy-plugin-bootstrap .col-sm-10, .fmcy-plugin-bootstrap .col-md-10, .fmcy-plugin-bootstrap .col-lg-10, .fmcy-plugin-bootstrap .col-xs-11, .fmcy-plugin-bootstrap .col-sm-11, .fmcy-plugin-bootstrap .col-md-11, .fmcy-plugin-bootstrap .col-lg-11, .fmcy-plugin-bootstrap .col-xs-12, .fmcy-plugin-bootstrap .col-sm-12, .fmcy-plugin-bootstrap .col-md-12, .fmcy-plugin-bootstrap .col-lg-12 {\n    position: relative;\n    min-height: 1px;\n    padding-left: 15px;\n    padding-right: 15px; }\n  .fmcy-plugin-bootstrap .col-xs-1, .fmcy-plugin-bootstrap .col-xs-2, .fmcy-plugin-bootstrap .col-xs-3, .fmcy-plugin-bootstrap .col-xs-4, .fmcy-plugin-bootstrap .col-xs-5, .fmcy-plugin-bootstrap .col-xs-6, .fmcy-plugin-bootstrap .col-xs-7, .fmcy-plugin-bootstrap .col-xs-8, .fmcy-plugin-bootstrap .col-xs-9, .fmcy-plugin-bootstrap .col-xs-10, .fmcy-plugin-bootstrap .col-xs-11, .fmcy-plugin-bootstrap .col-xs-12 {\n    float: left; }\n  .fmcy-plugin-bootstrap .col-xs-1 {\n    width: 8.33333%; }\n  .fmcy-plugin-bootstrap .col-xs-2 {\n    width: 16.66667%; }\n  .fmcy-plugin-bootstrap .col-xs-3 {\n    width: 25%; }\n  .fmcy-plugin-bootstrap .col-xs-4 {\n    width: 33.33333%; }\n  .fmcy-plugin-bootstrap .col-xs-5 {\n    width: 41.66667%; }\n  .fmcy-plugin-bootstrap .col-xs-6 {\n    width: 50%; }\n  .fmcy-plugin-bootstrap .col-xs-7 {\n    width: 58.33333%; }\n  .fmcy-plugin-bootstrap .col-xs-8 {\n    width: 66.66667%; }\n  .fmcy-plugin-bootstrap .col-xs-9 {\n    width: 75%; }\n  .fmcy-plugin-bootstrap .col-xs-10 {\n    width: 83.33333%; }\n  .fmcy-plugin-bootstrap .col-xs-11 {\n    width: 91.66667%; }\n  .fmcy-plugin-bootstrap .col-xs-12 {\n    width: 100%; }\n  .fmcy-plugin-bootstrap .col-xs-pull-0 {\n    right: auto; }\n  .fmcy-plugin-bootstrap .col-xs-pull-1 {\n    right: 8.33333%; }\n  .fmcy-plugin-bootstrap .col-xs-pull-2 {\n    right: 16.66667%; }\n  .fmcy-plugin-bootstrap .col-xs-pull-3 {\n    right: 25%; }\n  .fmcy-plugin-bootstrap .col-xs-pull-4 {\n    right: 33.33333%; }\n  .fmcy-plugin-bootstrap .col-xs-pull-5 {\n    right: 41.66667%; }\n  .fmcy-plugin-bootstrap .col-xs-pull-6 {\n    right: 50%; }\n  .fmcy-plugin-bootstrap .col-xs-pull-7 {\n    right: 58.33333%; }\n  .fmcy-plugin-bootstrap .col-xs-pull-8 {\n    right: 66.66667%; }\n  .fmcy-plugin-bootstrap .col-xs-pull-9 {\n    right: 75%; }\n  .fmcy-plugin-bootstrap .col-xs-pull-10 {\n    right: 83.33333%; }\n  .fmcy-plugin-bootstrap .col-xs-pull-11 {\n    right: 91.66667%; }\n  .fmcy-plugin-bootstrap .col-xs-pull-12 {\n    right: 100%; }\n  .fmcy-plugin-bootstrap .col-xs-push-0 {\n    left: auto; }\n  .fmcy-plugin-bootstrap .col-xs-push-1 {\n    left: 8.33333%; }\n  .fmcy-plugin-bootstrap .col-xs-push-2 {\n    left: 16.66667%; }\n  .fmcy-plugin-bootstrap .col-xs-push-3 {\n    left: 25%; }\n  .fmcy-plugin-bootstrap .col-xs-push-4 {\n    left: 33.33333%; }\n  .fmcy-plugin-bootstrap .col-xs-push-5 {\n    left: 41.66667%; }\n  .fmcy-plugin-bootstrap .col-xs-push-6 {\n    left: 50%; }\n  .fmcy-plugin-bootstrap .col-xs-push-7 {\n    left: 58.33333%; }\n  .fmcy-plugin-bootstrap .col-xs-push-8 {\n    left: 66.66667%; }\n  .fmcy-plugin-bootstrap .col-xs-push-9 {\n    left: 75%; }\n  .fmcy-plugin-bootstrap .col-xs-push-10 {\n    left: 83.33333%; }\n  .fmcy-plugin-bootstrap .col-xs-push-11 {\n    left: 91.66667%; }\n  .fmcy-plugin-bootstrap .col-xs-push-12 {\n    left: 100%; }\n  .fmcy-plugin-bootstrap .col-xs-offset-0 {\n    margin-left: 0%; }\n  .fmcy-plugin-bootstrap .col-xs-offset-1 {\n    margin-left: 8.33333%; }\n  .fmcy-plugin-bootstrap .col-xs-offset-2 {\n    margin-left: 16.66667%; }\n  .fmcy-plugin-bootstrap .col-xs-offset-3 {\n    margin-left: 25%; }\n  .fmcy-plugin-bootstrap .col-xs-offset-4 {\n    margin-left: 33.33333%; }\n  .fmcy-plugin-bootstrap .col-xs-offset-5 {\n    margin-left: 41.66667%; }\n  .fmcy-plugin-bootstrap .col-xs-offset-6 {\n    margin-left: 50%; }\n  .fmcy-plugin-bootstrap .col-xs-offset-7 {\n    margin-left: 58.33333%; }\n  .fmcy-plugin-bootstrap .col-xs-offset-8 {\n    margin-left: 66.66667%; }\n  .fmcy-plugin-bootstrap .col-xs-offset-9 {\n    margin-left: 75%; }\n  .fmcy-plugin-bootstrap .col-xs-offset-10 {\n    margin-left: 83.33333%; }\n  .fmcy-plugin-bootstrap .col-xs-offset-11 {\n    margin-left: 91.66667%; }\n  .fmcy-plugin-bootstrap .col-xs-offset-12 {\n    margin-left: 100%; }\n  @media (min-width: 768px) {\n    .fmcy-plugin-bootstrap .col-sm-1, .fmcy-plugin-bootstrap .col-sm-2, .fmcy-plugin-bootstrap .col-sm-3, .fmcy-plugin-bootstrap .col-sm-4, .fmcy-plugin-bootstrap .col-sm-5, .fmcy-plugin-bootstrap .col-sm-6, .fmcy-plugin-bootstrap .col-sm-7, .fmcy-plugin-bootstrap .col-sm-8, .fmcy-plugin-bootstrap .col-sm-9, .fmcy-plugin-bootstrap .col-sm-10, .fmcy-plugin-bootstrap .col-sm-11, .fmcy-plugin-bootstrap .col-sm-12 {\n      float: left; }\n    .fmcy-plugin-bootstrap .col-sm-1 {\n      width: 8.33333%; }\n    .fmcy-plugin-bootstrap .col-sm-2 {\n      width: 16.66667%; }\n    .fmcy-plugin-bootstrap .col-sm-3 {\n      width: 25%; }\n    .fmcy-plugin-bootstrap .col-sm-4 {\n      width: 33.33333%; }\n    .fmcy-plugin-bootstrap .col-sm-5 {\n      width: 41.66667%; }\n    .fmcy-plugin-bootstrap .col-sm-6 {\n      width: 50%; }\n    .fmcy-plugin-bootstrap .col-sm-7 {\n      width: 58.33333%; }\n    .fmcy-plugin-bootstrap .col-sm-8 {\n      width: 66.66667%; }\n    .fmcy-plugin-bootstrap .col-sm-9 {\n      width: 75%; }\n    .fmcy-plugin-bootstrap .col-sm-10 {\n      width: 83.33333%; }\n    .fmcy-plugin-bootstrap .col-sm-11 {\n      width: 91.66667%; }\n    .fmcy-plugin-bootstrap .col-sm-12 {\n      width: 100%; }\n    .fmcy-plugin-bootstrap .col-sm-pull-0 {\n      right: auto; }\n    .fmcy-plugin-bootstrap .col-sm-pull-1 {\n      right: 8.33333%; }\n    .fmcy-plugin-bootstrap .col-sm-pull-2 {\n      right: 16.66667%; }\n    .fmcy-plugin-bootstrap .col-sm-pull-3 {\n      right: 25%; }\n    .fmcy-plugin-bootstrap .col-sm-pull-4 {\n      right: 33.33333%; }\n    .fmcy-plugin-bootstrap .col-sm-pull-5 {\n      right: 41.66667%; }\n    .fmcy-plugin-bootstrap .col-sm-pull-6 {\n      right: 50%; }\n    .fmcy-plugin-bootstrap .col-sm-pull-7 {\n      right: 58.33333%; }\n    .fmcy-plugin-bootstrap .col-sm-pull-8 {\n      right: 66.66667%; }\n    .fmcy-plugin-bootstrap .col-sm-pull-9 {\n      right: 75%; }\n    .fmcy-plugin-bootstrap .col-sm-pull-10 {\n      right: 83.33333%; }\n    .fmcy-plugin-bootstrap .col-sm-pull-11 {\n      right: 91.66667%; }\n    .fmcy-plugin-bootstrap .col-sm-pull-12 {\n      right: 100%; }\n    .fmcy-plugin-bootstrap .col-sm-push-0 {\n      left: auto; }\n    .fmcy-plugin-bootstrap .col-sm-push-1 {\n      left: 8.33333%; }\n    .fmcy-plugin-bootstrap .col-sm-push-2 {\n      left: 16.66667%; }\n    .fmcy-plugin-bootstrap .col-sm-push-3 {\n      left: 25%; }\n    .fmcy-plugin-bootstrap .col-sm-push-4 {\n      left: 33.33333%; }\n    .fmcy-plugin-bootstrap .col-sm-push-5 {\n      left: 41.66667%; }\n    .fmcy-plugin-bootstrap .col-sm-push-6 {\n      left: 50%; }\n    .fmcy-plugin-bootstrap .col-sm-push-7 {\n      left: 58.33333%; }\n    .fmcy-plugin-bootstrap .col-sm-push-8 {\n      left: 66.66667%; }\n    .fmcy-plugin-bootstrap .col-sm-push-9 {\n      left: 75%; }\n    .fmcy-plugin-bootstrap .col-sm-push-10 {\n      left: 83.33333%; }\n    .fmcy-plugin-bootstrap .col-sm-push-11 {\n      left: 91.66667%; }\n    .fmcy-plugin-bootstrap .col-sm-push-12 {\n      left: 100%; }\n    .fmcy-plugin-bootstrap .col-sm-offset-0 {\n      margin-left: 0%; }\n    .fmcy-plugin-bootstrap .col-sm-offset-1 {\n      margin-left: 8.33333%; }\n    .fmcy-plugin-bootstrap .col-sm-offset-2 {\n      margin-left: 16.66667%; }\n    .fmcy-plugin-bootstrap .col-sm-offset-3 {\n      margin-left: 25%; }\n    .fmcy-plugin-bootstrap .col-sm-offset-4 {\n      margin-left: 33.33333%; }\n    .fmcy-plugin-bootstrap .col-sm-offset-5 {\n      margin-left: 41.66667%; }\n    .fmcy-plugin-bootstrap .col-sm-offset-6 {\n      margin-left: 50%; }\n    .fmcy-plugin-bootstrap .col-sm-offset-7 {\n      margin-left: 58.33333%; }\n    .fmcy-plugin-bootstrap .col-sm-offset-8 {\n      margin-left: 66.66667%; }\n    .fmcy-plugin-bootstrap .col-sm-offset-9 {\n      margin-left: 75%; }\n    .fmcy-plugin-bootstrap .col-sm-offset-10 {\n      margin-left: 83.33333%; }\n    .fmcy-plugin-bootstrap .col-sm-offset-11 {\n      margin-left: 91.66667%; }\n    .fmcy-plugin-bootstrap .col-sm-offset-12 {\n      margin-left: 100%; } }\n  @media (min-width: 992px) {\n    .fmcy-plugin-bootstrap .col-md-1, .fmcy-plugin-bootstrap .col-md-2, .fmcy-plugin-bootstrap .col-md-3, .fmcy-plugin-bootstrap .col-md-4, .fmcy-plugin-bootstrap .col-md-5, .fmcy-plugin-bootstrap .col-md-6, .fmcy-plugin-bootstrap .col-md-7, .fmcy-plugin-bootstrap .col-md-8, .fmcy-plugin-bootstrap .col-md-9, .fmcy-plugin-bootstrap .col-md-10, .fmcy-plugin-bootstrap .col-md-11, .fmcy-plugin-bootstrap .col-md-12 {\n      float: left; }\n    .fmcy-plugin-bootstrap .col-md-1 {\n      width: 8.33333%; }\n    .fmcy-plugin-bootstrap .col-md-2 {\n      width: 16.66667%; }\n    .fmcy-plugin-bootstrap .col-md-3 {\n      width: 25%; }\n    .fmcy-plugin-bootstrap .col-md-4 {\n      width: 33.33333%; }\n    .fmcy-plugin-bootstrap .col-md-5 {\n      width: 41.66667%; }\n    .fmcy-plugin-bootstrap .col-md-6 {\n      width: 50%; }\n    .fmcy-plugin-bootstrap .col-md-7 {\n      width: 58.33333%; }\n    .fmcy-plugin-bootstrap .col-md-8 {\n      width: 66.66667%; }\n    .fmcy-plugin-bootstrap .col-md-9 {\n      width: 75%; }\n    .fmcy-plugin-bootstrap .col-md-10 {\n      width: 83.33333%; }\n    .fmcy-plugin-bootstrap .col-md-11 {\n      width: 91.66667%; }\n    .fmcy-plugin-bootstrap .col-md-12 {\n      width: 100%; }\n    .fmcy-plugin-bootstrap .col-md-pull-0 {\n      right: auto; }\n    .fmcy-plugin-bootstrap .col-md-pull-1 {\n      right: 8.33333%; }\n    .fmcy-plugin-bootstrap .col-md-pull-2 {\n      right: 16.66667%; }\n    .fmcy-plugin-bootstrap .col-md-pull-3 {\n      right: 25%; }\n    .fmcy-plugin-bootstrap .col-md-pull-4 {\n      right: 33.33333%; }\n    .fmcy-plugin-bootstrap .col-md-pull-5 {\n      right: 41.66667%; }\n    .fmcy-plugin-bootstrap .col-md-pull-6 {\n      right: 50%; }\n    .fmcy-plugin-bootstrap .col-md-pull-7 {\n      right: 58.33333%; }\n    .fmcy-plugin-bootstrap .col-md-pull-8 {\n      right: 66.66667%; }\n    .fmcy-plugin-bootstrap .col-md-pull-9 {\n      right: 75%; }\n    .fmcy-plugin-bootstrap .col-md-pull-10 {\n      right: 83.33333%; }\n    .fmcy-plugin-bootstrap .col-md-pull-11 {\n      right: 91.66667%; }\n    .fmcy-plugin-bootstrap .col-md-pull-12 {\n      right: 100%; }\n    .fmcy-plugin-bootstrap .col-md-push-0 {\n      left: auto; }\n    .fmcy-plugin-bootstrap .col-md-push-1 {\n      left: 8.33333%; }\n    .fmcy-plugin-bootstrap .col-md-push-2 {\n      left: 16.66667%; }\n    .fmcy-plugin-bootstrap .col-md-push-3 {\n      left: 25%; }\n    .fmcy-plugin-bootstrap .col-md-push-4 {\n      left: 33.33333%; }\n    .fmcy-plugin-bootstrap .col-md-push-5 {\n      left: 41.66667%; }\n    .fmcy-plugin-bootstrap .col-md-push-6 {\n      left: 50%; }\n    .fmcy-plugin-bootstrap .col-md-push-7 {\n      left: 58.33333%; }\n    .fmcy-plugin-bootstrap .col-md-push-8 {\n      left: 66.66667%; }\n    .fmcy-plugin-bootstrap .col-md-push-9 {\n      left: 75%; }\n    .fmcy-plugin-bootstrap .col-md-push-10 {\n      left: 83.33333%; }\n    .fmcy-plugin-bootstrap .col-md-push-11 {\n      left: 91.66667%; }\n    .fmcy-plugin-bootstrap .col-md-push-12 {\n      left: 100%; }\n    .fmcy-plugin-bootstrap .col-md-offset-0 {\n      margin-left: 0%; }\n    .fmcy-plugin-bootstrap .col-md-offset-1 {\n      margin-left: 8.33333%; }\n    .fmcy-plugin-bootstrap .col-md-offset-2 {\n      margin-left: 16.66667%; }\n    .fmcy-plugin-bootstrap .col-md-offset-3 {\n      margin-left: 25%; }\n    .fmcy-plugin-bootstrap .col-md-offset-4 {\n      margin-left: 33.33333%; }\n    .fmcy-plugin-bootstrap .col-md-offset-5 {\n      margin-left: 41.66667%; }\n    .fmcy-plugin-bootstrap .col-md-offset-6 {\n      margin-left: 50%; }\n    .fmcy-plugin-bootstrap .col-md-offset-7 {\n      margin-left: 58.33333%; }\n    .fmcy-plugin-bootstrap .col-md-offset-8 {\n      margin-left: 66.66667%; }\n    .fmcy-plugin-bootstrap .col-md-offset-9 {\n      margin-left: 75%; }\n    .fmcy-plugin-bootstrap .col-md-offset-10 {\n      margin-left: 83.33333%; }\n    .fmcy-plugin-bootstrap .col-md-offset-11 {\n      margin-left: 91.66667%; }\n    .fmcy-plugin-bootstrap .col-md-offset-12 {\n      margin-left: 100%; } }\n  @media (min-width: 1200px) {\n    .fmcy-plugin-bootstrap .col-lg-1, .fmcy-plugin-bootstrap .col-lg-2, .fmcy-plugin-bootstrap .col-lg-3, .fmcy-plugin-bootstrap .col-lg-4, .fmcy-plugin-bootstrap .col-lg-5, .fmcy-plugin-bootstrap .col-lg-6, .fmcy-plugin-bootstrap .col-lg-7, .fmcy-plugin-bootstrap .col-lg-8, .fmcy-plugin-bootstrap .col-lg-9, .fmcy-plugin-bootstrap .col-lg-10, .fmcy-plugin-bootstrap .col-lg-11, .fmcy-plugin-bootstrap .col-lg-12 {\n      float: left; }\n    .fmcy-plugin-bootstrap .col-lg-1 {\n      width: 8.33333%; }\n    .fmcy-plugin-bootstrap .col-lg-2 {\n      width: 16.66667%; }\n    .fmcy-plugin-bootstrap .col-lg-3 {\n      width: 25%; }\n    .fmcy-plugin-bootstrap .col-lg-4 {\n      width: 33.33333%; }\n    .fmcy-plugin-bootstrap .col-lg-5 {\n      width: 41.66667%; }\n    .fmcy-plugin-bootstrap .col-lg-6 {\n      width: 50%; }\n    .fmcy-plugin-bootstrap .col-lg-7 {\n      width: 58.33333%; }\n    .fmcy-plugin-bootstrap .col-lg-8 {\n      width: 66.66667%; }\n    .fmcy-plugin-bootstrap .col-lg-9 {\n      width: 75%; }\n    .fmcy-plugin-bootstrap .col-lg-10 {\n      width: 83.33333%; }\n    .fmcy-plugin-bootstrap .col-lg-11 {\n      width: 91.66667%; }\n    .fmcy-plugin-bootstrap .col-lg-12 {\n      width: 100%; }\n    .fmcy-plugin-bootstrap .col-lg-pull-0 {\n      right: auto; }\n    .fmcy-plugin-bootstrap .col-lg-pull-1 {\n      right: 8.33333%; }\n    .fmcy-plugin-bootstrap .col-lg-pull-2 {\n      right: 16.66667%; }\n    .fmcy-plugin-bootstrap .col-lg-pull-3 {\n      right: 25%; }\n    .fmcy-plugin-bootstrap .col-lg-pull-4 {\n      right: 33.33333%; }\n    .fmcy-plugin-bootstrap .col-lg-pull-5 {\n      right: 41.66667%; }\n    .fmcy-plugin-bootstrap .col-lg-pull-6 {\n      right: 50%; }\n    .fmcy-plugin-bootstrap .col-lg-pull-7 {\n      right: 58.33333%; }\n    .fmcy-plugin-bootstrap .col-lg-pull-8 {\n      right: 66.66667%; }\n    .fmcy-plugin-bootstrap .col-lg-pull-9 {\n      right: 75%; }\n    .fmcy-plugin-bootstrap .col-lg-pull-10 {\n      right: 83.33333%; }\n    .fmcy-plugin-bootstrap .col-lg-pull-11 {\n      right: 91.66667%; }\n    .fmcy-plugin-bootstrap .col-lg-pull-12 {\n      right: 100%; }\n    .fmcy-plugin-bootstrap .col-lg-push-0 {\n      left: auto; }\n    .fmcy-plugin-bootstrap .col-lg-push-1 {\n      left: 8.33333%; }\n    .fmcy-plugin-bootstrap .col-lg-push-2 {\n      left: 16.66667%; }\n    .fmcy-plugin-bootstrap .col-lg-push-3 {\n      left: 25%; }\n    .fmcy-plugin-bootstrap .col-lg-push-4 {\n      left: 33.33333%; }\n    .fmcy-plugin-bootstrap .col-lg-push-5 {\n      left: 41.66667%; }\n    .fmcy-plugin-bootstrap .col-lg-push-6 {\n      left: 50%; }\n    .fmcy-plugin-bootstrap .col-lg-push-7 {\n      left: 58.33333%; }\n    .fmcy-plugin-bootstrap .col-lg-push-8 {\n      left: 66.66667%; }\n    .fmcy-plugin-bootstrap .col-lg-push-9 {\n      left: 75%; }\n    .fmcy-plugin-bootstrap .col-lg-push-10 {\n      left: 83.33333%; }\n    .fmcy-plugin-bootstrap .col-lg-push-11 {\n      left: 91.66667%; }\n    .fmcy-plugin-bootstrap .col-lg-push-12 {\n      left: 100%; }\n    .fmcy-plugin-bootstrap .col-lg-offset-0 {\n      margin-left: 0%; }\n    .fmcy-plugin-bootstrap .col-lg-offset-1 {\n      margin-left: 8.33333%; }\n    .fmcy-plugin-bootstrap .col-lg-offset-2 {\n      margin-left: 16.66667%; }\n    .fmcy-plugin-bootstrap .col-lg-offset-3 {\n      margin-left: 25%; }\n    .fmcy-plugin-bootstrap .col-lg-offset-4 {\n      margin-left: 33.33333%; }\n    .fmcy-plugin-bootstrap .col-lg-offset-5 {\n      margin-left: 41.66667%; }\n    .fmcy-plugin-bootstrap .col-lg-offset-6 {\n      margin-left: 50%; }\n    .fmcy-plugin-bootstrap .col-lg-offset-7 {\n      margin-left: 58.33333%; }\n    .fmcy-plugin-bootstrap .col-lg-offset-8 {\n      margin-left: 66.66667%; }\n    .fmcy-plugin-bootstrap .col-lg-offset-9 {\n      margin-left: 75%; }\n    .fmcy-plugin-bootstrap .col-lg-offset-10 {\n      margin-left: 83.33333%; }\n    .fmcy-plugin-bootstrap .col-lg-offset-11 {\n      margin-left: 91.66667%; }\n    .fmcy-plugin-bootstrap .col-lg-offset-12 {\n      margin-left: 100%; } }\n  .fmcy-plugin-bootstrap table {\n    background-color: transparent; }\n  .fmcy-plugin-bootstrap caption {\n    padding-top: 8px;\n    padding-bottom: 8px;\n    color: #777777;\n    text-align: left; }\n  .fmcy-plugin-bootstrap th {\n    text-align: left; }\n  .fmcy-plugin-bootstrap .table {\n    width: 100%;\n    max-width: 100%;\n    margin-bottom: 20px; }\n    .fmcy-plugin-bootstrap .table > thead > tr > th,\n    .fmcy-plugin-bootstrap .table > thead > tr > td,\n    .fmcy-plugin-bootstrap .table > tbody > tr > th,\n    .fmcy-plugin-bootstrap .table > tbody > tr > td,\n    .fmcy-plugin-bootstrap .table > tfoot > tr > th,\n    .fmcy-plugin-bootstrap .table > tfoot > tr > td {\n      padding: 8px;\n      line-height: 1.42857;\n      vertical-align: top;\n      border-top: 1px solid #ddd; }\n    .fmcy-plugin-bootstrap .table > thead > tr > th {\n      vertical-align: bottom;\n      border-bottom: 2px solid #ddd; }\n    .fmcy-plugin-bootstrap .table > caption + thead > tr:first-child > th,\n    .fmcy-plugin-bootstrap .table > caption + thead > tr:first-child > td,\n    .fmcy-plugin-bootstrap .table > colgroup + thead > tr:first-child > th,\n    .fmcy-plugin-bootstrap .table > colgroup + thead > tr:first-child > td,\n    .fmcy-plugin-bootstrap .table > thead:first-child > tr:first-child > th,\n    .fmcy-plugin-bootstrap .table > thead:first-child > tr:first-child > td {\n      border-top: 0; }\n    .fmcy-plugin-bootstrap .table > tbody + tbody {\n      border-top: 2px solid #ddd; }\n    .fmcy-plugin-bootstrap .table .table {\n      background-color: #fff; }\n  .fmcy-plugin-bootstrap .table-condensed > thead > tr > th,\n  .fmcy-plugin-bootstrap .table-condensed > thead > tr > td,\n  .fmcy-plugin-bootstrap .table-condensed > tbody > tr > th,\n  .fmcy-plugin-bootstrap .table-condensed > tbody > tr > td,\n  .fmcy-plugin-bootstrap .table-condensed > tfoot > tr > th,\n  .fmcy-plugin-bootstrap .table-condensed > tfoot > tr > td {\n    padding: 5px; }\n  .fmcy-plugin-bootstrap .table-bordered {\n    border: 1px solid #ddd; }\n    .fmcy-plugin-bootstrap .table-bordered > thead > tr > th,\n    .fmcy-plugin-bootstrap .table-bordered > thead > tr > td,\n    .fmcy-plugin-bootstrap .table-bordered > tbody > tr > th,\n    .fmcy-plugin-bootstrap .table-bordered > tbody > tr > td,\n    .fmcy-plugin-bootstrap .table-bordered > tfoot > tr > th,\n    .fmcy-plugin-bootstrap .table-bordered > tfoot > tr > td {\n      border: 1px solid #ddd; }\n    .fmcy-plugin-bootstrap .table-bordered > thead > tr > th,\n    .fmcy-plugin-bootstrap .table-bordered > thead > tr > td {\n      border-bottom-width: 2px; }\n  .fmcy-plugin-bootstrap .table-striped > tbody > tr:nth-of-type(odd) {\n    background-color: #f9f9f9; }\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr:hover {\n    background-color: #f5f5f5; }\n  .fmcy-plugin-bootstrap table col[class*=\"col-\"] {\n    position: static;\n    float: none;\n    display: table-column; }\n  .fmcy-plugin-bootstrap table td[class*=\"col-\"],\n  .fmcy-plugin-bootstrap table th[class*=\"col-\"] {\n    position: static;\n    float: none;\n    display: table-cell; }\n  .fmcy-plugin-bootstrap .table > thead > tr > td.active,\n  .fmcy-plugin-bootstrap .table > thead > tr > th.active,\n  .fmcy-plugin-bootstrap .table > thead > tr.active > td,\n  .fmcy-plugin-bootstrap .table > thead > tr.active > th,\n  .fmcy-plugin-bootstrap .table > tbody > tr > td.active,\n  .fmcy-plugin-bootstrap .table > tbody > tr > th.active,\n  .fmcy-plugin-bootstrap .table > tbody > tr.active > td,\n  .fmcy-plugin-bootstrap .table > tbody > tr.active > th,\n  .fmcy-plugin-bootstrap .table > tfoot > tr > td.active,\n  .fmcy-plugin-bootstrap .table > tfoot > tr > th.active,\n  .fmcy-plugin-bootstrap .table > tfoot > tr.active > td,\n  .fmcy-plugin-bootstrap .table > tfoot > tr.active > th {\n    background-color: #f5f5f5; }\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr > td.active:hover,\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr > th.active:hover,\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr.active:hover > td,\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr:hover > .active,\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr.active:hover > th {\n    background-color: #e8e8e8; }\n  .fmcy-plugin-bootstrap .table > thead > tr > td.success,\n  .fmcy-plugin-bootstrap .table > thead > tr > th.success,\n  .fmcy-plugin-bootstrap .table > thead > tr.success > td,\n  .fmcy-plugin-bootstrap .table > thead > tr.success > th,\n  .fmcy-plugin-bootstrap .table > tbody > tr > td.success,\n  .fmcy-plugin-bootstrap .table > tbody > tr > th.success,\n  .fmcy-plugin-bootstrap .table > tbody > tr.success > td,\n  .fmcy-plugin-bootstrap .table > tbody > tr.success > th,\n  .fmcy-plugin-bootstrap .table > tfoot > tr > td.success,\n  .fmcy-plugin-bootstrap .table > tfoot > tr > th.success,\n  .fmcy-plugin-bootstrap .table > tfoot > tr.success > td,\n  .fmcy-plugin-bootstrap .table > tfoot > tr.success > th {\n    background-color: #dff0d8; }\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr > td.success:hover,\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr > th.success:hover,\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr.success:hover > td,\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr:hover > .success,\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr.success:hover > th {\n    background-color: #d0e9c6; }\n  .fmcy-plugin-bootstrap .table > thead > tr > td.info,\n  .fmcy-plugin-bootstrap .table > thead > tr > th.info,\n  .fmcy-plugin-bootstrap .table > thead > tr.info > td,\n  .fmcy-plugin-bootstrap .table > thead > tr.info > th,\n  .fmcy-plugin-bootstrap .table > tbody > tr > td.info,\n  .fmcy-plugin-bootstrap .table > tbody > tr > th.info,\n  .fmcy-plugin-bootstrap .table > tbody > tr.info > td,\n  .fmcy-plugin-bootstrap .table > tbody > tr.info > th,\n  .fmcy-plugin-bootstrap .table > tfoot > tr > td.info,\n  .fmcy-plugin-bootstrap .table > tfoot > tr > th.info,\n  .fmcy-plugin-bootstrap .table > tfoot > tr.info > td,\n  .fmcy-plugin-bootstrap .table > tfoot > tr.info > th {\n    background-color: #d9edf7; }\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr > td.info:hover,\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr > th.info:hover,\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr.info:hover > td,\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr:hover > .info,\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr.info:hover > th {\n    background-color: #c4e3f3; }\n  .fmcy-plugin-bootstrap .table > thead > tr > td.warning,\n  .fmcy-plugin-bootstrap .table > thead > tr > th.warning,\n  .fmcy-plugin-bootstrap .table > thead > tr.warning > td,\n  .fmcy-plugin-bootstrap .table > thead > tr.warning > th,\n  .fmcy-plugin-bootstrap .table > tbody > tr > td.warning,\n  .fmcy-plugin-bootstrap .table > tbody > tr > th.warning,\n  .fmcy-plugin-bootstrap .table > tbody > tr.warning > td,\n  .fmcy-plugin-bootstrap .table > tbody > tr.warning > th,\n  .fmcy-plugin-bootstrap .table > tfoot > tr > td.warning,\n  .fmcy-plugin-bootstrap .table > tfoot > tr > th.warning,\n  .fmcy-plugin-bootstrap .table > tfoot > tr.warning > td,\n  .fmcy-plugin-bootstrap .table > tfoot > tr.warning > th {\n    background-color: #fcf8e3; }\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr > td.warning:hover,\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr > th.warning:hover,\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr.warning:hover > td,\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr:hover > .warning,\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr.warning:hover > th {\n    background-color: #faf2cc; }\n  .fmcy-plugin-bootstrap .table > thead > tr > td.danger,\n  .fmcy-plugin-bootstrap .table > thead > tr > th.danger,\n  .fmcy-plugin-bootstrap .table > thead > tr.danger > td,\n  .fmcy-plugin-bootstrap .table > thead > tr.danger > th,\n  .fmcy-plugin-bootstrap .table > tbody > tr > td.danger,\n  .fmcy-plugin-bootstrap .table > tbody > tr > th.danger,\n  .fmcy-plugin-bootstrap .table > tbody > tr.danger > td,\n  .fmcy-plugin-bootstrap .table > tbody > tr.danger > th,\n  .fmcy-plugin-bootstrap .table > tfoot > tr > td.danger,\n  .fmcy-plugin-bootstrap .table > tfoot > tr > th.danger,\n  .fmcy-plugin-bootstrap .table > tfoot > tr.danger > td,\n  .fmcy-plugin-bootstrap .table > tfoot > tr.danger > th {\n    background-color: #f2dede; }\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr > td.danger:hover,\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr > th.danger:hover,\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr.danger:hover > td,\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr:hover > .danger,\n  .fmcy-plugin-bootstrap .table-hover > tbody > tr.danger:hover > th {\n    background-color: #ebcccc; }\n  .fmcy-plugin-bootstrap .table-responsive {\n    overflow-x: auto;\n    min-height: 0.01%; }\n    @media screen and (max-width: 767px) {\n      .fmcy-plugin-bootstrap .table-responsive {\n        width: 100%;\n        margin-bottom: 15px;\n        overflow-y: hidden;\n        -ms-overflow-style: -ms-autohiding-scrollbar;\n        border: 1px solid #ddd; }\n        .fmcy-plugin-bootstrap .table-responsive > .table {\n          margin-bottom: 0; }\n          .fmcy-plugin-bootstrap .table-responsive > .table > thead > tr > th,\n          .fmcy-plugin-bootstrap .table-responsive > .table > thead > tr > td,\n          .fmcy-plugin-bootstrap .table-responsive > .table > tbody > tr > th,\n          .fmcy-plugin-bootstrap .table-responsive > .table > tbody > tr > td,\n          .fmcy-plugin-bootstrap .table-responsive > .table > tfoot > tr > th,\n          .fmcy-plugin-bootstrap .table-responsive > .table > tfoot > tr > td {\n            white-space: nowrap; }\n        .fmcy-plugin-bootstrap .table-responsive > .table-bordered {\n          border: 0; }\n          .fmcy-plugin-bootstrap .table-responsive > .table-bordered > thead > tr > th:first-child,\n          .fmcy-plugin-bootstrap .table-responsive > .table-bordered > thead > tr > td:first-child,\n          .fmcy-plugin-bootstrap .table-responsive > .table-bordered > tbody > tr > th:first-child,\n          .fmcy-plugin-bootstrap .table-responsive > .table-bordered > tbody > tr > td:first-child,\n          .fmcy-plugin-bootstrap .table-responsive > .table-bordered > tfoot > tr > th:first-child,\n          .fmcy-plugin-bootstrap .table-responsive > .table-bordered > tfoot > tr > td:first-child {\n            border-left: 0; }\n          .fmcy-plugin-bootstrap .table-responsive > .table-bordered > thead > tr > th:last-child,\n          .fmcy-plugin-bootstrap .table-responsive > .table-bordered > thead > tr > td:last-child,\n          .fmcy-plugin-bootstrap .table-responsive > .table-bordered > tbody > tr > th:last-child,\n          .fmcy-plugin-bootstrap .table-responsive > .table-bordered > tbody > tr > td:last-child,\n          .fmcy-plugin-bootstrap .table-responsive > .table-bordered > tfoot > tr > th:last-child,\n          .fmcy-plugin-bootstrap .table-responsive > .table-bordered > tfoot > tr > td:last-child {\n            border-right: 0; }\n          .fmcy-plugin-bootstrap .table-responsive > .table-bordered > tbody > tr:last-child > th,\n          .fmcy-plugin-bootstrap .table-responsive > .table-bordered > tbody > tr:last-child > td,\n          .fmcy-plugin-bootstrap .table-responsive > .table-bordered > tfoot > tr:last-child > th,\n          .fmcy-plugin-bootstrap .table-responsive > .table-bordered > tfoot > tr:last-child > td {\n            border-bottom: 0; } }\n  .fmcy-plugin-bootstrap fieldset {\n    padding: 0;\n    margin: 0;\n    border: 0;\n    min-width: 0; }\n  .fmcy-plugin-bootstrap legend {\n    display: block;\n    width: 100%;\n    padding: 0;\n    margin-bottom: 20px;\n    font-size: 21px;\n    line-height: inherit;\n    color: #333333;\n    border: 0;\n    border-bottom: 1px solid #e5e5e5; }\n  .fmcy-plugin-bootstrap label {\n    display: inline-block;\n    max-width: 100%;\n    margin-bottom: 5px;\n    font-weight: bold; }\n  .fmcy-plugin-bootstrap input[type=\"search\"] {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box; }\n  .fmcy-plugin-bootstrap input[type=\"radio\"],\n  .fmcy-plugin-bootstrap input[type=\"checkbox\"] {\n    margin: 4px 0 0;\n    margin-top: 1px \\9;\n    line-height: normal; }\n  .fmcy-plugin-bootstrap input[type=\"file\"] {\n    display: block; }\n  .fmcy-plugin-bootstrap input[type=\"range\"] {\n    display: block;\n    width: 100%; }\n  .fmcy-plugin-bootstrap select[multiple],\n  .fmcy-plugin-bootstrap select[size] {\n    height: auto; }\n  .fmcy-plugin-bootstrap input[type=\"file\"]:focus,\n  .fmcy-plugin-bootstrap input[type=\"radio\"]:focus,\n  .fmcy-plugin-bootstrap input[type=\"checkbox\"]:focus {\n    outline: 5px auto -webkit-focus-ring-color;\n    outline-offset: -2px; }\n  .fmcy-plugin-bootstrap output {\n    display: block;\n    padding-top: 7px;\n    font-size: 14px;\n    line-height: 1.42857;\n    color: #555555; }\n  .fmcy-plugin-bootstrap .form-control {\n    display: block;\n    width: 100%;\n    height: 34px;\n    padding: 6px 12px;\n    font-size: 14px;\n    line-height: 1.42857;\n    color: #555555;\n    background-color: #fff;\n    background-image: none;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n    -webkit-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n    -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s; }\n    .fmcy-plugin-bootstrap .form-control:focus {\n      border-color: #66afe9;\n      outline: 0;\n      -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);\n      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6); }\n    .fmcy-plugin-bootstrap .form-control::-moz-placeholder {\n      color: #999;\n      opacity: 1; }\n    .fmcy-plugin-bootstrap .form-control:-ms-input-placeholder {\n      color: #999; }\n    .fmcy-plugin-bootstrap .form-control::-webkit-input-placeholder {\n      color: #999; }\n    .fmcy-plugin-bootstrap .form-control::-ms-expand {\n      border: 0;\n      background-color: transparent; }\n    .fmcy-plugin-bootstrap .form-control[disabled], .fmcy-plugin-bootstrap .form-control[readonly],\n    fieldset[disabled] .fmcy-plugin-bootstrap .form-control {\n      background-color: #eeeeee;\n      opacity: 1; }\n    .fmcy-plugin-bootstrap .form-control[disabled],\n    fieldset[disabled] .fmcy-plugin-bootstrap .form-control {\n      cursor: not-allowed; }\n  .fmcy-plugin-bootstrap textarea.form-control {\n    height: auto; }\n  .fmcy-plugin-bootstrap input[type=\"search\"] {\n    -webkit-appearance: none; }\n  @media screen and (-webkit-min-device-pixel-ratio: 0) {\n    .fmcy-plugin-bootstrap input[type=\"date\"].form-control,\n    .fmcy-plugin-bootstrap input[type=\"time\"].form-control,\n    .fmcy-plugin-bootstrap input[type=\"datetime-local\"].form-control,\n    .fmcy-plugin-bootstrap input[type=\"month\"].form-control {\n      line-height: 34px; }\n    .fmcy-plugin-bootstrap input[type=\"date\"].input-sm, .fmcy-plugin-bootstrap .input-group-sm > input[type=\"date\"].form-control, .fmcy-plugin-bootstrap .input-group-sm > input[type=\"date\"].input-group-addon, .fmcy-plugin-bootstrap .input-group-sm > .input-group-btn > input[type=\"date\"].btn,\n    .input-group-sm .fmcy-plugin-bootstrap input[type=\"date\"],\n    .fmcy-plugin-bootstrap input[type=\"time\"].input-sm, .fmcy-plugin-bootstrap .input-group-sm > input[type=\"time\"].form-control, .fmcy-plugin-bootstrap .input-group-sm > input[type=\"time\"].input-group-addon, .fmcy-plugin-bootstrap .input-group-sm > .input-group-btn > input[type=\"time\"].btn,\n    .input-group-sm\n    .fmcy-plugin-bootstrap input[type=\"time\"],\n    .fmcy-plugin-bootstrap input[type=\"datetime-local\"].input-sm, .fmcy-plugin-bootstrap .input-group-sm > input[type=\"datetime-local\"].form-control, .fmcy-plugin-bootstrap .input-group-sm > input[type=\"datetime-local\"].input-group-addon, .fmcy-plugin-bootstrap .input-group-sm > .input-group-btn > input[type=\"datetime-local\"].btn,\n    .input-group-sm\n    .fmcy-plugin-bootstrap input[type=\"datetime-local\"],\n    .fmcy-plugin-bootstrap input[type=\"month\"].input-sm, .fmcy-plugin-bootstrap .input-group-sm > input[type=\"month\"].form-control, .fmcy-plugin-bootstrap .input-group-sm > input[type=\"month\"].input-group-addon, .fmcy-plugin-bootstrap .input-group-sm > .input-group-btn > input[type=\"month\"].btn,\n    .input-group-sm\n    .fmcy-plugin-bootstrap input[type=\"month\"] {\n      line-height: 30px; }\n    .fmcy-plugin-bootstrap input[type=\"date\"].input-lg, .fmcy-plugin-bootstrap .input-group-lg > input[type=\"date\"].form-control, .fmcy-plugin-bootstrap .input-group-lg > input[type=\"date\"].input-group-addon, .fmcy-plugin-bootstrap .input-group-lg > .input-group-btn > input[type=\"date\"].btn,\n    .input-group-lg .fmcy-plugin-bootstrap input[type=\"date\"],\n    .fmcy-plugin-bootstrap input[type=\"time\"].input-lg, .fmcy-plugin-bootstrap .input-group-lg > input[type=\"time\"].form-control, .fmcy-plugin-bootstrap .input-group-lg > input[type=\"time\"].input-group-addon, .fmcy-plugin-bootstrap .input-group-lg > .input-group-btn > input[type=\"time\"].btn,\n    .input-group-lg\n    .fmcy-plugin-bootstrap input[type=\"time\"],\n    .fmcy-plugin-bootstrap input[type=\"datetime-local\"].input-lg, .fmcy-plugin-bootstrap .input-group-lg > input[type=\"datetime-local\"].form-control, .fmcy-plugin-bootstrap .input-group-lg > input[type=\"datetime-local\"].input-group-addon, .fmcy-plugin-bootstrap .input-group-lg > .input-group-btn > input[type=\"datetime-local\"].btn,\n    .input-group-lg\n    .fmcy-plugin-bootstrap input[type=\"datetime-local\"],\n    .fmcy-plugin-bootstrap input[type=\"month\"].input-lg, .fmcy-plugin-bootstrap .input-group-lg > input[type=\"month\"].form-control, .fmcy-plugin-bootstrap .input-group-lg > input[type=\"month\"].input-group-addon, .fmcy-plugin-bootstrap .input-group-lg > .input-group-btn > input[type=\"month\"].btn,\n    .input-group-lg\n    .fmcy-plugin-bootstrap input[type=\"month\"] {\n      line-height: 46px; } }\n  .fmcy-plugin-bootstrap .form-group {\n    margin-bottom: 15px; }\n  .fmcy-plugin-bootstrap .radio,\n  .fmcy-plugin-bootstrap .checkbox {\n    position: relative;\n    display: block;\n    margin-top: 10px;\n    margin-bottom: 10px; }\n    .fmcy-plugin-bootstrap .radio label,\n    .fmcy-plugin-bootstrap .checkbox label {\n      min-height: 20px;\n      padding-left: 20px;\n      margin-bottom: 0;\n      font-weight: normal;\n      cursor: pointer; }\n  .fmcy-plugin-bootstrap .radio input[type=\"radio\"],\n  .fmcy-plugin-bootstrap .radio-inline input[type=\"radio\"],\n  .fmcy-plugin-bootstrap .checkbox input[type=\"checkbox\"],\n  .fmcy-plugin-bootstrap .checkbox-inline input[type=\"checkbox\"] {\n    position: absolute;\n    margin-left: -20px;\n    margin-top: 4px \\9; }\n  .fmcy-plugin-bootstrap .radio + .radio,\n  .fmcy-plugin-bootstrap .checkbox + .checkbox {\n    margin-top: -5px; }\n  .fmcy-plugin-bootstrap .radio-inline,\n  .fmcy-plugin-bootstrap .checkbox-inline {\n    position: relative;\n    display: inline-block;\n    padding-left: 20px;\n    margin-bottom: 0;\n    vertical-align: middle;\n    font-weight: normal;\n    cursor: pointer; }\n  .fmcy-plugin-bootstrap .radio-inline + .radio-inline,\n  .fmcy-plugin-bootstrap .checkbox-inline + .checkbox-inline {\n    margin-top: 0;\n    margin-left: 10px; }\n  .fmcy-plugin-bootstrap input[type=\"radio\"][disabled], .fmcy-plugin-bootstrap input[type=\"radio\"].disabled,\n  fieldset[disabled] .fmcy-plugin-bootstrap input[type=\"radio\"],\n  .fmcy-plugin-bootstrap input[type=\"checkbox\"][disabled],\n  .fmcy-plugin-bootstrap input[type=\"checkbox\"].disabled,\n  fieldset[disabled]\n  .fmcy-plugin-bootstrap input[type=\"checkbox\"] {\n    cursor: not-allowed; }\n  .fmcy-plugin-bootstrap .radio-inline.disabled,\n  fieldset[disabled] .fmcy-plugin-bootstrap .radio-inline,\n  .fmcy-plugin-bootstrap .checkbox-inline.disabled,\n  fieldset[disabled]\n  .fmcy-plugin-bootstrap .checkbox-inline {\n    cursor: not-allowed; }\n  .fmcy-plugin-bootstrap .radio.disabled label,\n  fieldset[disabled] .fmcy-plugin-bootstrap .radio label,\n  .fmcy-plugin-bootstrap .checkbox.disabled label,\n  fieldset[disabled]\n  .fmcy-plugin-bootstrap .checkbox label {\n    cursor: not-allowed; }\n  .fmcy-plugin-bootstrap .form-control-static {\n    padding-top: 7px;\n    padding-bottom: 7px;\n    margin-bottom: 0;\n    min-height: 34px; }\n    .fmcy-plugin-bootstrap .form-control-static.input-lg, .fmcy-plugin-bootstrap .input-group-lg > .form-control-static.form-control, .fmcy-plugin-bootstrap .input-group-lg > .form-control-static.input-group-addon, .fmcy-plugin-bootstrap .input-group-lg > .input-group-btn > .form-control-static.btn, .fmcy-plugin-bootstrap .form-control-static.input-sm, .fmcy-plugin-bootstrap .input-group-sm > .form-control-static.form-control, .fmcy-plugin-bootstrap .input-group-sm > .form-control-static.input-group-addon, .fmcy-plugin-bootstrap .input-group-sm > .input-group-btn > .form-control-static.btn {\n      padding-left: 0;\n      padding-right: 0; }\n  .fmcy-plugin-bootstrap .input-sm, .fmcy-plugin-bootstrap .input-group-sm > .form-control, .fmcy-plugin-bootstrap .input-group-sm > .input-group-addon, .fmcy-plugin-bootstrap .input-group-sm > .input-group-btn > .btn {\n    height: 30px;\n    padding: 5px 10px;\n    font-size: 12px;\n    line-height: 1.5;\n    border-radius: 3px; }\n  .fmcy-plugin-bootstrap select.input-sm, .fmcy-plugin-bootstrap .input-group-sm > select.form-control, .fmcy-plugin-bootstrap .input-group-sm > select.input-group-addon, .fmcy-plugin-bootstrap .input-group-sm > .input-group-btn > select.btn {\n    height: 30px;\n    line-height: 30px; }\n  .fmcy-plugin-bootstrap textarea.input-sm, .fmcy-plugin-bootstrap .input-group-sm > textarea.form-control, .fmcy-plugin-bootstrap .input-group-sm > textarea.input-group-addon, .fmcy-plugin-bootstrap .input-group-sm > .input-group-btn > textarea.btn,\n  .fmcy-plugin-bootstrap select[multiple].input-sm, .fmcy-plugin-bootstrap .input-group-sm > select[multiple].form-control, .fmcy-plugin-bootstrap .input-group-sm > select[multiple].input-group-addon, .fmcy-plugin-bootstrap .input-group-sm > .input-group-btn > select[multiple].btn {\n    height: auto; }\n  .fmcy-plugin-bootstrap .form-group-sm .form-control {\n    height: 30px;\n    padding: 5px 10px;\n    font-size: 12px;\n    line-height: 1.5;\n    border-radius: 3px; }\n  .fmcy-plugin-bootstrap .form-group-sm select.form-control {\n    height: 30px;\n    line-height: 30px; }\n  .fmcy-plugin-bootstrap .form-group-sm textarea.form-control,\n  .fmcy-plugin-bootstrap .form-group-sm select[multiple].form-control {\n    height: auto; }\n  .fmcy-plugin-bootstrap .form-group-sm .form-control-static {\n    height: 30px;\n    min-height: 32px;\n    padding: 6px 10px;\n    font-size: 12px;\n    line-height: 1.5; }\n  .fmcy-plugin-bootstrap .input-lg, .fmcy-plugin-bootstrap .input-group-lg > .form-control, .fmcy-plugin-bootstrap .input-group-lg > .input-group-addon, .fmcy-plugin-bootstrap .input-group-lg > .input-group-btn > .btn {\n    height: 46px;\n    padding: 10px 16px;\n    font-size: 18px;\n    line-height: 1.33333;\n    border-radius: 6px; }\n  .fmcy-plugin-bootstrap select.input-lg, .fmcy-plugin-bootstrap .input-group-lg > select.form-control, .fmcy-plugin-bootstrap .input-group-lg > select.input-group-addon, .fmcy-plugin-bootstrap .input-group-lg > .input-group-btn > select.btn {\n    height: 46px;\n    line-height: 46px; }\n  .fmcy-plugin-bootstrap textarea.input-lg, .fmcy-plugin-bootstrap .input-group-lg > textarea.form-control, .fmcy-plugin-bootstrap .input-group-lg > textarea.input-group-addon, .fmcy-plugin-bootstrap .input-group-lg > .input-group-btn > textarea.btn,\n  .fmcy-plugin-bootstrap select[multiple].input-lg, .fmcy-plugin-bootstrap .input-group-lg > select[multiple].form-control, .fmcy-plugin-bootstrap .input-group-lg > select[multiple].input-group-addon, .fmcy-plugin-bootstrap .input-group-lg > .input-group-btn > select[multiple].btn {\n    height: auto; }\n  .fmcy-plugin-bootstrap .form-group-lg .form-control {\n    height: 46px;\n    padding: 10px 16px;\n    font-size: 18px;\n    line-height: 1.33333;\n    border-radius: 6px; }\n  .fmcy-plugin-bootstrap .form-group-lg select.form-control {\n    height: 46px;\n    line-height: 46px; }\n  .fmcy-plugin-bootstrap .form-group-lg textarea.form-control,\n  .fmcy-plugin-bootstrap .form-group-lg select[multiple].form-control {\n    height: auto; }\n  .fmcy-plugin-bootstrap .form-group-lg .form-control-static {\n    height: 46px;\n    min-height: 38px;\n    padding: 11px 16px;\n    font-size: 18px;\n    line-height: 1.33333; }\n  .fmcy-plugin-bootstrap .has-feedback {\n    position: relative; }\n    .fmcy-plugin-bootstrap .has-feedback .form-control {\n      padding-right: 42.5px; }\n  .fmcy-plugin-bootstrap .form-control-feedback {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n    display: block;\n    width: 34px;\n    height: 34px;\n    line-height: 34px;\n    text-align: center;\n    pointer-events: none; }\n  .fmcy-plugin-bootstrap .input-lg + .form-control-feedback, .fmcy-plugin-bootstrap .input-group-lg > .form-control + .form-control-feedback, .fmcy-plugin-bootstrap .input-group-lg > .input-group-addon + .form-control-feedback, .fmcy-plugin-bootstrap .input-group-lg > .input-group-btn > .btn + .form-control-feedback,\n  .fmcy-plugin-bootstrap .input-group-lg + .form-control-feedback,\n  .fmcy-plugin-bootstrap .form-group-lg .form-control + .form-control-feedback {\n    width: 46px;\n    height: 46px;\n    line-height: 46px; }\n  .fmcy-plugin-bootstrap .input-sm + .form-control-feedback, .fmcy-plugin-bootstrap .input-group-sm > .form-control + .form-control-feedback, .fmcy-plugin-bootstrap .input-group-sm > .input-group-addon + .form-control-feedback, .fmcy-plugin-bootstrap .input-group-sm > .input-group-btn > .btn + .form-control-feedback,\n  .fmcy-plugin-bootstrap .input-group-sm + .form-control-feedback,\n  .fmcy-plugin-bootstrap .form-group-sm .form-control + .form-control-feedback {\n    width: 30px;\n    height: 30px;\n    line-height: 30px; }\n  .fmcy-plugin-bootstrap .has-success .help-block,\n  .fmcy-plugin-bootstrap .has-success .control-label,\n  .fmcy-plugin-bootstrap .has-success .radio,\n  .fmcy-plugin-bootstrap .has-success .checkbox,\n  .fmcy-plugin-bootstrap .has-success .radio-inline,\n  .fmcy-plugin-bootstrap .has-success .checkbox-inline,\n  .fmcy-plugin-bootstrap .has-success.radio label,\n  .fmcy-plugin-bootstrap .has-success.checkbox label,\n  .fmcy-plugin-bootstrap .has-success.radio-inline label,\n  .fmcy-plugin-bootstrap .has-success.checkbox-inline label {\n    color: #3c763d; }\n  .fmcy-plugin-bootstrap .has-success .form-control {\n    border-color: #3c763d;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); }\n    .fmcy-plugin-bootstrap .has-success .form-control:focus {\n      border-color: #2b542c;\n      -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #67b168;\n      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #67b168; }\n  .fmcy-plugin-bootstrap .has-success .input-group-addon {\n    color: #3c763d;\n    border-color: #3c763d;\n    background-color: #dff0d8; }\n  .fmcy-plugin-bootstrap .has-success .form-control-feedback {\n    color: #3c763d; }\n  .fmcy-plugin-bootstrap .has-warning .help-block,\n  .fmcy-plugin-bootstrap .has-warning .control-label,\n  .fmcy-plugin-bootstrap .has-warning .radio,\n  .fmcy-plugin-bootstrap .has-warning .checkbox,\n  .fmcy-plugin-bootstrap .has-warning .radio-inline,\n  .fmcy-plugin-bootstrap .has-warning .checkbox-inline,\n  .fmcy-plugin-bootstrap .has-warning.radio label,\n  .fmcy-plugin-bootstrap .has-warning.checkbox label,\n  .fmcy-plugin-bootstrap .has-warning.radio-inline label,\n  .fmcy-plugin-bootstrap .has-warning.checkbox-inline label {\n    color: #8a6d3b; }\n  .fmcy-plugin-bootstrap .has-warning .form-control {\n    border-color: #8a6d3b;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); }\n    .fmcy-plugin-bootstrap .has-warning .form-control:focus {\n      border-color: #66512c;\n      -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #c0a16b;\n      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #c0a16b; }\n  .fmcy-plugin-bootstrap .has-warning .input-group-addon {\n    color: #8a6d3b;\n    border-color: #8a6d3b;\n    background-color: #fcf8e3; }\n  .fmcy-plugin-bootstrap .has-warning .form-control-feedback {\n    color: #8a6d3b; }\n  .fmcy-plugin-bootstrap .has-error .help-block,\n  .fmcy-plugin-bootstrap .has-error .control-label,\n  .fmcy-plugin-bootstrap .has-error .radio,\n  .fmcy-plugin-bootstrap .has-error .checkbox,\n  .fmcy-plugin-bootstrap .has-error .radio-inline,\n  .fmcy-plugin-bootstrap .has-error .checkbox-inline,\n  .fmcy-plugin-bootstrap .has-error.radio label,\n  .fmcy-plugin-bootstrap .has-error.checkbox label,\n  .fmcy-plugin-bootstrap .has-error.radio-inline label,\n  .fmcy-plugin-bootstrap .has-error.checkbox-inline label {\n    color: #a94442; }\n  .fmcy-plugin-bootstrap .has-error .form-control {\n    border-color: #a94442;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); }\n    .fmcy-plugin-bootstrap .has-error .form-control:focus {\n      border-color: #843534;\n      -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ce8483;\n      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ce8483; }\n  .fmcy-plugin-bootstrap .has-error .input-group-addon {\n    color: #a94442;\n    border-color: #a94442;\n    background-color: #f2dede; }\n  .fmcy-plugin-bootstrap .has-error .form-control-feedback {\n    color: #a94442; }\n  .fmcy-plugin-bootstrap .has-feedback label ~ .form-control-feedback {\n    top: 25px; }\n  .fmcy-plugin-bootstrap .has-feedback label.sr-only ~ .form-control-feedback, .fmcy-plugin-bootstrap .has-feedback .bootstrap-datetimepicker-widget label.btn[data-action=\"incrementHours\"]::after ~ .form-control-feedback, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .has-feedback label.btn[data-action=\"incrementHours\"]::after ~ .form-control-feedback, .fmcy-plugin-bootstrap .has-feedback .bootstrap-datetimepicker-widget label.btn[data-action=\"incrementMinutes\"]::after ~ .form-control-feedback, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .has-feedback label.btn[data-action=\"incrementMinutes\"]::after ~ .form-control-feedback, .fmcy-plugin-bootstrap .has-feedback .bootstrap-datetimepicker-widget label.btn[data-action=\"decrementHours\"]::after ~ .form-control-feedback, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .has-feedback label.btn[data-action=\"decrementHours\"]::after ~ .form-control-feedback, .fmcy-plugin-bootstrap .has-feedback .bootstrap-datetimepicker-widget label.btn[data-action=\"decrementMinutes\"]::after ~ .form-control-feedback, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .has-feedback label.btn[data-action=\"decrementMinutes\"]::after ~ .form-control-feedback, .fmcy-plugin-bootstrap .has-feedback .bootstrap-datetimepicker-widget label.btn[data-action=\"showHours\"]::after ~ .form-control-feedback, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .has-feedback label.btn[data-action=\"showHours\"]::after ~ .form-control-feedback, .fmcy-plugin-bootstrap .has-feedback .bootstrap-datetimepicker-widget label.btn[data-action=\"showMinutes\"]::after ~ .form-control-feedback, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .has-feedback label.btn[data-action=\"showMinutes\"]::after ~ .form-control-feedback, .fmcy-plugin-bootstrap .has-feedback .bootstrap-datetimepicker-widget label.btn[data-action=\"togglePeriod\"]::after ~ .form-control-feedback, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .has-feedback label.btn[data-action=\"togglePeriod\"]::after ~ .form-control-feedback, .fmcy-plugin-bootstrap .has-feedback .bootstrap-datetimepicker-widget label.btn[data-action=\"clear\"]::after ~ .form-control-feedback, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .has-feedback label.btn[data-action=\"clear\"]::after ~ .form-control-feedback, .fmcy-plugin-bootstrap .has-feedback .bootstrap-datetimepicker-widget label.btn[data-action=\"today\"]::after ~ .form-control-feedback, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .has-feedback label.btn[data-action=\"today\"]::after ~ .form-control-feedback, .fmcy-plugin-bootstrap .has-feedback .bootstrap-datetimepicker-widget label.picker-switch::after ~ .form-control-feedback, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .has-feedback label.picker-switch::after ~ .form-control-feedback {\n    top: 0; }\n  .fmcy-plugin-bootstrap .help-block {\n    display: block;\n    margin-top: 5px;\n    margin-bottom: 10px;\n    color: #737373; }\n  @media (min-width: 768px) {\n    .fmcy-plugin-bootstrap .form-inline .form-group {\n      display: inline-block;\n      margin-bottom: 0;\n      vertical-align: middle; }\n    .fmcy-plugin-bootstrap .form-inline .form-control {\n      display: inline-block;\n      width: auto;\n      vertical-align: middle; }\n    .fmcy-plugin-bootstrap .form-inline .form-control-static {\n      display: inline-block; }\n    .fmcy-plugin-bootstrap .form-inline .input-group {\n      display: inline-table;\n      vertical-align: middle; }\n      .fmcy-plugin-bootstrap .form-inline .input-group .input-group-addon,\n      .fmcy-plugin-bootstrap .form-inline .input-group .input-group-btn,\n      .fmcy-plugin-bootstrap .form-inline .input-group .form-control {\n        width: auto; }\n    .fmcy-plugin-bootstrap .form-inline .input-group > .form-control {\n      width: 100%; }\n    .fmcy-plugin-bootstrap .form-inline .control-label {\n      margin-bottom: 0;\n      vertical-align: middle; }\n    .fmcy-plugin-bootstrap .form-inline .radio,\n    .fmcy-plugin-bootstrap .form-inline .checkbox {\n      display: inline-block;\n      margin-top: 0;\n      margin-bottom: 0;\n      vertical-align: middle; }\n      .fmcy-plugin-bootstrap .form-inline .radio label,\n      .fmcy-plugin-bootstrap .form-inline .checkbox label {\n        padding-left: 0; }\n    .fmcy-plugin-bootstrap .form-inline .radio input[type=\"radio\"],\n    .fmcy-plugin-bootstrap .form-inline .checkbox input[type=\"checkbox\"] {\n      position: relative;\n      margin-left: 0; }\n    .fmcy-plugin-bootstrap .form-inline .has-feedback .form-control-feedback {\n      top: 0; } }\n  .fmcy-plugin-bootstrap .form-horizontal .radio,\n  .fmcy-plugin-bootstrap .form-horizontal .checkbox,\n  .fmcy-plugin-bootstrap .form-horizontal .radio-inline,\n  .fmcy-plugin-bootstrap .form-horizontal .checkbox-inline {\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-top: 7px; }\n  .fmcy-plugin-bootstrap .form-horizontal .radio,\n  .fmcy-plugin-bootstrap .form-horizontal .checkbox {\n    min-height: 27px; }\n  .fmcy-plugin-bootstrap .form-horizontal .form-group {\n    margin-left: -15px;\n    margin-right: -15px; }\n    .fmcy-plugin-bootstrap .form-horizontal .form-group:before, .fmcy-plugin-bootstrap .form-horizontal .form-group:after {\n      content: \" \";\n      display: table; }\n    .fmcy-plugin-bootstrap .form-horizontal .form-group:after {\n      clear: both; }\n  @media (min-width: 768px) {\n    .fmcy-plugin-bootstrap .form-horizontal .control-label {\n      text-align: right;\n      margin-bottom: 0;\n      padding-top: 7px; } }\n  .fmcy-plugin-bootstrap .form-horizontal .has-feedback .form-control-feedback {\n    right: 15px; }\n  @media (min-width: 768px) {\n    .fmcy-plugin-bootstrap .form-horizontal .form-group-lg .control-label {\n      padding-top: 11px;\n      font-size: 18px; } }\n  @media (min-width: 768px) {\n    .fmcy-plugin-bootstrap .form-horizontal .form-group-sm .control-label {\n      padding-top: 6px;\n      font-size: 12px; } }\n  .fmcy-plugin-bootstrap .btn {\n    display: inline-block;\n    margin-bottom: 0;\n    font-weight: normal;\n    text-align: center;\n    vertical-align: middle;\n    touch-action: manipulation;\n    cursor: pointer;\n    background-image: none;\n    border: 1px solid transparent;\n    white-space: nowrap;\n    padding: 6px 12px;\n    font-size: 14px;\n    line-height: 1.42857;\n    border-radius: 4px;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none; }\n    .fmcy-plugin-bootstrap .btn:focus, .fmcy-plugin-bootstrap .btn.focus, .fmcy-plugin-bootstrap .btn:active:focus, .fmcy-plugin-bootstrap .btn:active.focus, .fmcy-plugin-bootstrap .btn.active:focus, .fmcy-plugin-bootstrap .btn.active.focus {\n      outline: 5px auto -webkit-focus-ring-color;\n      outline-offset: -2px; }\n    .fmcy-plugin-bootstrap .btn:hover, .fmcy-plugin-bootstrap .btn:focus, .fmcy-plugin-bootstrap .btn.focus {\n      color: #333;\n      text-decoration: none; }\n    .fmcy-plugin-bootstrap .btn:active, .fmcy-plugin-bootstrap .btn.active {\n      outline: 0;\n      background-image: none;\n      -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125); }\n    .fmcy-plugin-bootstrap .btn.disabled, .fmcy-plugin-bootstrap .btn[disabled],\n    fieldset[disabled] .fmcy-plugin-bootstrap .btn {\n      cursor: not-allowed;\n      opacity: 0.65;\n      filter: alpha(opacity=65);\n      -webkit-box-shadow: none;\n      box-shadow: none; }\n  .fmcy-plugin-bootstrap a.btn.disabled,\n  fieldset[disabled] .fmcy-plugin-bootstrap a.btn {\n    pointer-events: none; }\n  .fmcy-plugin-bootstrap .btn-default {\n    color: #333;\n    background-color: #fff;\n    border-color: #ccc; }\n    .fmcy-plugin-bootstrap .btn-default:focus, .fmcy-plugin-bootstrap .btn-default.focus {\n      color: #333;\n      background-color: #e6e6e6;\n      border-color: #8c8c8c; }\n    .fmcy-plugin-bootstrap .btn-default:hover {\n      color: #333;\n      background-color: #e6e6e6;\n      border-color: #adadad; }\n    .fmcy-plugin-bootstrap .btn-default:active, .fmcy-plugin-bootstrap .btn-default.active,\n    .open > .fmcy-plugin-bootstrap .btn-default.dropdown-toggle {\n      color: #333;\n      background-color: #e6e6e6;\n      border-color: #adadad; }\n      .fmcy-plugin-bootstrap .btn-default:active:hover, .fmcy-plugin-bootstrap .btn-default:active:focus, .fmcy-plugin-bootstrap .btn-default:active.focus, .fmcy-plugin-bootstrap .btn-default.active:hover, .fmcy-plugin-bootstrap .btn-default.active:focus, .fmcy-plugin-bootstrap .btn-default.active.focus,\n      .open > .fmcy-plugin-bootstrap .btn-default.dropdown-toggle:hover,\n      .open > .fmcy-plugin-bootstrap .btn-default.dropdown-toggle:focus,\n      .open > .fmcy-plugin-bootstrap .btn-default.dropdown-toggle.focus {\n        color: #333;\n        background-color: #d4d4d4;\n        border-color: #8c8c8c; }\n    .fmcy-plugin-bootstrap .btn-default:active, .fmcy-plugin-bootstrap .btn-default.active,\n    .open > .fmcy-plugin-bootstrap .btn-default.dropdown-toggle {\n      background-image: none; }\n    .fmcy-plugin-bootstrap .btn-default.disabled:hover, .fmcy-plugin-bootstrap .btn-default.disabled:focus, .fmcy-plugin-bootstrap .btn-default.disabled.focus, .fmcy-plugin-bootstrap .btn-default[disabled]:hover, .fmcy-plugin-bootstrap .btn-default[disabled]:focus, .fmcy-plugin-bootstrap .btn-default[disabled].focus,\n    fieldset[disabled] .fmcy-plugin-bootstrap .btn-default:hover,\n    fieldset[disabled] .fmcy-plugin-bootstrap .btn-default:focus,\n    fieldset[disabled] .fmcy-plugin-bootstrap .btn-default.focus {\n      background-color: #fff;\n      border-color: #ccc; }\n    .fmcy-plugin-bootstrap .btn-default .badge {\n      color: #fff;\n      background-color: #333; }\n  .fmcy-plugin-bootstrap .btn-primary {\n    color: #fff;\n    background-color: #337ab7;\n    border-color: #2e6da4; }\n    .fmcy-plugin-bootstrap .btn-primary:focus, .fmcy-plugin-bootstrap .btn-primary.focus {\n      color: #fff;\n      background-color: #286090;\n      border-color: #122b40; }\n    .fmcy-plugin-bootstrap .btn-primary:hover {\n      color: #fff;\n      background-color: #286090;\n      border-color: #204d74; }\n    .fmcy-plugin-bootstrap .btn-primary:active, .fmcy-plugin-bootstrap .btn-primary.active,\n    .open > .fmcy-plugin-bootstrap .btn-primary.dropdown-toggle {\n      color: #fff;\n      background-color: #286090;\n      border-color: #204d74; }\n      .fmcy-plugin-bootstrap .btn-primary:active:hover, .fmcy-plugin-bootstrap .btn-primary:active:focus, .fmcy-plugin-bootstrap .btn-primary:active.focus, .fmcy-plugin-bootstrap .btn-primary.active:hover, .fmcy-plugin-bootstrap .btn-primary.active:focus, .fmcy-plugin-bootstrap .btn-primary.active.focus,\n      .open > .fmcy-plugin-bootstrap .btn-primary.dropdown-toggle:hover,\n      .open > .fmcy-plugin-bootstrap .btn-primary.dropdown-toggle:focus,\n      .open > .fmcy-plugin-bootstrap .btn-primary.dropdown-toggle.focus {\n        color: #fff;\n        background-color: #204d74;\n        border-color: #122b40; }\n    .fmcy-plugin-bootstrap .btn-primary:active, .fmcy-plugin-bootstrap .btn-primary.active,\n    .open > .fmcy-plugin-bootstrap .btn-primary.dropdown-toggle {\n      background-image: none; }\n    .fmcy-plugin-bootstrap .btn-primary.disabled:hover, .fmcy-plugin-bootstrap .btn-primary.disabled:focus, .fmcy-plugin-bootstrap .btn-primary.disabled.focus, .fmcy-plugin-bootstrap .btn-primary[disabled]:hover, .fmcy-plugin-bootstrap .btn-primary[disabled]:focus, .fmcy-plugin-bootstrap .btn-primary[disabled].focus,\n    fieldset[disabled] .fmcy-plugin-bootstrap .btn-primary:hover,\n    fieldset[disabled] .fmcy-plugin-bootstrap .btn-primary:focus,\n    fieldset[disabled] .fmcy-plugin-bootstrap .btn-primary.focus {\n      background-color: #337ab7;\n      border-color: #2e6da4; }\n    .fmcy-plugin-bootstrap .btn-primary .badge {\n      color: #337ab7;\n      background-color: #fff; }\n  .fmcy-plugin-bootstrap .btn-success {\n    color: #fff;\n    background-color: #5cb85c;\n    border-color: #4cae4c; }\n    .fmcy-plugin-bootstrap .btn-success:focus, .fmcy-plugin-bootstrap .btn-success.focus {\n      color: #fff;\n      background-color: #449d44;\n      border-color: #255625; }\n    .fmcy-plugin-bootstrap .btn-success:hover {\n      color: #fff;\n      background-color: #449d44;\n      border-color: #398439; }\n    .fmcy-plugin-bootstrap .btn-success:active, .fmcy-plugin-bootstrap .btn-success.active,\n    .open > .fmcy-plugin-bootstrap .btn-success.dropdown-toggle {\n      color: #fff;\n      background-color: #449d44;\n      border-color: #398439; }\n      .fmcy-plugin-bootstrap .btn-success:active:hover, .fmcy-plugin-bootstrap .btn-success:active:focus, .fmcy-plugin-bootstrap .btn-success:active.focus, .fmcy-plugin-bootstrap .btn-success.active:hover, .fmcy-plugin-bootstrap .btn-success.active:focus, .fmcy-plugin-bootstrap .btn-success.active.focus,\n      .open > .fmcy-plugin-bootstrap .btn-success.dropdown-toggle:hover,\n      .open > .fmcy-plugin-bootstrap .btn-success.dropdown-toggle:focus,\n      .open > .fmcy-plugin-bootstrap .btn-success.dropdown-toggle.focus {\n        color: #fff;\n        background-color: #398439;\n        border-color: #255625; }\n    .fmcy-plugin-bootstrap .btn-success:active, .fmcy-plugin-bootstrap .btn-success.active,\n    .open > .fmcy-plugin-bootstrap .btn-success.dropdown-toggle {\n      background-image: none; }\n    .fmcy-plugin-bootstrap .btn-success.disabled:hover, .fmcy-plugin-bootstrap .btn-success.disabled:focus, .fmcy-plugin-bootstrap .btn-success.disabled.focus, .fmcy-plugin-bootstrap .btn-success[disabled]:hover, .fmcy-plugin-bootstrap .btn-success[disabled]:focus, .fmcy-plugin-bootstrap .btn-success[disabled].focus,\n    fieldset[disabled] .fmcy-plugin-bootstrap .btn-success:hover,\n    fieldset[disabled] .fmcy-plugin-bootstrap .btn-success:focus,\n    fieldset[disabled] .fmcy-plugin-bootstrap .btn-success.focus {\n      background-color: #5cb85c;\n      border-color: #4cae4c; }\n    .fmcy-plugin-bootstrap .btn-success .badge {\n      color: #5cb85c;\n      background-color: #fff; }\n  .fmcy-plugin-bootstrap .btn-info {\n    color: #fff;\n    background-color: #5bc0de;\n    border-color: #46b8da; }\n    .fmcy-plugin-bootstrap .btn-info:focus, .fmcy-plugin-bootstrap .btn-info.focus {\n      color: #fff;\n      background-color: #31b0d5;\n      border-color: #1b6d85; }\n    .fmcy-plugin-bootstrap .btn-info:hover {\n      color: #fff;\n      background-color: #31b0d5;\n      border-color: #269abc; }\n    .fmcy-plugin-bootstrap .btn-info:active, .fmcy-plugin-bootstrap .btn-info.active,\n    .open > .fmcy-plugin-bootstrap .btn-info.dropdown-toggle {\n      color: #fff;\n      background-color: #31b0d5;\n      border-color: #269abc; }\n      .fmcy-plugin-bootstrap .btn-info:active:hover, .fmcy-plugin-bootstrap .btn-info:active:focus, .fmcy-plugin-bootstrap .btn-info:active.focus, .fmcy-plugin-bootstrap .btn-info.active:hover, .fmcy-plugin-bootstrap .btn-info.active:focus, .fmcy-plugin-bootstrap .btn-info.active.focus,\n      .open > .fmcy-plugin-bootstrap .btn-info.dropdown-toggle:hover,\n      .open > .fmcy-plugin-bootstrap .btn-info.dropdown-toggle:focus,\n      .open > .fmcy-plugin-bootstrap .btn-info.dropdown-toggle.focus {\n        color: #fff;\n        background-color: #269abc;\n        border-color: #1b6d85; }\n    .fmcy-plugin-bootstrap .btn-info:active, .fmcy-plugin-bootstrap .btn-info.active,\n    .open > .fmcy-plugin-bootstrap .btn-info.dropdown-toggle {\n      background-image: none; }\n    .fmcy-plugin-bootstrap .btn-info.disabled:hover, .fmcy-plugin-bootstrap .btn-info.disabled:focus, .fmcy-plugin-bootstrap .btn-info.disabled.focus, .fmcy-plugin-bootstrap .btn-info[disabled]:hover, .fmcy-plugin-bootstrap .btn-info[disabled]:focus, .fmcy-plugin-bootstrap .btn-info[disabled].focus,\n    fieldset[disabled] .fmcy-plugin-bootstrap .btn-info:hover,\n    fieldset[disabled] .fmcy-plugin-bootstrap .btn-info:focus,\n    fieldset[disabled] .fmcy-plugin-bootstrap .btn-info.focus {\n      background-color: #5bc0de;\n      border-color: #46b8da; }\n    .fmcy-plugin-bootstrap .btn-info .badge {\n      color: #5bc0de;\n      background-color: #fff; }\n  .fmcy-plugin-bootstrap .btn-warning {\n    color: #fff;\n    background-color: #f0ad4e;\n    border-color: #eea236; }\n    .fmcy-plugin-bootstrap .btn-warning:focus, .fmcy-plugin-bootstrap .btn-warning.focus {\n      color: #fff;\n      background-color: #ec971f;\n      border-color: #985f0d; }\n    .fmcy-plugin-bootstrap .btn-warning:hover {\n      color: #fff;\n      background-color: #ec971f;\n      border-color: #d58512; }\n    .fmcy-plugin-bootstrap .btn-warning:active, .fmcy-plugin-bootstrap .btn-warning.active,\n    .open > .fmcy-plugin-bootstrap .btn-warning.dropdown-toggle {\n      color: #fff;\n      background-color: #ec971f;\n      border-color: #d58512; }\n      .fmcy-plugin-bootstrap .btn-warning:active:hover, .fmcy-plugin-bootstrap .btn-warning:active:focus, .fmcy-plugin-bootstrap .btn-warning:active.focus, .fmcy-plugin-bootstrap .btn-warning.active:hover, .fmcy-plugin-bootstrap .btn-warning.active:focus, .fmcy-plugin-bootstrap .btn-warning.active.focus,\n      .open > .fmcy-plugin-bootstrap .btn-warning.dropdown-toggle:hover,\n      .open > .fmcy-plugin-bootstrap .btn-warning.dropdown-toggle:focus,\n      .open > .fmcy-plugin-bootstrap .btn-warning.dropdown-toggle.focus {\n        color: #fff;\n        background-color: #d58512;\n        border-color: #985f0d; }\n    .fmcy-plugin-bootstrap .btn-warning:active, .fmcy-plugin-bootstrap .btn-warning.active,\n    .open > .fmcy-plugin-bootstrap .btn-warning.dropdown-toggle {\n      background-image: none; }\n    .fmcy-plugin-bootstrap .btn-warning.disabled:hover, .fmcy-plugin-bootstrap .btn-warning.disabled:focus, .fmcy-plugin-bootstrap .btn-warning.disabled.focus, .fmcy-plugin-bootstrap .btn-warning[disabled]:hover, .fmcy-plugin-bootstrap .btn-warning[disabled]:focus, .fmcy-plugin-bootstrap .btn-warning[disabled].focus,\n    fieldset[disabled] .fmcy-plugin-bootstrap .btn-warning:hover,\n    fieldset[disabled] .fmcy-plugin-bootstrap .btn-warning:focus,\n    fieldset[disabled] .fmcy-plugin-bootstrap .btn-warning.focus {\n      background-color: #f0ad4e;\n      border-color: #eea236; }\n    .fmcy-plugin-bootstrap .btn-warning .badge {\n      color: #f0ad4e;\n      background-color: #fff; }\n  .fmcy-plugin-bootstrap .btn-danger {\n    color: #fff;\n    background-color: #d9534f;\n    border-color: #d43f3a; }\n    .fmcy-plugin-bootstrap .btn-danger:focus, .fmcy-plugin-bootstrap .btn-danger.focus {\n      color: #fff;\n      background-color: #c9302c;\n      border-color: #761c19; }\n    .fmcy-plugin-bootstrap .btn-danger:hover {\n      color: #fff;\n      background-color: #c9302c;\n      border-color: #ac2925; }\n    .fmcy-plugin-bootstrap .btn-danger:active, .fmcy-plugin-bootstrap .btn-danger.active,\n    .open > .fmcy-plugin-bootstrap .btn-danger.dropdown-toggle {\n      color: #fff;\n      background-color: #c9302c;\n      border-color: #ac2925; }\n      .fmcy-plugin-bootstrap .btn-danger:active:hover, .fmcy-plugin-bootstrap .btn-danger:active:focus, .fmcy-plugin-bootstrap .btn-danger:active.focus, .fmcy-plugin-bootstrap .btn-danger.active:hover, .fmcy-plugin-bootstrap .btn-danger.active:focus, .fmcy-plugin-bootstrap .btn-danger.active.focus,\n      .open > .fmcy-plugin-bootstrap .btn-danger.dropdown-toggle:hover,\n      .open > .fmcy-plugin-bootstrap .btn-danger.dropdown-toggle:focus,\n      .open > .fmcy-plugin-bootstrap .btn-danger.dropdown-toggle.focus {\n        color: #fff;\n        background-color: #ac2925;\n        border-color: #761c19; }\n    .fmcy-plugin-bootstrap .btn-danger:active, .fmcy-plugin-bootstrap .btn-danger.active,\n    .open > .fmcy-plugin-bootstrap .btn-danger.dropdown-toggle {\n      background-image: none; }\n    .fmcy-plugin-bootstrap .btn-danger.disabled:hover, .fmcy-plugin-bootstrap .btn-danger.disabled:focus, .fmcy-plugin-bootstrap .btn-danger.disabled.focus, .fmcy-plugin-bootstrap .btn-danger[disabled]:hover, .fmcy-plugin-bootstrap .btn-danger[disabled]:focus, .fmcy-plugin-bootstrap .btn-danger[disabled].focus,\n    fieldset[disabled] .fmcy-plugin-bootstrap .btn-danger:hover,\n    fieldset[disabled] .fmcy-plugin-bootstrap .btn-danger:focus,\n    fieldset[disabled] .fmcy-plugin-bootstrap .btn-danger.focus {\n      background-color: #d9534f;\n      border-color: #d43f3a; }\n    .fmcy-plugin-bootstrap .btn-danger .badge {\n      color: #d9534f;\n      background-color: #fff; }\n  .fmcy-plugin-bootstrap .btn-link {\n    color: #337ab7;\n    font-weight: normal;\n    border-radius: 0; }\n    .fmcy-plugin-bootstrap .btn-link, .fmcy-plugin-bootstrap .btn-link:active, .fmcy-plugin-bootstrap .btn-link.active, .fmcy-plugin-bootstrap .btn-link[disabled],\n    fieldset[disabled] .fmcy-plugin-bootstrap .btn-link {\n      background-color: transparent;\n      -webkit-box-shadow: none;\n      box-shadow: none; }\n    .fmcy-plugin-bootstrap .btn-link, .fmcy-plugin-bootstrap .btn-link:hover, .fmcy-plugin-bootstrap .btn-link:focus, .fmcy-plugin-bootstrap .btn-link:active {\n      border-color: transparent; }\n    .fmcy-plugin-bootstrap .btn-link:hover, .fmcy-plugin-bootstrap .btn-link:focus {\n      color: #23527c;\n      text-decoration: underline;\n      background-color: transparent; }\n    .fmcy-plugin-bootstrap .btn-link[disabled]:hover, .fmcy-plugin-bootstrap .btn-link[disabled]:focus,\n    fieldset[disabled] .fmcy-plugin-bootstrap .btn-link:hover,\n    fieldset[disabled] .fmcy-plugin-bootstrap .btn-link:focus {\n      color: #777777;\n      text-decoration: none; }\n  .fmcy-plugin-bootstrap .btn-lg, .fmcy-plugin-bootstrap .btn-group-lg > .btn {\n    padding: 10px 16px;\n    font-size: 18px;\n    line-height: 1.33333;\n    border-radius: 6px; }\n  .fmcy-plugin-bootstrap .btn-sm, .fmcy-plugin-bootstrap .btn-group-sm > .btn {\n    padding: 5px 10px;\n    font-size: 12px;\n    line-height: 1.5;\n    border-radius: 3px; }\n  .fmcy-plugin-bootstrap .btn-xs, .fmcy-plugin-bootstrap .btn-group-xs > .btn {\n    padding: 1px 5px;\n    font-size: 12px;\n    line-height: 1.5;\n    border-radius: 3px; }\n  .fmcy-plugin-bootstrap .btn-block {\n    display: block;\n    width: 100%; }\n  .fmcy-plugin-bootstrap .btn-block + .btn-block {\n    margin-top: 5px; }\n  .fmcy-plugin-bootstrap input[type=\"submit\"].btn-block,\n  .fmcy-plugin-bootstrap input[type=\"reset\"].btn-block,\n  .fmcy-plugin-bootstrap input[type=\"button\"].btn-block {\n    width: 100%; }\n  .fmcy-plugin-bootstrap .fade {\n    opacity: 0;\n    -webkit-transition: opacity 0.15s linear;\n    -o-transition: opacity 0.15s linear;\n    transition: opacity 0.15s linear; }\n    .fmcy-plugin-bootstrap .fade.in {\n      opacity: 1; }\n  .fmcy-plugin-bootstrap .collapse {\n    display: none; }\n    .fmcy-plugin-bootstrap .collapse.in {\n      display: block; }\n  .fmcy-plugin-bootstrap tr.collapse.in {\n    display: table-row; }\n  .fmcy-plugin-bootstrap tbody.collapse.in {\n    display: table-row-group; }\n  .fmcy-plugin-bootstrap .collapsing {\n    position: relative;\n    height: 0;\n    overflow: hidden;\n    -webkit-transition-property: height, visibility;\n    transition-property: height, visibility;\n    -webkit-transition-duration: 0.35s;\n    transition-duration: 0.35s;\n    -webkit-transition-timing-function: ease;\n    transition-timing-function: ease; }\n  .fmcy-plugin-bootstrap .caret {\n    display: inline-block;\n    width: 0;\n    height: 0;\n    margin-left: 2px;\n    vertical-align: middle;\n    border-top: 4px dashed;\n    border-top: 4px solid \\9;\n    border-right: 4px solid transparent;\n    border-left: 4px solid transparent; }\n  .fmcy-plugin-bootstrap .dropup,\n  .fmcy-plugin-bootstrap .dropdown {\n    position: relative; }\n  .fmcy-plugin-bootstrap .dropdown-toggle:focus {\n    outline: 0; }\n  .fmcy-plugin-bootstrap .dropdown-menu {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 1000;\n    display: none;\n    float: left;\n    min-width: 160px;\n    padding: 5px 0;\n    margin: 2px 0 0;\n    list-style: none;\n    font-size: 14px;\n    text-align: left;\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    border-radius: 4px;\n    -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n    background-clip: padding-box; }\n    .fmcy-plugin-bootstrap .dropdown-menu.pull-right {\n      right: 0;\n      left: auto; }\n    .fmcy-plugin-bootstrap .dropdown-menu .divider {\n      height: 1px;\n      margin: 9px 0;\n      overflow: hidden;\n      background-color: #e5e5e5; }\n    .fmcy-plugin-bootstrap .dropdown-menu > li > a {\n      display: block;\n      padding: 3px 20px;\n      clear: both;\n      font-weight: normal;\n      line-height: 1.42857;\n      color: #333333;\n      white-space: nowrap; }\n  .fmcy-plugin-bootstrap .dropdown-menu > li > a:hover, .fmcy-plugin-bootstrap .dropdown-menu > li > a:focus {\n    text-decoration: none;\n    color: #262626;\n    background-color: #f5f5f5; }\n  .fmcy-plugin-bootstrap .dropdown-menu > .active > a, .fmcy-plugin-bootstrap .dropdown-menu > .active > a:hover, .fmcy-plugin-bootstrap .dropdown-menu > .active > a:focus {\n    color: #fff;\n    text-decoration: none;\n    outline: 0;\n    background-color: #337ab7; }\n  .fmcy-plugin-bootstrap .dropdown-menu > .disabled > a, .fmcy-plugin-bootstrap .dropdown-menu > .disabled > a:hover, .fmcy-plugin-bootstrap .dropdown-menu > .disabled > a:focus {\n    color: #777777; }\n  .fmcy-plugin-bootstrap .dropdown-menu > .disabled > a:hover, .fmcy-plugin-bootstrap .dropdown-menu > .disabled > a:focus {\n    text-decoration: none;\n    background-color: transparent;\n    background-image: none;\n    filter: progid:DXImageTransform.Microsoft.gradient(enabled = false);\n    cursor: not-allowed; }\n  .fmcy-plugin-bootstrap .open > .dropdown-menu {\n    display: block; }\n  .fmcy-plugin-bootstrap .open > a {\n    outline: 0; }\n  .fmcy-plugin-bootstrap .dropdown-menu-right {\n    left: auto;\n    right: 0; }\n  .fmcy-plugin-bootstrap .dropdown-menu-left {\n    left: 0;\n    right: auto; }\n  .fmcy-plugin-bootstrap .dropdown-header {\n    display: block;\n    padding: 3px 20px;\n    font-size: 12px;\n    line-height: 1.42857;\n    color: #777777;\n    white-space: nowrap; }\n  .fmcy-plugin-bootstrap .dropdown-backdrop {\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    z-index: 990; }\n  .fmcy-plugin-bootstrap .pull-right > .dropdown-menu {\n    right: 0;\n    left: auto; }\n  .fmcy-plugin-bootstrap .dropup .caret,\n  .fmcy-plugin-bootstrap .navbar-fixed-bottom .dropdown .caret {\n    border-top: 0;\n    border-bottom: 4px dashed;\n    border-bottom: 4px solid \\9;\n    content: \"\"; }\n  .fmcy-plugin-bootstrap .dropup .dropdown-menu,\n  .fmcy-plugin-bootstrap .navbar-fixed-bottom .dropdown .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-bottom: 2px; }\n  @media (min-width: 768px) {\n    .fmcy-plugin-bootstrap .navbar-right .dropdown-menu {\n      right: 0;\n      left: auto; }\n    .fmcy-plugin-bootstrap .navbar-right .dropdown-menu-left {\n      left: 0;\n      right: auto; } }\n  .fmcy-plugin-bootstrap .btn-group,\n  .fmcy-plugin-bootstrap .btn-group-vertical {\n    position: relative;\n    display: inline-block;\n    vertical-align: middle; }\n    .fmcy-plugin-bootstrap .btn-group > .btn,\n    .fmcy-plugin-bootstrap .btn-group-vertical > .btn {\n      position: relative;\n      float: left; }\n      .fmcy-plugin-bootstrap .btn-group > .btn:hover, .fmcy-plugin-bootstrap .btn-group > .btn:focus, .fmcy-plugin-bootstrap .btn-group > .btn:active, .fmcy-plugin-bootstrap .btn-group > .btn.active,\n      .fmcy-plugin-bootstrap .btn-group-vertical > .btn:hover,\n      .fmcy-plugin-bootstrap .btn-group-vertical > .btn:focus,\n      .fmcy-plugin-bootstrap .btn-group-vertical > .btn:active,\n      .fmcy-plugin-bootstrap .btn-group-vertical > .btn.active {\n        z-index: 2; }\n  .fmcy-plugin-bootstrap .btn-group .btn + .btn,\n  .fmcy-plugin-bootstrap .btn-group .btn + .btn-group,\n  .fmcy-plugin-bootstrap .btn-group .btn-group + .btn,\n  .fmcy-plugin-bootstrap .btn-group .btn-group + .btn-group {\n    margin-left: -1px; }\n  .fmcy-plugin-bootstrap .btn-toolbar {\n    margin-left: -5px; }\n    .fmcy-plugin-bootstrap .btn-toolbar:before, .fmcy-plugin-bootstrap .btn-toolbar:after {\n      content: \" \";\n      display: table; }\n    .fmcy-plugin-bootstrap .btn-toolbar:after {\n      clear: both; }\n    .fmcy-plugin-bootstrap .btn-toolbar .btn,\n    .fmcy-plugin-bootstrap .btn-toolbar .btn-group,\n    .fmcy-plugin-bootstrap .btn-toolbar .input-group {\n      float: left; }\n    .fmcy-plugin-bootstrap .btn-toolbar > .btn,\n    .fmcy-plugin-bootstrap .btn-toolbar > .btn-group,\n    .fmcy-plugin-bootstrap .btn-toolbar > .input-group {\n      margin-left: 5px; }\n  .fmcy-plugin-bootstrap .btn-group > .btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {\n    border-radius: 0; }\n  .fmcy-plugin-bootstrap .btn-group > .btn:first-child {\n    margin-left: 0; }\n    .fmcy-plugin-bootstrap .btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle) {\n      border-bottom-right-radius: 0;\n      border-top-right-radius: 0; }\n  .fmcy-plugin-bootstrap .btn-group > .btn:last-child:not(:first-child),\n  .fmcy-plugin-bootstrap .btn-group > .dropdown-toggle:not(:first-child) {\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0; }\n  .fmcy-plugin-bootstrap .btn-group > .btn-group {\n    float: left; }\n  .fmcy-plugin-bootstrap .btn-group > .btn-group:not(:first-child):not(:last-child) > .btn {\n    border-radius: 0; }\n  .fmcy-plugin-bootstrap .btn-group > .btn-group:first-child:not(:last-child) > .btn:last-child,\n  .fmcy-plugin-bootstrap .btn-group > .btn-group:first-child:not(:last-child) > .dropdown-toggle {\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0; }\n  .fmcy-plugin-bootstrap .btn-group > .btn-group:last-child:not(:first-child) > .btn:first-child {\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0; }\n  .fmcy-plugin-bootstrap .btn-group .dropdown-toggle:active,\n  .fmcy-plugin-bootstrap .btn-group.open .dropdown-toggle {\n    outline: 0; }\n  .fmcy-plugin-bootstrap .btn-group > .btn + .dropdown-toggle {\n    padding-left: 8px;\n    padding-right: 8px; }\n  .fmcy-plugin-bootstrap .btn-group > .btn-lg + .dropdown-toggle, .fmcy-plugin-bootstrap .btn-group-lg.btn-group > .btn + .dropdown-toggle {\n    padding-left: 12px;\n    padding-right: 12px; }\n  .fmcy-plugin-bootstrap .btn-group.open .dropdown-toggle {\n    -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125); }\n    .fmcy-plugin-bootstrap .btn-group.open .dropdown-toggle.btn-link {\n      -webkit-box-shadow: none;\n      box-shadow: none; }\n  .fmcy-plugin-bootstrap .btn .caret {\n    margin-left: 0; }\n  .fmcy-plugin-bootstrap .btn-lg .caret, .fmcy-plugin-bootstrap .btn-group-lg > .btn .caret {\n    border-width: 5px 5px 0;\n    border-bottom-width: 0; }\n  .fmcy-plugin-bootstrap .dropup .btn-lg .caret, .fmcy-plugin-bootstrap .dropup .btn-group-lg > .btn .caret {\n    border-width: 0 5px 5px; }\n  .fmcy-plugin-bootstrap .btn-group-vertical > .btn,\n  .fmcy-plugin-bootstrap .btn-group-vertical > .btn-group,\n  .fmcy-plugin-bootstrap .btn-group-vertical > .btn-group > .btn {\n    display: block;\n    float: none;\n    width: 100%;\n    max-width: 100%; }\n  .fmcy-plugin-bootstrap .btn-group-vertical > .btn-group:before, .fmcy-plugin-bootstrap .btn-group-vertical > .btn-group:after {\n    content: \" \";\n    display: table; }\n  .fmcy-plugin-bootstrap .btn-group-vertical > .btn-group:after {\n    clear: both; }\n  .fmcy-plugin-bootstrap .btn-group-vertical > .btn-group > .btn {\n    float: none; }\n  .fmcy-plugin-bootstrap .btn-group-vertical > .btn + .btn,\n  .fmcy-plugin-bootstrap .btn-group-vertical > .btn + .btn-group,\n  .fmcy-plugin-bootstrap .btn-group-vertical > .btn-group + .btn,\n  .fmcy-plugin-bootstrap .btn-group-vertical > .btn-group + .btn-group {\n    margin-top: -1px;\n    margin-left: 0; }\n  .fmcy-plugin-bootstrap .btn-group-vertical > .btn:not(:first-child):not(:last-child) {\n    border-radius: 0; }\n  .fmcy-plugin-bootstrap .btn-group-vertical > .btn:first-child:not(:last-child) {\n    border-top-right-radius: 4px;\n    border-top-left-radius: 4px;\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0; }\n  .fmcy-plugin-bootstrap .btn-group-vertical > .btn:last-child:not(:first-child) {\n    border-top-right-radius: 0;\n    border-top-left-radius: 0;\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 4px; }\n  .fmcy-plugin-bootstrap .btn-group-vertical > .btn-group:not(:first-child):not(:last-child) > .btn {\n    border-radius: 0; }\n  .fmcy-plugin-bootstrap .btn-group-vertical > .btn-group:first-child:not(:last-child) > .btn:last-child,\n  .fmcy-plugin-bootstrap .btn-group-vertical > .btn-group:first-child:not(:last-child) > .dropdown-toggle {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0; }\n  .fmcy-plugin-bootstrap .btn-group-vertical > .btn-group:last-child:not(:first-child) > .btn:first-child {\n    border-top-right-radius: 0;\n    border-top-left-radius: 0; }\n  .fmcy-plugin-bootstrap .btn-group-justified {\n    display: table;\n    width: 100%;\n    table-layout: fixed;\n    border-collapse: separate; }\n    .fmcy-plugin-bootstrap .btn-group-justified > .btn,\n    .fmcy-plugin-bootstrap .btn-group-justified > .btn-group {\n      float: none;\n      display: table-cell;\n      width: 1%; }\n    .fmcy-plugin-bootstrap .btn-group-justified > .btn-group .btn {\n      width: 100%; }\n    .fmcy-plugin-bootstrap .btn-group-justified > .btn-group .dropdown-menu {\n      left: auto; }\n  .fmcy-plugin-bootstrap [data-toggle=\"buttons\"] > .btn input[type=\"radio\"],\n  .fmcy-plugin-bootstrap [data-toggle=\"buttons\"] > .btn input[type=\"checkbox\"],\n  .fmcy-plugin-bootstrap [data-toggle=\"buttons\"] > .btn-group > .btn input[type=\"radio\"],\n  .fmcy-plugin-bootstrap [data-toggle=\"buttons\"] > .btn-group > .btn input[type=\"checkbox\"] {\n    position: absolute;\n    clip: rect(0, 0, 0, 0);\n    pointer-events: none; }\n  .fmcy-plugin-bootstrap .input-group {\n    position: relative;\n    display: table;\n    border-collapse: separate; }\n    .fmcy-plugin-bootstrap .input-group[class*=\"col-\"] {\n      float: none;\n      padding-left: 0;\n      padding-right: 0; }\n    .fmcy-plugin-bootstrap .input-group .form-control {\n      position: relative;\n      z-index: 2;\n      float: left;\n      width: 100%;\n      margin-bottom: 0; }\n      .fmcy-plugin-bootstrap .input-group .form-control:focus {\n        z-index: 3; }\n  .fmcy-plugin-bootstrap .input-group-addon,\n  .fmcy-plugin-bootstrap .input-group-btn,\n  .fmcy-plugin-bootstrap .input-group .form-control {\n    display: table-cell; }\n    .fmcy-plugin-bootstrap .input-group-addon:not(:first-child):not(:last-child),\n    .fmcy-plugin-bootstrap .input-group-btn:not(:first-child):not(:last-child),\n    .fmcy-plugin-bootstrap .input-group .form-control:not(:first-child):not(:last-child) {\n      border-radius: 0; }\n  .fmcy-plugin-bootstrap .input-group-addon,\n  .fmcy-plugin-bootstrap .input-group-btn {\n    width: 1%;\n    white-space: nowrap;\n    vertical-align: middle; }\n  .fmcy-plugin-bootstrap .input-group-addon {\n    padding: 6px 12px;\n    font-size: 14px;\n    font-weight: normal;\n    line-height: 1;\n    color: #555555;\n    text-align: center;\n    background-color: #eeeeee;\n    border: 1px solid #ccc;\n    border-radius: 4px; }\n    .fmcy-plugin-bootstrap .input-group-addon.input-sm, .fmcy-plugin-bootstrap .input-group-sm > .input-group-addon, .fmcy-plugin-bootstrap .input-group-sm > .input-group-btn > .input-group-addon.btn {\n      padding: 5px 10px;\n      font-size: 12px;\n      border-radius: 3px; }\n    .fmcy-plugin-bootstrap .input-group-addon.input-lg, .fmcy-plugin-bootstrap .input-group-lg > .input-group-addon, .fmcy-plugin-bootstrap .input-group-lg > .input-group-btn > .input-group-addon.btn {\n      padding: 10px 16px;\n      font-size: 18px;\n      border-radius: 6px; }\n    .fmcy-plugin-bootstrap .input-group-addon input[type=\"radio\"],\n    .fmcy-plugin-bootstrap .input-group-addon input[type=\"checkbox\"] {\n      margin-top: 0; }\n  .fmcy-plugin-bootstrap .input-group .form-control:first-child,\n  .fmcy-plugin-bootstrap .input-group-addon:first-child,\n  .fmcy-plugin-bootstrap .input-group-btn:first-child > .btn,\n  .fmcy-plugin-bootstrap .input-group-btn:first-child > .btn-group > .btn,\n  .fmcy-plugin-bootstrap .input-group-btn:first-child > .dropdown-toggle,\n  .fmcy-plugin-bootstrap .input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n  .fmcy-plugin-bootstrap .input-group-btn:last-child > .btn-group:not(:last-child) > .btn {\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0; }\n  .fmcy-plugin-bootstrap .input-group-addon:first-child {\n    border-right: 0; }\n  .fmcy-plugin-bootstrap .input-group .form-control:last-child,\n  .fmcy-plugin-bootstrap .input-group-addon:last-child,\n  .fmcy-plugin-bootstrap .input-group-btn:last-child > .btn,\n  .fmcy-plugin-bootstrap .input-group-btn:last-child > .btn-group > .btn,\n  .fmcy-plugin-bootstrap .input-group-btn:last-child > .dropdown-toggle,\n  .fmcy-plugin-bootstrap .input-group-btn:first-child > .btn:not(:first-child),\n  .fmcy-plugin-bootstrap .input-group-btn:first-child > .btn-group:not(:first-child) > .btn {\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0; }\n  .fmcy-plugin-bootstrap .input-group-addon:last-child {\n    border-left: 0; }\n  .fmcy-plugin-bootstrap .input-group-btn {\n    position: relative;\n    font-size: 0;\n    white-space: nowrap; }\n    .fmcy-plugin-bootstrap .input-group-btn > .btn {\n      position: relative; }\n      .fmcy-plugin-bootstrap .input-group-btn > .btn + .btn {\n        margin-left: -1px; }\n      .fmcy-plugin-bootstrap .input-group-btn > .btn:hover, .fmcy-plugin-bootstrap .input-group-btn > .btn:focus, .fmcy-plugin-bootstrap .input-group-btn > .btn:active {\n        z-index: 2; }\n    .fmcy-plugin-bootstrap .input-group-btn:first-child > .btn,\n    .fmcy-plugin-bootstrap .input-group-btn:first-child > .btn-group {\n      margin-right: -1px; }\n    .fmcy-plugin-bootstrap .input-group-btn:last-child > .btn,\n    .fmcy-plugin-bootstrap .input-group-btn:last-child > .btn-group {\n      z-index: 2;\n      margin-left: -1px; }\n  .fmcy-plugin-bootstrap .nav {\n    margin-bottom: 0;\n    padding-left: 0;\n    list-style: none; }\n    .fmcy-plugin-bootstrap .nav:before, .fmcy-plugin-bootstrap .nav:after {\n      content: \" \";\n      display: table; }\n    .fmcy-plugin-bootstrap .nav:after {\n      clear: both; }\n    .fmcy-plugin-bootstrap .nav > li {\n      position: relative;\n      display: block; }\n      .fmcy-plugin-bootstrap .nav > li > a {\n        position: relative;\n        display: block;\n        padding: 10px 15px; }\n        .fmcy-plugin-bootstrap .nav > li > a:hover, .fmcy-plugin-bootstrap .nav > li > a:focus {\n          text-decoration: none;\n          background-color: #eeeeee; }\n      .fmcy-plugin-bootstrap .nav > li.disabled > a {\n        color: #777777; }\n        .fmcy-plugin-bootstrap .nav > li.disabled > a:hover, .fmcy-plugin-bootstrap .nav > li.disabled > a:focus {\n          color: #777777;\n          text-decoration: none;\n          background-color: transparent;\n          cursor: not-allowed; }\n    .fmcy-plugin-bootstrap .nav .open > a, .fmcy-plugin-bootstrap .nav .open > a:hover, .fmcy-plugin-bootstrap .nav .open > a:focus {\n      background-color: #eeeeee;\n      border-color: #337ab7; }\n    .fmcy-plugin-bootstrap .nav .nav-divider {\n      height: 1px;\n      margin: 9px 0;\n      overflow: hidden;\n      background-color: #e5e5e5; }\n    .fmcy-plugin-bootstrap .nav > li > a > img {\n      max-width: none; }\n  .fmcy-plugin-bootstrap .nav-tabs {\n    border-bottom: 1px solid #ddd; }\n    .fmcy-plugin-bootstrap .nav-tabs > li {\n      float: left;\n      margin-bottom: -1px; }\n      .fmcy-plugin-bootstrap .nav-tabs > li > a {\n        margin-right: 2px;\n        line-height: 1.42857;\n        border: 1px solid transparent;\n        border-radius: 4px 4px 0 0; }\n        .fmcy-plugin-bootstrap .nav-tabs > li > a:hover {\n          border-color: #eeeeee #eeeeee #ddd; }\n      .fmcy-plugin-bootstrap .nav-tabs > li.active > a, .fmcy-plugin-bootstrap .nav-tabs > li.active > a:hover, .fmcy-plugin-bootstrap .nav-tabs > li.active > a:focus {\n        color: #555555;\n        background-color: #fff;\n        border: 1px solid #ddd;\n        border-bottom-color: transparent;\n        cursor: default; }\n  .fmcy-plugin-bootstrap .nav-pills > li {\n    float: left; }\n    .fmcy-plugin-bootstrap .nav-pills > li > a {\n      border-radius: 4px; }\n    .fmcy-plugin-bootstrap .nav-pills > li + li {\n      margin-left: 2px; }\n    .fmcy-plugin-bootstrap .nav-pills > li.active > a, .fmcy-plugin-bootstrap .nav-pills > li.active > a:hover, .fmcy-plugin-bootstrap .nav-pills > li.active > a:focus {\n      color: #fff;\n      background-color: #337ab7; }\n  .fmcy-plugin-bootstrap .nav-stacked > li {\n    float: none; }\n    .fmcy-plugin-bootstrap .nav-stacked > li + li {\n      margin-top: 2px;\n      margin-left: 0; }\n  .fmcy-plugin-bootstrap .nav-justified, .fmcy-plugin-bootstrap .nav-tabs.nav-justified {\n    width: 100%; }\n    .fmcy-plugin-bootstrap .nav-justified > li, .fmcy-plugin-bootstrap .nav-tabs.nav-justified > li {\n      float: none; }\n      .fmcy-plugin-bootstrap .nav-justified > li > a, .fmcy-plugin-bootstrap .nav-tabs.nav-justified > li > a {\n        text-align: center;\n        margin-bottom: 5px; }\n    .fmcy-plugin-bootstrap .nav-justified > .dropdown .dropdown-menu {\n      top: auto;\n      left: auto; }\n    @media (min-width: 768px) {\n      .fmcy-plugin-bootstrap .nav-justified > li, .fmcy-plugin-bootstrap .nav-tabs.nav-justified > li {\n        display: table-cell;\n        width: 1%; }\n        .fmcy-plugin-bootstrap .nav-justified > li > a, .fmcy-plugin-bootstrap .nav-tabs.nav-justified > li > a {\n          margin-bottom: 0; } }\n  .fmcy-plugin-bootstrap .nav-tabs-justified, .fmcy-plugin-bootstrap .nav-tabs.nav-justified {\n    border-bottom: 0; }\n    .fmcy-plugin-bootstrap .nav-tabs-justified > li > a, .fmcy-plugin-bootstrap .nav-tabs.nav-justified > li > a {\n      margin-right: 0;\n      border-radius: 4px; }\n    .fmcy-plugin-bootstrap .nav-tabs-justified > .active > a, .fmcy-plugin-bootstrap .nav-tabs.nav-justified > .active > a,\n    .fmcy-plugin-bootstrap .nav-tabs-justified > .active > a:hover, .fmcy-plugin-bootstrap .nav-tabs.nav-justified > .active > a:hover,\n    .fmcy-plugin-bootstrap .nav-tabs-justified > .active > a:focus, .fmcy-plugin-bootstrap .nav-tabs.nav-justified > .active > a:focus {\n      border: 1px solid #ddd; }\n    @media (min-width: 768px) {\n      .fmcy-plugin-bootstrap .nav-tabs-justified > li > a, .fmcy-plugin-bootstrap .nav-tabs.nav-justified > li > a {\n        border-bottom: 1px solid #ddd;\n        border-radius: 4px 4px 0 0; }\n      .fmcy-plugin-bootstrap .nav-tabs-justified > .active > a, .fmcy-plugin-bootstrap .nav-tabs.nav-justified > .active > a,\n      .fmcy-plugin-bootstrap .nav-tabs-justified > .active > a:hover, .fmcy-plugin-bootstrap .nav-tabs.nav-justified > .active > a:hover,\n      .fmcy-plugin-bootstrap .nav-tabs-justified > .active > a:focus, .fmcy-plugin-bootstrap .nav-tabs.nav-justified > .active > a:focus {\n        border-bottom-color: #fff; } }\n  .fmcy-plugin-bootstrap .tab-content > .tab-pane {\n    display: none; }\n  .fmcy-plugin-bootstrap .tab-content > .active {\n    display: block; }\n  .fmcy-plugin-bootstrap .nav-tabs .dropdown-menu {\n    margin-top: -1px;\n    border-top-right-radius: 0;\n    border-top-left-radius: 0; }\n  .fmcy-plugin-bootstrap .navbar {\n    position: relative;\n    min-height: 50px;\n    margin-bottom: 20px;\n    border: 1px solid transparent; }\n    .fmcy-plugin-bootstrap .navbar:before, .fmcy-plugin-bootstrap .navbar:after {\n      content: \" \";\n      display: table; }\n    .fmcy-plugin-bootstrap .navbar:after {\n      clear: both; }\n    @media (min-width: 768px) {\n      .fmcy-plugin-bootstrap .navbar {\n        border-radius: 4px; } }\n  .fmcy-plugin-bootstrap .navbar-header:before, .fmcy-plugin-bootstrap .navbar-header:after {\n    content: \" \";\n    display: table; }\n  .fmcy-plugin-bootstrap .navbar-header:after {\n    clear: both; }\n  @media (min-width: 768px) {\n    .fmcy-plugin-bootstrap .navbar-header {\n      float: left; } }\n  .fmcy-plugin-bootstrap .navbar-collapse {\n    overflow-x: visible;\n    padding-right: 15px;\n    padding-left: 15px;\n    border-top: 1px solid transparent;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);\n    -webkit-overflow-scrolling: touch; }\n    .fmcy-plugin-bootstrap .navbar-collapse:before, .fmcy-plugin-bootstrap .navbar-collapse:after {\n      content: \" \";\n      display: table; }\n    .fmcy-plugin-bootstrap .navbar-collapse:after {\n      clear: both; }\n    .fmcy-plugin-bootstrap .navbar-collapse.in {\n      overflow-y: auto; }\n    @media (min-width: 768px) {\n      .fmcy-plugin-bootstrap .navbar-collapse {\n        width: auto;\n        border-top: 0;\n        box-shadow: none; }\n        .fmcy-plugin-bootstrap .navbar-collapse.collapse {\n          display: block !important;\n          height: auto !important;\n          padding-bottom: 0;\n          overflow: visible !important; }\n        .fmcy-plugin-bootstrap .navbar-collapse.in {\n          overflow-y: visible; }\n        .navbar-fixed-top .fmcy-plugin-bootstrap .navbar-collapse,\n        .navbar-static-top .fmcy-plugin-bootstrap .navbar-collapse,\n        .navbar-fixed-bottom .fmcy-plugin-bootstrap .navbar-collapse {\n          padding-left: 0;\n          padding-right: 0; } }\n  .fmcy-plugin-bootstrap .navbar-fixed-top .navbar-collapse,\n  .fmcy-plugin-bootstrap .navbar-fixed-bottom .navbar-collapse {\n    max-height: 340px; }\n    @media (max-device-width: 480px) and (orientation: landscape) {\n      .fmcy-plugin-bootstrap .navbar-fixed-top .navbar-collapse,\n      .fmcy-plugin-bootstrap .navbar-fixed-bottom .navbar-collapse {\n        max-height: 200px; } }\n  .fmcy-plugin-bootstrap .container > .navbar-header,\n  .fmcy-plugin-bootstrap .container > .navbar-collapse,\n  .fmcy-plugin-bootstrap .container-fluid > .navbar-header,\n  .fmcy-plugin-bootstrap .container-fluid > .navbar-collapse {\n    margin-right: -15px;\n    margin-left: -15px; }\n    @media (min-width: 768px) {\n      .fmcy-plugin-bootstrap .container > .navbar-header,\n      .fmcy-plugin-bootstrap .container > .navbar-collapse,\n      .fmcy-plugin-bootstrap .container-fluid > .navbar-header,\n      .fmcy-plugin-bootstrap .container-fluid > .navbar-collapse {\n        margin-right: 0;\n        margin-left: 0; } }\n  .fmcy-plugin-bootstrap .navbar-static-top {\n    z-index: 1000;\n    border-width: 0 0 1px; }\n    @media (min-width: 768px) {\n      .fmcy-plugin-bootstrap .navbar-static-top {\n        border-radius: 0; } }\n  .fmcy-plugin-bootstrap .navbar-fixed-top,\n  .fmcy-plugin-bootstrap .navbar-fixed-bottom {\n    position: fixed;\n    right: 0;\n    left: 0;\n    z-index: 1030; }\n    @media (min-width: 768px) {\n      .fmcy-plugin-bootstrap .navbar-fixed-top,\n      .fmcy-plugin-bootstrap .navbar-fixed-bottom {\n        border-radius: 0; } }\n  .fmcy-plugin-bootstrap .navbar-fixed-top {\n    top: 0;\n    border-width: 0 0 1px; }\n  .fmcy-plugin-bootstrap .navbar-fixed-bottom {\n    bottom: 0;\n    margin-bottom: 0;\n    border-width: 1px 0 0; }\n  .fmcy-plugin-bootstrap .navbar-brand {\n    float: left;\n    padding: 15px 15px;\n    font-size: 18px;\n    line-height: 20px;\n    height: 50px; }\n    .fmcy-plugin-bootstrap .navbar-brand:hover, .fmcy-plugin-bootstrap .navbar-brand:focus {\n      text-decoration: none; }\n    .fmcy-plugin-bootstrap .navbar-brand > img {\n      display: block; }\n    @media (min-width: 768px) {\n      .navbar > .container .fmcy-plugin-bootstrap .navbar-brand,\n      .navbar > .container-fluid .fmcy-plugin-bootstrap .navbar-brand {\n        margin-left: -15px; } }\n  .fmcy-plugin-bootstrap .navbar-toggle {\n    position: relative;\n    float: right;\n    margin-right: 15px;\n    padding: 9px 10px;\n    margin-top: 8px;\n    margin-bottom: 8px;\n    background-color: transparent;\n    background-image: none;\n    border: 1px solid transparent;\n    border-radius: 4px; }\n    .fmcy-plugin-bootstrap .navbar-toggle:focus {\n      outline: 0; }\n    .fmcy-plugin-bootstrap .navbar-toggle .icon-bar {\n      display: block;\n      width: 22px;\n      height: 2px;\n      border-radius: 1px; }\n    .fmcy-plugin-bootstrap .navbar-toggle .icon-bar + .icon-bar {\n      margin-top: 4px; }\n    @media (min-width: 768px) {\n      .fmcy-plugin-bootstrap .navbar-toggle {\n        display: none; } }\n  .fmcy-plugin-bootstrap .navbar-nav {\n    margin: 7.5px -15px; }\n    .fmcy-plugin-bootstrap .navbar-nav > li > a {\n      padding-top: 10px;\n      padding-bottom: 10px;\n      line-height: 20px; }\n    @media (max-width: 767px) {\n      .fmcy-plugin-bootstrap .navbar-nav .open .dropdown-menu {\n        position: static;\n        float: none;\n        width: auto;\n        margin-top: 0;\n        background-color: transparent;\n        border: 0;\n        box-shadow: none; }\n        .fmcy-plugin-bootstrap .navbar-nav .open .dropdown-menu > li > a,\n        .fmcy-plugin-bootstrap .navbar-nav .open .dropdown-menu .dropdown-header {\n          padding: 5px 15px 5px 25px; }\n        .fmcy-plugin-bootstrap .navbar-nav .open .dropdown-menu > li > a {\n          line-height: 20px; }\n          .fmcy-plugin-bootstrap .navbar-nav .open .dropdown-menu > li > a:hover, .fmcy-plugin-bootstrap .navbar-nav .open .dropdown-menu > li > a:focus {\n            background-image: none; } }\n    @media (min-width: 768px) {\n      .fmcy-plugin-bootstrap .navbar-nav {\n        float: left;\n        margin: 0; }\n        .fmcy-plugin-bootstrap .navbar-nav > li {\n          float: left; }\n          .fmcy-plugin-bootstrap .navbar-nav > li > a {\n            padding-top: 15px;\n            padding-bottom: 15px; } }\n  .fmcy-plugin-bootstrap .navbar-form {\n    margin-left: -15px;\n    margin-right: -15px;\n    padding: 10px 15px;\n    border-top: 1px solid transparent;\n    border-bottom: 1px solid transparent;\n    -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.1);\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.1);\n    margin-top: 8px;\n    margin-bottom: 8px; }\n    @media (min-width: 768px) {\n      .fmcy-plugin-bootstrap .navbar-form .form-group {\n        display: inline-block;\n        margin-bottom: 0;\n        vertical-align: middle; }\n      .fmcy-plugin-bootstrap .navbar-form .form-control {\n        display: inline-block;\n        width: auto;\n        vertical-align: middle; }\n      .fmcy-plugin-bootstrap .navbar-form .form-control-static {\n        display: inline-block; }\n      .fmcy-plugin-bootstrap .navbar-form .input-group {\n        display: inline-table;\n        vertical-align: middle; }\n        .fmcy-plugin-bootstrap .navbar-form .input-group .input-group-addon,\n        .fmcy-plugin-bootstrap .navbar-form .input-group .input-group-btn,\n        .fmcy-plugin-bootstrap .navbar-form .input-group .form-control {\n          width: auto; }\n      .fmcy-plugin-bootstrap .navbar-form .input-group > .form-control {\n        width: 100%; }\n      .fmcy-plugin-bootstrap .navbar-form .control-label {\n        margin-bottom: 0;\n        vertical-align: middle; }\n      .fmcy-plugin-bootstrap .navbar-form .radio,\n      .fmcy-plugin-bootstrap .navbar-form .checkbox {\n        display: inline-block;\n        margin-top: 0;\n        margin-bottom: 0;\n        vertical-align: middle; }\n        .fmcy-plugin-bootstrap .navbar-form .radio label,\n        .fmcy-plugin-bootstrap .navbar-form .checkbox label {\n          padding-left: 0; }\n      .fmcy-plugin-bootstrap .navbar-form .radio input[type=\"radio\"],\n      .fmcy-plugin-bootstrap .navbar-form .checkbox input[type=\"checkbox\"] {\n        position: relative;\n        margin-left: 0; }\n      .fmcy-plugin-bootstrap .navbar-form .has-feedback .form-control-feedback {\n        top: 0; } }\n    @media (max-width: 767px) {\n      .fmcy-plugin-bootstrap .navbar-form .form-group {\n        margin-bottom: 5px; }\n        .fmcy-plugin-bootstrap .navbar-form .form-group:last-child {\n          margin-bottom: 0; } }\n    @media (min-width: 768px) {\n      .fmcy-plugin-bootstrap .navbar-form {\n        width: auto;\n        border: 0;\n        margin-left: 0;\n        margin-right: 0;\n        padding-top: 0;\n        padding-bottom: 0;\n        -webkit-box-shadow: none;\n        box-shadow: none; } }\n  .fmcy-plugin-bootstrap .navbar-nav > li > .dropdown-menu {\n    margin-top: 0;\n    border-top-right-radius: 0;\n    border-top-left-radius: 0; }\n  .fmcy-plugin-bootstrap .navbar-fixed-bottom .navbar-nav > li > .dropdown-menu {\n    margin-bottom: 0;\n    border-top-right-radius: 4px;\n    border-top-left-radius: 4px;\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0; }\n  .fmcy-plugin-bootstrap .navbar-btn {\n    margin-top: 8px;\n    margin-bottom: 8px; }\n    .fmcy-plugin-bootstrap .navbar-btn.btn-sm, .fmcy-plugin-bootstrap .btn-group-sm > .navbar-btn.btn {\n      margin-top: 10px;\n      margin-bottom: 10px; }\n    .fmcy-plugin-bootstrap .navbar-btn.btn-xs, .fmcy-plugin-bootstrap .btn-group-xs > .navbar-btn.btn {\n      margin-top: 14px;\n      margin-bottom: 14px; }\n  .fmcy-plugin-bootstrap .navbar-text {\n    margin-top: 15px;\n    margin-bottom: 15px; }\n    @media (min-width: 768px) {\n      .fmcy-plugin-bootstrap .navbar-text {\n        float: left;\n        margin-left: 15px;\n        margin-right: 15px; } }\n  @media (min-width: 768px) {\n    .fmcy-plugin-bootstrap .navbar-left {\n      float: left !important; }\n    .fmcy-plugin-bootstrap .navbar-right {\n      float: right !important;\n      margin-right: -15px; }\n      .fmcy-plugin-bootstrap .navbar-right ~ .navbar-right {\n        margin-right: 0; } }\n  .fmcy-plugin-bootstrap .navbar-default {\n    background-color: #f8f8f8;\n    border-color: #e7e7e7; }\n    .fmcy-plugin-bootstrap .navbar-default .navbar-brand {\n      color: #777; }\n      .fmcy-plugin-bootstrap .navbar-default .navbar-brand:hover, .fmcy-plugin-bootstrap .navbar-default .navbar-brand:focus {\n        color: #5e5e5e;\n        background-color: transparent; }\n    .fmcy-plugin-bootstrap .navbar-default .navbar-text {\n      color: #777; }\n    .fmcy-plugin-bootstrap .navbar-default .navbar-nav > li > a {\n      color: #777; }\n      .fmcy-plugin-bootstrap .navbar-default .navbar-nav > li > a:hover, .fmcy-plugin-bootstrap .navbar-default .navbar-nav > li > a:focus {\n        color: #333;\n        background-color: transparent; }\n    .fmcy-plugin-bootstrap .navbar-default .navbar-nav > .active > a, .fmcy-plugin-bootstrap .navbar-default .navbar-nav > .active > a:hover, .fmcy-plugin-bootstrap .navbar-default .navbar-nav > .active > a:focus {\n      color: #555;\n      background-color: #e7e7e7; }\n    .fmcy-plugin-bootstrap .navbar-default .navbar-nav > .disabled > a, .fmcy-plugin-bootstrap .navbar-default .navbar-nav > .disabled > a:hover, .fmcy-plugin-bootstrap .navbar-default .navbar-nav > .disabled > a:focus {\n      color: #ccc;\n      background-color: transparent; }\n    .fmcy-plugin-bootstrap .navbar-default .navbar-toggle {\n      border-color: #ddd; }\n      .fmcy-plugin-bootstrap .navbar-default .navbar-toggle:hover, .fmcy-plugin-bootstrap .navbar-default .navbar-toggle:focus {\n        background-color: #ddd; }\n      .fmcy-plugin-bootstrap .navbar-default .navbar-toggle .icon-bar {\n        background-color: #888; }\n    .fmcy-plugin-bootstrap .navbar-default .navbar-collapse,\n    .fmcy-plugin-bootstrap .navbar-default .navbar-form {\n      border-color: #e7e7e7; }\n    .fmcy-plugin-bootstrap .navbar-default .navbar-nav > .open > a, .fmcy-plugin-bootstrap .navbar-default .navbar-nav > .open > a:hover, .fmcy-plugin-bootstrap .navbar-default .navbar-nav > .open > a:focus {\n      background-color: #e7e7e7;\n      color: #555; }\n    @media (max-width: 767px) {\n      .fmcy-plugin-bootstrap .navbar-default .navbar-nav .open .dropdown-menu > li > a {\n        color: #777; }\n        .fmcy-plugin-bootstrap .navbar-default .navbar-nav .open .dropdown-menu > li > a:hover, .fmcy-plugin-bootstrap .navbar-default .navbar-nav .open .dropdown-menu > li > a:focus {\n          color: #333;\n          background-color: transparent; }\n      .fmcy-plugin-bootstrap .navbar-default .navbar-nav .open .dropdown-menu > .active > a, .fmcy-plugin-bootstrap .navbar-default .navbar-nav .open .dropdown-menu > .active > a:hover, .fmcy-plugin-bootstrap .navbar-default .navbar-nav .open .dropdown-menu > .active > a:focus {\n        color: #555;\n        background-color: #e7e7e7; }\n      .fmcy-plugin-bootstrap .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a, .fmcy-plugin-bootstrap .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:hover, .fmcy-plugin-bootstrap .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:focus {\n        color: #ccc;\n        background-color: transparent; } }\n    .fmcy-plugin-bootstrap .navbar-default .navbar-link {\n      color: #777; }\n      .fmcy-plugin-bootstrap .navbar-default .navbar-link:hover {\n        color: #333; }\n    .fmcy-plugin-bootstrap .navbar-default .btn-link {\n      color: #777; }\n      .fmcy-plugin-bootstrap .navbar-default .btn-link:hover, .fmcy-plugin-bootstrap .navbar-default .btn-link:focus {\n        color: #333; }\n      .fmcy-plugin-bootstrap .navbar-default .btn-link[disabled]:hover, .fmcy-plugin-bootstrap .navbar-default .btn-link[disabled]:focus,\n      fieldset[disabled] .fmcy-plugin-bootstrap .navbar-default .btn-link:hover,\n      fieldset[disabled] .fmcy-plugin-bootstrap .navbar-default .btn-link:focus {\n        color: #ccc; }\n  .fmcy-plugin-bootstrap .navbar-inverse {\n    background-color: #222;\n    border-color: #090909; }\n    .fmcy-plugin-bootstrap .navbar-inverse .navbar-brand {\n      color: #9d9d9d; }\n      .fmcy-plugin-bootstrap .navbar-inverse .navbar-brand:hover, .fmcy-plugin-bootstrap .navbar-inverse .navbar-brand:focus {\n        color: #fff;\n        background-color: transparent; }\n    .fmcy-plugin-bootstrap .navbar-inverse .navbar-text {\n      color: #9d9d9d; }\n    .fmcy-plugin-bootstrap .navbar-inverse .navbar-nav > li > a {\n      color: #9d9d9d; }\n      .fmcy-plugin-bootstrap .navbar-inverse .navbar-nav > li > a:hover, .fmcy-plugin-bootstrap .navbar-inverse .navbar-nav > li > a:focus {\n        color: #fff;\n        background-color: transparent; }\n    .fmcy-plugin-bootstrap .navbar-inverse .navbar-nav > .active > a, .fmcy-plugin-bootstrap .navbar-inverse .navbar-nav > .active > a:hover, .fmcy-plugin-bootstrap .navbar-inverse .navbar-nav > .active > a:focus {\n      color: #fff;\n      background-color: #090909; }\n    .fmcy-plugin-bootstrap .navbar-inverse .navbar-nav > .disabled > a, .fmcy-plugin-bootstrap .navbar-inverse .navbar-nav > .disabled > a:hover, .fmcy-plugin-bootstrap .navbar-inverse .navbar-nav > .disabled > a:focus {\n      color: #444;\n      background-color: transparent; }\n    .fmcy-plugin-bootstrap .navbar-inverse .navbar-toggle {\n      border-color: #333; }\n      .fmcy-plugin-bootstrap .navbar-inverse .navbar-toggle:hover, .fmcy-plugin-bootstrap .navbar-inverse .navbar-toggle:focus {\n        background-color: #333; }\n      .fmcy-plugin-bootstrap .navbar-inverse .navbar-toggle .icon-bar {\n        background-color: #fff; }\n    .fmcy-plugin-bootstrap .navbar-inverse .navbar-collapse,\n    .fmcy-plugin-bootstrap .navbar-inverse .navbar-form {\n      border-color: #101010; }\n    .fmcy-plugin-bootstrap .navbar-inverse .navbar-nav > .open > a, .fmcy-plugin-bootstrap .navbar-inverse .navbar-nav > .open > a:hover, .fmcy-plugin-bootstrap .navbar-inverse .navbar-nav > .open > a:focus {\n      background-color: #090909;\n      color: #fff; }\n    @media (max-width: 767px) {\n      .fmcy-plugin-bootstrap .navbar-inverse .navbar-nav .open .dropdown-menu > .dropdown-header {\n        border-color: #090909; }\n      .fmcy-plugin-bootstrap .navbar-inverse .navbar-nav .open .dropdown-menu .divider {\n        background-color: #090909; }\n      .fmcy-plugin-bootstrap .navbar-inverse .navbar-nav .open .dropdown-menu > li > a {\n        color: #9d9d9d; }\n        .fmcy-plugin-bootstrap .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:hover, .fmcy-plugin-bootstrap .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:focus {\n          color: #fff;\n          background-color: transparent; }\n      .fmcy-plugin-bootstrap .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a, .fmcy-plugin-bootstrap .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:hover, .fmcy-plugin-bootstrap .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:focus {\n        color: #fff;\n        background-color: #090909; }\n      .fmcy-plugin-bootstrap .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a, .fmcy-plugin-bootstrap .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:hover, .fmcy-plugin-bootstrap .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:focus {\n        color: #444;\n        background-color: transparent; } }\n    .fmcy-plugin-bootstrap .navbar-inverse .navbar-link {\n      color: #9d9d9d; }\n      .fmcy-plugin-bootstrap .navbar-inverse .navbar-link:hover {\n        color: #fff; }\n    .fmcy-plugin-bootstrap .navbar-inverse .btn-link {\n      color: #9d9d9d; }\n      .fmcy-plugin-bootstrap .navbar-inverse .btn-link:hover, .fmcy-plugin-bootstrap .navbar-inverse .btn-link:focus {\n        color: #fff; }\n      .fmcy-plugin-bootstrap .navbar-inverse .btn-link[disabled]:hover, .fmcy-plugin-bootstrap .navbar-inverse .btn-link[disabled]:focus,\n      fieldset[disabled] .fmcy-plugin-bootstrap .navbar-inverse .btn-link:hover,\n      fieldset[disabled] .fmcy-plugin-bootstrap .navbar-inverse .btn-link:focus {\n        color: #444; }\n  .fmcy-plugin-bootstrap .breadcrumb {\n    padding: 8px 15px;\n    margin-bottom: 20px;\n    list-style: none;\n    background-color: #f5f5f5;\n    border-radius: 4px; }\n    .fmcy-plugin-bootstrap .breadcrumb > li {\n      display: inline-block; }\n      .fmcy-plugin-bootstrap .breadcrumb > li + li:before {\n        content: \"/\\A0\";\n        padding: 0 5px;\n        color: #ccc; }\n    .fmcy-plugin-bootstrap .breadcrumb > .active {\n      color: #777777; }\n  .fmcy-plugin-bootstrap .pagination {\n    display: inline-block;\n    padding-left: 0;\n    margin: 20px 0;\n    border-radius: 4px; }\n    .fmcy-plugin-bootstrap .pagination > li {\n      display: inline; }\n      .fmcy-plugin-bootstrap .pagination > li > a,\n      .fmcy-plugin-bootstrap .pagination > li > span {\n        position: relative;\n        float: left;\n        padding: 6px 12px;\n        line-height: 1.42857;\n        text-decoration: none;\n        color: #337ab7;\n        background-color: #fff;\n        border: 1px solid #ddd;\n        margin-left: -1px; }\n      .fmcy-plugin-bootstrap .pagination > li:first-child > a,\n      .fmcy-plugin-bootstrap .pagination > li:first-child > span {\n        margin-left: 0;\n        border-bottom-left-radius: 4px;\n        border-top-left-radius: 4px; }\n      .fmcy-plugin-bootstrap .pagination > li:last-child > a,\n      .fmcy-plugin-bootstrap .pagination > li:last-child > span {\n        border-bottom-right-radius: 4px;\n        border-top-right-radius: 4px; }\n    .fmcy-plugin-bootstrap .pagination > li > a:hover, .fmcy-plugin-bootstrap .pagination > li > a:focus,\n    .fmcy-plugin-bootstrap .pagination > li > span:hover,\n    .fmcy-plugin-bootstrap .pagination > li > span:focus {\n      z-index: 2;\n      color: #23527c;\n      background-color: #eeeeee;\n      border-color: #ddd; }\n    .fmcy-plugin-bootstrap .pagination > .active > a, .fmcy-plugin-bootstrap .pagination > .active > a:hover, .fmcy-plugin-bootstrap .pagination > .active > a:focus,\n    .fmcy-plugin-bootstrap .pagination > .active > span,\n    .fmcy-plugin-bootstrap .pagination > .active > span:hover,\n    .fmcy-plugin-bootstrap .pagination > .active > span:focus {\n      z-index: 3;\n      color: #fff;\n      background-color: #337ab7;\n      border-color: #337ab7;\n      cursor: default; }\n    .fmcy-plugin-bootstrap .pagination > .disabled > span,\n    .fmcy-plugin-bootstrap .pagination > .disabled > span:hover,\n    .fmcy-plugin-bootstrap .pagination > .disabled > span:focus,\n    .fmcy-plugin-bootstrap .pagination > .disabled > a,\n    .fmcy-plugin-bootstrap .pagination > .disabled > a:hover,\n    .fmcy-plugin-bootstrap .pagination > .disabled > a:focus {\n      color: #777777;\n      background-color: #fff;\n      border-color: #ddd;\n      cursor: not-allowed; }\n  .fmcy-plugin-bootstrap .pagination-lg > li > a,\n  .fmcy-plugin-bootstrap .pagination-lg > li > span {\n    padding: 10px 16px;\n    font-size: 18px;\n    line-height: 1.33333; }\n  .fmcy-plugin-bootstrap .pagination-lg > li:first-child > a,\n  .fmcy-plugin-bootstrap .pagination-lg > li:first-child > span {\n    border-bottom-left-radius: 6px;\n    border-top-left-radius: 6px; }\n  .fmcy-plugin-bootstrap .pagination-lg > li:last-child > a,\n  .fmcy-plugin-bootstrap .pagination-lg > li:last-child > span {\n    border-bottom-right-radius: 6px;\n    border-top-right-radius: 6px; }\n  .fmcy-plugin-bootstrap .pagination-sm > li > a,\n  .fmcy-plugin-bootstrap .pagination-sm > li > span {\n    padding: 5px 10px;\n    font-size: 12px;\n    line-height: 1.5; }\n  .fmcy-plugin-bootstrap .pagination-sm > li:first-child > a,\n  .fmcy-plugin-bootstrap .pagination-sm > li:first-child > span {\n    border-bottom-left-radius: 3px;\n    border-top-left-radius: 3px; }\n  .fmcy-plugin-bootstrap .pagination-sm > li:last-child > a,\n  .fmcy-plugin-bootstrap .pagination-sm > li:last-child > span {\n    border-bottom-right-radius: 3px;\n    border-top-right-radius: 3px; }\n  .fmcy-plugin-bootstrap .pager {\n    padding-left: 0;\n    margin: 20px 0;\n    list-style: none;\n    text-align: center; }\n    .fmcy-plugin-bootstrap .pager:before, .fmcy-plugin-bootstrap .pager:after {\n      content: \" \";\n      display: table; }\n    .fmcy-plugin-bootstrap .pager:after {\n      clear: both; }\n    .fmcy-plugin-bootstrap .pager li {\n      display: inline; }\n      .fmcy-plugin-bootstrap .pager li > a,\n      .fmcy-plugin-bootstrap .pager li > span {\n        display: inline-block;\n        padding: 5px 14px;\n        background-color: #fff;\n        border: 1px solid #ddd;\n        border-radius: 15px; }\n      .fmcy-plugin-bootstrap .pager li > a:hover,\n      .fmcy-plugin-bootstrap .pager li > a:focus {\n        text-decoration: none;\n        background-color: #eeeeee; }\n    .fmcy-plugin-bootstrap .pager .next > a,\n    .fmcy-plugin-bootstrap .pager .next > span {\n      float: right; }\n    .fmcy-plugin-bootstrap .pager .previous > a,\n    .fmcy-plugin-bootstrap .pager .previous > span {\n      float: left; }\n    .fmcy-plugin-bootstrap .pager .disabled > a,\n    .fmcy-plugin-bootstrap .pager .disabled > a:hover,\n    .fmcy-plugin-bootstrap .pager .disabled > a:focus,\n    .fmcy-plugin-bootstrap .pager .disabled > span {\n      color: #777777;\n      background-color: #fff;\n      cursor: not-allowed; }\n  .fmcy-plugin-bootstrap .label {\n    display: inline;\n    padding: .2em .6em .3em;\n    font-size: 75%;\n    font-weight: bold;\n    line-height: 1;\n    color: #fff;\n    text-align: center;\n    white-space: nowrap;\n    vertical-align: baseline;\n    border-radius: .25em; }\n    .fmcy-plugin-bootstrap .label:empty {\n      display: none; }\n    .btn .fmcy-plugin-bootstrap .label {\n      position: relative;\n      top: -1px; }\n  .fmcy-plugin-bootstrap a.label:hover, .fmcy-plugin-bootstrap a.label:focus {\n    color: #fff;\n    text-decoration: none;\n    cursor: pointer; }\n  .fmcy-plugin-bootstrap .label-default {\n    background-color: #777777; }\n    .fmcy-plugin-bootstrap .label-default[href]:hover, .fmcy-plugin-bootstrap .label-default[href]:focus {\n      background-color: #5e5e5e; }\n  .fmcy-plugin-bootstrap .label-primary {\n    background-color: #337ab7; }\n    .fmcy-plugin-bootstrap .label-primary[href]:hover, .fmcy-plugin-bootstrap .label-primary[href]:focus {\n      background-color: #286090; }\n  .fmcy-plugin-bootstrap .label-success {\n    background-color: #5cb85c; }\n    .fmcy-plugin-bootstrap .label-success[href]:hover, .fmcy-plugin-bootstrap .label-success[href]:focus {\n      background-color: #449d44; }\n  .fmcy-plugin-bootstrap .label-info {\n    background-color: #5bc0de; }\n    .fmcy-plugin-bootstrap .label-info[href]:hover, .fmcy-plugin-bootstrap .label-info[href]:focus {\n      background-color: #31b0d5; }\n  .fmcy-plugin-bootstrap .label-warning {\n    background-color: #f0ad4e; }\n    .fmcy-plugin-bootstrap .label-warning[href]:hover, .fmcy-plugin-bootstrap .label-warning[href]:focus {\n      background-color: #ec971f; }\n  .fmcy-plugin-bootstrap .label-danger {\n    background-color: #d9534f; }\n    .fmcy-plugin-bootstrap .label-danger[href]:hover, .fmcy-plugin-bootstrap .label-danger[href]:focus {\n      background-color: #c9302c; }\n  .fmcy-plugin-bootstrap .badge {\n    display: inline-block;\n    min-width: 10px;\n    padding: 3px 7px;\n    font-size: 12px;\n    font-weight: bold;\n    color: #fff;\n    line-height: 1;\n    vertical-align: middle;\n    white-space: nowrap;\n    text-align: center;\n    background-color: #777777;\n    border-radius: 10px; }\n    .fmcy-plugin-bootstrap .badge:empty {\n      display: none; }\n    .btn .fmcy-plugin-bootstrap .badge {\n      position: relative;\n      top: -1px; }\n    .btn-xs .fmcy-plugin-bootstrap .badge, .fmcy-plugin-bootstrap .btn-group-xs > .btn .fmcy-plugin-bootstrap .badge,\n    .btn-group-xs > .btn .fmcy-plugin-bootstrap .badge {\n      top: 0;\n      padding: 1px 5px; }\n    .list-group-item.active > .fmcy-plugin-bootstrap .badge,\n    .nav-pills > .active > a > .fmcy-plugin-bootstrap .badge {\n      color: #337ab7;\n      background-color: #fff; }\n    .list-group-item > .fmcy-plugin-bootstrap .badge {\n      float: right; }\n    .list-group-item > .fmcy-plugin-bootstrap .badge + .fmcy-plugin-bootstrap .badge {\n      margin-right: 5px; }\n    .nav-pills > li > a > .fmcy-plugin-bootstrap .badge {\n      margin-left: 3px; }\n  .fmcy-plugin-bootstrap a.badge:hover, .fmcy-plugin-bootstrap a.badge:focus {\n    color: #fff;\n    text-decoration: none;\n    cursor: pointer; }\n  .fmcy-plugin-bootstrap .jumbotron {\n    padding-top: 30px;\n    padding-bottom: 30px;\n    margin-bottom: 30px;\n    color: inherit;\n    background-color: #eeeeee; }\n    .fmcy-plugin-bootstrap .jumbotron h1,\n    .fmcy-plugin-bootstrap .jumbotron .h1 {\n      color: inherit; }\n    .fmcy-plugin-bootstrap .jumbotron p {\n      margin-bottom: 15px;\n      font-size: 21px;\n      font-weight: 200; }\n    .fmcy-plugin-bootstrap .jumbotron > hr {\n      border-top-color: #d5d5d5; }\n    .container .fmcy-plugin-bootstrap .jumbotron,\n    .container-fluid .fmcy-plugin-bootstrap .jumbotron {\n      border-radius: 6px;\n      padding-left: 15px;\n      padding-right: 15px; }\n    .fmcy-plugin-bootstrap .jumbotron .container {\n      max-width: 100%; }\n    @media screen and (min-width: 768px) {\n      .fmcy-plugin-bootstrap .jumbotron {\n        padding-top: 48px;\n        padding-bottom: 48px; }\n        .container .fmcy-plugin-bootstrap .jumbotron,\n        .container-fluid .fmcy-plugin-bootstrap .jumbotron {\n          padding-left: 60px;\n          padding-right: 60px; }\n        .fmcy-plugin-bootstrap .jumbotron h1,\n        .fmcy-plugin-bootstrap .jumbotron .h1 {\n          font-size: 63px; } }\n  .fmcy-plugin-bootstrap .thumbnail {\n    display: block;\n    padding: 4px;\n    margin-bottom: 20px;\n    line-height: 1.42857;\n    background-color: #fff;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    -webkit-transition: border 0.2s ease-in-out;\n    -o-transition: border 0.2s ease-in-out;\n    transition: border 0.2s ease-in-out; }\n    .fmcy-plugin-bootstrap .thumbnail > img,\n    .fmcy-plugin-bootstrap .thumbnail a > img {\n      display: block;\n      max-width: 100%;\n      height: auto;\n      margin-left: auto;\n      margin-right: auto; }\n    .fmcy-plugin-bootstrap .thumbnail .caption {\n      padding: 9px;\n      color: #333333; }\n  .fmcy-plugin-bootstrap a.thumbnail:hover,\n  .fmcy-plugin-bootstrap a.thumbnail:focus,\n  .fmcy-plugin-bootstrap a.thumbnail.active {\n    border-color: #337ab7; }\n  .fmcy-plugin-bootstrap .alert {\n    padding: 15px;\n    margin-bottom: 20px;\n    border: 1px solid transparent;\n    border-radius: 4px; }\n    .fmcy-plugin-bootstrap .alert h4 {\n      margin-top: 0;\n      color: inherit; }\n    .fmcy-plugin-bootstrap .alert .alert-link {\n      font-weight: bold; }\n    .fmcy-plugin-bootstrap .alert > p,\n    .fmcy-plugin-bootstrap .alert > ul {\n      margin-bottom: 0; }\n    .fmcy-plugin-bootstrap .alert > p + p {\n      margin-top: 5px; }\n  .fmcy-plugin-bootstrap .alert-dismissable,\n  .fmcy-plugin-bootstrap .alert-dismissible {\n    padding-right: 35px; }\n    .fmcy-plugin-bootstrap .alert-dismissable .close,\n    .fmcy-plugin-bootstrap .alert-dismissible .close {\n      position: relative;\n      top: -2px;\n      right: -21px;\n      color: inherit; }\n  .fmcy-plugin-bootstrap .alert-success {\n    background-color: #dff0d8;\n    border-color: #d6e9c6;\n    color: #3c763d; }\n    .fmcy-plugin-bootstrap .alert-success hr {\n      border-top-color: #c9e2b3; }\n    .fmcy-plugin-bootstrap .alert-success .alert-link {\n      color: #2b542c; }\n  .fmcy-plugin-bootstrap .alert-info {\n    background-color: #d9edf7;\n    border-color: #bce8f1;\n    color: #31708f; }\n    .fmcy-plugin-bootstrap .alert-info hr {\n      border-top-color: #a6e1ec; }\n    .fmcy-plugin-bootstrap .alert-info .alert-link {\n      color: #245269; }\n  .fmcy-plugin-bootstrap .alert-warning {\n    background-color: #fcf8e3;\n    border-color: #faebcc;\n    color: #8a6d3b; }\n    .fmcy-plugin-bootstrap .alert-warning hr {\n      border-top-color: #f7e1b5; }\n    .fmcy-plugin-bootstrap .alert-warning .alert-link {\n      color: #66512c; }\n  .fmcy-plugin-bootstrap .alert-danger {\n    background-color: #f2dede;\n    border-color: #ebccd1;\n    color: #a94442; }\n    .fmcy-plugin-bootstrap .alert-danger hr {\n      border-top-color: #e4b9c0; }\n    .fmcy-plugin-bootstrap .alert-danger .alert-link {\n      color: #843534; }\n\n@-webkit-keyframes progress-bar-stripes {\n  from {\n    background-position: 40px 0; }\n  to {\n    background-position: 0 0; } }\n\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 40px 0; }\n  to {\n    background-position: 0 0; } }\n  .fmcy-plugin-bootstrap .progress {\n    overflow: hidden;\n    height: 20px;\n    margin-bottom: 20px;\n    background-color: #f5f5f5;\n    border-radius: 4px;\n    -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1); }\n  .fmcy-plugin-bootstrap .progress-bar {\n    float: left;\n    width: 0%;\n    height: 100%;\n    font-size: 12px;\n    line-height: 20px;\n    color: #fff;\n    text-align: center;\n    background-color: #337ab7;\n    -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);\n    box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);\n    -webkit-transition: width 0.6s ease;\n    -o-transition: width 0.6s ease;\n    transition: width 0.6s ease; }\n  .fmcy-plugin-bootstrap .progress-striped .progress-bar,\n  .fmcy-plugin-bootstrap .progress-bar-striped {\n    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-size: 40px 40px; }\n  .fmcy-plugin-bootstrap .progress.active .progress-bar,\n  .fmcy-plugin-bootstrap .progress-bar.active {\n    -webkit-animation: progress-bar-stripes 2s linear infinite;\n    -o-animation: progress-bar-stripes 2s linear infinite;\n    animation: progress-bar-stripes 2s linear infinite; }\n  .fmcy-plugin-bootstrap .progress-bar-success {\n    background-color: #5cb85c; }\n    .progress-striped .fmcy-plugin-bootstrap .progress-bar-success {\n      background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n      background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n      background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent); }\n  .fmcy-plugin-bootstrap .progress-bar-info {\n    background-color: #5bc0de; }\n    .progress-striped .fmcy-plugin-bootstrap .progress-bar-info {\n      background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n      background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n      background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent); }\n  .fmcy-plugin-bootstrap .progress-bar-warning {\n    background-color: #f0ad4e; }\n    .progress-striped .fmcy-plugin-bootstrap .progress-bar-warning {\n      background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n      background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n      background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent); }\n  .fmcy-plugin-bootstrap .progress-bar-danger {\n    background-color: #d9534f; }\n    .progress-striped .fmcy-plugin-bootstrap .progress-bar-danger {\n      background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n      background-image: -o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n      background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent); }\n  .fmcy-plugin-bootstrap .media {\n    margin-top: 15px; }\n    .fmcy-plugin-bootstrap .media:first-child {\n      margin-top: 0; }\n  .fmcy-plugin-bootstrap .media,\n  .fmcy-plugin-bootstrap .media-body {\n    zoom: 1;\n    overflow: hidden; }\n  .fmcy-plugin-bootstrap .media-body {\n    width: 10000px; }\n  .fmcy-plugin-bootstrap .media-object {\n    display: block; }\n    .fmcy-plugin-bootstrap .media-object.img-thumbnail {\n      max-width: none; }\n  .fmcy-plugin-bootstrap .media-right,\n  .fmcy-plugin-bootstrap .media > .pull-right {\n    padding-left: 10px; }\n  .fmcy-plugin-bootstrap .media-left,\n  .fmcy-plugin-bootstrap .media > .pull-left {\n    padding-right: 10px; }\n  .fmcy-plugin-bootstrap .media-left,\n  .fmcy-plugin-bootstrap .media-right,\n  .fmcy-plugin-bootstrap .media-body {\n    display: table-cell;\n    vertical-align: top; }\n  .fmcy-plugin-bootstrap .media-middle {\n    vertical-align: middle; }\n  .fmcy-plugin-bootstrap .media-bottom {\n    vertical-align: bottom; }\n  .fmcy-plugin-bootstrap .media-heading {\n    margin-top: 0;\n    margin-bottom: 5px; }\n  .fmcy-plugin-bootstrap .media-list {\n    padding-left: 0;\n    list-style: none; }\n  .fmcy-plugin-bootstrap .list-group {\n    margin-bottom: 20px;\n    padding-left: 0; }\n  .fmcy-plugin-bootstrap .list-group-item {\n    position: relative;\n    display: block;\n    padding: 10px 15px;\n    margin-bottom: -1px;\n    background-color: #fff;\n    border: 1px solid #ddd; }\n    .fmcy-plugin-bootstrap .list-group-item:first-child {\n      border-top-right-radius: 4px;\n      border-top-left-radius: 4px; }\n    .fmcy-plugin-bootstrap .list-group-item:last-child {\n      margin-bottom: 0;\n      border-bottom-right-radius: 4px;\n      border-bottom-left-radius: 4px; }\n  .fmcy-plugin-bootstrap a.list-group-item,\n  .fmcy-plugin-bootstrap button.list-group-item {\n    color: #555; }\n    .fmcy-plugin-bootstrap a.list-group-item .list-group-item-heading,\n    .fmcy-plugin-bootstrap button.list-group-item .list-group-item-heading {\n      color: #333; }\n    .fmcy-plugin-bootstrap a.list-group-item:hover, .fmcy-plugin-bootstrap a.list-group-item:focus,\n    .fmcy-plugin-bootstrap button.list-group-item:hover,\n    .fmcy-plugin-bootstrap button.list-group-item:focus {\n      text-decoration: none;\n      color: #555;\n      background-color: #f5f5f5; }\n  .fmcy-plugin-bootstrap button.list-group-item {\n    width: 100%;\n    text-align: left; }\n  .fmcy-plugin-bootstrap .list-group-item.disabled, .fmcy-plugin-bootstrap .list-group-item.disabled:hover, .fmcy-plugin-bootstrap .list-group-item.disabled:focus {\n    background-color: #eeeeee;\n    color: #777777;\n    cursor: not-allowed; }\n    .fmcy-plugin-bootstrap .list-group-item.disabled .list-group-item-heading, .fmcy-plugin-bootstrap .list-group-item.disabled:hover .list-group-item-heading, .fmcy-plugin-bootstrap .list-group-item.disabled:focus .list-group-item-heading {\n      color: inherit; }\n    .fmcy-plugin-bootstrap .list-group-item.disabled .list-group-item-text, .fmcy-plugin-bootstrap .list-group-item.disabled:hover .list-group-item-text, .fmcy-plugin-bootstrap .list-group-item.disabled:focus .list-group-item-text {\n      color: #777777; }\n  .fmcy-plugin-bootstrap .list-group-item.active, .fmcy-plugin-bootstrap .list-group-item.active:hover, .fmcy-plugin-bootstrap .list-group-item.active:focus {\n    z-index: 2;\n    color: #fff;\n    background-color: #337ab7;\n    border-color: #337ab7; }\n    .fmcy-plugin-bootstrap .list-group-item.active .list-group-item-heading,\n    .fmcy-plugin-bootstrap .list-group-item.active .list-group-item-heading > small,\n    .fmcy-plugin-bootstrap .list-group-item.active .list-group-item-heading > .small, .fmcy-plugin-bootstrap .list-group-item.active:hover .list-group-item-heading,\n    .fmcy-plugin-bootstrap .list-group-item.active:hover .list-group-item-heading > small,\n    .fmcy-plugin-bootstrap .list-group-item.active:hover .list-group-item-heading > .small, .fmcy-plugin-bootstrap .list-group-item.active:focus .list-group-item-heading,\n    .fmcy-plugin-bootstrap .list-group-item.active:focus .list-group-item-heading > small,\n    .fmcy-plugin-bootstrap .list-group-item.active:focus .list-group-item-heading > .small {\n      color: inherit; }\n    .fmcy-plugin-bootstrap .list-group-item.active .list-group-item-text, .fmcy-plugin-bootstrap .list-group-item.active:hover .list-group-item-text, .fmcy-plugin-bootstrap .list-group-item.active:focus .list-group-item-text {\n      color: #c7ddef; }\n  .fmcy-plugin-bootstrap .list-group-item-success {\n    color: #3c763d;\n    background-color: #dff0d8; }\n  .fmcy-plugin-bootstrap a.list-group-item-success,\n  .fmcy-plugin-bootstrap button.list-group-item-success {\n    color: #3c763d; }\n    .fmcy-plugin-bootstrap a.list-group-item-success .list-group-item-heading,\n    .fmcy-plugin-bootstrap button.list-group-item-success .list-group-item-heading {\n      color: inherit; }\n    .fmcy-plugin-bootstrap a.list-group-item-success:hover, .fmcy-plugin-bootstrap a.list-group-item-success:focus,\n    .fmcy-plugin-bootstrap button.list-group-item-success:hover,\n    .fmcy-plugin-bootstrap button.list-group-item-success:focus {\n      color: #3c763d;\n      background-color: #d0e9c6; }\n    .fmcy-plugin-bootstrap a.list-group-item-success.active, .fmcy-plugin-bootstrap a.list-group-item-success.active:hover, .fmcy-plugin-bootstrap a.list-group-item-success.active:focus,\n    .fmcy-plugin-bootstrap button.list-group-item-success.active,\n    .fmcy-plugin-bootstrap button.list-group-item-success.active:hover,\n    .fmcy-plugin-bootstrap button.list-group-item-success.active:focus {\n      color: #fff;\n      background-color: #3c763d;\n      border-color: #3c763d; }\n  .fmcy-plugin-bootstrap .list-group-item-info {\n    color: #31708f;\n    background-color: #d9edf7; }\n  .fmcy-plugin-bootstrap a.list-group-item-info,\n  .fmcy-plugin-bootstrap button.list-group-item-info {\n    color: #31708f; }\n    .fmcy-plugin-bootstrap a.list-group-item-info .list-group-item-heading,\n    .fmcy-plugin-bootstrap button.list-group-item-info .list-group-item-heading {\n      color: inherit; }\n    .fmcy-plugin-bootstrap a.list-group-item-info:hover, .fmcy-plugin-bootstrap a.list-group-item-info:focus,\n    .fmcy-plugin-bootstrap button.list-group-item-info:hover,\n    .fmcy-plugin-bootstrap button.list-group-item-info:focus {\n      color: #31708f;\n      background-color: #c4e3f3; }\n    .fmcy-plugin-bootstrap a.list-group-item-info.active, .fmcy-plugin-bootstrap a.list-group-item-info.active:hover, .fmcy-plugin-bootstrap a.list-group-item-info.active:focus,\n    .fmcy-plugin-bootstrap button.list-group-item-info.active,\n    .fmcy-plugin-bootstrap button.list-group-item-info.active:hover,\n    .fmcy-plugin-bootstrap button.list-group-item-info.active:focus {\n      color: #fff;\n      background-color: #31708f;\n      border-color: #31708f; }\n  .fmcy-plugin-bootstrap .list-group-item-warning {\n    color: #8a6d3b;\n    background-color: #fcf8e3; }\n  .fmcy-plugin-bootstrap a.list-group-item-warning,\n  .fmcy-plugin-bootstrap button.list-group-item-warning {\n    color: #8a6d3b; }\n    .fmcy-plugin-bootstrap a.list-group-item-warning .list-group-item-heading,\n    .fmcy-plugin-bootstrap button.list-group-item-warning .list-group-item-heading {\n      color: inherit; }\n    .fmcy-plugin-bootstrap a.list-group-item-warning:hover, .fmcy-plugin-bootstrap a.list-group-item-warning:focus,\n    .fmcy-plugin-bootstrap button.list-group-item-warning:hover,\n    .fmcy-plugin-bootstrap button.list-group-item-warning:focus {\n      color: #8a6d3b;\n      background-color: #faf2cc; }\n    .fmcy-plugin-bootstrap a.list-group-item-warning.active, .fmcy-plugin-bootstrap a.list-group-item-warning.active:hover, .fmcy-plugin-bootstrap a.list-group-item-warning.active:focus,\n    .fmcy-plugin-bootstrap button.list-group-item-warning.active,\n    .fmcy-plugin-bootstrap button.list-group-item-warning.active:hover,\n    .fmcy-plugin-bootstrap button.list-group-item-warning.active:focus {\n      color: #fff;\n      background-color: #8a6d3b;\n      border-color: #8a6d3b; }\n  .fmcy-plugin-bootstrap .list-group-item-danger {\n    color: #a94442;\n    background-color: #f2dede; }\n  .fmcy-plugin-bootstrap a.list-group-item-danger,\n  .fmcy-plugin-bootstrap button.list-group-item-danger {\n    color: #a94442; }\n    .fmcy-plugin-bootstrap a.list-group-item-danger .list-group-item-heading,\n    .fmcy-plugin-bootstrap button.list-group-item-danger .list-group-item-heading {\n      color: inherit; }\n    .fmcy-plugin-bootstrap a.list-group-item-danger:hover, .fmcy-plugin-bootstrap a.list-group-item-danger:focus,\n    .fmcy-plugin-bootstrap button.list-group-item-danger:hover,\n    .fmcy-plugin-bootstrap button.list-group-item-danger:focus {\n      color: #a94442;\n      background-color: #ebcccc; }\n    .fmcy-plugin-bootstrap a.list-group-item-danger.active, .fmcy-plugin-bootstrap a.list-group-item-danger.active:hover, .fmcy-plugin-bootstrap a.list-group-item-danger.active:focus,\n    .fmcy-plugin-bootstrap button.list-group-item-danger.active,\n    .fmcy-plugin-bootstrap button.list-group-item-danger.active:hover,\n    .fmcy-plugin-bootstrap button.list-group-item-danger.active:focus {\n      color: #fff;\n      background-color: #a94442;\n      border-color: #a94442; }\n  .fmcy-plugin-bootstrap .list-group-item-heading {\n    margin-top: 0;\n    margin-bottom: 5px; }\n  .fmcy-plugin-bootstrap .list-group-item-text {\n    margin-bottom: 0;\n    line-height: 1.3; }\n  .fmcy-plugin-bootstrap .panel {\n    margin-bottom: 20px;\n    background-color: #fff;\n    border: 1px solid transparent;\n    border-radius: 4px;\n    -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05); }\n  .fmcy-plugin-bootstrap .panel-body {\n    padding: 15px; }\n    .fmcy-plugin-bootstrap .panel-body:before, .fmcy-plugin-bootstrap .panel-body:after {\n      content: \" \";\n      display: table; }\n    .fmcy-plugin-bootstrap .panel-body:after {\n      clear: both; }\n  .fmcy-plugin-bootstrap .panel-heading {\n    padding: 10px 15px;\n    border-bottom: 1px solid transparent;\n    border-top-right-radius: 3px;\n    border-top-left-radius: 3px; }\n    .fmcy-plugin-bootstrap .panel-heading > .dropdown .dropdown-toggle {\n      color: inherit; }\n  .fmcy-plugin-bootstrap .panel-title {\n    margin-top: 0;\n    margin-bottom: 0;\n    font-size: 16px;\n    color: inherit; }\n    .fmcy-plugin-bootstrap .panel-title > a,\n    .fmcy-plugin-bootstrap .panel-title > small,\n    .fmcy-plugin-bootstrap .panel-title > .small,\n    .fmcy-plugin-bootstrap .panel-title > small > a,\n    .fmcy-plugin-bootstrap .panel-title > .small > a {\n      color: inherit; }\n  .fmcy-plugin-bootstrap .panel-footer {\n    padding: 10px 15px;\n    background-color: #f5f5f5;\n    border-top: 1px solid #ddd;\n    border-bottom-right-radius: 3px;\n    border-bottom-left-radius: 3px; }\n  .fmcy-plugin-bootstrap .panel > .list-group,\n  .fmcy-plugin-bootstrap .panel > .panel-collapse > .list-group {\n    margin-bottom: 0; }\n    .fmcy-plugin-bootstrap .panel > .list-group .list-group-item,\n    .fmcy-plugin-bootstrap .panel > .panel-collapse > .list-group .list-group-item {\n      border-width: 1px 0;\n      border-radius: 0; }\n    .fmcy-plugin-bootstrap .panel > .list-group:first-child .list-group-item:first-child,\n    .fmcy-plugin-bootstrap .panel > .panel-collapse > .list-group:first-child .list-group-item:first-child {\n      border-top: 0;\n      border-top-right-radius: 3px;\n      border-top-left-radius: 3px; }\n    .fmcy-plugin-bootstrap .panel > .list-group:last-child .list-group-item:last-child,\n    .fmcy-plugin-bootstrap .panel > .panel-collapse > .list-group:last-child .list-group-item:last-child {\n      border-bottom: 0;\n      border-bottom-right-radius: 3px;\n      border-bottom-left-radius: 3px; }\n  .fmcy-plugin-bootstrap .panel > .panel-heading + .panel-collapse > .list-group .list-group-item:first-child {\n    border-top-right-radius: 0;\n    border-top-left-radius: 0; }\n  .fmcy-plugin-bootstrap .panel-heading + .list-group .list-group-item:first-child {\n    border-top-width: 0; }\n  .fmcy-plugin-bootstrap .list-group + .panel-footer {\n    border-top-width: 0; }\n  .fmcy-plugin-bootstrap .panel > .table,\n  .fmcy-plugin-bootstrap .panel > .table-responsive > .table,\n  .fmcy-plugin-bootstrap .panel > .panel-collapse > .table {\n    margin-bottom: 0; }\n    .fmcy-plugin-bootstrap .panel > .table caption,\n    .fmcy-plugin-bootstrap .panel > .table-responsive > .table caption,\n    .fmcy-plugin-bootstrap .panel > .panel-collapse > .table caption {\n      padding-left: 15px;\n      padding-right: 15px; }\n  .fmcy-plugin-bootstrap .panel > .table:first-child,\n  .fmcy-plugin-bootstrap .panel > .table-responsive:first-child > .table:first-child {\n    border-top-right-radius: 3px;\n    border-top-left-radius: 3px; }\n    .fmcy-plugin-bootstrap .panel > .table:first-child > thead:first-child > tr:first-child,\n    .fmcy-plugin-bootstrap .panel > .table:first-child > tbody:first-child > tr:first-child,\n    .fmcy-plugin-bootstrap .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child,\n    .fmcy-plugin-bootstrap .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child {\n      border-top-left-radius: 3px;\n      border-top-right-radius: 3px; }\n      .fmcy-plugin-bootstrap .panel > .table:first-child > thead:first-child > tr:first-child td:first-child,\n      .fmcy-plugin-bootstrap .panel > .table:first-child > thead:first-child > tr:first-child th:first-child,\n      .fmcy-plugin-bootstrap .panel > .table:first-child > tbody:first-child > tr:first-child td:first-child,\n      .fmcy-plugin-bootstrap .panel > .table:first-child > tbody:first-child > tr:first-child th:first-child,\n      .fmcy-plugin-bootstrap .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child,\n      .fmcy-plugin-bootstrap .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child,\n      .fmcy-plugin-bootstrap .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child,\n      .fmcy-plugin-bootstrap .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child {\n        border-top-left-radius: 3px; }\n      .fmcy-plugin-bootstrap .panel > .table:first-child > thead:first-child > tr:first-child td:last-child,\n      .fmcy-plugin-bootstrap .panel > .table:first-child > thead:first-child > tr:first-child th:last-child,\n      .fmcy-plugin-bootstrap .panel > .table:first-child > tbody:first-child > tr:first-child td:last-child,\n      .fmcy-plugin-bootstrap .panel > .table:first-child > tbody:first-child > tr:first-child th:last-child,\n      .fmcy-plugin-bootstrap .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child,\n      .fmcy-plugin-bootstrap .panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child,\n      .fmcy-plugin-bootstrap .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child,\n      .fmcy-plugin-bootstrap .panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child {\n        border-top-right-radius: 3px; }\n  .fmcy-plugin-bootstrap .panel > .table:last-child,\n  .fmcy-plugin-bootstrap .panel > .table-responsive:last-child > .table:last-child {\n    border-bottom-right-radius: 3px;\n    border-bottom-left-radius: 3px; }\n    .fmcy-plugin-bootstrap .panel > .table:last-child > tbody:last-child > tr:last-child,\n    .fmcy-plugin-bootstrap .panel > .table:last-child > tfoot:last-child > tr:last-child,\n    .fmcy-plugin-bootstrap .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child,\n    .fmcy-plugin-bootstrap .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child {\n      border-bottom-left-radius: 3px;\n      border-bottom-right-radius: 3px; }\n      .fmcy-plugin-bootstrap .panel > .table:last-child > tbody:last-child > tr:last-child td:first-child,\n      .fmcy-plugin-bootstrap .panel > .table:last-child > tbody:last-child > tr:last-child th:first-child,\n      .fmcy-plugin-bootstrap .panel > .table:last-child > tfoot:last-child > tr:last-child td:first-child,\n      .fmcy-plugin-bootstrap .panel > .table:last-child > tfoot:last-child > tr:last-child th:first-child,\n      .fmcy-plugin-bootstrap .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child,\n      .fmcy-plugin-bootstrap .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child,\n      .fmcy-plugin-bootstrap .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child,\n      .fmcy-plugin-bootstrap .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child {\n        border-bottom-left-radius: 3px; }\n      .fmcy-plugin-bootstrap .panel > .table:last-child > tbody:last-child > tr:last-child td:last-child,\n      .fmcy-plugin-bootstrap .panel > .table:last-child > tbody:last-child > tr:last-child th:last-child,\n      .fmcy-plugin-bootstrap .panel > .table:last-child > tfoot:last-child > tr:last-child td:last-child,\n      .fmcy-plugin-bootstrap .panel > .table:last-child > tfoot:last-child > tr:last-child th:last-child,\n      .fmcy-plugin-bootstrap .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child,\n      .fmcy-plugin-bootstrap .panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child,\n      .fmcy-plugin-bootstrap .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child,\n      .fmcy-plugin-bootstrap .panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child {\n        border-bottom-right-radius: 3px; }\n  .fmcy-plugin-bootstrap .panel > .panel-body + .table,\n  .fmcy-plugin-bootstrap .panel > .panel-body + .table-responsive,\n  .fmcy-plugin-bootstrap .panel > .table + .panel-body,\n  .fmcy-plugin-bootstrap .panel > .table-responsive + .panel-body {\n    border-top: 1px solid #ddd; }\n  .fmcy-plugin-bootstrap .panel > .table > tbody:first-child > tr:first-child th,\n  .fmcy-plugin-bootstrap .panel > .table > tbody:first-child > tr:first-child td {\n    border-top: 0; }\n  .fmcy-plugin-bootstrap .panel > .table-bordered,\n  .fmcy-plugin-bootstrap .panel > .table-responsive > .table-bordered {\n    border: 0; }\n    .fmcy-plugin-bootstrap .panel > .table-bordered > thead > tr > th:first-child,\n    .fmcy-plugin-bootstrap .panel > .table-bordered > thead > tr > td:first-child,\n    .fmcy-plugin-bootstrap .panel > .table-bordered > tbody > tr > th:first-child,\n    .fmcy-plugin-bootstrap .panel > .table-bordered > tbody > tr > td:first-child,\n    .fmcy-plugin-bootstrap .panel > .table-bordered > tfoot > tr > th:first-child,\n    .fmcy-plugin-bootstrap .panel > .table-bordered > tfoot > tr > td:first-child,\n    .fmcy-plugin-bootstrap .panel > .table-responsive > .table-bordered > thead > tr > th:first-child,\n    .fmcy-plugin-bootstrap .panel > .table-responsive > .table-bordered > thead > tr > td:first-child,\n    .fmcy-plugin-bootstrap .panel > .table-responsive > .table-bordered > tbody > tr > th:first-child,\n    .fmcy-plugin-bootstrap .panel > .table-responsive > .table-bordered > tbody > tr > td:first-child,\n    .fmcy-plugin-bootstrap .panel > .table-responsive > .table-bordered > tfoot > tr > th:first-child,\n    .fmcy-plugin-bootstrap .panel > .table-responsive > .table-bordered > tfoot > tr > td:first-child {\n      border-left: 0; }\n    .fmcy-plugin-bootstrap .panel > .table-bordered > thead > tr > th:last-child,\n    .fmcy-plugin-bootstrap .panel > .table-bordered > thead > tr > td:last-child,\n    .fmcy-plugin-bootstrap .panel > .table-bordered > tbody > tr > th:last-child,\n    .fmcy-plugin-bootstrap .panel > .table-bordered > tbody > tr > td:last-child,\n    .fmcy-plugin-bootstrap .panel > .table-bordered > tfoot > tr > th:last-child,\n    .fmcy-plugin-bootstrap .panel > .table-bordered > tfoot > tr > td:last-child,\n    .fmcy-plugin-bootstrap .panel > .table-responsive > .table-bordered > thead > tr > th:last-child,\n    .fmcy-plugin-bootstrap .panel > .table-responsive > .table-bordered > thead > tr > td:last-child,\n    .fmcy-plugin-bootstrap .panel > .table-responsive > .table-bordered > tbody > tr > th:last-child,\n    .fmcy-plugin-bootstrap .panel > .table-responsive > .table-bordered > tbody > tr > td:last-child,\n    .fmcy-plugin-bootstrap .panel > .table-responsive > .table-bordered > tfoot > tr > th:last-child,\n    .fmcy-plugin-bootstrap .panel > .table-responsive > .table-bordered > tfoot > tr > td:last-child {\n      border-right: 0; }\n    .fmcy-plugin-bootstrap .panel > .table-bordered > thead > tr:first-child > td,\n    .fmcy-plugin-bootstrap .panel > .table-bordered > thead > tr:first-child > th,\n    .fmcy-plugin-bootstrap .panel > .table-bordered > tbody > tr:first-child > td,\n    .fmcy-plugin-bootstrap .panel > .table-bordered > tbody > tr:first-child > th,\n    .fmcy-plugin-bootstrap .panel > .table-responsive > .table-bordered > thead > tr:first-child > td,\n    .fmcy-plugin-bootstrap .panel > .table-responsive > .table-bordered > thead > tr:first-child > th,\n    .fmcy-plugin-bootstrap .panel > .table-responsive > .table-bordered > tbody > tr:first-child > td,\n    .fmcy-plugin-bootstrap .panel > .table-responsive > .table-bordered > tbody > tr:first-child > th {\n      border-bottom: 0; }\n    .fmcy-plugin-bootstrap .panel > .table-bordered > tbody > tr:last-child > td,\n    .fmcy-plugin-bootstrap .panel > .table-bordered > tbody > tr:last-child > th,\n    .fmcy-plugin-bootstrap .panel > .table-bordered > tfoot > tr:last-child > td,\n    .fmcy-plugin-bootstrap .panel > .table-bordered > tfoot > tr:last-child > th,\n    .fmcy-plugin-bootstrap .panel > .table-responsive > .table-bordered > tbody > tr:last-child > td,\n    .fmcy-plugin-bootstrap .panel > .table-responsive > .table-bordered > tbody > tr:last-child > th,\n    .fmcy-plugin-bootstrap .panel > .table-responsive > .table-bordered > tfoot > tr:last-child > td,\n    .fmcy-plugin-bootstrap .panel > .table-responsive > .table-bordered > tfoot > tr:last-child > th {\n      border-bottom: 0; }\n  .fmcy-plugin-bootstrap .panel > .table-responsive {\n    border: 0;\n    margin-bottom: 0; }\n  .fmcy-plugin-bootstrap .panel-group {\n    margin-bottom: 20px; }\n    .fmcy-plugin-bootstrap .panel-group .panel {\n      margin-bottom: 0;\n      border-radius: 4px; }\n      .fmcy-plugin-bootstrap .panel-group .panel + .panel {\n        margin-top: 5px; }\n    .fmcy-plugin-bootstrap .panel-group .panel-heading {\n      border-bottom: 0; }\n      .fmcy-plugin-bootstrap .panel-group .panel-heading + .panel-collapse > .panel-body,\n      .fmcy-plugin-bootstrap .panel-group .panel-heading + .panel-collapse > .list-group {\n        border-top: 1px solid #ddd; }\n    .fmcy-plugin-bootstrap .panel-group .panel-footer {\n      border-top: 0; }\n      .fmcy-plugin-bootstrap .panel-group .panel-footer + .panel-collapse .panel-body {\n        border-bottom: 1px solid #ddd; }\n  .fmcy-plugin-bootstrap .panel-default {\n    border-color: #ddd; }\n    .fmcy-plugin-bootstrap .panel-default > .panel-heading {\n      color: #333333;\n      background-color: #f5f5f5;\n      border-color: #ddd; }\n      .fmcy-plugin-bootstrap .panel-default > .panel-heading + .panel-collapse > .panel-body {\n        border-top-color: #ddd; }\n      .fmcy-plugin-bootstrap .panel-default > .panel-heading .badge {\n        color: #f5f5f5;\n        background-color: #333333; }\n    .fmcy-plugin-bootstrap .panel-default > .panel-footer + .panel-collapse > .panel-body {\n      border-bottom-color: #ddd; }\n  .fmcy-plugin-bootstrap .panel-primary {\n    border-color: #337ab7; }\n    .fmcy-plugin-bootstrap .panel-primary > .panel-heading {\n      color: #fff;\n      background-color: #337ab7;\n      border-color: #337ab7; }\n      .fmcy-plugin-bootstrap .panel-primary > .panel-heading + .panel-collapse > .panel-body {\n        border-top-color: #337ab7; }\n      .fmcy-plugin-bootstrap .panel-primary > .panel-heading .badge {\n        color: #337ab7;\n        background-color: #fff; }\n    .fmcy-plugin-bootstrap .panel-primary > .panel-footer + .panel-collapse > .panel-body {\n      border-bottom-color: #337ab7; }\n  .fmcy-plugin-bootstrap .panel-success {\n    border-color: #d6e9c6; }\n    .fmcy-plugin-bootstrap .panel-success > .panel-heading {\n      color: #3c763d;\n      background-color: #dff0d8;\n      border-color: #d6e9c6; }\n      .fmcy-plugin-bootstrap .panel-success > .panel-heading + .panel-collapse > .panel-body {\n        border-top-color: #d6e9c6; }\n      .fmcy-plugin-bootstrap .panel-success > .panel-heading .badge {\n        color: #dff0d8;\n        background-color: #3c763d; }\n    .fmcy-plugin-bootstrap .panel-success > .panel-footer + .panel-collapse > .panel-body {\n      border-bottom-color: #d6e9c6; }\n  .fmcy-plugin-bootstrap .panel-info {\n    border-color: #bce8f1; }\n    .fmcy-plugin-bootstrap .panel-info > .panel-heading {\n      color: #31708f;\n      background-color: #d9edf7;\n      border-color: #bce8f1; }\n      .fmcy-plugin-bootstrap .panel-info > .panel-heading + .panel-collapse > .panel-body {\n        border-top-color: #bce8f1; }\n      .fmcy-plugin-bootstrap .panel-info > .panel-heading .badge {\n        color: #d9edf7;\n        background-color: #31708f; }\n    .fmcy-plugin-bootstrap .panel-info > .panel-footer + .panel-collapse > .panel-body {\n      border-bottom-color: #bce8f1; }\n  .fmcy-plugin-bootstrap .panel-warning {\n    border-color: #faebcc; }\n    .fmcy-plugin-bootstrap .panel-warning > .panel-heading {\n      color: #8a6d3b;\n      background-color: #fcf8e3;\n      border-color: #faebcc; }\n      .fmcy-plugin-bootstrap .panel-warning > .panel-heading + .panel-collapse > .panel-body {\n        border-top-color: #faebcc; }\n      .fmcy-plugin-bootstrap .panel-warning > .panel-heading .badge {\n        color: #fcf8e3;\n        background-color: #8a6d3b; }\n    .fmcy-plugin-bootstrap .panel-warning > .panel-footer + .panel-collapse > .panel-body {\n      border-bottom-color: #faebcc; }\n  .fmcy-plugin-bootstrap .panel-danger {\n    border-color: #ebccd1; }\n    .fmcy-plugin-bootstrap .panel-danger > .panel-heading {\n      color: #a94442;\n      background-color: #f2dede;\n      border-color: #ebccd1; }\n      .fmcy-plugin-bootstrap .panel-danger > .panel-heading + .panel-collapse > .panel-body {\n        border-top-color: #ebccd1; }\n      .fmcy-plugin-bootstrap .panel-danger > .panel-heading .badge {\n        color: #f2dede;\n        background-color: #a94442; }\n    .fmcy-plugin-bootstrap .panel-danger > .panel-footer + .panel-collapse > .panel-body {\n      border-bottom-color: #ebccd1; }\n  .fmcy-plugin-bootstrap .embed-responsive {\n    position: relative;\n    display: block;\n    height: 0;\n    padding: 0;\n    overflow: hidden; }\n    .fmcy-plugin-bootstrap .embed-responsive .embed-responsive-item,\n    .fmcy-plugin-bootstrap .embed-responsive iframe,\n    .fmcy-plugin-bootstrap .embed-responsive embed,\n    .fmcy-plugin-bootstrap .embed-responsive object,\n    .fmcy-plugin-bootstrap .embed-responsive video {\n      position: absolute;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      height: 100%;\n      width: 100%;\n      border: 0; }\n  .fmcy-plugin-bootstrap .embed-responsive-16by9 {\n    padding-bottom: 56.25%; }\n  .fmcy-plugin-bootstrap .embed-responsive-4by3 {\n    padding-bottom: 75%; }\n  .fmcy-plugin-bootstrap .well {\n    min-height: 20px;\n    padding: 19px;\n    margin-bottom: 20px;\n    background-color: #f5f5f5;\n    border: 1px solid #e3e3e3;\n    border-radius: 4px;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05); }\n    .fmcy-plugin-bootstrap .well blockquote {\n      border-color: #ddd;\n      border-color: rgba(0, 0, 0, 0.15); }\n  .fmcy-plugin-bootstrap .well-lg {\n    padding: 24px;\n    border-radius: 6px; }\n  .fmcy-plugin-bootstrap .well-sm {\n    padding: 9px;\n    border-radius: 3px; }\n  .fmcy-plugin-bootstrap .close {\n    float: right;\n    font-size: 21px;\n    font-weight: bold;\n    line-height: 1;\n    color: #000;\n    text-shadow: 0 1px 0 #fff;\n    opacity: 0.2;\n    filter: alpha(opacity=20); }\n    .fmcy-plugin-bootstrap .close:hover, .fmcy-plugin-bootstrap .close:focus {\n      color: #000;\n      text-decoration: none;\n      cursor: pointer;\n      opacity: 0.5;\n      filter: alpha(opacity=50); }\n  .fmcy-plugin-bootstrap button.close {\n    padding: 0;\n    cursor: pointer;\n    background: transparent;\n    border: 0;\n    -webkit-appearance: none; }\n  .fmcy-plugin-bootstrap .modal-open {\n    overflow: hidden; }\n  .fmcy-plugin-bootstrap .modal {\n    display: none;\n    overflow: hidden;\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1050;\n    -webkit-overflow-scrolling: touch;\n    outline: 0; }\n    .fmcy-plugin-bootstrap .modal.fade .modal-dialog {\n      -webkit-transform: translate(0, -25%);\n      -ms-transform: translate(0, -25%);\n      -o-transform: translate(0, -25%);\n      transform: translate(0, -25%);\n      -webkit-transition: -webkit-transform 0.3s ease-out;\n      -moz-transition: -moz-transform 0.3s ease-out;\n      -o-transition: -o-transform 0.3s ease-out;\n      transition: transform 0.3s ease-out; }\n    .fmcy-plugin-bootstrap .modal.in .modal-dialog {\n      -webkit-transform: translate(0, 0);\n      -ms-transform: translate(0, 0);\n      -o-transform: translate(0, 0);\n      transform: translate(0, 0); }\n  .fmcy-plugin-bootstrap .modal-open .modal {\n    overflow-x: hidden;\n    overflow-y: auto; }\n  .fmcy-plugin-bootstrap .modal-dialog {\n    position: relative;\n    width: auto;\n    margin: 10px; }\n  .fmcy-plugin-bootstrap .modal-content {\n    position: relative;\n    background-color: #fff;\n    border: 1px solid #999;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    border-radius: 6px;\n    -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);\n    box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);\n    background-clip: padding-box;\n    outline: 0; }\n  .fmcy-plugin-bootstrap .modal-backdrop {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1040;\n    background-color: #000; }\n    .fmcy-plugin-bootstrap .modal-backdrop.fade {\n      opacity: 0;\n      filter: alpha(opacity=0); }\n    .fmcy-plugin-bootstrap .modal-backdrop.in {\n      opacity: 0.5;\n      filter: alpha(opacity=50); }\n  .fmcy-plugin-bootstrap .modal-header {\n    padding: 15px;\n    border-bottom: 1px solid #e5e5e5; }\n    .fmcy-plugin-bootstrap .modal-header:before, .fmcy-plugin-bootstrap .modal-header:after {\n      content: \" \";\n      display: table; }\n    .fmcy-plugin-bootstrap .modal-header:after {\n      clear: both; }\n  .fmcy-plugin-bootstrap .modal-header .close {\n    margin-top: -2px; }\n  .fmcy-plugin-bootstrap .modal-title {\n    margin: 0;\n    line-height: 1.42857; }\n  .fmcy-plugin-bootstrap .modal-body {\n    position: relative;\n    padding: 15px; }\n  .fmcy-plugin-bootstrap .modal-footer {\n    padding: 15px;\n    text-align: right;\n    border-top: 1px solid #e5e5e5; }\n    .fmcy-plugin-bootstrap .modal-footer:before, .fmcy-plugin-bootstrap .modal-footer:after {\n      content: \" \";\n      display: table; }\n    .fmcy-plugin-bootstrap .modal-footer:after {\n      clear: both; }\n    .fmcy-plugin-bootstrap .modal-footer .btn + .btn {\n      margin-left: 5px;\n      margin-bottom: 0; }\n    .fmcy-plugin-bootstrap .modal-footer .btn-group .btn + .btn {\n      margin-left: -1px; }\n    .fmcy-plugin-bootstrap .modal-footer .btn-block + .btn-block {\n      margin-left: 0; }\n  .fmcy-plugin-bootstrap .modal-scrollbar-measure {\n    position: absolute;\n    top: -9999px;\n    width: 50px;\n    height: 50px;\n    overflow: scroll; }\n  @media (min-width: 768px) {\n    .fmcy-plugin-bootstrap .modal-dialog {\n      width: 600px;\n      margin: 30px auto; }\n    .fmcy-plugin-bootstrap .modal-content {\n      -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);\n      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5); }\n    .fmcy-plugin-bootstrap .modal-sm {\n      width: 300px; } }\n  @media (min-width: 992px) {\n    .fmcy-plugin-bootstrap .modal-lg {\n      width: 900px; } }\n  .fmcy-plugin-bootstrap .tooltip {\n    position: absolute;\n    z-index: 1070;\n    display: block;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    font-style: normal;\n    font-weight: normal;\n    letter-spacing: normal;\n    line-break: auto;\n    line-height: 1.42857;\n    text-align: left;\n    text-align: start;\n    text-decoration: none;\n    text-shadow: none;\n    text-transform: none;\n    white-space: normal;\n    word-break: normal;\n    word-spacing: normal;\n    word-wrap: normal;\n    font-size: 12px;\n    opacity: 0;\n    filter: alpha(opacity=0); }\n    .fmcy-plugin-bootstrap .tooltip.in {\n      opacity: 0.9;\n      filter: alpha(opacity=90); }\n    .fmcy-plugin-bootstrap .tooltip.top {\n      margin-top: -3px;\n      padding: 5px 0; }\n    .fmcy-plugin-bootstrap .tooltip.right {\n      margin-left: 3px;\n      padding: 0 5px; }\n    .fmcy-plugin-bootstrap .tooltip.bottom {\n      margin-top: 3px;\n      padding: 5px 0; }\n    .fmcy-plugin-bootstrap .tooltip.left {\n      margin-left: -3px;\n      padding: 0 5px; }\n  .fmcy-plugin-bootstrap .tooltip-inner {\n    max-width: 200px;\n    padding: 3px 8px;\n    color: #fff;\n    text-align: center;\n    background-color: #000;\n    border-radius: 4px; }\n  .fmcy-plugin-bootstrap .tooltip-arrow {\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-color: transparent;\n    border-style: solid; }\n  .fmcy-plugin-bootstrap .tooltip.top .tooltip-arrow {\n    bottom: 0;\n    left: 50%;\n    margin-left: -5px;\n    border-width: 5px 5px 0;\n    border-top-color: #000; }\n  .fmcy-plugin-bootstrap .tooltip.top-left .tooltip-arrow {\n    bottom: 0;\n    right: 5px;\n    margin-bottom: -5px;\n    border-width: 5px 5px 0;\n    border-top-color: #000; }\n  .fmcy-plugin-bootstrap .tooltip.top-right .tooltip-arrow {\n    bottom: 0;\n    left: 5px;\n    margin-bottom: -5px;\n    border-width: 5px 5px 0;\n    border-top-color: #000; }\n  .fmcy-plugin-bootstrap .tooltip.right .tooltip-arrow {\n    top: 50%;\n    left: 0;\n    margin-top: -5px;\n    border-width: 5px 5px 5px 0;\n    border-right-color: #000; }\n  .fmcy-plugin-bootstrap .tooltip.left .tooltip-arrow {\n    top: 50%;\n    right: 0;\n    margin-top: -5px;\n    border-width: 5px 0 5px 5px;\n    border-left-color: #000; }\n  .fmcy-plugin-bootstrap .tooltip.bottom .tooltip-arrow {\n    top: 0;\n    left: 50%;\n    margin-left: -5px;\n    border-width: 0 5px 5px;\n    border-bottom-color: #000; }\n  .fmcy-plugin-bootstrap .tooltip.bottom-left .tooltip-arrow {\n    top: 0;\n    right: 5px;\n    margin-top: -5px;\n    border-width: 0 5px 5px;\n    border-bottom-color: #000; }\n  .fmcy-plugin-bootstrap .tooltip.bottom-right .tooltip-arrow {\n    top: 0;\n    left: 5px;\n    margin-top: -5px;\n    border-width: 0 5px 5px;\n    border-bottom-color: #000; }\n  .fmcy-plugin-bootstrap .popover {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 1060;\n    display: none;\n    max-width: 276px;\n    padding: 1px;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    font-style: normal;\n    font-weight: normal;\n    letter-spacing: normal;\n    line-break: auto;\n    line-height: 1.42857;\n    text-align: left;\n    text-align: start;\n    text-decoration: none;\n    text-shadow: none;\n    text-transform: none;\n    white-space: normal;\n    word-break: normal;\n    word-spacing: normal;\n    word-wrap: normal;\n    font-size: 14px;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid #ccc;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    border-radius: 6px;\n    -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2); }\n    .fmcy-plugin-bootstrap .popover.top {\n      margin-top: -10px; }\n    .fmcy-plugin-bootstrap .popover.right {\n      margin-left: 10px; }\n    .fmcy-plugin-bootstrap .popover.bottom {\n      margin-top: 10px; }\n    .fmcy-plugin-bootstrap .popover.left {\n      margin-left: -10px; }\n  .fmcy-plugin-bootstrap .popover-title {\n    margin: 0;\n    padding: 8px 14px;\n    font-size: 14px;\n    background-color: #f7f7f7;\n    border-bottom: 1px solid #ebebeb;\n    border-radius: 5px 5px 0 0; }\n  .fmcy-plugin-bootstrap .popover-content {\n    padding: 9px 14px; }\n  .fmcy-plugin-bootstrap .popover > .arrow, .fmcy-plugin-bootstrap .popover > .arrow:after {\n    position: absolute;\n    display: block;\n    width: 0;\n    height: 0;\n    border-color: transparent;\n    border-style: solid; }\n  .fmcy-plugin-bootstrap .popover > .arrow {\n    border-width: 11px; }\n  .fmcy-plugin-bootstrap .popover > .arrow:after {\n    border-width: 10px;\n    content: \"\"; }\n  .fmcy-plugin-bootstrap .popover.top > .arrow {\n    left: 50%;\n    margin-left: -11px;\n    border-bottom-width: 0;\n    border-top-color: #999999;\n    border-top-color: rgba(0, 0, 0, 0.25);\n    bottom: -11px; }\n    .fmcy-plugin-bootstrap .popover.top > .arrow:after {\n      content: \" \";\n      bottom: 1px;\n      margin-left: -10px;\n      border-bottom-width: 0;\n      border-top-color: #fff; }\n  .fmcy-plugin-bootstrap .popover.right > .arrow {\n    top: 50%;\n    left: -11px;\n    margin-top: -11px;\n    border-left-width: 0;\n    border-right-color: #999999;\n    border-right-color: rgba(0, 0, 0, 0.25); }\n    .fmcy-plugin-bootstrap .popover.right > .arrow:after {\n      content: \" \";\n      left: 1px;\n      bottom: -10px;\n      border-left-width: 0;\n      border-right-color: #fff; }\n  .fmcy-plugin-bootstrap .popover.bottom > .arrow {\n    left: 50%;\n    margin-left: -11px;\n    border-top-width: 0;\n    border-bottom-color: #999999;\n    border-bottom-color: rgba(0, 0, 0, 0.25);\n    top: -11px; }\n    .fmcy-plugin-bootstrap .popover.bottom > .arrow:after {\n      content: \" \";\n      top: 1px;\n      margin-left: -10px;\n      border-top-width: 0;\n      border-bottom-color: #fff; }\n  .fmcy-plugin-bootstrap .popover.left > .arrow {\n    top: 50%;\n    right: -11px;\n    margin-top: -11px;\n    border-right-width: 0;\n    border-left-color: #999999;\n    border-left-color: rgba(0, 0, 0, 0.25); }\n    .fmcy-plugin-bootstrap .popover.left > .arrow:after {\n      content: \" \";\n      right: 1px;\n      border-right-width: 0;\n      border-left-color: #fff;\n      bottom: -10px; }\n  .fmcy-plugin-bootstrap .carousel {\n    position: relative; }\n  .fmcy-plugin-bootstrap .carousel-inner {\n    position: relative;\n    overflow: hidden;\n    width: 100%; }\n    .fmcy-plugin-bootstrap .carousel-inner > .item {\n      display: none;\n      position: relative;\n      -webkit-transition: 0.6s ease-in-out left;\n      -o-transition: 0.6s ease-in-out left;\n      transition: 0.6s ease-in-out left; }\n      .fmcy-plugin-bootstrap .carousel-inner > .item > img,\n      .fmcy-plugin-bootstrap .carousel-inner > .item > a > img {\n        display: block;\n        max-width: 100%;\n        height: auto;\n        line-height: 1; }\n      @media all and (transform-3d), (-webkit-transform-3d) {\n        .fmcy-plugin-bootstrap .carousel-inner > .item {\n          -webkit-transition: -webkit-transform 0.6s ease-in-out;\n          -moz-transition: -moz-transform 0.6s ease-in-out;\n          -o-transition: -o-transform 0.6s ease-in-out;\n          transition: transform 0.6s ease-in-out;\n          -webkit-backface-visibility: hidden;\n          -moz-backface-visibility: hidden;\n          backface-visibility: hidden;\n          -webkit-perspective: 1000px;\n          -moz-perspective: 1000px;\n          perspective: 1000px; }\n          .fmcy-plugin-bootstrap .carousel-inner > .item.next, .fmcy-plugin-bootstrap .carousel-inner > .item.active.right {\n            -webkit-transform: translate3d(100%, 0, 0);\n            transform: translate3d(100%, 0, 0);\n            left: 0; }\n          .fmcy-plugin-bootstrap .carousel-inner > .item.prev, .fmcy-plugin-bootstrap .carousel-inner > .item.active.left {\n            -webkit-transform: translate3d(-100%, 0, 0);\n            transform: translate3d(-100%, 0, 0);\n            left: 0; }\n          .fmcy-plugin-bootstrap .carousel-inner > .item.next.left, .fmcy-plugin-bootstrap .carousel-inner > .item.prev.right, .fmcy-plugin-bootstrap .carousel-inner > .item.active {\n            -webkit-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n            left: 0; } }\n    .fmcy-plugin-bootstrap .carousel-inner > .active,\n    .fmcy-plugin-bootstrap .carousel-inner > .next,\n    .fmcy-plugin-bootstrap .carousel-inner > .prev {\n      display: block; }\n    .fmcy-plugin-bootstrap .carousel-inner > .active {\n      left: 0; }\n    .fmcy-plugin-bootstrap .carousel-inner > .next,\n    .fmcy-plugin-bootstrap .carousel-inner > .prev {\n      position: absolute;\n      top: 0;\n      width: 100%; }\n    .fmcy-plugin-bootstrap .carousel-inner > .next {\n      left: 100%; }\n    .fmcy-plugin-bootstrap .carousel-inner > .prev {\n      left: -100%; }\n    .fmcy-plugin-bootstrap .carousel-inner > .next.left,\n    .fmcy-plugin-bootstrap .carousel-inner > .prev.right {\n      left: 0; }\n    .fmcy-plugin-bootstrap .carousel-inner > .active.left {\n      left: -100%; }\n    .fmcy-plugin-bootstrap .carousel-inner > .active.right {\n      left: 100%; }\n  .fmcy-plugin-bootstrap .carousel-control {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 15%;\n    opacity: 0.5;\n    filter: alpha(opacity=50);\n    font-size: 20px;\n    color: #fff;\n    text-align: center;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);\n    background-color: transparent; }\n    .fmcy-plugin-bootstrap .carousel-control.left {\n      background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);\n      background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);\n      background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);\n      background-repeat: repeat-x;\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000', endColorstr='#00000000', GradientType=1); }\n    .fmcy-plugin-bootstrap .carousel-control.right {\n      left: auto;\n      right: 0;\n      background-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);\n      background-image: -o-linear-gradient(left, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);\n      background-image: linear-gradient(to right, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);\n      background-repeat: repeat-x;\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#80000000', GradientType=1); }\n    .fmcy-plugin-bootstrap .carousel-control:hover, .fmcy-plugin-bootstrap .carousel-control:focus {\n      outline: 0;\n      color: #fff;\n      text-decoration: none;\n      opacity: 0.9;\n      filter: alpha(opacity=90); }\n    .fmcy-plugin-bootstrap .carousel-control .icon-prev,\n    .fmcy-plugin-bootstrap .carousel-control .icon-next,\n    .fmcy-plugin-bootstrap .carousel-control .glyphicon-chevron-left,\n    .fmcy-plugin-bootstrap .carousel-control .glyphicon-chevron-right {\n      position: absolute;\n      top: 50%;\n      margin-top: -10px;\n      z-index: 5;\n      display: inline-block; }\n    .fmcy-plugin-bootstrap .carousel-control .icon-prev,\n    .fmcy-plugin-bootstrap .carousel-control .glyphicon-chevron-left {\n      left: 50%;\n      margin-left: -10px; }\n    .fmcy-plugin-bootstrap .carousel-control .icon-next,\n    .fmcy-plugin-bootstrap .carousel-control .glyphicon-chevron-right {\n      right: 50%;\n      margin-right: -10px; }\n    .fmcy-plugin-bootstrap .carousel-control .icon-prev,\n    .fmcy-plugin-bootstrap .carousel-control .icon-next {\n      width: 20px;\n      height: 20px;\n      line-height: 1;\n      font-family: serif; }\n    .fmcy-plugin-bootstrap .carousel-control .icon-prev:before {\n      content: '\\2039'; }\n    .fmcy-plugin-bootstrap .carousel-control .icon-next:before {\n      content: '\\203A'; }\n  .fmcy-plugin-bootstrap .carousel-indicators {\n    position: absolute;\n    bottom: 10px;\n    left: 50%;\n    z-index: 15;\n    width: 60%;\n    margin-left: -30%;\n    padding-left: 0;\n    list-style: none;\n    text-align: center; }\n    .fmcy-plugin-bootstrap .carousel-indicators li {\n      display: inline-block;\n      width: 10px;\n      height: 10px;\n      margin: 1px;\n      text-indent: -999px;\n      border: 1px solid #fff;\n      border-radius: 10px;\n      cursor: pointer;\n      background-color: #000 \\9;\n      background-color: transparent; }\n    .fmcy-plugin-bootstrap .carousel-indicators .active {\n      margin: 0;\n      width: 12px;\n      height: 12px;\n      background-color: #fff; }\n  .fmcy-plugin-bootstrap .carousel-caption {\n    position: absolute;\n    left: 15%;\n    right: 15%;\n    bottom: 20px;\n    z-index: 10;\n    padding-top: 20px;\n    padding-bottom: 20px;\n    color: #fff;\n    text-align: center;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6); }\n    .fmcy-plugin-bootstrap .carousel-caption .btn {\n      text-shadow: none; }\n  @media screen and (min-width: 768px) {\n    .fmcy-plugin-bootstrap .carousel-control .glyphicon-chevron-left,\n    .fmcy-plugin-bootstrap .carousel-control .glyphicon-chevron-right,\n    .fmcy-plugin-bootstrap .carousel-control .icon-prev,\n    .fmcy-plugin-bootstrap .carousel-control .icon-next {\n      width: 30px;\n      height: 30px;\n      margin-top: -10px;\n      font-size: 30px; }\n    .fmcy-plugin-bootstrap .carousel-control .glyphicon-chevron-left,\n    .fmcy-plugin-bootstrap .carousel-control .icon-prev {\n      margin-left: -10px; }\n    .fmcy-plugin-bootstrap .carousel-control .glyphicon-chevron-right,\n    .fmcy-plugin-bootstrap .carousel-control .icon-next {\n      margin-right: -10px; }\n    .fmcy-plugin-bootstrap .carousel-caption {\n      left: 20%;\n      right: 20%;\n      padding-bottom: 30px; }\n    .fmcy-plugin-bootstrap .carousel-indicators {\n      bottom: 20px; } }\n  .fmcy-plugin-bootstrap .clearfix:before, .fmcy-plugin-bootstrap .clearfix:after {\n    content: \" \";\n    display: table; }\n  .fmcy-plugin-bootstrap .clearfix:after {\n    clear: both; }\n  .fmcy-plugin-bootstrap .center-block {\n    display: block;\n    margin-left: auto;\n    margin-right: auto; }\n  .fmcy-plugin-bootstrap .pull-right {\n    float: right !important; }\n  .fmcy-plugin-bootstrap .pull-left {\n    float: left !important; }\n  .fmcy-plugin-bootstrap .hide {\n    display: none !important; }\n  .fmcy-plugin-bootstrap .show {\n    display: block !important; }\n  .fmcy-plugin-bootstrap .invisible {\n    visibility: hidden; }\n  .fmcy-plugin-bootstrap .text-hide {\n    font: 0/0 a;\n    color: transparent;\n    text-shadow: none;\n    background-color: transparent;\n    border: 0; }\n  .fmcy-plugin-bootstrap .hidden {\n    display: none !important; }\n  .fmcy-plugin-bootstrap .affix {\n    position: fixed; }\n\n@-ms-viewport {\n  width: device-width; }\n  .fmcy-plugin-bootstrap .visible-xs {\n    display: none !important; }\n  .fmcy-plugin-bootstrap .visible-sm {\n    display: none !important; }\n  .fmcy-plugin-bootstrap .visible-md {\n    display: none !important; }\n  .fmcy-plugin-bootstrap .visible-lg {\n    display: none !important; }\n  .fmcy-plugin-bootstrap .visible-xs-block,\n  .fmcy-plugin-bootstrap .visible-xs-inline,\n  .fmcy-plugin-bootstrap .visible-xs-inline-block,\n  .fmcy-plugin-bootstrap .visible-sm-block,\n  .fmcy-plugin-bootstrap .visible-sm-inline,\n  .fmcy-plugin-bootstrap .visible-sm-inline-block,\n  .fmcy-plugin-bootstrap .visible-md-block,\n  .fmcy-plugin-bootstrap .visible-md-inline,\n  .fmcy-plugin-bootstrap .visible-md-inline-block,\n  .fmcy-plugin-bootstrap .visible-lg-block,\n  .fmcy-plugin-bootstrap .visible-lg-inline,\n  .fmcy-plugin-bootstrap .visible-lg-inline-block {\n    display: none !important; }\n  @media (max-width: 767px) {\n    .fmcy-plugin-bootstrap .visible-xs {\n      display: block !important; }\n    .fmcy-plugin-bootstrap table.visible-xs {\n      display: table !important; }\n    .fmcy-plugin-bootstrap tr.visible-xs {\n      display: table-row !important; }\n    .fmcy-plugin-bootstrap th.visible-xs,\n    .fmcy-plugin-bootstrap td.visible-xs {\n      display: table-cell !important; } }\n  @media (max-width: 767px) {\n    .fmcy-plugin-bootstrap .visible-xs-block {\n      display: block !important; } }\n  @media (max-width: 767px) {\n    .fmcy-plugin-bootstrap .visible-xs-inline {\n      display: inline !important; } }\n  @media (max-width: 767px) {\n    .fmcy-plugin-bootstrap .visible-xs-inline-block {\n      display: inline-block !important; } }\n  @media (min-width: 768px) and (max-width: 991px) {\n    .fmcy-plugin-bootstrap .visible-sm {\n      display: block !important; }\n    .fmcy-plugin-bootstrap table.visible-sm {\n      display: table !important; }\n    .fmcy-plugin-bootstrap tr.visible-sm {\n      display: table-row !important; }\n    .fmcy-plugin-bootstrap th.visible-sm,\n    .fmcy-plugin-bootstrap td.visible-sm {\n      display: table-cell !important; } }\n  @media (min-width: 768px) and (max-width: 991px) {\n    .fmcy-plugin-bootstrap .visible-sm-block {\n      display: block !important; } }\n  @media (min-width: 768px) and (max-width: 991px) {\n    .fmcy-plugin-bootstrap .visible-sm-inline {\n      display: inline !important; } }\n  @media (min-width: 768px) and (max-width: 991px) {\n    .fmcy-plugin-bootstrap .visible-sm-inline-block {\n      display: inline-block !important; } }\n  @media (min-width: 992px) and (max-width: 1199px) {\n    .fmcy-plugin-bootstrap .visible-md {\n      display: block !important; }\n    .fmcy-plugin-bootstrap table.visible-md {\n      display: table !important; }\n    .fmcy-plugin-bootstrap tr.visible-md {\n      display: table-row !important; }\n    .fmcy-plugin-bootstrap th.visible-md,\n    .fmcy-plugin-bootstrap td.visible-md {\n      display: table-cell !important; } }\n  @media (min-width: 992px) and (max-width: 1199px) {\n    .fmcy-plugin-bootstrap .visible-md-block {\n      display: block !important; } }\n  @media (min-width: 992px) and (max-width: 1199px) {\n    .fmcy-plugin-bootstrap .visible-md-inline {\n      display: inline !important; } }\n  @media (min-width: 992px) and (max-width: 1199px) {\n    .fmcy-plugin-bootstrap .visible-md-inline-block {\n      display: inline-block !important; } }\n  @media (min-width: 1200px) {\n    .fmcy-plugin-bootstrap .visible-lg {\n      display: block !important; }\n    .fmcy-plugin-bootstrap table.visible-lg {\n      display: table !important; }\n    .fmcy-plugin-bootstrap tr.visible-lg {\n      display: table-row !important; }\n    .fmcy-plugin-bootstrap th.visible-lg,\n    .fmcy-plugin-bootstrap td.visible-lg {\n      display: table-cell !important; } }\n  @media (min-width: 1200px) {\n    .fmcy-plugin-bootstrap .visible-lg-block {\n      display: block !important; } }\n  @media (min-width: 1200px) {\n    .fmcy-plugin-bootstrap .visible-lg-inline {\n      display: inline !important; } }\n  @media (min-width: 1200px) {\n    .fmcy-plugin-bootstrap .visible-lg-inline-block {\n      display: inline-block !important; } }\n  @media (max-width: 767px) {\n    .fmcy-plugin-bootstrap .hidden-xs {\n      display: none !important; } }\n  @media (min-width: 768px) and (max-width: 991px) {\n    .fmcy-plugin-bootstrap .hidden-sm {\n      display: none !important; } }\n  @media (min-width: 992px) and (max-width: 1199px) {\n    .fmcy-plugin-bootstrap .hidden-md {\n      display: none !important; } }\n  @media (min-width: 1200px) {\n    .fmcy-plugin-bootstrap .hidden-lg {\n      display: none !important; } }\n  .fmcy-plugin-bootstrap .visible-print {\n    display: none !important; }\n  @media print {\n    .fmcy-plugin-bootstrap .visible-print {\n      display: block !important; }\n    .fmcy-plugin-bootstrap table.visible-print {\n      display: table !important; }\n    .fmcy-plugin-bootstrap tr.visible-print {\n      display: table-row !important; }\n    .fmcy-plugin-bootstrap th.visible-print,\n    .fmcy-plugin-bootstrap td.visible-print {\n      display: table-cell !important; } }\n  .fmcy-plugin-bootstrap .visible-print-block {\n    display: none !important; }\n    @media print {\n      .fmcy-plugin-bootstrap .visible-print-block {\n        display: block !important; } }\n  .fmcy-plugin-bootstrap .visible-print-inline {\n    display: none !important; }\n    @media print {\n      .fmcy-plugin-bootstrap .visible-print-inline {\n        display: inline !important; } }\n  .fmcy-plugin-bootstrap .visible-print-inline-block {\n    display: none !important; }\n    @media print {\n      .fmcy-plugin-bootstrap .visible-print-inline-block {\n        display: inline-block !important; } }\n  @media print {\n    .fmcy-plugin-bootstrap .hidden-print {\n      display: none !important; } }\n  .fmcy-plugin-bootstrap .sr-only, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"incrementHours\"]::after, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"incrementMinutes\"]::after, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"decrementHours\"]::after, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"decrementMinutes\"]::after, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"showHours\"]::after, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"showMinutes\"]::after, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"togglePeriod\"]::after, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"clear\"]::after, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"today\"]::after, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .picker-switch::after, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table th.prev::after, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table th.next::after {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    margin: -1px;\n    padding: 0;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    border: 0; }\n  .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget {\n    list-style: none; }\n    .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget.dropdown-menu {\n      margin: 2px 0;\n      padding: 4px;\n      width: 19em; }\n      @media (min-width: 768px) {\n        .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\n          width: 38em; } }\n      @media (min-width: 992px) {\n        .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\n          width: 38em; } }\n      @media (min-width: 1200px) {\n        .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\n          width: 38em; } }\n      .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget.dropdown-menu:before, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget.dropdown-menu:after {\n        content: '';\n        display: inline-block;\n        position: absolute; }\n      .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {\n        border-left: 7px solid transparent;\n        border-right: 7px solid transparent;\n        border-bottom: 7px solid #ccc;\n        border-bottom-color: rgba(0, 0, 0, 0.2);\n        top: -7px;\n        left: 7px; }\n      .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget.dropdown-menu.bottom:after {\n        border-left: 6px solid transparent;\n        border-right: 6px solid transparent;\n        border-bottom: 6px solid white;\n        top: -6px;\n        left: 8px; }\n      .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget.dropdown-menu.top:before {\n        border-left: 7px solid transparent;\n        border-right: 7px solid transparent;\n        border-top: 7px solid #ccc;\n        border-top-color: rgba(0, 0, 0, 0.2);\n        bottom: -7px;\n        left: 6px; }\n      .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget.dropdown-menu.top:after {\n        border-left: 6px solid transparent;\n        border-right: 6px solid transparent;\n        border-top: 6px solid white;\n        bottom: -6px;\n        left: 7px; }\n      .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before {\n        left: auto;\n        right: 6px; }\n      .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after {\n        left: auto;\n        right: 7px; }\n    .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .list-unstyled {\n      margin: 0; }\n    .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget a[data-action] {\n      padding: 6px 0; }\n    .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget a[data-action]:active {\n      box-shadow: none; }\n    .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .timepicker-hour, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .timepicker-minute, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .timepicker-second {\n      width: 54px;\n      font-weight: bold;\n      font-size: 1.2em;\n      margin: 0; }\n    .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget button[data-action] {\n      padding: 6px; }\n    .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"incrementHours\"]::after {\n      content: \"Increment Hours\"; }\n    .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"incrementMinutes\"]::after {\n      content: \"Increment Minutes\"; }\n    .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"decrementHours\"]::after {\n      content: \"Decrement Hours\"; }\n    .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"decrementMinutes\"]::after {\n      content: \"Decrement Minutes\"; }\n    .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"showHours\"]::after {\n      content: \"Show Hours\"; }\n    .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"showMinutes\"]::after {\n      content: \"Show Minutes\"; }\n    .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"togglePeriod\"]::after {\n      content: \"Toggle AM/PM\"; }\n    .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"clear\"]::after {\n      content: \"Clear the picker\"; }\n    .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .btn[data-action=\"today\"]::after {\n      content: \"Set the date to today\"; }\n    .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .picker-switch {\n      text-align: center; }\n      .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .picker-switch::after {\n        content: \"Toggle Date and Time Screens\"; }\n      .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .picker-switch td {\n        padding: 0;\n        margin: 0;\n        height: auto;\n        width: auto;\n        line-height: inherit; }\n        .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget .picker-switch td span {\n          line-height: 2.5;\n          height: 2.5em;\n          width: 100%; }\n    .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table {\n      width: 100%;\n      margin: 0; }\n      .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table td,\n      .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table th {\n        text-align: center;\n        border-radius: 4px; }\n      .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table th {\n        height: 20px;\n        line-height: 20px;\n        width: 20px; }\n        .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table th.picker-switch {\n          width: 145px; }\n        .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table th.disabled, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table th.disabled:hover {\n          background: none;\n          color: #777777;\n          cursor: not-allowed; }\n        .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table th.prev::after {\n          content: \"Previous Month\"; }\n        .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table th.next::after {\n          content: \"Next Month\"; }\n      .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table thead tr:first-child th {\n        cursor: pointer; }\n        .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table thead tr:first-child th:hover {\n          background: #eeeeee; }\n      .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table td {\n        height: 54px;\n        line-height: 54px;\n        width: 54px; }\n        .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table td.cw {\n          font-size: .8em;\n          height: 20px;\n          line-height: 20px;\n          color: #777777; }\n        .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table td.day {\n          height: 20px;\n          line-height: 20px;\n          width: 20px; }\n        .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table td.day:hover, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table td.hour:hover, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table td.minute:hover, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table td.second:hover {\n          background: #eeeeee;\n          cursor: pointer; }\n        .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table td.old, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table td.new {\n          color: #777777; }\n        .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table td.today {\n          position: relative; }\n          .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table td.today:before {\n            content: '';\n            display: inline-block;\n            border: solid transparent;\n            border-width: 0 0 7px 7px;\n            border-bottom-color: #337ab7;\n            border-top-color: rgba(0, 0, 0, 0.2);\n            position: absolute;\n            bottom: 4px;\n            right: 4px; }\n        .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table td.active, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table td.active:hover {\n          background-color: #337ab7;\n          color: #fff;\n          text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25); }\n        .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table td.active.today:before {\n          border-bottom-color: #fff; }\n        .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table td.disabled, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table td.disabled:hover {\n          background: none;\n          color: #777777;\n          cursor: not-allowed; }\n        .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table td span {\n          display: inline-block;\n          width: 54px;\n          height: 54px;\n          line-height: 54px;\n          margin: 2px 1.5px;\n          cursor: pointer;\n          border-radius: 4px; }\n          .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table td span:hover {\n            background: #eeeeee; }\n          .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table td span.active {\n            background-color: #337ab7;\n            color: #fff;\n            text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25); }\n          .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table td span.old {\n            color: #777777; }\n          .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table td span.disabled, .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget table td span.disabled:hover {\n            background: none;\n            color: #777777;\n            cursor: not-allowed; }\n    .fmcy-plugin-bootstrap .bootstrap-datetimepicker-widget.usetwentyfour td.hour {\n      height: 27px;\n      line-height: 27px; }\n  .fmcy-plugin-bootstrap .input-group.date .input-group-addon {\n    cursor: pointer; }\n\n.fmcy-plugin-bootstrap .btn-fmcy {\n  font-family: 'bebasneue', 'Arial', sans-serif;\n  font-size: 20px;\n  color: #FFF;\n  font-weight: normal;\n  font-style: normal;\n  text-transform: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  speak: none;\n  display: inline-block;\n  text-shadow: 0px 0px 0 rgba(255, 255, 255, 0.3);\n  -moz-box-shadow: inset 0 0px 0 0 rgba(255, 255, 255, 0.4), 0px 0px 0px rgba(0, 0, 0, 0.1);\n  -webkit-box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, 0.4), 1px 1px 1px rgba(0, 0, 0, 0.1);\n  box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, 0.4), 1px 1px 1px rgba(0, 0, 0, 0.1);\n  -moz-border-radius: 5px;\n  -webkit-border-radius: 5px;\n  border-radius: 5px;\n  border-radius: 5px;\n  border: 3px solid white;\n  background: none;\n  box-shadow: none; }\n  .fmcy-plugin-bootstrap .btn-fmcy:hover, .fmcy-plugin-bootstrap .btn-fmcy:active, .fmcy-plugin-bootstrap .btn-fmcy:active:hover, .fmcy-plugin-bootstrap .btn-fmcy.active, .fmcy-plugin-bootstrap .btn-fmcy:focus, .fmcy-plugin-bootstrap .btn-fmcy.focus {\n    background: none;\n    color: #625840;\n    border-color: #FFF;\n    box-shadow: none;\n    outline: 0; }\n  .fmcy-plugin-bootstrap .btn-fmcy.btn-success {\n    border-color: #000;\n    color: #000; }\n    .fmcy-plugin-bootstrap .btn-fmcy.btn-success:hover, .fmcy-plugin-bootstrap .btn-fmcy.btn-success:active, .fmcy-plugin-bootstrap .btn-fmcy.btn-success:active:hover, .fmcy-plugin-bootstrap .btn-fmcy.btn-success.active, .fmcy-plugin-bootstrap .btn-fmcy.btn-success:focus, .fmcy-plugin-bootstrap .btn-fmcy.btn-success.focus {\n      border-color: #625840;\n      color: #625840;\n      background: none; }\n", ""]);
	
	// exports


/***/ },
/* 228 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/fonts/glyphicons-halflings-regular-e18bbf611f2a2e43afc071aa2f4e1512.ttf";

/***/ },
/* 229 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/fonts/glyphicons-halflings-regular-fa2772327f55d8198301fdb8bcfc8158.woff";

/***/ },
/* 230 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/fonts/glyphicons-halflings-regular-448c34a56d699c29117adc64c43affeb.woff2";

/***/ },
/* 231 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/glyphicons-halflings-regular-89889688147bd7575d6327160d64e760.svg";

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(227);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./bootstrap.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./bootstrap.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 233 */,
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {'use strict';
	
	__webpack_require__(250);
	var BaseViews = __webpack_require__(5);
	var CartLocationDisplay = __webpack_require__(91);
	var LocationsList = Backbone.Marionette.CompositeView.extend({
	  template: __webpack_require__(254),
	  className: 'fmcy-locations-list container-fluid',
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      _appChannel: null,
	      resizeHeightToScreenSize: true,
	      actionButton: true,
	      clickableLocationInfo: false
	    });
	  },
	  childView: CartLocationDisplay,
	  childViewContainer: '.fmcy-locations-list-container',
	  childViewOptions: function childViewOptions(model, index) {
	    var opts = {
	      model: model,
	      hidePhotoSmallScreen: false,
	      actionButton: this.options.actionButton,
	      buttonText: 'Select',
	      clickableLocationInfo: this.options.clickableLocationInfo
	    };
	    return opts;
	  },
	  childEvents: {
	    'item:clicked': function itemClicked(view, model) {
	      this.trigger('item:clicked', model);
	    },
	    'info:clicked': function infoClicked(view, model) {
	      this.trigger('info:clicked', model);
	    }
	  },
	  _onWindowResize: function _onWindowResize() {
	    this.$el.css('min-height', $(window).height());
	    if ($(window).width() > 900) {
	      this.$el.css('width', 450);
	    } else {
	      this.$el.css('width', $(window).width());
	    }
	  },
	  onRender: function onRender() {
	    if (this.options.resizeHeightToScreenSize) {
	      this.$el.css('padding-bottom', '200px');
	      $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
	      this._onWindowResize();
	    }
	    BaseViews.LayoutView.prototype.onRender.call(this);
	  },
	  onDestroy: function onDestroy() {
	    if (this.options.resizeHeightToScreenSize) {
	      $(window).off('resize.' + this.cid);
	    }
	    BaseViews.LayoutView.prototype.onDestroy.call(this);
	  }
	});
	module.exports = LocationsList;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _, moment, Backbone) {'use strict';
	
	__webpack_require__(369);
	__webpack_require__(198);
	var Moment = __webpack_require__(8);
	var EntitiesBase = __webpack_require__(17);
	var DateUtils = __webpack_require__(10);
	var Obscura = __webpack_require__(103);
	var lsCache = __webpack_require__(77);
	var LS_CACHE_CART_ID = 'farm_cart_collection_3';
	var CACHE_TIMEOUT = 14400000;
	var STANDARD_GST_MULTIPLIER = 0.05;
	var CUSTOMER_TOTAL_PER_ORDER_CANNABIS_WEIGHT = 30; // 30 grams
	var validationUtils = __webpack_require__(29);
	var StringUtils = __webpack_require__(9);
	
	var cartCommonMixin = {
	  addCartItem: function addCartItem(filterLocation, userId, variantModel, menuItemModel) {
	    var imageUrl = null;
	    var cartCount;
	    if (menuItemModel.get('images').length > 0) {
	      var images = menuItemModel.get('images');
	      var primaryImage = images.findWhere({ is_primary: '1' });
	      if (primaryImage) {
	        imageUrl = primaryImage.get('thumb_url');
	      } else {
	        imageUrl = images.at(0).get('thumb_url');
	      }
	    }
	    var existingCartItem = this.findWhere({
	      variant_id: variantModel.get('id'),
	      location: filterLocation,
	      user_id: userId
	    });
	    if (existingCartItem) {
	      // up the cart count....
	      cartCount = parseInt(existingCartItem.get('cartCount'));
	      cartCount = cartCount += 1;
	      existingCartItem.set('cartCount', cartCount);
	    } else {
	      cartCount = 1;
	      this.add(new CartItemModel({
	        title: menuItemModel.get('title'),
	        quantity: variantModel.get('quantity'),
	        weight: variantModel.get('weight'),
	        on_sale: variantModel.get('on_sale'),
	        sale_price: variantModel.get('sale_price'),
	        price: variantModel.get('price'),
	        mix_match_codes: variantModel.get('mix_match_codes'),
	        long_descr_pos: variantModel.get('long_descr_pos'),
	        promotion_headline: variantModel.get('promotion_headline'),
	        sale_min_qty: variantModel.get('sale_min_qty'),
	        sale_min_qty_discount: variantModel.get('sale_min_qty_discount'),
	        variant_id: variantModel.get('id'),
	        product_id: variantModel.get('product_id'),
	        vendor_name: menuItemModel.get('vendor_name'),
	        id_pos: variantModel.get('id_pos'),
	        slug: menuItemModel.get('slug'),
	        thumb_url: imageUrl,
	        user_id: userId,
	        location: filterLocation,
	        cartCount: cartCount
	      }));
	    }
	  },
	  itemsByUserLocation: function itemsByUserLocation(filterLocation, userId, updateSubTotalSkip) {
	    var cart_items = new Obscura(this);
	    cart_items.filterBy('userLocation', function (model) {
	      if (userId === model.get('user_id') && filterLocation === model.get('location')) {
	        return true;
	      } else {
	        return false;
	      }
	    });
	
	    if (updateSubTotalSkip !== null && updateSubTotalSkip === true) {
	      cart_items.each(function (model) {
	        model.updateSubTotal(filterLocation, userId);
	      });
	    }
	
	    return cart_items;
	  },
	  moveCartItemsToLocation: function moveCartItemsToLocation(userId, currentLocation, requestedLocation) {
	    var self = this;
	    var $deferred = $.Deferred();
	
	    // get current location cart items...
	    var currentCartItems = this.itemsByUserLocation(currentLocation, userId);
	
	    //clear destination cart items
	    this.clearCart(requestedLocation, userId);
	
	    // loop through and move to new location
	    currentCartItems.each(function (model) {
	      var modelJSON = model.toJSON();
	      delete modelJSON.id;
	      modelJSON.location = requestedLocation;
	      self.add(new CartItemModel(modelJSON));
	    });
	
	    //clear current once moved
	    this.clearCart(currentLocation, userId);
	
	    $deferred.resolve(this.itemsByUserLocation(requestedLocation, userId));
	    return $deferred.promise();
	  },
	  totalCountByUserLocation: function totalCountByUserLocation(filterLocation, userId) {
	    var count = 0;
	    this.each(function (model) {
	      if (userId === model.get('user_id') && filterLocation === model.get('location')) {
	        count += parseInt(model.get('cartCount'));
	      }
	    });
	    return count;
	  },
	  totalCostByUserLocation: function totalCostByUserLocation(userId, filterLocation, filterLocationDetails) {
	    var subTotal = 0;
	    var total = 0;
	    var tax = 0;
	    var taxGST = 0;
	    var taxPST = 0;
	    var groupDiscounts = 0;
	    var depositTotal = 0;
	    var extraDiscount = 0;
	    var deliveryTotal = 0;
	    var tipTotal = 0;
	    var tipPercentage = 0;
	
	    this.each(function (model) {
	      if (userId === model.get('user_id') && filterLocation === model.get('location')) {
	        var itemSubTotal = model.getSubTotal(filterLocation, userId);
	        subTotal += itemSubTotal.item_sub_total;
	        depositTotal += itemSubTotal.deposit_cost_total;
	        groupDiscounts += itemSubTotal.itemGroupDiscount;
	        taxGST += itemSubTotal.total_tax_gst;
	        taxPST += itemSubTotal.total_tax_pst;
	      }
	    });
	
	    if (this.deliveryModel.get('deliveryMethod') == 'local_delivery') {
	      var basicDeliveryCost;
	      if (!filterLocationDetails.get('delivery_fee')) {
	        basicDeliveryCost = 0;
	      } else {
	        basicDeliveryCost = parseFloat(filterLocationDetails.get('delivery_fee'));
	      }
	
	      deliveryTotal += basicDeliveryCost;
	      taxGST += deliveryTotal * STANDARD_GST_MULTIPLIER;
	
	      if (this.deliveryModel.get('deliveryTipPercentage') !== null) {
	        tipPercentage = parseFloat(this.deliveryModel.get('deliveryTipPercentage'));
	      } else {
	        tipPercentage = parseFloat(filterLocationDetails.get('default_tip'));
	      }
	    } // end if local_delivery
	
	    // round the tax at the end and calculate the total
	    tax = Math.round(taxGST * 100) / 100 + Math.round(taxPST * 100) / 100;
	    total = subTotal + tax + depositTotal + deliveryTotal;
	
	    tipTotal = Math.round(total * tipPercentage * 100) / 100;
	
	    total += tipTotal;
	
	    return {
	      subTotal: subTotal,
	      groupDiscounts: groupDiscounts,
	      depositTotal: depositTotal,
	      deliveryTotal: deliveryTotal,
	      tipTotal: tipTotal,
	      tipPercentage: tipPercentage,
	      tax: tax,
	      taxGST: taxGST,
	      taxPST: taxPST,
	      total: total
	    };
	  },
	  updateSubTotals: function updateSubTotals(filterLocation, userId) {
	    this.each(function (model) {
	      if (userId === model.get('user_id') && filterLocation === model.get('location')) {
	        model.updateSubTotal(filterLocation, userId);
	      }
	    });
	    return this;
	  },
	  totalCartWeight: function totalCartWeight(options) {
	    var options = _.defaults(options || {}, {
	      filterLocation: null,
	      userId: null,
	      totalCannabisWeightAllowed: CUSTOMER_TOTAL_PER_ORDER_CANNABIS_WEIGHT
	    });
	
	    var totalWeight = 0;
	    this.each(function (model) {
	      if (options.userId === model.get('user_id') && options.filterLocation === model.get('location')) {
	        var weight = parseFloat(model.get('weight'));
	        if (weight !== null && weight !== 0 && !isNaN(weight)) {
	          totalWeight += parseFloat(model.get('cartCount')) * weight;
	        }
	      }
	    });
	
	    // round to two decimal places...
	    totalWeight = +(Math.round(totalWeight + 'e+2') + 'e-2');
	    var weightError = false;
	    var weightOver = 0;
	    if (totalWeight > options.totalCannabisWeightAllowed) {
	      weightError = true;
	      weightOver = totalWeight - options.totalCannabisWeightAllowed;
	    }
	
	    lsCache.set(LS_CACHE_CART_ID, this.toJSON(), CACHE_TIMEOUT);
	
	    return {
	      error: weightError,
	      totalWeight: totalWeight,
	      weightOver: weightOver
	    };
	  },
	  cleanupErrors: function cleanupErrors() {
	    this.each(function (model) {
	      model.set('error', false);
	      model.set('actualCount', null);
	      model.set('code', null);
	    });
	  },
	  customerBrowserDetails: function customerBrowserDetails() {
	    var browserTime = new Date();
	    return {
	      colorDepth: screen.colorDepth,
	      javaEnabled: navigator.javaEnabled(),
	      browserLanguage: navigator.language,
	      screenHeight: screen.height,
	      screenWidth: screen.width,
	      userAgent: navigator.userAgent,
	      browserTimezoneZoneOffset: browserTime.getTimezoneOffset()
	    };
	  },
	  submitOrder: function submitOrder(userId, filterLocation, filterLocationDetails) {
	    var self = this;
	    var $deferred = $.Deferred();
	    var order_cost = this.totalCostByUserLocation(userId, filterLocation, filterLocationDetails);
	    var payment_method = this.paymentModel.get('paymentMethod');
	    var delivery_method = this.deliveryModel.get('deliveryMethod');
	
	    var cartGiftModel = null;
	    if (farmacy.settings.giftEnabled) {
	      cartGiftModel = this.paymentModel.get('cartGiftModel').toJSON();
	    }
	
	    var deliveryAddressModel = this.deliveryModel.get('cartDeliveryAddressModel');
	    if (deliveryAddressModel !== null) {
	      deliveryAddressModel = deliveryAddressModel.toJSON();
	    }
	
	    var localDeliveryDetails = null;
	
	    if (delivery_method == 'local_delivery') {
	
	      var serverUnixTime = moment().unix() + filterLocationDetails.get('server_client_time_offset');
	
	      this.deliveryModel.set('deliveryDate', DateUtils.getFormattedTimestamp(serverUnixTime, {
	        format: 'MMMM Do, YYYY'
	      }));
	
	      this.deliveryModel.set('deliveryTime', serverUnixTime);
	
	      this.deliveryModel.set('deliveryTimeReadable', DateUtils.getFormattedTimestamp(serverUnixTime, {
	        format: 'h:mm:ss a'
	      }));
	
	      if (filterLocationDetails.get('delivery_to_minutes')) {
	        this.deliveryModel.set('deliveryWindowMinutes', filterLocationDetails.get('delivery_to_minutes'));
	      }
	
	      localDeliveryDetails = {
	        deliveryTime: this.deliveryModel.get('deliveryTime'),
	        deliveryTimeReadable: this.deliveryModel.get('deliveryTimeReadable'),
	        deliveryTimeStartUnix: this.deliveryModel.get('deliveryTimeStartUnix'),
	        deliveryTimeEndUnix: this.deliveryModel.get('deliveryTimeEndUnix'),
	        deliveryWindowMinutes: this.deliveryModel.get('deliveryWindowMinutes'),
	        deliveryDate: this.deliveryModel.get('deliveryDate'),
	        deliveryNotes: this.deliveryModel.get('deliveryNotes'),
	        deliveryPhone: this.deliveryModel.get('deliveryPhone')
	      };
	    }
	
	    Backbone.Radio.channel('global').request('ajax', 'farmacyajaxv2-ordercartitems', {
	      location_slug: filterLocation,
	      user_id: userId,
	      subTotal: order_cost.subTotal,
	      tax: order_cost.tax,
	      taxGST: order_cost.taxGST,
	      taxPST: order_cost.taxPST,
	      depositTotal: order_cost.depositTotal,
	      total: order_cost.total,
	      tip_total: order_cost.tipTotal,
	      tip_percentage: order_cost.tipPercentage,
	      delivery_total: order_cost.deliveryTotal,
	      delivery_method: delivery_method,
	      payment_method: payment_method,
	      cart_items: this.itemsByUserLocation(filterLocation, userId).toJSON(),
	      gift_details: cartGiftModel,
	      local_delivery_details: localDeliveryDetails,
	      delivery_address: deliveryAddressModel
	    }).success(function (response) {
	      $deferred.resolve(response);
	    }).fail(function (error) {
	      $deferred.reject();
	    });
	    return $deferred.promise();
	  },
	  payOrder: function payOrder(options) {
	    var three_d_secure_trans = farmacy.settings.payments.threeDSecureByLocation[options.filterLocation];
	    if (three_d_secure_trans == true) {
	      return this.payOrder3dSecure(options);
	    } else {
	      return this.payOrderLegacy();
	    }
	  },
	  payOrderLegacy: function payOrderLegacy() {
	    var self = this;
	    var $deferred = $.Deferred();
	    if (this.paymentModel.get('currentOrder')) {
	
	      Backbone.Radio.channel('global').request('ajax', 'farmacyajaxv2-orderpay', {
	        order_id: this.paymentModel.get('currentOrder').get('order_id'),
	        payment_method: this.paymentModel.get('paymentMethod'),
	        payment_method_details: this.paymentModel.get('paymentCreditCardModel').toJSON(),
	        customer_browser_details: this.customerBrowserDetails(),
	        three_d_secure_trans: false
	      }).success(function (response) {
	        if (response.error == false && response.message.order_id) {
	          // clear card payment_method_details...
	          self.paymentModel.set('paymentCreditCardModel', new PaymentCreditCardModel());
	          self.paymentModel.set('cartGiftModel', new CartGiftModel());
	        } else {
	          // error specific to field
	          if (response.errorField !== null) {
	            var paymentCreditCardModel = self.paymentModel.get('paymentCreditCardModel');
	            if (paymentCreditCardModel) {
	              paymentCreditCardModel.set('cc_security_code', null);
	              if (response.errorField === 'cc_number') {
	                // clear all card data when declined, usually a smell for fraud
	                self.clearCardDetails();
	              }
	            }
	          }
	        }
	        $deferred.resolve(response);
	      }).fail(function (error) {
	        $deferred.reject();
	      });
	    } else {
	      $deferred.reject();
	    }
	    return $deferred.promise();
	  },
	  payOrder3dSecure: function payOrder3dSecure(options) {
	    var self = this;
	    var $deferred = $.Deferred();
	    var _appChannel = options._appChannel;
	
	    if (this.paymentModel.get('currentOrder')) {
	      var data = {
	        order_id: this.paymentModel.get('currentOrder').get('order_id'),
	        payment_method: this.paymentModel.get('paymentMethod'),
	        payment_method_details: this.paymentModel.get('paymentCreditCardModel').toJSON(),
	        customer_browser_details: this.customerBrowserDetails(),
	        three_d_secure_trans: true,
	        three_d_secure_trans_step: 'challenge'
	      };
	      var handleError = function handleError(response) {
	        // error specific to field
	        if (response.errorField !== null) {
	          var paymentCreditCardModel = self.paymentModel.get('paymentCreditCardModel');
	          if (paymentCreditCardModel) {
	            paymentCreditCardModel.set('cc_security_code', null);
	            if (response.errorField === 'cc_number') {
	              // clear all card data when declined, usually a smell for fraud
	              self.clearCardDetails();
	            }
	          }
	        }
	        $deferred.resolve(response);
	      };
	      Backbone.Radio.channel('global').request('ajax', 'farmacyajaxv2-orderpay', data).success(function (challengeResponse) {
	        if (challengeResponse.error == false && challengeResponse.type == 'three_d_secure') {
	          // clear payment data
	          self.paymentModel.set('paymentCreditCardModel', new PaymentCreditCardModel());
	          self.paymentModel.set('cartGiftModel', new CartGiftModel());
	          $deferred.resolve({
	            error: false,
	            data: {
	              type: 'three_d_secure',
	              challengeUrl: challengeResponse.data.challengeUrl,
	              challengeData: challengeResponse.data.challengeData
	            }
	          });
	        } else if (challengeResponse.error == false && challengeResponse.message.order_id) {
	          // frictionless response...
	          self.paymentModel.set('paymentCreditCardModel', new PaymentCreditCardModel());
	          self.paymentModel.set('cartGiftModel', new CartGiftModel());
	          $deferred.resolve(challengeResponse);
	        } else {
	          handleError(challengeResponse);
	        }
	      }).fail(function (error) {
	        $deferred.reject();
	      });
	    } else {
	      $deferred.reject();
	    }
	    return $deferred.promise();
	  },
	  clearCardDetails: function clearCardDetails() {
	    var paymentCreditCardModel = this.paymentModel.get('paymentCreditCardModel');
	    if (paymentCreditCardModel) {
	      paymentCreditCardModel.set('cc_name_on_card', null);
	      paymentCreditCardModel.set('cc_number', null);
	      paymentCreditCardModel.set('cc_expiry_date', null);
	      paymentCreditCardModel.set('cc_security_code', null);
	      paymentCreditCardModel.set('cc_postal_code', null);
	    }
	  },
	  clearCart: function clearCart(filterLocation, userId) {
	    var self = this;
	    this.itemsByUserLocation(filterLocation, userId).each(function () {
	      self.findWhere({
	        location: filterLocation,
	        user_id: userId
	      }).destroy();
	    });
	  },
	  checkCartItemsForPriceChanges: function checkCartItemsForPriceChanges(filterLocation, userId) {
	    var self = this;
	    var $deferred = $.Deferred();
	    var errors = [];
	
	    if (this.itemsByUserLocation(filterLocation, userId).length === 0) {
	      $deferred.resolve();
	    }
	
	    Backbone.Radio.channel('global').request('ajax', 'farmacyajaxv2-verifycartprices', {
	      location_slug: filterLocation,
	      cart_items: this.itemsByUserLocation(filterLocation, userId).toJSON()
	    }).success(function (response) {
	      var changeCount = 0;
	      response.variants.forEach(function (variant, index) {
	        if (variant.on_sale == '1') {
	          variant.on_sale = true;
	        } else {
	          variant.on_sale = false;
	        }
	
	        var modelMatch = self.findWhere({
	          variant_id: variant.id,
	          user_id: userId,
	          location: filterLocation
	        });
	        if (modelMatch) {
	          if (modelMatch.get('price') !== variant.price) {
	            modelMatch.set('price', variant.price);
	            changeCount += 1;
	          }
	
	          if (modelMatch.get('sale_price') !== variant.sale_price) {
	            modelMatch.set('sale_price', variant.sale_price);
	            changeCount += 1;
	          }
	
	          if (modelMatch.get('on_sale') !== variant.on_sale) {
	            modelMatch.set('on_sale', variant.on_sale);
	            changeCount += 1;
	          }
	
	          if (modelMatch.get('weight') !== variant.weight) {
	            modelMatch.set('weight', variant.weight);
	            changeCount += 1;
	          }
	
	          if (modelMatch.get('tax_code') !== variant.tax_code) {
	            modelMatch.set('tax_code', variant.tax_code);
	            changeCount += 1;
	          }
	
	          if (modelMatch.get('tax_code_pst_percentage') !== variant.tax_code_pst_percentage) {
	            modelMatch.set('tax_code_pst_percentage', variant.tax_code_pst_percentage);
	            changeCount += 1;
	          }
	
	          if (modelMatch.get('tax_code_gst_percentage') !== variant.tax_code_gst_percentage) {
	            modelMatch.set('tax_code_gst_percentage', variant.tax_code_gst_percentage);
	            changeCount += 1;
	          }
	
	          if (modelMatch.get('tax_code_gst_on_pst') !== variant.tax_code_gst_on_pst) {
	            modelMatch.set('tax_code_gst_on_pst', variant.tax_code_gst_on_pst);
	            changeCount += 1;
	          }
	
	          if (modelMatch.get('tax_code_flat_fee') !== variant.tax_code_flat_fee) {
	            modelMatch.set('tax_code_flat_fee', variant.tax_code_flat_fee);
	            changeCount += 1;
	          }
	
	          if (modelMatch.get('deposit_cost') !== variant.deposit_cost) {
	            modelMatch.set('deposit_cost', variant.deposit_cost);
	            changeCount += 1;
	          }
	
	          if (modelMatch.get('long_descr_pos') !== variant.long_descr_pos) {
	            modelMatch.set('long_descr_pos', variant.long_descr_pos);
	            changeCount += 1;
	          }
	
	          if (modelMatch.get('mix_match_codes') !== variant.mix_match_codes) {
	            modelMatch.set('mix_match_codes', variant.mix_match_codes);
	            changeCount += 1;
	          }
	
	          if (modelMatch.get('sale_min_qty') !== variant.sale_min_qty) {
	            modelMatch.set('sale_min_qty', variant.sale_min_qty);
	            changeCount += 1;
	          }
	
	          if (modelMatch.get('sale_min_qty_discount') !== variant.sale_min_qty_discount) {
	            modelMatch.set('sale_min_qty_discount', variant.sale_min_qty_discount);
	            changeCount += 1;
	          }
	
	          if (modelMatch.get('promotion_headline') !== variant.promotion_headline) {
	            modelMatch.set('promotion_headline', variant.promotion_headline);
	            changeCount += 1;
	          }
	
	          if (modelMatch.get('sub_category_id_pos') !== variant.sub_category_id_pos) {
	            modelMatch.set('sub_category_id_pos', variant.sub_category_id_pos);
	            changeCount += 1;
	          }
	
	          if (modelMatch.get('category_id_pos') !== variant.category_id_pos) {
	            modelMatch.set('category_id_pos', variant.category_id_pos);
	            changeCount += 1;
	          }
	        }
	      });
	
	      if (changeCount > 0) {
	        self.updateSubTotals(filterLocation, userId);
	        lsCache.set(LS_CACHE_CART_ID, self.toJSON(), CACHE_TIMEOUT);
	      }
	
	      $deferred.resolve({
	        changeCount: changeCount
	      });
	    }).fail(function () {
	      $deferred.reject();
	    });
	    return $deferred.promise();
	  },
	  validateCartContents: function validateCartContents(userId, filterLocation, filterLocationDetails) {
	    var self = this;
	    var $deferred = $.Deferred();
	    var errors = null;
	
	    if (this.itemsByUserLocation(filterLocation, userId).length === 0) {
	      errors.push({
	        code: 'cartempty'
	      });
	      $deferred.resolve({
	        errors: errors
	      });
	    }
	
	    function parseInventoryErrors(response) {
	      self.cleanupErrors();
	      errors = response.pos_verify_inventory_errors;
	      if (errors == null || errors.length == 0) {
	        errors = response.local_verify_inventory_errors;
	      }
	
	      if (errors !== null) {
	        errors.forEach(function (error, index) {
	          var modelMatch = self.findWhere({
	            variant_id: error.variant_id,
	            user_id: userId,
	            location: filterLocation
	          });
	          if (modelMatch) {
	            modelMatch.set('error', true);
	            modelMatch.set('actualCount', parseInt(error.actualCount));
	            modelMatch.set('code', error.code);
	          }
	        });
	      } else {
	        errors = [];
	      }
	      var totalCannabisWeightAllowed = CUSTOMER_TOTAL_PER_ORDER_CANNABIS_WEIGHT;
	      if (totalCannabisWeightAllowed <= 0) {
	        totalCannabisWeightAllowed = 0;
	      }
	      var totalCartWeight = self.totalCartWeight({
	        filterLocation: filterLocation,
	        userId: userId,
	        totalCannabisWeightAllowed: totalCannabisWeightAllowed
	      });
	
	      if (totalCartWeight.error === true) {
	
	        var message = null;
	        if (totalCannabisWeightAllowed !== CUSTOMER_TOTAL_PER_ORDER_CANNABIS_WEIGHT) {
	          message = 'You can only order a total 30 grams at a time. This includes previous orders not picked up or delivered. Currently your profile has exceeded the 30 gram order limit by ' + totalCartWeight.weightOver + ' grams. Please remove items from this order';
	        }
	
	        errors.push({
	          code: 'overlimit',
	          message: message
	        });
	      }
	
	      if (response.paymentMethods !== null) {
	
	        var paymentMethodAvailable = true;
	
	        if (self.paymentModel.get('paymentMethod') == 'credit' && !response.paymentMethods.creditCardPaymentEnabled) {
	          paymentMethodAvailable = false;
	        }
	
	        if (self.paymentModel.get('paymentMethod') == 'interac' && !response.paymentMethods.interacPaymentEnabled) {
	          paymentMethodAvailable = false;
	        }
	
	        /*
	        // leaving this here in case we want to pivot on the returned settings change, in the case of settings changing
	        // when a user is in the checkout flow.
	        farmacy.settings.payments.interacPaymentEnabled = response.paymentMethods.interacPaymentEnabled;
	        farmacy.settings.payments.creditCardPaymentEnabled = response.paymentMethods.creditCardPaymentEnabled;
	        */
	
	        if (!paymentMethodAvailable) {
	          errors.push({
	            code: 'paymentmethod',
	            message: 'The payment method you have selected is currently unavailable at this time.'
	          });
	        }
	      }
	
	      // if its local delivery validate address and delivery time.
	      if (self.deliveryModel.get('deliveryMethod') == 'local_delivery') {
	
	        var cartdeliveryAddressModel = self.deliveryModel.get('cartDeliveryAddressModel');
	        var postalCodeError = false;
	        if (cartdeliveryAddressModel.get('local_delivery_confirmed_farm_location_slug') !== filterLocation || cartdeliveryAddressModel.get('local_delivery_postal_code_verified') == null || cartdeliveryAddressModel.get('local_delivery_postal_code_verified') !== cartdeliveryAddressModel.get('local_delivery_postal_code')) {
	          postalCodeError = true;
	        }
	        if (postalCodeError == true) {
	          errors.push({
	            code: 'postalcode',
	            message: 'Postal code must be verified.'
	          });
	        }
	
	        var addressError = false;
	        if (cartdeliveryAddressModel.get('local_delivery_street_address') == null || cartdeliveryAddressModel.get('local_delivery_street_address').length < 1) {
	          errors.push({
	            code: 'deliveryaddress',
	            message: 'Please provide a valid address.'
	          });
	        }
	
	        // basic length validation on phone number, pretty much just checking if its blank.
	        if (self.deliveryModel.get('deliveryPhone') == null || self.deliveryModel.get('deliveryPhone').length < 7) {
	          errors.push({
	            code: 'phone',
	            message: 'Please provide a valid phone number.'
	          });
	        }
	
	        var deliveryMinimumCartTotal = 0;
	        if (filterLocationDetails.get('delivery_min_dollar_amount')) {
	          deliveryMinimumCartTotal = parseFloat(filterLocationDetails.get('delivery_min_dollar_amount'));
	        }
	        var order_cost = self.totalCostByUserLocation(userId, filterLocation, filterLocationDetails);
	        if (order_cost.subTotal < deliveryMinimumCartTotal) {
	          errors.push({
	            code: 'deliveryminimum',
	            message: 'For local delivery a minimum order of ' + StringUtils.currency(deliveryMinimumCartTotal) + ' before taxes and tip is required.'
	          });
	        }
	
	        var deliveryErrorMessage = 'Delivery is unavailable at this time.';
	
	        if (parseInt(filterLocationDetails.get('delivery_active')) == 0 || filterLocationDetails.get('delivery_active') == false) {
	          errors.push({
	            code: 'deliveryunavailable',
	            message: deliveryErrorMessage
	          });
	        } else {
	
	          // validate if delivery is still active, in the case that they have had the cart sitting open.
	          if (!filterLocationDetails.isDeliveryAvailableAtCurrentTime().available) {
	
	            var deliveryNextAvailable = filterLocationDetails.deliveryNextAvailable();
	
	            if (deliveryNextAvailable.available) {
	              if (deliveryNextAvailable.isToday) {
	                deliveryNextAvailable.day = 'today';
	              } else {
	                deliveryNextAvailable.day = deliveryNextAvailable.day.charAt(0).toUpperCase() + deliveryNextAvailable.day.slice(1);
	              }
	
	              deliveryErrorMessage += ' Delivery will be available again ' + deliveryNextAvailable.day + ' between ' + deliveryNextAvailable.startTime + ' and ' + deliveryNextAvailable.endTime;
	
	              errors.push({
	                code: 'deliveryunavailable',
	                message: deliveryErrorMessage
	              });
	            }
	          }
	        }
	      } // end if local_delivery
	
	      $deferred.resolve({
	        errors: errors
	      });
	    } // end parseInventoryErrors function...
	
	    Backbone.Radio.channel('global').request('ajax', 'farmacyajaxv2-verifycartitems', {
	      location_slug: filterLocation,
	      cart_items: this.itemsByUserLocation(filterLocation, userId).toJSON()
	    }).success(function (response) {
	      parseInventoryErrors(response);
	    }).fail(function () {
	      $deferred.reject();
	    });
	
	    return $deferred.promise();
	  }
	};
	
	var CartItemModel = EntitiesBase.ModelBase.extend({
	  defaults: {
	    title: null,
	    quantity: null,
	    on_sale: null,
	    sale_price: null,
	    price: null,
	    id: null,
	    weight: null,
	    product_id: null,
	    variant_id: null,
	    id_pos: null,
	    thumb_url: null,
	    user_id: null,
	    error: false,
	    actualCount: null,
	    code: null
	  },
	  getPrice: function getPrice() {
	    if (this.get('on_sale') === true && this.get('sale_price') !== '0' && this.get('sale_price') !== '0.00' && this.get('sale_price') !== 0 && this.get('sale_price') !== 0.00) {
	      return parseFloat(this.get('sale_price'));
	    } else {
	      return parseFloat(this.get('price'));
	    }
	  },
	  getTax: function getTax(price) {
	    var itemTax = 0;
	    var gstPercentage = parseFloat(this.get('tax_code_gst_percentage'));
	    var pstPercentage = parseFloat(this.get('tax_code_pst_percentage'));
	    var itemTaxPST;
	    var itemTaxGST;
	    if (this.get('tax_code_gst_on_pst') === '1') {
	      itemTaxPST = price * pstPercentage;
	      itemTaxGST = price * gstPercentage;
	      var gstOnPst = itemTaxPST * gstPercentage;
	      itemTaxGST += gstOnPst;
	      itemTax = itemTaxPST + itemTaxGST;
	    } else {
	      //itemTax = price * ( pstPercentage + gstPercentage );
	      itemTaxPST = price * pstPercentage;
	      itemTaxGST = price * gstPercentage;
	      itemTax = itemTaxPST + itemTaxGST;
	    }
	
	    // add flat fee tax if any...
	    itemTax += parseFloat(this.get('tax_code_flat_fee'));
	
	    return {
	      itemTotalTax: itemTax,
	      itemTaxPST: itemTaxPST,
	      itemTaxGST: itemTaxGST,
	      itemBeverageFee: parseFloat(this.get('tax_code_flat_fee')) // beverage fee
	    };
	  },
	  getSubTotal: function getSubTotal(userId, filterLocation, filterLocationDetails) {
	    var self = this;
	    var price = 0;
	    var itemDepositCost = 0;
	    var saleMinQty = parseFloat(this.get('sale_min_qty'));
	
	    var saleMinQtyDiscount;
	    var itemGroupDiscountIsPercentage = false;
	
	    // is the group discount a percentage...
	    if (typeof this.get('sale_min_qty_discount') == 'string' && this.get('sale_min_qty_discount').includes('%')) {
	      itemGroupDiscountIsPercentage = true;
	      saleMinQtyDiscount = parseFloat(this.get('sale_min_qty_discount').replace('%', ''));
	    } else {
	      saleMinQtyDiscount = parseFloat(this.get('sale_min_qty_discount'));
	    }
	
	    var itemGroupDiscount = 0;
	    var itemGroupDiscountSpread = 0;
	    var itemMixMatchDiscountSpread = 0;
	
	    var cartCount = parseFloat(this.get('cartCount'));
	
	    if (cartCount >= saleMinQty) {
	      if (itemGroupDiscountIsPercentage === true) {
	        saleMinQtyDiscount = saleMinQtyDiscount / 100;
	        // group percentage discount...
	        itemGroupDiscount = Math.floor(cartCount / saleMinQty) * saleMinQty * self.getPrice() * saleMinQtyDiscount;
	      } else {
	        // if it's buy 3 get 5 off, it would take off five at 3, and then another five at six and so on...
	        itemGroupDiscount = Math.floor(cartCount / saleMinQty) * saleMinQtyDiscount;
	      }
	
	      // spread discount out for cart display...
	      itemGroupDiscountSpread = itemGroupDiscount / cartCount;
	    }
	    //[{"MIX_MATCH_COD":"DEALERPICK","PRC_BRK_DESCR":"Total quantity 2 => Price-1 - 5","DESCR":"MIX/MATCH $10 OFF 2x 3.5G/7G","SALE_MIN_QTY_DISCOUNT":5,"SALE_MIN_QTY":3}]
	    if (this.get('mix_match_codes') !== null && this.get('mix_match_codes').length > 0) {
	      var mix_match_codes_array = JSON.parse(this.get('mix_match_codes'));
	      if (mix_match_codes_array && mix_match_codes_array.length) {
	        _.each(mix_match_codes_array, function (code, key) {
	          var codeItemCartCount = parseFloat(cartCount);
	          self.collection.itemsByUserLocation(filterLocation, userId).each(function (model) {
	            if (model.get('variant_id') !== self.get('variant_id')) {
	              // skip its the same variant
	              var model_mix_match_codes_array = JSON.parse(model.get('mix_match_codes'));
	              if (model_mix_match_codes_array && model_mix_match_codes_array.length) {
	                _.each(model_mix_match_codes_array, function (model_mix_match_code, key) {
	                  if (model_mix_match_code.MIX_MATCH_COD == code.MIX_MATCH_COD) {
	                    codeItemCartCount += parseFloat(model.get('cartCount'));
	                  }
	                }); // end each model mix codes...
	              }
	            } // if variant id's dont match
	          }); // end looping through collection looking for match
	
	          var mixMatchSaleMinQty = parseFloat(code.SALE_MIN_QTY);
	
	          var mixMatchSaleMinQtyDiscount;
	
	          var mixMatchDiscountIsPercentage = false;
	
	          if (typeof code.SALE_MIN_QTY_DISCOUNT == 'string' && code.SALE_MIN_QTY_DISCOUNT.includes('%')) {
	            mixMatchDiscountIsPercentage = true;
	            mixMatchSaleMinQtyDiscount = parseFloat(code.SALE_MIN_QTY_DISCOUNT.replace('%', ''));
	          } else {
	            mixMatchSaleMinQtyDiscount = parseFloat(code.SALE_MIN_QTY_DISCOUNT);
	          }
	          var itemMixMatchDiscount = 0;
	          if (codeItemCartCount >= mixMatchSaleMinQty) {
	            if (mixMatchDiscountIsPercentage === true) {
	              mixMatchSaleMinQtyDiscount = mixMatchSaleMinQtyDiscount / 100;
	              // percentage discount in groups...
	              itemMixMatchDiscount = Math.floor(codeItemCartCount / mixMatchSaleMinQty) * mixMatchSaleMinQty * self.getPrice() * mixMatchSaleMinQtyDiscount;
	            } else {
	              // if it's buy 3 get 5 off, it would take off five at 3, and then another five at six and so on...
	              itemMixMatchDiscount = Math.floor(codeItemCartCount / mixMatchSaleMinQty) * mixMatchSaleMinQtyDiscount;
	            }
	
	            // spread discount out for cart display...
	            itemMixMatchDiscountSpread += itemMixMatchDiscount / codeItemCartCount;
	          }
	        });
	      }
	    } // end if mix and match...
	
	    price = this.getPrice();
	    price = price - itemGroupDiscountSpread;
	    price = price - itemMixMatchDiscountSpread;
	
	    var itemTax = this.getTax(price);
	    var itemTotalTax = itemTax.itemTotalTax;
	
	    // to get savings... take original price minus price after deductions...
	    var itemSavings = parseFloat(this.getPrice() - price);
	
	    //deposit cost...
	    itemDepositCost = parseFloat(this.get('deposit_cost'));
	
	    return {
	      deposit_cost_total: cartCount * itemDepositCost,
	      group_discount_total: parseFloat(this.get('cartCount')) * itemSavings,
	      total_tax: cartCount * itemTotalTax,
	      total_tax_gst: cartCount * itemTax.itemTaxGST,
	      total_tax_pst: cartCount * itemTax.itemTaxPST,
	      item_tax: itemTotalTax,
	      item_tax_pst: itemTax.itemTaxPST,
	      item_tax_gst: itemTax.itemTaxGST,
	      item_sub_total: parseFloat(this.get('cartCount')) * parseFloat(price),
	      item_total: cartCount * (price + itemTotalTax + itemDepositCost),
	      itemDepositCost: itemDepositCost
	    };
	  },
	  updateSubTotal: function updateSubTotal(filterLocation, userId) {
	    var subTotal = this.getSubTotal(filterLocation, userId);
	    this.set('deposit_cost_total', subTotal.deposit_cost_total);
	    this.set('group_discount_total', subTotal.group_discount_total);
	    this.set('total_tax', subTotal.total_tax);
	    this.set('item_total', subTotal.item_total);
	    this.set('total_tax_gst', subTotal.total_tax_gst);
	    this.set('total_tax_pst', subTotal.total_tax_pst);
	    this.set('item_sub_total', subTotal.item_sub_total);
	  }
	});
	
	var CartCollection = EntitiesBase.CollectionBase.extend({
	  model: CartItemModel
	});
	
	_.extend(CartCollection.prototype, cartCommonMixin);
	
	var cartGiftValidationMixin = {
	  gift_receiver_name: {
	    required: true,
	    msg: validationUtils.getIsRequiredMessageForFieldName('Name')
	  },
	  gift_receiver_email: {
	    required: true,
	    msg: validationUtils.getIsRequiredMessageForFieldName('Email')
	  }
	};
	
	var CartGiftModel = EntitiesBase.ModelBase.extend({
	  constructor: function constructor(attrs, options) {
	    EntitiesBase.ModelBase.prototype.constructor.call(this, attrs, options);
	  },
	  validation: {},
	  validationFields: function validationFields() {
	    var fields = ['gift_receiver_name', 'gift_receiver_email'];
	    return fields;
	  },
	  shouldValidateGiftForm: function shouldValidateGiftForm() {
	    if (this.get('gift_receiver_name') || this.get('gift_receiver_email') || this.get('gift_receiver_message')) {
	      return true;
	    }
	  },
	  defaults: {
	    gift_receiver_name: null,
	    gift_receiver_email: null,
	    gift_receiver_message: null
	  }
	});
	
	_.extend(CartGiftModel.prototype, Backbone.Validation.mixin);
	_.extend(CartGiftModel.prototype.validation, cartGiftValidationMixin);
	
	var creditCardValidationMixin = {
	  cc_name_on_card: {
	    required: true,
	    msg: validationUtils.getIsRequiredMessageForFieldName('Name on card')
	  },
	  cc_number: {
	    required: true,
	    fn: function fn(value, attr, computedState) {
	      if (value == null || value == '') {
	        return 'Credit card number is required.';
	      } else if (!$.payment.validateCardNumber(value)) {
	        return 'Not a valid card number.';
	      }
	    }
	  },
	  cc_expiry_date: {
	    required: true,
	    fn: function fn(value, attr, computedState) {
	      if (value == null || value == '') {
	        return 'Expiry date is required.';
	      }
	      var expiryDateArray = value.split('/');
	      if (expiryDateArray.length !== 2) {
	        return 'Not a valid expiry date.';
	      } else {
	        expiryDateArray[0] = expiryDateArray[0].trim();
	        expiryDateArray[1] = expiryDateArray[1].trim();
	        if (!$.payment.validateCardExpiry(expiryDateArray[0], expiryDateArray[1])) {
	          return 'Not a valid expiry date.';
	        }
	      }
	    }
	  },
	  cc_security_code: {
	    required: true,
	    fn: function fn(value, attr, computedState) {
	      if (value == null || value == '') {
	        return 'Security code is required.';
	      } else if (!$.payment.validateCardCVC(value)) {
	        return 'Not a valid security code.';
	      }
	    }
	  },
	  cc_postal_code: {
	    required: true,
	    msg: validationUtils.getIsRequiredMessageForFieldName('ZIP / Postal code')
	  }
	};
	
	var PaymentCreditCardModel = EntitiesBase.ModelBase.extend({
	  constructor: function constructor(attrs, options) {
	    EntitiesBase.ModelBase.prototype.constructor.call(this, attrs, options);
	  },
	  validation: {},
	  validationFields: function validationFields() {
	    var fields = ['cc_name_on_card', 'cc_number', 'cc_expiry_date', 'cc_security_code', 'cc_postal_code'];
	    return fields;
	  },
	  defaults: {
	    cc_name_on_card: null,
	    cc_number: null,
	    cc_expiry_date: null,
	    cc_security_code: null,
	    cc_postal_code: null,
	    cc_card_type: null
	  }
	});
	
	_.extend(PaymentCreditCardModel.prototype, Backbone.Validation.mixin);
	_.extend(PaymentCreditCardModel.prototype.validation, creditCardValidationMixin);
	
	var PaymentModel = EntitiesBase.ModelBase.extend({
	  constructor: function constructor(attrs, options) {
	    EntitiesBase.ModelBase.prototype.constructor.call(this, attrs, options);
	  },
	  defaults: {
	    paymentMethod: 'credit', // credit...
	    paymentCreditCardModel: null,
	    isGift: false,
	    cartGiftModel: null,
	    currentOrder: null
	  }
	});
	
	var cartDeliveryAddressValidationMixin = {
	  local_delivery_street_address: {
	    required: true,
	    msg: validationUtils.getIsRequiredMessageForFieldName('Street Address')
	  },
	  local_delivery_postal_code: {
	    required: true,
	    msg: validationUtils.getIsRequiredMessageForFieldName('Postal Code')
	  }
	};
	
	var CartDeliveryAddressModel = EntitiesBase.ModelBase.extend({
	  constructor: function constructor(attrs, options) {
	    EntitiesBase.ModelBase.prototype.constructor.call(this, attrs, options);
	  },
	  validation: {},
	  validationFields: function validationFields() {
	    var fields = ['local_delivery_street_address'];
	    return fields;
	  },
	  defaults: {
	    local_delivery_street_address: null,
	    local_delivery_apartment_number: null,
	    local_delivery_city: null,
	    local_delivery_postal_code: null,
	    local_delivery_street_address_geocoded_response: null,
	    local_delivery_street_address_geocoded_lat: null,
	    local_delivery_street_address_geocoded_lon: null,
	    local_delivery_street_address_geocoded_state: null,
	    local_delivery_street_address_geocoded_postal_code: null,
	    local_delivery_street_address_geocoded_country: null,
	    local_delivery_street_address_geocoded_city: null,
	    local_delivery_street_address_geocoded_street_name: null,
	    local_delivery_street_address_geocoded_street_address: null,
	    local_delivery_street_address_geocoded_apartment: null,
	    local_delivery_street_address_verified: false,
	    local_delivery_postal_code_verified: null,
	    local_delivery_confirmed_farm_location_slug: null,
	    local_delivery_method: null
	  }
	});
	
	_.extend(CartDeliveryAddressModel.prototype, Backbone.Validation.mixin);
	_.extend(CartDeliveryAddressModel.prototype.validation, cartDeliveryAddressValidationMixin);
	
	var DeliveryModel = EntitiesBase.ModelBase.extend({
	  constructor: function constructor(attrs, options) {
	    EntitiesBase.ModelBase.prototype.constructor.call(this, attrs, options);
	  },
	  defaults: {
	    deliveryMethod: 'pickup',
	    deliveryTime: null,
	    deliveryTimeReadable: null,
	    deliveryWindowMinutes: 120,
	    deliveryTimeStartUnix: null,
	    deliveryTimeEndUnix: null,
	    deliveryDate: null,
	    deliveryPossibleDays: null,
	    deliveryPossibleTimes: null,
	    deliveryPossibleTimesLastUpdated: null,
	    deliveryAddressModel: null,
	    deliveryNotes: null,
	    deliveryTipPercentage: null,
	    deliveryPhone: null
	  }
	});
	
	var TipCollection = new Backbone.Collection([{
	  label: '0%',
	  value: 0
	}, {
	  label: '5%',
	  value: 0.05
	}, {
	  label: '10%',
	  value: 0.10
	}, {
	  label: '15%',
	  value: 0.15
	}]);
	
	module.exports = {
	  Cart: function Cart() {
	    var cart_collection;
	    if (lsCache.get(LS_CACHE_CART_ID)) {
	      cart_collection = new CartCollection(lsCache.get(LS_CACHE_CART_ID));
	    } else {
	      cart_collection = new CartCollection();
	    }
	
	    cart_collection.on('add', function (model, collection, options) {
	      lsCache.set(LS_CACHE_CART_ID, collection.toJSON(), CACHE_TIMEOUT);
	    });
	
	    cart_collection.on('remove', function (model, collection, options) {
	      lsCache.set(LS_CACHE_CART_ID, collection.toJSON(), CACHE_TIMEOUT);
	    });
	    cart_collection.paymentModel = new PaymentModel();
	    cart_collection.paymentModel.set('paymentCreditCardModel', new PaymentCreditCardModel());
	    cart_collection.paymentModel.set('cartGiftModel', new CartGiftModel());
	
	    cart_collection.deliveryModel = new DeliveryModel();
	
	    var cartDeliveryAddressModel;
	
	    if (lsCache.get('cartDeliveryAddressModel')) {
	      cartDeliveryAddressModel = new CartDeliveryAddressModel(lsCache.get('cartDeliveryAddressModel'));
	    } else {
	      cartDeliveryAddressModel = new CartDeliveryAddressModel();
	    }
	
	    if (cartDeliveryAddressModel.get('local_delivery_method')) {
	      cart_collection.deliveryModel.set('deliveryMethod', cartDeliveryAddressModel.get('local_delivery_method'));
	    }
	
	    cart_collection.deliveryModel.set('cartDeliveryAddressModel', cartDeliveryAddressModel);
	
	    return cart_collection;
	  },
	  ClearCart: function ClearCart() {
	    // make cache expire here...
	    lsCache.flush();
	  },
	  TipCollection: TipCollection
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(1), __webpack_require__(8), __webpack_require__(4)))

/***/ },
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-locations-list {\n  background-color: #080808;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  left: 0px; }\n  .fmcy-locations-list .fmcy-locations-list-container {\n    padding-left: 10px;\n    padding-right: 10px; }\n    .fmcy-locations-list .fmcy-locations-list-container .fmcy-cart-location-display {\n      padding-bottom: 10px;\n      border-bottom: 1px #322a17 solid; }\n", ""]);
	
	// exports


/***/ },
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(244);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./locations-list.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./locations-list.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-locations-list-expanded-row">\n  <div class="fmcy-locations-list-container"></div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, Marionette, _) {__webpack_require__(276);
	var TabsModel = Backbone.Model.extend({
	    defaults: {
	        active: false
	    }
	});
	var TabsCollection = Backbone.Collection.extend({
	    model: TabsModel
	});
	
	var LabelBase = Marionette.ItemView.extend({
	    tagName: 'li',
	    modelEvents: {
	        'change:active': 'render'
	    },
	    onRender: function () {
	        this.$el.toggleClass('active', this.model.get('active'));
	    },
	    serializeData: function () {
	        return {
	            options: this.options,
	            model: this.model.toJSON()
	        };
	    }
	});
	
	var DropdownLabel = LabelBase.extend({
	    template: __webpack_require__(282),
	    className: 'tl-tabs-dropdown-label',
	    triggers: function () {
	        return {
	            'click': {
	                event: 'clicked',
	                stopPropagation: false,
	                preventDefault: true
	            }
	        };
	    }
	});
	
	var TabsDropdown = Marionette.CompositeView.extend({
	    template: __webpack_require__(283),
	    childView: DropdownLabel,
	    childViewContainer: '.tl-dropdown-menu-container',
	    tagName: 'li',
	    className: 'tl-tabs-dropdown dropdown',
	    childEvents: {
	        'clicked': function (tabView) {
	            this.trigger('dropdown:item:clicked', tabView.model);
	        }
	    },
	    modelEvents: {
	        'change:active': 'render'
	    },
	    _getBsDropdownToggle: function () {
	        return jQuery(this.$el.find('.dropdown-toggle'));
	    },
	    onRender: function () {
	        var self = this;
	        self.$el.attr('role', 'presentation');
	        self.$el.toggleClass('active', self.model.get('active'));
	        var $dropdownToggle = self._getBsDropdownToggle();
	        $dropdownToggle.dropdown();
	        if (self.model.get('open')) {
	            $dropdownToggle.dropdown('toggle');
	        }
	        jQuery(self.$el).on('show.bs.dropdown	', function () {
	            self.model.set('open', true);
	        });
	        jQuery(self.$el).on('shown.bs.dropdown', function () {
	            self.model.set('open', true);
	        });
	        jQuery(self.$el).on('hide.bs.dropdown', function () {
	            self.model.set('open', false);
	        });
	        jQuery(self.$el).on('hidden.bs.dropdown', function () {
	            self.model.set('open', false);
	        });
	    },
	    serializeData: function () {
	        return {
	            options: this.options,
	            model: this.model.toJSON()
	        };
	    }
	});
	
	var TabsLabel = LabelBase.extend({
	    template: __webpack_require__(284),
	    className: 'tl-tabs-label',
	    triggers: function () {
	        return {
	            'click': {
	                event: 'tab:clicked',
	                stopPropagation: false,
	                preventDefault: true
	            }
	        };
	    },
	    onRender: function () {
	        this.$el.attr('role', 'presentation');
	        this.$el.toggleClass('active', this.model.get('active'));
	    }
	});
	
	var TabsLabels = Marionette.CollectionView.extend({
	    childViewOptions: function (model, index) {
	        return {
	            collection: model.get('dropdown')
	        };
	    },
	    childEvents: {
	        'tab:clicked': function (tabsLabel) {
	            this.trigger('tab:clicked', tabsLabel.model);
	        },
	        'dropdown:item:clicked': function (tabsLabel, model) {
	            this.trigger('tab:clicked', model);
	        }
	    },
	    getChildView: function (model) {
	        if (model.get('dropdown')) {
	            return TabsDropdown;
	        } else {
	            return TabsLabel;
	        }
	    },
	    tagName: 'ul',
	    className: function () {
	        var classNames = ['tl-tabs-labels', 'nav'];
	        switch (this.options.style) {
	            case 'tabs':
	                classNames.push('nav-tabs');
	                break;
	            case 'pills':
	                classNames.push('nav-pills');
	                break;
	            default:
	        }
	        return classNames.join(' ');
	    }
	});
	
	var Tabs = Marionette.LayoutView.extend({
	    template: __webpack_require__(285),
	    className: 'tl-tabs',
	    regions: {
	        tabsLabelsRegion: '.tl-tabs-labels-region'
	    },
	    initialize: function (options) {
	        var self = this;
	        this.options = _.defaults(
	            options || {}, {
	                style: 'pills' // pills | tabs
	            }
	        );
	
	        if (!this.options.tabs) {
	            throw new Error('tabs not supplied in options');
	        }
	
	        this.collection = new TabsCollection(this.options.tabs);
	        this.collection.each(function (tabModel) {
	            if (tabModel.get('dropdown')) {
	                tabModel.set('dropdown', new TabsCollection(tabModel.get('dropdown')));
	            }
	        });
	    },
	    setActiveTabById: function (tabId) {
	        var targetTab = this.collection.get(tabId);
	        if (targetTab) {
	            targetTab.set('active', true);
	            this.setActiveTabByModel(targetTab);
	        }
	    },
	    setActiveTabByModel: function (targetTab) {
	        targetTab.collection.each(function (tabModel) {
	            tabModel.set('active', tabModel === targetTab);
	            if (tabModel.has('dropdown')) {
	                tabModel.get('dropdown').each(function (dropdownTabModel) {
	                    dropdownTabModel.set('active', dropdownTabModel === targetTab);
	                });
	            }
	        });
	    },
	    onRender: function () {
	        var self = this;
	        var tabsLabels = new TabsLabels({
	            collection: self.collection,
	            style: self.options.style
	        });
	        tabsLabels.on('tab:clicked', function (model) {
	            self.trigger('tab:clicked', model);
	            self.trigger('tab:clicked:' + model.id);
	            self.setActiveTabByModel(model);
	        });
	        self.tabsLabelsRegion.show(tabsLabels);
	    }
	});
	module.exports = Tabs;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16), __webpack_require__(6), __webpack_require__(7)))

/***/ },
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	__webpack_require__(209);
	__webpack_require__(273);
	var Button = __webpack_require__(70);
	var SpinnerButton = __webpack_require__(19);
	var BaseViews = __webpack_require__(5);
	
	var DeliveryPostalCodeFormInput = BaseViews.LayoutView.extend({
	    className: 'fmcy-delivery-postal-code-input',
	    template: __webpack_require__(280),
	    ui: {
	        postalCodeInput: '#fmcy-delivery-postal-code-input-field',
	        alertMessage: '.fmcy-delivery-postal-code-input-alert-message',
	        alertMessageText: '.alert-danger',
	        buttonVerify: '.verify-click-here'
	    },
	    initialize: function initialize(options) {
	        var self = this;
	        self.options = _.defaults(options || {}, {
	            _appChannel: null,
	            error: false,
	            errorMessage: '',
	            defaultErrorMessage: 'Please verify your postal code.'
	        });
	    },
	    regions: {
	        verifyButtonRegion: '.fmcy-verify-button-region'
	    },
	    validateVisitedFieldsOnly: false,
	    modelEvents: function modelEvents() {
	        var self = this;
	        return _.extend({}, _.result(BaseViews.LayoutView.prototype, 'modelEvents'), {
	            validated: self.maybeDisplayValidationAlert.bind(self)
	        });
	    },
	    validatedFields: function validatedFields() {
	        var validatedFields = ['local_delivery_postal_code'];
	        return validatedFields;
	    },
	    setAlertMessage: function setAlertMessage(msg) {
	        this.ui.alertMessageText.html(msg);
	    },
	    toggleValidationAlert: function toggleValidationAlert(show) {
	        if (show) {
	            this.ui.alertMessage.removeClass('hidden');
	        } else {
	            this.ui.alertMessage.addClass('hidden');
	        }
	        this.trigger('toggle:validation:alert', show);
	    },
	    maybeDisplayValidationAlert: function maybeDisplayValidationAlert() {
	        if (this.$el.find('.has-error').length) {
	            this.toggleValidationAlert(true);
	        } else {
	            this.toggleValidationAlert(false);
	        }
	    },
	    onModelAttributeValid: function onModelAttributeValid(attr, selector) {
	        if (BaseViews.LayoutView.prototype.onModelAttributeValid.call(this, attr, selector)) {
	            this.maybeDisplayValidationAlert();
	        }
	    },
	    onModelAttributeInvalid: function onModelAttributeInvalid(attr, error, selector, hideAlertMessage) {
	        if (BaseViews.LayoutView.prototype.onModelAttributeInvalid.call(this, attr, error, selector)) {
	            this.setAlertMessage(this.options.defaultErrorMessage);
	            if (!hideAlertMessage) {
	                this.maybeDisplayValidationAlert();
	            }
	        }
	    },
	    bindings: function bindings() {
	        var options = {
	            events: ['blur'],
	            setOptions: {
	                validate: false
	            }
	        };
	
	        var bindings = {
	            '[name=local_delivery_postal_code]': _.extend({}, options, { observe: 'local_delivery_postal_code' })
	        };
	
	        return bindings;
	    },
	    events: function events() {
	        var self = this;
	
	        function setVisited(ev) {
	            self._setElementAsVisited($(ev.target));
	        }
	        return {
	            'blur input': setVisited,
	            'click select': setVisited,
	            keydown: 'keyAction'
	        };
	    },
	    keyAction: function keyAction(event) {
	        var code = event.keyCode || event.which;
	
	        // enter key
	        if (code == 13) {
	            this._onVerifyPostalCode(null);
	        }
	    },
	    _onVerifyPostalCode: function _onVerifyPostalCode(event) {
	        var isValid = this.model.isValid(['local_delivery_postal_code']);
	        if (isValid) {
	            this.trigger('validate:postal:code', this.model.get('local_delivery_postal_code'));
	        } else {
	            this.resetVerifyButton();
	        }
	    },
	    _renderVerifyButton: function _renderVerifyButton() {
	        var self = this;
	        this.verifyButton = new SpinnerButton.SpinnerButton({
	            label: 'VERIFY',
	            multiClick: false,
	            classNames: 'fmcy-verify-btn',
	            theme: SpinnerButton.THEMES.PRIMARY,
	            size: SpinnerButton.SIZES.LARGE,
	            onClickedCallback: function onClickedCallback() {
	                self.verifyButton.toggleSpinner(true);
	                self.verifyButton.toggledEnabledState(false);
	                self._onVerifyPostalCode(null);
	            }
	        });
	        this.verifyButtonRegion.show(this.verifyButton);
	    },
	    resetVerifyButton: function resetVerifyButton() {
	        this.verifyButton.toggleSpinner(false);
	        this.verifyButton.toggledEnabledState(true);
	    },
	    onRender: function onRender() {
	        this.ui.postalCodeInput.mask("S#S #S#");
	        this._renderVerifyButton();
	
	        if (this.options.error) {
	            if (this.options.errorMessage) {
	                this.setAlertMessage(this.options.errorMessage);
	            } else {
	                this.setAlertMessage(this.options.defaultErrorMessage);
	            }
	            this.toggleValidationAlert(true);
	        }
	
	        BaseViews.LayoutView.prototype.onRender.call(this);
	    },
	    serializeData: function serializeData() {
	        return {
	            defaultErrorMessage: this.options.defaultErrorMessage
	        };
	    }
	});
	module.exports = DeliveryPostalCodeFormInput;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette, _, Backbone) {'use strict';
	
	var Button = __webpack_require__(70);
	var FeaturePopupDefaultView = Marionette.LayoutView.extend({
	  template: __webpack_require__(281),
	  className: 'container-fluid',
	  regions: {
	    moreInfoBtnRegion: '.feature-popup-content-more-info-btn'
	  },
	  initialize: function initialize(options) {
	    this.options = _.defaults(options || {}, {
	      title: 'Point title',
	      description: 'Lorem ipsum, blah blah blah',
	      featureImageUrl: undefined,
	      moreInfoUrl: undefined,
	      type: 'default', // maybe, will make this video, sound, etc. Or pass in a view not sure.
	      childView: undefined
	    });
	    this.model = this.options.model || new Backbone.Model();
	  },
	  serializeData: function serializeData() {
	    return {
	      title: this.options.title,
	      description: this.options.description,
	      featureImageUrl: this.options.featureImageUrl,
	      moreInfoUrl: this.options.moreInfoUrl
	    };
	  },
	  onRender: function onRender() {
	    var self = this;
	    if (this.options.moreInfoUrl) {
	      this._moreInfoBtn = new Button.Button({
	        label: 'More Info',
	        classNames: 'tl-more-info-btn',
	        enabled: true,
	        theme: Button.THEMES.DEFAULT,
	        size: Button.SIZES.SMALL,
	        onClickedCallback: function onClickedCallback() {
	          window.open(self.options.moreInfoUrl, '_blank');
	        }
	      });
	      this.moreInfoBtnRegion.show(this._moreInfoBtn);
	    }
	  }
	});
	
	module.exports = FeaturePopupDefaultView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15), __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-delivery-postal-code-input {\n  padding: 0px 10px; }\n  .fmcy-delivery-postal-code-input .fmcy-delivery-postal-code-input-header {\n    color: #fff;\n    font-size: 90%;\n    font-weight: 700;\n    padding: 10px 0px;\n    font-family: 'droid_serif' !important; }\n  .fmcy-delivery-postal-code-input .fmcy-delivery-postal-code-input-field {\n    font-size: 90%;\n    color: #fff;\n    padding-bottom: 5px;\n    margin-bottom: 0px;\n    font-family: 'droid_serif' !important;\n    font-weight: 700; }\n  .fmcy-delivery-postal-code-input .fmcy-delivery-postal-code-input-field-label {\n    font-size: 90%;\n    color: #fff;\n    padding-bottom: 5px;\n    margin-bottom: 0px;\n    font-family: 'droid_serif' !important;\n    font-weight: 700; }\n  .fmcy-delivery-postal-code-input .fmcy-delivery-postal-code-input-alert-message {\n    margin-left: 0px !important;\n    margin-right: 0px !important; }\n    .fmcy-delivery-postal-code-input .fmcy-delivery-postal-code-input-alert-message .alert-danger {\n      text-align: left;\n      color: #a94442;\n      background-color: #f2dede;\n      font-size: 100%;\n      font-weight: 700;\n      padding: 10px 10px;\n      border: 1px solid transparent;\n      border-radius: 4px;\n      font-family: 'droid_serif' !important; }\n  .fmcy-delivery-postal-code-input .verify-click-here-wrapper {\n    color: #ccc;\n    font-size: 10px;\n    line-height: 20px;\n    font-family: 'droid_serif' !important;\n    padding-bottom: 10px; }\n    @media only screen and (min-width: 768px) {\n      .fmcy-delivery-postal-code-input .verify-click-here-wrapper {\n        margin-top: 27px; } }\n    .fmcy-delivery-postal-code-input .verify-click-here-wrapper .fmcy-verify-btn {\n      width: 100%;\n      color: #ffffff;\n      border-color: #666 !important;\n      letter-spacing: 1px;\n      background-color: #666 !important;\n      position: relative;\n      border: 2px solid;\n      font-family: \"bebasneue\", \"Arial\", sans-serif;\n      font-size: 160%;\n      line-height: 0.75em;\n      border-radius: 5px;\n      padding-left: 10px;\n      padding-right: 10px;\n      cursor: pointer;\n      text-align: center; }\n", ""]);
	
	// exports


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Bootstrap Grid Flexbox v1.1.2 (https://github.com/ngengs/bootstrap-grid-flexbox)\n * Copyright 2016 Rizky Kharisma @ngengs (http://ngengs.com).\n * Licensed under MIT (https://github.com/ngengs/bootstrap-grid-flexbox/blob/master/LICENSE)\n */\n.row-flex {\n  box-sizing: border-box;\n  display: flex;\n  flex: 0 1 auto;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin-left: -15px;\n  margin-right: -15px; }\n  .row-flex.reverse {\n    flex-direction: row-reverse; }\n\n.col-flex-xs-1, .col-flex-sm-1, .col-flex-md-1, .col-flex-lg-1, .col-flex-xl-1, .col-flex-xs-2, .col-flex-sm-2, .col-flex-md-2, .col-flex-lg-2, .col-flex-xl-2, .col-flex-xs-3, .col-flex-sm-3, .col-flex-md-3, .col-flex-lg-3, .col-flex-xl-3, .col-flex-xs-4, .col-flex-sm-4, .col-flex-md-4, .col-flex-lg-4, .col-flex-xl-4, .col-flex-xs-5, .col-flex-sm-5, .col-flex-md-5, .col-flex-lg-5, .col-flex-xl-5, .col-flex-xs-6, .col-flex-sm-6, .col-flex-md-6, .col-flex-lg-6, .col-flex-xl-6, .col-flex-xs-7, .col-flex-sm-7, .col-flex-md-7, .col-flex-lg-7, .col-flex-xl-7, .col-flex-xs-8, .col-flex-sm-8, .col-flex-md-8, .col-flex-lg-8, .col-flex-xl-8, .col-flex-xs-9, .col-flex-sm-9, .col-flex-md-9, .col-flex-lg-9, .col-flex-xl-9, .col-flex-xs-10, .col-flex-sm-10, .col-flex-md-10, .col-flex-lg-10, .col-flex-xl-10, .col-flex-xs-11, .col-flex-sm-11, .col-flex-md-11, .col-flex-lg-11, .col-flex-xl-11, .col-flex-xs-12, .col-flex-sm-12, .col-flex-md-12, .col-flex-lg-12, .col-flex-xl-12 {\n  box-sizing: border-box;\n  flex: 0 0 auto;\n  min-height: 1px;\n  padding-left: 15px;\n  padding-right: 15px;\n  width: 100%;\n  flex-basis: 100%;\n  max-width: 100%; }\n\n.start-xs {\n  justify-content: flex-start; }\n  .start-xs.text-start {\n    text-align: start; }\n\n.center-xs {\n  justify-content: center; }\n  .center-xs.text-center {\n    text-align: center; }\n\n.end-xs {\n  justify-content: flex-end; }\n  .end-xs.text-end {\n    text-align: end; }\n\n.top-xs {\n  align-items: flex-start; }\n\n.middle-xs {\n  align-items: center; }\n\n.bottom-xs {\n  align-items: flex-end; }\n\n.col-flex-xs-1 {\n  width: 8.33333%;\n  flex-basis: 8.33333%;\n  max-width: 8.33333%; }\n\n.col-flex-xs-2 {\n  width: 16.66667%;\n  flex-basis: 16.66667%;\n  max-width: 16.66667%; }\n\n.col-flex-xs-3 {\n  width: 25%;\n  flex-basis: 25%;\n  max-width: 25%; }\n\n.col-flex-xs-4 {\n  width: 33.33333%;\n  flex-basis: 33.33333%;\n  max-width: 33.33333%; }\n\n.col-flex-xs-5 {\n  width: 41.66667%;\n  flex-basis: 41.66667%;\n  max-width: 41.66667%; }\n\n.col-flex-xs-6 {\n  width: 50%;\n  flex-basis: 50%;\n  max-width: 50%; }\n\n.col-flex-xs-7 {\n  width: 58.33333%;\n  flex-basis: 58.33333%;\n  max-width: 58.33333%; }\n\n.col-flex-xs-8 {\n  width: 66.66667%;\n  flex-basis: 66.66667%;\n  max-width: 66.66667%; }\n\n.col-flex-xs-9 {\n  width: 75%;\n  flex-basis: 75%;\n  max-width: 75%; }\n\n.col-flex-xs-10 {\n  width: 83.33333%;\n  flex-basis: 83.33333%;\n  max-width: 83.33333%; }\n\n.col-flex-xs-11 {\n  width: 91.66667%;\n  flex-basis: 91.66667%;\n  max-width: 91.66667%; }\n\n.col-flex-xs-12 {\n  width: 100%;\n  flex-basis: 100%;\n  max-width: 100%; }\n\n.col-flex-xs-pull-0 {\n  right: auto; }\n\n.col-flex-xs-pull-1 {\n  right: 8.33333%; }\n\n.col-flex-xs-pull-2 {\n  right: 16.66667%; }\n\n.col-flex-xs-pull-3 {\n  right: 25%; }\n\n.col-flex-xs-pull-4 {\n  right: 33.33333%; }\n\n.col-flex-xs-pull-5 {\n  right: 41.66667%; }\n\n.col-flex-xs-pull-6 {\n  right: 50%; }\n\n.col-flex-xs-pull-7 {\n  right: 58.33333%; }\n\n.col-flex-xs-pull-8 {\n  right: 66.66667%; }\n\n.col-flex-xs-pull-9 {\n  right: 75%; }\n\n.col-flex-xs-pull-10 {\n  right: 83.33333%; }\n\n.col-flex-xs-pull-11 {\n  right: 91.66667%; }\n\n.col-flex-xs-pull-12 {\n  right: 100%; }\n\n.col-flex-xs-push-0 {\n  left: auto; }\n\n.col-flex-xs-push-1 {\n  left: 8.33333%; }\n\n.col-flex-xs-push-2 {\n  left: 16.66667%; }\n\n.col-flex-xs-push-3 {\n  left: 25%; }\n\n.col-flex-xs-push-4 {\n  left: 33.33333%; }\n\n.col-flex-xs-push-5 {\n  left: 41.66667%; }\n\n.col-flex-xs-push-6 {\n  left: 50%; }\n\n.col-flex-xs-push-7 {\n  left: 58.33333%; }\n\n.col-flex-xs-push-8 {\n  left: 66.66667%; }\n\n.col-flex-xs-push-9 {\n  left: 75%; }\n\n.col-flex-xs-push-10 {\n  left: 83.33333%; }\n\n.col-flex-xs-push-11 {\n  left: 91.66667%; }\n\n.col-flex-xs-push-12 {\n  left: 100%; }\n\n.col-flex-xs-offset-0 {\n  margin-left: 0%; }\n\n.col-flex-xs-offset-1 {\n  margin-left: 8.33333%; }\n\n.col-flex-xs-offset-2 {\n  margin-left: 16.66667%; }\n\n.col-flex-xs-offset-3 {\n  margin-left: 25%; }\n\n.col-flex-xs-offset-4 {\n  margin-left: 33.33333%; }\n\n.col-flex-xs-offset-5 {\n  margin-left: 41.66667%; }\n\n.col-flex-xs-offset-6 {\n  margin-left: 50%; }\n\n.col-flex-xs-offset-7 {\n  margin-left: 58.33333%; }\n\n.col-flex-xs-offset-8 {\n  margin-left: 66.66667%; }\n\n.col-flex-xs-offset-9 {\n  margin-left: 75%; }\n\n.col-flex-xs-offset-10 {\n  margin-left: 83.33333%; }\n\n.col-flex-xs-offset-11 {\n  margin-left: 91.66667%; }\n\n.col-flex-xs-offset-12 {\n  margin-left: 100%; }\n\n@media (min-width: 768px) {\n  .start-sm {\n    justify-content: flex-start; }\n    .start-sm.text-start {\n      text-align: start; }\n  .center-sm {\n    justify-content: center; }\n    .center-sm.text-center {\n      text-align: center; }\n  .end-sm {\n    justify-content: flex-end; }\n    .end-sm.text-end {\n      text-align: end; }\n  .top-sm {\n    align-items: flex-start; }\n  .middle-sm {\n    align-items: center; }\n  .bottom-sm {\n    align-items: flex-end; }\n  .col-flex-sm-1 {\n    width: 8.33333%;\n    flex-basis: 8.33333%;\n    max-width: 8.33333%; }\n  .col-flex-sm-2 {\n    width: 16.66667%;\n    flex-basis: 16.66667%;\n    max-width: 16.66667%; }\n  .col-flex-sm-3 {\n    width: 25%;\n    flex-basis: 25%;\n    max-width: 25%; }\n  .col-flex-sm-4 {\n    width: 33.33333%;\n    flex-basis: 33.33333%;\n    max-width: 33.33333%; }\n  .col-flex-sm-5 {\n    width: 41.66667%;\n    flex-basis: 41.66667%;\n    max-width: 41.66667%; }\n  .col-flex-sm-6 {\n    width: 50%;\n    flex-basis: 50%;\n    max-width: 50%; }\n  .col-flex-sm-7 {\n    width: 58.33333%;\n    flex-basis: 58.33333%;\n    max-width: 58.33333%; }\n  .col-flex-sm-8 {\n    width: 66.66667%;\n    flex-basis: 66.66667%;\n    max-width: 66.66667%; }\n  .col-flex-sm-9 {\n    width: 75%;\n    flex-basis: 75%;\n    max-width: 75%; }\n  .col-flex-sm-10 {\n    width: 83.33333%;\n    flex-basis: 83.33333%;\n    max-width: 83.33333%; }\n  .col-flex-sm-11 {\n    width: 91.66667%;\n    flex-basis: 91.66667%;\n    max-width: 91.66667%; }\n  .col-flex-sm-12 {\n    width: 100%;\n    flex-basis: 100%;\n    max-width: 100%; }\n  .col-flex-sm-pull-0 {\n    right: auto; }\n  .col-flex-sm-pull-1 {\n    right: 8.33333%; }\n  .col-flex-sm-pull-2 {\n    right: 16.66667%; }\n  .col-flex-sm-pull-3 {\n    right: 25%; }\n  .col-flex-sm-pull-4 {\n    right: 33.33333%; }\n  .col-flex-sm-pull-5 {\n    right: 41.66667%; }\n  .col-flex-sm-pull-6 {\n    right: 50%; }\n  .col-flex-sm-pull-7 {\n    right: 58.33333%; }\n  .col-flex-sm-pull-8 {\n    right: 66.66667%; }\n  .col-flex-sm-pull-9 {\n    right: 75%; }\n  .col-flex-sm-pull-10 {\n    right: 83.33333%; }\n  .col-flex-sm-pull-11 {\n    right: 91.66667%; }\n  .col-flex-sm-pull-12 {\n    right: 100%; }\n  .col-flex-sm-push-0 {\n    left: auto; }\n  .col-flex-sm-push-1 {\n    left: 8.33333%; }\n  .col-flex-sm-push-2 {\n    left: 16.66667%; }\n  .col-flex-sm-push-3 {\n    left: 25%; }\n  .col-flex-sm-push-4 {\n    left: 33.33333%; }\n  .col-flex-sm-push-5 {\n    left: 41.66667%; }\n  .col-flex-sm-push-6 {\n    left: 50%; }\n  .col-flex-sm-push-7 {\n    left: 58.33333%; }\n  .col-flex-sm-push-8 {\n    left: 66.66667%; }\n  .col-flex-sm-push-9 {\n    left: 75%; }\n  .col-flex-sm-push-10 {\n    left: 83.33333%; }\n  .col-flex-sm-push-11 {\n    left: 91.66667%; }\n  .col-flex-sm-push-12 {\n    left: 100%; }\n  .col-flex-sm-offset-0 {\n    margin-left: 0%; }\n  .col-flex-sm-offset-1 {\n    margin-left: 8.33333%; }\n  .col-flex-sm-offset-2 {\n    margin-left: 16.66667%; }\n  .col-flex-sm-offset-3 {\n    margin-left: 25%; }\n  .col-flex-sm-offset-4 {\n    margin-left: 33.33333%; }\n  .col-flex-sm-offset-5 {\n    margin-left: 41.66667%; }\n  .col-flex-sm-offset-6 {\n    margin-left: 50%; }\n  .col-flex-sm-offset-7 {\n    margin-left: 58.33333%; }\n  .col-flex-sm-offset-8 {\n    margin-left: 66.66667%; }\n  .col-flex-sm-offset-9 {\n    margin-left: 75%; }\n  .col-flex-sm-offset-10 {\n    margin-left: 83.33333%; }\n  .col-flex-sm-offset-11 {\n    margin-left: 91.66667%; }\n  .col-flex-sm-offset-12 {\n    margin-left: 100%; } }\n\n@media (min-width: 992px) {\n  .start-md {\n    justify-content: flex-start; }\n    .start-md.text-start {\n      text-align: start; }\n  .center-md {\n    justify-content: center; }\n    .center-md.text-center {\n      text-align: center; }\n  .end-md {\n    justify-content: flex-end; }\n    .end-md.text-end {\n      text-align: end; }\n  .top-md {\n    align-items: flex-start; }\n  .middle-md {\n    align-items: center; }\n  .bottom-md {\n    align-items: flex-end; }\n  .col-flex-md-1 {\n    width: 8.33333%;\n    flex-basis: 8.33333%;\n    max-width: 8.33333%; }\n  .col-flex-md-2 {\n    width: 16.66667%;\n    flex-basis: 16.66667%;\n    max-width: 16.66667%; }\n  .col-flex-md-3 {\n    width: 25%;\n    flex-basis: 25%;\n    max-width: 25%; }\n  .col-flex-md-4 {\n    width: 33.33333%;\n    flex-basis: 33.33333%;\n    max-width: 33.33333%; }\n  .col-flex-md-5 {\n    width: 41.66667%;\n    flex-basis: 41.66667%;\n    max-width: 41.66667%; }\n  .col-flex-md-6 {\n    width: 50%;\n    flex-basis: 50%;\n    max-width: 50%; }\n  .col-flex-md-7 {\n    width: 58.33333%;\n    flex-basis: 58.33333%;\n    max-width: 58.33333%; }\n  .col-flex-md-8 {\n    width: 66.66667%;\n    flex-basis: 66.66667%;\n    max-width: 66.66667%; }\n  .col-flex-md-9 {\n    width: 75%;\n    flex-basis: 75%;\n    max-width: 75%; }\n  .col-flex-md-10 {\n    width: 83.33333%;\n    flex-basis: 83.33333%;\n    max-width: 83.33333%; }\n  .col-flex-md-11 {\n    width: 91.66667%;\n    flex-basis: 91.66667%;\n    max-width: 91.66667%; }\n  .col-flex-md-12 {\n    width: 100%;\n    flex-basis: 100%;\n    max-width: 100%; }\n  .col-flex-md-pull-0 {\n    right: auto; }\n  .col-flex-md-pull-1 {\n    right: 8.33333%; }\n  .col-flex-md-pull-2 {\n    right: 16.66667%; }\n  .col-flex-md-pull-3 {\n    right: 25%; }\n  .col-flex-md-pull-4 {\n    right: 33.33333%; }\n  .col-flex-md-pull-5 {\n    right: 41.66667%; }\n  .col-flex-md-pull-6 {\n    right: 50%; }\n  .col-flex-md-pull-7 {\n    right: 58.33333%; }\n  .col-flex-md-pull-8 {\n    right: 66.66667%; }\n  .col-flex-md-pull-9 {\n    right: 75%; }\n  .col-flex-md-pull-10 {\n    right: 83.33333%; }\n  .col-flex-md-pull-11 {\n    right: 91.66667%; }\n  .col-flex-md-pull-12 {\n    right: 100%; }\n  .col-flex-md-push-0 {\n    left: auto; }\n  .col-flex-md-push-1 {\n    left: 8.33333%; }\n  .col-flex-md-push-2 {\n    left: 16.66667%; }\n  .col-flex-md-push-3 {\n    left: 25%; }\n  .col-flex-md-push-4 {\n    left: 33.33333%; }\n  .col-flex-md-push-5 {\n    left: 41.66667%; }\n  .col-flex-md-push-6 {\n    left: 50%; }\n  .col-flex-md-push-7 {\n    left: 58.33333%; }\n  .col-flex-md-push-8 {\n    left: 66.66667%; }\n  .col-flex-md-push-9 {\n    left: 75%; }\n  .col-flex-md-push-10 {\n    left: 83.33333%; }\n  .col-flex-md-push-11 {\n    left: 91.66667%; }\n  .col-flex-md-push-12 {\n    left: 100%; }\n  .col-flex-md-offset-0 {\n    margin-left: 0%; }\n  .col-flex-md-offset-1 {\n    margin-left: 8.33333%; }\n  .col-flex-md-offset-2 {\n    margin-left: 16.66667%; }\n  .col-flex-md-offset-3 {\n    margin-left: 25%; }\n  .col-flex-md-offset-4 {\n    margin-left: 33.33333%; }\n  .col-flex-md-offset-5 {\n    margin-left: 41.66667%; }\n  .col-flex-md-offset-6 {\n    margin-left: 50%; }\n  .col-flex-md-offset-7 {\n    margin-left: 58.33333%; }\n  .col-flex-md-offset-8 {\n    margin-left: 66.66667%; }\n  .col-flex-md-offset-9 {\n    margin-left: 75%; }\n  .col-flex-md-offset-10 {\n    margin-left: 83.33333%; }\n  .col-flex-md-offset-11 {\n    margin-left: 91.66667%; }\n  .col-flex-md-offset-12 {\n    margin-left: 100%; } }\n\n@media (min-width: 1200px) {\n  .start-lg {\n    justify-content: flex-start; }\n    .start-lg.text-start {\n      text-align: start; }\n  .center-lg {\n    justify-content: center; }\n    .center-lg.text-center {\n      text-align: center; }\n  .end-lg {\n    justify-content: flex-end; }\n    .end-lg.text-end {\n      text-align: end; }\n  .top-lg {\n    align-items: flex-start; }\n  .middle-lg {\n    align-items: center; }\n  .bottom-lg {\n    align-items: flex-end; }\n  .col-flex-lg-1 {\n    width: 8.33333%;\n    flex-basis: 8.33333%;\n    max-width: 8.33333%; }\n  .col-flex-lg-2 {\n    width: 16.66667%;\n    flex-basis: 16.66667%;\n    max-width: 16.66667%; }\n  .col-flex-lg-3 {\n    width: 25%;\n    flex-basis: 25%;\n    max-width: 25%; }\n  .col-flex-lg-4 {\n    width: 33.33333%;\n    flex-basis: 33.33333%;\n    max-width: 33.33333%; }\n  .col-flex-lg-5 {\n    width: 41.66667%;\n    flex-basis: 41.66667%;\n    max-width: 41.66667%; }\n  .col-flex-lg-6 {\n    width: 50%;\n    flex-basis: 50%;\n    max-width: 50%; }\n  .col-flex-lg-7 {\n    width: 58.33333%;\n    flex-basis: 58.33333%;\n    max-width: 58.33333%; }\n  .col-flex-lg-8 {\n    width: 66.66667%;\n    flex-basis: 66.66667%;\n    max-width: 66.66667%; }\n  .col-flex-lg-9 {\n    width: 75%;\n    flex-basis: 75%;\n    max-width: 75%; }\n  .col-flex-lg-10 {\n    width: 83.33333%;\n    flex-basis: 83.33333%;\n    max-width: 83.33333%; }\n  .col-flex-lg-11 {\n    width: 91.66667%;\n    flex-basis: 91.66667%;\n    max-width: 91.66667%; }\n  .col-flex-lg-12 {\n    width: 100%;\n    flex-basis: 100%;\n    max-width: 100%; }\n  .col-flex-lg-pull-0 {\n    right: auto; }\n  .col-flex-lg-pull-1 {\n    right: 8.33333%; }\n  .col-flex-lg-pull-2 {\n    right: 16.66667%; }\n  .col-flex-lg-pull-3 {\n    right: 25%; }\n  .col-flex-lg-pull-4 {\n    right: 33.33333%; }\n  .col-flex-lg-pull-5 {\n    right: 41.66667%; }\n  .col-flex-lg-pull-6 {\n    right: 50%; }\n  .col-flex-lg-pull-7 {\n    right: 58.33333%; }\n  .col-flex-lg-pull-8 {\n    right: 66.66667%; }\n  .col-flex-lg-pull-9 {\n    right: 75%; }\n  .col-flex-lg-pull-10 {\n    right: 83.33333%; }\n  .col-flex-lg-pull-11 {\n    right: 91.66667%; }\n  .col-flex-lg-pull-12 {\n    right: 100%; }\n  .col-flex-lg-push-0 {\n    left: auto; }\n  .col-flex-lg-push-1 {\n    left: 8.33333%; }\n  .col-flex-lg-push-2 {\n    left: 16.66667%; }\n  .col-flex-lg-push-3 {\n    left: 25%; }\n  .col-flex-lg-push-4 {\n    left: 33.33333%; }\n  .col-flex-lg-push-5 {\n    left: 41.66667%; }\n  .col-flex-lg-push-6 {\n    left: 50%; }\n  .col-flex-lg-push-7 {\n    left: 58.33333%; }\n  .col-flex-lg-push-8 {\n    left: 66.66667%; }\n  .col-flex-lg-push-9 {\n    left: 75%; }\n  .col-flex-lg-push-10 {\n    left: 83.33333%; }\n  .col-flex-lg-push-11 {\n    left: 91.66667%; }\n  .col-flex-lg-push-12 {\n    left: 100%; }\n  .col-flex-lg-offset-0 {\n    margin-left: 0%; }\n  .col-flex-lg-offset-1 {\n    margin-left: 8.33333%; }\n  .col-flex-lg-offset-2 {\n    margin-left: 16.66667%; }\n  .col-flex-lg-offset-3 {\n    margin-left: 25%; }\n  .col-flex-lg-offset-4 {\n    margin-left: 33.33333%; }\n  .col-flex-lg-offset-5 {\n    margin-left: 41.66667%; }\n  .col-flex-lg-offset-6 {\n    margin-left: 50%; }\n  .col-flex-lg-offset-7 {\n    margin-left: 58.33333%; }\n  .col-flex-lg-offset-8 {\n    margin-left: 66.66667%; }\n  .col-flex-lg-offset-9 {\n    margin-left: 75%; }\n  .col-flex-lg-offset-10 {\n    margin-left: 83.33333%; }\n  .col-flex-lg-offset-11 {\n    margin-left: 91.66667%; }\n  .col-flex-lg-offset-12 {\n    margin-left: 100%; } }\n\n@media (min-width: 1600px) {\n  .start-xl {\n    justify-content: flex-start; }\n    .start-xl.text-start {\n      text-align: start; }\n  .center-xl {\n    justify-content: center; }\n    .center-xl.text-center {\n      text-align: center; }\n  .end-xl {\n    justify-content: flex-end; }\n    .end-xl.text-end {\n      text-align: end; }\n  .top-xl {\n    align-items: flex-start; }\n  .middle-xl {\n    align-items: center; }\n  .bottom-xl {\n    align-items: flex-end; }\n  .col-flex-xl-1 {\n    width: 8.33333%;\n    flex-basis: 8.33333%;\n    max-width: 8.33333%; }\n  .col-flex-xl-2 {\n    width: 16.66667%;\n    flex-basis: 16.66667%;\n    max-width: 16.66667%; }\n  .col-flex-xl-3 {\n    width: 25%;\n    flex-basis: 25%;\n    max-width: 25%; }\n  .col-flex-xl-4 {\n    width: 33.33333%;\n    flex-basis: 33.33333%;\n    max-width: 33.33333%; }\n  .col-flex-xl-5 {\n    width: 41.66667%;\n    flex-basis: 41.66667%;\n    max-width: 41.66667%; }\n  .col-flex-xl-6 {\n    width: 50%;\n    flex-basis: 50%;\n    max-width: 50%; }\n  .col-flex-xl-7 {\n    width: 58.33333%;\n    flex-basis: 58.33333%;\n    max-width: 58.33333%; }\n  .col-flex-xl-8 {\n    width: 66.66667%;\n    flex-basis: 66.66667%;\n    max-width: 66.66667%; }\n  .col-flex-xl-9 {\n    width: 75%;\n    flex-basis: 75%;\n    max-width: 75%; }\n  .col-flex-xl-10 {\n    width: 83.33333%;\n    flex-basis: 83.33333%;\n    max-width: 83.33333%; }\n  .col-flex-xl-11 {\n    width: 91.66667%;\n    flex-basis: 91.66667%;\n    max-width: 91.66667%; }\n  .col-flex-xl-12 {\n    width: 100%;\n    flex-basis: 100%;\n    max-width: 100%; }\n  .col-flex-xl-pull-0 {\n    right: auto; }\n  .col-flex-xl-pull-1 {\n    right: 8.33333%; }\n  .col-flex-xl-pull-2 {\n    right: 16.66667%; }\n  .col-flex-xl-pull-3 {\n    right: 25%; }\n  .col-flex-xl-pull-4 {\n    right: 33.33333%; }\n  .col-flex-xl-pull-5 {\n    right: 41.66667%; }\n  .col-flex-xl-pull-6 {\n    right: 50%; }\n  .col-flex-xl-pull-7 {\n    right: 58.33333%; }\n  .col-flex-xl-pull-8 {\n    right: 66.66667%; }\n  .col-flex-xl-pull-9 {\n    right: 75%; }\n  .col-flex-xl-pull-10 {\n    right: 83.33333%; }\n  .col-flex-xl-pull-11 {\n    right: 91.66667%; }\n  .col-flex-xl-pull-12 {\n    right: 100%; }\n  .col-flex-xl-push-0 {\n    left: auto; }\n  .col-flex-xl-push-1 {\n    left: 8.33333%; }\n  .col-flex-xl-push-2 {\n    left: 16.66667%; }\n  .col-flex-xl-push-3 {\n    left: 25%; }\n  .col-flex-xl-push-4 {\n    left: 33.33333%; }\n  .col-flex-xl-push-5 {\n    left: 41.66667%; }\n  .col-flex-xl-push-6 {\n    left: 50%; }\n  .col-flex-xl-push-7 {\n    left: 58.33333%; }\n  .col-flex-xl-push-8 {\n    left: 66.66667%; }\n  .col-flex-xl-push-9 {\n    left: 75%; }\n  .col-flex-xl-push-10 {\n    left: 83.33333%; }\n  .col-flex-xl-push-11 {\n    left: 91.66667%; }\n  .col-flex-xl-push-12 {\n    left: 100%; }\n  .col-flex-xl-offset-0 {\n    margin-left: 0%; }\n  .col-flex-xl-offset-1 {\n    margin-left: 8.33333%; }\n  .col-flex-xl-offset-2 {\n    margin-left: 16.66667%; }\n  .col-flex-xl-offset-3 {\n    margin-left: 25%; }\n  .col-flex-xl-offset-4 {\n    margin-left: 33.33333%; }\n  .col-flex-xl-offset-5 {\n    margin-left: 41.66667%; }\n  .col-flex-xl-offset-6 {\n    margin-left: 50%; }\n  .col-flex-xl-offset-7 {\n    margin-left: 58.33333%; }\n  .col-flex-xl-offset-8 {\n    margin-left: 66.66667%; }\n  .col-flex-xl-offset-9 {\n    margin-left: 75%; }\n  .col-flex-xl-offset-10 {\n    margin-left: 83.33333%; }\n  .col-flex-xl-offset-11 {\n    margin-left: 91.66667%; }\n  .col-flex-xl-offset-12 {\n    margin-left: 100%; } }\n", ""]);
	
	// exports


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ },
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(265);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./delivery-postal-code-input.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./delivery-postal-code-input.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(266);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./bootstrap-grid-flexbox.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./bootstrap-grid-flexbox.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 275 */,
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(267);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./tabs.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./tabs.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-delivery-postal-code-input-wrapper container-fluid">\n    <div class="row">\n        <div class="col-xs-12">\n          <div class="fmcy-delivery-postal-code-input-header">Enter your postal code below to determine if we can deliver to your address.</div>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-xs-12 col-sm-9">\n          <fieldset class="form-group has-feedback">\n              <label for="fmcy-delivery-postal-code-input-field" class="fmcy-delivery-postal-code-input-field-label">Postal Code *</label>\n              <div class="input-group">\n                <div class="input-group-addon">\n                  <i class="glyphicon glyphicon-search"></i>\n                </div>\n                <input type="text" class="form-control" name="local_delivery_postal_code" id="fmcy-delivery-postal-code-input-field" placeholder=""\n                />\n                <i class="glyphicon glyphicon-remove-sign form-control-feedback hidden"></i>\n              </div>\n              <span class="help-block hidden"></span>\n          </fieldset>\n        </div>\n        <div class="col-xs-12 col-sm-3">\n          <div class="fmcy-verify-button-region verify-click-here-wrapper"></div>\n        </div>\n    </div>\n    <div class="row fmcy-delivery-postal-code-input-alert-message hidden">\n        <div class="col-xs-12 alert alert-danger" role="alert">'+
	((__t=(defaultErrorMessage))==null?'':__t)+
	'</div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 281 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="row no-gutters">\n    ';
	 if (featureImageUrl !== "") { 
	__p+='\n      ';
	 if (description !== "") { 
	__p+='\n      <div class="col-xs-12">\n        <img class="img-responsive" src="'+
	((__t=( featureImageUrl ))==null?'':__t)+
	'">\n      </div>\n      <div class="col-xs-12 feature-popup-content-text-padding">\n      ';
	 } else { 
	__p+='\n      <div class="col-xs-12">\n        <img class="img-responsive" src="'+
	((__t=( featureImageUrl ))==null?'':__t)+
	'">\n      </div>\n      <div class="col-xs-12">\n      ';
	 } 
	__p+='\n    ';
	 } else { 
	__p+='\n    <div class="col-xs-12">\n    ';
	 } 
	__p+='\n    <div class="container-fluid">\n      <div class="row">\n        <div class="col-xs-12">\n          '+
	((__t=( title ))==null?'':__t)+
	'\n        </div>\n        <div class="col-xs-12">\n          '+
	((__t=( description ))==null?'':__t)+
	'\n        </div>\n        <div class="col-xs-12">\n          <div class="feature-popup-content-more-info-btn"></div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 282 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<a href="#">\n    '+
	((__t=( model.labelText ))==null?'':__t)+
	'\n</a>\n';
	}
	return __p;
	};


/***/ },
/* 283 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<a class="dropdown-toggle" href="#" role="button" aria-haspopup="true" aria-expanded="false" data-toggle="dropdown">\n    '+
	((__t=( model.labelText ))==null?'':__t)+
	'\n    <span class="caret"></span>\n</a>\n<ul class="tl-dropdown-menu-container dropdown-menu"></ul>';
	}
	return __p;
	};


/***/ },
/* 284 */
282,
/* 285 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="tl-tabs-labels-region"></div>';
	}
	return __p;
	};


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	var CartLocationDisplay = __webpack_require__(91);
	__webpack_require__(323);
	var DeliveryPostalCodeFormInput = __webpack_require__(259);
	
	var DeliveryPostalCodeFormSuccessState = BaseViews.LayoutView.extend({
	  className: 'fmcy-delivery-postal-code-form-success-state',
	  template: __webpack_require__(332),
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      postalCode: 'V0N 2M2'
	    });
	  },
	  serializeData: function serializeData() {
	    return {
	      postalCode: this.options.postalCode
	    };
	  }
	});
	
	var DeliveryPostalCodeForm = BaseViews.LayoutView.extend({
	  className: 'fmcy-delivery-postal-code-form',
	  template: __webpack_require__(333),
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      _appChannel: null,
	      error: false,
	      errorMessage: 'Please verify postal code.',
	      changeToLocationModel: null,
	      model: null,
	      referrer: 'entry'
	    });
	    if (this.options.model) {
	      this.deliveryModel = this.options.model;
	    } else {
	      this.deliveryModel = this.options._appChannel.request('cart:get:delivery:model');
	    }
	  },
	  regions: {
	    postalCodeFormRegion: '.fmcy-postal-code-form-region',
	    deliverySuccessStateRegion: '.fmcy-delivery-success-state-region'
	  },
	  _hideSuccessMessage: function _hideSuccessMessage() {
	    this.deliverySuccessStateRegion.empty();
	  },
	  _renderSuccessMessage: function _renderSuccessMessage(postalCode) {
	    var deliveryPostalCodeFormSuccessState = new DeliveryPostalCodeFormSuccessState({
	      postalCode: postalCode
	    });
	    this.deliverySuccessStateRegion.show(deliveryPostalCodeFormSuccessState);
	    this.trigger('show:continue:button');
	  },
	  _renderDeliveryPostalCodeFormInput: function _renderDeliveryPostalCodeFormInput(_options) {
	    var self = this;
	    var options = _.defaults(_options || {}, {
	      deliveryMethod: 'local_delivery',
	      error: self.options.error,
	      changeToLocationModel: self.options.changeToLocationModel,
	      errorMessage: self.options.errorMessage
	    });
	
	    this.deliveryPostalCodeFormInput = new DeliveryPostalCodeFormInput({
	      _appChannel: this.options._appChannel,
	      model: this.deliveryModel.get('cartDeliveryAddressModel'),
	      error: options.error,
	      changeToLocationModel: options.changeToLocationModel,
	      errorMessage: options.errorMessage,
	      source: 'embedded'
	    });
	
	    this.deliveryPostalCodeFormInput.on('toggle:validation:alert', function (show) {
	      if (show == true) {
	        self._hideSuccessMessage();
	      }
	    });
	
	    this.deliveryPostalCodeFormInput.on('validate:postal:code', function (postalCode) {
	      self.options._appChannel.request('validate:postal:code:delivery:area', postalCode).then(function (result) {
	        if (result.error == true) {
	          self.deliveryPostalCodeFormInput.setAlertMessage('Sorry we cannot deliver to that postal code.');
	          self.deliveryPostalCodeFormInput.toggleValidationAlert(true);
	          self.trigger('hide:continue:button');
	          self._hideSuccessMessage();
	          if (self.deliveryPostalCodeFormInput) {
	            self.deliveryPostalCodeFormInput.resetVerifyButton();
	          }
	        } else {
	          if (self.deliveryPostalCodeFormInput) {
	            self.deliveryPostalCodeFormInput.resetVerifyButton();
	          }
	          // display success state...
	          self._renderSuccessMessage(postalCode);
	          if (result.response && result.response.withinDeliveryAreaSlug) {
	            self.options._appChannel.trigger('location:selected', result.response.withinDeliveryAreaSlug, self.options.referrer);
	          }
	        }
	      });
	    }); // end on validate:postal:code
	
	    this.postalCodeFormRegion.show(this.deliveryPostalCodeFormInput);
	  },
	  _maybeRenderDeliveryPostalCodeFormSuccessState: function _maybeRenderDeliveryPostalCodeFormSuccessState() {
	    var currentSelectedLocationSlug = this.options._appChannel.request('get:filter:location:details').get('slug');
	
	    if (currentSelectedLocationSlug == this.deliveryModel.get('cartDeliveryAddressModel').get('local_delivery_confirmed_farm_location_slug') && this.deliveryModel.get('cartDeliveryAddressModel').get('local_delivery_postal_code_verified') != null && this.deliveryModel.get('cartDeliveryAddressModel').get('local_delivery_postal_code_verified') == this.deliveryModel.get('cartDeliveryAddressModel').get('local_delivery_postal_code')) {
	      this._renderSuccessMessage(this.deliveryModel.get('cartDeliveryAddressModel').get('local_delivery_postal_code'));
	    }
	  },
	
	  onRender: function onRender() {
	    var self = this;
	
	    this._renderDeliveryPostalCodeFormInput();
	    this._maybeRenderDeliveryPostalCodeFormSuccessState();
	
	    BaseViews.LayoutView.prototype.onRender.call(self);
	  }
	});
	
	module.exports = DeliveryPostalCodeForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, Backbone, _) {'use strict';
	
	var EntitiesBase = __webpack_require__(17);
	var Obscura = __webpack_require__(103);
	var validationUtils = __webpack_require__(29);
	
	var ordersCommonMixin = {
	  cancel_order: function cancel_order(model) {
	    var self = this;
	    var $deferred = $.Deferred();
	    var errors = [];
	    Backbone.Radio.channel('global').request('ajax', 'farmacyajaxv2-ordercancel', {
	      order_id: model.get('order_id'),
	      order_unique_id: model.get('order_unique_id'),
	      order_customer_id: model.get('order_customer_id')
	    }).success(function (response) {
	      $deferred.resolve(response);
	    }).fail(function (error) {
	      $deferred.reject(error);
	    });
	    return $deferred.promise();
	  },
	  get_ready_count: function get_ready_count() {
	    var orders_ready = new Obscura(this);
	    orders_ready.filterBy('userLocation', function (model) {
	      if (model.get('order_status') == 'ready') {
	        return true;
	      } else {
	        return false;
	      }
	    });
	    return orders_ready.length;
	  },
	  update_status: function update_status(order_id, order_status, order_payment_status) {
	    var model = this.findWhere({ 'order_id': order_id });
	    model.set('order_status', order_status);
	
	    if (order_payment_status) {
	      model.set('order_payment_status', order_payment_status);
	    }
	
	    return model;
	  },
	  check_exists: function check_exists(order_id) {
	    var model = this.findWhere({ 'order_id': order_id });
	    if (model) {
	      return true;
	    } else {
	      return false;
	    }
	  },
	  remove_by_order_id: function remove_by_order_id(order_id) {
	    var model = this.findWhere({ 'order_id': order_id });
	    this.remove(model);
	  },
	  get_active_order_channels: function get_active_order_channels() {
	    var channels = [];
	    var active_orders = new Obscura(this);
	    active_orders.filterBy('userLocation', function (model) {
	      if (model.get('order_status') == 'pre_payment' || model.get('order_status') == 'created' || model.get('order_status') == 'processing' || model.get('order_status') == 'ready') {
	        return true;
	      } else {
	        return false;
	      }
	    });
	    active_orders.each(function (model) {
	      channels.push('orders.' + model.get('order_unique_id'));
	    });
	    return channels;
	  }
	};
	
	var OrderModel = EntitiesBase.ModelBase.extend({});
	
	var OrdersCollection = EntitiesBase.CollectionBase.extend({
	  model: OrderModel
	});
	
	_.extend(OrdersCollection.prototype, ordersCommonMixin);
	
	var FavouriteProductsModel = EntitiesBase.ModelBase.extend({});
	
	var FavouriteProductsCollection = EntitiesBase.CollectionBase.extend({
	  model: FavouriteProductsModel
	});
	
	var _CustomerModel = EntitiesBase.ModelBase.extend({
	  constructor: function constructor(attrs, options) {
	    EntitiesBase.ModelBase.prototype.constructor.call(this, attrs, options);
	  },
	  defaults: {
	    first_name: null,
	    last_name: null,
	    display_name: null,
	    email: null,
	    phone: null,
	    user_id: null,
	    favourite_products: new FavouriteProductsCollection()
	
	  },
	  nestedEntities: {
	    orders: OrdersCollection,
	    favourite_products: FavouriteProductsCollection
	  },
	  idAttribute: 'user_id'
	});
	
	var customerJoinClubValidationMixin = {
	  phone: {
	    required: true,
	    fn: function fn(value, attr, computedState) {
	      if (value == '') {
	        return validationUtils.getIsRequiredMessageForFieldName('Phone');
	      } else if (value.length < 14) {
	        // 14 seems odd but it's including the space, ( and - in the mask input...
	        return 'Must be a valid phone number';
	      }
	    }
	  },
	  first_name: {
	    required: true,
	    msg: validationUtils.getIsRequiredMessageForFieldName('first_name')
	  },
	  last_name: {
	    required: true,
	    msg: validationUtils.getIsRequiredMessageForFieldName('last_name')
	  }
	};
	
	var _CustomerJoinClubModel = _CustomerModel.extend({
	  validation: {},
	  unsavedChangesIgnoredAttributes: ['orders'],
	  methodToActionMap: {
	    create: 'farmacyajaxv2-createorupdateclubinfo',
	    update: 'farmacyajaxv2-createorupdateclubinfo',
	    patch: 'farmacyajaxv2-createorupdateclubinfo'
	  }
	});
	_.extend(_CustomerJoinClubModel.prototype, Backbone.Validation.mixin);
	_.extend(_CustomerJoinClubModel.prototype.validation, customerJoinClubValidationMixin);
	
	var emailChangeValidationMixin = {
	  new_requested_email: {
	    required: true,
	    pattern: 'email',
	    msg: "Email is required"
	  }
	};
	
	var _CustomerEmailChangeModel = EntitiesBase.ModelBase.extend({
	  defaults: {
	    new_requested_email: null
	  },
	  constructor: function constructor(attrs, options) {
	    EntitiesBase.ModelBase.prototype.constructor.call(this, attrs, options);
	  },
	  validation: {}
	});
	_.extend(_CustomerEmailChangeModel.prototype, Backbone.Validation.mixin);
	_.extend(_CustomerEmailChangeModel.prototype.validation, emailChangeValidationMixin);
	
	var passwordChangeValidationMixin = {
	  current_password: {
	    required: true,
	    msg: "Password is required"
	  },
	  new_requested_password: {
	    fn: function fn(value, attr, computedState) {
	      if (value == null || value == '') {
	        return 'New password is required.';
	      } else if (value.length < 6) {
	        return 'Password must be at least 6 characters long.';
	      }
	    }
	  },
	  new_requested_password_match: {
	    fn: function fn(value, attr, computedState) {
	      var message = 'Passwords must match';
	      if (value == null || value == '') {
	        return message;
	      } else if (computedState.new_requested_password !== value) {
	        return message;
	      }
	    }
	  }
	};
	
	var _CustomerPasswordChangeModel = EntitiesBase.ModelBase.extend({
	  defaults: {
	    current_password: null,
	    new_requested_password: null,
	    new_requested_password_match: null
	  },
	  constructor: function constructor(attrs, options) {
	    EntitiesBase.ModelBase.prototype.constructor.call(this, attrs, options);
	  },
	  validation: {}
	});
	_.extend(_CustomerPasswordChangeModel.prototype, Backbone.Validation.mixin);
	_.extend(_CustomerPasswordChangeModel.prototype.validation, passwordChangeValidationMixin);
	
	var nameChangeValidationMixin = {
	  first_name: {
	    required: true,
	    pattern: '[a-zA-Z_]',
	    rangeLength: [1, 25],
	    msg: "First name is required"
	  },
	  last_name: {
	    required: true,
	    pattern: '[a-zA-Z_]',
	    rangeLength: [1, 25],
	    msg: "Last name is required"
	  }
	};
	
	var _CustomerNameChangeModel = EntitiesBase.ModelBase.extend({
	  defaults: {
	    first_name: null,
	    last_name: null
	  },
	  constructor: function constructor(attrs, options) {
	    EntitiesBase.ModelBase.prototype.constructor.call(this, attrs, options);
	  },
	  validation: {}
	});
	_.extend(_CustomerNameChangeModel.prototype, Backbone.Validation.mixin);
	_.extend(_CustomerNameChangeModel.prototype.validation, nameChangeValidationMixin);
	
	module.exports = {
	  CustomerModel: function CustomerModel(data) {
	    data.orders = new OrdersCollection(data.orders);
	    data.favourite_products = new FavouriteProductsCollection(data.favourite_products);
	    return new _CustomerModel(data);
	  },
	  CustomerJoinClubModel: function CustomerJoinClubModel(data) {
	    return new _CustomerJoinClubModel(data);
	  },
	  CustomerEmailChangeModel: function CustomerEmailChangeModel(data) {
	    return new _CustomerEmailChangeModel(data);
	  },
	  CustomerPasswordChangeModel: function CustomerPasswordChangeModel(data) {
	    return new _CustomerPasswordChangeModel(data);
	  },
	  CustomerNameChangeModel: function CustomerNameChangeModel(data) {
	    return new _CustomerNameChangeModel(data);
	  },
	  OrderModel: OrderModel
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(4), __webpack_require__(1)))

/***/ },
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	__webpack_require__(417);
	
	var CartErrorMessage = BaseViews.LayoutView.extend({
	    className: 'fmcy-cart-error-message',
	    template: __webpack_require__(442),
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            theme: 'light',
	            message: 'Please review issues below'
	        });
	    },
	    serializeData: function serializeData() {
	        return {
	            message: this.options.message
	        };
	    },
	    onRender: function onRender() {
	        var self = this;
	        BaseViews.LayoutView.prototype.onRender.call(self);
	    },
	    onDestroy: function onDestroy() {
	        BaseViews.LayoutView.prototype.onDestroy.call(self);
	    }
	});
	
	module.exports = CartErrorMessage;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	__webpack_require__(322);
	var BaseViews = __webpack_require__(5);
	
	var CartItemCountIncrementor = BaseViews.LayoutView.extend({
	  className: 'fmcy-cart-item-count-incrementor container-fluid',
	  template: __webpack_require__(331),
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      theme: 'light'
	    });
	    this.model.on('change:cartCount', function () {
	      self._renderCount();
	    });
	  },
	  ui: {
	    count: '.fmcy-cart-item-count-incrementor-count',
	    countPlus: '.fmcy-cart-item-count-incrementor-plus',
	    countMinus: '.fmcy-cart-item-count-incrementor-minus'
	  },
	  triggers: {
	    'click @ui.countPlus': 'click:plus',
	    'click @ui.countMinus': 'click:minus'
	  },
	  _renderCount: function _renderCount() {
	    if (this.ui.count && typeof this.ui.count.html == 'function') {
	      this.ui.count.html(this.model.get('cartCount'));
	    }
	  },
	  onDestroy: function onDestroy() {
	    this.model.off('change:cartCount');
	  },
	  serializeData: function serializeData() {
	    return {
	      cartCount: this.model.get('cartCount')
	    };
	  }
	});
	
	module.exports = CartItemCountIncrementor;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	__webpack_require__(419);
	var BaseViews = __webpack_require__(5);
	
	var ShoppingCartIndicator = BaseViews.ItemView.extend({
	  _expandedMap: false,
	  template: __webpack_require__(444),
	  className: 'fmcy-shopping-cart-indicator',
	  ui: {
	    cartCount: '.fmcy-shopping-cart-indicator-count'
	  },
	  events: {
	    'click': 'onClick'
	  },
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      _appChannel: null,
	      _menuState: null,
	      cartCount: 0,
	      style: 'icon'
	    });
	  },
	  onClick: function onClick() {
	    this.options._appChannel.trigger('menu:overlay:view:close');
	    this.options._appChannel.trigger('cart:view');
	  },
	  _updateCartCount: function _updateCartCount(count) {
	    // TODO: figure out why I need to check for JQUERY...
	    if (this.ui.cartCount !== '.fmcy-shopping-cart-indicator-count') {
	      if (count === 0) {
	        this.ui.cartCount.hide();
	      } else {
	        this.ui.cartCount.show();
	      }
	      this.ui.cartCount.html(count);
	    }
	  },
	  onRender: function onRender() {
	    var self = this;
	    this._updateCartCount(this.options.cartCount);
	    this.listenTo(this.options._appChannel, 'cart:items:updated', function () {
	      if (self.rendered === true) {
	        self._updateCartCount(self.options._appChannel.request('cart:get:items:count'));
	      }
	    });
	    this.rendered = true;
	  },
	  serializeData: function serializeData() {
	    var locationModel = this.options._appChannel.request('get:filter:location:details');
	    return {
	      style: this.options.style,
	      locationName: locationModel.get('name')
	    };
	  }
	});
	module.exports = ShoppingCartIndicator;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette, _, Backbone) {'use strict';
	
	__webpack_require__(324);
	var Button = __webpack_require__(70);
	var DefaultView = __webpack_require__(260);
	var FeaturePopupContent = Marionette.LayoutView.extend({
	  template: __webpack_require__(334),
	  className: 'feature-popup-content container-fluid',
	  initialize: function initialize(options) {
	    this.options = _.defaults(options || {}, {
	      contentView: undefined,
	      mode: 'view' // view || edit
	    });
	    this.model = this.options.model || new Backbone.Model();
	  },
	  regions: {
	    contentRegion: '.content-region',
	    selectBtnRegion: '.select-btn-region'
	  },
	  _renderSelectButton: function _renderSelectButton() {
	    var self = this;
	    this._selectBtn = new Button.Button({
	      label: 'SELECT THIS LOCATION',
	      enabled: true,
	      classNames: 'fmcy-feature-popup-content-action-btn',
	      theme: Button.THEMES.DEFAULT,
	      onClickedCallback: function onClickedCallback() {
	        self.trigger('feature:selected');
	      }
	    });
	
	    this.selectBtnRegion.show(this._selectBtn);
	  },
	
	  onRender: function onRender() {
	    var self = this;
	    if (this.options.childView != undefined) {
	      this.contentView = this.options.childView;
	      this.contentRegion.show(this.contentView);
	    } else {
	      this.contentView = new DefaultView(this.options);
	      this.contentRegion.show(this.contentView);
	      if (this.options.temp_closed !== '1') {
	        this._renderSelectButton();
	      }
	    }
	  }
	});
	
	module.exports = FeaturePopupContent;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15), __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	var SubCategoryView = BaseViews.ItemView.extend({
	    template: __webpack_require__(335),
	    className: 'fmcy-sub-category-item',
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {});
	    },
	    events: {
	        'click': 'onClick'
	    },
	    onClick: function onClick() {
	        this.trigger('subcat:clicked');
	    },
	    serializeData: function serializeData() {
	        return {
	            category: this.model.toJSON()
	        };
	    },
	    onRender: function onRender() {
	        this.$el.css('padding-left', this.model.get('level') * 10 + 'px');
	    }
	});
	
	module.exports = SubCategoryView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var BaseViews = __webpack_require__(5);
	__webpack_require__(325);
	var SearchFiltersItem = BaseViews.ItemView.extend({
	    className: function className() {
	        if (this.options.totalItems == 4) {
	            return 'fmcy-search-filters-item col-xs-3 col-md-2  fmcy-category-menu-item';
	        } else {
	            return 'fmcy-search-filters-item col-xs-4 col-md-2  fmcy-category-menu-item';
	        }
	    },
	    template: __webpack_require__(336),
	    events: {
	        click: 'categoryClicked'
	    },
	    onRender: function onRender() {
	        if (this.options.style) {
	            this.$el.addClass(this.options.style);
	        }
	        if (this.options.childIndex > 5) {
	            this.$el.addClass('fmcy-top-spacer');
	        }
	    },
	    categoryClicked: function categoryClicked() {
	        this.trigger('filter:clicked');
	    },
	    setActive: function setActive() {
	        this.$el.addClass('active');
	    },
	    reset: function reset() {
	        this.$el.removeClass('active');
	    },
	    serializeData: function serializeData() {
	        var iconClass = 'fmcy-menu-category-item-icon-default';
	
	        return {
	            name: this.model.get('name'),
	            iconclass: iconClass
	        };
	    }
	});
	
	module.exports = SearchFiltersItem;

/***/ },
/* 302 */,
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette, _, Backbone, moment, $) {'use strict';
	
	var Radio = __webpack_require__(261);
	var PubNub = __webpack_require__(671);
	var expireCache = __webpack_require__(668);
	var DateUtils = __webpack_require__(10);
	var PubSub = Marionette.Object.extend({
	    _uuid: null,
	    _ONLINE_STATUS_CACHE_TIMEOUT_SECS: 10,
	    _pubnubInst: null,
	    _onlineStatusCache: null,
	    _pubnubTimeOffsetFromClient: null,
	    _fetchingPubnubTimeOffsetFromClientDeferred: null,
	    initialize: function initialize(options) {
	        var self = this;
	
	        this.options = _.defaults(options || {}, {
	            logVerbosity: false,
	            presenceTimeout: 30,
	            uuid: null
	        });
	
	        if (_.isEmpty(this.options.subscribeKey) || _.isEmpty(this.options.publishKey)) {
	            throw new Error('Pubnub configuration parameters not supplied');
	        }
	
	        this._onlineStatusCache = expireCache.namespace('online:status', this._ONLINE_STATUS_CACHE_TIMEOUT_SECS);
	
	        this._pubnubInst = new PubNub({
	            subscribeKey: this.options.subscribeKey,
	            publishKey: this.options.publishKey,
	            ssl: true,
	            restore: true,
	            logVerbosity: this.options.logVerbosity,
	            presenceTimeout: this.options.presenceTimeout,
	            uuid: this.options.uuid
	        });
	
	        // A call to _getPubnubTimeOffsetFromClient here has the effect of setting
	        // the pubnub time offset from client which we want as early as possible.
	        this._getPubnubTimeOffsetFromClient();
	
	        this._uuid = this._pubnubInst.getUUID();
	
	        console.log('pubsub established UUID: ', this._uuid);
	
	        var pubsubChannel = Backbone.Radio.channel('pubsub');
	
	        pubsubChannel.reply('getUUID', function (options) {
	            return self._uuid;
	        });
	
	        pubsubChannel.reply('getChannelUUIDs', function (channelName, options) {
	            return self.getChannelUUIDs(channelName, options);
	        });
	
	        pubsubChannel.reply('getOnlineChannelsForUUID', function (uuid) {
	            return self.getOnlineChannelsForUUID(uuid);
	        });
	
	        pubsubChannel.reply('getMomentUTCFromTimetoken', function (timetoken) {
	            return self.getMomentUTCFromTimetoken(timetoken);
	        });
	
	        pubsubChannel.reply('publish', function (channelName, message, options) {
	            return self.publish(channelName, message, options);
	        });
	
	        pubsubChannel.reply('subscribe', function (channelName, options) {
	            return self.subscribe(channelName, options);
	        });
	
	        pubsubChannel.reply('getPrivateChannnelName', function (channelName) {
	            return self.getPrivateChannnelName(channelName);
	        });
	
	        pubsubChannel.reply('isTokenStale', function (token, staleAfterSeconds) {
	            return self.isTokenStale(token, staleAfterSeconds);
	        });
	
	        pubsubChannel.reply('setState', function (state, channelName) {
	            return self._setState(state, channelName);
	        });
	    },
	    getMomentUTCFromTimetoken: function getMomentUTCFromTimetoken(timetoken) {
	        return moment.utc(timetoken / 1e4);
	    },
	    publish: function publish(channelName, message, options) {
	        var self = this;
	        var $deferred = $.Deferred();
	        options = _.defaults(options || {}, {
	            // Arbritrary data object to be passed with the message.
	            meta: {}
	        });
	        self._pubnubInst.publish({
	            message: message,
	            channel: channelName,
	            meta: options.meta
	        }, function (status, response) {
	            if (status.error) {
	                console.log(status);
	                $deferred.reject(status);
	            } else {
	                $deferred.resolve(response);
	            }
	        });
	        return $deferred.promise();
	    },
	    subscribe: function subscribe(channelName, options) {
	        var self = this;
	        if (!_.isArray(channelName)) {
	            channelName = [channelName];
	        }
	        options = _.defaults(options || {}, {
	            channelGroups: [],
	            withPresence: false
	        });
	
	        var notificationsHandler = {
	            message: function message(_message) {
	                if (channelName.indexOf(_message.channel) === -1) {
	                    // Not listening to channel, check for wildcard
	                    var wildcardChannelMatch = false;
	                    channelName.forEach(function (channel) {
	                        var channelArray = channel.split('.*');
	                        if (channelArray !== null && channelArray.length > 1) {
	                            var messageChannelArray = _message.channel.split('.');
	                            if (messageChannelArray !== null && messageChannelArray.length > 1) {
	                                if (channelArray[0] == messageChannelArray[0]) {
	                                    wildcardChannelMatch = true;
	                                }
	                            }
	                        }
	                    });
	                    if (wildcardChannelMatch !== true) {
	                        return;
	                    }
	                }
	                if (options.notificationsHandler && options.notificationsHandler.message) {
	                    options.notificationsHandler.message(_message);
	                }
	            },
	            presence: function presence(presenceEvent) {
	                if (options.notificationsHandler && options.notificationsHandler.presence) {
	                    options.notificationsHandler.presence(presenceEvent);
	                }
	            }
	        };
	
	        this._pubnubInst.addListener(notificationsHandler);
	        this._pubnubInst.subscribe({
	            channels: channelName,
	            channelGroups: options.channelGroups,
	            withPresence: options.withPresence
	        });
	        return function unsubscribeCallback() {
	            self._pubnubInst.removeListener(notificationsHandler);
	        };
	    },
	    getOnlineChannelsForUUID: function getOnlineChannelsForUUID(uuid) {
	        var $deferred = $.Deferred();
	        this._pubnubInst.whereNow({
	            uuid: uuid
	        }, function (status, response) {
	            if (status.error) {
	                $deferred.reject();
	            } else {
	                $deferred.resolve(response.channels);
	            }
	        });
	        return $deferred.promise();
	    },
	    getChannelUUIDs: function getChannelUUIDs(channelName, options) {
	        var $deferred = $.Deferred();
	        var self = this;
	        var cachedOnlineStatus = self._onlineStatusCache(channelName);
	
	        if (cachedOnlineStatus) {
	            $deferred.resolve(cachedOnlineStatus);
	            return $deferred.promise();
	        }
	
	        options = _.defaults(options || {}, {
	            includeUUIDs: true,
	            includeState: true
	        });
	
	        this._pubnubInst.hereNow({
	            channels: [channelName],
	            includeUUIDs: options.includeUUIDs,
	            includeState: options.includeState
	        }, function (status, response) {
	            if (status.error) {
	                $deferred.reject();
	            } else {
	                self._onlineStatusCache(channelName, response.channels[channelName]);
	                $deferred.resolve(self._onlineStatusCache(channelName));
	            }
	        });
	        return $deferred.promise();
	    },
	    getPrivateChannnelName: function getPrivateChannnelName(channelName) {
	        return channelName + ':' + this._uuid;
	    },
	    _getPubnubTime: function _getPubnubTime() {
	        var $deferred = $.Deferred();
	        this._pubnubInst.time(function (status, response) {
	            if (status.error) {
	                $deferred.reject();
	            } else {
	                $deferred.resolve(response.timetoken);
	            }
	        });
	        return $deferred.promise();
	    },
	    isTokenStale: function isTokenStale(token, staleAfterSeconds) {
	        var $deferred = $.Deferred();
	        var tokenMoment = this.getMomentUTCFromTimetoken(token);
	        var nowMoment = moment.utc();
	        this._getPubnubTimeOffsetFromClient().then(function (offsetMs) {
	            if (offsetMs < 0) {
	                nowMoment.add(offsetMs, 'ms');
	            } else {
	                nowMoment.subtract(offsetMs, 'ms');
	            }
	            $deferred.resolve(nowMoment.diff(tokenMoment, 'seconds') >= staleAfterSeconds);
	        });
	        return $deferred.promise();
	    },
	    _setState: function _setState(state, channelName) {
	        if (!_.isArray(channelName)) {
	            channelName = [channelName];
	        }
	        this._pubnubInst.setState({
	            channels: channelName,
	            uuid: this._uuid,
	            state: state
	        });
	    },
	    _getPubnubTimeOffsetFromClient: function _getPubnubTimeOffsetFromClient() {
	        var self = this;
	        if (self._fetchingPubnubTimeOffsetFromClientDeferred) {
	            return self._fetchingPubnubTimeOffsetFromClientDeferred;
	        }
	
	        self._fetchingPubnubTimeOffsetFromClientDeferred = $.Deferred();
	        var nowBeforeCallMoment = moment.utc();
	        self._getPubnubTime().then(function (timetoken) {
	            var nowAfterCallMoment = moment.utc();
	            var callLatency = nowAfterCallMoment.diff(nowBeforeCallMoment);
	            //console.log('Time call latency: ', callLatency);
	            var nowMoment = moment.utc().subtract(callLatency, 'ms');
	            var pubnubNowMoment = self.getMomentUTCFromTimetoken(timetoken);
	            self._pubnubTimeOffsetFromClient = nowMoment.diff(pubnubNowMoment);
	            //console.log('Client diff from pubnub: ', self._pubnubTimeOffsetFromClient);
	            self._fetchingPubnubTimeOffsetFromClientDeferred.resolve(self._pubnubTimeOffsetFromClient);
	        }).fail(function () {
	            self._fetchingPubnubTimeOffsetFromClientDeferred.reject();
	            self._fetchingPubnubTimeOffsetFromClientDeferred = null;
	        });
	        return self._fetchingPubnubTimeOffsetFromClientDeferred;
	    },
	    broadcastUserTypingStatus: function broadcastUserTypingStatus(channels) {
	        var self = this;
	        var typingTimeoutId = null;
	        $(document).keydown(_.debounce(function (e) {
	
	            self._setState({
	                typing: true
	            }, channels);
	
	            if (typingTimeoutId) {
	                window.clearTimeout(typingTimeoutId);
	                typingTimeoutId = null;
	            }
	
	            typingTimeoutId = window.setTimeout(function () {
	                self._setState({
	                    typing: false
	                }, channels);
	            }, 500);
	        }, 50, true));
	    },
	    onDestroy: function onDestroy() {
	        this._pubnubInst.stop();
	        this._pubnubInst.unsubscribeAll();
	    }
	});
	module.exports = PubSub;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15), __webpack_require__(1), __webpack_require__(4), __webpack_require__(8), __webpack_require__(11)))

/***/ },
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-cart-item-count-incrementor .fmcy-cart-item-count-incrementor-inner {\n  position: relative; }\n\n.fmcy-cart-item-count-incrementor .fmcy-cart-item-count-incrementor-plus {\n  display: inline-block;\n  cursor: pointer;\n  background-image: url(" + escape(__webpack_require__(317)) + ");\n  background-repeat: no-repeat;\n  background-position: top right;\n  background-size: cover;\n  width: 25px;\n  height: 25px;\n  opacity: 1;\n  margin-left: 13px; }\n\n.fmcy-cart-item-count-incrementor .fmcy-cart-item-count-incrementor-minus {\n  display: inline-block;\n  cursor: pointer;\n  background-image: url(" + escape(__webpack_require__(316)) + ");\n  background-repeat: no-repeat;\n  background-position: top right;\n  background-size: cover;\n  width: 25px;\n  height: 25px;\n  opacity: 1;\n  margin-right: 13px; }\n\n.fmcy-cart-item-count-incrementor .fmcy-cart-item-count-incrementor-count {\n  display: inline-block;\n  font-size: 200%;\n  padding-left: 10px;\n  padding-right: 10px;\n  position: absolute;\n  left: 18px;\n  top: 6px;\n  width: 40px;\n  text-align: center;\n  color: #fff; }\n", ""]);
	
	// exports


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-delivery-postal-code-form {\n  font-family: \"bebasneue\", \"Arial\", sans-serif; }\n  .fmcy-delivery-postal-code-form .fmcy-delivery-success-state-container {\n    margin: 25px;\n    padding-left: 0;\n    padding-right: 0; }\n    .fmcy-delivery-postal-code-form .fmcy-delivery-success-state-container .alert-success {\n      padding-bottom: 15px;\n      padding-top: 15px;\n      text-align: center;\n      font-size: 90%;\n      font-weight: 700;\n      border: 1px solid transparent;\n      border-radius: 4px;\n      font-family: 'droid_serif' !important; }\n  .fmcy-delivery-postal-code-form .fmcy-cart-location-display-inner {\n    color: #3c763d; }\n", ""]);
	
	// exports


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".leaflet-popup-content .container-fluid {\n  padding-left: 0px !important;\n  padding-right: 0px !important; }\n\n.leaflet-popup-content .feature-popup-content-text-padding {\n  padding-left: 10px !important; }\n\n.leaflet-popup-content h5 {\n  margin-top: 0px;\n  font-weight: bold; }\n\n.leaflet-popup-content .feature-popup-content-more-info-btn {\n  padding-top: 10px; }\n", ""]);
	
	// exports


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-search-filters-item {\n  font-size: 16px;\n  text-align: center;\n  cursor: pointer;\n  padding-left: 3px !important;\n  padding-right: 3px !important;\n  padding-bottom: 10px !important; }\n  .fmcy-search-filters-item.default.active .fmcy-category-menu-item-text {\n    border-top: 3px solid #00afb4;\n    border-bottom: 3px solid #00afb4;\n    color: #FFFFFF;\n    background-color: #00afb4; }\n  .fmcy-search-filters-item.default .fmcy-category-menu-item-text {\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 125%;\n    color: #e5e3e3;\n    font-weight: normal;\n    font-style: normal;\n    text-transform: none;\n    line-height: 1.4;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    speak: none;\n    border-style: solid;\n    border-top: 3px solid #e5e3e3;\n    border-bottom: 3px solid #e5e3e3;\n    min-width: 100%; }\n  .fmcy-search-filters-item.sub-filters.active .fmcy-category-menu-item-text {\n    color: #fff;\n    background-color: #00afb4; }\n  .fmcy-search-filters-item.sub-filters.active.indica .fmcy-category-menu-item-text {\n    background-color: #0080FF; }\n  .fmcy-search-filters-item.sub-filters.active.hybrid .fmcy-category-menu-item-text {\n    background-color: #808285; }\n  .fmcy-search-filters-item.sub-filters.active.sativa .fmcy-category-menu-item-text {\n    background-color: #93743F; }\n  .fmcy-search-filters-item.sub-filters .fmcy-category-menu-item-text {\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 100%;\n    padding: 6px;\n    color: #000000;\n    background-color: #fff;\n    font-weight: normal;\n    font-style: normal;\n    text-transform: none;\n    line-height: 1.4;\n    border-radius: 6px;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    speak: none;\n    min-width: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis; }\n\n@media only screen and (max-width: 768px) {\n  .fmcy-search-filters-item.sub-filters .fmcy-category-menu-item-text {\n    font-size: 80%; } }\n\n/* Small Devices, Tablets */\n/*\n@media only screen and (min-width: 768px) {\n    .fmcy-search-filters-item {\n      padding-left: 15px;\n      padding-right: 15px;\n      padding-bottom: 0px !important;\n      .fmcy-category-menu-item-text {\n        padding: 2px;\n      }\n        &.fmcy-top-spacer {\n            margin-top: 15px;\n        }\n    }\n}\n*/\n", ""]);
	
	// exports


/***/ },
/* 315 */,
/* 316 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/btn-minus-98429200ae8e6e9a956c0fcb0fa255bc.png";

/***/ },
/* 317 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/btn-plus-01ed27d7a0062a0928bb6611222ca2bb.png";

/***/ },
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(311);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-item-count-incrementor.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-item-count-incrementor.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(312);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./delivery-postal-code-form.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./delivery-postal-code-form.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(313);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./feature-popup-content.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./feature-popup-content.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(314);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./search-filters-item.scss", function() {
				var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js!../../../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./search-filters-item.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-cart-item-count-incrementor-inner">\n  <div class="fmcy-cart-item-count-incrementor-minus"></div>\n  <div class="fmcy-cart-item-count-incrementor-count">'+
	((__t=(cartCount))==null?'':__t)+
	'</div>\n  <div class="fmcy-cart-item-count-incrementor-plus"></div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 332 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-cart-delivery-postal-code-form-success-wrapper">\n    <div>\n        <div class="col-xs-12 alert-success">\n          <div class="fmcy-cart-delivery-postal-code-form-success-title">We can deliver to your postal code: '+
	((__t=(postalCode))==null?'':__t)+
	'</div>\n        </div>\n    </div>\n</div>';
	}
	return __p;
	};


/***/ },
/* 333 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-postal-code-form-region"></div>\n<div class="container-fluid fmcy-delivery-success-state-container">\n    <div class="row">\n        <div class="col-xs-12">\n        	<div class="fmcy-delivery-success-state-region"></div>\n        </div>\n    </div>\n</div>';
	}
	return __p;
	};


/***/ },
/* 334 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="row">\n  <div class="col-xs-12 content-region"></div>\n</div>\n<div class="row">\n  <div class="col-xs-12 select-btn-region"></div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 335 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+=''+
	((__t=( category.name ))==null?'':__t)+
	'\n';
	}
	return __p;
	};


/***/ },
/* 336 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-category-menu-item-text">'+
	((__t=(name))==null?'':__t)+
	'</div>';
	}
	return __p;
	};


/***/ },
/* 337 */,
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	__webpack_require__(420);
	__webpack_require__(219);
	__webpack_require__(427);
	__webpack_require__(428);
	__webpack_require__(346);
	var BaseViews = __webpack_require__(5);
	var FeaturePopupContent = __webpack_require__(299);
	var CartLocationDisplay = __webpack_require__(91);
	
	var LocationsMap = BaseViews.LayoutView.extend({
	  map: null,
	  template: __webpack_require__(445),
	  className: 'fmcy-locations-map',
	  ui: {
	    mapTarget: '.fmcy-locations-map-target',
	    closeMapButton: '.fmcy-locations-map-close-btn'
	  },
	  triggers: {
	    'click @ui.closeMapButton': 'close:clicked'
	  },
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      _appChannel: null,
	      allLocations: true,
	      adjustForMenuBar: true,
	      showCloseButton: true,
	      showZoomControls: true,
	      scrollWheelZoom: true,
	      animate: true,
	      topPos: null,
	      botPos: 0,
	      leftPos: 0
	    });
	  },
	  tweenOnPopUpOpen: true,
	  _initializeMap: function _initializeMap() {
	    var self = this;
	
	    this.map = L.map(this.ui.mapTarget[0], {
	      renderer: L.canvas(),
	      maxZoom: 18,
	      zoomControl: this.options.showZoomControls,
	      scrollWheelZoom: this.options.scrollWheelZoom
	    });
	
	    if (this.map) {
	      this.map._onResize();
	    }
	
	    this._onWindowResize();
	
	    this.map.createPane('basemap');
	
	    // set map to Victoria...
	    this.map.setView([48.4284, -123.3656], 10);
	    var basemap = L.tileLayer('https://api.mapbox.com/styles/v1/ogfarm/ckq9yvych0wi418mp23gspn8r/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1Ijoib2dmYXJtIiwiYSI6ImNrcTcyOW5jdjAwamsydXBnOHB1eTU0bG0ifQ.gJU9G9adyvvv8X4UBdUGhw').addTo(this.map);
	
	    this.map.dragging.enable();
	
	    if (this.map.tap) {
	      this.map.tap.enable();
	    }
	
	    this.map.touchZoom.enable();
	    this.map.doubleClickZoom.enable();
	
	    $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
	
	    this.map.on('popupopen', function (e) {
	      _.delay(function () {
	        var px = self.map.project(e.popup._latlng); // find the pixel location on the map where the popup anchor is
	        px.y -= e.popup._container.clientHeight / 2 - 90;
	        if (self.tweenOnPopUpOpen == true) {
	          self.map.panTo(self.map.unproject(px), { animate: true }); // pan to new center
	        }
	      }, 250);
	    });
	
	    this.map.on('zoomstart', function (e) {
	      self._removeFeaturePopup();
	    });
	  },
	  _displayFarmacyLocations: function _displayFarmacyLocations() {
	    var self = this;
	    this.markerClusterGroup = L.markerClusterGroup();
	
	    var farmacyMarkerIcon = L.divIcon({
	      className: 'map-marker-farmacy',
	      iconSize: [50, 50],
	      iconAnchor: [25, 50],
	      popupAnchor: [-3, -76]
	    });
	
	    this._locations = this.options._appChannel.request('get:locations');
	    this._locationsTurfPointsArray = [];
	    this._locations.each(function (model) {
	      var farmacyMarker = L.marker([model.get('lat'), model.get('lng')], { icon: farmacyMarkerIcon });
	      farmacyMarker.bindTooltip('<div class="map-marker-farmacy-tooltip"><div class="map-marker-farmacy-tooltip-title">' + model.get('name') + '</div><div class="map-marker-farmacy-tooltip-subtitle">' + model.get('line_1') + '</div></div>', { permanent: true, offset: [0, 0], direction: 'bottom' });
	      farmacyMarker.on('click', function () {
	        self._displayFeaturePopUp({
	          lat: model.get('lat'),
	          lon: model.get('lng'),
	          title: null,
	          description: null,
	          imageUrl: model.get('image_medium_url'),
	          model: model
	        });
	      });
	
	      self.markerClusterGroup.addLayer(farmacyMarker);
	
	      model.set('feature', farmacyMarker);
	      self._locationsTurfPointsArray.push(turf.point([model.get('lng'), model.get('lat')]));
	    });
	
	    this.map.addLayer(this.markerClusterGroup);
	    _.delay(function () {
	      self._zoomToFeatures(self._locationsTurfPointsArray);
	    }, 500);
	  },
	
	  _displayPickupLocation: function _displayPickupLocation() {
	    this._location = this.options._appChannel.request('get:filter:location:details');
	    var self = this;
	    this.markerClusterGroup = L.markerClusterGroup();
	
	    var farmacyMarkerIcon = L.divIcon({
	      className: 'map-marker-farmacy',
	      iconSize: [50, 50],
	      iconAnchor: [25, 50],
	      popupAnchor: [-3, -76]
	    });
	
	    this._locationsTurfPointsArray = [];
	
	    this.map.setView([this._location.get('lat'), this._location.get('lng')], 16);
	
	    var farmacyMarker = L.marker([this._location.get('lat'), this._location.get('lng')], { icon: farmacyMarkerIcon });
	
	    this.markerClusterGroup.addLayer(farmacyMarker);
	
	    this._location.set('feature', farmacyMarker);
	    this._locationsTurfPointsArray.push(turf.point([this._location.get('lng'), this._location.get('lat')]));
	
	    // offset...
	    var px = this.map.project([this._location.get('lat'), this._location.get('lng')]); // find the pixel location on the map where the popup anchor is
	    px.x += 150;
	    var popupOffsetLocation = this.map.unproject(px);
	    this._locationsTurfPointsArray.push(turf.point([popupOffsetLocation.lng, popupOffsetLocation.lat]));
	    // end offset
	
	    this.map.addLayer(this.markerClusterGroup);
	
	    var _cartLocationDisplay = new CartLocationDisplay({
	      _appChannel: this.options._appChannel,
	      alignment: 'vertical'
	    });
	
	    this._zoomToFeatures(self._locationsTurfPointsArray, function () {
	      self._displayFeaturePopUp({
	        lat: self._location.get('lat'),
	        lon: self._location.get('lng'),
	        title: null,
	        description: null,
	        contentView: _cartLocationDisplay,
	        model: self._location,
	        tweenToExtent: false
	      });
	    }, 0, 20);
	  },
	  displayDeliveryLocation: function displayDeliveryLocation(deliveryLocation) {
	    var self = this;
	    var userMarkerIcon = L.divIcon({
	      className: 'map-marker-farmacy-delivery-location',
	      iconSize: [50, 50],
	      iconAnchor: [25, 50],
	      popupAnchor: [-3, -76]
	    });
	    self._locationsTurfPointsArray = [];
	    if (self.deliverLocationMarker != undefined) {
	      this.map.removeLayer(self.deliverLocationMarker);
	    };
	    self.deliverLocationMarker = L.marker([deliveryLocation.latLng[0], deliveryLocation.latLng[1]], { icon: userMarkerIcon }).addTo(self.map);
	
	    var px = this.map.project([deliveryLocation.latLng[0], deliveryLocation.latLng[1]]); // find the pixel location on the map where the popup anchor is
	    px.x += 450;
	    var popupOffsetLocation = self.map.unproject(px);
	    self._locationsTurfPointsArray.push(turf.point([popupOffsetLocation.lng, popupOffsetLocation.lat]));
	
	    self._locationsTurfPointsArray.push(turf.point([deliveryLocation.latLng[1], deliveryLocation.latLng[0]]));
	
	    self._zoomToFeatures(self._locationsTurfPointsArray, function () {
	      // zoomed
	    }, 0, 20);
	  },
	  _findClosestLocationToUser: function _findClosestLocationToUser(lat, lon) {
	    var self = this;
	    var userfrom = turf.point([lon, lat]);
	    var closestDistance = 1000000;
	    this.closestLocationModel = null;
	
	    this._locations.each(function (model) {
	      var to = turf.point([model.get('lng'), model.get('lat')]);
	      var distance = turf.distance(userfrom, to);
	      if (distance < closestDistance) {
	        closestDistance = distance;
	        self.closestLocationModel = model;
	      }
	    });
	
	    this._locations.each(function (model) {
	      if (self.closestLocationModel !== model) {
	        self.map.removeLayer(model.get('feature'));
	      }
	    });
	
	    this.trigger('map:closest:point:user:detected', self.closestLocationModel, closestDistance);
	
	    var closestLocationTurfPoint = turf.point([self.closestLocationModel.get('lng'), self.closestLocationModel.get('lat')]);
	    var pointA = new L.LatLng(lat, lon);
	    var pointB = new L.LatLng(self.closestLocationModel.get('lat'), self.closestLocationModel.get('lng'));
	
	    this._zoomToFeatures([userfrom, closestLocationTurfPoint], function () {
	      var pointList = [pointA, pointB];
	
	      self.lineBetweenUserAndLocation = new L.Polyline(pointList, {
	        color: 'red',
	        weight: 3,
	        opacity: 0.5,
	        smoothFactor: 1,
	        dashArray: '1,7'
	      });
	
	      self.lineBetweenUserAndLocation.addTo(self.map);
	
	      _.delay(function () {
	        self._cleanupUserPointLocation();
	        self._zoomToFeatures([closestLocationTurfPoint], function () {
	          self._displayFeaturePopUp({
	            lat: self.closestLocationModel.get('lat'),
	            lon: self.closestLocationModel.get('lng'),
	            title: null,
	            description: null,
	            model: self.closestLocationModel
	          });
	        });
	      }, 3000);
	    });
	  },
	  _cleanupUserPointLocation: function _cleanupUserPointLocation() {
	    this.map.removeLayer(this.lineBetweenUserAndLocation);
	    this.map.removeLayer(this.userMarker);
	  },
	  _displayFeaturePopUp: function _displayFeaturePopUp(options) {
	    var options = _.defaults(options || {}, {
	      lat: 0,
	      lon: 0,
	      title: 'testing',
	      description: null,
	      model: options.model,
	      contentView: null,
	      imageUrl: null,
	      tweenToExtent: true
	    });
	
	    if (options.tweenToExtent && this.options.animate) {
	      this.tweenOnPopUpOpen = true;
	    } else {
	      this.tweenOnPopUpOpen = false;
	    }
	
	    var self = this;
	    var popupLocation = [];
	
	    popupLocation[0] = options.lat;
	    popupLocation[1] = options.lon;
	
	    var px = this.map.project([popupLocation[0], popupLocation[1]]); // find the pixel location on the map where the popup anchor is
	    px.y -= 50; // this should be based on icon size...
	    var popupOffsetLocation = this.map.unproject(px);
	    popupLocation[0] = popupOffsetLocation.lat;
	    popupLocation[1] = popupOffsetLocation.lng;
	
	    var view = new FeaturePopupContent({
	      title: options.title,
	      description: options.description,
	      childView: options.contentView,
	      featureImageUrl: options.imageUrl,
	      temp_closed: options.model.get('temp_closed'),
	      temp_closed_message: options.model.get('temp_closed_message')
	    });
	
	    view.on('feature:selected', function () {
	      self.trigger('map:feature:selected', options.model);
	    });
	
	    this.popup = L.popup({
	      minWidth: 180,
	      autoPan: false
	    }).setLatLng([popupLocation[0], popupLocation[1]]).setContent(view.render().el).openOn(self.map);
	  },
	  _removeFeaturePopup: function _removeFeaturePopup() {
	    if (this.popup) {
	      this.map.removeLayer(this.popup);
	    }
	  },
	  _getPaddingBasedOnScreenSize: function _getPaddingBasedOnScreenSize() {
	    var padding = 200;
	    var windowWidth = $(window).width();
	    if (windowWidth <= 650) {
	      padding = 150;
	    }
	    if (windowWidth <= 411) {
	      padding = 100;
	    }
	    if (windowWidth <= 375) {
	      padding = 60;
	    }
	    if (windowWidth <= 320) {
	      padding = 10;
	    }
	    return padding;
	  },
	  _zoomToFeatures: function _zoomToFeatures(featuresArray, callBack, delay, padding) {
	    var self = this;
	    if (!padding) {
	      padding = this._getPaddingBasedOnScreenSize();
	    }
	    if (!delay) {
	      delay = 2000;
	    }
	
	    if (!self.options.animate) {
	      delay = 0;
	    }
	
	    // check if a singular feature object is being passed in...
	    if (!$.isArray(featuresArray)) {
	      var featureObject = featuresArray;
	      featuresArray = [featureObject];
	    }
	    if (featuresArray.length == 0) {
	      return;
	    }
	    // Zoom to bounds of features...
	    var features = turf.featureCollection(featuresArray);
	    var bbox = turf.bbox(features);
	    var bboxPolygon = turf.bboxPolygon(bbox);
	    var boundsArray = [[bbox[1], bbox[0]], [bbox[3], bbox[2]]];
	
	    var hasMapCenter = true;
	    try {
	      this.map.getCenter();
	    } catch (err) {
	      hasMapCenter = false;
	    }
	
	    if (hasMapCenter && self.options.animate) {
	      if (featuresArray.length === 1) {
	        this.map.flyToBounds(boundsArray, {
	          animate: self.options.animate,
	          padding: [padding, padding],
	          maxZoom: 12
	        });
	      } else {
	        this.map.flyToBounds(boundsArray, {
	          animate: self.options.animate,
	          padding: [padding, padding]
	        });
	      }
	    } else {
	      this.map.fitBounds(boundsArray, {
	        animate: self.options.animate,
	        padding: [padding, padding]
	      });
	    }
	
	    if (callBack) {
	      _.delay(function () {
	        callBack();
	      }, delay);
	    }
	  },
	  mapToFeaturesExtent: function mapToFeaturesExtent() {
	    var self = this;
	    if (this._locationsTurfPointsArray) {
	      var features = turf.featureCollection(self._locationsTurfPointsArray);
	      var bbox = turf.bbox(features);
	      var bboxPolygon = turf.bboxPolygon(bbox);
	      var boundsArray = [[bbox[1], bbox[0]], [bbox[3], bbox[2]]];
	
	      var padding = this._getPaddingBasedOnScreenSize();
	
	      _.delay(function () {
	        self.map.fitBounds(boundsArray, {
	          animate: false,
	          padding: [padding, padding]
	        });
	      }, 50);
	    }
	  },
	  addUserLocationToMap: function addUserLocationToMap(location) {
	    var self = this;
	    var userMarkerIcon = L.divIcon({
	      className: 'map-marker-farmacy-user-location',
	      iconSize: [50, 50],
	      iconAnchor: [25, 50],
	      popupAnchor: [-3, -76]
	    });
	    self.userMarker = L.marker([location.coords.latitude, location.coords.longitude], { icon: userMarkerIcon }).addTo(self.map);
	
	    self._locations.each(function (model) {
	      self._locationsTurfPointsArray.push(turf.point([model.get('lng'), model.get('lat')]));
	    });
	
	    self._locationsTurfPointsArray.push(turf.point([location.coords.longitude, location.coords.latitude]));
	
	    self._findClosestLocationToUser(location.coords.latitude, location.coords.longitude);
	  },
	  _onWindowResize: function _onWindowResize(event) {
	    var topPos = 81;
	    var leftPos = 0;
	    var botPos = 0;
	    if (this.options.adjustForMenuBar == false) {
	      topPos = 0;
	    }
	
	    if (this.options.topPos) {
	      topPos = this.options.topPos;
	    }
	
	    if (this.options.leftPos) {
	      leftPos = this.options.leftPos;
	    }
	
	    if (this.options.botPos) {
	      botPos = this.options.botPos;
	    }
	
	    this.ui.mapTarget.css('top', topPos);
	    this.ui.mapTarget.css('left', leftPos);
	    this.ui.mapTarget.height($(window).height() - topPos - botPos);
	    this.ui.mapTarget.width($(window).width() - leftPos);
	    if (this.map) {
	      this.map._onResize();
	    }
	  },
	  adjustMapContainerPosition: function adjustMapContainerPosition(topPos, leftPos) {
	    if (leftPos !== null) {
	      this.options.leftPos = leftPos;
	    }
	    if (topPos !== null) {
	      this.options.topPos = topPos;
	    }
	    this._onWindowResize();
	  },
	
	  onShow: function onShow() {
	    var self = this;
	    this._initializeMap();
	    if (this.options.allLocations == true) {
	      this._displayFarmacyLocations();
	    } else {
	      this._displayPickupLocation();
	    }
	  },
	  onRender: function onRender() {
	    var self = this;
	    if (this.options.showCloseButton == false) {
	      this.ui.closeMapButton.hide();
	    }
	    this.options._appChannel.on('map:display:delivery:location', function (deliveryLocation) {
	      self.displayDeliveryLocation(deliveryLocation);
	    });
	    BaseViews.LayoutView.prototype.onRender.call(this);
	  },
	  onDestroy: function onDestroy() {
	    this.options._appChannel.off('map:display:delivery:location');
	    $(window).off('resize.' + this.cid);
	  }
	});
	
	module.exports = LocationsMap;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t((e.Leaflet=e.Leaflet||{},e.Leaflet.markercluster=e.Leaflet.markercluster||{}))}(this,function(e){"use strict";var t=L.MarkerClusterGroup=L.FeatureGroup.extend({options:{maxClusterRadius:80,iconCreateFunction:null,clusterPane:L.Marker.prototype.options.pane,spiderfyOnMaxZoom:!0,showCoverageOnHover:!0,zoomToBoundsOnClick:!0,singleMarkerMode:!1,disableClusteringAtZoom:null,removeOutsideVisibleBounds:!0,animate:!0,animateAddingMarkers:!1,spiderfyDistanceMultiplier:1,spiderLegPolylineOptions:{weight:1.5,color:"#222",opacity:.5},chunkedLoading:!1,chunkInterval:200,chunkDelay:50,chunkProgress:null,polygonOptions:{}},initialize:function(e){L.Util.setOptions(this,e),this.options.iconCreateFunction||(this.options.iconCreateFunction=this._defaultIconCreateFunction),this._featureGroup=L.featureGroup(),this._featureGroup.addEventParent(this),this._nonPointGroup=L.featureGroup(),this._nonPointGroup.addEventParent(this),this._inZoomAnimation=0,this._needsClustering=[],this._needsRemoving=[],this._currentShownBounds=null,this._queue=[],this._childMarkerEventHandlers={dragstart:this._childMarkerDragStart,move:this._childMarkerMoved,dragend:this._childMarkerDragEnd};var t=L.DomUtil.TRANSITION&&this.options.animate;L.extend(this,t?this._withAnimation:this._noAnimation),this._markerCluster=t?L.MarkerCluster:L.MarkerClusterNonAnimated},addLayer:function(e){if(e instanceof L.LayerGroup)return this.addLayers([e]);if(!e.getLatLng)return this._nonPointGroup.addLayer(e),this.fire("layeradd",{layer:e}),this;if(!this._map)return this._needsClustering.push(e),this.fire("layeradd",{layer:e}),this;if(this.hasLayer(e))return this;this._unspiderfy&&this._unspiderfy(),this._addLayer(e,this._maxZoom),this.fire("layeradd",{layer:e}),this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons();var t=e,i=this._zoom;if(e.__parent)for(;t.__parent._zoom>=i;)t=t.__parent;return this._currentShownBounds.contains(t.getLatLng())&&(this.options.animateAddingMarkers?this._animationAddLayer(e,t):this._animationAddLayerNonAnimated(e,t)),this},removeLayer:function(e){return e instanceof L.LayerGroup?this.removeLayers([e]):e.getLatLng?this._map?e.__parent?(this._unspiderfy&&(this._unspiderfy(),this._unspiderfyLayer(e)),this._removeLayer(e,!0),this.fire("layerremove",{layer:e}),this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons(),e.off(this._childMarkerEventHandlers,this),this._featureGroup.hasLayer(e)&&(this._featureGroup.removeLayer(e),e.clusterShow&&e.clusterShow()),this):this:(!this._arraySplice(this._needsClustering,e)&&this.hasLayer(e)&&this._needsRemoving.push({layer:e,latlng:e._latlng}),this.fire("layerremove",{layer:e}),this):(this._nonPointGroup.removeLayer(e),this.fire("layerremove",{layer:e}),this)},addLayers:function(e,t){if(!L.Util.isArray(e))return this.addLayer(e);var i,n=this._featureGroup,r=this._nonPointGroup,s=this.options.chunkedLoading,o=this.options.chunkInterval,a=this.options.chunkProgress,h=e.length,l=0,u=!0;if(this._map){var _=(new Date).getTime(),d=L.bind(function(){for(var c=(new Date).getTime();h>l;l++){if(s&&0===l%200){var p=(new Date).getTime()-c;if(p>o)break}if(i=e[l],i instanceof L.LayerGroup)u&&(e=e.slice(),u=!1),this._extractNonGroupLayers(i,e),h=e.length;else if(i.getLatLng){if(!this.hasLayer(i)&&(this._addLayer(i,this._maxZoom),t||this.fire("layeradd",{layer:i}),i.__parent&&2===i.__parent.getChildCount())){var f=i.__parent.getAllChildMarkers(),m=f[0]===i?f[1]:f[0];n.removeLayer(m)}}else r.addLayer(i),t||this.fire("layeradd",{layer:i})}a&&a(l,h,(new Date).getTime()-_),l===h?(this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons(),this._topClusterLevel._recursivelyAddChildrenToMap(null,this._zoom,this._currentShownBounds)):setTimeout(d,this.options.chunkDelay)},this);d()}else for(var c=this._needsClustering;h>l;l++)i=e[l],i instanceof L.LayerGroup?(u&&(e=e.slice(),u=!1),this._extractNonGroupLayers(i,e),h=e.length):i.getLatLng?this.hasLayer(i)||c.push(i):r.addLayer(i);return this},removeLayers:function(e){var t,i,n=e.length,r=this._featureGroup,s=this._nonPointGroup,o=!0;if(!this._map){for(t=0;n>t;t++)i=e[t],i instanceof L.LayerGroup?(o&&(e=e.slice(),o=!1),this._extractNonGroupLayers(i,e),n=e.length):(this._arraySplice(this._needsClustering,i),s.removeLayer(i),this.hasLayer(i)&&this._needsRemoving.push({layer:i,latlng:i._latlng}),this.fire("layerremove",{layer:i}));return this}if(this._unspiderfy){this._unspiderfy();var a=e.slice(),h=n;for(t=0;h>t;t++)i=a[t],i instanceof L.LayerGroup?(this._extractNonGroupLayers(i,a),h=a.length):this._unspiderfyLayer(i)}for(t=0;n>t;t++)i=e[t],i instanceof L.LayerGroup?(o&&(e=e.slice(),o=!1),this._extractNonGroupLayers(i,e),n=e.length):i.__parent?(this._removeLayer(i,!0,!0),this.fire("layerremove",{layer:i}),r.hasLayer(i)&&(r.removeLayer(i),i.clusterShow&&i.clusterShow())):(s.removeLayer(i),this.fire("layerremove",{layer:i}));return this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons(),this._topClusterLevel._recursivelyAddChildrenToMap(null,this._zoom,this._currentShownBounds),this},clearLayers:function(){return this._map||(this._needsClustering=[],this._needsRemoving=[],delete this._gridClusters,delete this._gridUnclustered),this._noanimationUnspiderfy&&this._noanimationUnspiderfy(),this._featureGroup.clearLayers(),this._nonPointGroup.clearLayers(),this.eachLayer(function(e){e.off(this._childMarkerEventHandlers,this),delete e.__parent},this),this._map&&this._generateInitialClusters(),this},getBounds:function(){var e=new L.LatLngBounds;this._topClusterLevel&&e.extend(this._topClusterLevel._bounds);for(var t=this._needsClustering.length-1;t>=0;t--)e.extend(this._needsClustering[t].getLatLng());return e.extend(this._nonPointGroup.getBounds()),e},eachLayer:function(e,t){var i,n,r,s=this._needsClustering.slice(),o=this._needsRemoving;for(this._topClusterLevel&&this._topClusterLevel.getAllChildMarkers(s),n=s.length-1;n>=0;n--){for(i=!0,r=o.length-1;r>=0;r--)if(o[r].layer===s[n]){i=!1;break}i&&e.call(t,s[n])}this._nonPointGroup.eachLayer(e,t)},getLayers:function(){var e=[];return this.eachLayer(function(t){e.push(t)}),e},getLayer:function(e){var t=null;return e=parseInt(e,10),this.eachLayer(function(i){L.stamp(i)===e&&(t=i)}),t},hasLayer:function(e){if(!e)return!1;var t,i=this._needsClustering;for(t=i.length-1;t>=0;t--)if(i[t]===e)return!0;for(i=this._needsRemoving,t=i.length-1;t>=0;t--)if(i[t].layer===e)return!1;return!(!e.__parent||e.__parent._group!==this)||this._nonPointGroup.hasLayer(e)},zoomToShowLayer:function(e,t){"function"!=typeof t&&(t=function(){});var i=function(){!e._icon&&!e.__parent._icon||this._inZoomAnimation||(this._map.off("moveend",i,this),this.off("animationend",i,this),e._icon?t():e.__parent._icon&&(this.once("spiderfied",t,this),e.__parent.spiderfy()))};e._icon&&this._map.getBounds().contains(e.getLatLng())?t():e.__parent._zoom<Math.round(this._map._zoom)?(this._map.on("moveend",i,this),this._map.panTo(e.getLatLng())):(this._map.on("moveend",i,this),this.on("animationend",i,this),e.__parent.zoomToBounds())},onAdd:function(e){this._map=e;var t,i,n;if(!isFinite(this._map.getMaxZoom()))throw"Map has no maxZoom specified";for(this._featureGroup.addTo(e),this._nonPointGroup.addTo(e),this._gridClusters||this._generateInitialClusters(),this._maxLat=e.options.crs.projection.MAX_LATITUDE,t=0,i=this._needsRemoving.length;i>t;t++)n=this._needsRemoving[t],n.newlatlng=n.layer._latlng,n.layer._latlng=n.latlng;for(t=0,i=this._needsRemoving.length;i>t;t++)n=this._needsRemoving[t],this._removeLayer(n.layer,!0),n.layer._latlng=n.newlatlng;this._needsRemoving=[],this._zoom=Math.round(this._map._zoom),this._currentShownBounds=this._getExpandedVisibleBounds(),this._map.on("zoomend",this._zoomEnd,this),this._map.on("moveend",this._moveEnd,this),this._spiderfierOnAdd&&this._spiderfierOnAdd(),this._bindEvents(),i=this._needsClustering,this._needsClustering=[],this.addLayers(i,!0)},onRemove:function(e){e.off("zoomend",this._zoomEnd,this),e.off("moveend",this._moveEnd,this),this._unbindEvents(),this._map._mapPane.className=this._map._mapPane.className.replace(" leaflet-cluster-anim",""),this._spiderfierOnRemove&&this._spiderfierOnRemove(),delete this._maxLat,this._hideCoverage(),this._featureGroup.remove(),this._nonPointGroup.remove(),this._featureGroup.clearLayers(),this._map=null},getVisibleParent:function(e){for(var t=e;t&&!t._icon;)t=t.__parent;return t||null},_arraySplice:function(e,t){for(var i=e.length-1;i>=0;i--)if(e[i]===t)return e.splice(i,1),!0},_removeFromGridUnclustered:function(e,t){for(var i=this._map,n=this._gridUnclustered,r=Math.floor(this._map.getMinZoom());t>=r&&n[t].removeObject(e,i.project(e.getLatLng(),t));t--);},_childMarkerDragStart:function(e){e.target.__dragStart=e.target._latlng},_childMarkerMoved:function(e){if(!this._ignoreMove&&!e.target.__dragStart){var t=e.target._popup&&e.target._popup.isOpen();this._moveChild(e.target,e.oldLatLng,e.latlng),t&&e.target.openPopup()}},_moveChild:function(e,t,i){e._latlng=t,this.removeLayer(e),e._latlng=i,this.addLayer(e)},_childMarkerDragEnd:function(e){var t=e.target.__dragStart;delete e.target.__dragStart,t&&this._moveChild(e.target,t,e.target._latlng)},_removeLayer:function(e,t,i){var n=this._gridClusters,r=this._gridUnclustered,s=this._featureGroup,o=this._map,a=Math.floor(this._map.getMinZoom());t&&this._removeFromGridUnclustered(e,this._maxZoom);var h,l=e.__parent,u=l._markers;for(this._arraySplice(u,e);l&&(l._childCount--,l._boundsNeedUpdate=!0,!(l._zoom<a));)t&&l._childCount<=1?(h=l._markers[0]===e?l._markers[1]:l._markers[0],n[l._zoom].removeObject(l,o.project(l._cLatLng,l._zoom)),r[l._zoom].addObject(h,o.project(h.getLatLng(),l._zoom)),this._arraySplice(l.__parent._childClusters,l),l.__parent._markers.push(h),h.__parent=l.__parent,l._icon&&(s.removeLayer(l),i||s.addLayer(h))):l._iconNeedsUpdate=!0,l=l.__parent;delete e.__parent},_isOrIsParent:function(e,t){for(;t;){if(e===t)return!0;t=t.parentNode}return!1},fire:function(e,t,i){if(t&&t.layer instanceof L.MarkerCluster){if(t.originalEvent&&this._isOrIsParent(t.layer._icon,t.originalEvent.relatedTarget))return;e="cluster"+e}L.FeatureGroup.prototype.fire.call(this,e,t,i)},listens:function(e,t){return L.FeatureGroup.prototype.listens.call(this,e,t)||L.FeatureGroup.prototype.listens.call(this,"cluster"+e,t)},_defaultIconCreateFunction:function(e){var t=e.getChildCount(),i=" marker-cluster-";return i+=10>t?"small":100>t?"medium":"large",new L.DivIcon({html:"<div><span>"+t+"</span></div>",className:"marker-cluster"+i,iconSize:new L.Point(40,40)})},_bindEvents:function(){var e=this._map,t=this.options.spiderfyOnMaxZoom,i=this.options.showCoverageOnHover,n=this.options.zoomToBoundsOnClick;(t||n)&&this.on("clusterclick",this._zoomOrSpiderfy,this),i&&(this.on("clustermouseover",this._showCoverage,this),this.on("clustermouseout",this._hideCoverage,this),e.on("zoomend",this._hideCoverage,this))},_zoomOrSpiderfy:function(e){for(var t=e.layer,i=t;1===i._childClusters.length;)i=i._childClusters[0];i._zoom===this._maxZoom&&i._childCount===t._childCount&&this.options.spiderfyOnMaxZoom?t.spiderfy():this.options.zoomToBoundsOnClick&&t.zoomToBounds(),e.originalEvent&&13===e.originalEvent.keyCode&&this._map._container.focus()},_showCoverage:function(e){var t=this._map;this._inZoomAnimation||(this._shownPolygon&&t.removeLayer(this._shownPolygon),e.layer.getChildCount()>2&&e.layer!==this._spiderfied&&(this._shownPolygon=new L.Polygon(e.layer.getConvexHull(),this.options.polygonOptions),t.addLayer(this._shownPolygon)))},_hideCoverage:function(){this._shownPolygon&&(this._map.removeLayer(this._shownPolygon),this._shownPolygon=null)},_unbindEvents:function(){var e=this.options.spiderfyOnMaxZoom,t=this.options.showCoverageOnHover,i=this.options.zoomToBoundsOnClick,n=this._map;(e||i)&&this.off("clusterclick",this._zoomOrSpiderfy,this),t&&(this.off("clustermouseover",this._showCoverage,this),this.off("clustermouseout",this._hideCoverage,this),n.off("zoomend",this._hideCoverage,this))},_zoomEnd:function(){this._map&&(this._mergeSplitClusters(),this._zoom=Math.round(this._map._zoom),this._currentShownBounds=this._getExpandedVisibleBounds())},_moveEnd:function(){if(!this._inZoomAnimation){var e=this._getExpandedVisibleBounds();this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),this._zoom,e),this._topClusterLevel._recursivelyAddChildrenToMap(null,Math.round(this._map._zoom),e),this._currentShownBounds=e}},_generateInitialClusters:function(){var e=Math.ceil(this._map.getMaxZoom()),t=Math.floor(this._map.getMinZoom()),i=this.options.maxClusterRadius,n=i;"function"!=typeof i&&(n=function(){return i}),null!==this.options.disableClusteringAtZoom&&(e=this.options.disableClusteringAtZoom-1),this._maxZoom=e,this._gridClusters={},this._gridUnclustered={};for(var r=e;r>=t;r--)this._gridClusters[r]=new L.DistanceGrid(n(r)),this._gridUnclustered[r]=new L.DistanceGrid(n(r));this._topClusterLevel=new this._markerCluster(this,t-1)},_addLayer:function(e,t){var i,n,r=this._gridClusters,s=this._gridUnclustered,o=Math.floor(this._map.getMinZoom());for(this.options.singleMarkerMode&&this._overrideMarkerIcon(e),e.on(this._childMarkerEventHandlers,this);t>=o;t--){i=this._map.project(e.getLatLng(),t);var a=r[t].getNearObject(i);if(a)return a._addChild(e),e.__parent=a,void 0;if(a=s[t].getNearObject(i)){var h=a.__parent;h&&this._removeLayer(a,!1);var l=new this._markerCluster(this,t,a,e);r[t].addObject(l,this._map.project(l._cLatLng,t)),a.__parent=l,e.__parent=l;var u=l;for(n=t-1;n>h._zoom;n--)u=new this._markerCluster(this,n,u),r[n].addObject(u,this._map.project(a.getLatLng(),n));return h._addChild(u),this._removeFromGridUnclustered(a,t),void 0}s[t].addObject(e,i)}this._topClusterLevel._addChild(e),e.__parent=this._topClusterLevel},_refreshClustersIcons:function(){this._featureGroup.eachLayer(function(e){e instanceof L.MarkerCluster&&e._iconNeedsUpdate&&e._updateIcon()})},_enqueue:function(e){this._queue.push(e),this._queueTimeout||(this._queueTimeout=setTimeout(L.bind(this._processQueue,this),300))},_processQueue:function(){for(var e=0;e<this._queue.length;e++)this._queue[e].call(this);this._queue.length=0,clearTimeout(this._queueTimeout),this._queueTimeout=null},_mergeSplitClusters:function(){var e=Math.round(this._map._zoom);this._processQueue(),this._zoom<e&&this._currentShownBounds.intersects(this._getExpandedVisibleBounds())?(this._animationStart(),this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),this._zoom,this._getExpandedVisibleBounds()),this._animationZoomIn(this._zoom,e)):this._zoom>e?(this._animationStart(),this._animationZoomOut(this._zoom,e)):this._moveEnd()},_getExpandedVisibleBounds:function(){return this.options.removeOutsideVisibleBounds?L.Browser.mobile?this._checkBoundsMaxLat(this._map.getBounds()):this._checkBoundsMaxLat(this._map.getBounds().pad(1)):this._mapBoundsInfinite},_checkBoundsMaxLat:function(e){var t=this._maxLat;return void 0!==t&&(e.getNorth()>=t&&(e._northEast.lat=1/0),e.getSouth()<=-t&&(e._southWest.lat=-1/0)),e},_animationAddLayerNonAnimated:function(e,t){if(t===e)this._featureGroup.addLayer(e);else if(2===t._childCount){t._addToMap();var i=t.getAllChildMarkers();this._featureGroup.removeLayer(i[0]),this._featureGroup.removeLayer(i[1])}else t._updateIcon()},_extractNonGroupLayers:function(e,t){var i,n=e.getLayers(),r=0;for(t=t||[];r<n.length;r++)i=n[r],i instanceof L.LayerGroup?this._extractNonGroupLayers(i,t):t.push(i);return t},_overrideMarkerIcon:function(e){var t=e.options.icon=this.options.iconCreateFunction({getChildCount:function(){return 1},getAllChildMarkers:function(){return[e]}});return t}});L.MarkerClusterGroup.include({_mapBoundsInfinite:new L.LatLngBounds(new L.LatLng(-1/0,-1/0),new L.LatLng(1/0,1/0))}),L.MarkerClusterGroup.include({_noAnimation:{_animationStart:function(){},_animationZoomIn:function(e,t){this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),e),this._topClusterLevel._recursivelyAddChildrenToMap(null,t,this._getExpandedVisibleBounds()),this.fire("animationend")},_animationZoomOut:function(e,t){this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),e),this._topClusterLevel._recursivelyAddChildrenToMap(null,t,this._getExpandedVisibleBounds()),this.fire("animationend")},_animationAddLayer:function(e,t){this._animationAddLayerNonAnimated(e,t)}},_withAnimation:{_animationStart:function(){this._map._mapPane.className+=" leaflet-cluster-anim",this._inZoomAnimation++},_animationZoomIn:function(e,t){var i,n=this._getExpandedVisibleBounds(),r=this._featureGroup,s=Math.floor(this._map.getMinZoom());this._ignoreMove=!0,this._topClusterLevel._recursively(n,e,s,function(s){var o,a=s._latlng,h=s._markers;for(n.contains(a)||(a=null),s._isSingleParent()&&e+1===t?(r.removeLayer(s),s._recursivelyAddChildrenToMap(null,t,n)):(s.clusterHide(),s._recursivelyAddChildrenToMap(a,t,n)),i=h.length-1;i>=0;i--)o=h[i],n.contains(o._latlng)||r.removeLayer(o)}),this._forceLayout(),this._topClusterLevel._recursivelyBecomeVisible(n,t),r.eachLayer(function(e){e instanceof L.MarkerCluster||!e._icon||e.clusterShow()}),this._topClusterLevel._recursively(n,e,t,function(e){e._recursivelyRestoreChildPositions(t)}),this._ignoreMove=!1,this._enqueue(function(){this._topClusterLevel._recursively(n,e,s,function(e){r.removeLayer(e),e.clusterShow()}),this._animationEnd()})},_animationZoomOut:function(e,t){this._animationZoomOutSingle(this._topClusterLevel,e-1,t),this._topClusterLevel._recursivelyAddChildrenToMap(null,t,this._getExpandedVisibleBounds()),this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),e,this._getExpandedVisibleBounds())},_animationAddLayer:function(e,t){var i=this,n=this._featureGroup;n.addLayer(e),t!==e&&(t._childCount>2?(t._updateIcon(),this._forceLayout(),this._animationStart(),e._setPos(this._map.latLngToLayerPoint(t.getLatLng())),e.clusterHide(),this._enqueue(function(){n.removeLayer(e),e.clusterShow(),i._animationEnd()})):(this._forceLayout(),i._animationStart(),i._animationZoomOutSingle(t,this._map.getMaxZoom(),this._zoom)))}},_animationZoomOutSingle:function(e,t,i){var n=this._getExpandedVisibleBounds(),r=Math.floor(this._map.getMinZoom());e._recursivelyAnimateChildrenInAndAddSelfToMap(n,r,t+1,i);var s=this;this._forceLayout(),e._recursivelyBecomeVisible(n,i),this._enqueue(function(){if(1===e._childCount){var o=e._markers[0];this._ignoreMove=!0,o.setLatLng(o.getLatLng()),this._ignoreMove=!1,o.clusterShow&&o.clusterShow()}else e._recursively(n,i,r,function(e){e._recursivelyRemoveChildrenFromMap(n,r,t+1)});s._animationEnd()})},_animationEnd:function(){this._map&&(this._map._mapPane.className=this._map._mapPane.className.replace(" leaflet-cluster-anim","")),this._inZoomAnimation--,this.fire("animationend")},_forceLayout:function(){L.Util.falseFn(document.body.offsetWidth)}}),L.markerClusterGroup=function(e){return new L.MarkerClusterGroup(e)};var i=L.MarkerCluster=L.Marker.extend({options:L.Icon.prototype.options,initialize:function(e,t,i,n){L.Marker.prototype.initialize.call(this,i?i._cLatLng||i.getLatLng():new L.LatLng(0,0),{icon:this,pane:e.options.clusterPane}),this._group=e,this._zoom=t,this._markers=[],this._childClusters=[],this._childCount=0,this._iconNeedsUpdate=!0,this._boundsNeedUpdate=!0,this._bounds=new L.LatLngBounds,i&&this._addChild(i),n&&this._addChild(n)},getAllChildMarkers:function(e,t){e=e||[];for(var i=this._childClusters.length-1;i>=0;i--)this._childClusters[i].getAllChildMarkers(e);for(var n=this._markers.length-1;n>=0;n--)t&&this._markers[n].__dragStart||e.push(this._markers[n]);return e},getChildCount:function(){return this._childCount},zoomToBounds:function(e){for(var t,i=this._childClusters.slice(),n=this._group._map,r=n.getBoundsZoom(this._bounds),s=this._zoom+1,o=n.getZoom();i.length>0&&r>s;){s++;var a=[];for(t=0;t<i.length;t++)a=a.concat(i[t]._childClusters);i=a}r>s?this._group._map.setView(this._latlng,s):o>=r?this._group._map.setView(this._latlng,o+1):this._group._map.fitBounds(this._bounds,e)},getBounds:function(){var e=new L.LatLngBounds;return e.extend(this._bounds),e},_updateIcon:function(){this._iconNeedsUpdate=!0,this._icon&&this.setIcon(this)},createIcon:function(){return this._iconNeedsUpdate&&(this._iconObj=this._group.options.iconCreateFunction(this),this._iconNeedsUpdate=!1),this._iconObj.createIcon()},createShadow:function(){return this._iconObj.createShadow()},_addChild:function(e,t){this._iconNeedsUpdate=!0,this._boundsNeedUpdate=!0,this._setClusterCenter(e),e instanceof L.MarkerCluster?(t||(this._childClusters.push(e),e.__parent=this),this._childCount+=e._childCount):(t||this._markers.push(e),this._childCount++),this.__parent&&this.__parent._addChild(e,!0)},_setClusterCenter:function(e){this._cLatLng||(this._cLatLng=e._cLatLng||e._latlng)},_resetBounds:function(){var e=this._bounds;e._southWest&&(e._southWest.lat=1/0,e._southWest.lng=1/0),e._northEast&&(e._northEast.lat=-1/0,e._northEast.lng=-1/0)},_recalculateBounds:function(){var e,t,i,n,r=this._markers,s=this._childClusters,o=0,a=0,h=this._childCount;if(0!==h){for(this._resetBounds(),e=0;e<r.length;e++)i=r[e]._latlng,this._bounds.extend(i),o+=i.lat,a+=i.lng;for(e=0;e<s.length;e++)t=s[e],t._boundsNeedUpdate&&t._recalculateBounds(),this._bounds.extend(t._bounds),i=t._wLatLng,n=t._childCount,o+=i.lat*n,a+=i.lng*n;this._latlng=this._wLatLng=new L.LatLng(o/h,a/h),this._boundsNeedUpdate=!1}},_addToMap:function(e){e&&(this._backupLatlng=this._latlng,this.setLatLng(e)),this._group._featureGroup.addLayer(this)},_recursivelyAnimateChildrenIn:function(e,t,i){this._recursively(e,this._group._map.getMinZoom(),i-1,function(e){var i,n,r=e._markers;for(i=r.length-1;i>=0;i--)n=r[i],n._icon&&(n._setPos(t),n.clusterHide())},function(e){var i,n,r=e._childClusters;for(i=r.length-1;i>=0;i--)n=r[i],n._icon&&(n._setPos(t),n.clusterHide())})},_recursivelyAnimateChildrenInAndAddSelfToMap:function(e,t,i,n){this._recursively(e,n,t,function(r){r._recursivelyAnimateChildrenIn(e,r._group._map.latLngToLayerPoint(r.getLatLng()).round(),i),r._isSingleParent()&&i-1===n?(r.clusterShow(),r._recursivelyRemoveChildrenFromMap(e,t,i)):r.clusterHide(),r._addToMap()})},_recursivelyBecomeVisible:function(e,t){this._recursively(e,this._group._map.getMinZoom(),t,null,function(e){e.clusterShow()})},_recursivelyAddChildrenToMap:function(e,t,i){this._recursively(i,this._group._map.getMinZoom()-1,t,function(n){if(t!==n._zoom)for(var r=n._markers.length-1;r>=0;r--){var s=n._markers[r];i.contains(s._latlng)&&(e&&(s._backupLatlng=s.getLatLng(),s.setLatLng(e),s.clusterHide&&s.clusterHide()),n._group._featureGroup.addLayer(s))}},function(t){t._addToMap(e)})},_recursivelyRestoreChildPositions:function(e){for(var t=this._markers.length-1;t>=0;t--){var i=this._markers[t];i._backupLatlng&&(i.setLatLng(i._backupLatlng),delete i._backupLatlng)}if(e-1===this._zoom)for(var n=this._childClusters.length-1;n>=0;n--)this._childClusters[n]._restorePosition();else for(var r=this._childClusters.length-1;r>=0;r--)this._childClusters[r]._recursivelyRestoreChildPositions(e)},_restorePosition:function(){this._backupLatlng&&(this.setLatLng(this._backupLatlng),delete this._backupLatlng)},_recursivelyRemoveChildrenFromMap:function(e,t,i,n){var r,s;this._recursively(e,t-1,i-1,function(e){for(s=e._markers.length-1;s>=0;s--)r=e._markers[s],n&&n.contains(r._latlng)||(e._group._featureGroup.removeLayer(r),r.clusterShow&&r.clusterShow())},function(e){for(s=e._childClusters.length-1;s>=0;s--)r=e._childClusters[s],n&&n.contains(r._latlng)||(e._group._featureGroup.removeLayer(r),r.clusterShow&&r.clusterShow())})},_recursively:function(e,t,i,n,r){var s,o,a=this._childClusters,h=this._zoom;if(h>=t&&(n&&n(this),r&&h===i&&r(this)),t>h||i>h)for(s=a.length-1;s>=0;s--)o=a[s],o._boundsNeedUpdate&&o._recalculateBounds(),e.intersects(o._bounds)&&o._recursively(e,t,i,n,r)},_isSingleParent:function(){return this._childClusters.length>0&&this._childClusters[0]._childCount===this._childCount}});L.Marker.include({clusterHide:function(){var e=this.options.opacity;return this.setOpacity(0),this.options.opacity=e,this},clusterShow:function(){return this.setOpacity(this.options.opacity)}}),L.DistanceGrid=function(e){this._cellSize=e,this._sqCellSize=e*e,this._grid={},this._objectPoint={}},L.DistanceGrid.prototype={addObject:function(e,t){var i=this._getCoord(t.x),n=this._getCoord(t.y),r=this._grid,s=r[n]=r[n]||{},o=s[i]=s[i]||[],a=L.Util.stamp(e);this._objectPoint[a]=t,o.push(e)},updateObject:function(e,t){this.removeObject(e),this.addObject(e,t)},removeObject:function(e,t){var i,n,r=this._getCoord(t.x),s=this._getCoord(t.y),o=this._grid,a=o[s]=o[s]||{},h=a[r]=a[r]||[];for(delete this._objectPoint[L.Util.stamp(e)],i=0,n=h.length;n>i;i++)if(h[i]===e)return h.splice(i,1),1===n&&delete a[r],!0},eachObject:function(e,t){var i,n,r,s,o,a,h,l=this._grid;for(i in l){o=l[i];for(n in o)for(a=o[n],r=0,s=a.length;s>r;r++)h=e.call(t,a[r]),h&&(r--,s--)}},getNearObject:function(e){var t,i,n,r,s,o,a,h,l=this._getCoord(e.x),u=this._getCoord(e.y),_=this._objectPoint,d=this._sqCellSize,c=null;for(t=u-1;u+1>=t;t++)if(r=this._grid[t])for(i=l-1;l+1>=i;i++)if(s=r[i])for(n=0,o=s.length;o>n;n++)a=s[n],h=this._sqDist(_[L.Util.stamp(a)],e),(d>h||d>=h&&null===c)&&(d=h,c=a);return c},_getCoord:function(e){var t=Math.floor(e/this._cellSize);return isFinite(t)?t:e},_sqDist:function(e,t){var i=t.x-e.x,n=t.y-e.y;return i*i+n*n}},function(){L.QuickHull={getDistant:function(e,t){var i=t[1].lat-t[0].lat,n=t[0].lng-t[1].lng;return n*(e.lat-t[0].lat)+i*(e.lng-t[0].lng)},findMostDistantPointFromBaseLine:function(e,t){var i,n,r,s=0,o=null,a=[];for(i=t.length-1;i>=0;i--)n=t[i],r=this.getDistant(n,e),r>0&&(a.push(n),r>s&&(s=r,o=n));return{maxPoint:o,newPoints:a}},buildConvexHull:function(e,t){var i=[],n=this.findMostDistantPointFromBaseLine(e,t);return n.maxPoint?(i=i.concat(this.buildConvexHull([e[0],n.maxPoint],n.newPoints)),i=i.concat(this.buildConvexHull([n.maxPoint,e[1]],n.newPoints))):[e[0]]},getConvexHull:function(e){var t,i=!1,n=!1,r=!1,s=!1,o=null,a=null,h=null,l=null,u=null,_=null;for(t=e.length-1;t>=0;t--){var d=e[t];(i===!1||d.lat>i)&&(o=d,i=d.lat),(n===!1||d.lat<n)&&(a=d,n=d.lat),(r===!1||d.lng>r)&&(h=d,r=d.lng),(s===!1||d.lng<s)&&(l=d,s=d.lng)}n!==i?(_=a,u=o):(_=l,u=h);var c=[].concat(this.buildConvexHull([_,u],e),this.buildConvexHull([u,_],e));return c}}}(),L.MarkerCluster.include({getConvexHull:function(){var e,t,i=this.getAllChildMarkers(),n=[];for(t=i.length-1;t>=0;t--)e=i[t].getLatLng(),n.push(e);return L.QuickHull.getConvexHull(n)}}),L.MarkerCluster.include({_2PI:2*Math.PI,_circleFootSeparation:25,_circleStartAngle:0,_spiralFootSeparation:28,_spiralLengthStart:11,_spiralLengthFactor:5,_circleSpiralSwitchover:9,spiderfy:function(){if(this._group._spiderfied!==this&&!this._group._inZoomAnimation){var e,t=this.getAllChildMarkers(null,!0),i=this._group,n=i._map,r=n.latLngToLayerPoint(this._latlng);this._group._unspiderfy(),this._group._spiderfied=this,t.length>=this._circleSpiralSwitchover?e=this._generatePointsSpiral(t.length,r):(r.y+=10,e=this._generatePointsCircle(t.length,r)),this._animationSpiderfy(t,e)}},unspiderfy:function(e){this._group._inZoomAnimation||(this._animationUnspiderfy(e),this._group._spiderfied=null)},_generatePointsCircle:function(e,t){var i,n,r=this._group.options.spiderfyDistanceMultiplier*this._circleFootSeparation*(2+e),s=r/this._2PI,o=this._2PI/e,a=[];for(s=Math.max(s,35),a.length=e,i=0;e>i;i++)n=this._circleStartAngle+i*o,a[i]=new L.Point(t.x+s*Math.cos(n),t.y+s*Math.sin(n))._round();return a},_generatePointsSpiral:function(e,t){var i,n=this._group.options.spiderfyDistanceMultiplier,r=n*this._spiralLengthStart,s=n*this._spiralFootSeparation,o=n*this._spiralLengthFactor*this._2PI,a=0,h=[];for(h.length=e,i=e;i>=0;i--)e>i&&(h[i]=new L.Point(t.x+r*Math.cos(a),t.y+r*Math.sin(a))._round()),a+=s/r+5e-4*i,r+=o/a;return h},_noanimationUnspiderfy:function(){var e,t,i=this._group,n=i._map,r=i._featureGroup,s=this.getAllChildMarkers(null,!0);for(i._ignoreMove=!0,this.setOpacity(1),t=s.length-1;t>=0;t--)e=s[t],r.removeLayer(e),e._preSpiderfyLatlng&&(e.setLatLng(e._preSpiderfyLatlng),delete e._preSpiderfyLatlng),e.setZIndexOffset&&e.setZIndexOffset(0),e._spiderLeg&&(n.removeLayer(e._spiderLeg),delete e._spiderLeg);i.fire("unspiderfied",{cluster:this,markers:s}),i._ignoreMove=!1,i._spiderfied=null}}),L.MarkerClusterNonAnimated=L.MarkerCluster.extend({_animationSpiderfy:function(e,t){var i,n,r,s,o=this._group,a=o._map,h=o._featureGroup,l=this._group.options.spiderLegPolylineOptions;for(o._ignoreMove=!0,i=0;i<e.length;i++)s=a.layerPointToLatLng(t[i]),n=e[i],r=new L.Polyline([this._latlng,s],l),a.addLayer(r),n._spiderLeg=r,n._preSpiderfyLatlng=n._latlng,n.setLatLng(s),n.setZIndexOffset&&n.setZIndexOffset(1e6),h.addLayer(n);this.setOpacity(.3),o._ignoreMove=!1,o.fire("spiderfied",{cluster:this,markers:e})},_animationUnspiderfy:function(){this._noanimationUnspiderfy()}}),L.MarkerCluster.include({_animationSpiderfy:function(e,t){var i,n,r,s,o,a,h=this,l=this._group,u=l._map,_=l._featureGroup,d=this._latlng,c=u.latLngToLayerPoint(d),p=L.Path.SVG,f=L.extend({},this._group.options.spiderLegPolylineOptions),m=f.opacity;for(void 0===m&&(m=L.MarkerClusterGroup.prototype.options.spiderLegPolylineOptions.opacity),p?(f.opacity=0,f.className=(f.className||"")+" leaflet-cluster-spider-leg"):f.opacity=m,l._ignoreMove=!0,i=0;i<e.length;i++)n=e[i],a=u.layerPointToLatLng(t[i]),r=new L.Polyline([d,a],f),u.addLayer(r),n._spiderLeg=r,p&&(s=r._path,o=s.getTotalLength()+.1,s.style.strokeDasharray=o,s.style.strokeDashoffset=o),n.setZIndexOffset&&n.setZIndexOffset(1e6),n.clusterHide&&n.clusterHide(),_.addLayer(n),n._setPos&&n._setPos(c);for(l._forceLayout(),l._animationStart(),i=e.length-1;i>=0;i--)a=u.layerPointToLatLng(t[i]),n=e[i],n._preSpiderfyLatlng=n._latlng,n.setLatLng(a),n.clusterShow&&n.clusterShow(),p&&(r=n._spiderLeg,s=r._path,s.style.strokeDashoffset=0,r.setStyle({opacity:m}));this.setOpacity(.3),l._ignoreMove=!1,setTimeout(function(){l._animationEnd(),l.fire("spiderfied",{cluster:h,markers:e})},200)},_animationUnspiderfy:function(e){var t,i,n,r,s,o,a=this,h=this._group,l=h._map,u=h._featureGroup,_=e?l._latLngToNewLayerPoint(this._latlng,e.zoom,e.center):l.latLngToLayerPoint(this._latlng),d=this.getAllChildMarkers(null,!0),c=L.Path.SVG;for(h._ignoreMove=!0,h._animationStart(),this.setOpacity(1),i=d.length-1;i>=0;i--)t=d[i],t._preSpiderfyLatlng&&(t.closePopup(),t.setLatLng(t._preSpiderfyLatlng),delete t._preSpiderfyLatlng,o=!0,t._setPos&&(t._setPos(_),o=!1),t.clusterHide&&(t.clusterHide(),o=!1),o&&u.removeLayer(t),c&&(n=t._spiderLeg,r=n._path,s=r.getTotalLength()+.1,r.style.strokeDashoffset=s,n.setStyle({opacity:0})));h._ignoreMove=!1,setTimeout(function(){var e=0;for(i=d.length-1;i>=0;i--)t=d[i],t._spiderLeg&&e++;for(i=d.length-1;i>=0;i--)t=d[i],t._spiderLeg&&(t.clusterShow&&t.clusterShow(),t.setZIndexOffset&&t.setZIndexOffset(0),e>1&&u.removeLayer(t),l.removeLayer(t._spiderLeg),delete t._spiderLeg);h._animationEnd(),h.fire("unspiderfied",{cluster:a,markers:d})},200)}}),L.MarkerClusterGroup.include({_spiderfied:null,unspiderfy:function(){this._unspiderfy.apply(this,arguments)},_spiderfierOnAdd:function(){this._map.on("click",this._unspiderfyWrapper,this),this._map.options.zoomAnimation&&this._map.on("zoomstart",this._unspiderfyZoomStart,this),this._map.on("zoomend",this._noanimationUnspiderfy,this),L.Browser.touch||this._map.getRenderer(this)},_spiderfierOnRemove:function(){this._map.off("click",this._unspiderfyWrapper,this),this._map.off("zoomstart",this._unspiderfyZoomStart,this),this._map.off("zoomanim",this._unspiderfyZoomAnim,this),this._map.off("zoomend",this._noanimationUnspiderfy,this),this._noanimationUnspiderfy()
	},_unspiderfyZoomStart:function(){this._map&&this._map.on("zoomanim",this._unspiderfyZoomAnim,this)},_unspiderfyZoomAnim:function(e){L.DomUtil.hasClass(this._map._mapPane,"leaflet-touching")||(this._map.off("zoomanim",this._unspiderfyZoomAnim,this),this._unspiderfy(e))},_unspiderfyWrapper:function(){this._unspiderfy()},_unspiderfy:function(e){this._spiderfied&&this._spiderfied.unspiderfy(e)},_noanimationUnspiderfy:function(){this._spiderfied&&this._spiderfied._noanimationUnspiderfy()},_unspiderfyLayer:function(e){e._spiderLeg&&(this._featureGroup.removeLayer(e),e.clusterShow&&e.clusterShow(),e.setZIndexOffset&&e.setZIndexOffset(0),this._map.removeLayer(e._spiderLeg),delete e._spiderLeg)}}),L.MarkerClusterGroup.include({refreshClusters:function(e){return e?e instanceof L.MarkerClusterGroup?e=e._topClusterLevel.getAllChildMarkers():e instanceof L.LayerGroup?e=e._layers:e instanceof L.MarkerCluster?e=e.getAllChildMarkers():e instanceof L.Marker&&(e=[e]):e=this._topClusterLevel.getAllChildMarkers(),this._flagParentsIconsNeedUpdate(e),this._refreshClustersIcons(),this.options.singleMarkerMode&&this._refreshSingleMarkerModeMarkers(e),this},_flagParentsIconsNeedUpdate:function(e){var t,i;for(t in e)for(i=e[t].__parent;i;)i._iconNeedsUpdate=!0,i=i.__parent},_refreshSingleMarkerModeMarkers:function(e){var t,i;for(t in e)i=e[t],this.hasLayer(i)&&i.setIcon(this._overrideMarkerIcon(i))}}),L.Marker.include({refreshIconOptions:function(e,t){var i=this.options.icon;return L.setOptions(i,e),this.setIcon(i),t&&this.__parent&&this.__parent._group.refreshClusters(this),this}}),e.MarkerClusterGroup=t,e.MarkerCluster=i});
	//# sourceMappingURL=leaflet.markercluster.js.map

/***/ },
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Backbone) {'use strict';
	
	__webpack_require__(415);
	
	var BaseViews = __webpack_require__(5);
	
	var TipButton = BaseViews.ItemView.extend({
	    template: __webpack_require__(441),
	    className: 'fmcy-delivery-tip-button',
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            active: false
	        });
	    },
	    triggers: function triggers() {
	        return {
	            'click': {
	                event: 'button:clicked'
	            }
	        };
	    },
	    serializeData: function serializeData() {
	        return {
	            label: this.model.get('label'),
	            value: this.model.get('value'),
	            active: this.options.active
	        };
	    }
	});
	
	var TipButtonToggle = Backbone.Marionette.CompositeView.extend({
	    className: 'fmcy-cart-delivery-tip-button-toggle',
	    template: __webpack_require__(440),
	    childView: TipButton,
	    childViewContainer: '.fmcy-tip-buttons',
	    childEvents: {
	        'button:clicked': 'onButtonClicked'
	    },
	    onButtonClicked: function onButtonClicked(event) {
	        this.trigger('tip:selected', event.model.get('value'));
	    },
	    childViewOptions: function childViewOptions(model, index) {
	        var options = _.extend({
	            modelIndex: index
	        }, this.options);
	
	        if (this.options.selectedValue == model.get('value')) {
	            options.active = true;
	        }
	
	        return options;
	    },
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {
	            toolTip: false,
	            selectedValue: null
	        });
	    },
	    serializeData: function serializeData() {
	        return {
	            options: this.options
	        };
	    }
	});
	
	module.exports = TipButtonToggle;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	__webpack_require__(418);
	var BaseViews = __webpack_require__(5);
	var Textbox = __webpack_require__(73);
	var StringUtils = __webpack_require__(9);
	var CartItemCountIncrementor = __webpack_require__(297);
	var CartItem = BaseViews.LayoutView.extend({
	  className: 'fmcy-cart-item container-fluid',
	  template: __webpack_require__(443),
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      theme: 'light'
	    });
	    this.model.on('change:cartCount', function () {
	      // check its not a number...
	      var cartCount = parseInt(self.model.get('cartCount'));
	      if (cartCount !== '') {
	        self.trigger('cart:item:qty:updated');
	      }
	    });
	  },
	  regions: {
	    itemImageRegion: '.fmcy-cart-item-image-region',
	    cartCountInputRegion: '.fmcy-cart-count-input-region'
	  },
	  ui: {
	    cartItemRemoveButton: '.fmcy-cart-item-remove-button',
	    cartItemTotalText: '.cart-item-total-text',
	    cartItemSavingsText: '.fmcy-cart-item-savings-text',
	    errorMessage: '.fmcy-cart-item-error-message',
	    itemImage: '.fmcy-cart-item-image-region',
	    itemTitle: '.fmcy-cart-item-title'
	  },
	  triggers: {
	    'click @ui.cartItemRemoveButton': 'delete:item',
	    'click @ui.itemImage': 'click:item',
	    'click @ui.itemTitle': 'click:item'
	  },
	  _updateItemTotal: function _updateItemTotal() {
	    this.ui.cartItemTotalText.html(StringUtils.currency(parseFloat(this.model.get('item_sub_total'))));
	    this.ui.cartItemSavingsText.html(this.getSavedText());
	    this.maybeShowSavingsText();
	  },
	  _renderCountIncrementor: function _renderCountIncrementor() {
	    var self = this;
	    var cartItemCountIncrementor = new CartItemCountIncrementor({
	      model: this.model
	    });
	
	    cartItemCountIncrementor.on('click:plus', function (view) {
	      var cartCount = view.model.get('cartCount');
	      cartCount += 1;
	      self.model.set('cartCount', cartCount);
	    });
	
	    cartItemCountIncrementor.on('click:minus', function (view) {
	      var cartCount = view.model.get('cartCount');
	      if (cartCount !== 0) {
	        cartCount -= 1;
	        self.model.set('cartCount', cartCount);
	      }
	    });
	
	    this.cartCountInputRegion.show(cartItemCountIncrementor);
	  },
	  _renderItemImage: function _renderItemImage() {
	    var itemImageRegion = new (__webpack_require__(65))({
	      imageURL: this.model.get('thumb_url'),
	      displayNoImageAvailableIcon: true
	    });
	
	    if (this.model.get('slug')) {
	      this.ui.itemImage.css('cursor', 'pointer');
	      this.ui.itemTitle.css('cursor', 'pointer');
	    }
	
	    this.itemImageRegion.show(itemImageRegion);
	  },
	  hideItem: function hideItem() {
	    this.$el.hide();
	  },
	  maybeShowSavingsText: function maybeShowSavingsText() {
	    if (this.model.get('group_discount_total') == 0) {
	      this.ui.cartItemSavingsText.hide();
	    } else {
	      this.ui.cartItemSavingsText.show();
	    }
	  },
	  onRender: function onRender() {
	    this._renderItemImage();
	    this._renderCountIncrementor();
	    this.maybeShowSavingsText();
	    if (this.options.errors !== null && this.options.errors.length > 0 && this.model.get('error') === true) {
	      var message;
	
	      if (parseInt(this.model.get('actualCount')) == 0) {
	        message = 'Out of stock, please remove.';
	      } else if (parseInt(this.model.get('actualCount')) < parseInt(this.model.get('cartCount'))) {
	        message = 'Only ' + parseInt(this.model.get('actualCount')) + ' available';
	      } else {
	        message = 'Problem, please remove.';
	      }
	
	      this.$el.addClass('fmcy-cart-item-error');
	      this.ui.errorMessage.html(message);
	    }
	  },
	  getSavedText: function getSavedText() {
	    return '- ' + StringUtils.currency(parseFloat(this.model.get('group_discount_total')));
	  },
	  onDestroy: function onDestroy() {
	    this.model.off('change:cartCount');
	  },
	  serializeData: function serializeData() {
	    return {
	      savedText: this.getSavedText(),
	      cartItemTitle: this.model.get('title'),
	      cartItemQuantityWeight: this.model.get('quantity'),
	      cartItemPrice: StringUtils.currency(this.model.getPrice()),
	      itemTotal: StringUtils.currency(parseFloat(this.model.get('item_sub_total'))),
	      cartCount: this.model.get('cartCount')
	    };
	  }
	});
	
	module.exports = CartItem;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {'use strict';
	
	__webpack_require__(421);
	var Obscura = __webpack_require__(103);
	var View = Backbone.Marionette.CompositeView.extend({
	  template: __webpack_require__(446),
	  className: 'fmcy-category-text-menu-list',
	  childView: __webpack_require__(300),
	  childViewContainer: '.fmcy-category-sub-categories',
	  childViewOptions: function childViewOptions(model, index) {
	    return {
	      category: this.model,
	      collection: this.collection,
	      appChannel: this.options.appChannel
	    };
	  },
	  childEvents: {
	    'subcat:clicked': 'onChildSubcatClicked'
	  },
	  ui: {
	    categoryHeader: '.fmcy-category-header'
	  },
	  events: {
	    'click @ui.categoryHeader': 'headerClicked'
	  },
	  serializeData: function serializeData() {
	    return {
	      category: this.model.toJSON()
	    };
	  },
	  initialize: function initialize() {
	    var self = this;
	
	    var orderedCollection = new Backbone.Collection();
	    var subCatCollection = new Obscura(this.options.categories);
	
	    // first level sub category
	    subCatCollection.filterBy('parent_id', function (subModel) {
	      if (subModel.get('parent_id') === self.model.get('id')) {
	        subModel.set('level', 1);
	        return true;
	      } else {
	        return false;
	      }
	    }).setSort('ordinal', 'asc');
	
	    subCatCollection.each(function (model, index) {
	      orderedCollection.add(model);
	      // only supports one level deep...
	      self.collection.each(function (childmodel) {
	        if (childmodel.get('parent_id') !== null && childmodel.get('parent_id') == model.get('id')) {
	          childmodel.set('level', 2);
	          orderedCollection.add(childmodel);
	        }
	      });
	    });
	
	    var orderedCollectionObscura = new Obscura(orderedCollection);
	    orderedCollectionObscura.setSort('ordinal', 'asc');
	
	    this.collection = orderedCollectionObscura;
	  },
	  onChildSubcatClicked: function onChildSubcatClicked(childView) {
	    this.trigger('category:clicked', childView.model);
	  },
	  headerClicked: function headerClicked() {
	    this.trigger('category:clicked', this.model);
	  },
	  getHeight: function getHeight() {
	    return this.$el.height();
	  }
	});
	
	module.exports = View;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette, _) {'use strict';
	
	var SearchFiltersItem = __webpack_require__(301);
	var SearchFilterTabs = Marionette.CollectionView.extend({
	    className: 'fmcy-search-filter-tabs clearfix',
	    childView: SearchFiltersItem,
	    childEvents: {
	        'filter:clicked': 'onFilterClicked'
	    },
	    onBeforeShow: function onBeforeShow() {
	        var self = this;
	        this.collection.each(function (model) {
	            if (self.options.initialFilter && self.options.initialFilter == model.get('slug')) {
	                var view = self.children.findByModel(model);
	                if (view) {
	                    view.setActive();
	                }
	            }
	        });
	    },
	    onFilterClicked: function onFilterClicked(childView) {
	        var self = this;
	
	        this.collection.each(function (model) {
	            var view = self.children.findByModel(model);
	            if (view) {
	                view.reset();
	            }
	        });
	        if (childView) {
	            childView.setActive();
	        }
	        this.trigger('filter:clicked', childView.model);
	    },
	    setFilterActive: function setFilterActive(model) {
	        var self = this;
	
	        this.collection.each(function (model) {
	            var view = self.children.findByModel(model);
	            if (view) {
	                view.reset();
	            }
	        });
	
	        var childView = self.children.findByModel(model);
	        if (!childView) {
	            var selectedModel = this.collection.findWhere({
	                name: model.get('name')
	            });
	            childView = self.children.findByModel(selectedModel);
	        }
	        if (childView) {
	            childView.setActive();
	        }
	    },
	    childViewOptions: function childViewOptions(model, index) {
	        return {
	            childIndex: index,
	            totalItems: this.collection.length
	        };
	    },
	    buildChildView: function buildChildView(child, ChildViewClass, childViewOptions) {
	        this.options.childIndex = childViewOptions.childIndex;
	        this.options.totalItems = childViewOptions.totalItems;
	
	        var options = _.extend({ model: child }, this.options);
	        return new SearchFiltersItem(options);
	    }
	});
	
	module.exports = SearchFilterTabs;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15), __webpack_require__(1)))

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	var SearchOptionsItem = BaseViews.ItemView.extend({
	    tagName: 'option',
	    className: 'fmcy-search-options-item',
	    template: __webpack_require__(447),
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {});
	    },
	    serializeData: function serializeData() {
	        return {
	            option: this.model.get('option')
	        };
	    },
	    onRender: function onRender() {
	        this.$el.attr('id', this.model.get('id'));
	    }
	});
	module.exports = SearchOptionsItem;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Backbone) {'use strict';
	
	__webpack_require__(422);
	var BaseViews = __webpack_require__(5);
	var SpinnerButton = __webpack_require__(19);
	
	var OrderItem = BaseViews.LayoutView.extend({
	  className: 'fmcy-order-item',
	  template: __webpack_require__(448),
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      extraClassName: null
	    });
	  },
	  regions: {
	    editBtnRegion: '.fmcy-order-item-btn-edit-region',
	    changeBtnRegion: '.fmcy-order-item-btn-change-region',
	    cancelBtnRegion: '.fmcy-order-item-btn-cancel-region'
	  },
	  ui: {
	    orderItem: '.fmcy-order-item-code'
	  },
	  events: {
	    'click @ui.orderItem': '_orderItemClicked'
	  },
	  _renderPayButton: function _renderPayButton() {
	    var self = this;
	    this._payBtn = new SpinnerButton.SpinnerButton({
	      label: 'PAY NOW',
	      enabled: true,
	      theme: SpinnerButton.THEMES.PRIMARY,
	      size: SpinnerButton.SIZES.SMALL,
	      onClickedCallback: function onClickedCallback() {
	        self._payBtn.toggleSpinner(true);
	        self._payBtn.toggledEnabledState(false);
	        self.options._appChannel.trigger('cart:view');
	      }
	    });
	
	    this.editBtnRegion.show(this._payBtn);
	  },
	  _renderEditButton: function _renderEditButton() {
	    var self = this;
	    this._editBtn = new SpinnerButton.SpinnerButton({
	      label: 'EDIT',
	      enabled: true,
	      theme: SpinnerButton.THEMES.PRIMARY,
	      size: SpinnerButton.SIZES.SMALL,
	      onClickedCallback: function onClickedCallback() {
	        self._renderEditBar();
	      }
	    });
	
	    this.editBtnRegion.show(this._editBtn);
	  },
	  _renderEditBar: function _renderEditBar() {
	    this.$el.addClass('fmcy-editing-order-item');
	    //this._renderChangeButton();
	    this._renderCancelButton();
	  },
	  _renderCancelButton: function _renderCancelButton() {
	    self = this;
	    this._cancelBtn = new SpinnerButton.SpinnerButton({
	      label: 'CANCEL ORDER',
	      enabled: true,
	      theme: SpinnerButton.THEMES.PRIMARY,
	      size: SpinnerButton.SIZES.SMALL,
	      onClickedCallback: function onClickedCallback() {
	        self._cancelBtn.toggleSpinner(true);
	        self._cancelBtn.toggledEnabledState(false);
	        self.options._appChannel.request('order:cancel', self.model).then(function (response) {
	          self.model.set('order_status', 'customer_cancelled');
	          self.$el.removeClass('fmcy-editing-order-item');
	          self.render();
	          Backbone.Radio.channel('global').trigger('order:updated', self.model);
	          self.options._appChannel.trigger('orders:updated');
	        }).always(function () {
	          self._cancelBtn.toggleSpinner(false);
	          self._cancelBtn.toggledEnabledState(true);
	        });
	      }
	    });
	
	    this.cancelBtnRegion.show(this._cancelBtn);
	  },
	  _renderChangeButton: function _renderChangeButton() {
	    this._changeBtn = new SpinnerButton.SpinnerButton({
	      label: 'CHANGE ORDER',
	      enabled: true,
	      theme: SpinnerButton.THEMES.PRIMARY,
	      size: SpinnerButton.SIZES.SMALL,
	      onClickedCallback: function onClickedCallback() {
	        // do something
	      }
	    });
	
	    this.changeBtnRegion.show(this._changeBtn);
	  },
	  _isPayable: function _isPayable() {
	    switch (this.model.get('order_status')) {
	      case 'pre_payment':
	        return true;
	        break;
	      default:
	        return false;
	        break;
	    }
	  },
	  _isEditable: function _isEditable() {
	    switch (this.model.get('order_status')) {
	      case 'ready':
	        if (this.model.get('order_payment_status')) {
	          return false;
	        } else {
	          return true;
	        }
	        break;
	      case 'pre_payment':
	      case 'processing':
	      case 'created':
	        return true;
	        break;
	      default:
	        return false;
	        break;
	    }
	  },
	  _isClickable: function _isClickable() {
	    switch (this.model.get('order_status')) {
	      case 'pre_payment':
	        return false;
	        break;
	      default:
	        return true;
	        break;
	    }
	  },
	  _orderItemClicked: function _orderItemClicked() {
	    if (this._isClickable()) {
	      this.options._appChannel.trigger('menu:overlay:view:close');
	    }
	  },
	  _gotoOrderDetailsLink: function _gotoOrderDetailsLink() {
	    var rootUrl = window.location.protocol + '//' + window.location.hostname;
	    return rootUrl + '/my-account/#order/' + this.model.get('order_unique_id');
	  },
	  onRender: function onRender() {
	    if (this.options.extraClassName) {
	      this.$el.addClass(this.options.extraClassName);
	    }
	    this.$el.addClass('fmcy-order-status-' + this.model.get('order_status'));
	
	    if (this._isPayable() == true) {
	      this._renderPayButton();
	    } else {
	      if (this._isEditable() == true) {
	        this._renderEditButton();
	      }
	    }
	  },
	  serializeData: function serializeData() {
	    var notificationMessage = '';
	    switch (this.model.get('order_status')) {
	      case 'ready':
	        if (this.model.get('order_delivery_method') == 'pickup') {
	          notificationMessage = 'Order ' + this.model.get('order_code') + ' is ready for pickup!';
	        } else {
	          notificationMessage = 'Order ' + this.model.get('order_code') + ' is packed up!';
	        }
	        break;
	      case 'cancelled':
	      case 'customer_cancelled':
	        notificationMessage = 'Order ' + this.model.get('order_code') + ' cancelled.';
	        break;
	      case 'completed':
	        notificationMessage = 'Order ' + this.model.get('order_code') + ' completed.';
	        break;
	      case 'pre_payment':
	        notificationMessage = 'Order payment pending.';
	        break;
	      case 'refunded':
	        notificationMessage = 'Order ' + this.model.get('order_code') + ' refunded.';
	        break;
	      default:
	        notificationMessage = 'Order processing.';
	        break;
	    }
	    return {
	      order_details_url: this._gotoOrderDetailsLink(),
	      is_clickable: this._isClickable(),
	      order_unique_id: this.model.get('order_unique_id'),
	      order_code: this.model.get('order_code'),
	      order_status: this.model.get('order_status'),
	      notification_message: notificationMessage
	    };
	  }
	});
	
	module.exports = OrderItem;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	__webpack_require__(423);
	var BaseViews = __webpack_require__(5);
	var VideoItem = BaseViews.LayoutView.extend({
	    className: 'fmcy-video-item',
	    template: __webpack_require__(449),
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            videoStyle: 'thumb',
	            extraClassName: null
	        });
	    },
	    ui: {
	        videoImage: '.fmcy-video-item-image'
	    },
	    events: {
	        'click': 'onClick'
	    },
	    onClick: function onClick() {
	        this.trigger('thumb:clicked');
	    },
	    onRender: function onRender() {
	        if (this.options.extraClassName) {
	            this.$el.addClass(this.options.extraClassName);
	        }
	        var imageURL = this.model.get('image_medium_url');
	
	        this.ui.videoImage.css('background-image', 'url(' + imageURL + ')');
	    },
	    serializeData: function serializeData() {
	        return {
	            videoStyle: this.options.videoStyle,
	            description: this.model.get('description'),
	            name: this.model.get('name')
	        };
	    }
	});
	
	module.exports = VideoItem;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-tip-buttons {\n  display: flex !important; }\n  .fmcy-tip-buttons .fmcy-delivery-tip-button {\n    flex-grow: 1;\n    padding-right: 5px; }\n    .fmcy-tip-buttons .fmcy-delivery-tip-button .btn {\n      min-height: 40px;\n      padding-top: 10px;\n      background-color: #666 !important;\n      border-color: #666 !important; }\n      .fmcy-tip-buttons .fmcy-delivery-tip-button .btn.active {\n        background-color: #333 !important;\n        border-color: #333 !important; }\n", ""]);
	
	// exports


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-cart-error-message {\n  margin: 0px 10px 10px 10px; }\n  .fmcy-cart-error-message .fmcy-cart-error-message-inner {\n    text-align: left;\n    color: #a94442;\n    background-color: #f2dede;\n    font-size: 100%;\n    font-weight: 700;\n    padding: 10px 10px;\n    border: 1px solid transparent;\n    border-radius: 4px;\n    font-family: 'droid_serif' !important; }\n", ""]);
	
	// exports


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-cart-item {\n  font-family: \"bebasneue\", \"Arial\", sans-serif;\n  font-weight: normal;\n  font-style: normal;\n  font-size: 110%;\n  text-transform: none;\n  -webkit-font-smoothing: antialiased;\n  line-height: 100%;\n  border-bottom: 1px #000 solid;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  background-color: #1f1e1e;\n  position: relative; }\n  .fmcy-cart-item .row.no-gutters {\n    margin-right: 0;\n    margin-left: 0; }\n    .fmcy-cart-item .row.no-gutters > [class^=\"col-\"],\n    .fmcy-cart-item .row.no-gutters > [class*=\" col-\"] {\n      padding-right: 0;\n      padding-left: 0; }\n  .fmcy-cart-item .fmcy-cart-item-error-message {\n    display: none; }\n  .fmcy-cart-item.fmcy-cart-item-error {\n    background-color: #f2dede; }\n    .fmcy-cart-item.fmcy-cart-item-error .fmcy-cart-item-error-message {\n      display: block;\n      color: #ffffff;\n      background-color: #a94442;\n      line-height: 20px;\n      border-radius: 5px;\n      width: 80%;\n      padding: 2px;\n      margin-bottom: 5px;\n      margin-top: 5px;\n      text-align: center; }\n    .fmcy-cart-item.fmcy-cart-item-error .fmcy-cart-item-title,\n    .fmcy-cart-item.fmcy-cart-item-error .fmcy-cart-item-quantity-weight,\n    .fmcy-cart-item.fmcy-cart-item-error .fmcy-cart-item-count-incrementor-count,\n    .fmcy-cart-item.fmcy-cart-item-error .cart-item-total {\n      color: #333; }\n  .fmcy-cart-item .fmcy-cart-item-remove-button {\n    cursor: pointer;\n    background-image: url(" + escape(__webpack_require__(189)) + ");\n    background-repeat: no-repeat;\n    background-position: top right;\n    background-size: cover;\n    width: 16px;\n    height: 16px;\n    z-index: 1000;\n    left: 5px;\n    top: 5px;\n    opacity: 1;\n    position: absolute; }\n  .fmcy-cart-item .fmcy-cart-item-info-wrapper {\n    position: relative; }\n  .fmcy-cart-item .fmcy-cart-item-qty-sub-total {\n    position: relative; }\n    .fmcy-cart-item .fmcy-cart-item-qty-sub-total .fmcy-cart-item-savings {\n      position: absolute;\n      right: 10px;\n      bottom: 28px; }\n      @media only screen and (min-width: 400px) {\n        .fmcy-cart-item .fmcy-cart-item-qty-sub-total .fmcy-cart-item-savings {\n          right: 20px; } }\n      .fmcy-cart-item .fmcy-cart-item-qty-sub-total .fmcy-cart-item-savings .fmcy-cart-item-savings-text {\n        background-color: #93743f;\n        border-radius: 5px;\n        color: white;\n        padding-right: 5px;\n        padding-left: 5px; }\n  .fmcy-cart-item .fmcy-cart-item-title {\n    color: #ffffff;\n    font-size: 140%;\n    line-height: 100%; }\n  .fmcy-cart-item .fmcy-cart-count-input-region {\n    display: inline-block; }\n  .fmcy-cart-item .fmcy-cart-count-label {\n    display: inline-block; }\n  .fmcy-cart-item .fmcy-cart-item-input-textbox {\n    max-width: 50px; }\n  .fmcy-cart-item .fmcy-cart-item-quantity-weight {\n    padding-bottom: 10px;\n    font-size: 110%;\n    line-height: 120%;\n    letter-spacing: 1px;\n    font-weight: bold;\n    font-family: avril;\n    color: #fff; }\n  .fmcy-cart-item .fmcy-cart-price {\n    text-transform: uppercase;\n    font-family: 'avril', 'Arial', sans-serif;\n    font-weight: bold; }\n  .fmcy-cart-item .fmcy-cart-item-image-region {\n    padding-top: 6px; }\n    .fmcy-cart-item .fmcy-cart-item-image-region .fmcy-image {\n      height: 100px;\n      height: 65px;\n      width: 65px;\n      border: #000000 solid 1px;\n      background-size: cover; }\n  .fmcy-cart-item .fmcy-cart-item-image {\n    padding-left: 5px; }\n  .fmcy-cart-item .cart-item-total {\n    line-height: 34px;\n    color: #fff;\n    text-align: right; }\n    .fmcy-cart-item .cart-item-total .cart-item-total-text {\n      padding-right: 10px; }\n      @media only screen and (min-width: 400px) {\n        .fmcy-cart-item .cart-item-total .cart-item-total-text {\n          padding-right: 20px; } }\n", ""]);
	
	// exports


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-shopping-cart-indicator {\n  line-height: 70px; }\n  .fmcy-shopping-cart-indicator .fmcy-shopping-cart-indicator-icon {\n    display: block;\n    position: relative;\n    cursor: pointer;\n    background: url(" + escape(__webpack_require__(396)) + ");\n    background: url(" + escape(__webpack_require__(397)) + "), linear-gradient(transparent, transparent);\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: contain;\n    width: 24px;\n    height: 22px; }\n    .fmcy-shopping-cart-indicator .fmcy-shopping-cart-indicator-icon .fmcy-shopping-cart-indicator-count {\n      text-indent: 0;\n      display: block;\n      width: 20px;\n      height: 20px;\n      line-height: 1.74;\n      box-sizing: content-box;\n      font-size: 12px;\n      position: absolute;\n      top: -10px;\n      left: 11px;\n      border-radius: 100%;\n      border: 2px solid #000;\n      background-color: #0fb1b5;\n      color: #fff;\n      text-align: center;\n      font-family: \"bebasneue\", \"Arial\", sans-serif; }\n  .fmcy-shopping-cart-indicator .fmcy-shopping-cart-indicator-expanded .fmcy-shopping-cart-indicator-count {\n    display: inline-block;\n    font-size: 30px;\n    color: #0fb1b5;\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    vertical-align: middle;\n    padding-left: 5px; }\n  .fmcy-shopping-cart-indicator .fmcy-shopping-cart-indicator-expanded .fmcy-shopping-cart-indicator-pick-up-location {\n    display: inline-block;\n    color: #fff;\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    vertical-align: middle;\n    max-width: 100px;\n    font-size: 14px;\n    line-height: 14px;\n    text-align: left;\n    padding-left: 5px; }\n  @media only screen and (min-width: 400px) {\n    .fmcy-shopping-cart-indicator .fmcy-shopping-cart-indicator-expanded .fmcy-shopping-cart-indicator-count {\n      padding-left: 0px; } }\n  @media only screen and (min-width: 981px) {\n    .fmcy-shopping-cart-indicator .fmcy-shopping-cart-indicator-expanded .fmcy-shopping-cart-indicator-count {\n      font-size: 34px; }\n    .fmcy-shopping-cart-indicator .fmcy-shopping-cart-indicator-expanded .fmcy-shopping-cart-indicator-pick-up-location {\n      max-width: 140px;\n      font-size: 18px;\n      line-height: 18px;\n      padding-left: 10px; } }\n\n@media only screen and (max-width: 1100px) {\n  .fmcy-shopping-cart-indicator .fmcy-shopping-cart-indicator-icon {\n    height: 33px; } }\n", ""]);
	
	// exports


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-locations-map {\n  position: relative;\n  background: #181919; }\n  .fmcy-locations-map .fmcy-locations-map-target {\n    background: #181919; }\n  .fmcy-locations-map .leaflet-container a.leaflet-popup-close-button {\n    color: #fff !important; }\n  .fmcy-locations-map .fmcy-locations-map-close-btn {\n    cursor: pointer;\n    background-image: url(" + escape(__webpack_require__(398)) + ");\n    background-repeat: no-repeat;\n    background-position: top right;\n    background-size: cover;\n    width: 32px;\n    height: 32px;\n    z-index: 1000;\n    position: absolute;\n    right: 10px;\n    top: 91px;\n    opacity: 1; }\n  .fmcy-locations-map .map-marker-farmacy {\n    background-image: url(" + escape(__webpack_require__(400)) + ");\n    background-repeat: no-repeat;\n    width: 50px;\n    height: 50px; }\n  .fmcy-locations-map .leaflet-control-zoom a {\n    color: #fff !important;\n    background-color: #000; }\n  .fmcy-locations-map .leaflet-bar a, .fmcy-locations-map .leaflet-bar a:hover {\n    border-bottom: 1px solid #333333;\n    width: 33px;\n    height: 33px;\n    line-height: 31px;\n    text-decoration: none; }\n  .fmcy-locations-map .leaflet-control-attribution {\n    display: none; }\n  .fmcy-locations-map .map-marker-farmacy-user-location {\n    background-image: url(" + escape(__webpack_require__(401)) + ");\n    background-repeat: no-repeat;\n    width: 50px;\n    height: 50px; }\n  .fmcy-locations-map .map-marker-farmacy-delivery-location {\n    background-image: url(" + escape(__webpack_require__(399)) + ");\n    background-repeat: no-repeat;\n    width: 50px;\n    height: 50px; }\n  .fmcy-locations-map .leaflet-tooltip {\n    background: none;\n    border: none;\n    box-shadow: none;\n    line-height: 1.5em; }\n    .fmcy-locations-map .leaflet-tooltip .map-marker-farmacy-tooltip {\n      text-align: center; }\n      .fmcy-locations-map .leaflet-tooltip .map-marker-farmacy-tooltip .map-marker-farmacy-tooltip-subtitle {\n        color: #fff;\n        font-family: \"bebasneue\", \"Arial\", sans-serif;\n        font-size: 125%;\n        text-shadow: 1px 1px #333333; }\n      .fmcy-locations-map .leaflet-tooltip .map-marker-farmacy-tooltip .map-marker-farmacy-tooltip-title {\n        font-size: 175%;\n        color: #7e6b3a;\n        font-family: \"bebasneue\", \"Arial\", sans-serif;\n        text-shadow: 1px 1px #333333; }\n  .fmcy-locations-map .leaflet-tooltip-bottom:before {\n    border: 0; }\n  .fmcy-locations-map .leaflet-popup-content-wrapper, .fmcy-locations-map .leaflet-popup-tip {\n    background: #000;\n    color: #fff;\n    box-shadow: 0 3px 14px rgba(0, 0, 0, 0.4);\n    border-radius: 0;\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 175%;\n    text-align: center;\n    max-width: 218px; }\n    .fmcy-locations-map .leaflet-popup-content-wrapper .img-responsive, .fmcy-locations-map .leaflet-popup-tip .img-responsive {\n      width: 178px; }\n", ""]);
	
	// exports


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-category-text-menu-list {\n  position: absolute;\n  letter-spacing: 1px; }\n  .fmcy-category-text-menu-list .fmcy-category-header {\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 16px;\n    border-bottom: 1px solid;\n    margin-top: 10px;\n    margin-bottom: 5px;\n    cursor: pointer; }\n  .fmcy-category-text-menu-list .fmcy-sub-category-item {\n    cursor: pointer; }\n", ""]);
	
	// exports


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-order-item {\n  display: flex;\n  padding-top: 15px;\n  padding-bottom: 15px;\n  background-color: #1f1e1e;\n  position: relative;\n  border-bottom: solid 1px #000; }\n  .fmcy-order-item .btn-primary {\n    background-color: #0fb1b5;\n    border-color: #0fb1b5; }\n  .fmcy-order-item.fmcy-editing-order-item {\n    height: 100px; }\n  .fmcy-order-item .fmcy-order-item-btn-edit-region {\n    position: absolute;\n    right: 10px;\n    top: 5px; }\n  .fmcy-order-item .fmcy-order-item-edit-bar {\n    position: absolute;\n    top: 50px;\n    left: 50px; }\n    .fmcy-order-item .fmcy-order-item-edit-bar .fmcy-order-item-btn-cancel-region .btn-primary {\n      background-color: #6a0c11;\n      border-color: #6a0c11; }\n  .fmcy-order-item.fmcy-order-status-ready {\n    background-color: #0fb1b5; }\n  .fmcy-order-item.fmcy-order-status-cancelled {\n    background-color: #000; }\n  .fmcy-order-item.fmcy-order-status-customer_cancelled {\n    background-color: #000; }\n  .fmcy-order-item .fmcy-order-item-inner {\n    border: none;\n    display: flex;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n    align-content: stretch;\n    align-items: stretch;\n    padding-left: 35px; }\n    @media only screen and (max-width: 411px) {\n      .fmcy-order-item .fmcy-order-item-inner {\n        padding-left: 10px; } }\n    .fmcy-order-item .fmcy-order-item-inner .fmcy-order-item-row {\n      order: 0;\n      flex: 0 1 auto;\n      align-self: auto; }\n    .fmcy-order-item .fmcy-order-item-inner .fmcy-order-item-code {\n      text-align: left;\n      font-family: \"bebasneue\", \"Arial\", sans-serif;\n      font-size: 20px;\n      line-height: 12px;\n      color: #fff;\n      font-weight: normal;\n      font-style: normal;\n      text-transform: none;\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n      speak: none; }\n      .fmcy-order-item .fmcy-order-item-inner .fmcy-order-item-code a {\n        color: #fff !important; }\n        .fmcy-order-item .fmcy-order-item-inner .fmcy-order-item-code a:hover {\n          text-decoration: none;\n          color: #fff !important; }\n        .fmcy-order-item .fmcy-order-item-inner .fmcy-order-item-code a:active {\n          text-decoration: none; }\n", ""]);
	
	// exports


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-video-item {\n  display: flex;\n  padding: 10px;\n  padding-bottom: 30px;\n  font-size: 3vw;\n  line-height: 3vw; }\n  @media only screen and (min-width: 991px) {\n    .fmcy-video-item {\n      font-size: 1vw;\n      line-height: 1vw; } }\n  .fmcy-video-item .fmcy-video-item-inner {\n    cursor: pointer;\n    position: relative;\n    width: 100%; }\n  .fmcy-video-item .fmcy-video-item-image-wrapper {\n    position: relative; }\n  .fmcy-video-item .fmcy-video-play-button {\n    position: absolute;\n    background-image: url(" + escape(__webpack_require__(402)) + ");\n    width: 80px;\n    height: 80px;\n    background-size: cover;\n    top: 50%;\n    left: 50%;\n    margin-left: -40px;\n    margin-top: -40px; }\n  .fmcy-video-item .fmcy-video-item-inner {\n    border: none;\n    display: flex;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n    align-content: stretch;\n    align-items: stretch; }\n    .fmcy-video-item .fmcy-video-item-inner .fmcy-video-item-row {\n      order: 0;\n      flex: 0 1 auto;\n      align-self: auto; }\n    .fmcy-video-item .fmcy-video-item-inner .fmcy-video-item-image {\n      background-size: contain;\n      background-repeat: no-repeat;\n      background-position: center; }\n  .fmcy-video-item .fmcy-video-item-title {\n    text-align: center;\n    padding-top: 10px;\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 2em;\n    line-height: 1.2em;\n    color: #fff;\n    font-weight: normal;\n    font-style: normal;\n    text-transform: none;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    speak: none; }\n  .fmcy-video-item .fmcy-video-item-description {\n    text-align: left;\n    color: #fff;\n    font-size: 1.2em;\n    line-height: 2em;\n    padding-top: 10px;\n    padding-bottom: 20px; }\n", ""]);
	
	// exports


/***/ },
/* 391 */,
/* 392 */,
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".leaflet-cluster-anim .leaflet-marker-icon, .leaflet-cluster-anim .leaflet-marker-shadow {\n  -webkit-transition: -webkit-transform 0.3s ease-out, opacity 0.3s ease-in;\n  -moz-transition: -moz-transform 0.3s ease-out, opacity 0.3s ease-in;\n  -o-transition: -o-transform 0.3s ease-out, opacity 0.3s ease-in;\n  transition: transform 0.3s ease-out, opacity 0.3s ease-in; }\n\n.leaflet-cluster-spider-leg {\n  /* stroke-dashoffset (duration and function) should match with leaflet-marker-icon transform in order to track it exactly */\n  -webkit-transition: -webkit-stroke-dashoffset 0.3s ease-out, -webkit-stroke-opacity 0.3s ease-in;\n  -moz-transition: -moz-stroke-dashoffset 0.3s ease-out, -moz-stroke-opacity 0.3s ease-in;\n  -o-transition: -o-stroke-dashoffset 0.3s ease-out, -o-stroke-opacity 0.3s ease-in;\n  transition: stroke-dashoffset 0.3s ease-out, stroke-opacity 0.3s ease-in; }\n", ""]);
	
	// exports


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".marker-cluster-small {\n  background-color: rgba(130, 109, 63, 0.6); }\n\n.marker-cluster-small div {\n  background-color: rgba(126, 107, 58, 0.6); }\n\n.marker-cluster-medium {\n  background-color: rgba(130, 109, 63, 0.6); }\n\n.marker-cluster-medium div {\n  background-color: rgba(126, 107, 58, 0.6); }\n\n.marker-cluster-large {\n  background-color: rgba(130, 109, 63, 0.6); }\n\n.marker-cluster-large div {\n  background-color: rgba(126, 107, 58, 0.6); }\n\n/* IE 6-8 fallback colors */\n.leaflet-oldie .marker-cluster-small {\n  background-color: #b5e28c; }\n\n.leaflet-oldie .marker-cluster-small div {\n  background-color: #6ecc39; }\n\n.leaflet-oldie .marker-cluster-medium {\n  background-color: #f1d357; }\n\n.leaflet-oldie .marker-cluster-medium div {\n  background-color: #f0c20c; }\n\n.leaflet-oldie .marker-cluster-large {\n  background-color: #fd9c73; }\n\n.leaflet-oldie .marker-cluster-large div {\n  background-color: #f18017; }\n\n.marker-cluster {\n  background-clip: padding-box;\n  border-radius: 20px; }\n\n.marker-cluster div {\n  width: 30px;\n  height: 30px;\n  margin-left: 5px;\n  margin-top: 5px;\n  text-align: center;\n  border-radius: 15px;\n  font: 12px \"Avril\", Arial, Helvetica, sans-serif;\n  color: #fff; }\n\n.marker-cluster span {\n  line-height: 30px; }\n", ""]);
	
	// exports


/***/ },
/* 395 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/card-interac-md-529271d7a0b60842ada6148e2deb6e6d.png";

/***/ },
/* 396 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/bag-icon-dcfc1eae6884dc8208184fcebbec1816.png";

/***/ },
/* 397 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/bag-icon-f70ad0a099f33f45b0ed1735580ff575.svg";

/***/ },
/* 398 */
189,
/* 399 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/map-marker-delivery-location-d63946b0bb8de364b11f4e922c6c70a3.png";

/***/ },
/* 400 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/map-marker-farmacy-4dbfd04df81a5d2ba56207a750955b4e.png";

/***/ },
/* 401 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/map-marker-user-location-908a052e0642ffba3bf090ba18fe4f88.png";

/***/ },
/* 402 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/video-play-button-f85509f3f5412ae80265d64dda187dc4.png";

/***/ },
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(383);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-delivery-tip-button-toggle.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-delivery-tip-button-toggle.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(526);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./sprites.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./sprites.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(384);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-error-message.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-error-message.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(385);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-item.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-item.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(386);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./shopping-cart-indicator.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./shopping-cart-indicator.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(387);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./locations-map.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./locations-map.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(388);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./category.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./category.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(389);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./order-item.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./order-item.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(390);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./video-item.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./video-item.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(393);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./MarkerCluster.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./MarkerCluster.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(394);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./MarkerCluster.default.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./MarkerCluster.default.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-tip-buttons btn-group" data-toggle="buttons"></div>';
	}
	return __p;
	};


/***/ },
/* 441 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<label class="btn btn-primary btn-block ';
	 if (active) {
	__p+='active';
	}
	__p+='">\n	<input type="radio" name="options" id="'+
	((__t=(value))==null?'':__t)+
	'" checked hidden> '+
	((__t=(label))==null?'':__t)+
	'\n</label>';
	}
	return __p;
	};


/***/ },
/* 442 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-cart-error-message-inner">\n  '+
	((__t=( message ))==null?'':__t)+
	'\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 443 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-cart-item-remove-button"></div>\n<div class="fmy-cart-item-wrapper row no-gutters">\n  <div class="col-xs-4">\n    <div class="fmcy-cart-item-image">\n      <div class="fmcy-cart-item-image-region"></div>\n    </div>\n  </div>\n  <div class="col-xs-8 fmcy-cart-item-info-wrapper">\n    <div class="fmcy-cart-item-title">'+
	((__t=( cartItemTitle ))==null?'':__t)+
	'</div>\n    <div class="fmcy-cart-item-quantity-weight">'+
	((__t=( cartItemQuantityWeight ))==null?'':__t)+
	' - <span class="fmcy-cart-price">'+
	((__t=( cartItemPrice ))==null?'':__t)+
	'</span></div>\n    <div class="container-fluid fmcy-cart-item-qty-sub-total">\n      <div class="row">\n        <div class="col-xs-6">\n          <div class="fmcy-cart-count-input-region"></div>\n        </div>\n        <div class="col-xs-6 cart-item-total">Total: <span class="cart-item-total-text">'+
	((__t=( itemTotal ))==null?'':__t)+
	'</span></div>\n      </div>\n      <div class="fmcy-cart-item-savings">\n        <div class="fmcy-cart-item-savings-text">\n          '+
	((__t=( savedText ))==null?'':__t)+
	'\n        </div>\n      </div>\n    </div>\n    <div class="fmcy-cart-item-error-message"></div>\n  </div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 444 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	 if (style == 'icon') { 
	__p+='\n<div class="fmcy-shopping-cart-indicator-icon" title="View your shopping cart">\n  <span class="fmcy-shopping-cart-indicator-count">0</span>\n</div>\n';
	 } else { 
	__p+='\n<div class="fmcy-shopping-cart-indicator-expanded">\n  <span class="fmcy-shopping-cart-indicator-count">0</span>\n  <span class="fmcy-shopping-cart-indicator-pick-up-location">Items for '+
	((__t=( locationName ))==null?'':__t)+
	' pick-up</span>\n</div>\n';
	 } 
	__p+='\n';
	}
	return __p;
	};


/***/ },
/* 445 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-locations-map-close-btn"></div>\n<div class="fmcy-locations-map-target"></div>\n';
	}
	return __p;
	};


/***/ },
/* 446 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-category-header">\n    <div class="fmcy-category-name">'+
	((__t=( category.name ))==null?'':__t)+
	'</div>\n</div>\n<div class="fmcy-category-sub-categories"></div>\n';
	}
	return __p;
	};


/***/ },
/* 447 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+=''+
	((__t=( option ))==null?'':__t)+
	'';
	}
	return __p;
	};


/***/ },
/* 448 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-order-item-inner">\n  <div class="fmcy-order-item-code">\n    ';
	 if (is_clickable == true) { 
	__p+='\n      <a href="'+
	((__t=(order_details_url))==null?'':__t)+
	'">'+
	((__t=( notification_message ))==null?'':__t)+
	'</a>\n    ';
	 } else { 
	__p+='\n      '+
	((__t=( notification_message ))==null?'':__t)+
	'\n    ';
	 } 
	__p+='\n  </div>\n</div>\n<div class="fmcy-order-item-edit-bar">\n  <div class="fmcy-order-item-btn-change-region"></div>\n  <div class="fmcy-order-item-btn-cancel-region"></div>\n</div>\n<div class="fmcy-order-item-btn-edit-region"></div>\n';
	}
	return __p;
	};


/***/ },
/* 449 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-video-item-inner">\n  ';
	 if (videoStyle === 'thumb') { 
	__p+='\n    <div class="fmcy-video-item-image-wrapper">\n      <div class="fmcy-video-item-image fmcy-video-item-image-thumb fmcy-video-item-image-region"></div>\n      <div class="fmcy-video-play-button"></div>\n    </div>\n    <div class="fmcy-video-item-title">'+
	((__t=( name ))==null?'':__t)+
	'</div>\n    <div class="fmcy-video-item-description">'+
	((__t=( description ))==null?'':__t)+
	'</div>\n  ';
	 } else { 
	__p+='\n    <div class="fmcy-video-item-title">'+
	((__t=( name ))==null?'':__t)+
	'</div>\n    <div class="fmcy-video-item-description">'+
	((__t=( description ))==null?'':__t)+
	'</div>\n    <div class="fmcy-video-item-image-wrapper ">\n      <div class="fmcy-video-item-image fmcy-video-item-image-large fmcy-video-item-image-region"></div>\n      <div class="fmcy-video-play-button"></div>\n    </div>\n  ';
	 }
	__p+='\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette, _) {__webpack_require__(906);
	__webpack_require__(830);
	var Radio = __webpack_require__(905);
	var Behavior = Marionette.Behavior.extend({
	    initialize: function (options, view) {
	        this.listenToOnce(view, 'modal:open', this.openModal);
	    },
	    openModal: function (callback) {
	        this.view.dialog = this.view.channel.request('open', {
	            view: this.view,
	            callback: callback
	        });
	        this.listenToOnce(this.view, 'modal:close', this.closeModal);
	    },
	    closeModal: function (callback) {
	        this.view.channel.request('close', {
	            callback: callback
	        });
	    }
	});
	
	var Controller = Marionette.Controller.extend({
	    channel: null,
	    initialize: function (options) {
	        var self = this;
	        self.container = options.container;
	        self.channel = options.channel || Radio.channel('dialog');
	        self.view = new Dialog({
	            channel: self.channel
	        });
	        self.container.show(self.view);
	
	        _.bindAll(self, 'openModal', 'closeModal');
	
	        self.channel.reply('open', function (options) {
	            self.openModal(options);
	            return self.view;
	        });
	        self.channel.reply('close', this.closeModal);
	    },
	
	    openModal: function (options) {
	        this.view.openModal(options);
	    },
	
	    closeModal: function (options) {
	        this.view.closeModal(options);
	    }
	});
	
	/*
	    Example usage
	
	    Instantiation:
	    var DialogController =
	        require('treeline-shared-components/dialog').Controller;
	    this.modalController = new DialogController({
	        container: this.myDialogRegion
	    });
	
	    Show a view in the dialog:
	    Radio.channel('dialog').request(
	        'open',
	        {
	            view: new MyViewType(),
	            callback: function myOnDialogShownCallback () {
	                ...
	            }
	        }
	    );
	
	    Close the dialog:
	    Radio.channel('dialog').request(
	        'close',
	        {
	            callback: function myOnDialogClosedCallback () {
	                ...
	            }
	        }
	    );
	
	*/
	
	var Dialog = Marionette.LayoutView.extend({
	    _currentViewCustomClassName: '',
	    template: __webpack_require__(881),
	    // TODO rtomaselli: temporarily removed the 'fade' class because
	    // when showing consecutive dialogs due to the animation the
	    // background was not getting removed properly. Add 'fade' back in
	    // once we've figured out how to show consecutive dialogs properly.
	    className: 'tl-dialog modal',
	    attributes: {
	        'tabindex': -1,
	        'role': 'dialog'
	    },
	    regions: {
	        content: '.modal-content'
	    },
	    events: {
	        'click .close': 'closeModal'
	    },
	    triggers: {
	        'show.bs.modal': { preventDefault: false, event: 'show:modal' },
	        'shown.bs.modal': { preventDefault: false, event: 'after:show:modal' },
	        'hide.bs.modal': { preventDefault: false, event: 'hide:modal' },
	        'hidden.bs.modal': { preventDefault: false, event: 'after:hide:modal' }
	    },
	    openModal: function (options) {
	        if (options && options.callback) {
	            this.once('after:show:modal', options.callback);
	        }
	        this.setupModal(options);
	        jQuery(this.$el).modal('show');
	        if (options.fullScreen) {
	            this.$el.addClass('tl-full-screen-dialog');
	        } else {
	            this.$el.removeClass('tl-full-screen-dialog');
	        }
	        this._currentViewCustomClassName = options.customClassName;
	        this.$el.addClass(this._currentViewCustomClassName);
	    },
	    closeModal: function (options) {
	        if (options && options.callback) {
	            this.once('after:hide:modal', options.callback);
	        }
	        if (this.content.currentView) {
	            this.content.currentView.trigger('close');
	        }
	
	        jQuery(this.$el).modal('hide');
	        this.$el.removeClass('tl-full-screen-dialog');
	        this.$el.removeClass(this._currentViewCustomClassName);
	        this.teardownModal();
	    },
	    setView: function (view) {
	        this.content.show(view);
	    },
	    setupModal: function (options) {
	        if (this.isShown) {
	            this.teardownModal();
	        }
	        this.content.show(options.view);
	        this.isShown = true;
	    },
	
	    teardownModal: function () {
	        if (!this.isShown) {
	            return;
	        }
	
	        this.content.empty();
	        this.isShown = false;
	    },
	    onShow: function () {
	        jQuery(this.$el).modal({ show: false });
	    }
	});
	
	module.exports = {
	    Controller: Controller,
	    Behavior: Behavior
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(7)))

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $, Backbone) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	__webpack_require__(601);
	
	var OrderComplete = BaseViews.LayoutView.extend({
	  className: 'fmcy-order-complete',
	  template: __webpack_require__(641),
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      theme: 'light',
	      orderId: 0,
	      order: null,
	      location: null
	    });
	  },
	  serializeData: function serializeData() {
	    if (this.options.order.order_delivery_method == 'pickup') {
	      return {
	        deliveryMethod: this.options.order.order_delivery_method,
	        orderId: this.options.orderId,
	        hours: this.options.location.get('hours_readable'),
	        locationName: this.options.location.get('name')
	      };
	    } else {
	      return {
	        deliveryAddress: this.options.order.order_local_delivery_street_address,
	        deliveryMethod: this.options.order.order_delivery_method,
	        deliveryDate: this.options.order.order_delivery_date,
	        deliveryTime: this.options.order.order_delivery_time,
	        deliveryTimeReadable: this.options.order.order_delivery_time_readable,
	        deliveryWindowMinutes: this.options.order.order_delivery_window_minutes,
	        orderId: this.options.orderId,
	        hours: this.options.location.get('hours_readable'),
	        locationName: this.options.location.get('name')
	      };
	    }
	  },
	  onRender: function onRender() {
	    $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
	    this._onWindowResize();
	    Backbone.Radio.channel('global').request('request:notifications:permission');
	    BaseViews.LayoutView.prototype.onRender.call(self);
	  },
	  _onWindowResize: function _onWindowResize(event) {
	    var magicBuffer = 117;
	    var minHeight = $(window).height() - magicBuffer;
	    this.$el.css('minHeight', minHeight);
	  },
	  onDestroy: function onDestroy() {
	    $(window).off('resize.' + this.cid);
	    BaseViews.LayoutView.prototype.onDestroy.call(self);
	  }
	});
	
	module.exports = OrderComplete;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11), __webpack_require__(4)))

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	__webpack_require__(604);
	var BaseViews = __webpack_require__(5);
	
	var HamburgerButton = BaseViews.ItemView.extend({
	  _expandedMap: false,
	  template: __webpack_require__(644),
	  className: 'fmcy-hamburger-button',
	  ui: {
	    notificationCount: '.fmcy-hamburger-notification-count'
	  },
	  events: {
	    'click': 'onClick'
	  },
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      _appChannel: null,
	      _menuState: null,
	      open: true,
	      notificationCount: 0
	    });
	  },
	  onClick: function onClick() {
	    this.options._appChannel.trigger('menu:overlay:view:close', 'sidebar');
	    this.options._appChannel.trigger('menu:sidebar:view');
	  },
	  toggleIcon: function toggleIcon(open) {
	    var closeIconClassName = 'fmcy-menu-toggle-close-icon';
	    var openIconClassName = 'fmcy-menu-toggle-hamburger-icon';
	    if (!open) {
	      this.$el.removeClass(closeIconClassName);
	      this.$el.addClass(openIconClassName);
	    } else {
	      this.$el.removeClass(openIconClassName);
	      this.$el.addClass(closeIconClassName);
	    }
	  },
	  _updateNotieCount: function _updateNotieCount(count) {
	    if (count === 0) {
	      this.ui.notificationCount.hide();
	    } else {
	      this.ui.notificationCount.show();
	    }
	    this.ui.notificationCount.html(count);
	  },
	  onRender: function onRender() {
	    var self = this;
	    this._updateNotieCount(this.options.notificationCount);
	
	    this.toggleIcon(false);
	    this.listenTo(this.options._appChannel, 'orders:updated', function () {
	      self._updateNotieCount(self.options._appChannel.request('orders:ready:count'));
	    });
	  }
	});
	module.exports = HamburgerButton;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	__webpack_require__(605);
	var BaseViews = __webpack_require__(5);
	
	var ProfileButton = BaseViews.ItemView.extend({
	  _expandedMap: false,
	  template: __webpack_require__(645),
	  className: 'fmcy-profile-button',
	  ui: {
	    notificationCount: '.fmcy-profile-notification-count'
	  },
	  events: {
	    'click': 'onClick'
	  },
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      _appChannel: null,
	      _menuState: null,
	      open: true,
	      notificationCount: 0
	    });
	  },
	  onClick: function onClick() {
	    this.options._appChannel.trigger('menu:sidebar:view');
	  },
	  toggleIcon: function toggleIcon(open) {
	    var closeIconClassName = 'fmcy-menu-toggle-close-icon';
	    var openIconClassName = 'fmcy-menu-toggle-profile-icon';
	    if (!open) {
	      this.$el.removeClass(closeIconClassName);
	      this.$el.addClass(openIconClassName);
	    } else {
	      this.$el.removeClass(openIconClassName);
	      this.$el.addClass(closeIconClassName);
	    }
	  },
	  _updateNotieCount: function _updateNotieCount(count) {
	    if (count === 0) {
	      this.ui.notificationCount.hide();
	    } else {
	      this.ui.notificationCount.show();
	    }
	    this.ui.notificationCount.html(count);
	  },
	  onRender: function onRender() {
	    var self = this;
	    this._updateNotieCount(this.options.notificationCount);
	
	    this.toggleIcon(false);
	    this.listenTo(this.options._appChannel, 'orders:updated', function () {
	      self._updateNotieCount(self.options._appChannel.request('orders:ready:count'));
	    });
	  }
	});
	module.exports = ProfileButton;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	__webpack_require__(606);
	var BaseViews = __webpack_require__(5);
	
	var SearchButton = BaseViews.ItemView.extend({
	  _expandedMap: false,
	  template: __webpack_require__(646),
	  className: 'fmcy-search-button',
	  events: {
	    'click': 'onClick'
	  },
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      _appChannel: null,
	      _menuState: null,
	      open: true
	    });
	  },
	  onClick: function onClick() {
	    this.options._appChannel.trigger('menu:overlay:view:close', 'search');
	    this.options._appChannel.trigger('menu:search:view');
	  },
	  toggleIcon: function toggleIcon(open) {
	    var closeIconClassName = 'fmcy-menu-toggle-close-icon';
	    var openIconClassName = 'fmcy-menu-toggle-search-icon';
	    if (!open) {
	      this.$el.removeClass(closeIconClassName);
	      this.$el.addClass(openIconClassName);
	    } else {
	      this.$el.removeClass(openIconClassName);
	      this.$el.addClass(closeIconClassName);
	    }
	  },
	  onRender: function onRender() {
	    var self = this;
	    this.toggleIcon(false);
	  }
	});
	module.exports = SearchButton;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _, $) {'use strict';
	
	__webpack_require__(607);
	var Obscura = __webpack_require__(103);
	
	var CategoryTextMenu = Backbone.Marionette.CompositeView.extend({
	  className: 'fmcy-category-text-menu container-fluid',
	  template: __webpack_require__(647),
	  childView: __webpack_require__(361),
	  childViewContainer: '.fmcy-categories-text-menu-container',
	  childViewOptions: function childViewOptions(categoryModel, index) {
	    var self = this;
	    return {
	      appChannel: self.options._appChannel,
	      model: categoryModel,
	      categories: self.options.categories,
	      collection: self.options.categories
	    };
	  },
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      foo: 'bar',
	      defaultMenuHeight: 150,
	      _appChannel: null,
	      categories: null,
	      mode: 'default',
	      parentCategorySlug: 'cannabis'
	    });
	    this.menuHeight = this.options.defaultMenuHeight;
	    this.collection = options.categories;
	
	    var parent_id = this.collection.findWhere({ slug: this.options.parentCategorySlug }).get('id');
	    if (!parent_id) {
	      parent_id = null;
	    }
	
	    var parentCollection = new Obscura(this.collection);
	    parentCollection.filterBy('parent_id', function (model) {
	      // top level
	      if (model.get('parent_id') === parent_id) {
	        model.set('level', 0);
	        return true;
	      } else {
	        return false;
	      }
	    }).setSort('ordinal', 'asc');
	
	    this.collection = parentCollection;
	  },
	  _initializeElements: function _initializeElements() {
	    var self = this;
	    this.$el.css('opacity', 0);
	    this.collection.each(function (model) {
	      var view = self.children.findByModel(model);
	      if (view) {
	        view.$el.css('opacity', 0);
	      }
	    });
	  },
	  _adjustMenuAlignment: function _adjustMenuAlignment() {
	    var self = this;
	
	    var menu_width = this.$el.width();
	    var totalColumns = 5;
	    if ($(window).width() >= 1200) {
	      totalColumns = 5;
	    } else if ($(window).width() >= 1081) {
	      totalColumns = 4;
	    } else if ($(window).width() >= 700) {
	      totalColumns = 3;
	    } else if ($(window).width() >= 480) {
	      totalColumns = 2;
	    } else {
	      totalColumns = 1;
	    }
	    var columnWidth = menu_width / totalColumns;
	    var menu_height = this.options.defaultMenuHeight;
	    if (this.menuHeight !== this.options.defaultMenuHeight) {
	      menu_height = this.menuHeight;
	    }
	    var currentRow = 1;
	    var currentColumn = 1;
	    var starting_y_pos = 25;
	    var starting_x_pos = 50;
	    var bottomPadding = 25;
	    var totalOneColumnHeight = 0;
	    var current_current_x_pos = starting_x_pos;
	    var current_current_y_pos = starting_y_pos;
	
	    this.collection.each(function (model) {
	      var view = self.children.findByModel(model);
	
	      if (view) {
	
	        view.$el.css('top', current_current_y_pos + 'px');
	        view.$el.css('left', current_current_x_pos + 'px');
	
	        current_current_y_pos += view.getHeight();
	        totalOneColumnHeight += view.getHeight();
	
	        if (totalColumns !== 1) {
	          if (current_current_y_pos > currentRow * menu_height - bottomPadding) {
	
	            currentColumn += 1;
	
	            if (currentColumn > totalColumns) {
	              currentRow += 1;
	              currentColumn = 1;
	            }
	
	            current_current_y_pos = (currentRow - 1) * menu_height + starting_y_pos;
	            current_current_x_pos = (currentColumn - 1) * columnWidth + starting_x_pos;
	
	            view.$el.css('top', current_current_y_pos + 'px');
	            view.$el.css('left', current_current_x_pos + 'px');
	            current_current_y_pos += view.getHeight();
	          }
	        }
	      }
	    });
	
	    if (totalColumns !== 1) {
	      menu_height = menu_height * currentRow;
	    } else {
	      menu_height = totalOneColumnHeight;
	    }
	
	    if (menu_height > this.menuHeight) {
	      this.menuHeight = menu_height;
	      this._adjustMenuAlignment();
	    } else {
	      this.$el.height(menu_height + 150);
	      this.$el.css('opacity', 1);
	      var viewCount = 0;
	      this.collection.each(function (model) {
	        viewCount += 1;
	        var view = self.children.findByModel(model);
	        if (view) {
	          view.$el.css('opacity', 1);
	        }
	      });
	    }
	  },
	  _onWindowResize: function _onWindowResize(event) {
	    this.menuHeight = this.options.defaultMenuHeight;
	    this._adjustMenuAlignment();
	  },
	  onRender: function onRender() {
	    var self = this;
	    self._initializeElements();
	    _.delay(function () {
	      self._adjustMenuAlignment();
	      $(window).on('resize.' + self.cid, _.bind(self._onWindowResize, self));
	    }, 50);
	  },
	  onDestroy: function onDestroy() {
	    $(window).off('resize.' + this.cid);
	  },
	  onChildviewCategoryClicked: function onChildviewCategoryClicked(view, model) {
	    var parentSlug;
	    var childSlug = model.get('slug');
	
	    var parentModel = this.collection.findWhere({ id: model.get('parent_id') });
	
	    if (parentModel == null) {
	      parentSlug = childSlug;
	      childSlug = 'all';
	    } else {
	      parentSlug = parentModel.get('slug');
	    }
	
	    this.options._appChannel.request('load:category', parentSlug, childSlug);
	  }
	});
	module.exports = CategoryTextMenu;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var BaseViews = __webpack_require__(5);
	__webpack_require__(611);
	
	var ProductVendorEntities = __webpack_require__(42);
	
	var VendorSelect = BaseViews.LayoutView.extend({
	  template: __webpack_require__(652)
	});
	
	var VendorSelected = BaseViews.LayoutView.extend({
	  className: 'fmcy-vendor-selected',
	  template: __webpack_require__(653),
	  serializeData: function () {
	    return {
	      vendorName: this.model.get('name')
	    }
	  }
	});
	
	var VendorSelectSelected = BaseViews.LayoutView.extend({
	    _tabs: null,
	    _dropdownList: null,
	    template: __webpack_require__(651),
	    className: 'fmcy-vendor-select-selected fmcy-search-toggle-btn',
	    regions: {
	        childRegion: '.fmcy-vendor-selected-child-region'
	    },
	    initialize: function(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            _menuState: null,
	            appChannel: null
	        });
	    },
	    events: {
	      'click': 'onClick'
	    },
	    onClick: function () {
	      if (this.options._menuState.get('filterVendor') !== null && !isNaN(this.options._menuState.get('filterVendor'))) {
	        this.options.appChannel.trigger(
	            'search:options:changed',
	            {
	                filterVendor: null
	            }
	        );
	      } else {
	        this.options.appChannel.trigger('menu:search:view', {
	          searchType: 'vendor'
	        });
	      }
	    },
	    _getVendorModel: function (id) {
	      var $deferred = $.Deferred();
	      var vendorModel = new ProductVendorEntities.ProductVendorModel({ id: id });
	      vendorModel.fetch().then(function () {
	          $deferred.resolve(vendorModel);
	      }).fail(function () {
	          $deferred.reject();
	      });
	      return $deferred;
	    },
	    _renderSelectedVendor: function (vendorId) {
	      var self = this;
	      if (vendorId) {
	        this._getVendorModel(vendorId).then(function (vendorModel) {
	          self.vendorSelected = new VendorSelected({
	            model: vendorModel
	          });
	          self.childRegion.show(self.vendorSelected);
	        });
	      } else {
	        self.vendorSelect = new VendorSelect();
	        self.childRegion.show(self.vendorSelect);
	      }
	    },
	    onRender: function() {
	      var self = this;
	      this.options._menuState.on('change:filterVendor', function (model) {
	        self._renderSelectedVendor(model.get('filterVendor'));
	      });
	
	      if (this.options._menuState && this.options._menuState.get('filterVendor')) {
	        self._renderSelectedVendor(this.options._menuState.get('filterVendor'));
	      }
	    }
	});
	module.exports = VendorSelectSelected;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 467 */,
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * International Telephone Input v18.2.1
	 * https://github.com/jackocnr/intl-tel-input.git
	 * Licensed under the MIT license
	 */
	
	// wrap in UMD
	(function(factory) {
	    if (typeof module === "object" && module.exports) {
	        module.exports = factory(__webpack_require__(11));
	    } else if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(11) ], __WEBPACK_AMD_DEFINE_RESULT__ = function($) {
	            factory($);
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else factory(jQuery);
	})(function($, undefined) {
	    "use strict";
	    // Array of country objects for the flag dropdown.
	    // Here is the criteria for the plugin to support a given country/territory
	    // - It has an iso2 code: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
	    // - It has it's own country calling code (it is not a sub-region of another country): https://en.wikipedia.org/wiki/List_of_country_calling_codes
	    // - It has a flag in the region-flags project: https://github.com/behdad/region-flags/tree/gh-pages/png
	    // - It is supported by libphonenumber (it must be listed on this page): https://github.com/googlei18n/libphonenumber/blob/master/resources/ShortNumberMetadata.xml
	    // Each country array has the following information:
	    // [
	    //    Country name,
	    //    iso2 code,
	    //    International dial code,
	    //    Order (if >1 country with same dial code),
	    //    Area codes
	    // ]
	    var allCountries = [ [ "Afghanistan (‫افغانستان‬‎)", "af", "93" ], [ "Albania (Shqipëri)", "al", "355" ], [ "Algeria (‫الجزائر‬‎)", "dz", "213" ], [ "American Samoa", "as", "1", 5, [ "684" ] ], [ "Andorra", "ad", "376" ], [ "Angola", "ao", "244" ], [ "Anguilla", "ai", "1", 6, [ "264" ] ], [ "Antigua and Barbuda", "ag", "1", 7, [ "268" ] ], [ "Argentina", "ar", "54" ], [ "Armenia (Հայաստան)", "am", "374" ], [ "Aruba", "aw", "297" ], [ "Ascension Island", "ac", "247" ], [ "Australia", "au", "61", 0 ], [ "Austria (Österreich)", "at", "43" ], [ "Azerbaijan (Azərbaycan)", "az", "994" ], [ "Bahamas", "bs", "1", 8, [ "242" ] ], [ "Bahrain (‫البحرين‬‎)", "bh", "973" ], [ "Bangladesh (বাংলাদেশ)", "bd", "880" ], [ "Barbados", "bb", "1", 9, [ "246" ] ], [ "Belarus (Беларусь)", "by", "375" ], [ "Belgium (België)", "be", "32" ], [ "Belize", "bz", "501" ], [ "Benin (Bénin)", "bj", "229" ], [ "Bermuda", "bm", "1", 10, [ "441" ] ], [ "Bhutan (འབྲུག)", "bt", "975" ], [ "Bolivia", "bo", "591" ], [ "Bosnia and Herzegovina (Босна и Херцеговина)", "ba", "387" ], [ "Botswana", "bw", "267" ], [ "Brazil (Brasil)", "br", "55" ], [ "British Indian Ocean Territory", "io", "246" ], [ "British Virgin Islands", "vg", "1", 11, [ "284" ] ], [ "Brunei", "bn", "673" ], [ "Bulgaria (България)", "bg", "359" ], [ "Burkina Faso", "bf", "226" ], [ "Burundi (Uburundi)", "bi", "257" ], [ "Cambodia (កម្ពុជា)", "kh", "855" ], [ "Cameroon (Cameroun)", "cm", "237" ], [ "Canada", "ca", "1", 1, [ "204", "226", "236", "249", "250", "263", "289", "306", "343", "354", "365", "367", "368", "382", "387", "403", "416", "418", "428", "431", "437", "438", "450", "584", "468", "474", "506", "514", "519", "548", "579", "581", "584", "587", "604", "613", "639", "647", "672", "683", "705", "709", "742", "753", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905" ] ], [ "Cape Verde (Kabu Verdi)", "cv", "238" ], [ "Caribbean Netherlands", "bq", "599", 1, [ "3", "4", "7" ] ], [ "Cayman Islands", "ky", "1", 12, [ "345" ] ], [ "Central African Republic (République centrafricaine)", "cf", "236" ], [ "Chad (Tchad)", "td", "235" ], [ "Chile", "cl", "56" ], [ "China (中国)", "cn", "86" ], [ "Christmas Island", "cx", "61", 2, [ "89164" ] ], [ "Cocos (Keeling) Islands", "cc", "61", 1, [ "89162" ] ], [ "Colombia", "co", "57" ], [ "Comoros (‫جزر القمر‬‎)", "km", "269" ], [ "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)", "cd", "243" ], [ "Congo (Republic) (Congo-Brazzaville)", "cg", "242" ], [ "Cook Islands", "ck", "682" ], [ "Costa Rica", "cr", "506" ], [ "Côte d’Ivoire", "ci", "225" ], [ "Croatia (Hrvatska)", "hr", "385" ], [ "Cuba", "cu", "53" ], [ "Curaçao", "cw", "599", 0 ], [ "Cyprus (Κύπρος)", "cy", "357" ], [ "Czech Republic (Česká republika)", "cz", "420" ], [ "Denmark (Danmark)", "dk", "45" ], [ "Djibouti", "dj", "253" ], [ "Dominica", "dm", "1", 13, [ "767" ] ], [ "Dominican Republic (República Dominicana)", "do", "1", 2, [ "809", "829", "849" ] ], [ "Ecuador", "ec", "593" ], [ "Egypt (‫مصر‬‎)", "eg", "20" ], [ "El Salvador", "sv", "503" ], [ "Equatorial Guinea (Guinea Ecuatorial)", "gq", "240" ], [ "Eritrea", "er", "291" ], [ "Estonia (Eesti)", "ee", "372" ], [ "Eswatini", "sz", "268" ], [ "Ethiopia", "et", "251" ], [ "Falkland Islands (Islas Malvinas)", "fk", "500" ], [ "Faroe Islands (Føroyar)", "fo", "298" ], [ "Fiji", "fj", "679" ], [ "Finland (Suomi)", "fi", "358", 0 ], [ "France", "fr", "33" ], [ "French Guiana (Guyane française)", "gf", "594" ], [ "French Polynesia (Polynésie française)", "pf", "689" ], [ "Gabon", "ga", "241" ], [ "Gambia", "gm", "220" ], [ "Georgia (საქართველო)", "ge", "995" ], [ "Germany (Deutschland)", "de", "49" ], [ "Ghana (Gaana)", "gh", "233" ], [ "Gibraltar", "gi", "350" ], [ "Greece (Ελλάδα)", "gr", "30" ], [ "Greenland (Kalaallit Nunaat)", "gl", "299" ], [ "Grenada", "gd", "1", 14, [ "473" ] ], [ "Guadeloupe", "gp", "590", 0 ], [ "Guam", "gu", "1", 15, [ "671" ] ], [ "Guatemala", "gt", "502" ], [ "Guernsey", "gg", "44", 1, [ "1481", "7781", "7839", "7911" ] ], [ "Guinea (Guinée)", "gn", "224" ], [ "Guinea-Bissau (Guiné Bissau)", "gw", "245" ], [ "Guyana", "gy", "592" ], [ "Haiti", "ht", "509" ], [ "Honduras", "hn", "504" ], [ "Hong Kong (香港)", "hk", "852" ], [ "Hungary (Magyarország)", "hu", "36" ], [ "Iceland (Ísland)", "is", "354" ], [ "India (भारत)", "in", "91" ], [ "Indonesia", "id", "62" ], [ "Iran (‫ایران‬‎)", "ir", "98" ], [ "Iraq (‫العراق‬‎)", "iq", "964" ], [ "Ireland", "ie", "353" ], [ "Isle of Man", "im", "44", 2, [ "1624", "74576", "7524", "7924", "7624" ] ], [ "Israel (‫ישראל‬‎)", "il", "972" ], [ "Italy (Italia)", "it", "39", 0 ], [ "Jamaica", "jm", "1", 4, [ "876", "658" ] ], [ "Japan (日本)", "jp", "81" ], [ "Jersey", "je", "44", 3, [ "1534", "7509", "7700", "7797", "7829", "7937" ] ], [ "Jordan (‫الأردن‬‎)", "jo", "962" ], [ "Kazakhstan (Казахстан)", "kz", "7", 1, [ "33", "7" ] ], [ "Kenya", "ke", "254" ], [ "Kiribati", "ki", "686" ], [ "Kosovo", "xk", "383" ], [ "Kuwait (‫الكويت‬‎)", "kw", "965" ], [ "Kyrgyzstan (Кыргызстан)", "kg", "996" ], [ "Laos (ລາວ)", "la", "856" ], [ "Latvia (Latvija)", "lv", "371" ], [ "Lebanon (‫لبنان‬‎)", "lb", "961" ], [ "Lesotho", "ls", "266" ], [ "Liberia", "lr", "231" ], [ "Libya (‫ليبيا‬‎)", "ly", "218" ], [ "Liechtenstein", "li", "423" ], [ "Lithuania (Lietuva)", "lt", "370" ], [ "Luxembourg", "lu", "352" ], [ "Macau (澳門)", "mo", "853" ], [ "Madagascar (Madagasikara)", "mg", "261" ], [ "Malawi", "mw", "265" ], [ "Malaysia", "my", "60" ], [ "Maldives", "mv", "960" ], [ "Mali", "ml", "223" ], [ "Malta", "mt", "356" ], [ "Marshall Islands", "mh", "692" ], [ "Martinique", "mq", "596" ], [ "Mauritania (‫موريتانيا‬‎)", "mr", "222" ], [ "Mauritius (Moris)", "mu", "230" ], [ "Mayotte", "yt", "262", 1, [ "269", "639" ] ], [ "Mexico (México)", "mx", "52" ], [ "Micronesia", "fm", "691" ], [ "Moldova (Republica Moldova)", "md", "373" ], [ "Monaco", "mc", "377" ], [ "Mongolia (Монгол)", "mn", "976" ], [ "Montenegro (Crna Gora)", "me", "382" ], [ "Montserrat", "ms", "1", 16, [ "664" ] ], [ "Morocco (‫المغرب‬‎)", "ma", "212", 0 ], [ "Mozambique (Moçambique)", "mz", "258" ], [ "Myanmar (Burma) (မြန်မာ)", "mm", "95" ], [ "Namibia (Namibië)", "na", "264" ], [ "Nauru", "nr", "674" ], [ "Nepal (नेपाल)", "np", "977" ], [ "Netherlands (Nederland)", "nl", "31" ], [ "New Caledonia (Nouvelle-Calédonie)", "nc", "687" ], [ "New Zealand", "nz", "64" ], [ "Nicaragua", "ni", "505" ], [ "Niger (Nijar)", "ne", "227" ], [ "Nigeria", "ng", "234" ], [ "Niue", "nu", "683" ], [ "Norfolk Island", "nf", "672" ], [ "North Korea (조선 민주주의 인민 공화국)", "kp", "850" ], [ "North Macedonia (Северна Македонија)", "mk", "389" ], [ "Northern Mariana Islands", "mp", "1", 17, [ "670" ] ], [ "Norway (Norge)", "no", "47", 0 ], [ "Oman (‫عُمان‬‎)", "om", "968" ], [ "Pakistan (‫پاکستان‬‎)", "pk", "92" ], [ "Palau", "pw", "680" ], [ "Palestine (‫فلسطين‬‎)", "ps", "970" ], [ "Panama (Panamá)", "pa", "507" ], [ "Papua New Guinea", "pg", "675" ], [ "Paraguay", "py", "595" ], [ "Peru (Perú)", "pe", "51" ], [ "Philippines", "ph", "63" ], [ "Poland (Polska)", "pl", "48" ], [ "Portugal", "pt", "351" ], [ "Puerto Rico", "pr", "1", 3, [ "787", "939" ] ], [ "Qatar (‫قطر‬‎)", "qa", "974" ], [ "Réunion (La Réunion)", "re", "262", 0 ], [ "Romania (România)", "ro", "40" ], [ "Russia (Россия)", "ru", "7", 0 ], [ "Rwanda", "rw", "250" ], [ "Saint Barthélemy", "bl", "590", 1 ], [ "Saint Helena", "sh", "290" ], [ "Saint Kitts and Nevis", "kn", "1", 18, [ "869" ] ], [ "Saint Lucia", "lc", "1", 19, [ "758" ] ], [ "Saint Martin (Saint-Martin (partie française))", "mf", "590", 2 ], [ "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)", "pm", "508" ], [ "Saint Vincent and the Grenadines", "vc", "1", 20, [ "784" ] ], [ "Samoa", "ws", "685" ], [ "San Marino", "sm", "378" ], [ "São Tomé and Príncipe (São Tomé e Príncipe)", "st", "239" ], [ "Saudi Arabia (‫المملكة العربية السعودية‬‎)", "sa", "966" ], [ "Senegal (Sénégal)", "sn", "221" ], [ "Serbia (Србија)", "rs", "381" ], [ "Seychelles", "sc", "248" ], [ "Sierra Leone", "sl", "232" ], [ "Singapore", "sg", "65" ], [ "Sint Maarten", "sx", "1", 21, [ "721" ] ], [ "Slovakia (Slovensko)", "sk", "421" ], [ "Slovenia (Slovenija)", "si", "386" ], [ "Solomon Islands", "sb", "677" ], [ "Somalia (Soomaaliya)", "so", "252" ], [ "South Africa", "za", "27" ], [ "South Korea (대한민국)", "kr", "82" ], [ "South Sudan (‫جنوب السودان‬‎)", "ss", "211" ], [ "Spain (España)", "es", "34" ], [ "Sri Lanka (ශ්‍රී ලංකාව)", "lk", "94" ], [ "Sudan (‫السودان‬‎)", "sd", "249" ], [ "Suriname", "sr", "597" ], [ "Svalbard and Jan Mayen", "sj", "47", 1, [ "79" ] ], [ "Sweden (Sverige)", "se", "46" ], [ "Switzerland (Schweiz)", "ch", "41" ], [ "Syria (‫سوريا‬‎)", "sy", "963" ], [ "Taiwan (台灣)", "tw", "886" ], [ "Tajikistan", "tj", "992" ], [ "Tanzania", "tz", "255" ], [ "Thailand (ไทย)", "th", "66" ], [ "Timor-Leste", "tl", "670" ], [ "Togo", "tg", "228" ], [ "Tokelau", "tk", "690" ], [ "Tonga", "to", "676" ], [ "Trinidad and Tobago", "tt", "1", 22, [ "868" ] ], [ "Tunisia (‫تونس‬‎)", "tn", "216" ], [ "Turkey (Türkiye)", "tr", "90" ], [ "Turkmenistan", "tm", "993" ], [ "Turks and Caicos Islands", "tc", "1", 23, [ "649" ] ], [ "Tuvalu", "tv", "688" ], [ "U.S. Virgin Islands", "vi", "1", 24, [ "340" ] ], [ "Uganda", "ug", "256" ], [ "Ukraine (Україна)", "ua", "380" ], [ "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)", "ae", "971" ], [ "United Kingdom", "gb", "44", 0 ], [ "United States", "us", "1", 0 ], [ "Uruguay", "uy", "598" ], [ "Uzbekistan (Oʻzbekiston)", "uz", "998" ], [ "Vanuatu", "vu", "678" ], [ "Vatican City (Città del Vaticano)", "va", "39", 1, [ "06698" ] ], [ "Venezuela", "ve", "58" ], [ "Vietnam (Việt Nam)", "vn", "84" ], [ "Wallis and Futuna (Wallis-et-Futuna)", "wf", "681" ], [ "Western Sahara (‫الصحراء الغربية‬‎)", "eh", "212", 1, [ "5288", "5289" ] ], [ "Yemen (‫اليمن‬‎)", "ye", "967" ], [ "Zambia", "zm", "260" ], [ "Zimbabwe", "zw", "263" ], [ "Åland Islands", "ax", "358", 1, [ "18" ] ] ];
	    // loop over all of the countries above, restructuring the data to be objects with named keys
	    for (var i = 0; i < allCountries.length; i++) {
	        var c = allCountries[i];
	        allCountries[i] = {
	            name: c[0],
	            iso2: c[1],
	            dialCode: c[2],
	            priority: c[3] || 0,
	            areaCodes: c[4] || null
	        };
	    }
	    "use strict";
	    function _objectSpread(target) {
	        for (var i = 1; i < arguments.length; i++) {
	            var source = arguments[i] != null ? Object(arguments[i]) : {};
	            var ownKeys = Object.keys(source);
	            if (typeof Object.getOwnPropertySymbols === "function") {
	                ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function(sym) {
	                    return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	                }));
	            }
	            ownKeys.forEach(function(key) {
	                _defineProperty(target, key, source[key]);
	            });
	        }
	        return target;
	    }
	    function _defineProperty(obj, key, value) {
	        key = _toPropertyKey(key);
	        if (key in obj) {
	            Object.defineProperty(obj, key, {
	                value: value,
	                enumerable: true,
	                configurable: true,
	                writable: true
	            });
	        } else {
	            obj[key] = value;
	        }
	        return obj;
	    }
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	    function _defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];
	            descriptor.enumerable = descriptor.enumerable || false;
	            descriptor.configurable = true;
	            if ("value" in descriptor) descriptor.writable = true;
	            Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
	        }
	    }
	    function _createClass(Constructor, protoProps, staticProps) {
	        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	        if (staticProps) _defineProperties(Constructor, staticProps);
	        Object.defineProperty(Constructor, "prototype", {
	            writable: false
	        });
	        return Constructor;
	    }
	    function _toPropertyKey(arg) {
	        var key = _toPrimitive(arg, "string");
	        return typeof key === "symbol" ? key : String(key);
	    }
	    function _toPrimitive(input, hint) {
	        if (typeof input !== "object" || input === null) return input;
	        var prim = input[Symbol.toPrimitive];
	        if (prim !== undefined) {
	            var res = prim.call(input, hint || "default");
	            if (typeof res !== "object") return res;
	            throw new TypeError("@@toPrimitive must return a primitive value.");
	        }
	        return (hint === "string" ? String : Number)(input);
	    }
	    var intlTelInputGlobals = {
	        getInstance: function getInstance(input) {
	            var id = input.getAttribute("data-intl-tel-input-id");
	            return window.intlTelInputGlobals.instances[id];
	        },
	        instances: {},
	        // using a global like this allows us to mock it in the tests
	        documentReady: function documentReady() {
	            return document.readyState === "complete";
	        }
	    };
	    if (typeof window === "object") {
	        window.intlTelInputGlobals = intlTelInputGlobals;
	    }
	    // these vars persist through all instances of the plugin
	    var id = 0;
	    var defaults = {
	        // whether or not to allow the dropdown
	        allowDropdown: true,
	        // auto insert dial code (A) on init, (B) on user selecting a country, (C) on calling setCountry
	        // also listen for blur/submit and auto remove dial code if that's all there is
	        autoInsertDialCode: false,
	        // add a placeholder in the input with an example number for the selected country
	        autoPlaceholder: "polite",
	        // modify the parentClass
	        customContainer: "",
	        // modify the auto placeholder
	        customPlaceholder: null,
	        // append menu to specified element
	        dropdownContainer: null,
	        // don't display these countries
	        excludeCountries: [],
	        // format the input value during initialisation and on setNumber
	        formatOnDisplay: true,
	        // geoIp lookup function
	        geoIpLookup: null,
	        // inject a hidden input with this name, and on submit, populate it with the result of getNumber
	        hiddenInput: "",
	        // initial country
	        initialCountry: "",
	        // localized country names e.g. { 'de': 'Deutschland' }
	        localizedCountries: null,
	        // national vs international formatting for numbers e.g. placeholders and displaying existing numbers
	        nationalMode: true,
	        // display only these countries
	        onlyCountries: [],
	        // number type to use for placeholders
	        placeholderNumberType: "MOBILE",
	        // the countries at the top of the list. defaults to united states and united kingdom
	        preferredCountries: [ "us", "gb" ],
	        // display the country dial code next to the selected flag
	        separateDialCode: false,
	        // option to hide the flags - must be used with separateDialCode, or allowDropdown=false
	        showFlags: true,
	        // specify the path to the libphonenumber script to enable validation/formatting
	        utilsScript: ""
	    };
	    // https://en.wikipedia.org/wiki/List_of_North_American_Numbering_Plan_area_codes#Non-geographic_area_codes
	    var regionlessNanpNumbers = [ "800", "822", "833", "844", "855", "866", "877", "880", "881", "882", "883", "884", "885", "886", "887", "888", "889" ];
	    // utility function to iterate over an object. can't use Object.entries or native forEach because
	    // of IE11
	    var forEachProp = function forEachProp(obj, callback) {
	        var keys = Object.keys(obj);
	        for (var i = 0; i < keys.length; i++) {
	            callback(keys[i], obj[keys[i]]);
	        }
	    };
	    // run a method on each instance of the plugin
	    var forEachInstance = function forEachInstance(method) {
	        forEachProp(window.intlTelInputGlobals.instances, function(key) {
	            window.intlTelInputGlobals.instances[key][method]();
	        });
	    };
	    // this is our plugin class that we will create an instance of
	    // eslint-disable-next-line no-unused-vars
	    var Iti = /*#__PURE__*/ function() {
	        function Iti(input, options) {
	            var _this = this;
	            _classCallCheck(this, Iti);
	            this.id = id++;
	            this.telInput = input;
	            this.activeItem = null;
	            this.highlightedItem = null;
	            // process specified options / defaults
	            // alternative to Object.assign, which isn't supported by IE11
	            var customOptions = options || {};
	            this.options = {};
	            forEachProp(defaults, function(key, value) {
	                _this.options[key] = customOptions.hasOwnProperty(key) ? customOptions[key] : value;
	            });
	            this.hadInitialPlaceholder = Boolean(input.getAttribute("placeholder"));
	        }
	        _createClass(Iti, [ {
	            key: "_init",
	            value: function _init() {
	                var _this2 = this;
	                // if in nationalMode, do not insert dial codes
	                if (this.options.nationalMode) {
	                    this.options.autoInsertDialCode = false;
	                }
	                // if separateDialCode enabled, do not insert dial codes
	                if (this.options.separateDialCode) {
	                    this.options.autoInsertDialCode = false;
	                }
	                // force showFlags=true if there's a dropdown and we're not displaying the dial code,
	                // as otherwise you just have a down arrow on it's own which doesn't make sense
	                var forceShowFlags = this.options.allowDropdown && !this.options.separateDialCode;
	                if (!this.options.showFlags && forceShowFlags) {
	                    this.options.showFlags = true;
	                }
	                // we cannot just test screen size as some smartphones/website meta tags will report desktop
	                // resolutions
	                // Note: for some reason jasmine breaks if you put this in the main Plugin function with the
	                // rest of these declarations
	                // Note: to target Android Mobiles (and not Tablets), we must find 'Android' and 'Mobile'
	                this.isMobile = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	                if (this.isMobile) {
	                    // trigger the mobile dropdown css
	                    document.body.classList.add("iti-mobile");
	                    // on mobile, we want a full screen dropdown, so we must append it to the body
	                    if (!this.options.dropdownContainer) {
	                        this.options.dropdownContainer = document.body;
	                    }
	                }
	                // check if input has one parent with RTL
	                this.isRTL = !!this.telInput.closest("[dir=rtl]");
	                // these promises get resolved when their individual requests complete
	                // this way the dev can do something like iti.promise.then(...) to know when all requests are
	                // complete
	                if (typeof Promise !== "undefined") {
	                    var autoCountryPromise = new Promise(function(resolve, reject) {
	                        _this2.resolveAutoCountryPromise = resolve;
	                        _this2.rejectAutoCountryPromise = reject;
	                    });
	                    var utilsScriptPromise = new Promise(function(resolve, reject) {
	                        _this2.resolveUtilsScriptPromise = resolve;
	                        _this2.rejectUtilsScriptPromise = reject;
	                    });
	                    this.promise = Promise.all([ autoCountryPromise, utilsScriptPromise ]);
	                } else {
	                    // prevent errors when Promise doesn't exist
	                    this.resolveAutoCountryPromise = this.rejectAutoCountryPromise = function() {};
	                    this.resolveUtilsScriptPromise = this.rejectUtilsScriptPromise = function() {};
	                }
	                // in various situations there could be no country selected initially, but we need to be able
	                // to assume this variable exists
	                this.selectedCountryData = {};
	                // process all the data: onlyCountries, excludeCountries, preferredCountries etc
	                this._processCountryData();
	                // generate the markup
	                this._generateMarkup();
	                // set the initial state of the input value and the selected flag
	                this._setInitialState();
	                // start all of the event listeners: autoInsertDialCode, input keydown, selectedFlag click
	                this._initListeners();
	                // utils script, and auto country
	                this._initRequests();
	            }
	        }, {
	            key: "_processCountryData",
	            value: function _processCountryData() {
	                // process onlyCountries or excludeCountries array if present
	                this._processAllCountries();
	                // process the countryCodes map
	                this._processCountryCodes();
	                // process the preferredCountries
	                this._processPreferredCountries();
	                // translate countries according to localizedCountries option
	                if (this.options.localizedCountries) {
	                    this._translateCountriesByLocale();
	                }
	                // sort countries by name
	                if (this.options.onlyCountries.length || this.options.localizedCountries) {
	                    this.countries.sort(this._countryNameSort);
	                }
	            }
	        }, {
	            key: "_addCountryCode",
	            value: function _addCountryCode(iso2, countryCode, priority) {
	                if (countryCode.length > this.countryCodeMaxLen) {
	                    this.countryCodeMaxLen = countryCode.length;
	                }
	                if (!this.countryCodes.hasOwnProperty(countryCode)) {
	                    this.countryCodes[countryCode] = [];
	                }
	                // bail if we already have this country for this countryCode
	                for (var i = 0; i < this.countryCodes[countryCode].length; i++) {
	                    if (this.countryCodes[countryCode][i] === iso2) {
	                        return;
	                    }
	                }
	                // check for undefined as 0 is falsy
	                var index = priority !== undefined ? priority : this.countryCodes[countryCode].length;
	                this.countryCodes[countryCode][index] = iso2;
	            }
	        }, {
	            key: "_processAllCountries",
	            value: function _processAllCountries() {
	                if (this.options.onlyCountries.length) {
	                    var lowerCaseOnlyCountries = this.options.onlyCountries.map(function(country) {
	                        return country.toLowerCase();
	                    });
	                    this.countries = allCountries.filter(function(country) {
	                        return lowerCaseOnlyCountries.indexOf(country.iso2) > -1;
	                    });
	                } else if (this.options.excludeCountries.length) {
	                    var lowerCaseExcludeCountries = this.options.excludeCountries.map(function(country) {
	                        return country.toLowerCase();
	                    });
	                    this.countries = allCountries.filter(function(country) {
	                        return lowerCaseExcludeCountries.indexOf(country.iso2) === -1;
	                    });
	                } else {
	                    this.countries = allCountries;
	                }
	            }
	        }, {
	            key: "_translateCountriesByLocale",
	            value: function _translateCountriesByLocale() {
	                for (var i = 0; i < this.countries.length; i++) {
	                    var iso = this.countries[i].iso2.toLowerCase();
	                    if (this.options.localizedCountries.hasOwnProperty(iso)) {
	                        this.countries[i].name = this.options.localizedCountries[iso];
	                    }
	                }
	            }
	        }, {
	            key: "_countryNameSort",
	            value: function _countryNameSort(a, b) {
	                if (a.name < b.name) {
	                    return -1;
	                }
	                if (a.name > b.name) {
	                    return 1;
	                }
	                return 0;
	            }
	        }, {
	            key: "_processCountryCodes",
	            value: function _processCountryCodes() {
	                this.countryCodeMaxLen = 0;
	                // here we store just dial codes
	                this.dialCodes = {};
	                // here we store "country codes" (both dial codes and their area codes)
	                this.countryCodes = {};
	                // first: add dial codes
	                for (var i = 0; i < this.countries.length; i++) {
	                    var c = this.countries[i];
	                    if (!this.dialCodes[c.dialCode]) {
	                        this.dialCodes[c.dialCode] = true;
	                    }
	                    this._addCountryCode(c.iso2, c.dialCode, c.priority);
	                }
	                // next: add area codes
	                // this is a second loop over countries, to make sure we have all of the "root" countries
	                // already in the map, so that we can access them, as each time we add an area code substring
	                // to the map, we also need to include the "root" country's code, as that also matches
	                for (var _i = 0; _i < this.countries.length; _i++) {
	                    var _c = this.countries[_i];
	                    // area codes
	                    if (_c.areaCodes) {
	                        var rootCountryCode = this.countryCodes[_c.dialCode][0];
	                        // for each area code
	                        for (var j = 0; j < _c.areaCodes.length; j++) {
	                            var areaCode = _c.areaCodes[j];
	                            // for each digit in the area code to add all partial matches as well
	                            for (var k = 1; k < areaCode.length; k++) {
	                                var partialDialCode = _c.dialCode + areaCode.substr(0, k);
	                                // start with the root country, as that also matches this dial code
	                                this._addCountryCode(rootCountryCode, partialDialCode);
	                                this._addCountryCode(_c.iso2, partialDialCode);
	                            }
	                            // add the full area code
	                            this._addCountryCode(_c.iso2, _c.dialCode + areaCode);
	                        }
	                    }
	                }
	            }
	        }, {
	            key: "_processPreferredCountries",
	            value: function _processPreferredCountries() {
	                this.preferredCountries = [];
	                for (var i = 0; i < this.options.preferredCountries.length; i++) {
	                    var countryCode = this.options.preferredCountries[i].toLowerCase();
	                    var countryData = this._getCountryData(countryCode, false, true);
	                    if (countryData) {
	                        this.preferredCountries.push(countryData);
	                    }
	                }
	            }
	        }, {
	            key: "_createEl",
	            value: function _createEl(name, attrs, container) {
	                var el = document.createElement(name);
	                if (attrs) {
	                    forEachProp(attrs, function(key, value) {
	                        return el.setAttribute(key, value);
	                    });
	                }
	                if (container) {
	                    container.appendChild(el);
	                }
	                return el;
	            }
	        }, {
	            key: "_generateMarkup",
	            value: function _generateMarkup() {
	                // if autocomplete does not exist on the element and its form, then
	                // prevent autocomplete as there's no safe, cross-browser event we can react to, so it can
	                // easily put the plugin in an inconsistent state e.g. the wrong flag selected for the
	                // autocompleted number, which on submit could mean wrong number is saved
	                if (!this.telInput.hasAttribute("autocomplete") && !(this.telInput.form && this.telInput.form.hasAttribute("autocomplete"))) {
	                    this.telInput.setAttribute("autocomplete", "off");
	                }
	                var _this$options = this.options, allowDropdown = _this$options.allowDropdown, separateDialCode = _this$options.separateDialCode, showFlags = _this$options.showFlags, customContainer = _this$options.customContainer, hiddenInput = _this$options.hiddenInput, dropdownContainer = _this$options.dropdownContainer;
	                // containers (mostly for positioning)
	                var parentClass = "iti";
	                if (allowDropdown) {
	                    parentClass += " iti--allow-dropdown";
	                }
	                if (separateDialCode) {
	                    parentClass += " iti--separate-dial-code";
	                }
	                if (showFlags) {
	                    parentClass += " iti--show-flags";
	                }
	                if (customContainer) {
	                    parentClass += " ".concat(customContainer);
	                }
	                var wrapper = this._createEl("div", {
	                    "class": parentClass
	                });
	                this.telInput.parentNode.insertBefore(wrapper, this.telInput);
	                // only hide the flagsContainer if allowDropdown, showFlags and separateDialCode are all false
	                var showFlagsContainer = allowDropdown || showFlags || separateDialCode;
	                if (showFlagsContainer) {
	                    this.flagsContainer = this._createEl("div", {
	                        "class": "iti__flag-container"
	                    }, wrapper);
	                }
	                wrapper.appendChild(this.telInput);
	                // selected flag (displayed to left of input)
	                // using Aria tags for "Select-Only Combobox Example"
	                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
	                if (showFlagsContainer) {
	                    this.selectedFlag = this._createEl("div", _objectSpread({
	                        "class": "iti__selected-flag"
	                    }, allowDropdown && {
	                        role: "combobox",
	                        "aria-haspopup": "listbox",
	                        "aria-controls": "iti-".concat(this.id, "__country-listbox"),
	                        "aria-expanded": "false",
	                        "aria-label": "Telephone country code"
	                    }), this.flagsContainer);
	                }
	                if (showFlags) {
	                    this.selectedFlagInner = this._createEl("div", {
	                        "class": "iti__flag"
	                    }, this.selectedFlag);
	                }
	                if (this.selectedFlag && this.telInput.disabled) {
	                    this.selectedFlag.setAttribute("aria-disabled", "true");
	                }
	                if (separateDialCode) {
	                    this.selectedDialCode = this._createEl("div", {
	                        "class": "iti__selected-dial-code"
	                    }, this.selectedFlag);
	                }
	                if (allowDropdown) {
	                    if (!this.telInput.disabled) {
	                        // make element focusable and tab navigable
	                        this.selectedFlag.setAttribute("tabindex", "0");
	                    }
	                    this.dropdownArrow = this._createEl("div", {
	                        "class": "iti__arrow"
	                    }, this.selectedFlag);
	                    // country dropdown: preferred countries, then divider, then all countries
	                    this.countryList = this._createEl("ul", {
	                        "class": "iti__country-list iti__hide",
	                        id: "iti-".concat(this.id, "__country-listbox"),
	                        role: "listbox",
	                        "aria-label": "List of countries"
	                    });
	                    if (this.preferredCountries.length) {
	                        this._appendListItems(this.preferredCountries, "iti__preferred", true);
	                        this._createEl("li", {
	                            "class": "iti__divider",
	                            role: "separator",
	                            "aria-disabled": "true"
	                        }, this.countryList);
	                    }
	                    this._appendListItems(this.countries, "iti__standard");
	                    // create dropdownContainer markup
	                    if (dropdownContainer) {
	                        this.dropdown = this._createEl("div", {
	                            "class": "iti iti--container"
	                        });
	                        this.dropdown.appendChild(this.countryList);
	                    } else {
	                        this.flagsContainer.appendChild(this.countryList);
	                    }
	                }
	                if (hiddenInput) {
	                    var hiddenInputName = hiddenInput;
	                    var name = this.telInput.getAttribute("name");
	                    if (name) {
	                        var i = name.lastIndexOf("[");
	                        // if input name contains square brackets, then give the hidden input the same name,
	                        // replacing the contents of the last set of brackets with the given hiddenInput name
	                        if (i !== -1) {
	                            hiddenInputName = "".concat(name.substr(0, i), "[").concat(hiddenInputName, "]");
	                        }
	                    }
	                    this.hiddenInput = this._createEl("input", {
	                        type: "hidden",
	                        name: hiddenInputName
	                    });
	                    wrapper.appendChild(this.hiddenInput);
	                }
	            }
	        }, {
	            key: "_appendListItems",
	            value: function _appendListItems(countries, className, preferred) {
	                // we create so many DOM elements, it is faster to build a temp string
	                // and then add everything to the DOM in one go at the end
	                var tmp = "";
	                // for each country
	                for (var i = 0; i < countries.length; i++) {
	                    var c = countries[i];
	                    var idSuffix = preferred ? "-preferred" : "";
	                    // open the list item
	                    tmp += "<li class='iti__country ".concat(className, "' tabIndex='-1' id='iti-").concat(this.id, "__item-").concat(c.iso2).concat(idSuffix, "' role='option' data-dial-code='").concat(c.dialCode, "' data-country-code='").concat(c.iso2, "' aria-selected='false'>");
	                    // add the flag
	                    if (this.options.showFlags) {
	                        tmp += "<div class='iti__flag-box'><div class='iti__flag iti__".concat(c.iso2, "'></div></div>");
	                    }
	                    // and the country name and dial code
	                    tmp += "<span class='iti__country-name'>".concat(c.name, "</span>");
	                    tmp += "<span class='iti__dial-code'>+".concat(c.dialCode, "</span>");
	                    // close the list item
	                    tmp += "</li>";
	                }
	                this.countryList.insertAdjacentHTML("beforeend", tmp);
	            }
	        }, {
	            key: "_setInitialState",
	            value: function _setInitialState() {
	                // fix firefox bug: when first load page (with input with value set to number with intl dial
	                // code) and initialising plugin removes the dial code from the input, then refresh page,
	                // and we try to init plugin again but this time on number without dial code so get grey flag
	                var attributeValue = this.telInput.getAttribute("value");
	                var inputValue = this.telInput.value;
	                var useAttribute = attributeValue && attributeValue.charAt(0) === "+" && (!inputValue || inputValue.charAt(0) !== "+");
	                var val = useAttribute ? attributeValue : inputValue;
	                var dialCode = this._getDialCode(val);
	                var isRegionlessNanp = this._isRegionlessNanp(val);
	                var _this$options2 = this.options, initialCountry = _this$options2.initialCountry, autoInsertDialCode = _this$options2.autoInsertDialCode;
	                // if we already have a dial code, and it's not a regionlessNanp, we can go ahead and set the
	                // flag, else fall back to the default country
	                if (dialCode && !isRegionlessNanp) {
	                    this._updateFlagFromNumber(val);
	                } else if (initialCountry !== "auto") {
	                    // see if we should select a flag
	                    if (initialCountry) {
	                        this._setFlag(initialCountry.toLowerCase());
	                    } else {
	                        if (dialCode && isRegionlessNanp) {
	                            // has intl dial code, is regionless nanp, and no initialCountry, so default to US
	                            this._setFlag("us");
	                        } else {
	                            // no dial code and no initialCountry, so default to first in list
	                            this.defaultCountry = this.preferredCountries.length ? this.preferredCountries[0].iso2 : this.countries[0].iso2;
	                            if (!val) {
	                                this._setFlag(this.defaultCountry);
	                            }
	                        }
	                    }
	                    // if empty and autoInsertDialCode then insert the dial code
	                    if (!val && autoInsertDialCode) {
	                        this.telInput.value = "+".concat(this.selectedCountryData.dialCode);
	                    }
	                }
	                // NOTE: if initialCountry is set to auto, that will be handled separately
	                // format - note this wont be run after _updateDialCode as that's only called if no val
	                if (val) {
	                    this._updateValFromNumber(val);
	                }
	            }
	        }, {
	            key: "_initListeners",
	            value: function _initListeners() {
	                this._initKeyListeners();
	                if (this.options.autoInsertDialCode) {
	                    this._initBlurListeners();
	                }
	                if (this.options.allowDropdown) {
	                    this._initDropdownListeners();
	                }
	                if (this.hiddenInput) {
	                    this._initHiddenInputListener();
	                }
	            }
	        }, {
	            key: "_initHiddenInputListener",
	            value: function _initHiddenInputListener() {
	                var _this3 = this;
	                this._handleHiddenInputSubmit = function() {
	                    _this3.hiddenInput.value = _this3.getNumber();
	                };
	                if (this.telInput.form) {
	                    this.telInput.form.addEventListener("submit", this._handleHiddenInputSubmit);
	                }
	            }
	        }, {
	            key: "_getClosestLabel",
	            value: function _getClosestLabel() {
	                var el = this.telInput;
	                while (el && el.tagName !== "LABEL") {
	                    el = el.parentNode;
	                }
	                return el;
	            }
	        }, {
	            key: "_initDropdownListeners",
	            value: function _initDropdownListeners() {
	                var _this4 = this;
	                // hack for input nested inside label (which is valid markup): clicking the selected-flag to
	                // open the dropdown would then automatically trigger a 2nd click on the input which would
	                // close it again
	                this._handleLabelClick = function(e) {
	                    // if the dropdown is closed, then focus the input, else ignore the click
	                    if (_this4.countryList.classList.contains("iti__hide")) {
	                        _this4.telInput.focus();
	                    } else {
	                        e.preventDefault();
	                    }
	                };
	                var label = this._getClosestLabel();
	                if (label) {
	                    label.addEventListener("click", this._handleLabelClick);
	                }
	                // toggle country dropdown on click
	                this._handleClickSelectedFlag = function() {
	                    // only intercept this event if we're opening the dropdown
	                    // else let it bubble up to the top ("click-off-to-close" listener)
	                    // we cannot just stopPropagation as it may be needed to close another instance
	                    if (_this4.countryList.classList.contains("iti__hide") && !_this4.telInput.disabled && !_this4.telInput.readOnly) {
	                        _this4._showDropdown();
	                    }
	                };
	                this.selectedFlag.addEventListener("click", this._handleClickSelectedFlag);
	                // open dropdown list if currently focused
	                this._handleFlagsContainerKeydown = function(e) {
	                    var isDropdownHidden = _this4.countryList.classList.contains("iti__hide");
	                    if (isDropdownHidden && [ "ArrowUp", "Up", "ArrowDown", "Down", " ", "Enter" ].indexOf(e.key) !== -1) {
	                        // prevent form from being submitted if "ENTER" was pressed
	                        e.preventDefault();
	                        // prevent event from being handled again by document
	                        e.stopPropagation();
	                        _this4._showDropdown();
	                    }
	                    // allow navigation from dropdown to input on TAB
	                    if (e.key === "Tab") {
	                        _this4._closeDropdown();
	                    }
	                };
	                this.flagsContainer.addEventListener("keydown", this._handleFlagsContainerKeydown);
	            }
	        }, {
	            key: "_initRequests",
	            value: function _initRequests() {
	                var _this5 = this;
	                // if the user has specified the path to the utils script, fetch it on window.load, else resolve
	                if (this.options.utilsScript && !window.intlTelInputUtils) {
	                    // if the plugin is being initialised after the window.load event has already been fired
	                    if (window.intlTelInputGlobals.documentReady()) {
	                        window.intlTelInputGlobals.loadUtils(this.options.utilsScript);
	                    } else {
	                        // wait until the load event so we don't block any other requests e.g. the flags image
	                        window.addEventListener("load", function() {
	                            window.intlTelInputGlobals.loadUtils(_this5.options.utilsScript);
	                        });
	                    }
	                } else {
	                    this.resolveUtilsScriptPromise();
	                }
	                if (this.options.initialCountry === "auto") {
	                    this._loadAutoCountry();
	                } else {
	                    this.resolveAutoCountryPromise();
	                }
	            }
	        }, {
	            key: "_loadAutoCountry",
	            value: function _loadAutoCountry() {
	                // 3 options:
	                // 1) already loaded (we're done)
	                // 2) not already started loading (start)
	                // 3) already started loading (do nothing - just wait for loading callback to fire)
	                if (window.intlTelInputGlobals.autoCountry) {
	                    this.handleAutoCountry();
	                } else if (!window.intlTelInputGlobals.startedLoadingAutoCountry) {
	                    // don't do this twice!
	                    window.intlTelInputGlobals.startedLoadingAutoCountry = true;
	                    if (typeof this.options.geoIpLookup === "function") {
	                        this.options.geoIpLookup(function(countryCode) {
	                            window.intlTelInputGlobals.autoCountry = countryCode.toLowerCase();
	                            // tell all instances the auto country is ready
	                            // TODO: this should just be the current instances
	                            // UPDATE: use setTimeout in case their geoIpLookup function calls this callback straight
	                            // away (e.g. if they have already done the geo ip lookup somewhere else). Using
	                            // setTimeout means that the current thread of execution will finish before executing
	                            // this, which allows the plugin to finish initialising.
	                            setTimeout(function() {
	                                return forEachInstance("handleAutoCountry");
	                            });
	                        }, function() {
	                            return forEachInstance("rejectAutoCountryPromise");
	                        });
	                    }
	                }
	            }
	        }, {
	            key: "_initKeyListeners",
	            value: function _initKeyListeners() {
	                var _this6 = this;
	                // update flag on keyup
	                this._handleKeyupEvent = function() {
	                    if (_this6._updateFlagFromNumber(_this6.telInput.value)) {
	                        _this6._triggerCountryChange();
	                    }
	                };
	                this.telInput.addEventListener("keyup", this._handleKeyupEvent);
	                // update flag on cut/paste events (now supported in all major browsers)
	                this._handleClipboardEvent = function() {
	                    // hack because "paste" event is fired before input is updated
	                    setTimeout(_this6._handleKeyupEvent);
	                };
	                this.telInput.addEventListener("cut", this._handleClipboardEvent);
	                this.telInput.addEventListener("paste", this._handleClipboardEvent);
	            }
	        }, {
	            key: "_cap",
	            value: function _cap(number) {
	                var max = this.telInput.getAttribute("maxlength");
	                return max && number.length > max ? number.substr(0, max) : number;
	            }
	        }, {
	            key: "_initBlurListeners",
	            value: function _initBlurListeners() {
	                var _this7 = this;
	                // on blur or form submit: if just a dial code then remove it
	                this._handleSubmitOrBlurEvent = function() {
	                    _this7._removeEmptyDialCode();
	                };
	                if (this.telInput.form) {
	                    this.telInput.form.addEventListener("submit", this._handleSubmitOrBlurEvent);
	                }
	                this.telInput.addEventListener("blur", this._handleSubmitOrBlurEvent);
	            }
	        }, {
	            key: "_removeEmptyDialCode",
	            value: function _removeEmptyDialCode() {
	                if (this.telInput.value.charAt(0) === "+") {
	                    var numeric = this._getNumeric(this.telInput.value);
	                    // if just a plus, or if just a dial code
	                    if (!numeric || this.selectedCountryData.dialCode === numeric) {
	                        this.telInput.value = "";
	                    }
	                }
	            }
	        }, {
	            key: "_getNumeric",
	            value: function _getNumeric(s) {
	                return s.replace(/\D/g, "");
	            }
	        }, {
	            key: "_trigger",
	            value: function _trigger(name) {
	                // have to use old school document.createEvent as IE11 doesn't support `new Event()` syntax
	                var e = document.createEvent("Event");
	                e.initEvent(name, true, true);
	                // can bubble, and is cancellable
	                this.telInput.dispatchEvent(e);
	            }
	        }, {
	            key: "_showDropdown",
	            value: function _showDropdown() {
	                this.countryList.classList.remove("iti__hide");
	                this.selectedFlag.setAttribute("aria-expanded", "true");
	                this._setDropdownPosition();
	                // update highlighting and scroll to active list item
	                if (this.activeItem) {
	                    this._highlightListItem(this.activeItem, false);
	                    this._scrollTo(this.activeItem, true);
	                }
	                // bind all the dropdown-related listeners: mouseover, click, click-off, keydown
	                this._bindDropdownListeners();
	                // update the arrow
	                this.dropdownArrow.classList.add("iti__arrow--up");
	                this._trigger("open:countrydropdown");
	            }
	        }, {
	            key: "_toggleClass",
	            value: function _toggleClass(el, className, shouldHaveClass) {
	                if (shouldHaveClass && !el.classList.contains(className)) {
	                    el.classList.add(className);
	                } else if (!shouldHaveClass && el.classList.contains(className)) {
	                    el.classList.remove(className);
	                }
	            }
	        }, {
	            key: "_setDropdownPosition",
	            value: function _setDropdownPosition() {
	                var _this8 = this;
	                if (this.options.dropdownContainer) {
	                    this.options.dropdownContainer.appendChild(this.dropdown);
	                }
	                if (!this.isMobile) {
	                    var pos = this.telInput.getBoundingClientRect();
	                    // windowTop from https://stackoverflow.com/a/14384091/217866
	                    var windowTop = window.pageYOffset || document.documentElement.scrollTop;
	                    var inputTop = pos.top + windowTop;
	                    var dropdownHeight = this.countryList.offsetHeight;
	                    // dropdownFitsBelow = (dropdownBottom < windowBottom)
	                    var dropdownFitsBelow = inputTop + this.telInput.offsetHeight + dropdownHeight < windowTop + window.innerHeight;
	                    var dropdownFitsAbove = inputTop - dropdownHeight > windowTop;
	                    // by default, the dropdown will be below the input. If we want to position it above the
	                    // input, we add the dropup class.
	                    this._toggleClass(this.countryList, "iti__country-list--dropup", !dropdownFitsBelow && dropdownFitsAbove);
	                    // if dropdownContainer is enabled, calculate postion
	                    if (this.options.dropdownContainer) {
	                        // by default the dropdown will be directly over the input because it's not in the flow.
	                        // If we want to position it below, we need to add some extra top value.
	                        var extraTop = !dropdownFitsBelow && dropdownFitsAbove ? 0 : this.telInput.offsetHeight;
	                        // calculate placement
	                        this.dropdown.style.top = "".concat(inputTop + extraTop, "px");
	                        this.dropdown.style.left = "".concat(pos.left + document.body.scrollLeft, "px");
	                        // close menu on window scroll
	                        this._handleWindowScroll = function() {
	                            return _this8._closeDropdown();
	                        };
	                        window.addEventListener("scroll", this._handleWindowScroll);
	                    }
	                }
	            }
	        }, {
	            key: "_getClosestListItem",
	            value: function _getClosestListItem(target) {
	                var el = target;
	                while (el && el !== this.countryList && !el.classList.contains("iti__country")) {
	                    el = el.parentNode;
	                }
	                // if we reached the countryList element, then return null
	                return el === this.countryList ? null : el;
	            }
	        }, {
	            key: "_bindDropdownListeners",
	            value: function _bindDropdownListeners() {
	                var _this9 = this;
	                // when mouse over a list item, just highlight that one
	                // we add the class "highlight", so if they hit "enter" we know which one to select
	                this._handleMouseoverCountryList = function(e) {
	                    // handle event delegation, as we're listening for this event on the countryList
	                    var listItem = _this9._getClosestListItem(e.target);
	                    if (listItem) {
	                        _this9._highlightListItem(listItem, false);
	                    }
	                };
	                this.countryList.addEventListener("mouseover", this._handleMouseoverCountryList);
	                // listen for country selection
	                this._handleClickCountryList = function(e) {
	                    var listItem = _this9._getClosestListItem(e.target);
	                    if (listItem) {
	                        _this9._selectListItem(listItem);
	                    }
	                };
	                this.countryList.addEventListener("click", this._handleClickCountryList);
	                // click off to close
	                // (except when this initial opening click is bubbling up)
	                // we cannot just stopPropagation as it may be needed to close another instance
	                var isOpening = true;
	                this._handleClickOffToClose = function() {
	                    if (!isOpening) {
	                        _this9._closeDropdown();
	                    }
	                    isOpening = false;
	                };
	                document.documentElement.addEventListener("click", this._handleClickOffToClose);
	                // listen for up/down scrolling, enter to select, or letters to jump to country name.
	                // use keydown as keypress doesn't fire for non-char keys and we want to catch if they
	                // just hit down and hold it to scroll down (no keyup event).
	                // listen on the document because that's where key events are triggered if no input has focus
	                var query = "";
	                var queryTimer = null;
	                this._handleKeydownOnDropdown = function(e) {
	                    // prevent down key from scrolling the whole page,
	                    // and enter key from submitting a form etc
	                    e.preventDefault();
	                    // up and down to navigate
	                    if (e.key === "ArrowUp" || e.key === "Up" || e.key === "ArrowDown" || e.key === "Down") {
	                        _this9._handleUpDownKey(e.key);
	                    } else if (e.key === "Enter") {
	                        _this9._handleEnterKey();
	                    } else if (e.key === "Escape") {
	                        _this9._closeDropdown();
	                    } else if (/^[a-zA-ZÀ-ÿа-яА-Я ]$/.test(e.key)) {
	                        // jump to countries that start with the query string
	                        if (queryTimer) {
	                            clearTimeout(queryTimer);
	                        }
	                        query += e.key.toLowerCase();
	                        _this9._searchForCountry(query);
	                        // if the timer hits 1 second, reset the query
	                        queryTimer = setTimeout(function() {
	                            query = "";
	                        }, 1e3);
	                    }
	                };
	                document.addEventListener("keydown", this._handleKeydownOnDropdown);
	            }
	        }, {
	            key: "_handleUpDownKey",
	            value: function _handleUpDownKey(key) {
	                var next = key === "ArrowUp" || key === "Up" ? this.highlightedItem.previousElementSibling : this.highlightedItem.nextElementSibling;
	                if (next) {
	                    // skip the divider
	                    if (next.classList.contains("iti__divider")) {
	                        next = key === "ArrowUp" || key === "Up" ? next.previousElementSibling : next.nextElementSibling;
	                    }
	                    this._highlightListItem(next, true);
	                }
	            }
	        }, {
	            key: "_handleEnterKey",
	            value: function _handleEnterKey() {
	                if (this.highlightedItem) {
	                    this._selectListItem(this.highlightedItem);
	                }
	            }
	        }, {
	            key: "_searchForCountry",
	            value: function _searchForCountry(query) {
	                for (var i = 0; i < this.countries.length; i++) {
	                    if (this._startsWith(this.countries[i].name, query)) {
	                        var listItem = this.countryList.querySelector("#iti-".concat(this.id, "__item-").concat(this.countries[i].iso2));
	                        // update highlighting and scroll
	                        this._highlightListItem(listItem, false);
	                        this._scrollTo(listItem, true);
	                        break;
	                    }
	                }
	            }
	        }, {
	            key: "_startsWith",
	            value: function _startsWith(a, b) {
	                return a.substr(0, b.length).toLowerCase() === b;
	            }
	        }, {
	            key: "_updateValFromNumber",
	            value: function _updateValFromNumber(originalNumber) {
	                var number = originalNumber;
	                if (this.options.formatOnDisplay && window.intlTelInputUtils && this.selectedCountryData) {
	                    var useNational = this.options.nationalMode || number.charAt(0) !== "+" && !this.options.separateDialCode;
	                    var _intlTelInputUtils$nu = intlTelInputUtils.numberFormat, NATIONAL = _intlTelInputUtils$nu.NATIONAL, INTERNATIONAL = _intlTelInputUtils$nu.INTERNATIONAL;
	                    var format = useNational ? NATIONAL : INTERNATIONAL;
	                    number = intlTelInputUtils.formatNumber(number, this.selectedCountryData.iso2, format);
	                }
	                number = this._beforeSetNumber(number);
	                this.telInput.value = number;
	            }
	        }, {
	            key: "_updateFlagFromNumber",
	            value: function _updateFlagFromNumber(originalNumber) {
	                // if we already have US/Canada selected, make sure the number starts
	                // with a +1 so _getDialCode will be able to extract the area code
	                // update: if we dont yet have selectedCountryData, but we're here (trying to update the flag
	                // from the number), that means we're initialising the plugin with a number that already has a
	                // dial code, so fine to ignore this bit
	                var number = originalNumber;
	                var selectedDialCode = this.selectedCountryData.dialCode;
	                var isNanp = selectedDialCode === "1";
	                if (number && isNanp && number.charAt(0) !== "+") {
	                    if (number.charAt(0) !== "1") {
	                        number = "1".concat(number);
	                    }
	                    number = "+".concat(number);
	                }
	                // if separateDialCode enabled, then consider the selected dial code to be part of the number
	                if (this.options.separateDialCode && selectedDialCode && number.charAt(0) !== "+") {
	                    number = "+".concat(selectedDialCode).concat(number);
	                }
	                // try and extract valid dial code from input
	                var dialCode = this._getDialCode(number, true);
	                var numeric = this._getNumeric(number);
	                var countryCode = null;
	                if (dialCode) {
	                    var countryCodes = this.countryCodes[this._getNumeric(dialCode)];
	                    // check if the right country is already selected. this should be false if the number is
	                    // longer than the matched dial code because in this case we need to make sure that if
	                    // there are multiple country matches, that the first one is selected (note: we could
	                    // just check that here, but it requires the same loop that we already have later)
	                    var alreadySelected = countryCodes.indexOf(this.selectedCountryData.iso2) !== -1 && numeric.length <= dialCode.length - 1;
	                    var isRegionlessNanpNumber = selectedDialCode === "1" && this._isRegionlessNanp(numeric);
	                    // only update the flag if:
	                    // A) NOT (we currently have a NANP flag selected, and the number is a regionlessNanp)
	                    // AND
	                    // B) the right country is not already selected
	                    if (!isRegionlessNanpNumber && !alreadySelected) {
	                        // if using onlyCountries option, countryCodes[0] may be empty, so we must find the first
	                        // non-empty index
	                        for (var j = 0; j < countryCodes.length; j++) {
	                            if (countryCodes[j]) {
	                                countryCode = countryCodes[j];
	                                break;
	                            }
	                        }
	                    }
	                } else if (number.charAt(0) === "+" && numeric.length) {
	                    // invalid dial code, so empty
	                    // Note: use getNumeric here because the number has not been formatted yet, so could contain
	                    // bad chars
	                    countryCode = "";
	                } else if (!number || number === "+") {
	                    // empty, or just a plus, so default
	                    countryCode = this.defaultCountry;
	                }
	                if (countryCode !== null) {
	                    return this._setFlag(countryCode);
	                }
	                return false;
	            }
	        }, {
	            key: "_isRegionlessNanp",
	            value: function _isRegionlessNanp(number) {
	                var numeric = this._getNumeric(number);
	                if (numeric.charAt(0) === "1") {
	                    var areaCode = numeric.substr(1, 3);
	                    return regionlessNanpNumbers.indexOf(areaCode) !== -1;
	                }
	                return false;
	            }
	        }, {
	            key: "_highlightListItem",
	            value: function _highlightListItem(listItem, shouldFocus) {
	                var prevItem = this.highlightedItem;
	                if (prevItem) {
	                    prevItem.classList.remove("iti__highlight");
	                }
	                this.highlightedItem = listItem;
	                this.highlightedItem.classList.add("iti__highlight");
	                this.selectedFlag.setAttribute("aria-activedescendant", listItem.getAttribute("id"));
	                if (shouldFocus) {
	                    this.highlightedItem.focus();
	                }
	            }
	        }, {
	            key: "_getCountryData",
	            value: function _getCountryData(countryCode, ignoreOnlyCountriesOption, allowFail) {
	                var countryList = ignoreOnlyCountriesOption ? allCountries : this.countries;
	                for (var i = 0; i < countryList.length; i++) {
	                    if (countryList[i].iso2 === countryCode) {
	                        return countryList[i];
	                    }
	                }
	                if (allowFail) {
	                    return null;
	                }
	                throw new Error("No country data for '".concat(countryCode, "'"));
	            }
	        }, {
	            key: "_setFlag",
	            value: function _setFlag(countryCode) {
	                var _this$options3 = this.options, allowDropdown = _this$options3.allowDropdown, separateDialCode = _this$options3.separateDialCode, showFlags = _this$options3.showFlags;
	                var prevCountry = this.selectedCountryData.iso2 ? this.selectedCountryData : {};
	                // do this first as it will throw an error and stop if countryCode is invalid
	                this.selectedCountryData = countryCode ? this._getCountryData(countryCode, false, false) : {};
	                // update the defaultCountry - we only need the iso2 from now on, so just store that
	                if (this.selectedCountryData.iso2) {
	                    this.defaultCountry = this.selectedCountryData.iso2;
	                }
	                if (showFlags) {
	                    this.selectedFlagInner.setAttribute("class", "iti__flag iti__".concat(countryCode));
	                }
	                this._setSelectedCountryFlagTitleAttribute(countryCode, separateDialCode);
	                if (separateDialCode) {
	                    var dialCode = this.selectedCountryData.dialCode ? "+".concat(this.selectedCountryData.dialCode) : "";
	                    this.selectedDialCode.innerHTML = dialCode;
	                    // offsetWidth is zero if input is in a hidden container during initialisation
	                    var selectedFlagWidth = this.selectedFlag.offsetWidth || this._getHiddenSelectedFlagWidth();
	                    // add 6px of padding after the grey selected-dial-code box, as this is what we use in the css
	                    if (this.isRTL) {
	                        this.telInput.style.setProperty("padding-right", "".concat(selectedFlagWidth + 6, "px"), "important");
	                    } else {
	                        this.telInput.style.setProperty("padding-left", "".concat(selectedFlagWidth + 6, "px"), "important");
	                    }
	                }
	                // and the input's placeholder
	                this._updatePlaceholder();
	                // update the active list item
	                if (allowDropdown) {
	                    var prevItem = this.activeItem;
	                    if (prevItem) {
	                        prevItem.classList.remove("iti__active");
	                        prevItem.setAttribute("aria-selected", "false");
	                    }
	                    if (countryCode) {
	                        // check if there is a preferred item first, else fall back to standard
	                        var nextItem = this.countryList.querySelector("#iti-".concat(this.id, "__item-").concat(countryCode, "-preferred")) || this.countryList.querySelector("#iti-".concat(this.id, "__item-").concat(countryCode));
	                        nextItem.setAttribute("aria-selected", "true");
	                        nextItem.classList.add("iti__active");
	                        this.activeItem = nextItem;
	                    }
	                }
	                // return if the flag has changed or not
	                return prevCountry.iso2 !== countryCode;
	            }
	        }, {
	            key: "_setSelectedCountryFlagTitleAttribute",
	            value: function _setSelectedCountryFlagTitleAttribute(countryCode, separateDialCode) {
	                if (!this.selectedFlag) {
	                    return;
	                }
	                var title;
	                if (countryCode && !separateDialCode) {
	                    title = "".concat(this.selectedCountryData.name, ": +").concat(this.selectedCountryData.dialCode);
	                } else if (countryCode) {
	                    // For screen reader output, we don't want to include the dial code in the reader output twice
	                    // so just use the selected country name here:
	                    title = this.selectedCountryData.name;
	                } else {
	                    title = "Unknown";
	                }
	                this.selectedFlag.setAttribute("title", title);
	            }
	        }, {
	            key: "_getHiddenSelectedFlagWidth",
	            value: function _getHiddenSelectedFlagWidth() {
	                // to get the right styling to apply, all we need is a shallow clone of the container,
	                // and then to inject a deep clone of the selectedFlag element
	                var containerClone = this.telInput.parentNode.cloneNode();
	                containerClone.style.visibility = "hidden";
	                document.body.appendChild(containerClone);
	                var flagsContainerClone = this.flagsContainer.cloneNode();
	                containerClone.appendChild(flagsContainerClone);
	                var selectedFlagClone = this.selectedFlag.cloneNode(true);
	                flagsContainerClone.appendChild(selectedFlagClone);
	                var width = selectedFlagClone.offsetWidth;
	                containerClone.parentNode.removeChild(containerClone);
	                return width;
	            }
	        }, {
	            key: "_updatePlaceholder",
	            value: function _updatePlaceholder() {
	                var shouldSetPlaceholder = this.options.autoPlaceholder === "aggressive" || !this.hadInitialPlaceholder && this.options.autoPlaceholder === "polite";
	                if (window.intlTelInputUtils && shouldSetPlaceholder) {
	                    var numberType = intlTelInputUtils.numberType[this.options.placeholderNumberType];
	                    var placeholder = this.selectedCountryData.iso2 ? intlTelInputUtils.getExampleNumber(this.selectedCountryData.iso2, this.options.nationalMode, numberType) : "";
	                    placeholder = this._beforeSetNumber(placeholder);
	                    if (typeof this.options.customPlaceholder === "function") {
	                        placeholder = this.options.customPlaceholder(placeholder, this.selectedCountryData);
	                    }
	                    this.telInput.setAttribute("placeholder", placeholder);
	                }
	            }
	        }, {
	            key: "_selectListItem",
	            value: function _selectListItem(listItem) {
	                // update selected flag and active list item
	                var flagChanged = this._setFlag(listItem.getAttribute("data-country-code"));
	                this._closeDropdown();
	                this._updateDialCode(listItem.getAttribute("data-dial-code"));
	                // focus the input
	                this.telInput.focus();
	                // put cursor at end - this fix is required for FF and IE11 (with auto inserting dial code),
	                // who try to put the cursor at the beginning the first time
	                var len = this.telInput.value.length;
	                this.telInput.setSelectionRange(len, len);
	                if (flagChanged) {
	                    this._triggerCountryChange();
	                }
	            }
	        }, {
	            key: "_closeDropdown",
	            value: function _closeDropdown() {
	                this.countryList.classList.add("iti__hide");
	                this.selectedFlag.setAttribute("aria-expanded", "false");
	                this.selectedFlag.removeAttribute("aria-activedescendant");
	                // update the arrow
	                this.dropdownArrow.classList.remove("iti__arrow--up");
	                // unbind key events
	                document.removeEventListener("keydown", this._handleKeydownOnDropdown);
	                document.documentElement.removeEventListener("click", this._handleClickOffToClose);
	                this.countryList.removeEventListener("mouseover", this._handleMouseoverCountryList);
	                this.countryList.removeEventListener("click", this._handleClickCountryList);
	                // remove menu from container
	                if (this.options.dropdownContainer) {
	                    if (!this.isMobile) {
	                        window.removeEventListener("scroll", this._handleWindowScroll);
	                    }
	                    if (this.dropdown.parentNode) {
	                        this.dropdown.parentNode.removeChild(this.dropdown);
	                    }
	                }
	                this._trigger("close:countrydropdown");
	            }
	        }, {
	            key: "_scrollTo",
	            value: function _scrollTo(element, middle) {
	                var container = this.countryList;
	                // windowTop from https://stackoverflow.com/a/14384091/217866
	                var windowTop = window.pageYOffset || document.documentElement.scrollTop;
	                var containerHeight = container.offsetHeight;
	                var containerTop = container.getBoundingClientRect().top + windowTop;
	                var containerBottom = containerTop + containerHeight;
	                var elementHeight = element.offsetHeight;
	                var elementTop = element.getBoundingClientRect().top + windowTop;
	                var elementBottom = elementTop + elementHeight;
	                var newScrollTop = elementTop - containerTop + container.scrollTop;
	                var middleOffset = containerHeight / 2 - elementHeight / 2;
	                if (elementTop < containerTop) {
	                    // scroll up
	                    if (middle) {
	                        newScrollTop -= middleOffset;
	                    }
	                    container.scrollTop = newScrollTop;
	                } else if (elementBottom > containerBottom) {
	                    // scroll down
	                    if (middle) {
	                        newScrollTop += middleOffset;
	                    }
	                    var heightDifference = containerHeight - elementHeight;
	                    container.scrollTop = newScrollTop - heightDifference;
	                }
	            }
	        }, {
	            key: "_updateDialCode",
	            value: function _updateDialCode(newDialCodeBare) {
	                var inputVal = this.telInput.value;
	                // save having to pass this every time
	                var newDialCode = "+".concat(newDialCodeBare);
	                var newNumber;
	                if (inputVal.charAt(0) === "+") {
	                    // there's a plus so we're dealing with a replacement
	                    var prevDialCode = this._getDialCode(inputVal);
	                    if (prevDialCode) {
	                        // current number contains a valid dial code, so replace it
	                        newNumber = inputVal.replace(prevDialCode, newDialCode);
	                    } else {
	                        // current number contains an invalid dial code, so ditch it
	                        // (no way to determine where the invalid dial code ends and the rest of the number begins)
	                        newNumber = newDialCode;
	                    }
	                    this.telInput.value = newNumber;
	                } else if (this.options.autoInsertDialCode) {
	                    if (inputVal) {
	                        // there is an existing value with no dial code: prefix the new dial code
	                        newNumber = newDialCode + inputVal;
	                    } else {
	                        newNumber = newDialCode;
	                    }
	                    this.telInput.value = newNumber;
	                }
	            }
	        }, {
	            key: "_getDialCode",
	            value: function _getDialCode(number, includeAreaCode) {
	                var dialCode = "";
	                // only interested in international numbers (starting with a plus)
	                if (number.charAt(0) === "+") {
	                    var numericChars = "";
	                    // iterate over chars
	                    for (var i = 0; i < number.length; i++) {
	                        var c = number.charAt(i);
	                        // if char is number (https://stackoverflow.com/a/8935649/217866)
	                        if (!isNaN(parseInt(c, 10))) {
	                            numericChars += c;
	                            // if current numericChars make a valid dial code
	                            if (includeAreaCode) {
	                                if (this.countryCodes[numericChars]) {
	                                    // store the actual raw string (useful for matching later)
	                                    dialCode = number.substr(0, i + 1);
	                                }
	                            } else {
	                                if (this.dialCodes[numericChars]) {
	                                    dialCode = number.substr(0, i + 1);
	                                    // if we're just looking for a dial code, we can break as soon as we find one
	                                    break;
	                                }
	                            }
	                            // stop searching as soon as we can - in this case when we hit max len
	                            if (numericChars.length === this.countryCodeMaxLen) {
	                                break;
	                            }
	                        }
	                    }
	                }
	                return dialCode;
	            }
	        }, {
	            key: "_getFullNumber",
	            value: function _getFullNumber() {
	                var val = this.telInput.value.trim();
	                var dialCode = this.selectedCountryData.dialCode;
	                var prefix;
	                var numericVal = this._getNumeric(val);
	                if (this.options.separateDialCode && val.charAt(0) !== "+" && dialCode && numericVal) {
	                    // when using separateDialCode, it is visible so is effectively part of the typed number
	                    prefix = "+".concat(dialCode);
	                } else {
	                    prefix = "";
	                }
	                return prefix + val;
	            }
	        }, {
	            key: "_beforeSetNumber",
	            value: function _beforeSetNumber(originalNumber) {
	                var number = originalNumber;
	                if (this.options.separateDialCode) {
	                    var dialCode = this._getDialCode(number);
	                    // if there is a valid dial code
	                    if (dialCode) {
	                        // in case _getDialCode returned an area code as well
	                        dialCode = "+".concat(this.selectedCountryData.dialCode);
	                        // a lot of numbers will have a space separating the dial code and the main number, and
	                        // some NANP numbers will have a hyphen e.g. +1 684-733-1234 - in both cases we want to get
	                        // rid of it
	                        // NOTE: don't just trim all non-numerics as may want to preserve an open parenthesis etc
	                        var start = number[dialCode.length] === " " || number[dialCode.length] === "-" ? dialCode.length + 1 : dialCode.length;
	                        number = number.substr(start);
	                    }
	                }
	                return this._cap(number);
	            }
	        }, {
	            key: "_triggerCountryChange",
	            value: function _triggerCountryChange() {
	                this._trigger("countrychange");
	            }
	        }, {
	            key: "handleAutoCountry",
	            value: function handleAutoCountry() {
	                if (this.options.initialCountry === "auto") {
	                    // we must set this even if there is an initial val in the input: in case the initial val is
	                    // invalid and they delete it - they should see their auto country
	                    this.defaultCountry = window.intlTelInputGlobals.autoCountry;
	                    // if there's no initial value in the input, then update the flag
	                    if (!this.telInput.value) {
	                        this.setCountry(this.defaultCountry);
	                    }
	                    this.resolveAutoCountryPromise();
	                }
	            }
	        }, {
	            key: "handleUtils",
	            value: function handleUtils() {
	                // if the request was successful
	                if (window.intlTelInputUtils) {
	                    // if there's an initial value in the input, then format it
	                    if (this.telInput.value) {
	                        this._updateValFromNumber(this.telInput.value);
	                    }
	                    this._updatePlaceholder();
	                }
	                this.resolveUtilsScriptPromise();
	            }
	        }, {
	            key: "destroy",
	            value: function destroy() {
	                var form = this.telInput.form;
	                if (this.options.allowDropdown) {
	                    // make sure the dropdown is closed (and unbind listeners)
	                    this._closeDropdown();
	                    this.selectedFlag.removeEventListener("click", this._handleClickSelectedFlag);
	                    this.flagsContainer.removeEventListener("keydown", this._handleFlagsContainerKeydown);
	                    // label click hack
	                    var label = this._getClosestLabel();
	                    if (label) {
	                        label.removeEventListener("click", this._handleLabelClick);
	                    }
	                }
	                // unbind hiddenInput listeners
	                if (this.hiddenInput && form) {
	                    form.removeEventListener("submit", this._handleHiddenInputSubmit);
	                }
	                // unbind autoInsertDialCode listeners
	                if (this.options.autoInsertDialCode) {
	                    if (form) {
	                        form.removeEventListener("submit", this._handleSubmitOrBlurEvent);
	                    }
	                    this.telInput.removeEventListener("blur", this._handleSubmitOrBlurEvent);
	                }
	                // unbind key events, and cut/paste events
	                this.telInput.removeEventListener("keyup", this._handleKeyupEvent);
	                this.telInput.removeEventListener("cut", this._handleClipboardEvent);
	                this.telInput.removeEventListener("paste", this._handleClipboardEvent);
	                // remove attribute of id instance: data-intl-tel-input-id
	                this.telInput.removeAttribute("data-intl-tel-input-id");
	                // remove markup (but leave the original input)
	                var wrapper = this.telInput.parentNode;
	                wrapper.parentNode.insertBefore(this.telInput, wrapper);
	                wrapper.parentNode.removeChild(wrapper);
	                delete window.intlTelInputGlobals.instances[this.id];
	            }
	        }, {
	            key: "getExtension",
	            value: function getExtension() {
	                if (window.intlTelInputUtils) {
	                    return intlTelInputUtils.getExtension(this._getFullNumber(), this.selectedCountryData.iso2);
	                }
	                return "";
	            }
	        }, {
	            key: "getNumber",
	            value: function getNumber(format) {
	                if (window.intlTelInputUtils) {
	                    var iso2 = this.selectedCountryData.iso2;
	                    return intlTelInputUtils.formatNumber(this._getFullNumber(), iso2, format);
	                }
	                return "";
	            }
	        }, {
	            key: "getNumberType",
	            value: function getNumberType() {
	                if (window.intlTelInputUtils) {
	                    return intlTelInputUtils.getNumberType(this._getFullNumber(), this.selectedCountryData.iso2);
	                }
	                return -99;
	            }
	        }, {
	            key: "getSelectedCountryData",
	            value: function getSelectedCountryData() {
	                return this.selectedCountryData;
	            }
	        }, {
	            key: "getValidationError",
	            value: function getValidationError() {
	                if (window.intlTelInputUtils) {
	                    var iso2 = this.selectedCountryData.iso2;
	                    return intlTelInputUtils.getValidationError(this._getFullNumber(), iso2);
	                }
	                return -99;
	            }
	        }, {
	            key: "isValidNumber",
	            value: function isValidNumber() {
	                var val = this._getFullNumber().trim();
	                return window.intlTelInputUtils ? intlTelInputUtils.isValidNumber(val, this.selectedCountryData.iso2) : null;
	            }
	        }, {
	            key: "isPossibleNumber",
	            value: function isPossibleNumber() {
	                var val = this._getFullNumber().trim();
	                return window.intlTelInputUtils ? intlTelInputUtils.isPossibleNumber(val, this.selectedCountryData.iso2) : null;
	            }
	        }, {
	            key: "setCountry",
	            value: function setCountry(originalCountryCode) {
	                var countryCode = originalCountryCode.toLowerCase();
	                // check if already selected
	                if (this.selectedCountryData.iso2 !== countryCode) {
	                    this._setFlag(countryCode);
	                    this._updateDialCode(this.selectedCountryData.dialCode);
	                    this._triggerCountryChange();
	                }
	            }
	        }, {
	            key: "setNumber",
	            value: function setNumber(number) {
	                // we must update the flag first, which updates this.selectedCountryData, which is used for
	                // formatting the number before displaying it
	                var flagChanged = this._updateFlagFromNumber(number);
	                this._updateValFromNumber(number);
	                if (flagChanged) {
	                    this._triggerCountryChange();
	                }
	            }
	        }, {
	            key: "setPlaceholderNumberType",
	            value: function setPlaceholderNumberType(type) {
	                this.options.placeholderNumberType = type;
	                this._updatePlaceholder();
	            }
	        } ]);
	        return Iti;
	    }();
	    /********************
	 *  STATIC METHODS
	 ********************/
	    // get the country data object
	    intlTelInputGlobals.getCountryData = function() {
	        return allCountries;
	    };
	    // inject a <script> element to load utils.js
	    var injectScript = function injectScript(path, handleSuccess, handleFailure) {
	        // inject a new script element into the page
	        var script = document.createElement("script");
	        script.onload = function() {
	            forEachInstance("handleUtils");
	            if (handleSuccess) {
	                handleSuccess();
	            }
	        };
	        script.onerror = function() {
	            forEachInstance("rejectUtilsScriptPromise");
	            if (handleFailure) {
	                handleFailure();
	            }
	        };
	        script.className = "iti-load-utils";
	        script.async = true;
	        script.src = path;
	        document.body.appendChild(script);
	    };
	    // load the utils script
	    intlTelInputGlobals.loadUtils = function(path) {
	        // 2 options:
	        // 1) not already started loading (start)
	        // 2) already started loading (do nothing - just wait for the onload callback to fire, which will
	        // trigger handleUtils on all instances, invoking their resolveUtilsScriptPromise functions)
	        if (!window.intlTelInputUtils && !window.intlTelInputGlobals.startedLoadingUtilsScript) {
	            // only do this once
	            window.intlTelInputGlobals.startedLoadingUtilsScript = true;
	            // if we have promises, then return a promise
	            if (typeof Promise !== "undefined") {
	                return new Promise(function(resolve, reject) {
	                    return injectScript(path, resolve, reject);
	                });
	            }
	            injectScript(path);
	        }
	        return null;
	    };
	    // default options
	    intlTelInputGlobals.defaults = defaults;
	    // version
	    intlTelInputGlobals.version = "18.2.1";
	    var pluginName = "intlTelInput";
	    // A really lightweight plugin wrapper around the constructor,
	    // preventing against multiple instantiations
	    $.fn[pluginName] = function(options) {
	        var args = arguments;
	        // Is the first parameter an object (options), or was omitted, instantiate a new instance of the plugin.
	        if (options === undefined || typeof options === "object") {
	            return this.each(function() {
	                if (!$.data(this, "plugin_" + pluginName)) {
	                    var iti = new Iti(this, options);
	                    iti._init();
	                    window.intlTelInputGlobals.instances[iti.id] = iti;
	                    $.data(this, "plugin_" + pluginName, iti);
	                }
	            });
	        } else if (typeof options === "string" && options[0] !== "_") {
	            // If the first parameter is a string and it doesn't start with an underscore treat this as a call to a public method.
	            // Cache the method call to make it possible to return a value
	            var returns;
	            this.each(function() {
	                var instance = $.data(this, "plugin_" + pluginName);
	                // Tests that there's already a plugin-instance and checks that the requested public method exists
	                if (instance instanceof Iti && typeof instance[options] === "function") {
	                    // Call the method of our plugin instance, and pass it the supplied arguments.
	                    returns = instance[options].apply(instance, Array.prototype.slice.call(args, 1));
	                }
	                // Allow instances to be destroyed via the 'destroy' method
	                if (options === "destroy") $.data(this, "plugin_" + pluginName, null);
	            });
	            // If the earlier cached method gives a value back return the value, otherwise return this to preserve chainability.
	            return returns !== undefined ? returns : this;
	        }
	    };
	});

/***/ },
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	__webpack_require__(593);
	__webpack_require__(209);
	
	var BaseViews = __webpack_require__(5);
	
	var CartDeliveryAddressForm = BaseViews.LayoutView.extend({
	    className: 'fmcy-cart-delivery-address-form',
	    template: __webpack_require__(634),
	    ui: {
	        alertMessage: '.fmcy-cart-delivery-address-form-alert-message',
	        alertMessageText: '.alert-danger'
	    },
	    initialize: function initialize(options) {
	        var self = this;
	        self.options = _.defaults(options || {}, {
	            _appChannel: null,
	            error: false,
	            errorMessage: 'Please enter your address below'
	        });
	    },
	    modelEvents: function modelEvents() {
	        var self = this;
	        return _.extend({}, _.result(BaseViews.LayoutView.prototype, 'modelEvents'), {
	            validated: self.maybeDisplayValidationAlert.bind(self)
	        });
	    },
	    validatedFields: function validatedFields() {
	        var validatedFields = ['local_delivery_street_address'];
	        return validatedFields;
	    },
	    toggleValidationAlert: function toggleValidationAlert(show) {
	        if (show) {
	            this.ui.alertMessage.removeClass('hidden');
	        } else {
	            this.ui.alertMessage.addClass('hidden');
	        }
	    },
	    maybeDisplayValidationAlert: function maybeDisplayValidationAlert() {
	        if (this.$el.find('.has-error').length) {
	            this.toggleValidationAlert(true);
	        } else {
	            this.toggleValidationAlert(false);
	        }
	    },
	    onModelAttributeValid: function onModelAttributeValid(attr, selector) {
	        if (BaseViews.LayoutView.prototype.onModelAttributeValid.call(this, attr, selector)) {
	            this.maybeDisplayValidationAlert();
	        }
	    },
	    onModelAttributeInvalid: function onModelAttributeInvalid(attr, error, selector, hideAlertMessage) {
	        if (BaseViews.LayoutView.prototype.onModelAttributeInvalid.call(this, attr, error, selector)) {
	            if (!hideAlertMessage) {
	                this.maybeDisplayValidationAlert();
	            }
	        }
	    },
	    bindings: function bindings() {
	        var options = {
	            events: ['blur'],
	            setOptions: {
	                validate: false
	            }
	        };
	
	        var bindings = {
	            '[name=local_delivery_street_address]': _.extend({}, options, { observe: 'local_delivery_street_address' }),
	            '[name=local_delivery_apartment_number]': _.extend({}, options, { observe: 'local_delivery_apartment_number' }),
	            '[name=local_delivery_city]': _.extend({}, options, { observe: 'local_delivery_city' })
	        };
	
	        return bindings;
	    },
	    events: function events() {
	        var self = this;
	
	        function setVisited(ev) {
	            self._setElementAsVisited($(ev.target));
	        }
	        return {
	            'blur input': setVisited
	        };
	    },
	    serializeData: function serializeData() {
	        return {
	            errorMessage: this.options.errorMessage,
	            error: this.options.error
	        };
	    },
	    onRender: function onRender() {
	        var self = this;
	        if (this.options.error) {
	            this.ui.alertMessageText.html(this.options.errorMessage);
	            this.toggleValidationAlert(true);
	        }
	
	        BaseViews.LayoutView.prototype.onRender.call(this);
	    }
	});
	module.exports = CartDeliveryAddressForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	__webpack_require__(594);
	var BaseViews = __webpack_require__(5);
	
	var CartDeliveryNotesForm = BaseViews.LayoutView.extend({
	    className: 'fmcy-cart-delivery-notes-form',
	    template: __webpack_require__(635),
	    initialize: function initialize(options) {
	        var self = this;
	        self.options = _.defaults(options || {}, {
	            _appChannel: null
	        });
	    },
	    bindings: function bindings() {
	        var bindings = {
	            '[name=deliveryNotes]': _.extend({}, {}, { observe: 'deliveryNotes' })
	        };
	
	        return bindings;
	    },
	    onRender: function onRender() {
	        BaseViews.LayoutView.prototype.onRender.call(this);
	    }
	});
	module.exports = CartDeliveryNotesForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var _intlTelInputJquery = __webpack_require__(468);
	
	var _intlTelInputJquery2 = _interopRequireDefault(_intlTelInputJquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(595);
	__webpack_require__(209);
	
	
	var BaseViews = __webpack_require__(5);
	var CartLocationDisplay = __webpack_require__(91);
	
	var CartDeliveryPhoneForm = BaseViews.LayoutView.extend({
	    className: 'fmcy-cart-delivery-phone-form',
	    template: __webpack_require__(636),
	    ui: {
	        alertMessage: '.fmcy-cart-delivery-phone-form-alert-message',
	        alertMessageText: '.alert-danger',
	        phoneInput: '#fmcy-cart-delivery-phone-field'
	    },
	    initialize: function initialize(options) {
	        var self = this;
	        self.options = _.defaults(options || {}, {
	            _appChannel: null,
	            error: false,
	            errorMessage: 'Please enter phone number below.'
	        });
	    },
	    modelEvents: function modelEvents() {
	        var self = this;
	        return _.extend({}, _.result(BaseViews.LayoutView.prototype, 'modelEvents'), {
	            validated: self.maybeDisplayValidationAlert.bind(self)
	        });
	    },
	    validatedFields: function validatedFields() {
	        var validatedFields = ['deliveryPhone'];
	        return validatedFields;
	    },
	    toggleValidationAlert: function toggleValidationAlert(show) {
	        if (show) {
	            this.ui.alertMessage.removeClass('hidden');
	        } else {
	            this.ui.alertMessage.addClass('hidden');
	        }
	    },
	    maybeDisplayValidationAlert: function maybeDisplayValidationAlert() {
	        if (this.$el.find('.has-error').length) {
	            this.toggleValidationAlert(true);
	        } else {
	            this.toggleValidationAlert(false);
	        }
	    },
	    onModelAttributeValid: function onModelAttributeValid(attr, selector) {
	        if (BaseViews.LayoutView.prototype.onModelAttributeValid.call(this, attr, selector)) {
	            this.maybeDisplayValidationAlert();
	        }
	    },
	    onModelAttributeInvalid: function onModelAttributeInvalid(attr, error, selector, hideAlertMessage) {
	        if (BaseViews.LayoutView.prototype.onModelAttributeInvalid.call(this, attr, error, selector)) {
	            if (!hideAlertMessage) {
	                this.maybeDisplayValidationAlert();
	            }
	        }
	    },
	    events: function events() {
	        var self = this;
	
	        function setVisited(ev) {
	            self._setElementAsVisited($(ev.target));
	        }
	        function onChange(ev) {
	            self.model.set('deliveryPhone', self.getNumber());
	        }
	        return {
	            'blur input': setVisited,
	            'keyup @ui.phoneInput': onChange,
	            'change @ui.phoneInput': onChange,
	            'countrychange @ui.phoneInput': onChange
	        };
	    },
	    serializeData: function serializeData() {
	        return {
	            errorMessage: this.options.errorMessage,
	            error: this.options.error
	        };
	    },
	    setNumber: function setNumber(number) {
	        if (this.ui.phoneInput && this.ui.phoneInput.intlTelInput && number) {
	            this.ui.phoneInput.intlTelInput("setNumber", number);
	        }
	    },
	    getNumber: function getNumber() {
	        if (this.ui.phoneInput && this.ui.phoneInput.intlTelInput && this.ui.phoneInput.intlTelInput("getNumber")) {
	            return this.ui.phoneInput.intlTelInput("getNumber");
	        } else {
	            if (this.ui.phoneInput.val()) {
	                var dialcode = this.ui.phoneInput.intlTelInput("getSelectedCountryData").dialCode;
	                return '+' + dialcode + this.ui.phoneInput.val().replace(/[^\d]/g, '');
	            } else {
	                return '';
	            }
	        }
	    },
	    onRender: function onRender() {
	        var self = this;
	        self.ui.phoneInput.intlTelInput({
	            initialCountry: "ca",
	            separateDialCode: true,
	            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js"
	        });
	        if (this.options.error) {
	            this.ui.alertMessageText.html(this.options.errorMessage);
	            this.toggleValidationAlert(true);
	        }
	
	        self.ui.phoneInput.val(this.model.get('deliveryPhone'));
	        self.setNumber(this.model.get('deliveryPhone'));
	
	        BaseViews.LayoutView.prototype.onRender.call(this);
	    }
	});
	module.exports = CartDeliveryPhoneForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	__webpack_require__(596);
	var BaseViews = __webpack_require__(5);
	var TipButtonToggle = __webpack_require__(359);
	var TipCollection = __webpack_require__(235).TipCollection;
	var CartDeliveryTip = BaseViews.LayoutView.extend({
	    className: 'fmcy-cart-delivery-tip',
	    initialize: function initialize(options) {
	        var self = this;
	        self.options = _.defaults(options || {}, {
	            _appChannel: null,
	            expandedDetails: true,
	            selectedValue: 0.15
	        });
	    },
	    ui: {
	        expandedDetails: '.fmcy-cart-tip-expanded-details',
	        arrow: '.fmcy-cart-tip-arrow'
	    },
	    regions: {
	        buttonToggleRegion: '.fmcy-cart-delivery-tip-button-toggle-region'
	    },
	    template: __webpack_require__(637),
	    renderButtonToggle: function renderButtonToggle() {
	        var self = this;
	        this.tipButtonToggle = new TipButtonToggle({
	            selectedValue: this.options.selectedValue,
	            collection: TipCollection
	        });
	        this.tipButtonToggle.on('tip:selected', function (value) {
	            self.model.set('deliveryTipPercentage', value);
	            self.tipButtonToggle.options.selectedValue = value;
	            self.tipButtonToggle.render();
	            self.trigger('update');
	        });
	
	        this.buttonToggleRegion.show(this.tipButtonToggle);
	    },
	    onRender: function onRender() {
	        this.renderButtonToggle();
	        if (this.options.expandedDetails == true) {
	            this.ui.expandedDetails.css('display', 'block');
	            this.ui.arrow.css('display', 'none');
	        } else {
	            this.ui.expandedDetails.css('display', 'none');
	            this.ui.arrow.css('display', 'block');
	            this.$el.addClass('fmcy-cart-tip-below');
	        }
	        BaseViews.LayoutView.prototype.onRender.call(this);
	    }
	});
	module.exports = CartDeliveryTip;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	__webpack_require__(597);
	var BaseViews = __webpack_require__(5);
	
	var CartGiftForm = BaseViews.LayoutView.extend({
	    className: 'fmcy-cart-gift-form',
	    template: __webpack_require__(638),
	    ui: {
	        nameInput: '#fmcy-cart-gift-form-name-field',
	        alertMessage: '.fmcy-cart-gift-form-alert-message',
	        alertMessageText: '.alert-danger'
	    },
	    initialize: function initialize(options) {
	        var self = this;
	        self.options = _.defaults(options || {}, {
	            autoFocusPrimaryField: false
	        });
	    },
	    validateVisitedFieldsOnly: false,
	    modelEvents: function modelEvents() {
	        var self = this;
	        return _.extend({}, _.result(BaseViews.LayoutView.prototype, 'modelEvents'), {
	            validated: self.maybeDisplayValidationAlert.bind(self)
	        });
	    },
	    validatedFields: function validatedFields() {
	        var validatedFields = ['gift_receiver_name', 'gift_receiver_email'];
	        return validatedFields;
	    },
	    toggleValidationAlert: function toggleValidationAlert(show) {
	        if (show) {
	            this.ui.alertMessage.removeClass('hidden');
	        } else {
	            this.ui.alertMessage.addClass('hidden');
	        }
	    },
	    maybeDisplayValidationAlert: function maybeDisplayValidationAlert() {
	        /*
	        if (this.$el.find('.has-error').length) {
	            this.toggleValidationAlert(true);
	        } else {
	            this.toggleValidationAlert(false);
	        }
	        */
	    },
	    onModelAttributeValid: function onModelAttributeValid(attr, selector) {
	        if (BaseViews.LayoutView.prototype.onModelAttributeValid.call(this, attr, selector)) {
	            this.maybeDisplayValidationAlert();
	        }
	    },
	    onModelAttributeInvalid: function onModelAttributeInvalid(attr, error, selector, hideAlertMessage) {
	        if (BaseViews.LayoutView.prototype.onModelAttributeInvalid.call(this, attr, error, selector)) {
	            if (!hideAlertMessage) {
	                this.maybeDisplayValidationAlert();
	            }
	        }
	    },
	    bindings: function bindings() {
	        var options = {
	            events: ['blur'],
	            setOptions: {
	                validate: false
	            }
	        };
	        var bindings = {
	            '[name=gift_receiver_name]': _.extend({}, options, { observe: 'gift_receiver_name' }),
	            '[name=gift_receiver_email]': _.extend({}, options, { observe: 'gift_receiver_email' }),
	            '[name=gift_receiver_message]': _.extend({}, options, { observe: 'gift_receiver_message' })
	        };
	
	        return bindings;
	    },
	    events: function events() {
	        var self = this;
	
	        function setVisited(ev) {
	            self._setElementAsVisited($(ev.target));
	        }
	        return {
	            'blur input': setVisited,
	            'click select': setVisited
	        };
	    },
	    serializeData: function serializeData() {
	        return {
	            options: this.options
	        };
	    },
	    onRender: function onRender() {
	        var self = this;
	
	        if (self.options.autoFocusPrimaryField) {
	            setTimeout(function () {
	                self.ui.nameInput.trigger('focus');
	            }, 0);
	        }
	
	        if (this.options.error) {
	            setTimeout(function () {
	                self.model.isValid(self.model.validationFields());
	            }, 100);
	        }
	
	        BaseViews.LayoutView.prototype.onRender.call(this);
	    }
	});
	module.exports = CartGiftForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	__webpack_require__(209);
	__webpack_require__(198);
	__webpack_require__(598);
	var BaseViews = __webpack_require__(5);
	
	var CreditCardForm = BaseViews.LayoutView.extend({
	    className: 'fmcy-credit-card-form',
	    template: __webpack_require__(639),
	    ui: {
	        postalCodeInput: '#fmcy-credit-card-form-postal-code-field',
	        nameInput: '#fmcy-credit-card-form-name-field',
	        ccInput: '#fmcy-credit-card-form-cc-field',
	        ccInputCardIcon: '.fmcy-cart-payment-field-credit-card-icon',
	        ccExpiryInput: '#fmcy-credit-card-form-cc-expiry-field',
	        ccSecurityInput: '#fmcy-credit-card-form-cc-security-field',
	        alertMessage: '.fmcy-credit-card-form-alert-message',
	        alertMessageText: '.alert-danger'
	    },
	    initialize: function initialize(options) {
	        var self = this;
	        self.options = _.defaults(options || {}, {
	            autoFocusPrimaryField: false
	        });
	
	        self.model.on('change:cc_card_type', function () {
	            self._renderCCFieldIcon();
	        });
	    },
	    validateVisitedFieldsOnly: true,
	    modelEvents: function modelEvents() {
	        var self = this;
	        return _.extend({}, _.result(BaseViews.LayoutView.prototype, 'modelEvents'), {
	            validated: self.maybeDisplayValidationAlert.bind(self)
	        });
	    },
	    validatedFields: function validatedFields() {
	        var validatedFields = ['cc_name_on_card', 'cc_number', 'cc_expiry_date', 'cc_security_code', 'cc_postal_code'];
	        return validatedFields;
	    },
	    toggleValidationAlert: function toggleValidationAlert(show) {
	        if (show) {
	            this.ui.alertMessage.removeClass('hidden');
	            this.options._appChannel.request('scroll:to:page:top');
	        } else {
	            this.ui.alertMessage.addClass('hidden');
	        }
	    },
	    maybeDisplayValidationAlert: function maybeDisplayValidationAlert() {
	        if (this.$el.find('.has-error').length) {
	            this.toggleValidationAlert(true);
	        } else {
	            this.toggleValidationAlert(false);
	        }
	    },
	    onModelAttributeValid: function onModelAttributeValid(attr, selector) {
	        if (BaseViews.LayoutView.prototype.onModelAttributeValid.call(this, attr, selector)) {
	            this.maybeDisplayValidationAlert();
	        }
	    },
	    onModelAttributeInvalid: function onModelAttributeInvalid(attr, error, selector, hideAlertMessage) {
	        if (BaseViews.LayoutView.prototype.onModelAttributeInvalid.call(this, attr, error, selector)) {
	            if (!hideAlertMessage) {
	                this.maybeDisplayValidationAlert();
	            }
	        }
	    },
	    bindings: function bindings() {
	        var options = {
	            events: ['blur'],
	            setOptions: {
	                validate: true
	            }
	        };
	        var bindings = {
	            '[name=cc_name_on_card]': _.extend({}, options, { observe: 'cc_name_on_card' }),
	            '[name=cc_number]': _.extend({}, options, { observe: 'cc_number' }),
	            '[name=cc_expiry_date]': _.extend({}, options, { observe: 'cc_expiry_date' }),
	            '[name=cc_security_code]': _.extend({}, options, { observe: 'cc_security_code' }),
	            '[name=cc_postal_code]': _.extend({}, options, { observe: 'cc_postal_code' })
	        };
	
	        return bindings;
	    },
	    _renderCCFieldIcon: function _renderCCFieldIcon() {
	        var self = this;
	        if (this.ui.ccInputCardIcon && typeof this.ui.ccInputCardIcon.removeClass === 'function') {
	            this.ui.ccInputCardIcon.removeClass('visa-xs');
	            this.ui.ccInputCardIcon.removeClass('amex-xs');
	            this.ui.ccInputCardIcon.removeClass('discover-xs');
	            this.ui.ccInputCardIcon.removeClass('mastercard-xs');
	            if (this.model.get('cc_card_type') && typeof this.ui.ccInputCardIcon.addClass === 'function') {
	                this.ui.ccInputCardIcon.addClass(self.model.get('cc_card_type') + '-xs');
	            }
	        }
	    },
	    events: function events() {
	        var self = this;
	
	        function setVisited(ev) {
	            self._setElementAsVisited($(ev.target));
	        }
	
	        function ccInputChanged() {
	            self.prevCardType = self.cardType;
	            self.cardType = $.payment.cardType(self.ui.ccInput.val());
	            self.model.set('cc_card_type', self.cardType);
	        }
	
	        return {
	            'blur input': setVisited,
	            'keyup @ui.ccInput': ccInputChanged,
	            'click select': setVisited
	        };
	    },
	    serializeData: function serializeData() {
	        return {
	            options: this.options
	        };
	    },
	    onRender: function onRender() {
	        var self = this;
	
	        self.ui.ccInput.payment('formatCardNumber');
	        self.ui.ccExpiryInput.payment('formatCardExpiry');
	        self.ui.ccSecurityInput.payment('formatCardCVC');
	
	        if (self.options.autoFocusPrimaryField) {
	            setTimeout(function () {
	                self.ui.nameInput.trigger('focus');
	            }, 0);
	        }
	
	        if (this.options.errorField) {
	            this.onModelAttributeInvalid(this.options.errorField, null, null, true);
	        }
	
	        this.listenTo(this.options._appChannel, 'cart:display:errors', function () {
	            self.validateVisitedFieldsOnly = false;
	            self.model.isValid(self.model.validationFields());
	            self.validateVisitedFieldsOnly = true;
	        });
	        BaseViews.LayoutView.prototype.onRender.call(this);
	    }
	});
	module.exports = CreditCardForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette, _) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	
	__webpack_require__(599);
	
	var CartEmpty = BaseViews.ItemView.extend({
	    className: 'fmcy-cart-items-empty',
	    template: function template() {
	        return 'Your cart is currently empty';
	    }
	});
	
	var CartItem = __webpack_require__(360);
	
	var CartItems = Marionette.CollectionView.extend({
	    className: 'fmcy-cart-items',
	    emptyView: CartEmpty,
	    childView: CartItem,
	    childViewOptions: function childViewOptions(model, index) {
	        return {
	            errors: this.options.errors
	        };
	    },
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            theme: 'light',
	            _appChannel: null,
	            errors: null
	        });
	    },
	    onChildviewClickItem: function onChildviewClickItem(view) {
	        if (view.model.get('slug')) {
	            this.options._appChannel.request('load:product', view.model.get('slug'));
	        }
	    },
	    onChildviewDeleteItem: function onChildviewDeleteItem(view) {
	        var self = this;
	        var childView = this.children.findByModel(view.model);
	        if (childView) {
	            childView.hideItem();
	        }
	        this.options._appChannel.trigger('cart:remove:item', view.model);
	        this.trigger('cart:remove:item', view.model);
	        this.options._appChannel.trigger('cart:items:update:subtotals');
	        this.collection.each(function (model) {
	            if (model) {
	                var childView = self.children.findByModel(model);
	                if (childView) {
	                    childView._updateItemTotal();
	                }
	            }
	        });
	    },
	    onChildviewCartItemQtyUpdated: function onChildviewCartItemQtyUpdated(view) {
	        var self = this;
	        this.options._appChannel.trigger('cart:items:update:subtotals');
	        this.collection.each(function (model) {
	            if (model) {
	                var childView = self.children.findByModel(model);
	                if (childView) {
	                    childView._updateItemTotal();
	                    if (parseInt(model.get('cartCount')) <= 0) {
	                        view.trigger('delete:item', this);
	                    }
	                }
	            }
	        });
	
	        this.options._appChannel.trigger('cart:items:updated');
	    }
	});
	
	module.exports = CartItems;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15), __webpack_require__(1)))

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	__webpack_require__(600);
	
	var CartTotalWeight = BaseViews.LayoutView.extend({
	  className: 'fmcy-cart-total-weight',
	  template: __webpack_require__(640),
	  initialize: function initialize(options) {
	    var self = this;
	    var defaults = {
	      theme: 'light',
	      weight: 0,
	      hidden: false,
	      weightError: false,
	      messagePrefix: 'Cart total cannabis equivalent product weight: ',
	      messageSuffix: ' grams',
	      subMessageDefault: 'Maximum of 30 grams of cannabis equivalent per an order',
	      errorMessage: 'Your order exceeds the maximum of 30 grams of cannabis equivalent per an order.'
	    };
	
	    this.options = _.defaults(options || {}, defaults);
	
	    if (this.options.errorMessage == null) {
	      this.options.errorMessage = defaults.errorMessage;
	    }
	  },
	  serializeData: function serializeData() {
	    return {
	      subMessage: this.options.subMessageDefault
	    };
	  },
	  updateMessage: function updateMessage(weight) {
	    this.ui.totalWeightMessage.html(this.options.messagePrefix + weight.totalWeight + this.options.messageSuffix);
	
	    if (this.options.weightError || weight.error) {
	      if (!this.$el.hasClass('cart-total-error-message')) {
	        this.$el.addClass('cart-total-error-message');
	      }
	      this.ui.subMessage.html(this.options.errorMessage);
	    } else {
	      if (this.$el.hasClass('cart-total-error-message')) {
	        this.$el.removeClass('cart-total-error-message');
	      }
	      this.ui.subMessage.html(this.options.subMessageDefault);
	    }
	  },
	  ui: {
	    totalWeightMessage: '.fmcy-cart-total-weight-inner',
	    subMessage: '.fmcy-cart-total-weight-sub-message-text'
	  },
	  hide: function hide() {
	    this.$el.hide();
	  },
	  show: function show() {
	    this.$el.show();
	  },
	  onRender: function onRender() {
	    var self = this;
	    this.updateMessage(this.options.weight);
	    if (this.options.hidden) {
	      this.$el.hide();
	    }
	    BaseViews.LayoutView.prototype.onRender.call(self);
	  },
	  onDestroy: function onDestroy() {
	    BaseViews.LayoutView.prototype.onDestroy.call(self);
	  }
	});
	
	module.exports = CartTotalWeight;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 492 */,
/* 493 */,
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	__webpack_require__(608);
	var BaseViews = __webpack_require__(5);
	var ThumbnailItem = BaseViews.LayoutView.extend({
	    className: 'fmcy-thumbnail-item',
	    template: __webpack_require__(648),
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            videoStyle: 'thumb',
	            extraClassName: null
	        });
	    },
	    ui: {
	        thumbImage: '.fmcy-thumbnail-item-image'
	    },
	    events: {
	        'click': 'onClick'
	    },
	    onClick: function onClick() {
	        this.trigger('thumb:clicked');
	    },
	    setActive: function setActive() {
	        this.$el.addClass('thumbnail-item-selected');
	    },
	    reset: function reset() {
	        this.$el.removeClass('thumbnail-item-selected');
	    },
	    onRender: function onRender() {
	        if (this.options.extraClassName) {
	            this.$el.addClass(this.options.extraClassName);
	        }
	        var imageURL = this.model.get('thumb_url');
	
	        this.ui.thumbImage.css('background-image', 'url(' + imageURL + ')');
	    },
	    serializeData: function serializeData() {
	        return {
	            videoStyle: this.options.videoStyle,
	            description: this.model.get('description'),
	            name: this.model.get('name')
	        };
	    }
	});
	
	module.exports = ThumbnailItem;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 495 */,
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	__webpack_require__(610);
	var SearchFilterTabs = __webpack_require__(362);
	var DropdownList = __webpack_require__(43);
	
	var SearchFilters = BaseViews.LayoutView.extend({
	    _tabs: null,
	    _dropdownList: null,
	    template: __webpack_require__(650),
	    className: 'fmcy-search-filters clearfix',
	    regions: {
	        searchFilterTabsRegion: '.fmcy-search-filter-tabs-region',
	        searchFilterDropdownListRegion: '.fmcy-search-filter-dropdown-list-region'
	    },
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            initialFilter: 'all',
	            style: 'default',
	            caption: ''
	        });
	    },
	    setFilterActive: function setFilterActive(model) {
	        if (!this.isRendered) {
	            return;
	        }
	        this._tabs.setFilterActive(model);
	    },
	    _renderSearchFilterTabs: function _renderSearchFilterTabs() {
	        var self = this;
	        self._tabs = new SearchFilterTabs({
	            collection: self.options.collection,
	            initialFilter: self.options.initialFilter,
	            style: self.options.style
	        });
	
	        self._tabs.on('filter:clicked', function (selected) {
	            self.trigger('filter:clicked', selected);
	        });
	
	        self.searchFilterTabsRegion.show(self._tabs);
	    },
	    serializeData: function serializeData() {
	        return {
	            options: this.options
	        };
	    },
	    onRender: function onRender() {
	        this._renderSearchFilterTabs();
	    }
	});
	module.exports = SearchFilters;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette, _) {'use strict';
	
	var SearchOptionsItem = __webpack_require__(363);
	var SearchOptions = Marionette.CollectionView.extend({
	    tagName: 'select',
	    className: 'fmcy-search-options form-control',
	    events: {
	        change: 'optionSelected'
	    },
	    initialize: function initialize(options) {
	        this.options = _.defaults(options || {}, {});
	    },
	    onBeforeShow: function onBeforeShow() {
	        this.selectedModel = this.collection.at(0);
	    },
	    optionSelected: function optionSelected(event) {
	        this.selectedModel = this.collection.get(event.currentTarget.selectedOptions[0].id);
	        this.trigger('search:option:selected', this.selectedModel);
	    },
	    template: function template() {
	        return '';
	    },
	    childView: SearchOptionsItem
	});
	module.exports = SearchOptions;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15), __webpack_require__(1)))

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette, _) {'use strict';
	
	__webpack_require__(612);
	var OrderItem = __webpack_require__(364);
	var OrderItems = Marionette.CollectionView.extend({
	    className: 'fmcy-order-items row-flex clearfix',
	    childView: OrderItem,
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            style: 'condensed'
	        });
	    },
	    childViewOptions: function childViewOptions(model, index) {
	        var extraClassName = 'col-flex-xs-12';
	        return {
	            collection: this.options.collection,
	            extraClassName: extraClassName,
	            _appChannel: this.options._appChannel
	        };
	    },
	    onRender: function onRender() {
	        var self = this;
	        this.$el.addClass(this.options.style);
	        this.listenTo(this.options._appChannel, 'orders:updated', function () {
	            self.render();
	        });
	    }
	});
	module.exports = OrderItems;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15), __webpack_require__(1)))

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette, _) {'use strict';
	
	__webpack_require__(613);
	var VideoItem = __webpack_require__(365);
	var VideoItems = Marionette.CollectionView.extend({
	    className: 'fmcy-video-items row-flex clearfix',
	    childView: VideoItem,
	    childEvents: {
	        'thumb:clicked': 'onChildThumbClicked'
	    },
	    onChildThumbClicked: function onChildThumbClicked(childView) {
	        this.trigger('thumb:clicked', childView.model, this.options.collection);
	    },
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            thumbStyle: 'thumbs'
	        });
	    },
	    childViewOptions: function childViewOptions(model, index) {
	        var extraClassName = 'col-flex-xs-12';
	        var videoStyle = 'thumb';
	        if (index === 0 && this.options.collection.length !== 2) {
	            videoStyle = 'feature';
	        }
	        if (videoStyle === 'thumb') {
	            extraClassName += ' col-flex-sm-6';
	        }
	        if (this.options.collection.length === 4 && videoStyle !== 'feature') {
	            extraClassName += ' col-flex-md-4';
	        }
	
	        return {
	            collection: this.options.collection,
	            extraClassName: extraClassName,
	            videoStyle: videoStyle
	        };
	    },
	    onRender: function onRender() {
	        this.$el.addClass(this.options.thumbStyle);
	    }
	});
	module.exports = VideoItems;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15), __webpack_require__(1)))

/***/ },
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-cart-delivery-address-form {\n  padding: 0px 10px;\n  background-color: #1f1e1e; }\n  .fmcy-cart-delivery-address-form .fmcy-cart-delivery-address-form-title {\n    height: 54px;\n    color: #ffff;\n    background-color: #1f1e1e;\n    border-bottom: 1px #000 solid;\n    line-height: 57px;\n    font-size: 150%; }\n  .fmcy-cart-delivery-address-form .fmcy-cart-delivery-address-form-header {\n    color: #fff;\n    font-size: 90%;\n    font-weight: 700;\n    padding: 10px 0px;\n    font-family: 'droid_serif' !important; }\n  .fmcy-cart-delivery-address-form .fmcy-cart-delivery-address-field-label,\n  .fmcy-cart-delivery-address-form .fmcy-cart-delivery-apartment-number-field-label,\n  .fmcy-cart-delivery-address-form .fmcy-cart-delivery-city-field-label {\n    font-size: 90%;\n    color: #fff;\n    padding-bottom: 5px;\n    margin-bottom: 0px;\n    font-family: 'droid_serif' !important;\n    font-weight: 700; }\n  .fmcy-cart-delivery-address-form .fmcy-cart-delivery-address-form-alert-message {\n    margin-left: 0px !important;\n    margin-right: 0px !important; }\n    .fmcy-cart-delivery-address-form .fmcy-cart-delivery-address-form-alert-message .alert-danger {\n      text-align: left;\n      color: #a94442;\n      background-color: #f2dede;\n      font-size: 100%;\n      font-weight: 700;\n      padding: 10px 10px;\n      border: 1px solid transparent;\n      border-radius: 4px;\n      font-family: 'droid_serif' !important; }\n  .fmcy-cart-delivery-address-form .fmcy-cart-delivery-address-form-required-legend {\n    margin-bottom: 20px; }\n", ""]);
	
	// exports


/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-cart-delivery-notes-form {\n  padding: 0px 10px;\n  background-color: #1f1e1e; }\n  .fmcy-cart-delivery-notes-form .fmcy-cart-delivery-notes-form-title {\n    height: 54px;\n    color: #ffff;\n    background-color: #1f1e1e;\n    border-bottom: 1px #000 solid;\n    line-height: 57px;\n    font-size: 150%; }\n  .fmcy-cart-delivery-notes-form .fmcy-cart-delivery-notes-form-header {\n    color: #fff;\n    font-size: 90%;\n    font-weight: 700;\n    padding: 10px 0px;\n    font-family: 'droid_serif' !important; }\n", ""]);
	
	// exports


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".iti {\n  position: relative;\n  display: inline-block; }\n\n.iti * {\n  box-sizing: border-box; }\n\n.iti__hide {\n  display: none; }\n\n.iti__v-hide {\n  visibility: hidden; }\n\n.iti input,\n.iti input[type=text],\n.iti input[type=tel] {\n  position: relative;\n  z-index: 0;\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n  padding-right: 36px;\n  margin-right: 0; }\n\n.iti__flag-container {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  padding: 1px; }\n\n.iti__selected-flag {\n  z-index: 1;\n  position: relative;\n  display: flex;\n  align-items: center;\n  height: 100%;\n  padding: 0 6px 0 8px; }\n\n.iti__arrow {\n  margin-left: 6px;\n  width: 0;\n  height: 0;\n  border-left: 3px solid transparent;\n  border-right: 3px solid transparent;\n  border-top: 4px solid #555; }\n\n[dir=rtl] .iti__arrow {\n  margin-right: 6px;\n  margin-left: 0; }\n\n.iti__arrow--up {\n  border-top: none;\n  border-bottom: 4px solid #555; }\n\n.iti__country-list {\n  position: absolute;\n  z-index: 2;\n  list-style: none;\n  padding: 0;\n  margin: 0 0 0 -1px;\n  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);\n  background-color: white;\n  border: 1px solid #ccc;\n  white-space: nowrap;\n  max-height: 200px;\n  overflow-y: scroll;\n  -webkit-overflow-scrolling: touch; }\n\n.iti__country-list--dropup {\n  bottom: 100%;\n  margin-bottom: -1px; }\n\n@media (max-width: 500px) {\n  .iti__country-list {\n    white-space: normal; } }\n\n.iti__flag-box {\n  display: inline-block;\n  width: 20px; }\n\n.iti__divider {\n  padding-bottom: 5px;\n  margin-bottom: 5px;\n  border-bottom: 1px solid #ccc; }\n\n.iti__country {\n  display: flex;\n  align-items: center;\n  padding: 5px 10px;\n  outline: none; }\n\n.iti__dial-code {\n  color: #999; }\n\n.iti__country.iti__highlight {\n  background-color: rgba(0, 0, 0, 0.05); }\n\n.iti__flag-box, .iti__country-name {\n  margin-right: 6px; }\n\n[dir=rtl] .iti__flag-box, [dir=rtl] .iti__country-name {\n  margin-right: 0;\n  margin-left: 6px; }\n\n.iti--allow-dropdown input,\n.iti--allow-dropdown input[type=text],\n.iti--allow-dropdown input[type=tel], .iti--separate-dial-code input,\n.iti--separate-dial-code input[type=text],\n.iti--separate-dial-code input[type=tel] {\n  padding-right: 6px;\n  padding-left: 52px;\n  margin-left: 0; }\n\n[dir=rtl] .iti--allow-dropdown input,\n[dir=rtl] .iti--allow-dropdown input[type=text],\n[dir=rtl] .iti--allow-dropdown input[type=tel], [dir=rtl] .iti--separate-dial-code input,\n[dir=rtl] .iti--separate-dial-code input[type=text],\n[dir=rtl] .iti--separate-dial-code input[type=tel] {\n  padding-right: 52px;\n  padding-left: 6px;\n  margin-right: 0; }\n\n.iti--allow-dropdown .iti__flag-container, .iti--separate-dial-code .iti__flag-container {\n  right: auto;\n  left: 0; }\n\n[dir=rtl] .iti--allow-dropdown .iti__flag-container, [dir=rtl] .iti--separate-dial-code .iti__flag-container {\n  right: 0;\n  left: auto; }\n\n.iti--allow-dropdown .iti__flag-container:hover {\n  cursor: pointer; }\n\n.iti--allow-dropdown .iti__flag-container:hover .iti__selected-flag {\n  background-color: rgba(0, 0, 0, 0.05); }\n\n.iti--allow-dropdown input[disabled] + .iti__flag-container:hover,\n.iti--allow-dropdown input[readonly] + .iti__flag-container:hover {\n  cursor: default; }\n\n.iti--allow-dropdown input[disabled] + .iti__flag-container:hover .iti__selected-flag,\n.iti--allow-dropdown input[readonly] + .iti__flag-container:hover .iti__selected-flag {\n  background-color: transparent; }\n\n.iti--separate-dial-code .iti__selected-flag {\n  background-color: rgba(0, 0, 0, 0.05); }\n\n.iti--separate-dial-code.iti--show-flags .iti__selected-dial-code {\n  margin-left: 6px; }\n\n[dir=rtl] .iti--separate-dial-code.iti--show-flags .iti__selected-dial-code {\n  margin-left: 0;\n  margin-right: 6px; }\n\n.iti--container {\n  position: absolute;\n  top: -1000px;\n  left: -1000px;\n  z-index: 1060;\n  padding: 1px; }\n\n.iti--container:hover {\n  cursor: pointer; }\n\n.iti-mobile .iti--container {\n  top: 30px;\n  bottom: 30px;\n  left: 30px;\n  right: 30px;\n  position: fixed; }\n\n.iti-mobile .iti__country-list {\n  max-height: 100%;\n  width: 100%; }\n\n.iti-mobile .iti__country {\n  padding: 10px 10px;\n  line-height: 1.5em; }\n\n.iti__flag {\n  width: 20px; }\n\n.iti__flag.iti__be {\n  width: 18px; }\n\n.iti__flag.iti__ch {\n  width: 15px; }\n\n.iti__flag.iti__mc {\n  width: 19px; }\n\n.iti__flag.iti__ne {\n  width: 18px; }\n\n.iti__flag.iti__np {\n  width: 13px; }\n\n.iti__flag.iti__va {\n  width: 15px; }\n\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {\n  .iti__flag {\n    background-size: 5762px 15px; } }\n\n.iti__flag.iti__ac {\n  height: 10px;\n  background-position: 0px 0px; }\n\n.iti__flag.iti__ad {\n  height: 14px;\n  background-position: -22px 0px; }\n\n.iti__flag.iti__ae {\n  height: 10px;\n  background-position: -44px 0px; }\n\n.iti__flag.iti__af {\n  height: 14px;\n  background-position: -66px 0px; }\n\n.iti__flag.iti__ag {\n  height: 14px;\n  background-position: -88px 0px; }\n\n.iti__flag.iti__ai {\n  height: 10px;\n  background-position: -110px 0px; }\n\n.iti__flag.iti__al {\n  height: 15px;\n  background-position: -132px 0px; }\n\n.iti__flag.iti__am {\n  height: 10px;\n  background-position: -154px 0px; }\n\n.iti__flag.iti__ao {\n  height: 14px;\n  background-position: -176px 0px; }\n\n.iti__flag.iti__aq {\n  height: 14px;\n  background-position: -198px 0px; }\n\n.iti__flag.iti__ar {\n  height: 13px;\n  background-position: -220px 0px; }\n\n.iti__flag.iti__as {\n  height: 10px;\n  background-position: -242px 0px; }\n\n.iti__flag.iti__at {\n  height: 14px;\n  background-position: -264px 0px; }\n\n.iti__flag.iti__au {\n  height: 10px;\n  background-position: -286px 0px; }\n\n.iti__flag.iti__aw {\n  height: 14px;\n  background-position: -308px 0px; }\n\n.iti__flag.iti__ax {\n  height: 13px;\n  background-position: -330px 0px; }\n\n.iti__flag.iti__az {\n  height: 10px;\n  background-position: -352px 0px; }\n\n.iti__flag.iti__ba {\n  height: 10px;\n  background-position: -374px 0px; }\n\n.iti__flag.iti__bb {\n  height: 14px;\n  background-position: -396px 0px; }\n\n.iti__flag.iti__bd {\n  height: 12px;\n  background-position: -418px 0px; }\n\n.iti__flag.iti__be {\n  height: 15px;\n  background-position: -440px 0px; }\n\n.iti__flag.iti__bf {\n  height: 14px;\n  background-position: -460px 0px; }\n\n.iti__flag.iti__bg {\n  height: 12px;\n  background-position: -482px 0px; }\n\n.iti__flag.iti__bh {\n  height: 12px;\n  background-position: -504px 0px; }\n\n.iti__flag.iti__bi {\n  height: 12px;\n  background-position: -526px 0px; }\n\n.iti__flag.iti__bj {\n  height: 14px;\n  background-position: -548px 0px; }\n\n.iti__flag.iti__bl {\n  height: 14px;\n  background-position: -570px 0px; }\n\n.iti__flag.iti__bm {\n  height: 10px;\n  background-position: -592px 0px; }\n\n.iti__flag.iti__bn {\n  height: 10px;\n  background-position: -614px 0px; }\n\n.iti__flag.iti__bo {\n  height: 14px;\n  background-position: -636px 0px; }\n\n.iti__flag.iti__bq {\n  height: 14px;\n  background-position: -658px 0px; }\n\n.iti__flag.iti__br {\n  height: 14px;\n  background-position: -680px 0px; }\n\n.iti__flag.iti__bs {\n  height: 10px;\n  background-position: -702px 0px; }\n\n.iti__flag.iti__bt {\n  height: 14px;\n  background-position: -724px 0px; }\n\n.iti__flag.iti__bv {\n  height: 15px;\n  background-position: -746px 0px; }\n\n.iti__flag.iti__bw {\n  height: 14px;\n  background-position: -768px 0px; }\n\n.iti__flag.iti__by {\n  height: 10px;\n  background-position: -790px 0px; }\n\n.iti__flag.iti__bz {\n  height: 12px;\n  background-position: -812px 0px; }\n\n.iti__flag.iti__ca {\n  height: 10px;\n  background-position: -834px 0px; }\n\n.iti__flag.iti__cc {\n  height: 10px;\n  background-position: -856px 0px; }\n\n.iti__flag.iti__cd {\n  height: 15px;\n  background-position: -878px 0px; }\n\n.iti__flag.iti__cf {\n  height: 14px;\n  background-position: -900px 0px; }\n\n.iti__flag.iti__cg {\n  height: 14px;\n  background-position: -922px 0px; }\n\n.iti__flag.iti__ch {\n  height: 15px;\n  background-position: -944px 0px; }\n\n.iti__flag.iti__ci {\n  height: 14px;\n  background-position: -961px 0px; }\n\n.iti__flag.iti__ck {\n  height: 10px;\n  background-position: -983px 0px; }\n\n.iti__flag.iti__cl {\n  height: 14px;\n  background-position: -1005px 0px; }\n\n.iti__flag.iti__cm {\n  height: 14px;\n  background-position: -1027px 0px; }\n\n.iti__flag.iti__cn {\n  height: 14px;\n  background-position: -1049px 0px; }\n\n.iti__flag.iti__co {\n  height: 14px;\n  background-position: -1071px 0px; }\n\n.iti__flag.iti__cp {\n  height: 14px;\n  background-position: -1093px 0px; }\n\n.iti__flag.iti__cq {\n  height: 12px;\n  background-position: -1115px 0px; }\n\n.iti__flag.iti__cr {\n  height: 12px;\n  background-position: -1137px 0px; }\n\n.iti__flag.iti__cu {\n  height: 10px;\n  background-position: -1159px 0px; }\n\n.iti__flag.iti__cv {\n  height: 12px;\n  background-position: -1181px 0px; }\n\n.iti__flag.iti__cw {\n  height: 14px;\n  background-position: -1203px 0px; }\n\n.iti__flag.iti__cx {\n  height: 10px;\n  background-position: -1225px 0px; }\n\n.iti__flag.iti__cy {\n  height: 14px;\n  background-position: -1247px 0px; }\n\n.iti__flag.iti__cz {\n  height: 14px;\n  background-position: -1269px 0px; }\n\n.iti__flag.iti__de {\n  height: 12px;\n  background-position: -1291px 0px; }\n\n.iti__flag.iti__dg {\n  height: 10px;\n  background-position: -1313px 0px; }\n\n.iti__flag.iti__dj {\n  height: 14px;\n  background-position: -1335px 0px; }\n\n.iti__flag.iti__dk {\n  height: 15px;\n  background-position: -1357px 0px; }\n\n.iti__flag.iti__dm {\n  height: 10px;\n  background-position: -1379px 0px; }\n\n.iti__flag.iti__do {\n  height: 14px;\n  background-position: -1401px 0px; }\n\n.iti__flag.iti__dz {\n  height: 14px;\n  background-position: -1423px 0px; }\n\n.iti__flag.iti__ea {\n  height: 14px;\n  background-position: -1445px 0px; }\n\n.iti__flag.iti__ec {\n  height: 14px;\n  background-position: -1467px 0px; }\n\n.iti__flag.iti__ee {\n  height: 13px;\n  background-position: -1489px 0px; }\n\n.iti__flag.iti__eg {\n  height: 14px;\n  background-position: -1511px 0px; }\n\n.iti__flag.iti__eh {\n  height: 10px;\n  background-position: -1533px 0px; }\n\n.iti__flag.iti__er {\n  height: 10px;\n  background-position: -1555px 0px; }\n\n.iti__flag.iti__es {\n  height: 14px;\n  background-position: -1577px 0px; }\n\n.iti__flag.iti__et {\n  height: 10px;\n  background-position: -1599px 0px; }\n\n.iti__flag.iti__eu {\n  height: 14px;\n  background-position: -1621px 0px; }\n\n.iti__flag.iti__ez {\n  height: 14px;\n  background-position: -1643px 0px; }\n\n.iti__flag.iti__fi {\n  height: 12px;\n  background-position: -1665px 0px; }\n\n.iti__flag.iti__fj {\n  height: 10px;\n  background-position: -1687px 0px; }\n\n.iti__flag.iti__fk {\n  height: 10px;\n  background-position: -1709px 0px; }\n\n.iti__flag.iti__fm {\n  height: 11px;\n  background-position: -1731px 0px; }\n\n.iti__flag.iti__fo {\n  height: 15px;\n  background-position: -1753px 0px; }\n\n.iti__flag.iti__fr {\n  height: 14px;\n  background-position: -1775px 0px; }\n\n.iti__flag.iti__fx {\n  height: 14px;\n  background-position: -1797px 0px; }\n\n.iti__flag.iti__ga {\n  height: 15px;\n  background-position: -1819px 0px; }\n\n.iti__flag.iti__gb {\n  height: 10px;\n  background-position: -1841px 0px; }\n\n.iti__flag.iti__gd {\n  height: 12px;\n  background-position: -1863px 0px; }\n\n.iti__flag.iti__ge {\n  height: 14px;\n  background-position: -1885px 0px; }\n\n.iti__flag.iti__gf {\n  height: 14px;\n  background-position: -1907px 0px; }\n\n.iti__flag.iti__gg {\n  height: 14px;\n  background-position: -1929px 0px; }\n\n.iti__flag.iti__gh {\n  height: 14px;\n  background-position: -1951px 0px; }\n\n.iti__flag.iti__gi {\n  height: 10px;\n  background-position: -1973px 0px; }\n\n.iti__flag.iti__gl {\n  height: 14px;\n  background-position: -1995px 0px; }\n\n.iti__flag.iti__gm {\n  height: 14px;\n  background-position: -2017px 0px; }\n\n.iti__flag.iti__gn {\n  height: 14px;\n  background-position: -2039px 0px; }\n\n.iti__flag.iti__gp {\n  height: 14px;\n  background-position: -2061px 0px; }\n\n.iti__flag.iti__gq {\n  height: 14px;\n  background-position: -2083px 0px; }\n\n.iti__flag.iti__gr {\n  height: 14px;\n  background-position: -2105px 0px; }\n\n.iti__flag.iti__gs {\n  height: 10px;\n  background-position: -2127px 0px; }\n\n.iti__flag.iti__gt {\n  height: 13px;\n  background-position: -2149px 0px; }\n\n.iti__flag.iti__gu {\n  height: 11px;\n  background-position: -2171px 0px; }\n\n.iti__flag.iti__gw {\n  height: 10px;\n  background-position: -2193px 0px; }\n\n.iti__flag.iti__gy {\n  height: 12px;\n  background-position: -2215px 0px; }\n\n.iti__flag.iti__hk {\n  height: 14px;\n  background-position: -2237px 0px; }\n\n.iti__flag.iti__hm {\n  height: 10px;\n  background-position: -2259px 0px; }\n\n.iti__flag.iti__hn {\n  height: 10px;\n  background-position: -2281px 0px; }\n\n.iti__flag.iti__hr {\n  height: 10px;\n  background-position: -2303px 0px; }\n\n.iti__flag.iti__ht {\n  height: 12px;\n  background-position: -2325px 0px; }\n\n.iti__flag.iti__hu {\n  height: 10px;\n  background-position: -2347px 0px; }\n\n.iti__flag.iti__ic {\n  height: 14px;\n  background-position: -2369px 0px; }\n\n.iti__flag.iti__id {\n  height: 14px;\n  background-position: -2391px 0px; }\n\n.iti__flag.iti__ie {\n  height: 10px;\n  background-position: -2413px 0px; }\n\n.iti__flag.iti__il {\n  height: 15px;\n  background-position: -2435px 0px; }\n\n.iti__flag.iti__im {\n  height: 10px;\n  background-position: -2457px 0px; }\n\n.iti__flag.iti__in {\n  height: 14px;\n  background-position: -2479px 0px; }\n\n.iti__flag.iti__io {\n  height: 10px;\n  background-position: -2501px 0px; }\n\n.iti__flag.iti__iq {\n  height: 14px;\n  background-position: -2523px 0px; }\n\n.iti__flag.iti__ir {\n  height: 12px;\n  background-position: -2545px 0px; }\n\n.iti__flag.iti__is {\n  height: 15px;\n  background-position: -2567px 0px; }\n\n.iti__flag.iti__it {\n  height: 14px;\n  background-position: -2589px 0px; }\n\n.iti__flag.iti__je {\n  height: 12px;\n  background-position: -2611px 0px; }\n\n.iti__flag.iti__jm {\n  height: 10px;\n  background-position: -2633px 0px; }\n\n.iti__flag.iti__jo {\n  height: 10px;\n  background-position: -2655px 0px; }\n\n.iti__flag.iti__jp {\n  height: 14px;\n  background-position: -2677px 0px; }\n\n.iti__flag.iti__ke {\n  height: 14px;\n  background-position: -2699px 0px; }\n\n.iti__flag.iti__kg {\n  height: 12px;\n  background-position: -2721px 0px; }\n\n.iti__flag.iti__kh {\n  height: 13px;\n  background-position: -2743px 0px; }\n\n.iti__flag.iti__ki {\n  height: 10px;\n  background-position: -2765px 0px; }\n\n.iti__flag.iti__km {\n  height: 12px;\n  background-position: -2787px 0px; }\n\n.iti__flag.iti__kn {\n  height: 14px;\n  background-position: -2809px 0px; }\n\n.iti__flag.iti__kp {\n  height: 10px;\n  background-position: -2831px 0px; }\n\n.iti__flag.iti__kr {\n  height: 14px;\n  background-position: -2853px 0px; }\n\n.iti__flag.iti__kw {\n  height: 10px;\n  background-position: -2875px 0px; }\n\n.iti__flag.iti__ky {\n  height: 10px;\n  background-position: -2897px 0px; }\n\n.iti__flag.iti__kz {\n  height: 10px;\n  background-position: -2919px 0px; }\n\n.iti__flag.iti__la {\n  height: 14px;\n  background-position: -2941px 0px; }\n\n.iti__flag.iti__lb {\n  height: 14px;\n  background-position: -2963px 0px; }\n\n.iti__flag.iti__lc {\n  height: 10px;\n  background-position: -2985px 0px; }\n\n.iti__flag.iti__li {\n  height: 12px;\n  background-position: -3007px 0px; }\n\n.iti__flag.iti__lk {\n  height: 10px;\n  background-position: -3029px 0px; }\n\n.iti__flag.iti__lr {\n  height: 11px;\n  background-position: -3051px 0px; }\n\n.iti__flag.iti__ls {\n  height: 14px;\n  background-position: -3073px 0px; }\n\n.iti__flag.iti__lt {\n  height: 12px;\n  background-position: -3095px 0px; }\n\n.iti__flag.iti__lu {\n  height: 12px;\n  background-position: -3117px 0px; }\n\n.iti__flag.iti__lv {\n  height: 10px;\n  background-position: -3139px 0px; }\n\n.iti__flag.iti__ly {\n  height: 10px;\n  background-position: -3161px 0px; }\n\n.iti__flag.iti__ma {\n  height: 14px;\n  background-position: -3183px 0px; }\n\n.iti__flag.iti__mc {\n  height: 15px;\n  background-position: -3205px 0px; }\n\n.iti__flag.iti__md {\n  height: 10px;\n  background-position: -3226px 0px; }\n\n.iti__flag.iti__me {\n  height: 10px;\n  background-position: -3248px 0px; }\n\n.iti__flag.iti__mf {\n  height: 14px;\n  background-position: -3270px 0px; }\n\n.iti__flag.iti__mg {\n  height: 14px;\n  background-position: -3292px 0px; }\n\n.iti__flag.iti__mh {\n  height: 11px;\n  background-position: -3314px 0px; }\n\n.iti__flag.iti__mk {\n  height: 10px;\n  background-position: -3336px 0px; }\n\n.iti__flag.iti__ml {\n  height: 14px;\n  background-position: -3358px 0px; }\n\n.iti__flag.iti__mm {\n  height: 14px;\n  background-position: -3380px 0px; }\n\n.iti__flag.iti__mn {\n  height: 10px;\n  background-position: -3402px 0px; }\n\n.iti__flag.iti__mo {\n  height: 14px;\n  background-position: -3424px 0px; }\n\n.iti__flag.iti__mp {\n  height: 10px;\n  background-position: -3446px 0px; }\n\n.iti__flag.iti__mq {\n  height: 14px;\n  background-position: -3468px 0px; }\n\n.iti__flag.iti__mr {\n  height: 14px;\n  background-position: -3490px 0px; }\n\n.iti__flag.iti__ms {\n  height: 10px;\n  background-position: -3512px 0px; }\n\n.iti__flag.iti__mt {\n  height: 14px;\n  background-position: -3534px 0px; }\n\n.iti__flag.iti__mu {\n  height: 14px;\n  background-position: -3556px 0px; }\n\n.iti__flag.iti__mv {\n  height: 14px;\n  background-position: -3578px 0px; }\n\n.iti__flag.iti__mw {\n  height: 14px;\n  background-position: -3600px 0px; }\n\n.iti__flag.iti__mx {\n  height: 12px;\n  background-position: -3622px 0px; }\n\n.iti__flag.iti__my {\n  height: 10px;\n  background-position: -3644px 0px; }\n\n.iti__flag.iti__mz {\n  height: 14px;\n  background-position: -3666px 0px; }\n\n.iti__flag.iti__na {\n  height: 14px;\n  background-position: -3688px 0px; }\n\n.iti__flag.iti__nc {\n  height: 10px;\n  background-position: -3710px 0px; }\n\n.iti__flag.iti__ne {\n  height: 15px;\n  background-position: -3732px 0px; }\n\n.iti__flag.iti__nf {\n  height: 10px;\n  background-position: -3752px 0px; }\n\n.iti__flag.iti__ng {\n  height: 10px;\n  background-position: -3774px 0px; }\n\n.iti__flag.iti__ni {\n  height: 12px;\n  background-position: -3796px 0px; }\n\n.iti__flag.iti__nl {\n  height: 14px;\n  background-position: -3818px 0px; }\n\n.iti__flag.iti__no {\n  height: 15px;\n  background-position: -3840px 0px; }\n\n.iti__flag.iti__np {\n  height: 15px;\n  background-position: -3862px 0px; }\n\n.iti__flag.iti__nr {\n  height: 10px;\n  background-position: -3877px 0px; }\n\n.iti__flag.iti__nu {\n  height: 10px;\n  background-position: -3899px 0px; }\n\n.iti__flag.iti__nz {\n  height: 10px;\n  background-position: -3921px 0px; }\n\n.iti__flag.iti__om {\n  height: 10px;\n  background-position: -3943px 0px; }\n\n.iti__flag.iti__pa {\n  height: 14px;\n  background-position: -3965px 0px; }\n\n.iti__flag.iti__pe {\n  height: 14px;\n  background-position: -3987px 0px; }\n\n.iti__flag.iti__pf {\n  height: 14px;\n  background-position: -4009px 0px; }\n\n.iti__flag.iti__pg {\n  height: 15px;\n  background-position: -4031px 0px; }\n\n.iti__flag.iti__ph {\n  height: 10px;\n  background-position: -4053px 0px; }\n\n.iti__flag.iti__pk {\n  height: 14px;\n  background-position: -4075px 0px; }\n\n.iti__flag.iti__pl {\n  height: 13px;\n  background-position: -4097px 0px; }\n\n.iti__flag.iti__pm {\n  height: 14px;\n  background-position: -4119px 0px; }\n\n.iti__flag.iti__pn {\n  height: 10px;\n  background-position: -4141px 0px; }\n\n.iti__flag.iti__pr {\n  height: 14px;\n  background-position: -4163px 0px; }\n\n.iti__flag.iti__ps {\n  height: 10px;\n  background-position: -4185px 0px; }\n\n.iti__flag.iti__pt {\n  height: 14px;\n  background-position: -4207px 0px; }\n\n.iti__flag.iti__pw {\n  height: 13px;\n  background-position: -4229px 0px; }\n\n.iti__flag.iti__py {\n  height: 11px;\n  background-position: -4251px 0px; }\n\n.iti__flag.iti__qa {\n  height: 8px;\n  background-position: -4273px 0px; }\n\n.iti__flag.iti__re {\n  height: 14px;\n  background-position: -4295px 0px; }\n\n.iti__flag.iti__ro {\n  height: 14px;\n  background-position: -4317px 0px; }\n\n.iti__flag.iti__rs {\n  height: 14px;\n  background-position: -4339px 0px; }\n\n.iti__flag.iti__ru {\n  height: 14px;\n  background-position: -4361px 0px; }\n\n.iti__flag.iti__rw {\n  height: 14px;\n  background-position: -4383px 0px; }\n\n.iti__flag.iti__sa {\n  height: 14px;\n  background-position: -4405px 0px; }\n\n.iti__flag.iti__sb {\n  height: 10px;\n  background-position: -4427px 0px; }\n\n.iti__flag.iti__sc {\n  height: 10px;\n  background-position: -4449px 0px; }\n\n.iti__flag.iti__sd {\n  height: 10px;\n  background-position: -4471px 0px; }\n\n.iti__flag.iti__se {\n  height: 13px;\n  background-position: -4493px 0px; }\n\n.iti__flag.iti__sg {\n  height: 14px;\n  background-position: -4515px 0px; }\n\n.iti__flag.iti__sh {\n  height: 10px;\n  background-position: -4537px 0px; }\n\n.iti__flag.iti__si {\n  height: 10px;\n  background-position: -4559px 0px; }\n\n.iti__flag.iti__sj {\n  height: 15px;\n  background-position: -4581px 0px; }\n\n.iti__flag.iti__sk {\n  height: 14px;\n  background-position: -4603px 0px; }\n\n.iti__flag.iti__sl {\n  height: 14px;\n  background-position: -4625px 0px; }\n\n.iti__flag.iti__sm {\n  height: 15px;\n  background-position: -4647px 0px; }\n\n.iti__flag.iti__sn {\n  height: 14px;\n  background-position: -4669px 0px; }\n\n.iti__flag.iti__so {\n  height: 14px;\n  background-position: -4691px 0px; }\n\n.iti__flag.iti__sr {\n  height: 14px;\n  background-position: -4713px 0px; }\n\n.iti__flag.iti__ss {\n  height: 10px;\n  background-position: -4735px 0px; }\n\n.iti__flag.iti__st {\n  height: 10px;\n  background-position: -4757px 0px; }\n\n.iti__flag.iti__su {\n  height: 10px;\n  background-position: -4779px 0px; }\n\n.iti__flag.iti__sv {\n  height: 12px;\n  background-position: -4801px 0px; }\n\n.iti__flag.iti__sx {\n  height: 14px;\n  background-position: -4823px 0px; }\n\n.iti__flag.iti__sy {\n  height: 14px;\n  background-position: -4845px 0px; }\n\n.iti__flag.iti__sz {\n  height: 14px;\n  background-position: -4867px 0px; }\n\n.iti__flag.iti__ta {\n  height: 10px;\n  background-position: -4889px 0px; }\n\n.iti__flag.iti__tc {\n  height: 10px;\n  background-position: -4911px 0px; }\n\n.iti__flag.iti__td {\n  height: 14px;\n  background-position: -4933px 0px; }\n\n.iti__flag.iti__tf {\n  height: 14px;\n  background-position: -4955px 0px; }\n\n.iti__flag.iti__tg {\n  height: 13px;\n  background-position: -4977px 0px; }\n\n.iti__flag.iti__th {\n  height: 14px;\n  background-position: -4999px 0px; }\n\n.iti__flag.iti__tj {\n  height: 10px;\n  background-position: -5021px 0px; }\n\n.iti__flag.iti__tk {\n  height: 10px;\n  background-position: -5043px 0px; }\n\n.iti__flag.iti__tl {\n  height: 10px;\n  background-position: -5065px 0px; }\n\n.iti__flag.iti__tm {\n  height: 14px;\n  background-position: -5087px 0px; }\n\n.iti__flag.iti__tn {\n  height: 14px;\n  background-position: -5109px 0px; }\n\n.iti__flag.iti__to {\n  height: 10px;\n  background-position: -5131px 0px; }\n\n.iti__flag.iti__tr {\n  height: 14px;\n  background-position: -5153px 0px; }\n\n.iti__flag.iti__tt {\n  height: 12px;\n  background-position: -5175px 0px; }\n\n.iti__flag.iti__tv {\n  height: 10px;\n  background-position: -5197px 0px; }\n\n.iti__flag.iti__tw {\n  height: 14px;\n  background-position: -5219px 0px; }\n\n.iti__flag.iti__tz {\n  height: 14px;\n  background-position: -5241px 0px; }\n\n.iti__flag.iti__ua {\n  height: 14px;\n  background-position: -5263px 0px; }\n\n.iti__flag.iti__ug {\n  height: 14px;\n  background-position: -5285px 0px; }\n\n.iti__flag.iti__uk {\n  height: 10px;\n  background-position: -5307px 0px; }\n\n.iti__flag.iti__um {\n  height: 11px;\n  background-position: -5329px 0px; }\n\n.iti__flag.iti__un {\n  height: 14px;\n  background-position: -5351px 0px; }\n\n.iti__flag.iti__us {\n  height: 11px;\n  background-position: -5373px 0px; }\n\n.iti__flag.iti__uy {\n  height: 14px;\n  background-position: -5395px 0px; }\n\n.iti__flag.iti__uz {\n  height: 10px;\n  background-position: -5417px 0px; }\n\n.iti__flag.iti__va {\n  height: 15px;\n  background-position: -5439px 0px; }\n\n.iti__flag.iti__vc {\n  height: 14px;\n  background-position: -5456px 0px; }\n\n.iti__flag.iti__ve {\n  height: 14px;\n  background-position: -5478px 0px; }\n\n.iti__flag.iti__vg {\n  height: 10px;\n  background-position: -5500px 0px; }\n\n.iti__flag.iti__vi {\n  height: 14px;\n  background-position: -5522px 0px; }\n\n.iti__flag.iti__vn {\n  height: 14px;\n  background-position: -5544px 0px; }\n\n.iti__flag.iti__vu {\n  height: 12px;\n  background-position: -5566px 0px; }\n\n.iti__flag.iti__wf {\n  height: 14px;\n  background-position: -5588px 0px; }\n\n.iti__flag.iti__ws {\n  height: 10px;\n  background-position: -5610px 0px; }\n\n.iti__flag.iti__xk {\n  height: 15px;\n  background-position: -5632px 0px; }\n\n.iti__flag.iti__ye {\n  height: 14px;\n  background-position: -5654px 0px; }\n\n.iti__flag.iti__yt {\n  height: 14px;\n  background-position: -5676px 0px; }\n\n.iti__flag.iti__za {\n  height: 14px;\n  background-position: -5698px 0px; }\n\n.iti__flag.iti__zm {\n  height: 14px;\n  background-position: -5720px 0px; }\n\n.iti__flag.iti__zw {\n  height: 10px;\n  background-position: -5742px 0px; }\n\n.iti__flag {\n  height: 15px;\n  box-shadow: 0px 0px 1px 0px #888;\n  background-image: url(" + escape(__webpack_require__(552)) + ");\n  background-repeat: no-repeat;\n  background-color: #dbdbdb;\n  background-position: 20px 0; }\n\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {\n  .iti__flag {\n    background-image: url(" + escape(__webpack_require__(553)) + "); } }\n\n.iti__flag.iti__np {\n  background-color: transparent; }\n\n.iti__flag {\n  background-image: url(" + escape(__webpack_require__(575)) + "); }\n\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {\n  .iti__flag {\n    background-image: url(" + escape(__webpack_require__(576)) + "); } }\n\n.fmcy-cart-delivery-phone-form {\n  padding: 0px 10px;\n  background-color: #1f1e1e; }\n  .fmcy-cart-delivery-phone-form .fmcy-cart-delivery-phone-form-title {\n    height: 54px;\n    color: #ffff;\n    background-color: #1f1e1e;\n    border-bottom: 1px #000 solid;\n    line-height: 57px;\n    font-size: 150%; }\n  .fmcy-cart-delivery-phone-form .fmcy-cart-delivery-phone-form-header {\n    color: #fff;\n    font-size: 90%;\n    font-weight: 700;\n    padding: 10px 0px;\n    font-family: 'droid_serif' !important; }\n  .fmcy-cart-delivery-phone-form .fmcy-cart-delivery-phone-field-label {\n    font-size: 90%;\n    color: #fff;\n    padding-bottom: 5px;\n    margin-bottom: 0px;\n    font-family: 'droid_serif' !important;\n    font-weight: 700; }\n  .fmcy-cart-delivery-phone-form .fmcy-cart-delivery-phone-form-alert-message {\n    margin-left: 0px !important;\n    margin-right: 0px !important; }\n    .fmcy-cart-delivery-phone-form .fmcy-cart-delivery-phone-form-alert-message .alert-danger {\n      text-align: left;\n      color: #a94442;\n      background-color: #f2dede;\n      font-size: 100%;\n      font-weight: 700;\n      padding: 10px 10px;\n      border: 1px solid transparent;\n      border-radius: 4px;\n      font-family: 'droid_serif' !important; }\n  .fmcy-cart-delivery-phone-form .fmcy-cart-delivery-phone-form-required-legend {\n    margin-bottom: 20px; }\n  .fmcy-cart-delivery-phone-form .fmcy-cart-delivery-phone-input-group {\n    width: 100%; }\n    .fmcy-cart-delivery-phone-form .fmcy-cart-delivery-phone-input-group #fmcy-cart-delivery-phone-field {\n      width: 100%;\n      font-family: 'droid_serif' !important;\n      height: 34px;\n      font-size: 14px;\n      line-height: 1.42857;\n      color: #555555;\n      background-color: #fff;\n      background-image: none;\n      border: 1px solid #ccc;\n      border-radius: 4px;\n      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); }\n    .fmcy-cart-delivery-phone-form .fmcy-cart-delivery-phone-input-group .iti {\n      width: 100%; }\n    .fmcy-cart-delivery-phone-form .fmcy-cart-delivery-phone-input-group .iti__country-list {\n      z-index: 20;\n      font-family: 'droid_serif' !important; }\n\n.iti-mobile .iti--container {\n  z-index: 20000;\n  position: fixed !important;\n  top: 0px !important;\n  left: 0px !important;\n  right: 0px !important;\n  bottom: 0px !important; }\n  .iti-mobile .iti--container .iti__country-list {\n    max-width: 100% !important; }\n", ""]);
	
	// exports


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-cart-delivery-tip {\n  padding: 0px 10px;\n  background-color: #1f1e1e; }\n  .fmcy-cart-delivery-tip.fmcy-cart-tip-below {\n    padding-top: 5px;\n    padding-bottom: 5px; }\n  .fmcy-cart-delivery-tip .fmcy-cart-delivery-tip-title {\n    height: 54px;\n    color: #ffff;\n    background-color: #1f1e1e;\n    border-bottom: 1px #000 solid;\n    line-height: 57px;\n    font-size: 150%; }\n  .fmcy-cart-delivery-tip .fmcy-cart-delivery-tip-header {\n    color: #fff;\n    font-size: 90%;\n    font-weight: 700;\n    padding: 10px 0px;\n    font-family: 'droid_serif' !important; }\n", ""]);
	
	// exports


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-cart-gift-form {\n  padding: 0px 10px;\n  background-color: #1f1e1e; }\n  .fmcy-cart-gift-form .fmcy-cart-gift-form-title {\n    height: 54px;\n    color: #ffff;\n    background-color: #1f1e1e;\n    border-bottom: 1px #000 solid;\n    line-height: 57px;\n    font-size: 150%; }\n  .fmcy-cart-gift-form .fmcy-cart-gift-form-header {\n    color: #fff;\n    font-size: 90%;\n    font-weight: 700;\n    padding: 10px 0px;\n    font-family: 'droid_serif' !important; }\n  .fmcy-cart-gift-form .fmcy-cart-gift-field-label {\n    font-size: 90%;\n    color: #fff;\n    padding-bottom: 5px;\n    margin-bottom: 0px;\n    font-family: 'droid_serif' !important;\n    font-weight: 700; }\n  .fmcy-cart-gift-form .fmcy-cart-gift-form-alert-message {\n    margin-left: 0px !important;\n    margin-right: 0px !important; }\n    .fmcy-cart-gift-form .fmcy-cart-gift-form-alert-message .alert-danger {\n      text-align: left;\n      color: #a94442;\n      background-color: #f2dede;\n      font-size: 100%;\n      font-weight: 700;\n      padding: 10px 10px;\n      border: 1px solid transparent;\n      border-radius: 4px;\n      font-family: 'droid_serif' !important; }\n  .fmcy-cart-gift-form .fmcy-cart-gift-form-required-legend {\n    margin-bottom: 20px; }\n", ""]);
	
	// exports


/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".amex-lg, .amex-md, .amex-xs, .dinersclub-lg, .dinersclub-md, .dinersclub-xs, .discover-lg, .discover-md, .discover-xs, .jcb-lg, .jcb-md, .jcb-xs, .mastercard-lg, .mastercard-md, .mastercard-xs, .visa-lg, .visa-md, .visa-xs {\n  background: url(" + escape(__webpack_require__(551)) + ") no-repeat;\n  display: inline-block; }\n\n.amex-lg {\n  background-position: 0 0;\n  width: 128px;\n  height: 84px; }\n\n.amex-md {\n  background-position: -129px 0;\n  width: 64px;\n  height: 42px; }\n\n.amex-xs {\n  background-position: -130px -44px;\n  width: 32px;\n  height: 21px; }\n\n.dinersclub-lg {\n  background-position: -195px 0;\n  width: 128px;\n  height: 84px; }\n\n.dinersclub-md {\n  background-position: -325px 0;\n  width: 64px;\n  height: 42px; }\n\n.dinersclub-xs {\n  background-position: -325px -43px;\n  width: 32px;\n  height: 21px; }\n\n.discover-lg {\n  background-position: 0 -87px;\n  width: 128px;\n  height: 84px; }\n\n.discover-md {\n  background-position: -130px -87px;\n  width: 64px;\n  height: 42px; }\n\n.discover-xs {\n  background-position: -130px -132px;\n  width: 32px;\n  height: 21px; }\n\n.jcb-lg {\n  background-position: -196px -89px;\n  width: 128px;\n  height: 84px; }\n\n.jcb-md {\n  background-position: -325px -90px;\n  width: 64px;\n  height: 42px; }\n\n.jcb-xs {\n  background-position: -326px -134px;\n  width: 32px;\n  height: 21px; }\n\n.mastercard-lg {\n  background-position: 0 -176px;\n  width: 128px;\n  height: 84px; }\n\n.mastercard-md {\n  background-position: -130px -177px;\n  width: 64px;\n  height: 42px; }\n\n.mastercard-xs {\n  background-position: -131px -221px;\n  width: 32px;\n  height: 21px; }\n\n.visa-lg {\n  background-position: -196px -177px;\n  width: 128px;\n  height: 84px; }\n\n.visa-md {\n  background-position: -326px -179px;\n  width: 64px;\n  height: 42px; }\n\n.visa-xs {\n  background-position: -327px -223px;\n  width: 32px;\n  height: 21px; }\n", ""]);
	
	// exports


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-credit-card-form .fmcy-credit-card-form-alert-message {\n  margin-left: 0px !important;\n  margin-right: 0px !important; }\n  .fmcy-credit-card-form .fmcy-credit-card-form-alert-message .alert-danger {\n    text-align: left;\n    color: #a94442;\n    background-color: #f2dede;\n    font-size: 100%;\n    font-weight: 700;\n    padding: 10px 10px;\n    border: 1px solid transparent;\n    border-radius: 4px;\n    font-family: 'droid_serif' !important; }\n\n.fmcy-credit-card-form .fmcy-credit-card-form-required-legend {\n  margin-bottom: 20px; }\n\n@media only screen and (min-width: 768px) {\n  .fmcy-credit-card-form .fmcy-credit-card-form-row-expiry-security .fmcy-credit-card-form-column-expiry {\n    padding-right: 5px; }\n  .fmcy-credit-card-form .fmcy-credit-card-form-row-expiry-security .fmcy-credit-card-form-column-security {\n    padding-left: 5px; } }\n", ""]);
	
	// exports


/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-cart-items-empty {\n  padding-top: 30px;\n  text-align: center;\n  font-size: 150%; }\n", ""]);
	
	// exports


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-cart-total-weight {\n  font-family: 'droid_serif' !important; }\n  .fmcy-cart-total-weight .fmcy-cart-total-weight-inner {\n    text-align: center;\n    background-color: #2e302f;\n    color: #e7e7e7;\n    font-size: 90%;\n    min-height: 50px;\n    line-height: 20px;\n    padding-top: 12px;\n    padding-bottom: 12px;\n    padding-left: 5px;\n    padding-right: 5px;\n    border-bottom: #000 1px solid; }\n  .fmcy-cart-total-weight .fmcy-cart-total-weight-sub-message {\n    text-align: center;\n    background-color: #2e302f;\n    color: #999;\n    font-size: 90%;\n    min-height: 50px;\n    line-height: 20px;\n    padding-top: 12px;\n    padding-bottom: 12px;\n    padding-left: 5px;\n    padding-right: 5px;\n    border-bottom: #000 1px solid; }\n  .fmcy-cart-total-weight.cart-total-error-message .fmcy-cart-total-weight-sub-message .fmcy-cart-total-weight-sub-message-text {\n    display: block;\n    background-color: #f2dede;\n    color: #a94442;\n    font-weight: 700;\n    padding: 10px;\n    padding-left: 20px;\n    padding-right: 20px; }\n", ""]);
	
	// exports


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-order-complete {\n  margin: auto;\n  background-color: #2e302f;\n  color: #fff; }\n  .fmcy-order-complete .fmcy-order-complete-inner {\n    width: 100%;\n    max-width: 477px;\n    padding: 30px;\n    padding-bottom: 337px;\n    text-align: center;\n    margin: auto; }\n    @media only screen and (max-width: 490px) {\n      .fmcy-order-complete .fmcy-order-complete-inner {\n        padding-bottom: 490px; } }\n    .fmcy-order-complete .fmcy-order-complete-inner .fmcy-order-complete-step-indicator {\n      margin: auto;\n      width: 250px;\n      height: 90px;\n      background-size: contain;\n      background-repeat: no-repeat;\n      background-position: center center;\n      margin-bottom: 15px; }\n      @media only screen and (min-width: 490px) {\n        .fmcy-order-complete .fmcy-order-complete-inner .fmcy-order-complete-step-indicator {\n          width: 425px;\n          height: 173px; } }\n      .fmcy-order-complete .fmcy-order-complete-inner .fmcy-order-complete-step-indicator.delivery {\n        background-image: url(" + escape(__webpack_require__(555)) + "); }\n      .fmcy-order-complete .fmcy-order-complete-inner .fmcy-order-complete-step-indicator.pickup {\n        background-image: url(" + escape(__webpack_require__(554)) + "); }\n    .fmcy-order-complete .fmcy-order-complete-inner .fmcy-order-complete-thankyou-headline {\n      font-size: 150%;\n      margin-bottom: 15px;\n      font-family: 'avril', 'Arial', sans-serif; }\n    .fmcy-order-complete .fmcy-order-complete-inner .fmcy-order-complete-headline {\n      font-size: 300%;\n      margin-bottom: 15px;\n      line-height: 45px;\n      font-family: 'bebasneue', 'Arial', sans-serif; }\n      @media only screen and (min-width: 490px) {\n        .fmcy-order-complete .fmcy-order-complete-inner .fmcy-order-complete-headline {\n          margin-bottom: 30px; } }\n    .fmcy-order-complete .fmcy-order-complete-inner .fmcy-order-complete-order-number {\n      font-size: 250%;\n      margin-bottom: 15px; }\n    .fmcy-order-complete .fmcy-order-complete-inner .fmcy-order-complete-order-sub-headline {\n      font-family: 'droid_serif';\n      font-size: 80%; }\n      @media only screen and (min-width: 490px) {\n        .fmcy-order-complete .fmcy-order-complete-inner .fmcy-order-complete-order-sub-headline {\n          font-size: 120%; } }\n", ""]);
	
	// exports


/***/ },
/* 531 */,
/* 532 */,
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-hamburger-button.fmcy-menu-toggle-close-icon .fmcy-hamburger-button-icon {\n  background-image: url(" + escape(__webpack_require__(556)) + "); }\n\n.fmcy-hamburger-button.fmcy-menu-toggle-hamburger-icon .fmcy-hamburger-button-icon {\n  background-image: url(" + escape(__webpack_require__(557)) + "); }\n\n.fmcy-hamburger-button .fmcy-hamburger-button-icon {\n  display: block;\n  position: relative;\n  cursor: pointer;\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: contain;\n  width: 34px;\n  height: 41px; }\n  .fmcy-hamburger-button .fmcy-hamburger-button-icon .fmcy-hamburger-notification-count {\n    text-indent: 0;\n    display: block;\n    width: 20px;\n    height: 20px;\n    line-height: 1.74;\n    box-sizing: content-box;\n    font-size: 12px;\n    position: absolute;\n    top: 0px;\n    right: -5px;\n    border-radius: 100%;\n    border: 2px solid #000;\n    background-color: #0fb1b5;\n    color: #fff;\n    text-align: center;\n    font-family: \"bebasneue\", \"Arial\", sans-serif; }\n", ""]);
	
	// exports


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-profile-button.fmcy-menu-toggle-close-icon .fmcy-profile-button-icon {\n  background-image: url(" + escape(__webpack_require__(558)) + "); }\n\n.fmcy-profile-button.fmcy-menu-toggle-profile-icon .fmcy-profile-button-icon {\n  background-image: url(" + escape(__webpack_require__(559)) + "); }\n\n.fmcy-profile-button .fmcy-profile-button-icon {\n  display: block;\n  position: relative;\n  cursor: pointer;\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: contain;\n  width: 34px;\n  height: 41px; }\n  .fmcy-profile-button .fmcy-profile-button-icon .fmcy-profile-notification-count {\n    text-indent: 0;\n    display: block;\n    width: 20px;\n    height: 20px;\n    line-height: 1.74;\n    box-sizing: content-box;\n    font-size: 12px;\n    position: absolute;\n    top: -5px;\n    right: -10px;\n    border-radius: 100%;\n    border: 2px solid #000;\n    background-color: #0fb1b5;\n    color: #fff;\n    text-align: center;\n    font-family: \"bebasneue\", \"Arial\", sans-serif; }\n", ""]);
	
	// exports


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-search-button.fmcy-menu-toggle-close-icon .fmcy-search-button-icon {\n  background-image: url(" + escape(__webpack_require__(560)) + ");\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: contain;\n  width: 34px;\n  height: 41px; }\n\n.fmcy-search-button.fmcy-menu-toggle-search-icon .fmcy-search-button-icon {\n  background: url(" + escape(__webpack_require__(561)) + ");\n  background: url(" + escape(__webpack_require__(562)) + "), linear-gradient(transparent, transparent);\n  width: 24px;\n  height: 22px;\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: contain;\n  top: 27px;\n  left: 13px; }\n\n@media only screen and (max-width: 1100px) {\n  .fmcy-search-button.fmcy-menu-toggle-search-icon .fmcy-search-button-icon {\n    top: 18px;\n    left: 13px; }\n  .fmcy-search-button.fmcy-menu-toggle-search-icon.fmcy-menu-toggle-close-icon .fmcy-search-button-icon {\n    height: 54px; } }\n\n.fmcy-search-button .fmcy-search-button-icon {\n  display: block;\n  position: relative;\n  cursor: pointer; }\n", ""]);
	
	// exports


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-category-text-menu {\n  max-width: 1100px;\n  margin: auto;\n  position: relative;\n  margin-bottom: 90px; }\n", ""]);
	
	// exports


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-thumbnail-item {\n  display: flex;\n  margin-bottom: 5px; }\n  .fmcy-thumbnail-item .fmcy-thumbnail-item-inner {\n    cursor: pointer;\n    position: relative;\n    width: 100%; }\n  .fmcy-thumbnail-item .fmcy-thumbnail-item-image-wrapper {\n    position: relative; }\n  .fmcy-thumbnail-item .fmcy-thumbnail-item-inner {\n    border: solid #c4c1c2 2px;\n    display: flex;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n    align-content: stretch;\n    align-items: stretch; }\n    .fmcy-thumbnail-item .fmcy-thumbnail-item-inner .fmcy-thumbnail-item-row {\n      order: 0;\n      flex: 0 1 auto;\n      align-self: auto; }\n    .fmcy-thumbnail-item .fmcy-thumbnail-item-inner .fmcy-thumbnail-item-image {\n      background-size: contain;\n      background-repeat: no-repeat;\n      background-position: center; }\n  .fmcy-thumbnail-item.thumbnail-item-selected .fmcy-thumbnail-item-inner {\n    border: solid #00afb4 2px; }\n", ""]);
	
	// exports


/***/ },
/* 538 */,
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".select2-container .fmcy-menu-search-filters-dropdown {\n  z-index: 999999999999; }\n  .select2-container .fmcy-menu-search-filters-dropdown .select2-results__option--highlighted[aria-selected] {\n    background-color: #e5e3e3; }\n  body.admin-bar .select2-container .fmcy-menu-search-filters-dropdown.select2-dropdown--below, body.admin-bar .select2-container .fmcy-menu-search-filters-dropdown.select2-dropdown--above {\n    top: 46px; }\n\n.fmcy-search-filters {\n  font-size: 16px;\n  margin: auto; }\n  .fmcy-search-filters .fmcy-search-filter-caption {\n    font-family: 'vastshadow' !important;\n    font-size: 12px;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    font-weight: 500;\n    color: #000;\n    text-align: center;\n    line-height: 40px; }\n\n/* Extra Small Devices, Phones */\n/* Small Devices, Tablets */\n@media only screen and (min-width: 768px) {\n  .select2-container .fmcy-menu-search-filters-dropdown.select2-dropdown--below {\n    top: 4px; }\n  .select2-container .fmcy-menu-search-filters-dropdown.select2-dropdown--above {\n    top: -4px; }\n  body.admin-bar .select2-container .fmcy-menu-search-filters-dropdown.select2-dropdown--below {\n    top: 36px; }\n  body.admin-bar .select2-container .fmcy-menu-search-filters-dropdown.select2-dropdown--above {\n    top: 28px; } }\n\n/* Medium Devices, Desktops */\n/* Large Devices, Wide Screens */\n", ""]);
	
	// exports


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-vendor-selected {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n  .fmcy-vendor-selected .fmcy-selected-vendor-name {\n    color: #00afb4; }\n  .fmcy-vendor-selected .fmcy-search-clear-filters-x-btn {\n    color: #00afb4; }\n\n@media only screen and (max-width: 780px) {\n  .fmcy-vendor-selected {\n    max-width: 110px; } }\n\n@media only screen and (max-width: 410px) {\n  .fmcy-vendor-selected {\n    max-width: 70px; } }\n\n@media only screen and (max-width: 360px) {\n  .fmcy-vendor-selected {\n    max-width: 38px; } }\n", ""]);
	
	// exports


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-order-items.row-flex {\n  margin-left: 0;\n  margin-right: 0; }\n", ""]);
	
	// exports


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, "/* Custom, iPhone Retina */\n.fmcy-video-items.row-flex {\n  margin-left: 0;\n  margin-right: 0; }\n\n.fmcy-video-items .fmcy-video-item {\n  margin-bottom: 15px; }\n\n.fmcy-video-items .fmcy-video-item .fmcy-video-item-image {\n  height: 350px; }\n  @media only screen and (min-width: 991px) {\n    .fmcy-video-items .fmcy-video-item .fmcy-video-item-image.fmcy-video-item-image-large {\n      height: 700px; } }\n\n@media only screen and (min-width: 1600px) {\n  .fmcy-video-items .fmcy-video-item.fmcy-video-item-image {\n    height: 18vw; }\n    .fmcy-video-items .fmcy-video-item.fmcy-video-item-image.fmcy-video-item-image-large {\n      height: 36vw; } }\n", ""]);
	
	// exports


/***/ },
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/sprite-4c575d1418430f28c32f5d1b640e2871.png";

/***/ },
/* 552 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/flags-0b1ca148890222235a0f9903636ca21a.png";

/***/ },
/* 553 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/flags@2x-e1c092e127943ec4289c847c5768b644.png";

/***/ },
/* 554 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/stepIndicatorOrderReceived-c20f9e99fd96793151095317ce59c25c.png";

/***/ },
/* 555 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/stepIndicatorOrderReceivedDelivery-25ae5601c4d76297a05c285f99492933.png";

/***/ },
/* 556 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/hamburger-close-icon-2b5ab2c18e0d738da784cfdaf8a9c070.png";

/***/ },
/* 557 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/hamburger-icon-20acbc8fcc8a707fa2deb5169c0bd3fe.png";

/***/ },
/* 558 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/profile-close-icon-2b5ab2c18e0d738da784cfdaf8a9c070.png";

/***/ },
/* 559 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/profile-icon-20acbc8fcc8a707fa2deb5169c0bd3fe.png";

/***/ },
/* 560 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/search-close-icon-2b5ab2c18e0d738da784cfdaf8a9c070.png";

/***/ },
/* 561 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/search-icon-e7c9eb45e0d4dbc409a1a11334d963f9.png";

/***/ },
/* 562 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/search-icon-565a8de5b9acd526881e93e9880edf72.svg";

/***/ },
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */
552,
/* 576 */
553,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(521);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-delivery-address-form.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-delivery-address-form.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(522);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-delivery-notes-form.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-delivery-notes-form.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(523);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-delivery-phone-form.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-delivery-phone-form.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(524);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-delivery-tip.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-delivery-tip.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(525);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-gift-form.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-gift-form.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(527);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./credit-card-form.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./credit-card-form.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(528);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-items.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-items.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(529);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-total-weight.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-total-weight.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(530);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./order-complete.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./order-complete.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 602 */,
/* 603 */,
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(533);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./hamburger-button.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./hamburger-button.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(534);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./profile-button.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./profile-button.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(535);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./search-button.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./search-button.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(536);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./category-text-menu.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./category-text-menu.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(537);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./thumbnail-item.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./thumbnail-item.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 609 */,
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(539);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./search-filters.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./search-filters.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(540);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./vendor-select-selected.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./vendor-select-selected.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(541);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./order-items.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./order-items.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(542);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./video-items.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./video-items.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-cart-delivery-address-form-wrapper container-fluid">\n    <div class="row">\n        <div class="col-xs-12">\n          <div class="fmcy-cart-delivery-address-form-title">Address</div>\n        </div>\n    </div>\n    ';
	 if (error == true) { 
	__p+='\n    <div class="row fmcy-cart-delivery-address-form-alert-message">\n        <div class="col-xs-12 alert alert-danger" role="alert">'+
	((__t=(errorMessage))==null?'':__t)+
	'</div>\n    </div>\n    ';
	 } 
	__p+='\n    <div class="row">\n        <div class="col-xs-12">\n          <div class="fmcy-cart-delivery-address-form-header">Please enter the address we will be delivering to below.</div>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-xs-12">\n          <fieldset class="form-group has-feedback">\n              <label for="fmcy-cart-delivery-address-field" class="fmcy-cart-delivery-address-field-label">Address *</label>\n              <div class="input-group">\n                <div class="input-group-addon">\n                  <i class="glyphicon glyphicon-envelope"></i>\n                </div>\n                <input type="text" class="form-control" name="local_delivery_street_address" id="fmcy-cart-delivery-address-field" placeholder=""\n                />\n                <i class="glyphicon glyphicon-remove-sign form-control-feedback hidden"></i>\n              </div>\n              <span class="help-block hidden"></span>\n          </fieldset>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-xs-12">\n          <fieldset class="form-group has-feedback">\n              <label for="fmcy-cart-delivery-apartment-number-field" class="fmcy-cart-delivery-apartment-number-field-label">Apartment Number</label>\n              <div class="input-group">\n                <div class="input-group-addon">\n                  <i class="glyphicon glyphicon-flag"></i>\n                </div>\n                <input type="text" class="form-control" name="local_delivery_apartment_number" id="fmcy-cart-delivery-apartment-number-field" placeholder=""\n                />\n                <i class="glyphicon glyphicon-remove-sign form-control-feedback hidden"></i>\n              </div>\n              <span class="help-block hidden"></span>\n          </fieldset>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-xs-12">\n          <fieldset class="form-group has-feedback">\n              <label for="fmcy-cart-delivery-city-field" class="fmcy-cart-delivery-city-field-label">City</label>\n              <div class="input-group">\n                <div class="input-group-addon">\n                  <i class="glyphicon glyphicon-globe"></i>\n                </div>\n                <input type="text" class="form-control" name="local_delivery_city" id="fmcy-cart-delivery-city-field" placeholder=""\n                />\n                <i class="glyphicon glyphicon-remove-sign form-control-feedback hidden"></i>\n              </div>\n              <span class="help-block hidden"></span>\n          </fieldset>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 635 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-cart-delivery-notes-form-wrapper container-fluid">\n    <div class="row">\n        <div class="col-xs-12">\n          <div class="fmcy-cart-delivery-notes-form-title">Delivery Notes</div>\n          <div class="fmcy-cart-delivery-notes-form-header">Anything extra we should know regarding this delivery?</div>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-xs-12">\n          <fieldset class="form-group has-feedback">\n              <textarea class="fmcy-cart-delivery-notes-textbox form-control" name="deliveryNotes" id="fmcy-cart-delivery-notes-textbox-'+
	((__t=( viewId ))==null?'':__t)+
	'" placeholder="" rows="3" maxlength="300"></textarea>\n              <i class="glyphicon glyphicon-remove-sign form-control-feedback hidden"></i>\n              <span class="help-block hidden"></span>\n          </fieldset>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 636 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-cart-delivery-phone-form-wrapper container-fluid">\n    <div class="row">\n        <div class="col-xs-12">\n          <div class="fmcy-cart-delivery-phone-form-title">Phone</div>\n        </div>\n    </div>\n    ';
	 if (error == true) { 
	__p+='\n    <div class="row fmcy-cart-delivery-phone-form-alert-message">\n        <div class="col-xs-12 alert alert-danger" role="alert">'+
	((__t=(errorMessage))==null?'':__t)+
	'</div>\n    </div>\n    ';
	 } 
	__p+='\n    <div class="row">\n        <div class="col-xs-12">\n          <div class="fmcy-cart-delivery-phone-form-header">Please enter your phone number so we can get a hold of you if needs be.</div>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-xs-12">\n          <fieldset class="form-group has-feedback">\n              <label for="fmcy-cart-delivery-phone-field" class="fmcy-cart-delivery-phone-field-label">Phone Number *</label>\n              <div class="input-group fmcy-cart-delivery-phone-input-group">\n                <input type="text" name="deliveryPhone" id="fmcy-cart-delivery-phone-field" placeholder=""\n                />\n                <i class="glyphicon glyphicon-remove-sign form-control-feedback hidden"></i>\n              </div>\n              <span class="help-block hidden"></span>\n          </fieldset>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 637 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-cart-delivery-tip-wrapper container-fluid">\n    <div class="row fmcy-cart-tip-expanded-details">\n        <div class="col-xs-12">\n          <div class="fmcy-cart-delivery-tip-title">Tip</div>\n          <div class="fmcy-cart-delivery-tip-header">Love our service, tip us. Thanks!</div>\n        </div>\n    </div>\n\n    <div class="row">\n        <div class="col-xs-12">\n            <div class="fmcy-cart-delivery-tip-button-toggle-region"></div>\n        </div>\n    </div>\n</div>';
	}
	return __p;
	};


/***/ },
/* 638 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-cart-gift-form-wrapper container-fluid">\n    <div class="row">\n        <div class="col-xs-12">\n          <div class="fmcy-cart-gift-form-title">Gift Option</div>\n          <div class="fmcy-cart-gift-form-header">If you would like this to be a gift fill out the recipients details below and they will be notified when their order is ready to be picked up.</div>\n        </div>\n    </div>\n    <div class="row fmcy-cart-gift-form-alert-message hidden">\n        <div class="col-xs-12 alert alert-danger" role="alert">Please review the form below.</div>\n    </div>\n    <div class="row">\n        <div class="col-xs-12">\n          <fieldset class="form-group has-feedback">\n              <label for="fmcy-cart-gift-form-name-field" class="fmcy-cart-gift-field-label">Name *</label>\n              <div class="input-group">\n                <div class="input-group-addon">\n                  <i class="glyphicon glyphicon-user"></i>\n                </div>\n                <input type="text" class="form-control" name="gift_receiver_name" id="fmcy-cart-gift-form-name-field" placeholder=""\n                />\n                <i class="glyphicon glyphicon-remove-sign form-control-feedback hidden"></i>\n              </div>\n              <span class="help-block hidden"></span>\n          </fieldset>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-xs-12">\n          <fieldset class="form-group has-feedback">\n              <label for="fmcy-cart-gift-form-name-field" class="fmcy-cart-gift-field-label">Email *</label>\n              <div class="input-group">\n                <div class="input-group-addon">\n                  <i class="glyphicon glyphicon-envelope"></i>\n                </div>\n                <input type="text" class="form-control" name="gift_receiver_email" id="fmcy-cart-gift-form-email-field" placeholder=""\n                />\n                <i class="glyphicon glyphicon-remove-sign form-control-feedback hidden"></i>\n              </div>\n              <span class="help-block hidden"></span>\n          </fieldset>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-xs-12">\n          <fieldset class="form-group has-feedback">\n              <label for="fmcy-cart-gift-form-name-field" class="fmcy-cart-gift-field-label">Message (optional)</label>\n              <textarea class="form-control" rows="5" name="gift_receiver_message" id="fmcy-cart-gift-form-message-field"></textarea>\n          </fieldset>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 639 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-credit-card-form-wrapper container-fluid">\n    <div class="row fmcy-credit-card-form-alert-message hidden">\n        <div class="col-xs-12 alert alert-danger" role="alert">Please review the form below.</div>\n    </div>\n    <div class="row">\n        <div class="col-xs-12">\n          <fieldset class="form-group has-feedback">\n              <label for="fmcy-credit-card-form-name-field" class="fmcy-cart-payment-field-label">Name on card *</label>\n              <div class="input-group">\n                <div class="input-group-addon">\n                  <i class="glyphicon glyphicon-user"></i>\n                </div>\n                <input type="text" class="form-control" name="cc_name_on_card" autocomplete="cc-name" id="fmcy-credit-card-form-name-field" placeholder=""\n                />\n                <i class="glyphicon glyphicon-remove-sign form-control-feedback hidden"></i>\n              </div>\n              <span class="help-block hidden"></span>\n          </fieldset>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-xs-12">\n          <fieldset class="form-group has-feedback">\n              <label for="fmcy-credit-card-form-cc-field" class="fmcy-cart-payment-field-label">Card number *</label>\n              <div class="input-group">\n                <div class="input-group-addon">\n                  <i class="glyphicon glyphicon-credit-card"></i>\n                </div>\n                <input type="text" class="form-control" inputmode="numeric" autocomplete="cc-number" name="cc_number" id="fmcy-credit-card-form-cc-field" placeholder=""\n                />\n                <i class="glyphicon glyphicon-remove-sign form-control-feedback hidden"></i>\n              </div>\n              <span class="help-block hidden"></span>\n              <div class="fmcy-cart-payment-field-credit-card-icon"></div>\n          </fieldset>\n        </div>\n    </div>\n    <div class="row fmcy-credit-card-form-row-expiry-security">\n        <div class="col-xs-12 col-sm-6 fmcy-credit-card-form-column-expiry">\n          <fieldset class="form-group has-feedback">\n              <label for="fmcy-credit-card-form-cc-expiry-field" class="fmcy-cart-payment-field-label">Expiry date *</label>\n              <div class="input-group">\n                <div class="input-group-addon">\n                  <i class="glyphicon glyphicon-calendar"></i>\n                </div>\n                <input type="text" class="form-control" inputmode="numeric" autocomplete="cc-exp" name="cc_expiry_date" id="fmcy-credit-card-form-cc-expiry-field" placeholder="MM / YY"\n                />\n                <i class="glyphicon glyphicon-remove-sign form-control-feedback hidden"></i>\n              </div>\n              <span class="help-block hidden"></span>\n          </fieldset>\n        </div>\n        <div class="col-xs-12 col-sm-6 fmcy-credit-card-form-column-security">\n          <fieldset class="form-group has-feedback">\n              <label for="fmcy-credit-card-form-cc-security-field" class="fmcy-cart-payment-field-label">Security Code *</label>\n              <div class="input-group">\n                <div class="input-group-addon">\n                  <i class="glyphicon glyphicon-lock"></i>\n                </div>\n                <input type="text" inputmode="numeric" autocomplete="off" class="form-control" name="cc_security_code" id="fmcy-credit-card-form-cc-security-field" placeholder=""\n                />\n                <i class="glyphicon glyphicon-remove-sign form-control-feedback hidden"></i>\n              </div>\n              <span class="help-block hidden"></span>\n          </fieldset>\n        </div>\n    </div>\n    <div class="row">\n        <div class="col-xs-12">\n          <fieldset class="form-group has-feedback">\n              <label for="fmcy-credit-card-form-postal-code-field" class="fmcy-cart-payment-field-label">Billing ZIP / Postal Code *</label>\n              <div class="input-group">\n                <div class="input-group-addon">\n                  <i class="glyphicon glyphicon-envelope"></i>\n                </div>\n                <input type="text" class="form-control" name="cc_postal_code" autocomplete="billing postal-code" id="fmcy-credit-card-form-postal-code-field" placeholder=""\n                />\n                <i class="glyphicon glyphicon-remove-sign form-control-feedback hidden"></i>\n              </div>\n              <span class="help-block hidden"></span>\n          </fieldset>\n          <fieldset class="form-group has-feedback">\n            * required field\n          </fieldset>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 640 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-cart-total-weight-inner"></div>\n<div class="fmcy-cart-total-weight-sub-message">\n  <span class="fmcy-cart-total-weight-sub-message-text">'+
	((__t=(subMessage))==null?'':__t)+
	'</span>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 641 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-order-complete-inner">\n  <div class="fmcy-order-complete-thankyou-headline">THANK YOU</div>\n  <div class="fmcy-order-complete-headline">FARM '+
	((__t=( locationName ))==null?'':__t)+
	' has received your order</div>\n  ';
	 if (deliveryMethod == 'pickup') { 
	__p+='\n  <div class="fmcy-order-complete-order-sub-headline"><p>Next, you will receive a notification once your order is packaged and ready for pick up. Orders placed during open hours will be packaged within 1 hour, and orders placed after hours will be packaged when the store is next open.</p>\n  <p>Thank you for using Click and Collect.</p></div>\n  <div class="fmcy-order-complete-step-indicator pickup"></div>\n  ';
	 } else { 
	__p+='\n  <div class="fmcy-order-complete-order-sub-headline"><p>Thank you for choosing Original Farm! Your order for delivery to '+
	((__t=(deliveryAddress))==null?'':__t)+
	' has been received. The Original Farm will prepare your order and let you know when it is ready to be sent out. Estimated delivery time is '+
	((__t=(deliveryWindowMinutes))==null?'':__t)+
	' minutes from now. If you have any questions or concerns, please contact us.</p>\n  <p>Thank you for using Original Farm Delivery.</p></div>\n  <div class="fmcy-order-complete-step-indicator delivery"></div>\n  ';
	 } 
	__p+='\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 642 */,
/* 643 */,
/* 644 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-hamburger-button-icon" title="Menu">\n  <span class="fmcy-hamburger-notification-count">0</span>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 645 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-profile-button-icon" title="Menu">\n  <span class="fmcy-profile-notification-count">0</span>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 646 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-search-button-icon" title="Menu">\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 647 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-categories-text-menu-container"></div>\n';
	}
	return __p;
	};


/***/ },
/* 648 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-thumbnail-item-inner">\n    <div class="fmcy-thumbnail-item-image-wrapper">\n      <div class="fmcy-thumbnail-item-image fmcy-thumbnail-item-image-thumb fmcy-thumbnail-item-image-region"></div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 649 */,
/* 650 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	 if (options.caption) { 
	__p+='\n    <div class="fmcy-search-filter-caption">\n        '+
	((__t=( options.caption ))==null?'':__t)+
	'\n    </div>\n';
	 } 
	__p+='\n<div class="fmcy-search-filter-tabs-region"></div>\n<div class="fmcy-search-filter-dropdown-list-region"></div>\n';
	}
	return __p;
	};


/***/ },
/* 651 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-vendor-selected-child-region">By Brand</div>\n';
	}
	return __p;
	};


/***/ },
/* 652 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='By Brand\n';
	}
	return __p;
	};


/***/ },
/* 653 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<span class="fmcy-search-clear-filters-x-btn">X&nbsp;</span><span class="fmcy-selected-vendor-name">'+
	((__t=( vendorName ))==null?'':__t)+
	'</span>\n';
	}
	return __p;
	};


/***/ },
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, moment, $) {'use strict';
	
	__webpack_require__(814);
	var BaseViews = __webpack_require__(5);
	var Button = __webpack_require__(70);
	var SpinnerButton = __webpack_require__(19);
	var LocationMap = __webpack_require__(338);
	var LocationsList = __webpack_require__(234);
	__webpack_require__(1013);
	
	var LocationMapCTA = BaseViews.LayoutView.extend({
	  _expandedMap: false,
	  template: __webpack_require__(861),
	  className: 'fmcy-location-map-cta',
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      _appChannel: null
	    });
	  },
	  ui: {
	    detectedLocationResults: '.fmcy-location-map-detected-location-results',
	    detectedLocationResultsText: '.fmcy-location-map-detected-location-results-text',
	    detectLocationCTA: '.fmcy-location-map-cta-inner'
	  },
	  regions: {
	    useLocationButtonRegion: '.fmcy-location-display-detect-location-button-region'
	  },
	  displayClosestLocationDistance: function displayClosestLocationDistance(model, distance) {
	    this.ui.detectLocationCTA.hide();
	    this.ui.detectedLocationResultsText.html('The closest location to you is <span class="fmcy-location-map-detected-location-results-text-location">' + model.get('name') + '</span> which is <span class="fmcy-location-map-detected-location-results-text-location-distance">' + Math.round(distance) + 'KM</span> away.');
	    this.ui.detectedLocationResults.show();
	  },
	  _renderDetectLocationButton: function _renderDetectLocationButton() {
	    var self = this;
	    var detectLocationButton = new SpinnerButton.SpinnerButton({
	      label: 'FIND CLOSEST STORE TO YOUR LOCATION',
	      enabled: true,
	      theme: Button.THEMES.PRIMARY,
	      onClickedCallback: function onClickedCallback() {
	        detectLocationButton.toggleSpinner(true);
	        detectLocationButton.toggledEnabledState(false);
	        var options = {
	          enableHighAccuracy: true,
	          timeout: 5000,
	          maximumWait: 10000, // max wait time for desired accuracy
	          maximumAge: 0, // disable cache
	          desiredAccuracy: 30, // meters
	          fallbackToIP: true // fallback to IP if Geolocation fails or rejected
	        };
	        geolocator.locate(options, function (err, location) {
	          if (err) return console.log(err);
	          detectLocationButton.toggleSpinner(false);
	          detectLocationButton.toggledEnabledState(true);
	          self.trigger('detected:location', location);
	        });
	      }
	    });
	    this.useLocationButtonRegion.show(detectLocationButton);
	  },
	  onRender: function onRender() {
	    BaseViews.LayoutView.prototype.onRender.call(this);
	    this._renderDetectLocationButton();
	    this.ui.detectedLocationResults.hide();
	  }
	});
	
	var LocationDisplay = BaseViews.LayoutView.extend({
	  _expandedMap: false,
	  template: __webpack_require__(860),
	  className: 'fmcy-plugin-bootstrap fmcy-location-display container-fluid',
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      _appChannel: null,
	      _menuState: null,
	      referrer: null,
	      message: null
	    });
	  },
	  regions: {
	    changeLocationButtonRegion: '.fmcy-location-display-change-location-button-region',
	    fmcyLocationMapRegion: '.fmcy-location-map-region',
	    fmcyLocationMapCtaRegion: '.fmcy-location-map-cta-region',
	    fmcyLocationMapTabRegion: '.fmcy-location-map-tab-region',
	    fmcyLocationMapListRegion: '.fmcy-location-map-list-region'
	  },
	  ui: {
	    expandedRow: '.fmcy-location-display-expanded-row'
	  },
	  serializeData: function serializeData() {
	    this.model = this.options._appChannel.request('get:filter:location:details');
	    var dayOfTheWeek = moment().format('dddd').toLowerCase();
	    var isOpen = this.model.get('hours_' + dayOfTheWeek + '_open');
	    var startTime = this.model.get('hours_' + dayOfTheWeek + '_start_time');
	    var endTime = this.model.get('hours_' + dayOfTheWeek + '_end_time');
	
	    var hours;
	    if (isOpen === '1' && startTime !== null && startTime !== '' && endTime !== null && endTime !== '') {
	      hours = startTime.replace(':00', '') + ' to ' + endTime.replace(':00', '');
	    } else {
	      hours = 'Closed';
	    }
	
	    return {
	      name: this.model.get('name'),
	      line_1: this.model.get('line_1'),
	      city: this.model.get('city'),
	      hours: hours,
	      imageUrl: this.model.get('image_medium_url')
	    };
	  },
	  _renderMapCTA: function _renderMapCTA() {
	    var self = this;
	    this._locationMapCTA = new LocationMapCTA();
	    this._locationMapCTA.on('detected:location', function (location) {
	      if (self.location_map) {
	        self.location_map.addUserLocationToMap(location);
	      }
	    });
	    this.fmcyLocationMapCtaRegion.show(this._locationMapCTA);
	    this.options._appChannel.trigger('active:view:add', 'locationselectmap');
	  },
	  _hideMapCTA: function _hideMapCTA() {
	    this.fmcyLocationMapCtaRegion.empty();
	    this.options._appChannel.trigger('active:view:remove', 'locationselectmap');
	  },
	  _renderLocationMap: function _renderLocationMap() {
	    var self = this;
	    this._expandedMap = true;
	    this.ui.expandedRow.height($(window).height());
	    this.location_map = new LocationMap({
	      _appChannel: this.options._appChannel,
	      adjustForMenuBar: false,
	      topPos: 51,
	      leftPos: 450,
	      botPos: 75
	    });
	
	    this.location_map.on('map:feature:selected', function (model) {
	      self._hideLocationMap();
	      self._hideMapCTA();
	      self.options._appChannel.trigger('location:selected', model.get('slug'), self.options.referrer);
	      self.trigger('close:clicked');
	    });
	
	    this.location_map.on('map:closest:point:user:detected', function (model, distance) {
	      if (self._locationMapCTA) {
	        self._locationMapCTA.displayClosestLocationDistance(model, distance);
	      }
	    });
	
	    this.location_map.on('close:clicked', function () {
	      self._hideLocationMap();
	      self._hideMapCTA();
	      self.options._appChannel.trigger('active:view:remove', 'locationselectmap');
	      self.trigger('close:clicked');
	    });
	
	    this.fmcyLocationMapRegion.show(this.location_map);
	    this.options._appChannel.trigger('active:view:add', 'locationselectmap');
	  },
	  _hideLocationMap: function _hideLocationMap() {
	    this._expandedMap = false;
	    if (this.ui.expandedRow !== null) {
	      this.ui.expandedRow.height(0);
	    }
	    this.options._appChannel.trigger('active:view:remove', 'locationselectmap');
	    this.fmcyLocationMapRegion.empty();
	  },
	  _renderChangeLocationButton: function _renderChangeLocationButton() {
	    var self = this;
	    var changeLocationButton = new Button.Button({
	      label: 'CHANGE LOCATION',
	      enabled: true,
	      theme: Button.THEMES.DEFAULT,
	      onClickedCallback: function onClickedCallback() {
	        self._renderLocationMap();
	        self._renderMapCTA();
	      }
	    });
	    this.changeLocationButtonRegion.show(changeLocationButton);
	  },
	  _renderLocationList: function _renderLocationList() {
	    var self = this;
	    this.locationsList = new LocationsList({
	      collection: this.options._appChannel.request('get:locations')
	    });
	    this.locationsList.on('item:clicked', function (model) {
	      if (self.location_map) {
	        self.location_map.trigger('map:feature:selected', model);
	      }
	    });
	    this.fmcyLocationMapListRegion.show(this.locationsList);
	  },
	  _renderLocationTabs: function _renderLocationTabs() {
	    var self = this;
	    if (self._tabs) {
	      return;
	    }
	    self._tabs = new (__webpack_require__(255))({
	      style: 'tabs',
	      tabs: [{
	        id: 'list',
	        labelText: 'List'
	      }, {
	        id: 'map',
	        labelText: 'Map'
	      }]
	    });
	    self._tabs.on('tab:clicked', function (tabModel) {
	      if (tabModel.id == 'map') {
	        self.fmcyLocationMapListRegion.$el.hide();
	        if (self.location_map) {
	          self.location_map.adjustMapContainerPosition(null, 0);
	          self.location_map.mapToFeaturesExtent();
	        }
	      } else {
	        self.fmcyLocationMapListRegion.$el.show();
	        if (self.location_map) {
	          self.location_map.adjustMapContainerPosition(null, 450);
	        }
	      }
	    });
	    this._tabs.setActiveTabById('list');
	    self.fmcyLocationMapTabRegion.show(self._tabs);
	  },
	  onRender: function onRender() {
	    //this._renderChangeLocationButton();
	    this._renderLocationTabs();
	    this._renderLocationList();
	    this._renderLocationMap();
	    this._renderMapCTA();
	  }
	});
	module.exports = LocationDisplay;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(8), __webpack_require__(11)))

/***/ },
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/kiosk_backround_leaves-c2b5bd4ba1133b9cd2ddc819dbdc247b.jpg";

/***/ },
/* 670 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/touch_screen_icon-6cc3a40bde95f0310ef5c4d66c56a885.svg";

/***/ },
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette, _) {var DialogBehaviour = __webpack_require__(456).Behavior;
	var Controller = Marionette.Controller.extend({
	    initialize: function (options) {
	        this.container = options.container;
	        this.view = new ConfirmDialog();
	        this.container.show(this.view);
	    }
	});
	
	__webpack_require__(829);
	var ConfirmDialog = Marionette.LayoutView.extend({
	    confirmClicked: false,
	    cancelClicked: false,
	    channel: null,
	    className: 'tl-confirm-dialog',
	    template: __webpack_require__(880),
	    regions: {
	        contentViewRegion: '.tl-content-view-region'
	    },
	    behaviors: {
	        Modal: {
	            behaviorClass: DialogBehaviour
	        }
	    },
	    initialize: function (options) {
	        var self = this;
	        self.options = _.defaults(
	            options || {},
	            {
	                customClassName: null,
	                title: null,
	                confirmText: null,
	                cancelButtonLabel: 'Cancel',
	                showCancelButton: true,
	                confirmButtonLabel: 'OK',
	                // beforeConfirmedCallback can be used to prevent the user
	                // from confirming (and therefore closing) the dialog
	                // when the confirm button is clicked.
	                beforeConfirmedCallback: null,
	                confirmedCallback: null,
	                cancelledCallback: null,
	                contentView: null,
	                showSecondaryConfirmButton: false,
	                secondaryConfirmButtonLabel: null,
	                beforeSecondaryConfirmedCallback: null,
	                secondaryConfirmedCallback: null,
	
	            }
	        );
	        self.channel = options.channel || Radio.channel('dialog');
	        self.on('close', self._mayTriggerCancelledCallback.bind(self));
	        self.trigger('modal:open');
	    },
	    events: {
	        'click .tl-primary-confirm-btn': '_confirmClicked',
	        'click .tl-secondary-confirm-btn': '_secondaryConfirmClicked',
	        'click .tl-cancel-btn': '_cancelClicked'
	    },
	    _mayTriggerCancelledCallback: function () {
	        if (!this.cancelClicked && !this.confirmClicked && this.options.cancelledCallback) {
	            this.options.cancelledCallback();
	        }
	    },
	    _confirmClicked: function () {
	        if (!this.options.beforeConfirmedCallback ||
	            this.options.beforeConfirmedCallback(this.contentViewRegion.currentView))
	        {
	            if (this.options.confirmedCallback) {
	                this.options.confirmedCallback();
	            }
	            this.confirmClicked = true;
	            this.close();
	        }
	    },
	    _secondaryConfirmClicked: function () {
	        if (!this.options.beforeSecondaryConfirmedCallback ||
	            this.options.beforeSecondaryConfirmedCallback(this.contentViewRegion.currentView))
	        {
	            if (this.options.secondaryConfirmedCallback) {
	                this.options.secondaryConfirmedCallback();
	            }
	            this.confirmClicked = true;
	            this.close();
	        }
	    },
	    close: function () {
	        this.trigger('modal:close');
	    },
	    _cancelClicked: function () {
	        this._mayTriggerCancelledCallback();
	        this.cancelClicked = true;
	        this.close();
	    },
	    serializeData: function () {
	        return {
	            options: this.options
	        };
	    },
	    setView: function (view) {
	        this.contentViewRegion.show(view);
	    },
	    getDialog: function () {
	        return this.dialog;
	    },
	    onRender: function () {
	        if (this.options.contentView) {
	            this.contentViewRegion.show(this.options.contentView);
	        }
	        this.$el.addClass(this.options.customClassName);
	    }
	});
	
	module.exports = {
	    Controller: Controller,
	    View: ConfirmDialog
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(7)))

/***/ },
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	
	__webpack_require__(806);
	
	var CartEmpty = BaseViews.LayoutView.extend({
	  className: 'fmcy-cart-empty',
	  template: __webpack_require__(852),
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      _appChannel: null
	    });
	  },
	  serializeData: function serializeData() {
	    return {
	      message: 'Your cart is currently empty'
	    };
	  },
	  ui: {
	    cartLeftColumn: '.fmcy-cart-empty-left-column',
	    cartRightColumn: '.fmcy-cart-empty-right-column'
	  },
	  regions: {
	    errorMessageRegion: '.fmcy-cart-empty-error-message-region',
	    paymentFormRegion: '.fmcy-cart-empty-pay-form-region'
	  },
	  onRender: function onRender() {
	    var self = this;
	    $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
	    this._onWindowResize();
	    BaseViews.LayoutView.prototype.onRender.call(self);
	  },
	  _onWindowResize: function _onWindowResize(event) {
	    var magicBuffer = 132;
	    var minHeight = $(window).height() - magicBuffer;
	    this.$el.css('minHeight', minHeight);
	    this.ui.cartLeftColumn.css('minHeight', minHeight);
	    this.ui.cartRightColumn.css('minHeight', minHeight);
	  },
	  onDestroy: function onDestroy() {
	    $(window).off('resize.' + this.cid);
	    BaseViews.LayoutView.prototype.onDestroy.call(self);
	  }
	});
	
	module.exports = CartEmpty;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	var Spinner = __webpack_require__(20);
	__webpack_require__(807);
	
	var CartLoading = BaseViews.LayoutView.extend({
	    className: 'fmcy-cart-loading',
	    template: __webpack_require__(853),
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            theme: 'light'
	        });
	    },
	    regions: {
	        loadingIndicatorRegion: '.fmcy-cart-loading-indicator-region'
	    },
	    _renderLoader: function _renderLoader() {
	        this._spinner = new Spinner();
	        this.loadingIndicatorRegion.show(this._spinner);
	    },
	    onRender: function onRender() {
	        var self = this;
	        this._renderLoader();
	        BaseViews.LayoutView.prototype.onRender.call(self);
	    },
	    onDestroy: function onDestroy() {
	        BaseViews.LayoutView.prototype.onDestroy.call(self);
	    }
	});
	
	module.exports = CartLoading;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	var Spinner = __webpack_require__(20);
	
	__webpack_require__(808);
	
	var CartPaymentChallenge = BaseViews.LayoutView.extend({
	  className: 'fmcy-cart-payment-challenge',
	  template: __webpack_require__(854),
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      challengeData: null,
	      _appChannel: null
	    });
	  },
	  ui: {
	    formChallenge: '.fmcy-form-challenge',
	    formChallengeIframe: '.fmcy-form-challenge-iframe'
	  },
	  regions: {
	    spinnerRegion: '.spinner-region'
	  },
	  onRender: function onRender() {
	    var self = this;
	    $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
	    this.challengeIframe = $('<iframe>').attr('height', $(window).height()).attr('width', $(window).width()).appendTo(this.ui.formChallenge);
	
	    this.challengeIframe.ready(function () {
	      var body = self.challengeIframe.contents().find('body');
	      self.challengeForm = $('<form>', {
	        'action': self.options.challengeData.data.challengeUrl,
	        'target': '_self',
	        'method': 'POST'
	      }).append(jQuery('<input>', {
	        'name': 'creq',
	        'value': self.options.challengeData.data.challengeData,
	        'type': 'hidden'
	      })).appendTo(body);
	      self.challengeForm.submit();
	    });
	    this._renderSpinner();
	    this._onWindowResize();
	    BaseViews.LayoutView.prototype.onRender.call(self);
	  },
	  _renderSpinner: function _renderSpinner() {
	    this._spinner = new Spinner();
	    this.spinnerRegion.show(this._spinner);
	    this._spinner.setMessage('Authenticating...');
	  },
	  _onWindowResize: function _onWindowResize(event) {
	    var magicBuffer = 132;
	    var minHeight = $(window).height() - magicBuffer;
	    this.$el.css('minHeight', $(window).height());
	    if (this.challengeIframe) {
	      this.challengeIframe.attr('height', minHeight);
	      this.challengeIframe.attr('width', $(window).width());
	    }
	
	    this.ui.formChallenge.css('minHeight', $(window).height());
	    this.ui.formChallenge.css('minWidth', $(window).width());
	  },
	  onDestroy: function onDestroy() {
	    $(window).off('resize.' + this.cid);
	    BaseViews.LayoutView.prototype.onDestroy.call(self);
	  }
	});
	
	module.exports = CartPaymentChallenge;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	var StringUtils = __webpack_require__(9);
	var CartErrorMessage = __webpack_require__(296);
	var CreditCardForm = __webpack_require__(489);
	var CustomerEntities = __webpack_require__(287);
	
	__webpack_require__(809);
	__webpack_require__(416);
	
	var CartPayment = BaseViews.LayoutView.extend({
	  className: 'fmcy-cart-payment',
	  template: __webpack_require__(855),
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      theme: 'light',
	      errors: null,
	      errorMessage: null,
	      errorField: null,
	      _appChannel: null
	    });
	    this.currentOrderModel = this.options._appChannel.request('cart:get:curent:order');
	    this.cartCost = this.currentOrderModel.get('order_total');
	  },
	  serializeData: function serializeData() {
	    return {
	      cartTotalCost: StringUtils.currency(this.cartCost),
	      orderCode: this.currentOrderModel.get('order_code'),
	      paymentMethod: this.currentOrderModel.get('order_payment_method')
	    };
	  },
	  ui: {
	    cartTotalCost: '.fmcy-cart-payment-total-cost',
	    cartLeftColumn: '.fmcy-cart-payment-left-column',
	    cartRightColumn: '.fmcy-cart-payment-right-column'
	  },
	  regions: {
	    errorMessageRegion: '.fmcy-cart-payment-error-message-region',
	    paymentFormRegion: '.fmcy-cart-payment-pay-form-region'
	  },
	  _renderErrorMessage: function _renderErrorMessage() {
	    var errorMessageOptions = {};
	    if (this.options.errorMessage !== null) {
	      errorMessageOptions.message = this.options.errorMessage;
	    }
	    this._errorMessage = new CartErrorMessage(errorMessageOptions);
	    this.errorMessageRegion.show(this._errorMessage);
	  },
	  _renderCreditCardPaymentForm: function _renderCreditCardPaymentForm() {
	    this._creditCardForm = new CreditCardForm({
	      _appChannel: this.options._appChannel,
	      errorField: this.options.errorField,
	      model: this.options._appChannel.request('cart:get:payment:method:model')
	    });
	    this.paymentFormRegion.show(this._creditCardForm);
	  },
	
	  _hideErrorMessage: function _hideErrorMessage() {
	    this.options.errors = [];
	    this.options.errorMessage = null;
	    this.errorMessageRegion.empty();
	  },
	  onRender: function onRender() {
	    var self = this;
	
	    if (this.options.errors && this.options.errors.length > 0) {
	      this._renderErrorMessage();
	      this.options._appChannel.request('scroll:to:page:top');
	    }
	
	    if (this.currentOrderModel.get('order_payment_method') === 'credit') {
	      this._renderCreditCardPaymentForm();
	    }
	
	    $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
	
	    this._onWindowResize();
	
	    this.listenTo(this.options._appChannel, 'cart:pay', function () {
	      self._hideErrorMessage();
	    });
	
	    BaseViews.LayoutView.prototype.onRender.call(self);
	  },
	  _onWindowResize: function _onWindowResize(event) {
	    var magicBuffer = 132;
	    var minHeight = $(window).height() - magicBuffer;
	    this.$el.css('minHeight', minHeight);
	    this.ui.cartLeftColumn.css('minHeight', minHeight);
	    this.ui.cartRightColumn.css('minHeight', minHeight);
	  },
	  onDestroy: function onDestroy() {
	    $(window).off('resize.' + this.cid);
	    BaseViews.LayoutView.prototype.onDestroy.call(self);
	  }
	});
	
	module.exports = CartPayment;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	var CartItems = __webpack_require__(490);
	var CartLocationDisplay = __webpack_require__(91);
	var StringUtils = __webpack_require__(9);
	var CartErrorMessage = __webpack_require__(296);
	var CartTotalWeight = __webpack_require__(491);
	var CartGiftForm = __webpack_require__(488);
	var CartDeliveryAddressForm = __webpack_require__(484);
	var DeliveryPostalCodeForm = __webpack_require__(286);
	var CartDeliveryPhoneForm = __webpack_require__(486);
	var CartDeliveryNotesForm = __webpack_require__(485);
	var CartDeliveryTip = __webpack_require__(487);
	var lsCache = __webpack_require__(77);
	
	__webpack_require__(810);
	__webpack_require__(416);
	
	var CartReview = BaseViews.LayoutView.extend({
	  className: 'fmcy-cart-review',
	  template: __webpack_require__(856),
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      theme: 'light',
	      errors: null,
	      errorMessage: null,
	      _appChannel: null
	    });
	    this.errorsFixed = 0;
	    this.cartCost = this.options._appChannel.request('cart:get:total:cost');
	    this.paymentModel = this.options._appChannel.request('cart:get:payment:model');
	    this.deliveryModel = this.options._appChannel.request('cart:get:delivery:model');
	  },
	  _updateCartCost: function _updateCartCost(cartCost) {
	    this.cartCost = cartCost;
	    this.ui.cartTotalCost.html(StringUtils.currency(cartCost.total));
	    this.ui.cartSubTotal.html('Subtotal: ' + StringUtils.currency(cartCost.subTotal));
	    this.ui.cartDeliveryTotal.html('Delivery fee: ' + StringUtils.currency(cartCost.deliveryTotal));
	    this.ui.deliveryReviewTipText.html(StringUtils.decimalToPercentage(cartCost.tipPercentage) + ' Tip: ' + StringUtils.currency(cartCost.tipTotal));
	    this.ui.cartTax.html('Tax: ' + StringUtils.currency(cartCost.tax));
	    this.ui.cartDeposit.html('Recycling Deposit: ' + StringUtils.currency(cartCost.depositTotal));
	    this._maybeRenderRecyclingDeposit();
	    this._maybeRenderDeliveryLineItems();
	  },
	  _maybeRenderDeliveryLineItems: function _maybeRenderDeliveryLineItems() {
	    if (this.deliveryModel.get('deliveryMethod') == 'local_delivery') {
	      this.ui.cartDeliveryTotal.show();
	      this.ui.cartTip.show();
	    } else {
	      this.ui.cartDeliveryTotal.hide();
	      this.ui.cartTip.hide();
	    }
	  },
	  _renderNextAvailableDeliveryMessage: function _renderNextAvailableDeliveryMessage(deliveryNextAvailable) {
	    var deliveryMessage = '';
	    if (deliveryNextAvailable) {
	      if (deliveryNextAvailable.isToday) {
	        deliveryNextAvailable.day = 'today';
	      } else {
	        deliveryNextAvailable.day = deliveryNextAvailable.day.charAt(0).toUpperCase() + deliveryNextAvailable.day.slice(1);
	      }
	
	      var deliveryMessage = ' Delivery will be available again ' + deliveryNextAvailable.day + ' between ' + deliveryNextAvailable.startTime + ' and ' + deliveryNextAvailable.endTime;
	    }
	
	    this.ui.deliveryAvailableLaterMessage.html(deliveryMessage);
	    this.ui.deliveryAvailableLater.css('display', 'block');
	  },
	  _maybeRenderLocalDeliveryOption: function _maybeRenderLocalDeliveryOption() {
	
	    // if delivery is not available everywhere, hide the option
	    if (this.options._appChannel.request('validate:is:delivery:available:anywhere') == false) {
	      if (this.deliveryModel.get('deliveryMethod') == 'local_delivery') {
	        this.deliveryModel.set('deliveryMethod', 'pickup');
	      }
	      this.ui.deliveryLocalStandardRadioGroup.hide();
	
	      // delivery is unavailable everywhere and no error..
	      if (!this.deliveryUnavailableError) {
	        return;
	      }
	    }
	
	    // check delivery times and when its next available.
	    var isDeliveryAvailableAtThisTime = this.options._appChannel.request('validate:is:delivery:available:at:this:time');
	
	    if ((isDeliveryAvailableAtThisTime.deliveryAvailableAtThisTime == false || parseInt(isDeliveryAvailableAtThisTime.deliveryAvailableAtThisTime) == 0) && !this.deliveryUnavailableError) {
	
	      if (isDeliveryAvailableAtThisTime.deliveryNextAvailable && isDeliveryAvailableAtThisTime.deliveryNextAvailable.available == true) {
	        this._renderNextAvailableDeliveryMessage(isDeliveryAvailableAtThisTime.deliveryNextAvailable);
	      } else {
	        this._renderNextAvailableDeliveryMessage(false);
	      }
	    }
	  },
	  serializeData: function serializeData() {
	    var currentSelectedLocation = this.options._appChannel.request('get:filter:location:details');
	    var deliveryMinDollarAmount = currentSelectedLocation.get('delivery_min_dollar_amount');
	    if (!deliveryMinDollarAmount) {
	      deliveryMinDollarAmount = 0;
	    }
	
	    return {
	      cartTotalCost: StringUtils.currency(this.cartCost.total),
	      cartTax: StringUtils.currency(this.cartCost.tax),
	      cartDeposit: StringUtils.currency(this.cartCost.depositTotal),
	      cartSubTotal: StringUtils.currency(this.cartCost.subTotal),
	      cartDeliveryTotal: StringUtils.currency(this.cartCost.deliveryTotal),
	      cartDeliveryTipTotal: StringUtils.currency(this.cartCost.tipTotal),
	      cartDeliveryTipPercentage: StringUtils.decimalToPercentage(this.cartCost.tipPercentage),
	      deliveryMinDollarAmount: StringUtils.currency(deliveryMinDollarAmount),
	      creditCardPaymentEnabled: farmacy.settings.payments.creditCardPaymentEnabled,
	      interacPaymentEnabled: farmacy.settings.payments.interacPaymentEnabled
	    };
	  },
	  ui: {
	    cartTotalCost: '.fmcy-cart-review-total-cost',
	    cartSubTotal: '.fmcy-cart-review-sub-total',
	    cartDeliveryTotal: '.fmcy-cart-review-delivery-total',
	    cartTip: '.fmcy-cart-review-tip',
	    cartTax: '.fmcy-cart-review-tax',
	    cartDeposit: '.fmcy-cart-review-deposit',
	    cartLeftColumn: '.fmcy-cart-review-left-column',
	    cartRightColumn: '.fmcy-cart-review-right-column',
	    payNowCreditRadio: '#fmcy-cart-paynow-credit-radio',
	    payNowInteracRadio: '#fmcy-cart-paynow-interac-radio',
	    payLaterRadio: '#fmcy-cart-paylater-radio',
	    payLaterRadioGroup: '.fmcy-cart-paylater-group',
	    payNowCreditRadioGroup: '.fmcy-cart-paynow-credit-group',
	    deliveryPickupRadio: '#fmcy-cart-delivery-pickup-radio',
	    deliveryPickupLocationReviewEdit: '.local-pickup-location-review-edit',
	    deliveryLocalStandardRadio: '#fmcy-cart-delivery-local-standard-radio',
	    changeLocationLink: '.location-change-click-here',
	    paymentMethodErrorMessage: '.fmcy-cart-review-payment-method-error-message',
	    deliveryDefaultErrorMessage: '.fmcy-cart-review-delivery-default-error-message',
	    deliveryLocalStandardRadioGroup: '.fmcy-cart-delivery-local-standard-radio-group',
	    deliveryAvailableLater: '.fmcy-cart-delivery-available-later',
	    deliveryAvailableLaterMessage: '.fmcy-cart-delivery-available-next-message',
	    deliveryReviewTip: '.fmcy-cart-review-tip',
	    deliveryReviewTipText: '.fmcy-cart-review-tip-text'
	  },
	  events: {
	    'change input[type=radio][name=payRadioGroup]': 'onPayRadioChange',
	    'change input[type=radio][name=deliveryRadioGroup]': 'onDeliveryRadioChange',
	    'click @ui.changeLocationLink': 'onLocationChangeClicked',
	    'click @ui.deliveryReviewTip': 'onCartChangeTip'
	  },
	  onPayRadioChange: function onPayRadioChange(event) {
	    switch (event.currentTarget.value) {
	      case 'paylater':
	        this.options._appChannel.trigger('cart:set:payment:method', 'instore');
	        break;
	      case 'paynow_interac':
	        this.options._appChannel.trigger('cart:set:payment:method', 'interac');
	        break;
	      default:
	        //paynow_credit
	        this.options._appChannel.trigger('cart:set:payment:method', 'credit');
	        break;
	    }
	    this._maybeRenderGiftForm({
	      error: false
	    });
	    this.ui.paymentMethodErrorMessage.hide();
	  },
	  _renderPostalCodeForm: function _renderPostalCodeForm() {
	    var self = this;
	    this.deliveryPostalCodeForm = new DeliveryPostalCodeForm({
	      _appChannel: this.options._appChannel,
	      error: this.postalCodeError,
	      errorMessage: this.postalCodeErrorMessage,
	      referrer: 'cart'
	    });
	
	    this.cartLocalDeliveryPostalCodeRegion.show(this.deliveryPostalCodeForm);
	  },
	  _renderDeliveryNotes: function _renderDeliveryNotes() {
	    this.cartDeliveryNotesForm = new CartDeliveryNotesForm({
	      _appChannel: this.options._appChannel,
	      model: this.deliveryModel
	    });
	    this.cartLocalDeliveryNotesRegion.show(this.cartDeliveryNotesForm);
	  },
	  onCartChangeTip: function onCartChangeTip() {
	    this._renderDeliveryTip();
	  },
	  _renderDeliveryTip: function _renderDeliveryTip() {
	    var self = this;
	    this.cartDeliveryTip = new CartDeliveryTip({
	      _appChannel: this.options._appChannel,
	      model: this.deliveryModel,
	      expandedDetails: false,
	      selectedValue: this.cartCost.tipPercentage
	    });
	
	    this.cartDeliveryTip.on('update', function () {
	      self.options._appChannel.trigger('cart:items:updated');
	    });
	
	    this.cartTipBelowRegion.show(this.cartDeliveryTip);
	  },
	  _renderDeliveryPhone: function _renderDeliveryPhone() {
	    this.cartDeliveryPhonesForm = new CartDeliveryPhoneForm({
	      _appChannel: this.options._appChannel,
	      model: this.deliveryModel,
	      error: this.phoneError,
	      errorMessage: this.phoneErrorMessage
	    });
	    this.cartLocalDeliveryPhoneRegion.show(this.cartDeliveryPhonesForm);
	  },
	  _renderDeliveryAddressForm: function _renderDeliveryAddressForm() {
	    var self = this;
	    this.cartDeliveryAddressForm = new CartDeliveryAddressForm({
	      _appChannel: this.options._appChannel,
	      model: this.deliveryModel.get('cartDeliveryAddressModel'),
	      error: this.addressError,
	      errorMessage: this.addressErrorMessage
	    });
	    this.cartLocalDeliveryAddressRegion.show(this.cartDeliveryAddressForm);
	  },
	  _deliveryRadioHighlight: function _deliveryRadioHighlight(deliveryMethod) {
	
	    if (deliveryMethod == 'pickup') {
	      this.cartLocalDeliveryPostalCodeRegion.empty();
	      this.cartLocalDeliveryAddressRegion.empty();
	      this.cartLocalDeliveryNotesRegion.empty();
	      this.cartLocalDeliveryTipRegion.empty();
	      this.cartTipBelowRegion.empty();
	      this.cartLocalDeliveryPhoneRegion.empty();
	    } else {
	      this.ui.deliveryPickupLocationReviewEdit.hide();
	    }
	
	    var currentSelectedLocationSlug = this.options._appChannel.request('get:filter:location:details').get('slug');
	
	    var deliveryAdddressModel = this.deliveryModel.get('cartDeliveryAddressModel');
	    deliveryAdddressModel.set('local_delivery_method', deliveryMethod);
	    lsCache.set('cartDeliveryAddressModel', deliveryAdddressModel.toJSON(), 14400000);
	
	    switch (deliveryMethod) {
	      case 'pickup':
	        this.ui.deliveryPickupRadio.prop('checked', true);
	        this.ui.deliveryPickupRadio.checked = true;
	        this.ui.deliveryAvailableLater.addClass('delivery-later-message-soften');
	        break;
	      default:
	        // local delivery
	        this.ui.deliveryLocalStandardRadio.prop('checked', true);
	        this.ui.deliveryLocalStandardRadio.checked = true;
	        this._renderPostalCodeForm();
	        this._renderDeliveryAddressForm({
	          error: this.addressError
	        });
	        this._renderDeliveryNotes();
	        this._renderDeliveryPhone();
	        if (this.ui.deliveryAvailableLater.hasClass('delivery-later-message-soften')) {
	          this.ui.deliveryAvailableLater.removeClass('delivery-later-message-soften');
	        }
	        break;
	    }
	
	    switch (deliveryMethod) {
	      case 'pickup':
	        this.ui.deliveryPickupLocationReviewEdit.show();
	        this.options._appChannel.trigger('cart:set:delivery:method', deliveryMethod);
	        break;
	      default:
	        // local delivery
	        this.options._appChannel.trigger('cart:set:delivery:method', deliveryMethod);
	        break;
	    }
	
	    this._hideShowPaymentMethods(deliveryMethod);
	  },
	  onDeliveryRadioChange: function onDeliveryRadioChange(event) {
	    this._deliveryRadioHighlight(event.currentTarget.value);
	    this.options._appChannel.trigger('cart:items:updated');
	  },
	  _hideShowPaymentMethods: function _hideShowPaymentMethods(deliveryMethod) {
	    if (deliveryMethod == 'pickup') {
	      this.ui.payLaterRadioGroup.show();
	      var currentSelectedLocation = this.options._appChannel.request('get:filter:location:details');
	      if (farmacy.settings.payments.creditCardPaymentEnabled === true && (currentSelectedLocation.get('payments_allow_online') === true || currentSelectedLocation.get('payments_allow_online') === '1')) {
	        this.options._appChannel.trigger('cart:set:payment:method', 'credit');
	        this.ui.payNowCreditRadio.prop('checked', true);
	        this.ui.payNowCreditRadio.checked = true;
	        this.ui.payNowCreditRadioGroup.show();
	      } else {
	        this.options._appChannel.trigger('cart:set:payment:method', 'instore');
	        this.ui.payNowCreditRadio.prop('checked', false);
	        this.ui.payLaterRadio.prop('checked', true);
	        this.ui.payLaterRadio.checked = true;
	        this.ui.payNowCreditRadioGroup.hide();
	      }
	    } else {
	      this.ui.payLaterRadioGroup.hide();
	      this.options._appChannel.trigger('cart:set:payment:method', 'credit');
	      this.ui.payNowCreditRadio.prop('checked', true);
	      this.ui.payNowCreditRadio.checked = true;
	      this.ui.payNowCreditRadioGroup.show();
	    }
	  },
	  onLocationChangeClicked: function onLocationChangeClicked(event) {
	    this.options._appChannel.trigger('menu:overlay:view:close');
	    this.options._appChannel.trigger('location:selection:view', {
	      referrer: 'cart',
	      skipAgeGate: true
	    });
	  },
	  regions: {
	    cartItemsRegion: '.fmcy-cart-review-items-region',
	    errorMessageRegion: '.fmcy-cart-review-error-message-region',
	    totalWeightRegion: '.fmcy-cart-total-weight-region',
	    cartGiftRegion: '.fmcy-cart-gift-form-region',
	    cartPickupLocationRegion: '.fmcy-cart-pickup-location-region',
	    cartLocalDeliveryAddressRegion: '.fmcy-cart-delivery-address-region',
	    cartLocalDeliveryPostalCodeRegion: '.fmcy-cart-delivery-postal-code-region',
	    cartLocalDeliveryNotesRegion: '.fmcy-cart-delivery-notes-region',
	    cartLocalDeliveryTipRegion: '.fmcy-cart-delivery-tip-region',
	    cartLocalDeliveryPhoneRegion: '.fmcy-cart-delivery-phone-region',
	    cartTipBelowRegion: '.fmcy-cart-tip-below-region'
	  },
	  _renderTotalWeight: function _renderTotalWeight(options) {
	    this._totalWeightMessage = new CartTotalWeight(options);
	    this.totalWeightRegion.show(this._totalWeightMessage);
	  },
	  _hideTotalWeight: function _hideTotalWeight() {
	    this.totalWeightRegion.empty();
	  },
	  _updateCartTotalWeight: function _updateCartTotalWeight(weight) {
	    if (this.collection.length > 0) {
	      this._totalWeightMessage.show();
	    } else {
	      this._totalWeightMessage.hide();
	    }
	    if (this._totalWeightMessage !== null) {
	      this._totalWeightMessage.updateMessage(weight);
	    }
	  },
	  _renderCartLocationDisplay: function _renderCartLocationDisplay() {
	    this._cartLocationDisplay = new CartLocationDisplay({
	      _appChannel: this.options._appChannel,
	      hidePhotoSmallScreen: false
	    });
	    this.cartPickupLocationRegion.show(this._cartLocationDisplay);
	  },
	  _renderCartItems: function _renderCartItems() {
	    var self = this;
	    this._cartItems = new CartItems({
	      collection: this.collection,
	      _appChannel: this.options._appChannel,
	      errors: this.options.errors
	    });
	    this._cartItems.on('cart:remove:item', function (model) {
	      if (model.get('error') === true) {
	        self.errorsFixed += 1;
	        if (self.options.errors == null || self.errorsFixed >= self.options.errors.length) {
	          self._hideErrorMessage();
	        }
	      }
	    });
	    this.cartItemsRegion.show(this._cartItems);
	  },
	  _renderErrorMessage: function _renderErrorMessage() {
	    var errorMessageOptions = {};
	    if (this.options.errorMessage !== null) {
	      errorMessageOptions.message = this.options.errorMessage;
	    }
	    this._errorMessage = new CartErrorMessage(errorMessageOptions);
	    this.errorMessageRegion.show(this._errorMessage);
	  },
	  _hideErrorMessage: function _hideErrorMessage() {
	    this.errorMessageRegion.empty();
	  },
	  _maybeRenderRecyclingDeposit: function _maybeRenderRecyclingDeposit() {
	    if (this.cartCost.depositTotal == 0) {
	      this.ui.cartDeposit.hide();
	    } else {
	      this.ui.cartDeposit.show();
	    }
	  },
	  _maybeRenderGiftForm: function _maybeRenderGiftForm(options) {
	    if (farmacy.settings.giftEnabled) {
	      if (!this.giftForm) {
	        this.giftForm = new CartGiftForm({
	          model: this.paymentModel.get('cartGiftModel'),
	          error: options.error
	        });
	        this.cartGiftRegion.show(this.giftForm);
	      }
	    } else {
	      this.cartGiftRegion.empty();
	      this.giftForm = null;
	    }
	  },
	  addressError: false,
	  addressErrorMessage: '',
	  phoneError: false,
	  phoneErrorMessage: '',
	  postalCodeError: false,
	  deliveryUnavailableError: false,
	  postalCodeErrorMessage: '',
	
	  onRender: function onRender() {
	    var self = this;
	    this.collection = this.options._appChannel.request('cart:get:items');
	
	    var weightErrorMessage = null;
	    var weightError = false;
	    var giftFormError = false;
	    this.addressError = false;
	    this.phoneError = false;
	    this.postalCodeError = false;
	    this.deliveryUnavailableError = false;
	
	    if (this.options.errors && this.options.errors.length > 0) {
	      this._renderErrorMessage();
	      //TODO: figure out why it's sorting when qty changed...
	      //this.collection.setSort('error', 'desc');
	      var errors = this.options.errors;
	
	      errors.forEach(function (error) {
	        if (error.code == 'overlimit' && error.message !== null) {
	          weightErrorMessage = error.message;
	          weightError = true;
	        }
	        if (error.code == 'paymentmethod') {
	          self.ui.paymentMethodErrorMessage.css('display', 'block');
	        }
	        if (error.code == 'giftform') {
	          giftFormError = true;
	        }
	        if (error.code == 'deliveryminimum' || error.code == 'deliveryunavailable' || error.code == 'fetcherror') {
	          self.ui.deliveryDefaultErrorMessage.html(error.message);
	          self.ui.deliveryDefaultErrorMessage.css('display', 'block');
	        }
	        if (error.code == 'deliveryunavailable') {
	          self.ui.deliveryDefaultErrorMessage.html(error.message);
	          self.ui.deliveryDefaultErrorMessage.css('display', 'block');
	          self.deliveryUnavailableError = true;
	        }
	
	        if (error.code == 'deliveryaddress') {
	          self.addressError = true;
	          self.addressErrorMessage = error.message;
	        }
	        if (error.code == 'phone') {
	          self.phoneError = true;
	          self.phoneErrorMessage = error.message;
	        }
	        if (error.code == 'postalcode') {
	          self.postalCodeError = true;
	          self.postalCodeMessage = error.message;
	        }
	      });
	    }
	
	    this._renderCartItems();
	
	    var hideTotalWeight = true;
	    if (this.collection.length > 0) {
	      hideTotalWeight = false;
	    }
	
	    this._renderTotalWeight({
	      _appChannel: this.options._appChannel,
	      weight: this.options._appChannel.request('cart:get:total:weight'),
	      weightError: weightError,
	      hidden: hideTotalWeight,
	      errorMessage: weightErrorMessage
	    });
	
	    this.listenTo(this.options._appChannel, 'cart:items:updated', function () {
	      self._updateCartCost(self.options._appChannel.request('cart:get:total:cost'));
	      self._updateCartTotalWeight(self.options._appChannel.request('cart:get:total:weight'));
	      self.ui.deliveryDefaultErrorMessage.css('display', 'none');
	    });
	
	    $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
	
	    this._onWindowResize();
	
	    this._maybeRenderLocalDeliveryOption();
	    this._maybeRenderDeliveryLineItems();
	    this._maybeRenderRecyclingDeposit();
	
	    switch (this.paymentModel.get('paymentMethod')) {
	      case 'instore':
	        this.ui.payLaterRadio.prop('checked', true);
	        this.ui.payLaterRadio.checked = true;
	        break;
	      case 'interac':
	        this.ui.payNowInteracRadio.prop('checked', true);
	        this.ui.payNowInteracRadio.checked = true;
	        break;
	      default:
	        //credit
	        this.ui.payNowCreditRadio.prop('checked', true);
	        this.ui.payNowCreditRadio.checked = true;
	        break;
	    }
	
	    this._deliveryRadioHighlight(this.deliveryModel.get('deliveryMethod'));
	
	    this._renderCartLocationDisplay();
	    this._maybeRenderGiftForm({
	      error: giftFormError
	    });
	
	    BaseViews.LayoutView.prototype.onRender.call(self);
	  },
	  _onWindowResize: function _onWindowResize(event) {
	    var magicBuffer = 132;
	    var minHeight = $(window).height() - magicBuffer;
	    this.$el.css('minHeight', minHeight);
	    this.ui.cartLeftColumn.css('minHeight', minHeight);
	    this.ui.cartRightColumn.css('minHeight', minHeight);
	  },
	  onDestroy: function onDestroy() {
	    $(window).off('resize.' + this.cid);
	    BaseViews.LayoutView.prototype.onDestroy.call(self);
	  }
	});
	
	module.exports = CartReview;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	__webpack_require__(1014);
	__webpack_require__(811);
	var BaseViews = __webpack_require__(5);
	var CountDown = BaseViews.LayoutView.extend({
	    template: __webpack_require__(857),
	    className: 'fmcy-count-down',
	    ui: {
	        countDown: '.fmcy-countdown'
	    },
	    modelEvents: function modelEvents() {
	        var modelEvents = {};
	        if (this.options.modelAttr) {
	            modelEvents['change:' + this.options.modelAttr] = 'render';
	        }
	
	        return _.extend({}, _.result(BaseViews.LayoutView.prototype, 'modelEvents'), modelEvents);
	    },
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            countdownFinishedText: null,
	            modelAttr: null,
	            timestampMs: null,
	            beforeStartPrefix: null,
	            afterEndPrefix: null,
	            elapse: false,
	            formatDisplayCallback: null
	        });
	    },
	    setCountDownText: function setCountDownText(text) {
	        this.ui.countDown.text(text);
	    },
	    _renderCountDown: function _renderCountDown() {
	        var self = this;
	        var startTimestampMs;
	        if (self.options.modelAttr) {
	            if (self.options.fromRaw) {
	                startTimestampMs = self.options.fromRaw.call(self, self.model.get(self.options.modelAttr));
	            } else {
	                startTimestampMs = self.model.get(self.options.modelAttr);
	            }
	        } else {
	            startTimestampMs = self.options.startTimestampMs;
	        }
	
	        if (!startTimestampMs) {
	            return;
	        }
	
	        function getTimeString(event) {
	            var timeStringArr = [];
	            if (event.offset.weeks) {
	                timeStringArr.push('<span>' + event.offset.weeks + '</span> weeks');
	            }
	
	            if (event.offset.days) {
	                timeStringArr.push('<span>' + event.offset.days + '</span> days');
	            }
	
	            if (event.offset.hours) {
	                timeStringArr.push('<span>' + event.offset.hours + '</span> hours');
	            }
	
	            if (event.offset.minutes) {
	                timeStringArr.push('<span>' + event.offset.minutes + '</span> minutes');
	            }
	
	            if (event.offset.seconds) {
	                timeStringArr.push('<span>' + event.offset.seconds + '</span>');
	            }
	            return event.strftime(timeStringArr.join(' '));
	        }
	
	        self.ui.countDown.countdown(startTimestampMs, { elapse: self.options.elapse }).on('update.countdown', function (event) {
	            if (self.options.formatDisplayCallback) {
	                $(this).html(self.options.formatDisplayCallback.call(self, getTimeString(event), event.elapsed));
	            } else if (self.options.elapse && event.elapsed) {
	                $(this).html([self.options.afterEndPrefix, getTimeString(event)].join(' '));
	            } else {
	                $(this).html([self.options.beforeStartPrefix, getTimeString(event)].join(' '));
	            }
	        }).on('finish.countdown', function () {
	            self.trigger('finished');
	            if (self.options.countdownFinishedText) {
	                self.setCountDownText(self.options.countdownFinishedText);
	            }
	        });
	    },
	    onRender: function onRender() {
	        BaseViews.LayoutView.prototype.onRender.call(this);
	        this._renderCountDown();
	    }
	});
	module.exports = CountDown;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette) {'use strict';
	
	var DynamicRegion = Marionette.Region.extend({
	    constructor: function constructor() {
	        var self = this;
	        Marionette.Region.prototype.constructor.apply(this, arguments);
	        jQuery(this.$el).on('hidden.bs.modal', function (event) {
	            if (self.currentView && !self.currentView.isDestroyed) {
	                self.empty();
	            }
	        });
	        self.on('destroy empty', function () {
	            jQuery(self.$el).modal('hide');
	        });
	    },
	    onShow: function onShow() {
	        jQuery(this.$el).modal('show');
	    }
	});
	module.exports = DynamicRegion;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	__webpack_require__(812);
	var BaseViews = __webpack_require__(5);
	var Button = __webpack_require__(70);
	var SpinnerButton = __webpack_require__(19);
	
	var lsCache = __webpack_require__(77);
	
	var AgeGate = BaseViews.LayoutView.extend({
	    template: __webpack_require__(858),
	    className: 'fmcy-age-gate',
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            _appChannel: null
	        });
	        this.deliveryModel = this.options._appChannel.request('cart:get:delivery:model');
	        this.deliveryAddressModel = this.deliveryModel.get('cartDeliveryAddressModel');
	    },
	    ui: {
	        ageGateTitle: '.fmcy-age-gate-title',
	        ageGateButtonBar: '.fmcy-age-gate-button-bar'
	    },
	    regions: {
	        noButtonRegion: '.fmcy-no-button-region',
	        yesButtonRegion: '.fmcy-yes-button-region'
	    },
	    _renderYesButton: function _renderYesButton() {
	        var self = this;
	        var yesButton = new SpinnerButton.SpinnerButton({
	            label: 'Yes',
	            multiClick: false,
	            classNames: 'fmcy-yes-btn',
	            theme: SpinnerButton.THEMES.PRIMARY,
	            size: SpinnerButton.SIZES.LARGE,
	            onClickedCallback: function onClickedCallback() {
	                self.trigger('yes:clicked');
	            }
	        });
	        this.yesButtonRegion.show(yesButton);
	    },
	    _renderNoButton: function _renderNoButton() {
	        var self = this;
	        var noButton = new SpinnerButton.SpinnerButton({
	            label: 'No',
	            multiClick: false,
	            classNames: 'fmcy-no-btn',
	            theme: SpinnerButton.THEMES.PRIMARY,
	            size: SpinnerButton.SIZES.LARGE,
	            onClickedCallback: function onClickedCallback() {
	                self._renderNoButtonClickedMessage();
	            }
	        });
	        this.noButtonRegion.show(noButton);
	    },
	    _renderNoButtonClickedMessage: function _renderNoButtonClickedMessage() {
	        this.ui.ageGateTitle.html('Sorry you must be 19 to enter');
	        this.ui.ageGateButtonBar.css('display', 'none');
	    },
	    onRender: function onRender() {
	        this._renderYesButton();
	        this._renderNoButton();
	    }
	});
	module.exports = AgeGate;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	__webpack_require__(813);
	var BaseViews = __webpack_require__(5);
	var Button = __webpack_require__(70);
	var SpinnerButton = __webpack_require__(19);
	var LocationsList = __webpack_require__(234);
	var DeliveryPostalCodeForm = __webpack_require__(286);
	var lsCache = __webpack_require__(77);
	
	var PickupDeliverySelect = BaseViews.LayoutView.extend({
	    template: __webpack_require__(859),
	    className: 'fmcy-plugin-bootstrap fmcy-pickup-delivery-select container-fluid',
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            _appChannel: null,
	            _menuState: null,
	            referrer: 'entry'
	        });
	        this.deliveryModel = this.options._appChannel.request('cart:get:delivery:model');
	        this.deliveryAddressModel = this.deliveryModel.get('cartDeliveryAddressModel');
	        this.deliveryAvailableAnywhere = this.options._appChannel.request('validate:is:delivery:available:anywhere');
	    },
	    regions: {
	        fmcyPickupDeliverySelectTabRegion: '.fmcy-pickup-delivery-select-tab-region',
	        fmcyPickupDeliverySelectedContentRegion: '.fmcy-pickup-delivery-selected-content-region',
	        fmcyPickupDeliveryContinueButtonRegion: '.fmcy-continue-button-region'
	    },
	    ui: {
	        expandedRow: '.fmcy-pickup-delivery-select-expanded-row',
	        continueButtonSection: '.fmcy-delivery-select-continue-button-bar'
	    },
	    _renderContinueButton: function _renderContinueButton() {
	        var self = this;
	        this.ui.continueButtonSection.css('display', 'block');
	        var continueButton = new SpinnerButton.SpinnerButton({
	            label: 'Start shopping',
	            multiClick: false,
	            classNames: 'fmcy-continue-btn',
	            theme: SpinnerButton.THEMES.PRIMARY,
	            size: SpinnerButton.SIZES.LARGE,
	            onClickedCallback: function onClickedCallback() {
	                self.trigger('location:selected', null);
	            }
	        });
	        this.fmcyPickupDeliveryContinueButtonRegion.show(continueButton);
	    },
	    _hideContinueButton: function _hideContinueButton() {
	        this.ui.continueButtonSection.css('display', 'none');
	    },
	    _renderCheckDeliveryLayout: function _renderCheckDeliveryLayout() {
	        var self = this;
	        var postCodeError = false;
	        var cartdeliveryAddressModel = this.deliveryModel.get('cartDeliveryAddressModel');
	
	        if (currentSelectedLocationSlug == cartdeliveryAddressModel.get('local_delivery_confirmed_farm_location_slug') && cartdeliveryAddressModel.get('local_delivery_postal_code_verified') != null) {
	            this._renderContinueButton();
	        }
	
	        if (cartdeliveryAddressModel.get('local_delivery_postal_code_verified') != cartdeliveryAddressModel.get('local_delivery_postal_code')) {
	            postCodeError = true;
	        }
	
	        this.deliveryPostalCodeForm = new DeliveryPostalCodeForm({
	            _appChannel: this.options._appChannel,
	            error: postCodeError
	        });
	
	        this.deliveryPostalCodeForm.on('show:continue:button', function () {
	            self._renderContinueButton();
	        });
	
	        this.deliveryPostalCodeForm.on('hide:continue:button', function () {
	            self._hideContinueButton();
	        });
	
	        this.fmcyPickupDeliverySelectedContentRegion.show(this.deliveryPostalCodeForm);
	
	        var currentSelectedLocationSlug = this.options._appChannel.request('get:filter:location:details').get('slug');
	    },
	    _renderLocationList: function _renderLocationList() {
	        var self = this;
	        this.locationsList = new LocationsList({
	            collection: this.options._appChannel.request('get:locations'),
	            resizeHeightToScreenSize: false,
	            clickableLocationInfo: true
	        });
	        this.locationsList.on('item:clicked', function (model) {
	            self.options._appChannel.trigger('location:selected', model.get('slug'), self.options.referrer);
	            self.trigger('location:selected', model);
	        });
	        this.fmcyPickupDeliverySelectedContentRegion.show(this.locationsList);
	        this._hideContinueButton();
	    },
	    _renderLocationTabs: function _renderLocationTabs() {
	        var self = this;
	        if (self._tabs) {
	            return;
	        }
	
	        var tabItems = [{
	            id: 'pickup',
	            labelText: 'Instore Pickup'
	        }];
	
	        if (this.deliveryAvailableAnywhere) {
	            tabItems.push({
	                id: 'local_delivery',
	                labelText: 'Delivery'
	            });
	        }
	
	        self._tabs = new (__webpack_require__(255))({
	            style: 'tabs',
	            tabs: tabItems
	        });
	        self._tabs.on('tab:clicked', function (tabModel) {
	            var local_delivery_method = tabModel.id;
	            self.deliveryAddressModel.set('local_delivery_method', local_delivery_method);
	            if (tabModel.id == 'pickup') {
	                // pickup tab clicked...
	                self._renderLocationList();
	            } else {
	                // delivery tab clicked...
	                self._renderCheckDeliveryLayout();
	            }
	            lsCache.set('cartDeliveryAddressModel', self.deliveryAddressModel.toJSON(), 14400000);
	            self.options._appChannel.trigger('cart:set:delivery:method', local_delivery_method);
	        });
	        self.fmcyPickupDeliverySelectTabRegion.show(self._tabs);
	    },
	    onRender: function onRender() {
	        this._renderLocationTabs();
	        if (this.options.delivery_method !== null && (this.options.delivery_method == 'local_delivery' || this.options.delivery_method == 'pickup')) {
	            this.deliveryAddressModel.set('local_delivery_method', this.options.delivery_method);
	            lsCache.set('cartDeliveryAddressModel', this.deliveryAddressModel.toJSON(), 14400000);
	            this.options._appChannel.trigger('cart:set:delivery:method', local_delivery_method);
	        }
	
	        var local_delivery_method = this.deliveryAddressModel.get('local_delivery_method');
	
	        if (local_delivery_method && local_delivery_method == 'local_delivery' && this.deliveryAvailableAnywhere) {
	            this._tabs.setActiveTabById('local_delivery');
	            this._renderCheckDeliveryLayout();
	        } else {
	            this._tabs.setActiveTabById('pickup');
	            this._renderLocationList();
	        }
	    }
	});
	module.exports = PickupDeliverySelect;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette, _) {'use strict';
	
	__webpack_require__(109);
	var BaseViews = __webpack_require__(5);
	var MenuItemPrices = __webpack_require__(108);
	var Obscura = __webpack_require__(103);
	
	var PricesLocationTableSelectedTitle = Marionette.ItemView.extend({
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            title: 'title'
	        });
	    },
	    className: 'prices-location-table-selected-title',
	    template: function template() {
	        return '';
	    },
	    render: function render() {
	        this.$el.html(this.options.title);
	    }
	});
	
	var OtherPricesItemView = BaseViews.LayoutView.extend({
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            title: 'title'
	        });
	    },
	    events: {
	        'click .fmcy-other-location-name': '_otherLocationNameOnClick'
	    },
	    regions: {
	        tablePricesCheckRegion: '.fmcy-menu-item-table-prices-check-region'
	    },
	    tagName: 'tr',
	    template: __webpack_require__(863),
	    serializeData: function serializeData() {
	        return {
	            locationName: this.model.get('name')
	        };
	    },
	    _renderPricesTableCheck: function _renderPricesTableCheck(options) {
	        this._tablePricesCheck = new MenuItemPrices({
	            menuItemModel: this.options.menuItemModel,
	            collection: this.options.variantCollection,
	            locations: this.options.locations,
	            onSale: this.options.menuItemModel.isOnSale(),
	            appChannel: this.options.appChannel,
	            filterLocation: this.model.get('slug'),
	            selected: options.selected,
	            menuItemPriceLayoutSinglePrice: this.options.menuItemPriceLayoutSinglePrice,
	            align: this.options.align,
	            size: this.options.size,
	            style: 'checks',
	            theme: this.options.theme,
	            variantShowInStockIfAtAnyLocation: false
	        });
	
	        this.tablePricesCheckRegion.show(this._tablePricesCheck);
	    },
	    onRender: function onRender() {
	        if (this.model == this.options.selectedLocationModel) {
	            this._selectedLocation = true;
	            this.$el.addClass('prices-location-table-selected');
	            this._renderPricesTableCheck({ selected: true });
	        } else {
	            this._renderPricesTableCheck({ selected: false });
	        }
	    }
	});
	
	var OtherPricesCollectionView = BaseViews.CollectionView.extend({
	    className: '',
	    tagName: 'table',
	    childView: OtherPricesItemView,
	    childViewOptions: function childViewOptions(model, index) {
	        var options = _.extend({ modelIndex: index }, this.options);
	        return options;
	    }
	});
	
	var MenuItemPricesLocationTable = BaseViews.LayoutView.extend({
	    className: 'fmcy-menu-item-prices-location-table',
	    template: __webpack_require__(862),
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            menuItemModel: null,
	            variantCollection: null,
	            locations: null,
	            onSale: false,
	            appChannel: null,
	            filterLocation: null, //'hillsidevictoria'
	            menuItemPriceLayoutSinglePrice: 'stacked',
	            align: 'left',
	            size: 'large', // default | large
	            theme: 'default' // default | dark
	        });
	
	        self.selectedLocationModel = self.options.locations.findWhere({ slug: self.options.filterLocation });
	
	        this.options.locations = new Obscura(this.options.locations);
	
	        this.options.locations.setSort(function (model) {
	            if (model == self.selectedLocationModel) {
	                return -1;
	            } else {
	                return 1;
	            }
	        });
	    },
	    ui: {
	        selectedLocationPricesColumn: '.selected-location-prices-region-column'
	    },
	    regions: {
	        selectedLocationTitleRegion: '.selected-location-title-region',
	        selectedLocationPricesRegion: '.selected-location-prices-region',
	        otherLocationPricesRegion: '.other-location-prices-region'
	    },
	    _renderLocationPrices: function _renderLocationPrices() {
	        var self = this;
	        this._locationPrices = new MenuItemPrices({
	            onlinePurchaseEnabled: true,
	            menuItemModel: this.options.menuItemModel,
	            collection: this.options.variantCollection,
	            locations: this.options.locations,
	            onSale: this.options.menuItemModel.isOnSale(),
	            appChannel: this.options.appChannel,
	            hideOutOfStockVariation: false,
	            filterLocation: this.options.appChannel.request('get:filter:location'),
	            menuItemPriceLayoutSinglePrice: this.options.menuItemPriceLayoutSinglePrice,
	            align: this.options.align,
	            size: this.options.size,
	            theme: this.options.theme,
	            variantShowInStockIfAtAnyLocation: false
	        });
	        this.selectedLocationPricesRegion.show(this._locationPrices);
	    },
	    _renderOtherLocationPrices: function _renderOtherLocationPrices() {
	        this._otherLocationPrices = new OtherPricesCollectionView({
	            menuItemModel: this.options.menuItemModel,
	            collection: this.options.locations,
	            selectedLocationModel: this.selectedLocationModel,
	            variantCollection: this.options.variantCollection,
	            filterLocation: this.options.filterLocation,
	            appChannel: this.options.appChannel,
	            menuItemPriceLayoutSinglePrice: this.options.menuItemPriceLayoutSinglePrice,
	            align: this.options.align,
	            size: this.options.size,
	            theme: this.options.theme
	        });
	        this.otherLocationPricesRegion.show(this._otherLocationPrices);
	    },
	    _renderSelectedLocationPriceTable: function _renderSelectedLocationPriceTable() {
	        var self = this;
	        this._renderLocationPrices();
	        this._renderOtherLocationPrices();
	    },
	    onRender: function onRender() {
	        this._renderSelectedLocationPriceTable();
	        // need to listen to global app change of filterLocation....
	    }
	});
	module.exports = MenuItemPricesLocationTable;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15), __webpack_require__(1)))

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Backbone, $) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	var Swiper = __webpack_require__(1054);
	__webpack_require__(1053);
	__webpack_require__(815);
	
	var PhotoSwiper = BaseViews.LayoutView.extend({
	  className: 'fmcy-photo-swiper',
	  template: __webpack_require__(864),
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      theme: 'light',
	      collection: null
	    });
	
	    var SlideCollection = Backbone.Collection.extend({
	      comparator: function comparator(a) {
	        if (a.get('is_primary') === '1') {
	          return -1;
	        } else {
	          return 1;
	        }
	      }
	    });
	
	    this.slides = new SlideCollection(this.options.collection.toJSON());
	    this.slides.each(function (model) {
	      if (model.get('is_primary') === '1') {
	        self._currentSlideModel = model;
	      }
	    });
	  },
	  ui: {
	    swiperContainer: '.swiper-container',
	    swiperPagination: '.swiper-pagination',
	    swiperPrev: '.swiper-button-prev',
	    swiperNext: '.swiper-button-next'
	  },
	  getCurrentSlideModel: function getCurrentSlideModel() {
	    return this._currentSlideModel;
	  },
	  onRender: function onRender() {
	    var self = this;
	    $(document).ready(function () {
	      self.swiper = new Swiper(self.ui.swiperContainer, {
	        direction: 'horizontal',
	        loop: true,
	        pagination: {
	          el: self.ui.swiperPagination,
	          clickable: true
	        }
	      });
	      self.swiper.on('click', function (swiper, event) {
	        self.swiper.slideNext();
	      });
	
	      self.swiper.on('slideChange', function (swiper, event) {
	        self._currentSlideModel = self.slides.at(self.swiper.realIndex);
	        self.trigger('photo:swiper:slide:change', self._currentSlideModel);
	      });
	
	      function returnElement(model) {
	        var url = model.get('medium_url');
	        return '<div class="swiper-slide" id="' + model.get('id') + '"><div class="fmcy-menu-item-row fmcy-menu-item-thumb-image" style="background-image: url(' + url + ')"></div></div>';
	      }
	      var index = 0;
	      self.slides.each(function (model) {
	        self.swiper.addSlide(index, returnElement(model));
	        index += 1;
	      });
	    });
	
	    BaseViews.LayoutView.prototype.onRender.call(self);
	  }
	});
	
	module.exports = PhotoSwiper;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(11)))

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var BaseViews = __webpack_require__(5);
	__webpack_require__(816);
	var ProductZoomToggle = BaseViews.LayoutView.extend({
	    template: __webpack_require__(865),
	    className: 'fmcy-product-zoom-toggle fmcy-product-zoom-toggle',
	    events: {
	        click: 'onToggle'
	    },
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = options;
	        // Opposites because its a toggle.
	        this.enabledText = 'Disable Drag';
	        this.disabledText = 'Enable Drag';
	
	        this.setToggleText();
	        this.model.on('change:zoomEnabled', function () {
	            self.setToggleText();
	        });
	    },
	    setToggleText: function setToggleText() {
	        if (this.model.get('zoomEnabled') === true) {
	            this.model.set('zoomToggleText', this.enabledText);
	        } else {
	            this.model.set('zoomToggleText', this.disabledText);
	        }
	        this.render();
	    },
	    onToggle: function onToggle() {
	        if (this.model.get('zoomEnabled') === true) {
	            this.model.set('zoomEnabled', false);
	        } else {
	            this.model.set('zoomEnabled', true);
	        }
	        this.setToggleText();
	    }
	});
	module.exports = ProductZoomToggle;

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	__webpack_require__(817);
	var ProductZoomer = BaseViews.LayoutView.extend({
	    _leafletMap: null,
	    className: 'fmcy-product-zoomer fmcy-product-zoomer',
	    template: __webpack_require__(866),
	    ui: {
	        leafletMapTarget: '.fmcy-leaflet-map-target'
	    },
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            theme: 'light'
	        });
	        this.model.on('change:zoomEnabled', function () {
	            self.toggleMapControls();
	        });
	
	        this.model.on('change:imageSize', function () {
	            self.toggleImageSize();
	        });
	    },
	    toggleImageSize: function toggleImageSize() {
	        var imageSize = this.model.get('imageSize');
	        var imageObj = this.options.getImageBySize(imageSize);
	
	        // kind of a magic number...
	        var zoomBuffer = 2;
	        switch (imageSize) {
	            case 'xlarge':
	                zoomBuffer = 3;
	                break;
	            case 'large':
	                zoomBuffer = 3;
	                break;
	            default:
	                zoomBuffer = 2;
	                break;
	        }
	
	        // dimensions of the image
	
	        var w = imageObj.w * zoomBuffer,
	            h = imageObj.h * zoomBuffer,
	            url = imageObj.url;
	
	        // calculate the edges of the image, in coordinate space
	        var southWest = this._leafletMap.unproject([0, h], this._leafletMap.getMaxZoom() + 1);
	        var northEast = this._leafletMap.unproject([w, 0], this._leafletMap.getMaxZoom() + 1);
	
	        var bounds = new L.LatLngBounds(southWest, northEast);
	
	        if (this.imageOverlay) {
	            this.imageOverlay.removeFrom(this._leafletMap);
	        }
	
	        // add the image overlay,
	        this.imageOverlay = L.imageOverlay(url, bounds).addTo(this._leafletMap);
	
	        // so that it covers the entire map
	        this._leafletMap.fitBounds(bounds);
	
	        switch (imageSize) {
	            case 'xlarge':
	                this._leafletMap.options.minZoom = 5;
	                this._leafletMap.options.maxZoom = 9;
	                this._leafletMap.setZoom(7);
	                break;
	            case 'large':
	                this._leafletMap.options.minZoom = 5;
	                this._leafletMap.options.maxZoom = 10;
	                this._leafletMap.setZoom(7);
	                break;
	            default:
	                this._leafletMap.options.minZoom = 5;
	                this._leafletMap.options.maxZoom = 10;
	                this._leafletMap.setZoom(7);
	                break;
	        }
	    },
	    toggleMapControls: function toggleMapControls() {
	        if (this.model.get('zoomEnabled')) {
	            this._leafletMap.dragging.enable();
	            if (this._leafletMap.tap) {
	                this._leafletMap.tap.enable();
	            }
	            this._leafletMap.touchZoom.enable();
	            this._leafletMap.doubleClickZoom.enable();
	        } else {
	            this._leafletMap.dragging.disable();
	            this._leafletMap.touchZoom.disable();
	            this._leafletMap.doubleClickZoom.disable();
	            this._leafletMap.scrollWheelZoom.disable();
	            if (this._leafletMap.tap) {
	                this._leafletMap.tap.disable();
	            }
	        }
	    },
	    onShow: function onShow() {
	        var self = this;
	        if (this.options.theme === 'dark') {
	            this.$el.addClass('fmcy-product-zoomer-theme-dark');
	        }
	        this._leafletMap = L.map(this.ui.leafletMapTarget[0], {
	            zoomControl: true,
	            scrollWheelZoom: true,
	            minZoom: 7,
	            maxZoom: 9,
	            center: [0, 0],
	            zoom: 7,
	            tap: false,
	            crs: L.CRS.Simple
	        });
	
	        this.toggleImageSize();
	        this.toggleMapControls();
	
	        if (this._leafletMap) {
	            this._leafletMap._onResize();
	        }
	
	        this._onWindowResize();
	
	        $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
	    },
	    _onWindowResize: function _onWindowResize(event) {
	
	        this.ui.leafletMapTarget.height($(window).height());
	        this.ui.leafletMapTarget.width($(window).width());
	
	        if (this._leafletMap) {
	            this._leafletMap._onResize();
	        }
	    },
	    onDestroy: function onDestroy() {
	        $(window).off('resize.' + this.cid);
	    }
	});
	
	module.exports = ProductZoomer;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette, _, Backbone) {'use strict';
	
	__webpack_require__(818);
	var ThumbnailItem = __webpack_require__(494);
	var ThumbnailSelector = Marionette.CollectionView.extend({
	    className: 'fmcy-thumbnail-selector row-flex clearfix',
	    childView: ThumbnailItem,
	    childEvents: {
	        'thumb:clicked': 'onChildThumbClicked'
	    },
	    onChildThumbClicked: function onChildThumbClicked(childView) {
	        this.trigger('thumb:clicked', childView.model, this.options.collection);
	        this.resetItemsSelected();
	        childView.setActive();
	    },
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            thumbStyle: 'thumbs',
	            theme: 'light', // light, dark
	            alignment: 'vertical'
	        });
	
	        var SlideCollection = Backbone.Collection.extend({
	            comparator: function comparator(a) {
	                if (a.get('is_primary') === '1') {
	                    return -1;
	                } else {
	                    return 1;
	                }
	            }
	        });
	
	        this.collection = new SlideCollection(this.collection.toJSON());
	    },
	    resetItemsSelected: function resetItemsSelected() {
	        var self = this;
	        this.collection.each(function (model) {
	            var view = self.children.findByModel(model);
	            if (view) {
	                view.reset();
	            }
	        });
	    },
	    childViewOptions: function childViewOptions(model, index) {
	        var extraClassName = 'col-flex-xs-12';
	        if (model.get('is_primary') === '1') {
	            extraClassName += ' thumbnail-item-selected';
	        }
	        return {
	            collection: this.options.collection,
	            extraClassName: extraClassName
	        };
	    },
	    onRender: function onRender() {
	        this.$el.addClass(this.options.thumbStyle);
	    }
	});
	module.exports = ThumbnailSelector;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15), __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette, _, $) {'use strict';
	
	__webpack_require__(819);
	var BaseViews = __webpack_require__(5);
	var NoMenuItems = BaseViews.ItemView.extend({
	    className: 'fmcy-menu-items-no-menu-items',
	    collectionEvents: {
	        'fetch:start': 'render',
	        'fetch:end': 'render'
	    },
	    template: function template() {
	        return 'No products match your search criteria. Please review search filters.';
	    },
	    onRender: function onRender() {
	        if (this.options.isFetching()) {
	            this.$el.hide();
	        } else {
	            this.$el.show();
	        }
	    }
	});
	
	var MenuItemThumb = __webpack_require__(132);
	
	var MenuItems = Marionette.CollectionView.extend({
	    className: 'fmcy-menu-items row-flex clearfix',
	    emptyView: NoMenuItems,
	    childView: MenuItemThumb,
	    childEvents: {
	        'thumb:clicked': 'onChildThumbClicked'
	    },
	    onChildThumbClicked: function onChildThumbClicked(childView) {
	        this.trigger('thumb:clicked', childView.model);
	    },
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            showProductLocations: false,
	            showOnlineProductLocations: false,
	            _menuState: null,
	            shouldEnableOnlinePurhaseCallback: function shouldEnableOnlinePurhaseCallback(menuItem) {
	                return false;
	            }
	        });
	    },
	    emptyViewOptions: function emptyViewOptions(model, index) {
	        return {
	            collection: this.options.collection,
	            isFetching: this.options.isFetching
	        };
	    },
	    childViewOptions: function childViewOptions(model, index) {
	        return {
	            locations: this.options.locations,
	            thumbStyle: this.options.thumbStyle,
	            collection: this.options.collection,
	            _menuState: this.options._menuState,
	            isFetching: this.options.isFetching,
	            extraClassName: this.options.thumbStyle === 'full' ? 'col-flex-xs-12' : 'col-flex-xs-12 col-flex-sm-6 col-flex-md-4 col-flex-xl-3',
	            appChannel: this.options.appChannel,
	            displayImageURL: this.options.getItemDisplayImageURL(model),
	            onlinePurchaseEnabled: this.options.shouldEnableOnlinePurhaseCallback(model),
	            showProductLocations: _.result(this.options, 'showProductLocations'),
	            locationSwitchingEnabled: this.options.locationSwitchingEnabled,
	            showOnlineProductLocations: this.options.showOnlineProductLocations,
	            bannerPriority: _.result(this.options, 'bannerPriority'),
	            menuItemPriceLayoutSinglePrice: 'promotion'
	        };
	    },
	    _onWindowResize: function _onWindowResize(event) {
	        if ($(window).height() < 1920) {
	            this.$el.css('min-height', $(window).height() - 200);
	        }
	    },
	    onRender: function onRender() {
	        var self = this;
	
	        this.$el.addClass(this.options.thumbStyle);
	        this._onWindowResize();
	        $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
	        BaseViews.LayoutView.prototype.onRender.call(self);
	    },
	    onDestroy: function onDestroy() {
	        $(window).off('resize.' + this.cid);
	        BaseViews.LayoutView.prototype.onDestroy.call(self);
	    }
	});
	module.exports = MenuItems;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15), __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var BaseSlider = __webpack_require__(201);
	var MenuItemThumb = __webpack_require__(132);
	var MenuSlider = BaseSlider.extend({
	    initialize: function initialize(options) {
	        var self = this;
	        self.options = _.defaults(options || {}, {
	            shouldEnableOnlinePurhaseCallback: function shouldEnableOnlinePurhaseCallback(menuItem) {
	                return false;
	            },
	            menuItemThumbOptions: {}
	        });
	        BaseSlider.prototype.initialize.call(this, self.options);
	    },
	    createSlide: function createSlide(item, displayImageURL) {
	        var $deferred = $.Deferred();
	        var self = this;
	        $deferred.resolve(new MenuItemThumb(_.extend({
	            model: item,
	            displayImageURL: displayImageURL,
	            thumbStyle: 'full',
	            animationStyleShow: 'long',
	            imagePreloading: false,
	            appChannel: self.options.appChannel,
	            onlinePurchaseEnabled: self.options.shouldEnableOnlinePurhaseCallback(item),
	            showPricesPinned: false,
	            showPricesLast: true,
	            showTitleOverProductImage: true,
	            showMedicalAttrs: false,
	            showStrainIcon: false,
	            showStrainInEffectsRow: true,
	            menuItemPriceLayout: 'inline',
	            menuItemPriceLayoutSinglePrice: 'inline',
	            menuItemPricesTheme: 'dark'
	        }, self.options.menuItemThumbOptions)));
	        return $deferred.promise();
	    }
	});
	module.exports = MenuSlider;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 711 */,
/* 712 */,
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Backbone, $) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	var SearchFilters = __webpack_require__(496);
	var SearchOptions = __webpack_require__(497);
	var VendorSelectSelected = __webpack_require__(466);
	var MenuProductEntities = __webpack_require__(61);
	var ProductVendorEntities = __webpack_require__(42);
	var DropdownList = __webpack_require__(43);
	
	__webpack_require__(820);
	var Subfilters = BaseViews.LayoutView.extend({
	    _menuState: null,
	    _menuItemCategories: null,
	    _subCategoryFilter: null,
	    _initialVendorSet: true,
	    template: __webpack_require__(868),
	    className: 'fmcy-search',
	    ui: {
	        searchInput: '.fmcy-search-key',
	        searchButton: '.fmcy-search-button',
	        clearButton: '.fmcy-search-clear-filters-btn',
	        categoryMenuItem: '.fmcy-category-menu-item'
	    },
	    regions: {
	        subCategoryFilterRegion: '.fmcy-sub-category-filter-region',
	        sortDdlRegion: '.fmcy-sort-ddl-region',
	        vendorDdlRegion: '.fmcy-vendor-ddl-region',
	        locationsDdlRegion: '.fmcy-locations-ddl-region'
	    },
	    events: function events() {
	
	        var self = this;
	        function createToggleFunction(attr) {
	            return function () {
	                self.model.set(attr, !self.model.get(attr));
	                var data = {};
	                data[attr] = self.model.get(attr);
	
	                if (attr === 'filterSaleItems') {
	                    self.model.set('filterClearanceItems', self.model.get('filterSaleItems'));
	                    data['filterClearanceItems'] = self.model.get('filterClearanceItems');
	                }
	
	                self.options.appChannel.trigger('search:options:changed', data);
	            };
	        }
	
	        var events = {
	            'click .fmcy-search-sale-toggle-btn': createToggleFunction('filterSaleItems'),
	            'click .fmcy-search-new-toggle-btn': createToggleFunction('filterNewItems'),
	            'click .fmcy-search-clearance-toggle-btn': createToggleFunction('filterClearanceItems'),
	            'click @ui.clearButton': 'clearFilters'
	        };
	
	        return events;
	    },
	    bindings: function bindings() {
	
	        function toggle($el, val) {
	            $el.attr('on', val);
	        }
	
	        var bindings = {
	            '.fmcy-search-sale-toggle-btn': {
	                observe: 'filterSaleItems',
	                update: toggle
	            },
	            '.fmcy-search-new-toggle-btn': {
	                observe: 'filterNewItems',
	                update: toggle
	            }
	        };
	
	        if (this.options.showClearanceItemsFilter) {
	            bindings = _.extend(bindings, {
	                '.fmcy-search-clearance-toggle-btn': {
	                    observe: 'filterClearanceItems',
	                    update: toggle
	                }
	            });
	        }
	
	        return bindings;
	    },
	    initialize: function initialize(options) {
	        var self = this;
	        self.options = _.defaults(options || {}, {
	            filterBoxEnabled: false,
	            showClearanceItemsFilter: false,
	            showLocationsFilter: false
	        });
	        self._state = new Backbone.Model({
	            filterBoxEnabled: self.options.filterBoxEnabled,
	            showingSubCategories: false
	        });
	
	        self._menuState = self.model;
	        self._menuItemCategories = self._menuState.get('menuItemCategories');
	
	        self._bindModelAttrToDomAttribute(self._state, 'filterBoxEnabled', 'filter-box-enabled');
	
	        self._bindModelAttrToDomAttribute(self._state, 'showingSubCategories', 'showing-sub-categories');
	    },
	    keyAction: function keyAction(event) {
	        var code = event.keyCode || event.which;
	
	        // enter key
	        if (code == 13) {
	            this.doSearch(null);
	        }
	
	        // backspace key
	        if (code == 8) {
	            if (this.ui.searchInput.val().length <= 1) {
	                this.doSearch(null);
	            }
	        }
	    },
	    clearFilters: function clearFilters() {
	
	        this._menuState.set('filterSaleItems', false);
	        this._menuState.set('filterClearanceItems', false);
	        this._menuState.set('filterNewItems', false);
	        this._menuState.set('filterVendor', null);
	        this._menuState.set('filterCategory', 'all');
	        this._menuState.set('filterSubCategory', null);
	
	        this.options.appChannel.trigger('search:options:changed', {
	            filterSaleItems: false,
	            filterClearanceItems: false,
	            filterVendor: null,
	            searchTerm: null,
	            filterNewItems: false,
	            filterSort: 'alpha_asc'
	        });
	    },
	    doSearch: function doSearch(event) {
	        var self = this;
	        //self._menuState.set('preSearch', true);
	
	        self.options.appChannel.trigger('search:options:changed', {
	            searchTerm: self.ui.searchInput.val()
	        });
	    },
	    hideSubFilterMenu: function hideSubFilterMenu() {
	        this._state.set('showingSubCategories', false);
	        this.subCategoryFilterRegion.empty();
	    },
	    displaySubFilterMenu: function displaySubFilterMenu(options) {
	        var self = this;
	
	        options.collection = new Backbone.Collection(options.collection.toJSON());
	
	        options.collection.unshift({
	            name: 'All',
	            slug: 'all',
	            parent_id: options.category.id,
	            id: 'all'
	        });
	        this._subCategoryFilter = new SearchFilters({
	            collection: options.collection,
	            initialFilter: options.initialFilter || 'all',
	            style: 'sub-filters',
	            caption: options.category.get('name') + ' Menu'
	        });
	
	        this._subCategoryFilter.on('filter:clicked', function (subCategory) {
	
	            var parentSlug = self._menuItemCategories.findWhere({ id: subCategory.get('parent_id') }).get('slug');
	
	            if (self._menuState.get('slug') === subCategory.get('slug')) {
	                return;
	            }
	            if (subCategory.get('slug') === 'all' && parentSlug === self._menuState.get('slug')) {
	                return;
	            }
	            //self._menuState.set('preSearch', true);
	            self.options.appChannel.request('load:category', parentSlug, subCategory.get('slug'));
	        });
	
	        this.showChildView('subCategoryFilterRegion', this._subCategoryFilter);
	        this._state.set('showingSubCategories', true);
	    },
	    _renderCategoryFilters: function _renderCategoryFilters() {
	        var self = this;
	        var Obscura = __webpack_require__(103);
	        var categoriesCollection = new Obscura(this._menuItemCategories);
	
	        function setupFilterSubMenu(category, hideThumbs) {
	
	            if (hideThumbs) {
	                //self._menuState.set('preSearch', true);
	            }
	
	            if (self._menuState.get('filterCategory') != category.get('slug')) {
	                self._menuState.set('filterCategory', category.get('slug'));
	                self._menuState.set('filterSubCategory', 'all');
	            }
	
	            var searchFilterSubCategories = new Obscura(self._menuItemCategories);
	            searchFilterSubCategories.filterBy('subLevel', function (model) {
	                return model.get('parent_id') === category.get('id');
	            }).setSort('ordinal', 'asc');
	
	            if (searchFilterSubCategories.length) {
	                self.displaySubFilterMenu({
	                    category: category,
	                    collection: searchFilterSubCategories,
	                    initialFilter: self._menuState.get('filterSubCategory')
	                });
	            } else {
	                self.hideSubFilterMenu();
	            }
	        }
	
	        var selectedModel = this._menuItemCategories.findWhere({
	            slug: this._menuState.get('filterCategory')
	        });
	        if (selectedModel) {
	            setupFilterSubMenu(selectedModel);
	        }
	
	        // TODO: dedupe / cleanup
	        this._menuState.on('change:filterCategory', function () {
	            if (!self.isRendered) {
	                return false;
	            }
	            var selectedModel = self._menuItemCategories.findWhere({
	                slug: self._menuState.get('filterCategory')
	            });
	            if (selectedModel) {
	                setupFilterSubMenu(selectedModel);
	            }
	        });
	
	        this._menuState.on('change:filterSubCategory', function () {
	            var selectedModel = self._menuItemCategories.findWhere({
	                slug: self._menuState.get('filterSubCategory')
	            });
	            if (selectedModel) {
	                if (self._subCategoryFilter) {
	                    self._subCategoryFilter.setFilterActive(selectedModel);
	                }
	            }
	        });
	    },
	    _maybeRenderLocationsDropdownList: function _maybeRenderLocationsDropdownList() {
	        var self = this;
	
	        if (!self.options.showLocationsFilter) {
	            return;
	        }
	
	        self.locationsDdlRegion.show(new DropdownList({
	            customClassName: 'fmcy-sort-options',
	            dropdownCssClass: 'fmcy-sort-options-dropdown',
	            collection: self.options.appChannel.request('get:locations').toJSON(),
	            model: self._menuState,
	            modelAttr: 'filterLocation',
	            displayAttr: 'name',
	            valueAttr: 'slug',
	            suppressSearch: true,
	            onSelectedCallback: function onSelectedCallback(val) {
	                //self._menuState.set('preSearch', true);
	                self.options.appChannel.trigger('search:options:changed', {
	                    location: val
	                });
	            }
	        }));
	    },
	    _renderSortDropdownList: function _renderSortDropdownList() {
	        var self = this;
	        var sortOptionsCollection = new Backbone.Collection([{
	            id: 'alpha_asc',
	            label: 'Sort By Name Ascending'
	        }, {
	            id: 'alpha_desc',
	            label: 'Sort By Name Descending'
	        }, {
	            id: 'price_low_high',
	            label: 'Sort By Price Lowest to Highest'
	        }, {
	            id: 'price_high_low',
	            label: 'Sort By Price Highest to Lowest'
	        }]);
	
	        self.sortDdlRegion.show(new DropdownList({
	            customClassName: 'fmcy-sort-options',
	            dropdownCssClass: 'fmcy-sort-options-dropdown',
	            collection: sortOptionsCollection.toJSON(),
	            displayAttr: 'label',
	            valueAttr: 'id',
	            suppressSearch: true,
	            //placeholder: 'SEE MORE FILTERS',
	            onSelectedCallback: function onSelectedCallback(val) {
	                //self._menuState.set('preSearch', true);
	                self.options.appChannel.trigger('search:options:changed', {
	                    sort: val
	                });
	            }
	        }));
	    },
	    _renderVendorSelectSelected: function _renderVendorSelectSelected() {
	        this.vendorSelectSelected = new VendorSelectSelected({
	            appChannel: this.options.appChannel,
	            _menuState: this._menuState
	        });
	        this.vendorDdlRegion.show(this.vendorSelectSelected);
	    },
	    _renderVendorDropdownList: function _renderVendorDropdownList() {
	        var self = this;
	        var vendorCollection = new ProductVendorEntities.PageableProductVendorsCollection(self.options.appChannel.request('get:vendors').toJSON(), {
	            queryParams: {
	                filterHideOnMenuFilter: true,
	                filterOutOfStock: true
	            }
	        });
	
	        if (isNaN(self._menuState.get('filterVendor'))) {
	            self._initialVendorSet = false;
	        }
	
	        self.vendorDropdownList = new (__webpack_require__(33))({
	            collection: vendorCollection,
	            customClassName: 'fmcy-search fmcy-sort-options',
	            dropdownCssClass: 'fmcy-brands-select-dropdown',
	            model: self._menuState,
	            modelValueAttr: 'filterVendor',
	            suppressSearch: false,
	            width: '100%',
	            dropdownParent: this.$el,
	            inputFocused: false,
	            provideSingleListItemById: function provideSingleListItemById(id) {
	                var $deferred = $.Deferred();
	                var vendorModel = new ProductVendorEntities.ProductVendorModel({ id: id });
	                vendorModel.fetch().then(function () {
	                    $deferred.resolve(vendorModel);
	                }).fail(function () {
	                    $deferred.reject();
	                });
	                return $deferred;
	            },
	            displayAttr: 'name',
	            iconURLAttr: 'image_thumb_url_light_theme',
	            valueAttr: 'id',
	            allowClear: true,
	            placeholder: 'Select Brand',
	            onSelectedCallback: function onSelectedCallback(vendorId, model) {
	                if (!self._initialVendorSet) {
	                    //self._menuState.set('preSearch', true);
	                    self.options.appChannel.trigger('search:options:changed', {
	                        filterVendor: vendorId
	                    });
	                }
	                self._initialVendorSet = false;
	            }
	        });
	        self.vendorDdlRegion.show(self.vendorDropdownList);
	    },
	    onBeforeShow: function onBeforeShow() {
	        this._renderCategoryFilters();
	    },
	    onRender: function onRender() {
	        var self = this;
	        this._renderSortDropdownList();
	        this._renderVendorSelectSelected();
	        this._maybeRenderLocationsDropdownList();
	        BaseViews.LayoutView.prototype.onRender.call(this);
	    },
	    serializeData: function serializeData() {
	        return {
	            options: this.options
	        };
	    }
	});
	
	module.exports = Subfilters;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(11)))

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	var OrderItems = __webpack_require__(498);
	
	var ActiveOrders = BaseViews.LayoutView.extend({
	    className: 'fmcy-active-orders',
	    template: __webpack_require__(869),
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            theme: 'dark',
	            collection: null,
	            _appChannel: null
	        });
	    },
	    regions: {
	        ordersRegion: '.fmcy-orders-region'
	    },
	    _renderOrders: function _renderOrders() {
	        var self = this;
	        this._orderItems = new OrderItems({
	            collection: this.options.collection,
	            _appChannel: this.options._appChannel
	        });
	        this.ordersRegion.show(this._orderItems);
	    },
	    onRender: function onRender() {
	        this._renderOrders();
	        BaseViews.LayoutView.prototype.onRender.call(self);
	    }
	});
	
	module.exports = ActiveOrders;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(821);
	var BaseViews = __webpack_require__(5);
	var PageNotFoundView = BaseViews.LayoutView.extend({
	    className: 'fmcy-page-not-found',
	    template: __webpack_require__(870)
	});
	module.exports = PageNotFoundView;

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	__webpack_require__(822);
	var VideoItems = __webpack_require__(499);
	var VideoGroup = BaseViews.LayoutView.extend({
	    template: __webpack_require__(871),
	    className: 'fmcy-video-group container-fluid',
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            videos: null,
	            videoGroupTitle: 'Videos',
	            appChannel: null
	        });
	        this._videos = this.options.videos;
	    },
	    regions: {
	        videosRegion: '.fmcy-videos-region'
	    },
	    serializeData: function serializeData() {
	        return {
	            videoGroupTitle: this.options.videoGroupTitle
	        };
	    },
	    _renderVideos: function _renderVideos() {
	        var self = this;
	        this._videoItems = new VideoItems({
	            collection: this._videos
	        });
	        this._videoItems.on('thumb:clicked', function (model, collection) {
	            if (self.options.appChannel !== null) {
	                self.options.appChannel.request('load:enlarged:video', model, collection);
	            }
	        });
	        this.videosRegion.show(this._videoItems);
	    },
	    onRender: function onRender() {
	        this._renderVideos();
	    }
	});
	
	module.exports = VideoGroup;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette, _, Backbone, $) {'use strict';
	
	var NotificationsManager = Marionette.Object.extend({
	    _requestPermissionPromise: null,
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            defaultIconUrl: ''
	        });
	
	        Backbone.Radio.channel('global').reply('show:notification', this.showNotificaton.bind(this));
	
	        Backbone.Radio.channel('global').reply('request:notifications:permission', this.requestPermission.bind(this));
	    },
	    requestPermission: function requestPermission() {
	        var self = this;
	        if (self._requestPermissionPromise) {
	            return self._requestPermissionPromise.promise();
	        } else {
	            self._requestPermissionPromise = $.Deferred();
	        }
	
	        // Check if the browser supports notifications
	        if (!('Notification' in window)) {
	            self._requestPermissionPromise.resolve(false);
	        } else if (Notification.permission === 'granted') {
	            // Check whether notification permissions have already been granted
	            // If okay create a notification
	            self._requestPermissionPromise.resolve(true);
	        } else if (Notification.permission !== 'denied') {
	            // Otherwise, ask the user for permission
	            Notification.requestPermission(function (permission) {
	                self._requestPermissionPromise.resolve(permission === 'granted');
	            });
	        } else {
	            self._requestPermissionPromise.resolve(false);
	        }
	        return self._requestPermissionPromise.promise();
	    },
	    showNotificaton: function showNotificaton(title, options) {
	        var options = _.defaults(options || {}, {
	            body: '',
	            icon: this.options.defaultIconUrl,
	            closeAfterMs: 5000,
	            onClickedCallback: null
	        });
	
	        function launchNotification() {
	            var n = new Notification(title, _.pick(options, 'body', 'icon'));
	            n.onclick = function (event) {
	                event.preventDefault();
	                window.focus();
	                event.currentTarget.close();
	                if (options.onClickedCallback) {
	                    options.onClickedCallback();
	                }
	            };
	            setTimeout(n.close.bind(n), options.closeAfterMs);
	        }
	
	        this.requestPermission().then(function (granted) {
	            if (granted) {
	                launchNotification();
	            }
	        });
	    }
	});
	
	module.exports = NotificationsManager;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15), __webpack_require__(1), __webpack_require__(4), __webpack_require__(11)))

/***/ },
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var URLSearchParams = __webpack_require__(1097);
	module.exports = {
	    getQueryStringValue: function getQueryStringValue(key, url) {
	        return new URLSearchParams(url || window.location.search).get(key);
	    }
	};

/***/ },
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-cart-empty {\n  font-family: \"bebasneue\", \"Arial\", sans-serif;\n  position: relative;\n  max-width: 1100px;\n  margin: auto;\n  z-index: 100;\n  pointer-events: none;\n  font-size: 14px; }\n  .fmcy-cart-empty .fmcy-cart-empty-icon {\n    background-image: url(" + escape(__webpack_require__(779)) + ");\n    width: 199px;\n    height: 313px;\n    background-size: contain;\n    background-repeat: no-repeat;\n    margin: auto;\n    margin-top: 30px; }\n    @media only screen and (max-width: 500px) {\n      .fmcy-cart-empty .fmcy-cart-empty-icon {\n        width: 100px;\n        height: 157px; } }\n  .fmcy-cart-empty .fmcy-cart-empty-left-column {\n    border-right: #cccc solid 1px;\n    background-color: #e6e6e6; }\n    @media only screen and (max-width: 991px) {\n      .fmcy-cart-empty .fmcy-cart-empty-left-column {\n        display: none; } }\n  .fmcy-cart-empty .fmcy-cart-empty-title {\n    height: 54px;\n    color: #ffff;\n    background-color: #2e302f;\n    line-height: 57px;\n    padding-left: 10px;\n    font-size: 150%; }\n  .fmcy-cart-empty .fmcy-cart-empty-left-column {\n    opacity: 0; }\n  .fmcy-cart-empty .fmcy-cart-empty-right-column {\n    background-color: #2e302f;\n    padding-bottom: 110px;\n    position: relative;\n    pointer-events: auto; }\n", ""]);
	
	// exports


/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-cart-loading {\n  z-index: 100;\n  position: fixed;\n  margin-left: -52px;\n  width: 104px;\n  left: 50%;\n  top: 200px; }\n  .fmcy-cart-loading .tl-spinner-inner-4 {\n    background-color: #000 !important; }\n    .fmcy-cart-loading .tl-spinner-inner-4 .tl-message {\n      color: #333333; }\n", ""]);
	
	// exports


/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-cart-payment-challenge {\n  width: 100%;\n  background-color: #202020;\n  overflow-y: hidden;\n  position: relative; }\n  .fmcy-cart-payment-challenge .fmcy-form-challenge {\n    overflow-y: hidden;\n    position: absolute;\n    z-index: 2; }\n  .fmcy-cart-payment-challenge .spinner-region {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin-left: -70px;\n    margin-top: -65px;\n    z-index: 1; }\n    .fmcy-cart-payment-challenge .spinner-region .tl-spinner[showing-message=\"true\"] .tl-spinner-inner-4 {\n      background-color: none !important; }\n", ""]);
	
	// exports


/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-cart-payment {\n  font-family: \"bebasneue\", \"Arial\", sans-serif;\n  position: relative;\n  max-width: 1100px;\n  margin: auto;\n  z-index: 100;\n  pointer-events: none;\n  font-size: 14px; }\n  .fmcy-cart-payment .form-control {\n    font-family: 'droid_serif', sans-serif !important; }\n  .fmcy-cart-payment .help-block {\n    background-color: #f2dede;\n    display: table !important;\n    line-height: 20px;\n    border-radius: 5px;\n    min-width: 150px;\n    padding: 2px;\n    margin-bottom: 5px;\n    margin-top: 5px;\n    text-align: center;\n    float: right; }\n  .fmcy-cart-payment .alert {\n    font-size: 150%;\n    text-align: center; }\n  .fmcy-cart-payment .fmcy-cart-payment-left-column {\n    border-right: #cccc solid 1px;\n    background-color: #e6e6e6; }\n    @media only screen and (max-width: 991px) {\n      .fmcy-cart-payment .fmcy-cart-payment-left-column {\n        display: none; } }\n  .fmcy-cart-payment .fmcy-cart-payment-title {\n    height: 54px;\n    color: #ffff;\n    background-color: #2e302f;\n    line-height: 57px;\n    padding-left: 10px;\n    font-size: 150%; }\n  .fmcy-cart-payment .fmcy-cart-payment-credit-cards {\n    height: 54px;\n    text-align: left;\n    padding-left: 10px;\n    padding-top: 15px;\n    background-color: #1f1e1e;\n    border-bottom: 1px #000 solid; }\n    .fmcy-cart-payment .fmcy-cart-payment-credit-cards .visa-xs {\n      margin-left: 10px;\n      margin-right: 10px; }\n  .fmcy-cart-payment .fmcy-cart-payment-interac {\n    height: 64px;\n    text-align: left;\n    padding-left: 10px;\n    padding-top: 8px;\n    background-color: #1f1e1e;\n    border-bottom: 1px #000 solid; }\n    .fmcy-cart-payment .fmcy-cart-payment-interac .interac-icon {\n      background-image: url(" + escape(__webpack_require__(395)) + ");\n      width: 50px;\n      height: 50px;\n      background-size: cover;\n      background-repeat: no-repeat; }\n  .fmcy-cart-payment .fmcy-cart-payment-interac-information-text {\n    font-family: 'droid_serif', sans-serif !important;\n    color: #fff;\n    padding: 10px;\n    font-size: 90%; }\n  .fmcy-cart-payment .fmcy-cart-payment-left-column {\n    opacity: 0; }\n  .fmcy-cart-payment .fmcy-cart-payment-right-column {\n    background-color: #2e302f;\n    padding-bottom: 110px;\n    position: relative;\n    pointer-events: auto; }\n  .fmcy-cart-payment .fmcy-cart-payment-field-label {\n    font-size: 90%;\n    color: #fff;\n    padding-bottom: 5px;\n    margin-bottom: 0px;\n    font-family: 'droid_serif' !important;\n    font-weight: 700; }\n  .fmcy-cart-payment .fmcy-cart-payment-total {\n    border-bottom: 1px #000 solid;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    padding-left: 10px; }\n  .fmcy-cart-payment .fmcy-cart-payment-total-cost {\n    font-size: 180%;\n    color: #fff; }\n  .fmcy-cart-payment .fmcy-cart-payment-pay-form-region {\n    min-height: 100px;\n    border-bottom: 1px #000 solid; }\n  .fmcy-cart-payment .fmcy-credit-card-form {\n    padding: 10px; }\n  .fmcy-cart-payment .fmcy-cart-payment-field-credit-card-icon {\n    top: 35px;\n    right: 6px;\n    z-index: 2;\n    display: block;\n    width: 34px;\n    height: 34px;\n    line-height: 34px;\n    text-align: center;\n    pointer-events: none;\n    position: absolute; }\n  .fmcy-cart-payment .help-block {\n    margin-bottom: 0px !important; }\n", ""]);
	
	// exports


/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-cart-review {\n  font-family: \"bebasneue\", \"Arial\", sans-serif;\n  position: relative;\n  max-width: 1100px;\n  margin: auto;\n  z-index: 100;\n  pointer-events: none; }\n  .fmcy-cart-review .interac-icon {\n    background-image: url(" + escape(__webpack_require__(395)) + ");\n    width: 30px;\n    height: 30px;\n    background-size: contain;\n    background-repeat: no-repeat;\n    float: left;\n    margin-right: 10px; }\n  .fmcy-cart-review .fmcy-cart-review-payment-method-error-message, .fmcy-cart-review .fmcy-cart-review-delivery-default-error-message {\n    display: none;\n    font-family: 'droid_serif' !important;\n    text-align: center;\n    font-size: 90%;\n    min-height: 50px;\n    line-height: 29px;\n    border-bottom: #000 1px solid;\n    background-color: #f2dede;\n    color: #a94442;\n    font-weight: 700;\n    padding: 10px;\n    padding-left: 20px;\n    padding-right: 20px; }\n  .fmcy-cart-review .fmcy-cart-id-disclaimer {\n    font-family: 'droid_serif' !important;\n    text-align: center;\n    background-color: #2e302f;\n    color: #999;\n    font-size: 65%;\n    min-height: 50px;\n    line-height: 20px;\n    padding-top: 12px;\n    padding-bottom: 12px;\n    padding-left: 5px;\n    padding-right: 5px;\n    border-bottom: #000 1px solid; }\n  .fmcy-cart-review .card-icons {\n    padding-top: 5px; }\n  .fmcy-cart-review .visa-xs {\n    margin-left: 10px;\n    margin-right: 10px; }\n  .fmcy-cart-review .fmcy-cart-payment-field-label-interac {\n    line-height: 30px; }\n  .fmcy-cart-review .fmcy-cart-review-left-column {\n    border-right: #cccc solid 1px;\n    background-color: #e6e6e6; }\n    @media only screen and (max-width: 991px) {\n      .fmcy-cart-review .fmcy-cart-review-left-column {\n        display: none; } }\n  .fmcy-cart-review .fmcy-cart-review-title {\n    height: 54px;\n    color: #ffff;\n    /* background-color: #2e302f; */\n    background-color: #1f1e1e;\n    border-bottom: 1px #000 solid;\n    line-height: 57px;\n    padding-left: 10px;\n    font-size: 150%; }\n  .fmcy-cart-review .fmcy-cart-review-left-column {\n    opacity: 0; }\n  .fmcy-cart-review .fmcy-cart-review-right-column {\n    background-color: #2e302f;\n    padding-bottom: 200px;\n    position: relative;\n    pointer-events: auto; }\n  .fmcy-cart-review .fmcy-cart-review-total {\n    line-height: 53px;\n    font-size: 180%;\n    color: #000; }\n  .fmcy-cart-review .fmcy-cart-review-sub-total, .fmcy-cart-review .fmcy-cart-review-delivery-total, .fmcy-cart-review .fmcy-cart-review-tax, .fmcy-cart-review .fmcy-cart-review-tip, .fmcy-cart-review .fmcy-cart-review-deposit {\n    font-size: 150%;\n    text-align: right;\n    line-height: 43px;\n    padding-left: 10px;\n    padding-right: 20px;\n    width: 100%;\n    background-color: #2e302f;\n    color: #ffff;\n    height: 50px;\n    line-height: 50px;\n    border-bottom: #000 1px solid; }\n  .fmcy-cart-review .fmcy-cart-review-tip {\n    position: relative; }\n  .fmcy-cart-review .fmcy-cart-tip-change-btn {\n    font-size: 100%;\n    text-decoration: underline;\n    color: #999;\n    padding-right: 15px;\n    display: inline-block;\n    cursor: pointer; }\n  .fmcy-cart-review .fmcy-cart-review-tip-text {\n    display: inline-block; }\n  .fmcy-cart-review .fmcy-cart-review-message-text-col {\n    text-align: right;\n    padding-right: 20px;\n    padding-left: 20px;\n    padding-top: 7px;\n    padding-bottom: 7px; }\n  .fmcy-cart-review .fmcy-cart-review-message-text {\n    color: #ccc;\n    font-size: 45%;\n    line-height: 20px;\n    font-family: 'droid_serif' !important; }\n  .fmcy-cart-review .fmcy-cart-review-total-cost-col {\n    text-align: right;\n    background-color: #000;\n    color: #fff; }\n    .fmcy-cart-review .fmcy-cart-review-total-cost-col .fmcy-cart-review-total-cost {\n      padding-right: 20px; }\n  .fmcy-cart-review .fmcy-cart-pickup-location-region .fmcy-cart-location-display {\n    padding-left: 10px;\n    padding-bottom: 10px; }\n  .fmcy-cart-review .fmcy-cart-delivery-available-later {\n    font-family: 'droid_serif' !important;\n    background-color: #f2dede;\n    display: none;\n    margin: 10px 0;\n    position: relative;\n    padding: 12px 30px 12px 30px;\n    width: 100%;\n    display: none;\n    text-align: center;\n    color: #a94442;\n    font-size: 90%;\n    font-weight: 700; }\n    .fmcy-cart-review .fmcy-cart-delivery-available-later.delivery-later-message-soften {\n      background-color: #2e302f;\n      color: #fff; }\n  .fmcy-cart-review .fmcy-cart-paynow-paylater-select, .fmcy-cart-review .fmcy-cart-delivery-select {\n    font-family: 'droid_serif' !important;\n    font-size: 90%; }\n    .fmcy-cart-review .fmcy-cart-paynow-paylater-select .input-group, .fmcy-cart-review .fmcy-cart-delivery-select .input-group {\n      background-color: #1f1e1e;\n      display: block;\n      margin: 10px 0;\n      position: relative; }\n      .fmcy-cart-review .fmcy-cart-paynow-paylater-select .input-group label, .fmcy-cart-review .fmcy-cart-delivery-select .input-group label {\n        padding: 12px 78px 12px 30px;\n        width: 100%;\n        display: block;\n        text-align: left;\n        color: #fff;\n        cursor: pointer;\n        position: relative;\n        z-index: 2;\n        transition: color 200ms ease-in;\n        overflow: hidden; }\n        .fmcy-cart-review .fmcy-cart-paynow-paylater-select .input-group label:before, .fmcy-cart-review .fmcy-cart-delivery-select .input-group label:before {\n          border-radius: 0%;\n          content: '';\n          background-color: #4cb8be;\n          position: absolute;\n          left: 0;\n          right: 0;\n          top: 0;\n          bottom: 0;\n          transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);\n          opacity: 0;\n          z-index: -1; }\n        .fmcy-cart-review .fmcy-cart-paynow-paylater-select .input-group label:after, .fmcy-cart-review .fmcy-cart-delivery-select .input-group label:after {\n          width: 32px;\n          height: 32px;\n          content: '';\n          border: 2px solid #000000;\n          background-color: #ffffff;\n          background-image: url(\"data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.414 11L4 12.414l5.414 5.414L20.828 6.414 19.414 5l-10 10z' fill='%23fff' fill-rule='nonzero'/%3E%3C/svg%3E\");\n          background-repeat: no-repeat;\n          background-position: 2px 3px;\n          border-radius: 50%;\n          z-index: 2;\n          position: absolute;\n          right: 30px;\n          top: 50%;\n          transform: translateY(-50%);\n          cursor: pointer;\n          transition: all 200ms ease-in; }\n      .fmcy-cart-review .fmcy-cart-paynow-paylater-select .input-group input:checked ~ label, .fmcy-cart-review .fmcy-cart-delivery-select .input-group input:checked ~ label {\n        color: #fff; }\n        .fmcy-cart-review .fmcy-cart-paynow-paylater-select .input-group input:checked ~ label:before, .fmcy-cart-review .fmcy-cart-delivery-select .input-group input:checked ~ label:before {\n          opacity: 1; }\n        .fmcy-cart-review .fmcy-cart-paynow-paylater-select .input-group input:checked ~ label:after, .fmcy-cart-review .fmcy-cart-delivery-select .input-group input:checked ~ label:after {\n          background-color: #22b1b5;\n          border-color: #22b1b5; }\n      .fmcy-cart-review .fmcy-cart-paynow-paylater-select .input-group input, .fmcy-cart-review .fmcy-cart-delivery-select .input-group input {\n        width: 32px;\n        height: 32px;\n        order: 1;\n        z-index: 2;\n        position: absolute;\n        right: 30px;\n        top: 50%;\n        transform: translateY(-50%);\n        cursor: pointer;\n        visibility: hidden; }\n  .fmcy-cart-review .fmcy-cart-pickup-location-subtext-change-option {\n    color: #ccc;\n    font-size: 10px;\n    line-height: 20px;\n    font-family: 'droid_serif' !important;\n    padding-left: 10px;\n    padding-right: 10px;\n    padding-bottom: 10px; }\n    @media only screen and (min-width: 991px) {\n      .fmcy-cart-review .fmcy-cart-pickup-location-subtext-change-option {\n        float: right;\n        margin-top: 20px;\n        margin-right: 10px; } }\n    .fmcy-cart-review .fmcy-cart-pickup-location-subtext-change-option .location-change-click-here {\n      color: #ffffff;\n      border-color: #666 !important;\n      letter-spacing: 1px;\n      background-color: #666;\n      position: relative;\n      border: 2px solid;\n      font-family: \"bebasneue\", \"Arial\", sans-serif;\n      font-size: 160%;\n      line-height: 1.7em;\n      border-radius: 5px;\n      padding-left: 10px;\n      padding-right: 10px;\n      padding-top: 1px;\n      padding-bottom: 1px;\n      cursor: pointer; }\n  .fmcy-cart-review .fmcy-cart-delivery-postal-code-region .alert-success {\n    border-radius: 0px; }\n  .fmcy-cart-review .form-control {\n    font-family: 'droid_serif', sans-serif !important; }\n", ""]);
	
	// exports


/***/ },
/* 759 */
267,
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-age-gate {\n  background-color: #000;\n  padding-left: 0 !important;\n  padding-right: 0 !important; }\n  .fmcy-age-gate .fmcy-age-gate-expanded-row {\n    background-color: #000;\n    width: 100%; }\n  .fmcy-age-gate .fmcy-age-gate-content-wrapper {\n    position: absolute;\n    bottom: 150px;\n    right: 0;\n    left: 0; }\n  .fmcy-age-gate .fmcy-age-gate-title-wrapper {\n    padding: 10px;\n    max-width: 245px;\n    margin: auto; }\n  .fmcy-age-gate h1 {\n    font-family: \"bebasneue\", \"Arial\", sans-serif !important;\n    text-align: center;\n    color: #fff !important; }\n  .fmcy-age-gate .fmcy-age-gate-icon {\n    margin: auto;\n    background-image: url(" + escape(__webpack_require__(780)) + ");\n    width: 150px;\n    height: 150px;\n    background-size: cover;\n    background-repeat: no-repeat; }\n  .fmcy-age-gate .fmcy-age-gate-button-bar {\n    background-color: #000;\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n    position: fixed;\n    height: 74px;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    border-top: 1px solid rgba(255, 255, 255, 0.2);\n    box-shadow: 0 0 6px rgba(0, 0, 0, 0.7);\n    z-index: 9999; }\n    .fmcy-age-gate .fmcy-age-gate-button-bar .fmcy-age-gate-button-bar-inner {\n      margin: auto !important;\n      max-width: 1070px;\n      font-size: 90%;\n      color: #000; }\n    .fmcy-age-gate .fmcy-age-gate-button-bar .btn-primary {\n      width: 100%;\n      margin-top: 10px;\n      color: #ffffff !important;\n      border-color: #4cb8be !important;\n      letter-spacing: 1px !important;\n      background-color: #4cb8be !important;\n      position: relative;\n      border: 2px solid;\n      font-family: \"bebasneue\", \"Arial\", sans-serif;\n      font-size: 160%;\n      line-height: 1.7em !important; }\n      .fmcy-age-gate .fmcy-age-gate-button-bar .btn-primary.fmcy-no-btn {\n        border-color: #1f1e1e !important;\n        background-color: #1f1e1e !important; }\n", ""]);
	
	// exports


/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-pickup-delivery-select {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  padding-bottom: 100px; }\n  .fmcy-pickup-delivery-select .fmcy-pickup-delivery-select-tab-region {\n    height: 51px;\n    padding-top: 9px; }\n    .fmcy-pickup-delivery-select .fmcy-pickup-delivery-select-tab-region .nav-tabs {\n      border-bottom: 1px solid #1c1c1c; }\n    .fmcy-pickup-delivery-select .fmcy-pickup-delivery-select-tab-region .tl-tabs-label {\n      font-family: \"bebasneue\", \"Arial\", sans-serif;\n      color: #ffffff !important;\n      font-size: 20px; }\n    .fmcy-pickup-delivery-select .fmcy-pickup-delivery-select-tab-region a {\n      color: #ffffff !important; }\n    .fmcy-pickup-delivery-select .fmcy-pickup-delivery-select-tab-region .nav-tabs > li.active > a, .fmcy-pickup-delivery-select .fmcy-pickup-delivery-select-tab-region .nav-tabs > li.active > a:hover, .fmcy-pickup-delivery-select .fmcy-pickup-delivery-select-tab-region .nav-tabs > li.active > a:focus {\n      color: #fff;\n      background-color: #1c1c1c;\n      border: 1px solid #1c1c1c; }\n    .fmcy-pickup-delivery-select .fmcy-pickup-delivery-select-tab-region .nav-tabs > li > a:hover {\n      background-color: #1c1c1c;\n      border: 1px solid #1c1c1c; }\n    .fmcy-pickup-delivery-select .fmcy-pickup-delivery-select-tab-region .nav-tabs > li > a:focus {\n      background-color: #1c1c1c;\n      border: 1px solid #1c1c1c; }\n  .fmcy-pickup-delivery-select .fmcy-pickup-delivery-select-expanded-row {\n    background-color: #000;\n    width: 100%; }\n  .fmcy-pickup-delivery-select .btn-default {\n    letter-spacing: 1px !important;\n    position: relative;\n    padding: .3em 1em;\n    border: 2px solid;\n    -webkit-border-radius: 3px;\n    -moz-border-radius: 3px;\n    border-radius: 3px;\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 160%;\n    line-height: 1.7em !important; }\n  .fmcy-pickup-delivery-select .btn-primary {\n    color: #ffffff !important;\n    border-color: #7e6b3a !important;\n    letter-spacing: 1px !important;\n    background-color: #7e6b3a !important;\n    position: relative;\n    padding: .3em 1em;\n    border: 2px solid;\n    -webkit-border-radius: 3px;\n    -moz-border-radius: 3px;\n    border-radius: 3px;\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 160%;\n    line-height: 1.7em !important; }\n  .fmcy-pickup-delivery-select .fmcy-locations-list {\n    background-color: #1c1c1c; }\n  .fmcy-pickup-delivery-select .fmcy-pickup-delivery-selected-content-region {\n    background-color: #1c1c1c; }\n  .fmcy-pickup-delivery-select .fmcy-delivery-select-continue-button-bar {\n    display: none;\n    background-color: #000;\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n    position: fixed;\n    height: 74px;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    border-top: 1px solid rgba(255, 255, 255, 0.2);\n    box-shadow: 0 0 6px rgba(0, 0, 0, 0.7);\n    z-index: 9999; }\n    .fmcy-pickup-delivery-select .fmcy-delivery-select-continue-button-bar .fmcy-delivery-select-continue-button-bar-inner {\n      margin: auto !important;\n      max-width: 1070px;\n      font-size: 90%;\n      color: #000; }\n    .fmcy-pickup-delivery-select .fmcy-delivery-select-continue-button-bar .btn-primary {\n      width: 100%;\n      margin-top: 10px;\n      color: #ffffff !important;\n      border-color: #4cb8be !important;\n      letter-spacing: 1px !important;\n      background-color: #4cb8be !important;\n      position: relative;\n      border: 2px solid;\n      font-family: \"bebasneue\", \"Arial\", sans-serif;\n      font-size: 160%;\n      line-height: 1.7em !important; }\n", ""]);
	
	// exports


/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-location-display {\n  background-color: #fff;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  /*\n  @media only screen and (min-width: 900px) {\n    .fmcy-location-map-list-region {\n      top: 0;\n    }\n  }\n  */ }\n  .fmcy-location-display .fmcy-location-display-change-location-button-region {\n    text-align: right;\n    padding-top: 20px; }\n    .fmcy-location-display .fmcy-location-display-change-location-button-region .btn-default {\n      font-size: 12px; }\n  .fmcy-location-display .fmcy-location-map-list-region {\n    position: absolute;\n    top: 51px;\n    height: 400px;\n    z-index: 5000; }\n  .fmcy-location-display .fmcy-location-map-tab-region {\n    position: absolute;\n    top: -9px;\n    height: 51px;\n    width: 100%;\n    z-index: 1000;\n    padding-top: 9px; }\n    .fmcy-location-display .fmcy-location-map-tab-region .nav-tabs {\n      border-bottom: 1px solid #080808; }\n    .fmcy-location-display .fmcy-location-map-tab-region .tl-tabs-label {\n      font-family: \"bebasneue\", \"Arial\", sans-serif;\n      color: #ffffff !important;\n      font-size: 20px; }\n    .fmcy-location-display .fmcy-location-map-tab-region a {\n      color: #ffffff !important; }\n    .fmcy-location-display .fmcy-location-map-tab-region .nav-tabs > li.active > a, .fmcy-location-display .fmcy-location-map-tab-region .nav-tabs > li.active > a:hover, .fmcy-location-display .fmcy-location-map-tab-region .nav-tabs > li.active > a:focus {\n      color: #fff;\n      background-color: #080808;\n      border: 1px solid #080808; }\n    .fmcy-location-display .fmcy-location-map-tab-region .nav-tabs > li > a:hover {\n      background-color: #080808;\n      border: 1px solid #080808; }\n    .fmcy-location-display .fmcy-location-map-tab-region .nav-tabs > li > a:focus {\n      background-color: #080808;\n      border: 1px solid #080808; }\n  .fmcy-location-display .fmcy-locations-map {\n    background-color: #1a1a1a !important; }\n  .fmcy-location-display .fmcy-locations-map-close-btn {\n    top: 10px !important; }\n  .fmcy-location-display .fmcy-location-display-expanded-row {\n    background-color: #000;\n    width: 100%; }\n  .fmcy-location-display .fmcy-location-map-cta-region {\n    position: fixed;\n    z-index: 20001;\n    bottom: 0;\n    width: 100%; }\n    .fmcy-location-display .fmcy-location-map-cta-region .fmcy-location-map-cta {\n      text-align: center;\n      min-height: 75px;\n      background-color: black;\n      width: 100%; }\n  .fmcy-location-display .btn-default {\n    letter-spacing: 1px !important;\n    position: relative;\n    padding: .3em 1em;\n    border: 2px solid;\n    -webkit-border-radius: 3px;\n    -moz-border-radius: 3px;\n    border-radius: 3px;\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 160%;\n    line-height: 1.7em !important; }\n  .fmcy-location-display .btn-primary {\n    color: #ffffff !important;\n    border-color: #7e6b3a !important;\n    letter-spacing: 1px !important;\n    background-color: #7e6b3a !important;\n    position: relative;\n    padding: .3em 1em;\n    border: 2px solid;\n    -webkit-border-radius: 3px;\n    -moz-border-radius: 3px;\n    border-radius: 3px;\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 160%;\n    line-height: 1.7em !important; }\n  .fmcy-location-display .fmcy-location-display-select-location-label {\n    font-size: 80%;\n    color: #ccc;\n    font-weight: bold; }\n  .fmcy-location-display .fmcy-location-map-detected-location-results-text {\n    padding-top: 15px;\n    color: #ffffff;\n    max-width: 250px;\n    font-size: 90%;\n    margin: auto; }\n    .fmcy-location-display .fmcy-location-map-detected-location-results-text .fmcy-location-map-detected-location-results-text-location {\n      color: #7e6b3a;\n      font-family: \"bebasneue\", \"Arial\", sans-serif;\n      font-size: 125%; }\n    .fmcy-location-display .fmcy-location-map-detected-location-results-text .fmcy-location-map-detected-location-results-text-location-distance {\n      color: #7e6b3a;\n      font-family: \"bebasneue\", \"Arial\", sans-serif;\n      font-size: 125%; }\n", ""]);
	
	// exports


/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".swiper-container {\n  width: 100%;\n  height: 70vw; }\n\n.swiper-pagination-bullet {\n  background: #999;\n  opacity: 0.5; }\n\n.swiper-pagination-bullet-active {\n  opacity: 1; }\n", ""]);
	
	// exports


/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-product-zoom-toggle {\n  background-color: #fff;\n  border: 2px solid #CCCCCC;\n  border-radius: 23px;\n  padding: 5px 10px;\n  font-size: 1em;\n  font-weight: 600; }\n", ""]);
	
	// exports


/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-product-zoomer .fmcy-leaflet-map-container {\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n  overflow-x: hidden;\n  overflow-y: hidden; }\n  .fmcy-product-zoomer .fmcy-leaflet-map-container .fmcy-leaflet-map-target {\n    position: absolute;\n    opacity: 1;\n    background-color: #fff;\n    height: 300px; }\n    @media (min-width: 780px) {\n      .fmcy-product-zoomer .fmcy-leaflet-map-container .fmcy-leaflet-map-target {\n        height: 450px; } }\n    @media (min-width: 1600px) {\n      .fmcy-product-zoomer .fmcy-leaflet-map-container .fmcy-leaflet-map-target {\n        height: 650px; } }\n    .fmcy-product-zoomer .fmcy-leaflet-map-container .fmcy-leaflet-map-target .leaflet-container {\n      background: #fff; }\n    .fmcy-product-zoomer .fmcy-leaflet-map-container .fmcy-leaflet-map-target .leaflet-control-zoom a {\n      color: #000 !important; }\n\n.fmcy-product-zoomer.fmcy-product-zoomer-theme-dark .fmcy-leaflet-map-target {\n  background-color: #000; }\n\n.fmcy-product-zoomer .leaflet-control-attribution {\n  display: none; }\n", ""]);
	
	// exports


/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-thumbnail-selector {\n  z-index: 2; }\n  .fmcy-thumbnail-selector.row-flex {\n    margin-left: 0;\n    margin-right: 0; }\n  .fmcy-thumbnail-selector .fmcy-thumbnail-item .fmcy-thumbnail-item-image {\n    height: 30px; }\n", ""]);
	
	// exports


/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, "/* Custom, iPhone Retina */\n.fmcy-menu-items.row-flex {\n  margin-left: 0;\n  margin-right: 0; }\n\n.fmcy-menu-items .fmcy-menu-item-thumb {\n  margin-bottom: 15px;\n  margin-top: 15px; }\n\n.fmcy-menu-items .fmcy-menu-items-no-menu-items {\n  text-align: center;\n  width: 80%;\n  margin: auto;\n  margin-top: 25%; }\n\n/* Extra Small Devices, Phones */\n@media only screen and (min-width: 480px) {\n  .fmcy-menu-items .fmcy-menu-item-thumb {\n    max-height: 500px; }\n    .fmcy-menu-items .fmcy-menu-item-thumb .fmcy-menu-item-thumb-image {\n      height: 225px;\n      height: 60vw; } }\n\n/* Small Devices, Tablets */\n@media only screen and (min-width: 768px) {\n  .fmcy-menu-items .fmcy-menu-item-thumb .fmcy-menu-item-thumb-image {\n    height: 307px;\n    height: 30vw; } }\n\n/* Medium Devices, Desktops */\n@media only screen and (min-width: 992px) {\n  .fmcy-menu-items .fmcy-menu-item-thumb .fmcy-menu-item-thumb-image {\n    height: 250px;\n    height: 20vw; } }\n\n/* Large Devices, Wide Screens */\n@media only screen and (min-width: 1600px) {\n  .fmcy-menu-items .fmcy-menu-item-thumb .fmcy-menu-item-thumb-image {\n    height: 290px;\n    height: 16vw; } }\n", ""]);
	
	// exports


/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".select2-container .fmcy-menu-search-dropdown,\n.select2-container .fmcy-sort-options-dropdown {\n  z-index: 999999999999;\n  font-size: 16px;\n  line-height: 16px; }\n  .select2-container .fmcy-menu-search-dropdown .select2-results__option--highlighted[aria-selected],\n  .select2-container .fmcy-sort-options-dropdown .select2-results__option--highlighted[aria-selected] {\n    background-color: #00afb4; }\n  body.admin-bar .select2-container .fmcy-menu-search-dropdown.select2-dropdown--below, body.admin-bar .select2-container .fmcy-menu-search-dropdown.select2-dropdown--above, body.admin-bar\n  .select2-container .fmcy-sort-options-dropdown.select2-dropdown--below, body.admin-bar\n  .select2-container .fmcy-sort-options-dropdown.select2-dropdown--above {\n    top: 46px; }\n\n.select2-container .select2-selection__arrow {\n  height: 26px;\n  position: absolute;\n  top: -1px;\n  right: 1px;\n  width: 20px; }\n\n.fmcy-search {\n  font-size: 16px;\n  letter-spacing: 1px; }\n  .fmcy-search .select2-container {\n    left: 0px !important;\n    right: 0px !important; }\n  .fmcy-search[showing-sub-categories=\"true\"] .fmcy-sub-category-filter-row {\n    display: block; }\n  .fmcy-search[showing-sub-categories=\"true\"] .fmcy-category-filter-region {\n    margin-bottom: 0; }\n  .fmcy-search .row {\n    margin-left: 0 !important;\n    margin-right: 0 !important; }\n  .fmcy-search .dropdown-toggle {\n    min-width: 100px; }\n  .fmcy-search .dropdown-menu {\n    padding-left: 10px !important;\n    padding-right: 10px !important; }\n    .fmcy-search .dropdown-menu li {\n      list-style: none;\n      cursor: pointer; }\n      .fmcy-search .dropdown-menu li:hover {\n        background-color: #e5e5e5; }\n  .fmcy-search .btn.btn-fmcy {\n    font-size: 85%; }\n  .fmcy-search .fmcy-no-gutter {\n    padding-left: 0 !important;\n    padding-right: 0 !important; }\n  .fmcy-search .fmcy-search-content-wrapper {\n    max-width: 1100px;\n    margin: 0 auto;\n    padding-top: 0px;\n    padding-bottom: 0px; }\n    .fmcy-search .fmcy-search-content-wrapper .col-xs-12 {\n      padding-left: 5px;\n      padding-right: 5px; }\n  .fmcy-search .fmcy-search-caption {\n    font-family: 'avril', 'Arial', sans-serif;\n    font-size: 100%;\n    font-weight: 500;\n    color: #6D6E71;\n    text-align: center; }\n  .fmcy-search .fmcy-sub-category-filter-row {\n    display: none; }\n  .fmcy-search .fmcy-category-filter-region {\n    margin-top: 10px;\n    margin-bottom: 10px; }\n  .fmcy-search .fmcy-sub-category-filter-region {\n    margin-top: 0px;\n    margin-bottom: 0px; }\n  .fmcy-search .fmcy-quick-search-row {\n    background-color: #6D6E71; }\n    .fmcy-search .fmcy-quick-search-row .fmcy-quick-search-caption {\n      color: #FFFFFF;\n      margin-top: 5px;\n      margin-bottom: 5px; }\n    .fmcy-search .fmcy-quick-search-row .fmcy-quick-search-region {\n      margin-top: 10px;\n      margin-bottom: 10px; }\n  .fmcy-search .fmcy-category-filter-row,\n  .fmcy-search .fmcy-sub-category-filter-row {\n    background-color: #e5e3e3; }\n  .fmcy-search .fmcy-sort-and-filter-row {\n    background-color: #e5e3e3; }\n    .fmcy-search .fmcy-sort-and-filter-row .fmcy-search-caption {\n      margin-top: 5px; }\n      .fmcy-search .fmcy-sort-and-filter-row .fmcy-search-caption a {\n        display: inline-block;\n        margin-bottom: 0; }\n        .fmcy-search .fmcy-sort-and-filter-row .fmcy-search-caption a[aria-expanded=\"true\"] {\n          margin-bottom: 5px; }\n    .fmcy-search .fmcy-sort-and-filter-row .fmcy-search-toggle-btn {\n      font-family: 'avril', 'Arial', sans-serif;\n      font-size: 115%;\n      text-align: center;\n      cursor: pointer;\n      padding: 1px;\n      display: inline-block;\n      color: #000000;\n      font-weight: normal;\n      font-style: normal;\n      text-transform: none;\n      line-height: 34px;\n      border-radius: 6px;\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n      margin-bottom: 10px;\n      speak: none; }\n      .fmcy-search .fmcy-sort-and-filter-row .fmcy-search-toggle-btn[on=\"true\"] {\n        color: #00afb4; }\n    .fmcy-search .fmcy-sort-and-filter-row .fmcy-search-caption a {\n      text-align: center; }\n    .fmcy-search .fmcy-sort-and-filter-row .fmcy-search-panel {\n      margin-top: 10px;\n      margin-bottom: 10px;\n      background-color: #fff;\n      min-height: 35px; }\n      .fmcy-search .fmcy-sort-and-filter-row .fmcy-search-panel .btn-clear.btn-fmcy {\n        height: 32px;\n        background-color: #ccc; }\n      .fmcy-search .fmcy-sort-and-filter-row .fmcy-search-panel .form-control {\n        border: none; }\n      .fmcy-search .fmcy-sort-and-filter-row .fmcy-search-panel .fmcy-search-button.btn-fmcy {\n        background-color: #625840;\n        border-radius: 0; }\n        .fmcy-search .fmcy-sort-and-filter-row .fmcy-search-panel .fmcy-search-button.btn-fmcy:hover {\n          color: #fff;\n          background-color: #0080FF; }\n    .fmcy-search .fmcy-sort-and-filter-row .fmcy-sort-panel {\n      display: block;\n      margin-bottom: 10px; }\n      .fmcy-search .fmcy-sort-and-filter-row .fmcy-sort-panel .fmcy-sort-options {\n        font-family: 'avril', 'Arial', sans-serif;\n        font-size: 100%;\n        text-align: center;\n        cursor: pointer;\n        color: #000000;\n        font-weight: normal;\n        font-style: normal; }\n        .fmcy-search .fmcy-sort-and-filter-row .fmcy-sort-panel .fmcy-sort-options .select2-container {\n          width: 100% !important; }\n          .fmcy-search .fmcy-sort-and-filter-row .fmcy-sort-panel .fmcy-sort-options .select2-container .select2-selection {\n            border-radius: 6px;\n            border: none;\n            background: none; }\n            .fmcy-search .fmcy-sort-and-filter-row .fmcy-sort-panel .fmcy-sort-options .select2-container .select2-selection .select2-selection__rendered {\n              position: relative;\n              top: -1px;\n              color: #00afb4;\n              white-space: nowrap;\n              overflow: hidden;\n              text-overflow: ellipsis;\n              font-size: 115%; }\n      .fmcy-search .fmcy-sort-and-filter-row .fmcy-sort-panel .select2-container--default .select2-selection--single .select2-selection__placeholder {\n        color: #333; }\n\n.select2-container .fmcy-menu-search-dropdown.select2-dropdown--below,\n.select2-container .fmcy-brands-select-dropdown.select2-dropdown--below,\n.select2-container .fmcy-sort-options-dropdown.select2-dropdown--below {\n  top: 4px; }\n\n.select2-container .fmcy-menu-search-dropdown.select2-dropdown--above,\n.select2-container .fmcy-brands-select-dropdown.select2-dropdown--above,\n.select2-container .fmcy-sort-options-dropdown.select2-dropdown--above {\n  top: -4px; }\n\nbody.admin-bar .select2-container .fmcy-menu-search-dropdown.select2-dropdown--below, body.admin-bar\n.select2-container .fmcy-brands-select-dropdown.select2-dropdown--below, body.admin-bar\n.select2-container .fmcy-sort-options-dropdown.select2-dropdown--below {\n  top: 36px; }\n\nbody.admin-bar .select2-container .fmcy-menu-search-dropdown.select2-dropdown--above, body.admin-bar\n.select2-container .fmcy-brands-select-dropdown.select2-dropdown--above, body.admin-bar\n.select2-container .fmcy-sort-options-dropdown.select2-dropdown--above {\n  top: 28px; }\n\n.select2-container .fmcy-menu-search-dropdown .select2-results__options,\n.select2-container .fmcy-brands-select-dropdown .select2-results__options,\n.select2-container .fmcy-sort-options-dropdown .select2-results__options {\n  max-height: 410px !important;\n  list-style-type: none;\n  padding: 0; }\n\n.select2-container .fmcy-menu-search-dropdown .select2-results__message,\n.select2-container .fmcy-brands-select-dropdown .select2-results__message,\n.select2-container .fmcy-sort-options-dropdown .select2-results__message {\n  color: #fff !important; }\n\n.select2-container .fmcy-menu-search-dropdown .select2-results__option--highlighted,\n.select2-container .fmcy-brands-select-dropdown .select2-results__option--highlighted,\n.select2-container .fmcy-sort-options-dropdown .select2-results__option--highlighted {\n  background-color: #0fb1b5 !important; }\n\n.select2-container .fmcy-menu-search-dropdown .select2-results__option[aria-selected=true],\n.select2-container .fmcy-brands-select-dropdown .select2-results__option[aria-selected=true],\n.select2-container .fmcy-sort-options-dropdown .select2-results__option[aria-selected=true] {\n  background-color: #000 !important; }\n\n.select2-container .fmcy-menu-search-dropdown .select2-search--dropdown .select2-search__field,\n.select2-container .fmcy-brands-select-dropdown .select2-search--dropdown .select2-search__field,\n.select2-container .fmcy-sort-options-dropdown .select2-search--dropdown .select2-search__field {\n  padding: 6px !important;\n  font-size: 20px; }\n\n.select2-container .fmcy-menu-search-dropdown .select2-results .tl-wrapper.tl-show-icon .tl-text-wrapper,\n.select2-container .fmcy-brands-select-dropdown .select2-results .tl-wrapper.tl-show-icon .tl-text-wrapper,\n.select2-container .fmcy-sort-options-dropdown .select2-results .tl-wrapper.tl-show-icon .tl-text-wrapper {\n  color: #fff;\n  max-width: 221px;\n  line-height: 20px; }\n\n.select2-container .fmcy-menu-search-dropdown .select2-results .tl-icon-wrapper,\n.select2-container .fmcy-brands-select-dropdown .select2-results .tl-icon-wrapper,\n.select2-container .fmcy-sort-options-dropdown .select2-results .tl-icon-wrapper {\n  width: 49px !important; }\n\n.fmcy-search .fmcy-sort-and-filter-row .fmcy-search-caption,\n.fmcy-search .fmcy-quick-search-row .fmcy-search-caption {\n  text-align: right;\n  margin-right: -15px;\n  margin-top: 15px;\n  margin-bottom: 0; }\n\n.fmcy-search .fmcy-category-filter-region {\n  margin-bottom: 25px; }\n\n.fmcy-search[showing-sub-categories=\"true\"] .fmcy-category-filter-region {\n  margin-bottom: 0; }\n\n.fmcy-search .fmcy-sort-and-filter-row .fmcy-search-toggle-btns {\n  min-height: 37px;\n  padding-top: 7px; }\n\n.fmcy-search .fmcy-sort-and-filter-row .fmcy-search-caption {\n  margin-bottom: 5px; }\n  .fmcy-search .fmcy-sort-and-filter-row .fmcy-search-caption a {\n    margin-bottom: 0;\n    text-align: left; }\n\n.fmcy-search .fmcy-sort-and-filter-row .fmcy-sort-and-filter-controls {\n  text-align: center;\n  height: auto !important;\n  display: block !important; }\n  .fmcy-search .fmcy-sort-and-filter-row .fmcy-sort-and-filter-controls > div {\n    margin-left: 5px;\n    margin-right: 5px; }\n    .fmcy-search .fmcy-sort-and-filter-row .fmcy-sort-and-filter-controls > div:first-child {\n      margin-left: 0; }\n\n.fmcy-search .fmcy-sort-and-filter-row .fmcy-search-clear-filters-x-btn {\n  font-family: \"bebasneue\", \"Arial\", sans-serif;\n  font-size: 92%; }\n\n.fmcy-search .fmcy-sort-and-filter-row .fmcy-search-toggle-btn {\n  line-height: 22px;\n  display: inline-block;\n  vertical-align: middle;\n  margin-bottom: 0;\n  padding-bottom: 3px; }\n  .fmcy-search .fmcy-sort-and-filter-row .fmcy-search-toggle-btn:first-child {\n    margin-left: 0; }\n\n.fmcy-search .fmcy-sort-and-filter-row .fmcy-search-panel {\n  margin-top: 0; }\n\n.fmcy-search .fmcy-sort-and-filter-row .fmcy-sort-panel {\n  display: inline-block;\n  vertical-align: middle;\n  margin-bottom: 0; }\n\n/* Medium Devices, Desktops */\n@media only screen and (max-width: 780px) {\n  .fmcy-search {\n    font-size: 14px;\n    letter-spacing: 1px; }\n    .fmcy-search .fmcy-sort-and-filter-controls > div {\n      margin-left: 3px;\n      margin-right: 3px; }\n    .fmcy-search .select2-selection__rendered {\n      max-width: 102px; } }\n\n@media only screen and (max-width: 410px) {\n  .fmcy-search {\n    font-size: 13px; } }\n\n@media only screen and (max-width: 360px) {\n  .fmcy-search {\n    font-size: 12px;\n    letter-spacing: 0px; }\n    .fmcy-search .fmcy-sort-and-filter-controls > div {\n      margin-left: 2px;\n      margin-right: 2px; } }\n", ""]);
	
	// exports


/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-page-not-found {\n  color: #fff;\n  margin-top: 60px;\n  text-align: center; }\n", ""]);
	
	// exports


/***/ },
/* 770 */
267,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".tl-confirm-dialog .btn-secondary {\n  background-color: #868e96;\n  border-color: #868e96; }\n", ""]);
	
	// exports


/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1040;\n  background-color: #000; }\n  .modal-backdrop.fade {\n    opacity: 0;\n    filter: alpha(opacity=0); }\n  .modal-backdrop.in {\n    opacity: 0.5;\n    filter: alpha(opacity=50); }\n\n.tl-dialog.tl-full-screen-dialog {\n  z-index: 99999; }\n  .tl-dialog.tl-full-screen-dialog .tl-spinner {\n    height: 100vh; }\n  .tl-dialog.tl-full-screen-dialog .modal-dialog {\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    padding: 0; }\n  .tl-dialog.tl-full-screen-dialog .modal-content {\n    height: auto;\n    min-height: 100%;\n    border-radius: 0; }\n\n.tl-dialog .close {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  z-index: 10; }\n", ""]);
	
	// exports


/***/ },
/* 779 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/bag-empty-fill-product-52d93d63d21ae5cd1efbe16cf8481021.png";

/***/ },
/* 780 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/license-a2f5f2a2315281ddb57c26505e7f7d7d.png";

/***/ },
/* 781 */
159,
/* 782 */
160,
/* 783 */
161,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(754);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-empty.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-empty.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(755);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-loading.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-loading.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(756);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-payment-challenge.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-payment-challenge.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(757);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-payment.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-payment.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(758);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-review.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-review.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(759);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./count-down.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./count-down.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(760);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./age-gate.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./age-gate.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(761);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./pickup-delivery-select.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./pickup-delivery-select.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(762);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./location-display.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./location-display.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(763);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./photo-swiper.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./photo-swiper.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(764);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./product-zoom-toggle.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./product-zoom-toggle.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(765);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./product-zoomer.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./product-zoomer.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(766);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./thumbnail-selector.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./thumbnail-selector.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(767);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./menu-items.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./menu-items.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(768);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./subfilters.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./subfilters.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(769);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./page-not-found.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./page-not-found.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(770);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./video-group.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./video-group.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(777);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./confirm-dialog.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./confirm-dialog.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(778);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./dialog.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./dialog.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="row no-gutters">\n  <div class="col-xs-12 col-md-6 fmcy-cart-empty-left-column"></div>\n  <div class="col-xs-12 col-md-6 fmcy-cart-empty-right-column">\n    <div class="fmcy-cart-empty-title">Cart Empty</div>\n    <div class="fmcy-cart-empty-icon"></div>\n  </div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 853 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-cart-loading-overlay">\n  <div class="fmcy-cart-loading-indicator-region"></div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 854 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="spinner-region"></div>\n<div class="fmcy-form-challenge">\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 855 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="row no-gutters">\n  <div class="col-xs-12 col-md-6 fmcy-cart-payment-left-column"></div>\n  <div class="col-xs-12 col-md-6 fmcy-cart-payment-right-column">\n    <div class="fmcy-cart-payment-title">Order Payment '+
	((__t=(orderCode))==null?'':__t)+
	'</div>\n    <div class="fmcy-cart-payment-error-message-region"></div>\n     ';
	 if (paymentMethod == 'credit') { 
	__p+='\n    <div class="fmcy-cart-payment-credit-cards">\n      <span class="mastercard-xs"></span><span class="visa-xs"></span><span class="amex-xs"></span>  &nbsp;&nbsp;&nbsp;&nbsp;<span class="discover-xs"></span>\n    </div>\n    ';
	 } 
	__p+='\n    ';
	 if (paymentMethod == 'interac') { 
	__p+='\n   <div class="fmcy-cart-payment-interac">\n     <div class="interac-icon"></div>\n   </div>\n   ';
	 } 
	__p+='\n    <div class="fmcy-cart-payment-total">\n      <div class="fmcy-cart-payment-total-cost-label fmcy-cart-payment-field-label">\n        Payment amount\n      </div>\n      <div class="fmcy-cart-payment-total-cost">'+
	((__t=(cartTotalCost))==null?'':__t)+
	'</div>\n    </div>\n    <div class="fmcy-cart-payment-pay-form-region">\n      ';
	 if (paymentMethod == 'interac') { 
	__p+='\n     <div class="fmcy-cart-payment-interac-information-text">\n       You will be prompted to log in to your issuing bank and approve a payment to Original Farm. Please note that for INTERAC Online transactions, the funds will be withdrawn from your bank account immediately after you place your order. Any adjustments or order cancellations will be refunded directly to your account at the time of processing.\n     </div>\n     ';
	 } 
	__p+='\n    </div>\n  </div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 856 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="row no-gutters">\n  <div class="col-xs-12 col-md-6 fmcy-cart-review-left-column"></div>\n  <div class="col-xs-12 col-md-6 fmcy-cart-review-right-column">\n    <div class="fmcy-cart-review-title">Cart Review</div>\n    <div class="fmcy-cart-review-error-message-region"></div>\n    <div class="fmcy-cart-review-items-region"></div>\n    <div class="fmcy-cart-total-weight-region"></div>\n    <div class="fmcy-cart-id-disclaimer">\n      You must have two pieces of ID with you during the order hand over\n    </div>\n    <div class="fmcy-cart-review-sub-total">Subtotal: '+
	((__t=(cartSubTotal))==null?'':__t)+
	'</div>\n    <div class="fmcy-cart-review-delivery-total">Delivery fee: '+
	((__t=(cartDeliveryTotal))==null?'':__t)+
	'</div>\n    <div class="fmcy-cart-review-deposit">Recycling Deposit: '+
	((__t=(cartDeposit))==null?'':__t)+
	'</div>\n    <div class="fmcy-cart-review-tax">Tax: '+
	((__t=(cartTax))==null?'':__t)+
	'</div>\n    <div class="fmcy-cart-review-tip">\n      <div class="fmcy-cart-tip-change-btn">change tip</div>\n      <div class="fmcy-cart-review-tip-text">'+
	((__t=(cartDeliveryTipPercentage))==null?'':__t)+
	' Tip: '+
	((__t=(cartDeliveryTipTotal))==null?'':__t)+
	'</div>\n    </div>\n    <div class="fmcy-cart-tip-below-region"></div>\n    <div class="fmcy-cart-review-total">\n      <div class="fmcy-cart-review-total-cost-col">\n        Total: <span class="fmcy-cart-review-total-cost">'+
	((__t=(cartTotalCost))==null?'':__t)+
	'</span>\n      </div>\n    </div>\n    <div class="fmcy-cart-review-title">Delivery Options</div>\n    <div class="fmcy-cart-delivery-select">\n      <fieldset class="form-group">\n          <div class="input-group">\n            <input type="radio" class="custom-control-input" id="fmcy-cart-delivery-pickup-radio" value="pickup" name="deliveryRadioGroup">\n            <label for="fmcy-cart-delivery-pickup-radio" class="fmcy-cart-delivery-field-label">Pick up in store</label>\n          </div>\n          <div class="container-fluid local-pickup-location-review-edit">\n            <div class="row no-gutters">\n              <div class="col-xs-12 col-md-6">\n                <div class="fmcy-cart-pickup-location-region"></div>\n              </div>\n              <div class="col-xs-12 col-md-6">\n                <div class="fmcy-cart-pickup-location-subtext-change-option"><span class="location-change-click-here">CHANGE</span></div>\n              </div>\n            </div>\n          </div>\n          <div class="input-group fmcy-cart-delivery-local-standard-radio-group">\n            <input type="radio" class="custom-control-input" id="fmcy-cart-delivery-local-standard-radio" value="local_delivery" name="deliveryRadioGroup">\n            <label for="fmcy-cart-delivery-local-standard-radio" class="fmcy-cart-delivery-field-label">Local Delivery (minimum '+
	((__t=(deliveryMinDollarAmount))==null?'':__t)+
	' order)</label>\n          </div>\n      </fieldset>\n    </div>\n    <div class="fmcy-cart-review-delivery-default-error-message"></div>\n    <div class="fmcy-cart-delivery-postal-code-region"></div>\n    <div class="fmcy-cart-delivery-available-later">\n      <div class="fmcy-cart-delivery-available-later-header">Local Delivery is unavailable at this time.</div>\n      <div class="fmcy-cart-delivery-available-next-message"></div>\n    </div>\n    <div class="fmcy-cart-delivery-address-region"></div>\n    <div class="fmcy-cart-delivery-notes-region"></div>\n    <div class="fmcy-cart-delivery-phone-region"></div>\n    <div class="fmcy-cart-delivery-tip-region"></div>\n    <div class="fmcy-cart-review-title">Payment Options</div>\n    <div class="fmcy-cart-review-payment-method-error-message">The payment method you have selected is currently unavailable at this time.</div>\n    <div class="fmcy-cart-paynow-paylater-select">\n      <fieldset class="form-group">\n        <div class="input-group fmcy-cart-paylater-group">\n          <input type="radio" class="custom-control-input" id="fmcy-cart-paylater-radio" value="paylater" name="payRadioGroup">\n          <label for="fmcy-cart-paylater-radio" class="fmcy-cart-payment-field-label">Pay in store when picking up. We accept debit, credit payments and cash.</label>\n        </div>\n          ';
	 if (creditCardPaymentEnabled) { 
	__p+='\n          <div class="input-group fmcy-cart-paynow-credit-group">\n            <input type="radio" class="custom-control-input" id="fmcy-cart-paynow-credit-radio" value="paynow_credit" name="payRadioGroup">\n            <label for="fmcy-cart-paynow-credit-radio" class="fmcy-cart-payment-field-label">Pay now by credit card. <div class="card-icons"><span class="mastercard-xs"></span><span class="visa-xs"></span><span class="amex-xs"></span> &nbsp;&nbsp;<span class="discover-xs"></span></div></label>\n          </div>\n          ';
	 } 
	__p+='\n          ';
	 if (interacPaymentEnabled) { 
	__p+='\n          <div class="input-group fmcy-cart-paynow-interac-group">\n            <input type="radio" class="custom-control-input" id="fmcy-cart-paynow-interac-radio" value="paynow_interac" name="payRadioGroup">\n            <label for="fmcy-cart-paynow-interac-radio" class="fmcy-cart-payment-field-label fmcy-cart-payment-field-label-interac">Pay now by Interac.<div class="interac-icon"></div></label>\n          </div>\n          ';
	 } 
	__p+='\n      </fieldset>\n    </div>\n    <div class="fmcy-cart-gift-form-region"></div>\n  </div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 857 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<span class="fmcy-countdown"></span>';
	}
	return __p;
	};


/***/ },
/* 858 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-age-gate-expanded-row">\n  <div class="fmcy-age-gate-content-wrapper">\n    <div class="fmcy-age-gate-icon-wrapper">\n      <div class="fmcy-age-gate-icon"></div>\n    </div>\n    <div class="fmcy-age-gate-title-wrapper">\n      <h1 class="fmcy-age-gate-title">Are you at least 19 years old?</h1>\n    </div>\n  </div>\n  <div class="fmcy-age-gate-button-bar container-fluid">\n    <div class="fmcy-age-gate-button-bar-inner row">\n      <div class="col-xs-6">\n        <div class="fmcy-no-button-region"></div>\n      </div>\n      <div class="col-xs-6">\n        <div class="fmcy-yes-button-region"></div>\n      </div>\n    </div>\n  </div>\n</div>';
	}
	return __p;
	};


/***/ },
/* 859 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-pickup-delivery-select-expanded-row">\n  <div class="fmcy-pickup-delivery-select-tab-region"></div>\n  <div class="fmcy-pickup-delivery-selected-content-region"></div>\n  <div class="fmcy-delivery-select-continue-button-bar container-fluid">\n    <div class="fmcy-delivery-select-continue-button-bar-inner row">\n      <div class="col-xs-12">\n        <div class="fmcy-continue-button-region"></div>\n      </div>\n    </div>\n  </div>\n</div>';
	}
	return __p;
	};


/***/ },
/* 860 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-location-display-expanded-row">\n  <div class="fmcy-location-map-tab-region"></div>\n  <div class="fmcy-location-map-list-region"></div>\n  <div class="fmcy-location-map-cta-region"></div>\n  <div class="fmcy-location-map-region"></div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 861 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-location-map-cta-inner">\n  <div class="fmcy-location-display-select-location-label">Select a location above, or</div>\n  <div class="fmcy-location-display-detect-location-button-region"></div>\n</div>\n<div class="fmcy-location-map-detected-location-results">\n  <div class="fmcy-location-map-detected-location-results-text"></div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 862 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<table>\n  <tr>\n    <td class="fmcy-other-location-td-name-column location-table-available-at-title-column">\n      <div class="location-table-available-at-title"></div>\n    </td>\n    <td class="selected-location-prices-region-column">\n      <div class="selected-location-prices-region"></div>\n    </td>\n  </tr>\n</table>\n<div class="location-table-available-at-table-wrapper">\n  <div class="other-location-prices-region"></div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 863 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td class="fmcy-other-location-td-name-column">\n  <div class="fmcy-other-location-name">'+
	((__t=( locationName ))==null?'':__t)+
	'</div>\n</td>\n<td><div class="fmcy-menu-item-table-prices-check-region"></div></td>\n';
	}
	return __p;
	};


/***/ },
/* 864 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="swiper-container">\n  <div class="swiper-wrapper"></div>\n  <div class="swiper-pagination"></div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 865 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div>\n    '+
	((__t=(zoomToggleText))==null?'':__t)+
	'\n</div>';
	}
	return __p;
	};


/***/ },
/* 866 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="container-fluid map-maker-map-view-container-fluid">\n    <div class="row">\n        <div class="col-xs-12 fmcy-leaflet-map-container">\n            <div class="fmcy-leaflet-map-target"></div>\n        </div>\n    </div>\n</div>';
	}
	return __p;
	};


/***/ },
/* 867 */,
/* 868 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="row fmcy-sub-category-filter-row">\n    <div class="col-xs-12">\n        <div class="fmcy-search-content-wrapper">\n            <div class="fmcy-sub-category-filter-region"></div>\n        </div>\n    </div>\n</div>\n<div class="row fmcy-sort-and-filter-row">\n    <div class="col-xs-12 fmcy-no-gutter">\n        <div class="fmcy-search-content-wrapper">\n            <div class="row">\n                <div class="col-xs-12">\n                    <div class="fmcy-search-toggle-btns">\n                        <div class="fmcy-sort-and-filter-controls fmcy-scroll-adjust-margin" id="fmcy-sort-and-filter-controls-'+
	((__t=( viewId ))==null?'':__t)+
	'">\n                            <div class="fmcy-search-toggle-btn fmcy-search-clear-filters-btn"><span class="fmcy-search-clear-filters-x-btn">x</span> CLEAR ALL</div>\n                            <div class="fmcy-search-toggle-btn fmcy-search-sale-toggle-btn">on sale</div>\n                            <div class="fmcy-search-toggle-btn fmcy-search-new-toggle-btn">new</div>\n                            ';
	 if (options.showClearanceItemsFilter) { 
	__p+='\n                                <div class="fmcy-search-toggle-btn fmcy-search-clearance-toggle-btn">clearance</div>\n                            ';
	 } 
	__p+='\n                            ';
	 if (options.filterBoxEnabled) { 
	__p+='\n                            <div class="fmcy-filter-box-panel">\n                                <div class="input-group fmcy-search-panel">\n                                    <div class="input-group-btn"></div>\n                                    <input type="hidden" name="search_param" value="name">\n                                    <input type="text" class="fmcy-search-key form-control" name="q" placeholder="Filter" value="">\n                                    <span class="input-group-btn">\n                                        <a class="btn btn-fmcy btn-default text-muted btn-clear" title="Clear">\n                                            <i class="glyphicon glyphicon-remove"></i>\n                                        </a>\n                                        <button class="fmcy-search-button btn-fmcy btn" type="submit">  Filter  </button>\n                                    </span>\n                                </div>\n                            </div>\n                            ';
	 } 
	__p+='\n                            ';
	 if (options.showLocationsFilter) { 
	__p+='\n                            <div class="fmcy-sort-panel fmcy-sort-panel-locations">\n                                <div class="fmcy-locations-ddl-region"></div>\n                            </div>\n                            ';
	 } 
	__p+='\n                            <div class="fmcy-sort-panel fmcy-sort-panel-vendors">\n                              <div class="fmcy-vendor-ddl-region"></div>\n                            </div>\n                            <div class="fmcy-sort-panel">\n                                <div class="fmcy-sort-ddl-region"></div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 869 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="container-fluid">\n    <div class="row">\n        <div class="col-xs-12">\n          <div class="fmcy-orders-region"></div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 870 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='Oops. That wasn\'t supposed to happen.\n\nWe don\'t have the page you requested.';
	}
	return __p;
	};


/***/ },
/* 871 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-videos-region"></div>\n';
	}
	return __p;
	};


/***/ },
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	 if (options.title) { 
	__p+='\n<div class="modal-header">\n    <h4 class="modal-title">\n        '+
	((__t=( options.title ))==null?'':_.escape(__t))+
	'\n    </h4>\n</div>\n';
	 } 
	__p+='\n<div class="modal-body tl-content-view-region">\n    '+
	((__t=( options.confirmText ))==null?'':__t)+
	'\n</div>\n<div class="modal-footer">\n    ';
	 if (options.showCancelButton) { 
	__p+='\n        <button type="button" class="tl-cancel-btn btn btn-default">'+
	((__t=( options.cancelButtonLabel ))==null?'':_.escape(__t))+
	'</button>\n    ';
	 } 
	__p+='\n    <button type="button" class="tl-primary-confirm-btn btn btn-primary">'+
	((__t=( options.confirmButtonLabel ))==null?'':_.escape(__t))+
	'</button>\n    ';
	 if (options.showSecondaryConfirmButton) { 
	__p+='\n    <button type="button" class="tl-secondary-confirm-btn btn btn-secondary">'+
	((__t=( options.secondaryConfirmButtonLabel ))==null?'':_.escape(__t))+
	'</button>\n    ';
	 } 
	__p+='\n</div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ },
/* 881 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="modal-dialog">\n    <button type="button" class="close" aria-hidden="true">&times;</button>\n    <div class="modal-content"></div>\n</div>';
	}
	return __p;
	};


/***/ },
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	var CartReview = __webpack_require__(699);
	var CartPayment = __webpack_require__(698);
	var CartPaymentChallenge = __webpack_require__(697);
	var CartEmpty = __webpack_require__(695);
	var OrderComplete = __webpack_require__(457);
	var CartLoading = __webpack_require__(696);
	var LocationMap = __webpack_require__(338);
	
	__webpack_require__(1027);
	var CartExpandedModal = BaseViews.LayoutView.extend({
	  className: 'fmcy-cart-expanded-modal fmcy-plugin-bootstrap container-fluid',
	  template: __webpack_require__(1060),
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      theme: 'dark',
	      errors: null,
	      errorMessage: null,
	      errorField: null,
	      orderId: null,
	      showCloseButton: true,
	      state: 'default' //default, success
	    });
	  },
	  ui: {
	    btnClose: '.fmcy-menu-item-btn-close'
	  },
	  triggers: {
	    'click @ui.btnClose': 'close:clicked'
	  },
	  regions: {
	    cartStepRegion: '.fmcy-cart-step-region',
	    mapRegion: '.fmcy-location-map-region'
	  },
	  _renderMap: function _renderMap(options) {
	    if (this._locationMap) {
	      return;
	    }
	    this._locationMap = new LocationMap(_.extend(options, {
	      allLocations: false,
	      adjustForMenuBar: false,
	      showCloseButton: false,
	      showZoomControls: false,
	      scrollWheelZoom: false,
	      _appChannel: this.options._appChannel
	    }));
	    this.mapRegion.show(this._locationMap);
	  },
	  _renderOrderComplete: function _renderOrderComplete() {
	    this._orderComplete = new OrderComplete({
	      orderId: this.options.orderId, //TODO: pass more order details?
	      order: this.options.order,
	      location: this.options._appChannel.request('get:filter:location:details')
	    });
	    this.cartStepRegion.show(this._orderComplete);
	  },
	  _renderCartPayment: function _renderCartPayment() {
	    var self = this;
	    self._cartPayment = new CartPayment({
	      _appChannel: self.options._appChannel,
	      errors: self.options.errors,
	      errorMessage: self.options.errorMessage,
	      errorField: self.options.errorField
	    });
	    self.cartStepRegion.show(self._cartPayment);
	  },
	  _renderCartPaymentChallenge: function _renderCartPaymentChallenge() {
	    var self = this;
	    self._cartPaymentChallenge = new CartPaymentChallenge(self.options);
	    self.cartStepRegion.show(self._cartPaymentChallenge);
	  },
	  _renderCartReview: function _renderCartReview() {
	    var self = this;
	    this.options._appChannel.request('cart:validate:prices').then(function (response) {
	      self._cartReview = new CartReview({
	        _appChannel: self.options._appChannel,
	        errors: self.options.errors,
	        errorMessage: self.options.errorMessage
	      });
	      self.cartStepRegion.show(self._cartReview);
	    }).fail(function (response) {
	      console.log('failed...');
	      // failed... should do something...
	    });
	  },
	  _renderCartEmpty: function _renderCartEmpty() {
	    var self = this;
	    self._cartEmpty = new CartEmpty({
	      _appChannel: self.options._appChannel
	    });
	    self.cartStepRegion.show(self._cartEmpty);
	  },
	  _renderCartLoading: function _renderCartLoading() {
	    if (this.cartStepRegion) {
	      this._cartLoading = new CartLoading({
	        _appChannel: this.options._appChannel
	      });
	      this.cartStepRegion.show(this._cartLoading);
	    }
	  },
	  _renderState: function _renderState(state) {
	    switch (state) {
	      case 'success':
	        this._renderOrderComplete();
	        break;
	      case 'payment':
	        this._renderCartPayment();
	        if ($(window).width() > 991) {
	          this._renderMap({
	            animate: false
	          });
	        }
	        break;
	      case 'challenge':
	        this._renderCartPaymentChallenge();
	        break;
	      default:
	        this._renderCartLoading();
	        if (this.options._appChannel.request('cart:get:items:count') > 0) {
	          this._renderCartReview();
	        } else {
	          this._renderCartEmpty();
	        }
	
	        if ($(window).width() > 991) {
	          this._renderMap({
	            animate: true
	          });
	        }
	        break;
	    }
	    if (this.options.showCloseButton) {
	      this.ui.btnClose.show();
	    } else {
	      this.ui.btnClose.hide();
	    }
	  },
	  ChangeState: function ChangeState(options) {
	    // clear errors from options
	    if (this.options.errors !== null) {
	      this.options.errors = null;
	    }
	    if (this.options.errorMessage !== null) {
	      this.options.errorMessage = null;
	    }
	    _.extend(this.options, options);
	    this._renderState(options.state);
	  },
	  onShow: function onShow() {
	    var self = this;
	    this._renderState(this.options.state);
	    this.listenTo(this.options._appChannel, 'cart:validate', function () {
	      self._renderCartLoading();
	    });
	  },
	  onDestroy: function onDestroy() {
	    BaseViews.LayoutView.prototype.onDestroy.call(self);
	  }
	});
	
	module.exports = CartExpandedModal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	__webpack_require__(1028);
	
	var ClickBlockerModal = BaseViews.LayoutView.extend({
	    className: 'fmcy-click-blocker-modal fmcy-plugin-bootstrap',
	    template: __webpack_require__(1061),
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            theme: 'dark',
	            _appChannel: null
	        });
	    },
	    _onWindowResize: function _onWindowResize(event) {
	        this.$el.width($(window).width());
	        this.$el.height($(window).height());
	    },
	    onRender: function onRender() {
	        var self = this;
	        this._onWindowResize();
	        $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
	        BaseViews.LayoutView.prototype.onRender.call(self);
	    },
	    onDestroy: function onDestroy() {
	        $(window).off('resize.' + this.cid);
	        BaseViews.LayoutView.prototype.onDestroy.call(self);
	    }
	});
	
	module.exports = ClickBlockerModal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	__webpack_require__(1029);
	var PickupDeliverySelect = __webpack_require__(703);
	var AgeGate = __webpack_require__(702);
	
	var EntryFlow = BaseViews.LayoutView.extend({
	    className: 'fmcy-plugin-bootstrap fmcy-entry-flow',
	    template: __webpack_require__(1062),
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            _appChannel: null,
	            _menuState: null,
	            skipAgeGate: false,
	            referrer: 'entry',
	            delivery_method: null // local_delivery || 'pickup'
	        });
	    },
	    regions: {
	        currentStepRegion: '.fmcy-entry-flow-step-region'
	    },
	    _onWindowResize: function _onWindowResize(event) {
	        //this.$el.width($(window).width());
	        this.$el.height($(window).height());
	    },
	    _renderPickupDeliverySelect: function _renderPickupDeliverySelect() {
	        var self = this;
	        var pickUpDeliverySelectView = new PickupDeliverySelect({
	            _appChannel: this.options._appChannel,
	            _menuState: this.options._menuState,
	            referrer: this.options.referrer,
	            delivery_method: this.options.delivery_method
	        });
	
	        pickUpDeliverySelectView.on('location:selected', function (model) {
	            self.trigger('close:clicked');
	        });
	
	        this.currentStepRegion.show(pickUpDeliverySelectView);
	    },
	    _renderAgeGate: function _renderAgeGate() {
	        var self = this;
	        var ageGate = new AgeGate({
	            _appChannel: this.options._appChannel
	        });
	
	        ageGate.on('yes:clicked', function () {
	            self._renderPickupDeliverySelect();
	            self.options._appChannel.trigger('age:yes:clicked');
	        });
	
	        this.currentStepRegion.show(ageGate);
	    },
	    onRender: function onRender() {
	        var self = this;
	        this._onWindowResize();
	        $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
	
	        if (this.options.skipAgeGate) {
	            this._renderPickupDeliverySelect();
	        } else {
	            this._renderAgeGate();
	        }
	
	        BaseViews.LayoutView.prototype.onRender.call(self);
	    },
	    onDestroy: function onDestroy() {
	        $(window).off('resize.' + this.cid);
	        BaseViews.LayoutView.prototype.onDestroy.call(self);
	    }
	});
	
	module.exports = EntryFlow;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	__webpack_require__(1030);
	var Button = __webpack_require__(70);
	var CartLocationDisplay = __webpack_require__(91);
	var ShoppingCartIndicator = __webpack_require__(298);
	var SpinnerButton = __webpack_require__(19);
	var BaseViews = __webpack_require__(5);
	var StringUtils = __webpack_require__(9);
	
	var FooterControlBar = BaseViews.LayoutView.extend({
	  _expandedMap: false,
	  template: __webpack_require__(1063),
	  className: 'fmcy-footer-control-bar fmcy-plugin-bootstrap container-fluid',
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      _appChannel: null,
	      _menuState: null,
	      theme: 'dark' // light
	    });
	
	    this.options._appChannel.on('cart:display:errors', function () {
	      self._reActivateShoppingCartActionButton();
	    });
	  },
	  ui: {
	    leftColumn: '#fmcy-footer-bar-left-column',
	    rightColumn: '#fmcy-footer-bar-right-column'
	  },
	  regions: {
	    shoppingCartRightRegion: '.fmcy-footer-bar-right-region',
	    shoppingCartLeftRegion: '.fmcy-footer-bar-left-region'
	  },
	  hide: function hide() {
	    this.$el.hide();
	  },
	  show: function show() {
	    this.$el.show();
	  },
	  _renderCartLocationDisplay: function _renderCartLocationDisplay() {
	    this._cartLocationDisplay = new CartLocationDisplay({
	      _appChannel: this.options._appChannel
	    });
	    this.shoppingCartLeftRegion.show(this._cartLocationDisplay);
	  },
	  _clearLeftRegion: function _clearLeftRegion() {
	    this.shoppingCartLeftRegion.empty();
	  },
	  _renderCheckoutActionButton: function _renderCheckoutActionButton() {
	    var self = this;
	    var checkoutButton = new SpinnerButton.SpinnerButton({
	      label: 'CHECK OUT',
	      enabled: true,
	      theme: Button.THEMES.PRIMARY,
	      onClickedCallback: function onClickedCallback() {
	        self.options._appChannel.trigger('cart:view');
	      }
	    });
	    this.shoppingCartRightRegion.show(checkoutButton);
	  },
	  _renderShoppingCartBackCancelButton: function _renderShoppingCartBackCancelButton(label, action, cancelButtonLocation) {
	    var self = this;
	    this.shoppingCartBackCancelButton = new SpinnerButton.SpinnerButton({
	      label: label,
	      enabled: true,
	      theme: Button.THEMES.PRIMARY,
	      classNames: 'cancel-button',
	      onClickedCallback: function onClickedCallback() {
	        self.shoppingCartBackCancelButton.toggleSpinner(true);
	        self.shoppingCartBackCancelButton.toggledEnabledState(false);
	        self.options._appChannel.trigger(action);
	      }
	    });
	
	    if (cancelButtonLocation == 'right') {
	      this.shoppingCartRightRegion.show(this.shoppingCartBackCancelButton);
	    } else {
	      this.shoppingCartLeftRegion.show(this.shoppingCartBackCancelButton);
	    }
	  },
	  _renderShoppingCartActionButton: function _renderShoppingCartActionButton(label, action) {
	    var self = this;
	    this.shoppingCartActionButton = new SpinnerButton.SpinnerButton({
	      label: label,
	      enabled: true,
	      theme: Button.THEMES.PRIMARY,
	      onClickedCallback: function onClickedCallback() {
	        self.shoppingCartActionButton.toggleSpinner(true);
	        self.shoppingCartActionButton.toggledEnabledState(false);
	        self.options._appChannel.trigger(action);
	      }
	    });
	    this.shoppingCartRightRegion.show(this.shoppingCartActionButton);
	  },
	  _reActivateShoppingCartActionButton: function _reActivateShoppingCartActionButton() {
	    if (this.shoppingCartActionButton) {
	      this.shoppingCartActionButton.toggleSpinner(false);
	      this.shoppingCartActionButton.toggledEnabledState(true);
	    }
	  },
	  _renderShoppingCartIndicator: function _renderShoppingCartIndicator() {
	    this._shoppingCartIndicator = new ShoppingCartIndicator({
	      _appChannel: this.options._appChannel,
	      style: 'expanded',
	      cartCount: this.options._appChannel.request('cart:get:items:count')
	    });
	    this.shoppingCartLeftRegion.show(this._shoppingCartIndicator);
	  },
	  _clearRightRegion: function _clearRightRegion() {
	    this.shoppingCartRightRegion.empty();
	  },
	  _shouldMakeRightColumnFillScreen: function _shouldMakeRightColumnFillScreen() {
	    if ($(window).width() < 992) {
	      return true;
	    } else {
	      return false;
	    }
	  },
	  _setColumnCss: function _setColumnCss(columns) {
	    this.ui.leftColumn.removeClass();
	    this.ui.rightColumn.removeClass();
	    if (columns == 2) {
	      this.ui.leftColumn.addClass('col-xs-6');
	      this.ui.rightColumn.addClass('col-xs-6');
	    } else {
	      this.ui.leftColumn.addClass('col-xs-0 col-md-6');
	      this.ui.rightColumn.addClass('col-xs-12 col-md-6');
	    }
	  },
	  _updateDisplayState: function _updateDisplayState() {
	    var self = this;
	
	    self._clearRightRegion();
	    self._clearLeftRegion();
	    self._setColumnCss(2);
	
	    if (self.options._appChannel.request('active:view:check', 'reviewCart') && self.options._appChannel.request('active:view:check', 'orderSuccess')) {
	      self._renderCartLocationDisplay();
	      self.show();
	      $(document.body).addClass('fmcy-showing-footer-controlbar');
	    } else if (self.options._appChannel.request('active:view:check', 'reviewCart')) {
	
	      var cancelButtonLocation = 'right';
	      if (self.options._appChannel.request('cart:get:items:count') > 0) {
	        cancelButtonLocation = 'left';
	        self._renderShoppingCartActionButton('COMPLETE ORDER', 'cart:validate');
	      }
	
	      if ($(window).width() >= 460) {
	        self._renderShoppingCartBackCancelButton('CONTINUE SHOPPING', 'cart:close', cancelButtonLocation);
	      } else {
	        self._renderShoppingCartBackCancelButton('BACK', 'cart:close', cancelButtonLocation);
	      }
	
	      self.show();
	      $(document.body).addClass('fmcy-showing-footer-controlbar');
	    } else if (self.options._appChannel.request('active:view:check', 'paymentCart')) {
	      self.currentOrderModel = this.options._appChannel.request('cart:get:curent:order');
	      if (self.currentOrderModel && self.currentOrderModel.has('order_total')) {
	        self.cartCost = self.currentOrderModel.get('order_total');
	        self._renderShoppingCartActionButton('<i class="glyphicon glyphicon-lock"></i> PAY ' + StringUtils.currency(self.cartCost), 'cart:pay');
	        // collapse to one column on mobile...
	        if (self._shouldMakeRightColumnFillScreen()) {
	          self._setColumnCss(1);
	        }
	      }
	      self.show();
	      $(document.body).addClass('fmcy-showing-footer-controlbar');
	    } else if (self.options._appChannel.request('active:view:check', 'challengeCart')) {
	      self.hide();
	      $(document.body).removeClass('fmcy-showing-footer-controlbar');
	    } else {
	      var viewShowCheckout = true;
	      if (self.options._appChannel.request('active:view:check', 'sidebar') || !self.options._appChannel.request('active:view:check', 'locationselectmap')) {
	        viewShowCheckout = false;
	      }
	      if (self.options._appChannel.request('cart:get:items:count') > 0 && !viewShowCheckout) {
	        self._renderShoppingCartIndicator();
	        self._renderCheckoutActionButton();
	        self.show();
	        $(document.body).addClass('fmcy-showing-footer-controlbar');
	      } else {
	        self.hide();
	        $(document.body).removeClass('fmcy-showing-footer-controlbar');
	      }
	    }
	  },
	  onRender: function onRender() {
	    var self = this;
	    if (this.options.theme == 'dark') {
	      this.$el.addClass('fmy-footer-bar-dark-theme');
	    }
	    this.listenTo(this.options._appChannel, 'active:view:updated', function (activeViews) {
	      self._updateDisplayState();
	    });
	    this.listenTo(this.options._appChannel, 'cart:items:updated', function () {
	      self._updateDisplayState();
	    });
	    self._updateDisplayState();
	  }
	});
	module.exports = FooterControlBar;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette) {"use strict";
	
	var FooterDynamicRegion = Marionette.Region.extend({
	    constructor: function constructor() {
	        Marionette.Region.prototype.constructor.apply(this, arguments);
	    }
	});
	module.exports = FooterDynamicRegion;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	__webpack_require__(1031);
	var Button = __webpack_require__(70);
	var ShoppingCartIndicator = __webpack_require__(298);
	var SpinnerButton = __webpack_require__(19);
	var FarmBranding = __webpack_require__(167);
	var HamburgerButton = __webpack_require__(458);
	var SearchButton = __webpack_require__(460);
	var ProfileButton = __webpack_require__(459);
	var CategoryTextMenu = __webpack_require__(461);
	var BaseViews = __webpack_require__(5);
	
	var HeaderControlBar = BaseViews.LayoutView.extend({
	  _expandedMap: false,
	  template: __webpack_require__(1064),
	  className: 'fmcy-header-control-bar-kiosk fmcy-plugin-bootstrap container-fluid',
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      _appChannel: null,
	      _menuState: null
	    });
	  },
	  regions: {
	    headerNavSearchRegion: '.fmcy-header-bar-nav-search-region',
	    headerBrandingRegion: '.fmcy-header-branding-region'
	  },
	  ui: {
	    headerNavHamburgerRegion: '.fmcy-header-bar-nav-hamburger-region',
	    headerNavSearchRegion: '.fmcy-header-bar-nav-search-region',
	    joinButton: '.register-button',
	    cannabisButton: '.cannabis-button',
	    cannabisButtonColumn: '.cannabis-button-column',
	    salesButtonColumn: '.sales-button-column',
	    cbdButton: '.cbd-button',
	    cbdButtonColumn: '.cbd-button-column',
	    accessoriesButton: '.accessories-button',
	    accessoriesButtonColumn: '.accessories-button-column'
	  },
	  events: {
	    'click @ui.cannabisButtonColumn': '_cannabisButtonClicked',
	    'click @ui.cbdButtonColumn': '_cbdButtonClicked',
	    'click @ui.salesButtonColumn': '_saleButtonClicked',
	    'click @ui.accessoriesButtonColumn': '_accessoriesButtonClicked'
	  },
	  _resetTabs: function _resetTabs() {
	    this.ui.cannabisButtonColumn.css('backgroundColor', '#000000');
	    this.ui.accessoriesButtonColumn.css('backgroundColor', '#000000');
	  },
	  _cannabisButtonClicked: function _cannabisButtonClicked() {
	    this.options._appChannel.trigger('menu:overlay:view:close');
	
	    this.ui.cannabisButtonColumn.css('backgroundColor', '#00afb4');
	
	    this.options._appChannel.trigger('display:mega:menu', {
	      childView: new CategoryTextMenu({
	        _menuState: this.options._menuState,
	        _appChannel: this.options._appChannel,
	        parentCategorySlug: 'cannabis',
	        mode: 'kiosk',
	        defaultMenuHeight: 900,
	        categories: this.options._menuState.get('menuItemCategories')
	      }),
	      backgroundColor: '#e3e3e2',
	      textColor: '#000000'
	    });
	  },
	  _cbdButtonClicked: function _cbdButtonClicked() {
	    this.options._appChannel.trigger('menu:overlay:view:close');
	    this.options._appChannel.request('load:category', 'cbd-products', 'all', {});
	  },
	  _saleButtonClicked: function _saleButtonClicked() {
	    this.options._appChannel.trigger('menu:overlay:view:close');
	    this.options._appChannel.request('load:category', 'all', null, {
	      weeklysales: true
	    });
	  },
	  _accessoriesButtonClicked: function _accessoriesButtonClicked() {
	    this.options._appChannel.trigger('menu:overlay:view:close');
	
	    this.ui.accessoriesButtonColumn.css('backgroundColor', '#00afb4');
	
	    this.options._appChannel.trigger('display:mega:menu', {
	      childView: new CategoryTextMenu({
	        _menuState: this.options._menuState,
	        _appChannel: this.options._appChannel,
	        parentCategorySlug: 'accessories',
	        mode: 'kiosk',
	        defaultMenuHeight: 900,
	        categories: this.options._menuState.get('menuItemCategories')
	      }),
	      backgroundColor: '#393a3a',
	      textColor: '#ffffff'
	    });
	  },
	  hide: function hide() {
	    this.$el.hide();
	  },
	  show: function show() {
	    this.$el.show();
	  },
	  _renderFarmLogo: function _renderFarmLogo() {
	    var self = this;
	    this._branding = new FarmBranding({
	      style: 'full'
	    });
	    this._branding.on('clicked', function () {
	      self.options._appChannel.trigger('kiosk:show:intro');
	    });
	    this.headerBrandingRegion.show(this._branding);
	  },
	  _renderLocationSelectView: function _renderLocationSelectView() {
	    this.options._appChannel.trigger('menu:overlay:view:close');
	    this.options._appChannel.trigger('location:selection:view', {
	      referrer: 'entry',
	      skipAgeGate: true
	    });
	  },
	  _renderSearchButton: function _renderSearchButton() {
	    var self = this;
	    this._searchButton = new SearchButton({
	      _appChannel: this.options._appChannel,
	      notificationCount: this.options._appChannel.request('orders:ready:count')
	    });
	
	    this.listenTo(this.options._menuState, 'change:searchOpen', function (model) {
	      self._searchButton.toggleIcon(model.get('searchOpen'));
	      if (model.get('searchOpen')) {
	        // note ui
	        self.ui.headerNavSearchRegion.addClass('fmcy-header-bar-nav-sidebar-active');
	      } else {
	        self.ui.headerNavSearchRegion.removeClass('fmcy-header-bar-nav-sidebar-active');
	      }
	    });
	
	    this.headerNavSearchRegion.show(this._searchButton);
	  },
	  serializeData: function serializeData() {
	    return {
	      rootUrl: window.location.protocol + '//' + window.location.hostname,
	      isUserLoggedIn: this.options.isUserLoggedIn
	    };
	  },
	  onRender: function onRender() {
	    var self = this;
	    self._renderFarmLogo();
	
	    this.options._appChannel.on('menu:overlay:view:close', function () {
	      self._resetTabs();
	    });
	  }
	});
	module.exports = HeaderControlBar;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	__webpack_require__(1032);
	var Button = __webpack_require__(70);
	var ShoppingCartIndicator = __webpack_require__(298);
	var SpinnerButton = __webpack_require__(19);
	var FarmBranding = __webpack_require__(167);
	var HamburgerButton = __webpack_require__(458);
	var SearchButton = __webpack_require__(460);
	var ProfileButton = __webpack_require__(459);
	var CategoryTextMenu = __webpack_require__(461);
	var BaseViews = __webpack_require__(5);
	
	var HeaderControlBar = BaseViews.LayoutView.extend({
	  _expandedMap: false,
	  template: __webpack_require__(1065),
	  className: 'fmcy-header-control-bar fmcy-plugin-bootstrap container-fluid',
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      _appChannel: null,
	      _menuState: null
	    });
	  },
	  regions: {
	    headerShoppingCartIndicatorRegion: '.fmcy-header-bar-shopping-cart-indicator-region',
	    headerNavHamburgerRegion: '.fmcy-header-bar-nav-hamburger-region',
	    headerNavSearchRegion: '.fmcy-header-bar-nav-search-region',
	    headerNavProfileRegion: '.fmcy-header-bar-nav-profile-region',
	    headerBrandingRegion: '.fmcy-header-branding-region'
	  },
	  ui: {
	    headerShoppingCartIndicatorRegion: '.fmcy-header-bar-shopping-cart-indicator-region',
	    headerNavHamburgerRegion: '.fmcy-header-bar-nav-hamburger-region',
	    headerNavSearchRegion: '.fmcy-header-bar-nav-search-region',
	    headerNavProfileRegion: '.fmcy-header-bar-nav-profile-region',
	    joinButton: '.register-button',
	    cannabisButton: '.cannabis-button',
	    cannabisButtonColumn: '.cannabis-button-column',
	    cbdButton: '.cbd-button',
	    cbdButtonColumn: '.cbd-button-column',
	    accessoriesButton: '.accessories-button',
	    accessoriesButtonColumn: '.accessories-button-column',
	    locationIndicator: '.fmcy-header-control-bar-location-indicator-text'
	  },
	  events: {
	    'click @ui.joinButton': 'joinButtonClicked',
	    'click @ui.cannabisButtonColumn': '_cannabisButtonClicked',
	    'click @ui.cbdButtonColumn': '_cbdButtonClicked',
	    'click @ui.accessoriesButtonColumn': '_accessoriesButtonClicked',
	    'click @ui.locationIndicator': '_renderLocationSelectView'
	  },
	  joinButtonClicked: function joinButtonClicked() {
	    this.options._appChannel.trigger('menu:overlay:view:close');
	    this.options._appChannel.trigger('show:register:dialog');
	  },
	  _resetTabs: function _resetTabs() {
	    this.ui.cannabisButtonColumn.css('backgroundColor', '#000000');
	    this.ui.accessoriesButtonColumn.css('backgroundColor', '#000000');
	  },
	  _cannabisButtonClicked: function _cannabisButtonClicked() {
	    this.options._appChannel.trigger('menu:overlay:view:close');
	    this.ui.cannabisButtonColumn.css('backgroundColor', '#00afb4');
	    this.options._appChannel.trigger('display:mega:menu', {
	      childView: new CategoryTextMenu({
	        _menuState: this.options._menuState,
	        _appChannel: this.options._appChannel,
	        parentCategorySlug: 'cannabis',
	        categories: this.options._menuState.get('menuItemCategories')
	      }),
	      backgroundColor: '#e3e3e2',
	      textColor: '#000000'
	    });
	  },
	  _cbdButtonClicked: function _cbdButtonClicked() {
	    this.options._appChannel.trigger('menu:overlay:view:close');
	    this.options._appChannel.request('load:category', 'cbd-products', 'all');
	  },
	  _accessoriesButtonClicked: function _accessoriesButtonClicked() {
	    this.options._appChannel.trigger('menu:overlay:view:close');
	    this.ui.accessoriesButtonColumn.css('backgroundColor', '#00afb4');
	    this.options._appChannel.trigger('display:mega:menu', {
	      childView: new CategoryTextMenu({
	        _menuState: this.options._menuState,
	        _appChannel: this.options._appChannel,
	        parentCategorySlug: 'accessories',
	        categories: this.options._menuState.get('menuItemCategories')
	      }),
	      backgroundColor: '#393a3a',
	      textColor: '#ffffff'
	    });
	  },
	  hide: function hide() {
	    this.$el.hide();
	  },
	  show: function show() {
	    this.$el.show();
	  },
	  _hideShoppingCartActionButton: function _hideShoppingCartActionButton() {
	    this.headerShoppingCartIndicatorRegion.empty();
	  },
	  _renderFarmLogo: function _renderFarmLogo() {
	    var self = this;
	    this._branding = new FarmBranding({
	      style: 'full'
	    });
	    this._branding.on('clicked', function () {
	      if ($(window).width() >= 800) {
	        window.stop();
	        $(location).prop('href', window.location.protocol + '//' + window.location.hostname);
	      } else {
	        self._cannabisButtonClicked();
	      }
	    });
	    this.headerBrandingRegion.show(this._branding);
	  },
	  _renderLocationSelectView: function _renderLocationSelectView() {
	    this.options._appChannel.trigger('menu:overlay:view:close');
	    this.options._appChannel.trigger('location:selection:view', {
	      referrer: 'entry',
	      skipAgeGate: true
	    });
	  },
	  _renderHamburgerButton: function _renderHamburgerButton() {
	    var self = this;
	    this._hamburgerButton = new HamburgerButton({
	      _appChannel: this.options._appChannel,
	      notificationCount: this.options._appChannel.request('orders:ready:count')
	    });
	
	    this.listenTo(this.options._menuState, 'change:sideBarOpen', function (model) {
	      self._hamburgerButton.toggleIcon(model.get('sideBarOpen'));
	      if (model.get('sideBarOpen')) {
	        // note ui
	        self.ui.headerNavHamburgerRegion.addClass('fmcy-header-bar-nav-sidebar-active');
	      } else {
	        self.ui.headerNavHamburgerRegion.removeClass('fmcy-header-bar-nav-sidebar-active');
	      }
	    });
	
	    this.headerNavHamburgerRegion.show(this._hamburgerButton);
	  },
	  _renderSearchButton: function _renderSearchButton() {
	    var self = this;
	    this._searchButton = new SearchButton({
	      _appChannel: this.options._appChannel,
	      notificationCount: this.options._appChannel.request('orders:ready:count')
	    });
	
	    this.listenTo(this.options._menuState, 'change:searchOpen', function (model) {
	      self._searchButton.toggleIcon(model.get('searchOpen'));
	      if (model.get('searchOpen')) {
	        // note ui
	        self.ui.headerNavSearchRegion.addClass('fmcy-header-bar-nav-sidebar-active');
	      } else {
	        self.ui.headerNavSearchRegion.removeClass('fmcy-header-bar-nav-sidebar-active');
	      }
	    });
	
	    this.headerNavSearchRegion.show(this._searchButton);
	  },
	  _renderProfileButton: function _renderProfileButton() {
	    var self = this;
	    this._profileButton = new ProfileButton({
	      _appChannel: this.options._appChannel,
	      notificationCount: this.options._appChannel.request('orders:ready:count')
	    });
	
	    this.listenTo(this.options._menuState, 'change:profileOpen', function (model) {
	      self._profileButton.toggleIcon(model.get('profileOpen'));
	      if (model.get('profileOpen')) {
	        // note ui
	        self.ui.headerNavProfileRegion.addClass('fmcy-header-bar-nav-sidebar-active');
	      } else {
	        self.ui.headerNavProfileRegion.removeClass('fmcy-header-bar-nav-sidebar-active');
	      }
	    });
	
	    this.headerNavProfileRegion.show(this._profileButton);
	  },
	  _renderShoppingCartIndicator: function _renderShoppingCartIndicator() {
	    this._shoppingCartIndicator = new ShoppingCartIndicator({
	      _appChannel: this.options._appChannel,
	      cartCount: this.options._appChannel.request('cart:get:items:count')
	    });
	    this.headerShoppingCartIndicatorRegion.show(this._shoppingCartIndicator);
	  },
	  _hideShoppingCartIndicator: function _hideShoppingCartIndicator() {
	    this.headerShoppingCartIndicatorRegion.empty();
	  },
	  _formatShoppingLocationText: function _formatShoppingLocationText() {
	    var location = this.options._appChannel.request('get:filter:location:details');
	    return 'Shopping ' + location.get('name') + ' &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<u>Change</u>';
	  },
	  serializeData: function serializeData() {
	    return {
	      rootUrl: window.location.protocol + '//' + window.location.hostname,
	      isUserLoggedIn: this.options.isUserLoggedIn,
	      shoppingLocationText: this._formatShoppingLocationText()
	    };
	  },
	  onRender: function onRender() {
	    var self = this;
	    self._renderFarmLogo();
	    self._renderShoppingCartIndicator();
	    self._renderHamburgerButton();
	    self._renderSearchButton();
	    self._renderProfileButton();
	
	    this.listenTo(self.options._menuState, 'change:filterLocation', function () {
	      self.ui.locationIndicator.html(self._formatShoppingLocationText());
	    });
	
	    this.options._appChannel.on('menu:overlay:view:close', function () {
	      self._resetTabs();
	    });
	  }
	});
	module.exports = HeaderControlBar;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette) {"use strict";
	
	var HeaderDynamicRegion = Marionette.Region.extend({
	    constructor: function constructor() {
	        Marionette.Region.prototype.constructor.apply(this, arguments);
	    }
	});
	module.exports = HeaderDynamicRegion;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	__webpack_require__(1033);
	var LoaderExpanded = BaseViews.LayoutView.extend({
	    className: 'fmcy-loader-expanded',
	    template: __webpack_require__(1066),
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            theme: 'light'
	        });
	    },
	    regions: {
	        contentRegion: '.fmcy-loader-expanded-content-region'
	    },
	    onRender: function onRender() {
	        var self = this;
	
	        if (this.options.theme == 'dark') {
	            this.$el.addClass('dark');
	        }
	
	        BaseViews.LayoutView.prototype.onRender.call(self);
	    },
	    onDestroy: function onDestroy() {
	        BaseViews.LayoutView.prototype.onDestroy.call(self);
	    }
	});
	
	module.exports = LoaderExpanded;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	__webpack_require__(1034);
	var MegaMenuModal = BaseViews.LayoutView.extend({
	  className: 'fmcy-mega-menu-modal fmcy-plugin-bootstrap',
	  template: __webpack_require__(1067),
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      backgroundColor: '#000000',
	      textColor: '#ffffff',
	      _appChannel: null,
	      _menuState: null,
	      childView: null,
	      animate: false
	    });
	  },
	  ui: {
	    btnClose: '.fmcy-mega-menu-btn-close'
	  },
	  events: {
	    'click @ui.btnClose': 'onCloseClicked'
	  },
	  onCloseClicked: function onCloseClicked() {
	    this.trigger('close:clicked');
	  },
	  regions: {
	    megaMenuChildRegion: '.mega-menu-child-region'
	  },
	  _onWindowResize: function _onWindowResize(event) {
	    this.$el.width($(window).width());
	  },
	  _renderChildView: function _renderChildView() {
	    if (this.options.childView !== null) {
	      this.megaMenuChildRegion.show(this.options.childView);
	    }
	  },
	  onRender: function onRender() {
	    var self = this;
	    this.$el.css({ 'background-color': this.options.backgroundColor });
	    this.$el.css({ 'color': this.options.textColor });
	    this._onWindowResize();
	    this._renderChildView();
	
	    if (this.options.animate == true) {
	      this.$el.css({ 'opacity': 0 });
	      window.gsap.to(this.$el, {
	        opacity: 1,
	        duration: 0.5
	      }).delay(0.01);
	
	      this.ui.btnClose.css({ 'opacity': 0 });
	      window.gsap.to(this.ui.btnClose, {
	        opacity: 1,
	        duration: 0.5
	      }).delay(1);
	    } else {
	      this.$el.css({ 'opacity': 1 });
	      this.ui.btnClose.css({ 'opacity': 1 });
	    }
	
	    $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
	    BaseViews.LayoutView.prototype.onRender.call(self);
	  },
	  onDestroy: function onDestroy() {
	    $(window).off('resize.' + this.cid);
	    BaseViews.LayoutView.prototype.onDestroy.call(self);
	  }
	});
	
	module.exports = MegaMenuModal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	var Subfilters = __webpack_require__(713);
	var MenuSlider = __webpack_require__(710);
	var MenuItems = __webpack_require__(709);
	var MenuProductEntities = __webpack_require__(61);
	var LocationDisplay = __webpack_require__(663);
	
	__webpack_require__(232);
	__webpack_require__(1037);
	var Menu = BaseViews.LayoutView.extend({
	    _itemsView: null,
	    _menuItems: null,
	    _menuItemCategories: null,
	    _menuState: null,
	    template: __webpack_require__(1070),
	    className: 'fmcy-menu container-fluid',
	    regions: {
	        filtersRegion: '.fmcy-menu-filter-region',
	        searchRegion: '.fmcy-menu-search-region',
	        itemsRegion: '.fmcy-menu-items-region',
	        locationDisplayRegion: '.fmcy-menu-location-display-region'
	    },
	    modelEvents: _.extend({}, _.result(BaseViews.LayoutView.prototype, 'modelEvents'), {
	        'change:preSearch': 'preSearch'
	    }),
	    initialize: function initialize(options) {
	        var self = this;
	        self.options = _.defaults(options || {}, {
	            mode: 'menu', // menu|embedded|slider/kiosk,
	            thumbStyle: 'thumb', // thumb|full
	            menuItems: null,
	            locationMapEnabled: false,
	            searchPanelEnabled: false,
	            filterPanelEnabled: false,
	            locationSwitchingEnabled: true,
	            scrollFetchingEnabled: false,
	            shouldEnableOnlinePurhaseCallback: null,
	            redirectURL: null
	        });
	
	        _.bindAll(self, '_onScroll');
	        self._menuState = self.model;
	        self._menuItems = self._menuState.get('menuItems');
	        self._menuItemCategories = self._menuState.get('menuItemCategories');
	
	        self._onScroll = _.throttle(self._onScroll, 100);
	
	        if (!self.options.shouldEnableOnlinePurhaseCallback) {
	            throw new Error('Required menu paramaters not supplied: shouldEnableOnlinePurhaseCallback');
	        }
	
	        self.listenTo(self.options.appChannel, 'product:loaded', function (productModel) {
	            self.hideSearch();
	            self.hideFilters();
	            self.hideItems();
	        });
	    },
	    _onScroll: function _onScroll(event) {
	        var self = this;
	        if (this._menuState.get('displayingExpandedView')) {
	            return;
	        }
	        // need to figure this out better
	        var scrollBottomBuffer = 1000;
	        if ($(window).scrollTop() + $(window).height() > $(document).height() - scrollBottomBuffer) {
	            this.trigger('next:page');
	        }
	
	        if (this.options.filterPanelEnabled) {
	            if ($(window).scrollTop() >= 150) {
	                this.hideFilterPanelDebounce = _.debounce(function () {
	                    self._hideFilterPanel();
	                }, 500, true);
	                this.hideFilterPanelDebounce();
	            } else {
	                this._showFilterPanel();
	            }
	        }
	    },
	    onClose: function onClose() {
	        if (this.options.scrollFetchingEnabled) {
	            $(window).off(this._onScroll);
	        }
	    },
	    preSearch: function preSearch() {
	        if (this._menuState.get('preSearch')) {
	            this._menuState.set({ preSearch: false }, { silent: true });
	            //this.hideProductThumbs();
	        }
	    },
	    _hideFilterPanel: function _hideFilterPanel() {
	        /*
	        this.filtersRegion.$el.css('overflow', 'hidden');
	        Velocity(this.filtersRegion.$el, {
	          height: 37,
	        }, {
	          duration: 250
	        });
	        */
	    },
	    _showFilterPanel: function _showFilterPanel() {
	        var self = this;
	        /*
	        Velocity(this.filtersRegion.$el, {
	          height: '',
	        }, {
	          duration: 250,
	          delay: 250
	        }).animate(self.itemsRegion.$el, {
	                  'padding-top': self.filtersRegion.$el.height(),
	                }, {
	                  duration: 250
	                });
	                */
	    },
	    _renderFilterPanel: function _renderFilterPanel() {
	        var self = this;
	        var filters = new Subfilters({
	            model: self._menuState,
	            appChannel: self.options.appChannel,
	            locations: self.options.locations,
	            showLocationsFilter: false
	        });
	
	        filters.on('product:selected', function (product) {
	            if (product) {
	                self.options.appChannel.request('load:product', product.get('slug'));
	            }
	        });
	
	        function checkLoadingProduct() {
	            if (self._menuState.get('loadingProduct')) {
	                self.hideSearch();
	                self.hideFilters();
	            }
	        }
	
	        checkLoadingProduct();
	
	        filters.listenTo(this._menuState, 'change:loadingProduct', function () {
	            checkLoadingProduct();
	        });
	
	        self.showChildView('filtersRegion', filters);
	
	        this.filtersRegion.$el.on('click', function () {
	            self._showFilterPanel();
	        });
	    },
	    _renderSearch: function _renderSearch() {
	        // legacy search for kiosk...
	    },
	    maybeRenderLocationDisplay: function maybeRenderLocationDisplay() {
	        if (this.options.searchPanelEnabled) {
	            this._renderLocationDisplay();
	        }
	    },
	    _renderLocationDisplay: function _renderLocationDisplay() {
	        this._locationDisplay = new LocationDisplay({
	            _appChannel: this.options.appChannel,
	            _menuState: this._menuState
	        });
	        this.locationDisplayRegion.show(this._locationDisplay);
	    },
	    _renderItems: function _renderItems() {
	        var self = this;
	        function getItemDisplayImageURL(model, size) {
	            if (size) {
	                return model.getProductImageURL(size);
	            } else if ($(window).width() >= 800) {
	                return model.getProductImageURL(MenuProductEntities.PRODUCT_IMAGE_SIZES.MEDIUM);
	            } else {
	                return model.getProductImageURL(MenuProductEntities.PRODUCT_IMAGE_SIZES.THUMB);
	            }
	        }
	        switch (self.options.mode) {
	            case 'slider':
	                self._itemsView = new MenuSlider({
	                    getItemDisplayImageURL: getItemDisplayImageURL,
	                    collection: self._menuItems,
	                    appChannel: self.options.appChannel,
	                    shouldEnableOnlinePurhaseCallback: self.options.shouldEnableOnlinePurhaseCallback
	                });
	                break;
	            default:
	                self._itemsView = new MenuItems({
	                    locations: self.options.appChannel.request('get:locations'),
	                    getItemDisplayImageURL: getItemDisplayImageURL,
	                    collection: self._menuItems,
	                    thumbStyle: self.options.thumbStyle, // full, thumb
	                    isFetching: function isFetching() {
	                        return self._menuState.get('retrievingPageData');
	                    },
	                    _menuState: self._menuState,
	                    appChannel: self.options.appChannel,
	                    locationSwitchingEnabled: self.options.locationSwitchingEnabled,
	                    shouldEnableOnlinePurhaseCallback: self.options.shouldEnableOnlinePurhaseCallback,
	                    showOnlineProductLocations: this.options.appChannel.request('is:user:logged:in'),
	                    showProductLocations: function showProductLocations() {
	                        // Only show product locations on the thumb if showing products from
	                        // All Locations
	                        return self._menuState.get('multiLocationsSupportEnabled') && self._menuState.get('filterLocation') === 'all';
	                    }
	                });
	        }
	
	        self._itemsView.on('thumb:clicked', function (model) {
	            self.options.appChannel.request('load:product', model.get('slug'), null, model);
	        });
	
	        function checkLoadingProduct() {
	            if (self._menuState.get('loadingProduct')) {
	                self.hideItems();
	            }
	        }
	
	        checkLoadingProduct();
	        self._itemsView.listenTo(this._menuState, 'change:loadingProduct', function () {
	            checkLoadingProduct();
	        });
	
	        self.showChildView('itemsRegion', self._itemsView);
	    },
	    maybeShowFilters: function maybeShowFilters() {
	        if (!this.isRendered) {
	            return false;
	        }
	
	        if (this.options.filterPanelEnabled) {
	            this.showFilters();
	        }
	    },
	    showFilters: function showFilters() {
	        var self = this;
	        if (!this.isRendered) {
	            return false;
	        }
	        this.filtersRegion.$el.removeClass('invisible');
	        this.filtersRegion.$el.removeClass('hide');
	        this.filtersRegion.$el.css('width');
	
	        if (this.options.filterPanelEnabled) {
	            /*
	            _.delay(function () {
	              Velocity(self.itemsRegion.$el, {
	                'padding-top': self.filtersRegion.$el.height(),
	              }, {
	                duration: 250
	              });
	            }, 250);
	            */
	            // init controller
	            /*
	            if (this.scrollMagicController == null) {
	              this.scrollMagicController = new ScrollMagic.Controller();
	               // build scene
	              this.scrollMagicScene = new ScrollMagic.Scene({triggerElement: '.fmcy-menu-filter-region', offset: 350})
	                      // trigger a velocity opaticy animation
	                      //.setVelocity('.fmcy-menu-filter-region', {height: 37}, {duration: 400})
	                      .setPin('.fmcy-menu-filter-region')
	                      .addIndicators() // add indicators (requires plugin)
	                      .addTo(this.scrollMagicController);
	            }
	            */
	        }
	    },
	    hideFilters: function hideFilters() {
	        if (!this.isRendered) {
	            return false;
	        }
	        this.filtersRegion.$el.addClass('invisible');
	    },
	    maybeShowSearch: function maybeShowSearch() {
	        if (!this.isRendered) {
	            return false;
	        }
	
	        if (this.options.searchPanelEnabled) {
	            this.showSearch();
	        }
	    },
	    showSearch: function showSearch() {
	        if (!this.isRendered) {
	            return false;
	        }
	        this.searchRegion.$el.removeClass('invisible');
	        this.searchRegion.$el.removeClass('hide');
	    },
	    hideSearch: function hideSearch() {
	        if (!this.isRendered) {
	            return false;
	        }
	        this.searchRegion.$el.addClass('invisible');
	    },
	
	    showItems: function showItems() {
	        if (!this.isRendered) {
	            return false;
	        }
	        this.itemsRegion.$el.removeClass('invisible');
	        this.itemsRegion.$el.removeClass('hide');
	    },
	    hideItems: function hideItems() {
	        if (!this.isRendered) {
	            return false;
	        }
	        this.itemsRegion.$el.addClass('invisible');
	    },
	    hideProductThumbs: function hideProductThumbs() {
	        var self = this;
	        if (this._menuItems && this._menuItems.length) {
	            this._menuItems.each(function (model) {
	                if (self._itemsView) {
	                    var thumbView = self._itemsView.children.findByModel(model);
	                    if (thumbView) {
	                        thumbView.hideThumb();
	                    }
	                }
	            });
	        }
	    },
	    serializeData: function serializeData() {
	        return {
	            options: this.options,
	            menuState: this._menuState.toJSON()
	        };
	    },
	    onRender: function onRender() {
	        var self = this;
	        this._renderItems();
	        if (this.options.searchPanelEnabled) {
	            this._renderSearch();
	        }
	
	        this.$el.addClass('fmcy-menu-mode-' + this.options.mode);
	        this.$el.addClass('fmcy-menu-thumbstyle-' + this.options.thumbStyle);
	
	        if (this.options.filterPanelEnabled) {
	            this._renderFilterPanel();
	            /*
	            $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
	            _.delay(function () {
	              Velocity(self.itemsRegion.$el, {
	                'padding-top': self.filtersRegion.$el.height(),
	              }, {
	                duration: 250,
	              });
	            }, 150);
	            */
	        }
	
	        if (this.options.scrollFetchingEnabled) {
	            $(window).scroll(this._onScroll);
	        }
	
	        BaseViews.LayoutView.prototype.onRender.call(self);
	    },
	    _onWindowResize: function _onWindowResize(event) {
	        /*
	        Velocity(this.itemsRegion.$el, {
	          'padding-top': this.filtersRegion.$el.height(),
	        }, {
	          duration: 250,
	        });
	        */
	    },
	    onDestroy: function onDestroy() {
	        $(window).off('resize.' + this.cid);
	        BaseViews.LayoutView.prototype.onDestroy.call(self);
	    }
	});
	module.exports = Menu;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $, Backbone) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	var MenuItemPricesLocationTable = __webpack_require__(704);
	var MenuItemPrices = __webpack_require__(108);
	
	var AvailableAtLocations = __webpack_require__(129);
	var VideosGroup = __webpack_require__(716);
	var ThumbnailSelector = __webpack_require__(708);
	var PhotoSwiper = __webpack_require__(705);
	var PotencyDisplay = __webpack_require__(79);
	var FavouriteButton = __webpack_require__(130);
	
	__webpack_require__(1035);
	var UIUtils = __webpack_require__(145);
	
	var MenuItemExpanded = BaseViews.LayoutView.extend({
	  _menuItemPrices: null,
	  _DISPLAY_PRODUCT_TAG_FOR_CATEGORIES: ['hash', 'cbd'],
	  className: 'fmcy-menu-item-expanded',
	  template: __webpack_require__(1068),
	  ui: {
	    btnClose: '.fmcy-menu-item-btn-close',
	    imageSml: '.fmcy-menu-image',
	    itemImage: '.fmcy-menu-item-thumb-image',
	    strainAttribute: '.fmcy-item-strain-attribute',
	    ratingAttribute: '.fmcy-item-rating-attribute',
	    imageMagnifyIdicator: '.fmcy-menu-item-icon-magnify-region',
	    effectsRow: '.fmcy-menu-effects-row',
	    medicalRow: '.fmcy-menu-medical-row',
	    strainRow: '.fmcy-menu-item-strain-title-row',
	    imageLarge: '.fmcy-menu-item-thumb-image-large',
	    columnContainer: '.fmcy-menu-column-container',
	    magnifyButton: '.fmcy-menu-item-magnify-icon',
	    fmcyMenuWrapper: '.fmcy-menu-wrapper',
	    fmcyMenuContainer: '.fmcy-menu-container',
	    fmcyInfoContainer: '.fmcy-menu-product-info-container',
	    fmcyDescriptionText: '.fmcy-item-description-text-description',
	    vendorIcon: '.fmcy-vendor-icon-region'
	  },
	  events: {
	    'click @ui.btnClose': 'closeClicked',
	    'mousemove @ui.imageContainer': 'magnifyImage'
	  },
	  regions: {
	    pricesRegion: '.fmcy-item-prices-region',
	    addToCartRegion: '.fmcy-item-add-to-cart-region',
	    availableAtLocationsRegion: '.fmcy-available-at-locations-region',
	    vendorIconRegion: '.fmcy-vendor-icon-region',
	    favouriteButtonRegion: '.fmcy-favourite-button-region',
	    tagBarRegion: '.fmcy-tag-bar-region',
	    imageRegion: '.fmcy-menu-item-image-region',
	    imageLargeRegion: '.fmcy-menu-item-large-image-region',
	    videosGroupRegion: '.fmcy-item-videos-group-region',
	    thumbnailSelectorRegion: '.fmcy-menu-item-thumb-selector-region',
	    potencyRegion: '.fmcy-potency-region'
	  },
	  initialize: function initialize(options) {
	    var self = this;
	    self.options = _.defaults(options || {}, {
	      customClassName: '',
	      onlinePurchaseEnabled: false,
	      showProductLocations: false,
	      imagePreloading: true,
	      filterLocation: null,
	      shouldRenderProductLocations: this._shouldRenderProductLocations()
	    });
	    if (self.options.imagePreloading) {
	      var createjs = __webpack_require__(74);
	      createjs.LoadQueue.loadTimeout = self.options.imagePreloadTimeout;
	      self._preloadQueue = new createjs.LoadQueue(false);
	    }
	  },
	  serializeData: function serializeData() {
	    var nameIconColumnsHtml = '';
	    var strain = this.model.get('strain');
	    if (strain) {
	      strain = strain.toUpperCase();
	    }
	
	    var nameContainsStrainName = false;
	    if (this.model.get('itemName').toUpperCase().indexOf(strain) !== -1) {
	      nameContainsStrainName = true;
	      // hide strain if the strain name is alread within the title...
	      strain = false;
	    }
	
	    return {
	      itemName: this.model.get('itemName'),
	      itemDescription: this.model.get('itemDescriptionHtml') || this.model.get('itemDescription') || '',
	      strain: this.model.getStrainGroupCode() || '',
	      rating: this.model.get('rating') || 0,
	      mode: this.options.mode,
	      effectsAttrs: this.getEffectsAttrsString(),
	      medicalAttrs: this.getMedicalAttrsString(),
	      strainTitleImgClass: this.getStrainTitleImageClassName(),
	      bannerClassName: this.getBannerClassName(),
	      onSale: this.model.isOnSale(),
	      productLabResults: this.model.get('lab_results'),
	      strainName: strain,
	      onlinePurchaseEnabled: this.options.onlinePurchaseEnabled,
	      isNew: this.model.get('is_new') === true,
	      shouldRenderProductLocations: this.options.shouldRenderProductLocations,
	      hasVideos: this.model.get('videos').length > 0
	    };
	  },
	  _renderPotency: function _renderPotency() {
	    this.potencyRegion.show(new PotencyDisplay({
	      model: this.model,
	      filterLocation: this.options.filterLocation
	    }));
	  },
	  _renderPhotoSwiper: function _renderPhotoSwiper() {
	    var self = this;
	    this._photoSwiper = new PhotoSwiper({
	      collection: this.model.get('images')
	    });
	
	    this._photoSwiper.on('photo:swiper:slide:change', function (model) {
	      self._setImagePrimary(model);
	    });
	
	    this.showChildView('imageRegion', this._photoSwiper);
	  },
	  _renderPrices: function _renderPrices() {
	    if (this.options.mode === 'kiosk') {
	      this._menuItemPrices = new MenuItemPrices({
	        menuItemModel: this.model,
	        collection: this.model.get('variants'),
	        size: 'large',
	        displayAddToCarToolTip: true,
	        onSale: this.model.isOnSale(),
	        hideOutOfStockVariation: true,
	        filterLocation: this.options.appChannel.request('get:filter:location'),
	        appChannel: this.options.appChannel,
	        onlinePurchaseEnabled: this.options.onlinePurchaseEnabled,
	        menuItemPriceLayoutSinglePrice: 'promotion',
	        align: 'left'
	      });
	    } else {
	      this._menuItemPrices = new MenuItemPricesLocationTable({
	        menuItemModel: this.model,
	        variantCollection: this.model.get('variants'),
	        locations: this._getProductLocations(true),
	        size: 'large',
	        hideOutOfStockVariation: false,
	        filterLocation: this.options.filterLocation,
	        onSale: this.model.isOnSale(),
	        appChannel: this.options.appChannel,
	        menuItemPriceLayoutSinglePrice: 'stacked',
	        align: 'left'
	      });
	    }
	    this.showChildView('pricesRegion', this._menuItemPrices);
	  },
	  _maybeRenderVideos: function _maybeRenderVideos() {
	    if (this.model.get('videos').length > 0) {
	      this.videosGroup = new VideosGroup({
	        videos: this.model.get('videos'),
	        appChannel: this.options.appChannel
	      });
	      this.videosGroupRegion.show(this.videosGroup);
	    }
	  },
	  _setImagePrimary: function _setImagePrimary(model) {
	    this.model.get('images').each(function (image) {
	      if (parseInt(image.get('id')) !== parseInt(model.get('id'))) {
	        image.set('is_primary', '0');
	      } else {
	        image.set('is_primary', '1');
	      }
	    });
	  },
	  _maybeRenderImageThumbnails: function _maybeRenderImageThumbnails() {
	    var self = this;
	    if (this.model.get('images').length > 1) {
	      this.thumbnailSelector = new ThumbnailSelector({
	        collection: this.model.get('images'),
	        appChannel: this.options.appChannel
	      });
	      this.thumbnailSelector.on('thumb:clicked', function (model) {
	        self._setImagePrimary(model);
	        self._maybeRenderImage();
	      });
	      this.thumbnailSelectorRegion.show(this.thumbnailSelector);
	    }
	  },
	  _maybeRenderImage: function _maybeRenderImage() {
	    var self = this,
	        zoomEnabled,
	        imageSize;
	    if (UIUtils.isPhone()) {
	      zoomEnabled = false;
	      imageSize = 'medium';
	    } else {
	      zoomEnabled = true;
	      imageSize = 'large';
	    }
	
	    function setImage(imageURL) {
	      self.ui.itemImage.css('background-image', 'url(' + imageURL + ')');
	    }
	
	    function hideImage() {
	      self.ui.itemImage.css('background-image', 'none');
	    }
	
	    if (zoomEnabled) {
	      self.ui.itemImage.on('click', function () {
	        self.options.appChannel.request('load:product:zoomer', self.model);
	      });
	    }
	
	    self.ui.magnifyButton.on('click', function () {
	      self.options.appChannel.request('load:product:zoomer', self.model);
	    });
	
	    var displayImageURL;
	
	    displayImageURL = self.model.getProductImageURL(imageSize);
	
	    if (!displayImageURL) {
	      displayImageURL = self.options.noImageAvailableIcon;
	    }
	
	    if (self.options.imagePreloading) {
	
	      self.imageRegion.show(new (__webpack_require__(20))({
	        message: ''
	      }));
	
	      self.imageLargeRegion.show(new (__webpack_require__(20))({
	        message: ''
	      }));
	      hideImage();
	
	      var handleFileLoadError = function handleFileLoadError(event) {
	        if (!self.isRendered) {
	          return false;
	        }
	        if (event.item.id === self.model.id) {
	          console.log('File load error occurred: ', event);
	          self._preloadQueue.removeAllEventListeners('fileload');
	          self._preloadQueue.removeAllEventListeners('error');
	          self.imageRegion.empty();
	          self.imageLargeRegion.empty();
	          setImage(self.options.noImageAvailableIcon);
	        }
	      };
	
	      var handleFileLoaded = function handleFileLoaded(event) {
	        if (!self.isRendered) {
	          return false;
	        }
	        if (event.item.id === self.model.id) {
	          self._preloadQueue.removeAllEventListeners('fileload');
	          self._preloadQueue.removeAllEventListeners('error');
	          self.imageRegion.empty();
	          self.imageLargeRegion.empty();
	          if ((UIUtils.isPhone() || UIUtils.isTablet() || UIUtils.isAccessoriesKioskWidth()) && self.model.get('images').length > 1) {
	            self._renderPhotoSwiper();
	          } else {
	            setImage(event.item.src);
	          }
	        }
	      };
	
	      self._preloadQueue.on('error', handleFileLoadError);
	      self._preloadQueue.on('fileload', handleFileLoaded);
	      self._preloadQueue.loadFile({
	        id: self.model.id,
	        src: displayImageURL
	      });
	    } else {
	      setImage(displayImageURL);
	    }
	  },
	  _maybeRenderFavouriteButton: function _maybeRenderFavouriteButton() {
	    var self = this;
	    if (this.options.mode == 'menu' && this.options.isUserLoggedIn || this.options.mode == 'embedded' && this.options.isUserLoggedIn) {
	      self.options.appChannel.request('is:favourite', self.model).then(function (response) {
	        var favouriteButton = new FavouriteButton({
	          isFavourite: response
	        });
	        favouriteButton.on('toggle:favourite', function (isFavourite) {
	          self.model.set('isFavourite', isFavourite);
	          self.options.appChannel.request('toggle:favourite', self.model, isFavourite).then(function (response) {});
	        });
	        self.favouriteButtonRegion.show(favouriteButton);
	      });
	    }
	  },
	  onRender: function onRender() {
	    var self = this;
	    if (!self.model.getStrainGroupCode()) {
	      self.ui.strainAttribute.css({ display: 'none' });
	    }
	
	    if (self.model.isOrganic()) {
	      self.$el.addClass('fmcy-product-is-organic');
	    }
	
	    if (self.model.isBCGrown()) {
	      self.$el.addClass('fmcy-product-is-bc-grown');
	    }
	
	    if (self.model.isFarmExclusive()) {
	      self.$el.addClass('fmcy-product-is-farm-exclusive');
	    }
	
	    if (this.options.mode) {
	      self.$el.addClass('fmcy-product-expanded-mode-' + this.options.mode);
	    }
	    if (self.model.isVegan()) {
	      self.$el.addClass('fmcy-product-is-vegan');
	    }
	
	    if (self.model.isHighCBD()) {
	      self.$el.addClass('fmcy-product-high-cbd');
	    }
	
	    if (self.model.isHighCBNCBG()) {
	      self.$el.addClass('fmcy-product-high-cbn-cbg');
	    }
	
	    var strain = self.model.getStrainGroupCode();
	    if (strain) {
	      self.$el.addClass(strain);
	    }
	
	    if (!self.model.get('rating') || self.model.get('rating') === '0') {
	      self.ui.ratingAttribute.css({ display: 'none' });
	    }
	    self.$el.css({ 'min-height': $(window).height() + 'px' });
	
	    self.$el.addClass(self.options.customClassName);
	
	    if (self.model.get('theme') === 'dark') {
	      self.$el.addClass('fmcy-product-tile-theme-dark');
	    }
	
	    var vendor = this.model.get('vendor');
	    if (vendor) {
	      var brandIcon = new (__webpack_require__(65))({
	        imageURL: vendor.get('image_medium_url_' + this.model.get('theme') + '_theme'),
	        displayNoImageAvailableIcon: false
	      });
	
	      brandIcon.$el.addClass('fmcy-vendor-icon');
	      this.vendorIconRegion.show(brandIcon);
	    }
	
	    self._renderPrices();
	    self._maybeRenderImage();
	    self._maybeRenderAvailableAtLocations();
	    self._maybeRenderVideos();
	    self._maybeRenderImageThumbnails();
	    self._renderPotency();
	    self._maybeRenderFavouriteButton();
	    self.ui.effectsRow.hide();
	    self.ui.medicalRow.hide();
	    self.ui.strainRow.hide();
	
	    if (this._shouldRenderTagBar()) {
	      this.$el.addClass('fmcy-product-tile-showing-tag-bar');
	      this.tagBarRegion.show(new (__webpack_require__(80))({
	        showOnSaleTag: this.model.isOnSale(),
	        showOnClearanceTag: this.model.isOnClearance(),
	        productTagText: this._getProductTag(),
	        showCBDTag: this.model.isHighCBD(),
	        showCBNCBGTag: this.model.isHighCBNCBG(),
	        showBcGrownTag: this.model.isBCGrown(),
	        showFarmExclusiveTag: this.model.isFarmExclusive(),
	        showOrganicTag: this.model.isOrganic(),
	        showVeganTag: this.model.isVegan()
	      }));
	    }
	
	    BaseViews.LayoutView.prototype.onRender.call(self);
	  },
	  onShow: function onShow() {
	    this._onWindowResize();
	    $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
	  },
	  _shouldRenderTagBar: function _shouldRenderTagBar() {
	    return this.model.isOnSale() || this.model.isOnClearance() || this.model.isOrganic() || this.model.isBCGrown() || this.model.isFarmExclusive() || this.model.isVegan() || this.model.isHighCBD() || this.model.isHighCBNCBG() || this._getProductTag();
	  },
	  _getProductTag: function _getProductTag() {
	    var strainGroup = this.model.getStrainGroupCode();
	    if (this.options.productTag) {
	      return this.options.productTag;
	    } else if (this.model.get('promotion_headline') && !this.model.isOnClearance() && this.model.get('promotion_headline').toLowerCase() !== 'clearance' && this.model.get('promotion_headline').toLowerCase() !== 'weekly') {
	      return this.model.get('promotion_headline');
	    } else if (strainGroup) {
	      return strainGroup;
	    } else {
	      var productTag = '';
	      var categorySlug;
	      var x = 0;
	      var categories = this.model.get('categories');
	      var categoriesArr;
	      if (categories instanceof Backbone.Collection) {
	        categoriesArr = categories.toJSON();
	      } else {
	        categoriesArr = categories;
	      }
	      while (x <= this._DISPLAY_PRODUCT_TAG_FOR_CATEGORIES.length - 1 && !productTag) {
	        categorySlug = this._DISPLAY_PRODUCT_TAG_FOR_CATEGORIES[x];
	        if (_.findWhere(categoriesArr, { slug: categorySlug })) {
	          productTag = categorySlug;
	        }
	        x++;
	      }
	      return productTag;
	    }
	  },
	  _maybeRenderAvailableAtLocations: function _maybeRenderAvailableAtLocations() {
	    if (!this.options.shouldRenderProductLocations) {
	      return;
	    }
	
	    this.availableAtLocationsRegion.show(new AvailableAtLocations({
	      collection: this._getProductLocations(),
	      align: 'left'
	    }));
	  },
	  closeClicked: function closeClicked() {
	    var self = this;
	    if (this.addToCartBarView && this.addToCartBarView.$el) {
	      this.addToCartBarView.hide();
	    }
	    self.trigger('close:clicked');
	  },
	  _onWindowResize: function _onWindowResize(event) {
	
	    var bottomBuffer = 200;
	    this.ui.imageLarge.height($(window).height() - bottomBuffer);
	    this.ui.imageLarge.width($(window).width() / 2);
	    this.ui.imageLarge.css('right', 0);
	    //990
	    if ($(window).width() >= 1081) {
	      this.ui.fmcyInfoContainer.css('min-height', this.ui.imageLarge.height() - this.ui.vendorIcon.height() + 100);
	    }
	
	    if (this.model.get('videos').length === 0) {
	      this.ui.fmcyMenuWrapper.height(this.ui.fmcyInfoContainer.height() + this.ui.itemImage.height() + bottomBuffer);
	    }
	  },
	  onDestroy: function onDestroy() {
	    $(window).off('resize.' + this.cid);
	  }
	});
	_.extend(MenuItemExpanded.prototype, __webpack_require__(131));
	module.exports = MenuItemExpanded;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11), __webpack_require__(4)))

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Backbone, $) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	var ProductZoomer = __webpack_require__(707);
	var ProductZoomToggle = __webpack_require__(706);
	var UIUtils = __webpack_require__(145);
	var FarmBranding = __webpack_require__(167);
	
	__webpack_require__(1036);
	var ProductZoomerModal = BaseViews.LayoutView.extend({
	    className: 'fmcy-product-zoomer-modal',
	    template: __webpack_require__(1069),
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            theme: 'light'
	        });
	    },
	    ui: {
	        btnClose: '.fmcy-menu-item-btn-close'
	    },
	    triggers: {
	        'click @ui.btnClose': 'close:clicked'
	    },
	    regions: {
	        productZoomerRegion: '.fmcy-item-zoomer-region',
	        brandingRegion: '.fmcy-zoomer-branding-region'
	    },
	    _renderBranding: function _renderBranding() {
	        var branding = new FarmBranding();
	        this.brandingRegion.show(branding);
	    },
	    _renderZoomControls: function _renderZoomControls() {
	        var self = this,
	            zoomEnabled,
	            imageSize;
	
	        if (UIUtils.isPhone()) {
	            zoomEnabled = true;
	            imageSize = 'large';
	        } else {
	            zoomEnabled = true;
	            imageSize = 'xlarge';
	        }
	
	        var productZoomModel = new Backbone.Model({
	            zoomEnabled: zoomEnabled,
	            imageSize: imageSize
	        });
	
	        var productZoomer = new ProductZoomer({
	            model: productZoomModel,
	            theme: self.model.get('theme'),
	            getImageBySize: function getImageBySize(size) {
	                var imageURL = self.model.getProductImageURL(size);
	                switch (size) {
	                    case 'xlarge':
	                        return {
	                            url: imageURL,
	                            w: 5000,
	                            h: 3334
	                        };
	                    case 'large':
	                        return {
	                            url: imageURL,
	                            w: 2500,
	                            h: 1667
	                        };
	                    case 'medium':
	                        return {
	                            url: imageURL,
	                            w: 1024,
	                            h: 683
	                        };
	                    case 'thumb':
	                        return {
	                            url: imageURL,
	                            w: 510,
	                            h: 340
	                        };
	                }
	            }
	        });
	
	        self.productZoomerRegion.show(productZoomer);
	    },
	    _onPopState: function _onPopState(event) {
	        this.trigger('close:clicked');
	    },
	    _onWindowKeyUp: function _onWindowKeyUp(event) {
	        if (event.keyCode == 27) {
	            this.trigger('close:clicked');
	        }
	    },
	    onRender: function onRender() {
	        var self = this;
	        this._renderZoomControls();
	        this._renderBranding();
	        $(window).on('keyup.' + this.cid, _.bind(this._onWindowKeyUp, this));
	        $(window).on('popstate.' + this.cid, _.bind(this._onPopState, this));
	        BaseViews.LayoutView.prototype.onRender.call(self);
	    },
	    onDestroy: function onDestroy() {
	        $(window).off('keyup.' + this.cid);
	        $(window).off('popstate.' + this.cid);
	        BaseViews.LayoutView.prototype.onDestroy.call(self);
	    }
	});
	
	module.exports = ProductZoomerModal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4), __webpack_require__(11)))

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	
	__webpack_require__(1038);
	var PageLoading = BaseViews.LayoutView.extend({
	    _menuState: null,
	    className: 'fmcy-page-loading',
	    template: __webpack_require__(1071),
	    ui: {
	        spinner: '.fmcy-spinner'
	    },
	    regions: {
	        spinnerRegion: '.fmcy-spinner-region'
	    },
	    showLoader: function showLoader() {
	        var self = this;
	
	        if (!self.isRendered) {
	            return;
	        }
	
	        if (self.options.style === 'style1') {
	            self._renderSpinnerStyle1();
	        }
	
	        window.gsap.to(this.$el, {
	            opacity: 1,
	            duration: 0.5,
	            translateY: 0,
	            onStart: function onStart() {
	                self.$el.removeClass('hide');
	            }
	        });
	    },
	    hideLoader: function hideLoader() {
	        var self = this;
	
	        if (!self.isRendered) {
	            return;
	        }
	
	        window.gsap.to(this.$el, {
	            opacity: 0,
	            duration: 0.5,
	            translateY: '+100',
	            onComplete: function onComplete() {
	                if (!self.isRendered) {
	                    return;
	                }
	                if (self.options.style === 'style1') {
	                    self.spinnerRegion.empty();
	                }
	                self.$el.addClass('hide');
	            }
	        });
	    },
	    initialize: function initialize(options) {
	        var self = this;
	        self.options = _.defaults(options || {}, {
	            style: 'style1', // style1
	            theme: 'light' // light || dark
	        });
	
	        self._menuState = self.model;
	        self._menuState.on('change:retrievingPageData', function () {
	            self._checkRetrievingPageData();
	        });
	    },
	    _checkRetrievingPageData: function _checkRetrievingPageData() {
	        if (!this.isRendered) {
	            return false;
	        }
	
	        if (this._menuState.get('retrievingPageData')) {
	            this.showLoader();
	        } else {
	            this.hideLoader();
	        }
	    },
	    onBeforeShow: function onBeforeShow() {
	        if (this.options.backgroundColor) {
	            this.$el.css('background', this.options.backgroundColor);
	        }
	        if (this.options.theme) {
	            this.$el.addClass('page-loading-theme-' + this.options.theme);
	        }
	    },
	    _renderSpinnerStyle1: function _renderSpinnerStyle1() {
	        this.spinnerRegion.show(new (__webpack_require__(20))({
	            message: ''
	        }));
	    },
	    onRender: function onRender() {
	        this._checkRetrievingPageData();
	    }
	});
	
	module.exports = PageLoading;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 927 */,
/* 928 */,
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	__webpack_require__(1040);
	var Modal = BaseViews.LayoutView.extend({
	  className: 'fmcy-modal',
	  template: __webpack_require__(1073),
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      theme: 'dark',
	      title: 'Sorry product cannot be found',
	      description: 'The product potentially may have been discontinued. Please try searching above'
	    });
	  },
	  ui: {
	    btnClose: '.fmcy-menu-item-btn-close'
	  },
	  triggers: {
	    'click @ui.btnClose': 'close:clicked',
	    'click': 'close:clicked'
	  },
	  regions: {
	    contentRegion: '.fmcy-modal-content-region'
	  },
	  _onPopState: function _onPopState(event) {
	    this.trigger('close:clicked');
	  },
	  _onWindowKeyUp: function _onWindowKeyUp(event) {
	    if (event.keyCode == 27) {
	      this.trigger('close:clicked');
	    }
	  },
	  _onWindowResize: function _onWindowResize(event) {
	    this.$el.width($(window).outerWidth());
	    this.$el.height($(window).outerHeight());
	  },
	  onRender: function onRender() {
	    var self = this;
	    $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
	    $(window).on('keyup.' + this.cid, _.bind(this._onWindowKeyUp, this));
	    $(window).on('popstate.' + this.cid, _.bind(this._onPopState, this));
	    this._onWindowResize();
	    BaseViews.LayoutView.prototype.onRender.call(self);
	  },
	  onDestroy: function onDestroy() {
	    $(window).off('keyup.' + this.cid);
	    $(window).off('popstate.' + this.cid);
	    $(window).off('resize.' + this.cid);
	    BaseViews.LayoutView.prototype.onDestroy.call(self);
	  },
	  serializeData: function serializeData() {
	    return {
	      title: this.options.title,
	      description: this.options.description
	    };
	  }
	});
	
	module.exports = Modal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 930 */,
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	var MenuProductEntities = __webpack_require__(61);
	var ProductVendorEntities = __webpack_require__(42);
	__webpack_require__(1042);
	
	var SearchModal = BaseViews.LayoutView.extend({
	    _menuState: null,
	    _menuItemCategories: null,
	    className: 'fmcy-search-modal fmcy-plugin-bootstrap',
	    template: __webpack_require__(1075),
	    initialize: function initialize(options) {
	        var self = this;
	        this.options = _.defaults(options || {}, {
	            theme: 'dark',
	            isUserLoggedIn: false,
	            customerData: null,
	            _appChannel: null,
	            _menuState: null,
	            searchType: 'product' //product, vendor...
	        });
	
	        self._menuState = self.options._menuState;
	        self._menuItemCategories = self._menuState.get('menuItemCategories');
	    },
	    regions: {
	        searchRegion: '.fmcy-search-region'
	    },
	    ui: {
	        searchMenuWrapper: '.fmcy-search-menu-wrapper',
	        searchMenuInnerArea: '.fmcy-search-menu-inner-area'
	    },
	    _renderSearch: function _renderSearch() {
	        var DropdownListInner = __webpack_require__(33);
	        var self = this;
	        var productsCollection = new MenuProductEntities.PageableMenuProductsCollection(null, {
	            productCategories: self._menuItemCategories,
	            queryParams: {
	                remove_out_stock_variation: false
	            }
	        });
	        var list = new DropdownListInner({
	            collection: productsCollection,
	            displayAttr: 'searchTitle',
	            valueAttr: 'id',
	            iconURLAttr: 'preview_image',
	            placeholder: 'What are you looking for?',
	            allowClear: true,
	            width: '100%',
	            openAndFocused: true,
	            closeOnSelect: false,
	            dropdownCssClass: 'fmcy-menu-search-dropdown',
	            minimumResultsForSearch: 3,
	            minimumInputLength: 1,
	            inputTooShortMessage: 'Enter a product name or brand',
	            onSelectedCallback: function onSelectedCallback(val, model) {
	                if (model) {
	                    self.options._appChannel.request('load:product:url', model.get('slug'));
	                    self.options._appChannel.trigger('menu:search:view:close');
	                }
	            }
	        });
	
	        list.listenTo(self._menuState, 'change:displayedProduct', function () {
	            if (!self._menuState.get('displayedProduct')) {
	                list.val('');
	            }
	        });
	        this.searchRegion.show(list);
	    },
	    _renderVendorSearch: function _renderVendorSearch() {
	        var self = this;
	        var vendorCollection = new ProductVendorEntities.PageableProductVendorsCollection(self.options._appChannel.request('get:vendors').toJSON(), {
	            queryParams: {
	                filterHideOnMenuFilter: true,
	                filterOutOfStock: true
	            }
	        });
	
	        self.vendorDropdownList = new (__webpack_require__(33))({
	            collection: vendorCollection,
	            dropdownCssClass: 'fmcy-menu-search-dropdown',
	            suppressSearch: false,
	            width: '100%',
	            openAndFocused: true,
	            inputFocused: false,
	            displayAttr: 'name',
	            iconURLAttr: 'image_thumb_url_light_theme',
	            valueAttr: 'id',
	            allowClear: true,
	            placeholder: 'Select Brand',
	            onSelectedCallback: function onSelectedCallback(vendorId, model) {
	                self.options._appChannel.trigger('search:options:changed', {
	                    categorySlug: 'all',
	                    subCategorySlug: 'all',
	                    filterVendor: vendorId
	                });
	                self.options._appChannel.trigger('menu:search:view:close');
	            }
	        });
	        this.searchRegion.show(self.vendorDropdownList);
	    },
	    _onWindowResize: function _onWindowResize(event) {
	        if ($(window).width() > 1100) {
	            var rightPos = ($(window).width() - 1100) / 2;
	            this.ui.searchMenuWrapper.css('right', rightPos);
	            this.ui.searchMenuInnerArea.css('width', 410);
	        } else {
	            this.ui.searchMenuWrapper.css('right', 0);
	            this.ui.searchMenuInnerArea.css('width', $(window).width());
	        }
	    },
	    serializeData: function serializeData() {
	        var displayName = null;
	
	        if (this.options.customerData !== null) {
	            displayName = this.options.customerData.get('display_name');
	        }
	
	        return {
	            rootUrl: window.location.protocol + '//' + window.location.hostname,
	            isUserLoggedIn: this.options.isUserLoggedIn,
	            displayName: displayName
	        };
	    },
	    onRender: function onRender() {
	        var self = this;
	        if (this.options.searchType == 'vendor') {
	            this._renderVendorSearch();
	        } else {
	            this._renderSearch();
	        }
	        this._onWindowResize();
	        $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
	        BaseViews.LayoutView.prototype.onRender.call(self);
	    },
	    onDestroy: function onDestroy() {
	        $(window).off('resize.' + this.cid);
	        BaseViews.LayoutView.prototype.onDestroy.call(self);
	    }
	});
	
	module.exports = SearchModal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	__webpack_require__(1043);
	var ActiveOrders = __webpack_require__(714);
	var SidebarModal = BaseViews.LayoutView.extend({
	  className: 'fmcy-sidebar-modal fmcy-plugin-bootstrap',
	  template: __webpack_require__(1076),
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      theme: 'dark',
	      isUserLoggedIn: false,
	      customerData: null,
	      _appChannel: null
	    });
	  },
	  ui: {
	    loginButton: '.login-button',
	    joinButton: '.register-button',
	    displayName: '.display-name',
	    sideBarMenuWrapper: '.fmcy-side-bar-menu-wrapper',
	    sideBarLeftArea: '.fmcy-side-bar-menu-left-area'
	  },
	  events: {
	    'click @ui.loginButton': 'loginButtonClicked',
	    'click @ui.joinButton': 'joinButtonClicked'
	  },
	  joinButtonClicked: function joinButtonClicked() {
	    this.options._appChannel.trigger('menu:sidebar:view');
	    this.options._appChannel.trigger('show:register:dialog');
	  },
	  loginButtonClicked: function loginButtonClicked() {
	    this.options._appChannel.trigger('menu:sidebar:view');
	    this.options._appChannel.trigger('show:login:dialog');
	  },
	  regions: {
	    myOrdersRegion: '.fmcy-customer-my-orders-region'
	  },
	  _renderActiveOrders: function _renderActiveOrders() {
	    this._activeOrders = new ActiveOrders({
	      collection: this.options._appChannel.request('customer:get:data').get('orders'),
	      _appChannel: this.options._appChannel
	    });
	    this.myOrdersRegion.show(this._activeOrders);
	  },
	  _onWindowResize: function _onWindowResize(event) {
	    if ($(window).width() > 1100) {
	      var rightPos = ($(window).width() - 1100) / 2;
	      this.ui.sideBarMenuWrapper.css('right', rightPos);
	    } else {
	      this.ui.sideBarMenuWrapper.css('right', 0);
	      this.ui.sideBarLeftArea.width($(window).width());
	    }
	  },
	  serializeData: function serializeData() {
	    var displayName = null;
	
	    if (this.options.customerData !== null) {
	      displayName = this.options.customerData.get('first_name');
	      this.options.customerData.on('change:is_club_member', function () {
	        // show badge....
	      });
	    }
	
	    return {
	      rootUrl: window.location.protocol + '//' + window.location.hostname,
	      isUserLoggedIn: this.options.isUserLoggedIn,
	      displayName: displayName
	    };
	  },
	  onRender: function onRender() {
	    var self = this;
	    if (this.options.isUserLoggedIn == true) {
	      this._renderActiveOrders();
	    }
	    this._onWindowResize();
	    $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
	
	    this.listenTo(this.options._appChannel, 'orders:updated', function () {
	      self._renderActiveOrders();
	    });
	
	    if (this.options.isUserLoggedIn == true && this.options.customerData) {
	      this.listenTo(this.options.customerData, 'change:display_name', function () {
	        self.ui.displayName.html(displayName);
	      });
	    }
	
	    BaseViews.LayoutView.prototype.onRender.call(self);
	  },
	  onDestroy: function onDestroy() {
	    $(window).off('resize.' + this.cid);
	    BaseViews.LayoutView.prototype.onDestroy.call(self);
	  }
	});
	
	module.exports = SidebarModal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {'use strict';
	
	var BaseViews = __webpack_require__(5);
	var VideoPlayer = __webpack_require__(149);
	__webpack_require__(1044);
	var VideoExpandedModal = BaseViews.LayoutView.extend({
	  className: 'fmcy-video-expanded-modal',
	  template: __webpack_require__(1077),
	  initialize: function initialize(options) {
	    var self = this;
	    this.options = _.defaults(options || {}, {
	      theme: 'dark',
	      collection: null,
	      closeAtEndOfVideo: true
	    });
	  },
	  ui: {
	    btnClose: '.fmcy-menu-item-btn-close'
	  },
	  triggers: {
	    'click @ui.btnClose': 'close:clicked'
	  },
	  regions: {
	    videoRegion: '.fmcy-video-region'
	  },
	  _onPopState: function _onPopState(event) {
	    this.trigger('close:clicked');
	  },
	  _onWindowKeyUp: function _onWindowKeyUp(event) {
	    if (event.keyCode == 27) {
	      this.trigger('close:clicked');
	    }
	  },
	  _renderVideo: function _renderVideo() {
	    var self = this;
	    this._videoPlayer = new VideoPlayer({
	      videoUrl: this.model.get('url'),
	      width: '100%',
	      size: 'scale'
	    });
	    this._videoPlayer.on('videoplayer:ended', function () {
	      if (self.options.closeAtEndOfVideo) {
	        self.trigger('close:clicked');
	      }
	    });
	    this.videoRegion.show(this._videoPlayer);
	  },
	  _onWindowResize: function _onWindowResize(event) {
	    this._videoPlayer.setWidth($(window).outerWidth());
	    this._videoPlayer.setHeight($(window).outerHeight());
	  },
	  onRender: function onRender() {
	    this._renderVideo();
	    var self = this;
	    $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
	    $(window).on('keyup.' + this.cid, _.bind(this._onWindowKeyUp, this));
	    $(window).on('popstate.' + this.cid, _.bind(this._onPopState, this));
	    BaseViews.LayoutView.prototype.onRender.call(self);
	  },
	  onDestroy: function onDestroy() {
	    $(window).off('keyup.' + this.cid);
	    $(window).off('popstate.' + this.cid);
	    $(window).off('resize.' + this.cid);
	    BaseViews.LayoutView.prototype.onDestroy.call(self);
	  }
	});
	
	module.exports = VideoExpandedModal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(11)))

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1045);
	var BaseViews = __webpack_require__(5);
	var FarmBranding = __webpack_require__(167);
	
	var KioskIntro = BaseViews.LayoutView.extend({
	  className: 'fmcy-plugin-bootstrap fmcy-kiosk-intro-overlay',
	  template: __webpack_require__(1078),
	  regions: {
	    logoRegion: '.kiosk-intro-overlay-f-logo-region'
	  },
	  ui: {
	    contentWrapper: '.kiosk-intro-overlay-content-wrapper',
	    categoryIcon: '.kiosk-menu-intro-cat-icon'
	  },
	  events: {
	    'click @ui.categoryIcon': 'onClick'
	  },
	  onClick: function onClick(event) {
	    if (event.target.id) {
	      this.trigger('menu:show:category', event.target.id);
	    }
	  },
	  _renderBranding: function _renderBranding() {
	    var branding = new FarmBranding({
	      style: 'full'
	    });
	    this.logoRegion.show(branding);
	  },
	  onRender: function onRender() {
	    this._renderBranding();
	  }
	});
	module.exports = KioskIntro;

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1046);
	var BaseViews = __webpack_require__(5);
	var Countdown = __webpack_require__(700);
	var DateUtils = __webpack_require__(10);
	var FarmBranding = __webpack_require__(167);
	var SessionTimeoutOverlay = BaseViews.LayoutView.extend({
	  className: 'fmcy-session-timeout-overlay',
	  template: __webpack_require__(1079),
	  regions: {
	    countdownRegion: '.session-timeout-overlay-countdown-region',
	    logoRegion: '.session-timeout-overlay-f-logo-region'
	  },
	  ui: {
	    contentWrapper: '.session-timeout-overlay-content-wrapper'
	  },
	  events: {
	    'click': 'onClick'
	  },
	  onClick: function onClick() {
	    this.trigger('close:clicked');
	  },
	  _renderCountdown: function _renderCountdown() {
	    var self = this;
	    this._countDown = new Countdown({
	      elapse: false,
	      startTimestampMs: DateUtils.getNowTimestampMs() + 30000
	    });
	    this._countDown.on('finished', function () {
	      self.trigger('finished');
	    });
	    this.countdownRegion.show(this._countDown);
	  },
	  _renderBranding: function _renderBranding() {
	    var branding = new FarmBranding({
	      style: 'full'
	    });
	    this.logoRegion.show(branding);
	  },
	  onRender: function onRender() {
	    this._renderBranding();
	    this._renderCountdown();
	  }
	});
	module.exports = SessionTimeoutOverlay;

/***/ },
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-cart-expanded-modal {\n  font-family: \"bebasneue\", \"Arial\", sans-serif;\n  overflow-x: hidden;\n  background-color: #000; }\n  .fmcy-cart-expanded-modal .container-fluid {\n    padding-right: 0px !important;\n    padding-left: 0px !important; }\n  .fmcy-cart-expanded-modal .row.no-gutters {\n    margin-right: 0;\n    margin-left: 0; }\n    .fmcy-cart-expanded-modal .row.no-gutters > [class^=\"col-\"],\n    .fmcy-cart-expanded-modal .row.no-gutters > [class*=\" col-\"] {\n      padding-right: 0;\n      padding-left: 0; }\n  .fmcy-cart-expanded-modal .fmcy-location-map-region {\n    position: fixed;\n    top: 99px;\n    left: -15px; }\n  .fmcy-cart-expanded-modal .fmcy-cart-step-region {\n    z-index: 999;\n    position: relative; }\n  .fmcy-cart-expanded-modal .fmcy-menu-item-btn-close {\n    cursor: pointer;\n    background-image: url(" + escape(__webpack_require__(189)) + ");\n    background-repeat: no-repeat;\n    background-position: top right;\n    background-size: cover;\n    width: 32px;\n    height: 32px;\n    z-index: 1000;\n    position: fixed;\n    right: 28px;\n    top: 110px;\n    opacity: 1; }\n\n@media only screen and (max-width: 1100px) {\n  .fmcy-cart-expanded-modal .fmcy-location-map-region {\n    top: 99px; }\n  .fmcy-cart-expanded-modal .fmcy-menu-item-btn-close {\n    top: 91px; } }\n\nBODY.admin-bar .fmcy-cart-expanded-modal .fmcy-location-map-region {\n  top: 131px !important; }\n\nBODY.admin-bar .fmcy-cart-expanded-modal .fmcy-menu-item-btn-close {\n  top: 142px !important; }\n\n@media only screen and (max-width: 1100px) {\n  BODY.admin-bar .fmcy-cart-expanded-modal .fmcy-location-map-region {\n    top: 131px !important; }\n  BODY.admin-bar .fmcy-cart-expanded-modal .fmcy-menu-item-btn-close {\n    top: 123px !important; } }\n", ""]);
	
	// exports


/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-click-blocker-modal {\n  background-color: #000; }\n", ""]);
	
	// exports


/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-entry-flow-modal, .fmcy-entry-flow {\n  background-color: #1c1c1c; }\n\n.fmcy-entry-flow {\n  overflow-y: scroll; }\n\n@media only screen and (min-width: 600px) {\n  .fmcy-entry-flow-step-region-wrapper {\n    position: absolute;\n    margin: auto;\n    width: 500px;\n    height: 500px;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0; }\n  .fmcy-entry-flow-step-region {\n    width: 500px;\n    height: 500px; }\n  .fmcy-delivery-select-continue-button-bar,\n  .fmcy-age-gate-button-bar {\n    position: absolute !important;\n    background-color: #1c1c1c !important; }\n  .fmcy-entry-flow {\n    background-color: #000000 !important; }\n  .fmcy-entry-flow-step-region {\n    background-color: #1c1c1c !important; } }\n", ""]);
	
	// exports


/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-footer-control-bar {\n  background-color: #fff;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  position: fixed;\n  height: 74px;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  background-color: #fff;\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 0 6px rgba(0, 0, 0, 0.7);\n  z-index: 9999; }\n  .fmcy-footer-control-bar.fmy-footer-bar-dark-theme {\n    background-color: #000; }\n  .fmcy-footer-control-bar .fmcy-footer-control-bar-inner {\n    margin: auto !important;\n    max-width: 1070px;\n    font-size: 90%;\n    color: #000; }\n  .fmcy-footer-control-bar .btn-default {\n    letter-spacing: 1px !important;\n    position: relative;\n    padding: .3em 1em;\n    border: 2px solid;\n    -webkit-border-radius: 3px;\n    -moz-border-radius: 3px;\n    border-radius: 3px;\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 160%;\n    line-height: 1.7em !important; }\n  .fmcy-footer-control-bar .btn-primary {\n    width: 100%;\n    margin-top: 10px;\n    color: #ffffff !important;\n    border-color: #4cb8be !important;\n    letter-spacing: 1px !important;\n    background-color: #4cb8be !important;\n    position: relative;\n    border: 2px solid;\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 160%;\n    line-height: 1.7em !important; }\n    .fmcy-footer-control-bar .btn-primary.cancel-button {\n      border-color: #1f1e1e !important;\n      background-color: #1f1e1e !important; }\n  @media only screen and (max-width: 400px) {\n    .fmcy-footer-control-bar #fmcy-footer-bar-left-column, .fmcy-footer-control-bar #fmcy-footer-bar-right-column {\n      padding: 2px !important; }\n      .fmcy-footer-control-bar #fmcy-footer-bar-left-column .tl-spinner-button, .fmcy-footer-control-bar #fmcy-footer-bar-right-column .tl-spinner-button {\n        padding: 6px !important; } }\n", ""]);
	
	// exports


/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-header-control-bar-kiosk {\n  background-color: #000;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  position: fixed;\n  height: 110px;\n  width: 100%;\n  top: 0;\n  background-color: #000;\n  z-index: 5000; }\n  .fmcy-header-control-bar-kiosk.fmcy-header-bar-dark-theme {\n    background-color: #000; }\n  .fmcy-header-control-bar-kiosk .fmcy-header-bar-left-region {\n    line-height: 70px; }\n  .fmcy-header-control-bar-kiosk .fmcy-header-bar-left-column {\n    position: relative; }\n  .fmcy-header-control-bar-kiosk .fmcy-header-bar-right-column {\n    position: relative; }\n  .fmcy-header-control-bar-kiosk .fmcy-header-bar-nav-search-region {\n    position: absolute;\n    top: 12px;\n    right: 20px;\n    height: 74px;\n    width: 54px; }\n    .fmcy-header-control-bar-kiosk .fmcy-header-bar-nav-search-region.fmcy-header-bar-nav-sidebar-active {\n      background-color: #2e302f; }\n    .fmcy-header-control-bar-kiosk .fmcy-header-bar-nav-search-region .fmcy-search-button-icon {\n      top: 18px;\n      right: 11px;\n      position: absolute; }\n  .fmcy-header-control-bar-kiosk .fmcy-header-branding-region {\n    position: absolute;\n    left: 20px;\n    top: 30px; }\n  .fmcy-header-control-bar-kiosk .fmcy-header-bar-shopping-cart-indicator-region {\n    position: absolute;\n    right: 235px;\n    top: 26px; }\n  .fmcy-header-control-bar-kiosk .fmcy-header-control-bar-location-indicator-wrapper {\n    background-color: #75777a; }\n    .fmcy-header-control-bar-kiosk .fmcy-header-control-bar-location-indicator-wrapper .fmcy-header-control-bar-location-indicator-container {\n      max-width: 1079px; }\n      .fmcy-header-control-bar-kiosk .fmcy-header-control-bar-location-indicator-wrapper .fmcy-header-control-bar-location-indicator-container .fmcy-header-control-bar-location-indicator {\n        height: 25px;\n        font-size: 10px;\n        letter-spacing: 1px;\n        font-weight: bold;\n        color: #fff;\n        line-height: 25px;\n        text-transform: uppercase;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        cursor: pointer; }\n        .fmcy-header-control-bar-kiosk .fmcy-header-control-bar-location-indicator-wrapper .fmcy-header-control-bar-location-indicator-container .fmcy-header-control-bar-location-indicator .fmcy-header-control-bar-location-indicator-inner {\n          text-align: left;\n          padding-left: 28px;\n          font-weight: bold; }\n  .fmcy-header-control-bar-kiosk .fmcy-header-control-bar-inner {\n    margin: auto !important;\n    font-size: 90%;\n    max-width: 1079px;\n    color: #000;\n    position: relative; }\n    .fmcy-header-control-bar-kiosk .fmcy-header-control-bar-inner .fmcy-header-bar-menu-items {\n      position: absolute;\n      left: 200px;\n      width: 100%;\n      top: 0;\n      max-width: 811px; }\n      .fmcy-header-control-bar-kiosk .fmcy-header-control-bar-inner .fmcy-header-bar-menu-items .fmcy-header-bar-menu-items-inner .fmcy-header-bar-menu-item-column {\n        height: 109px;\n        min-width: 200px;\n        text-align: center;\n        padding-top: 39px;\n        cursor: pointer;\n        display: inline-block; }\n      .fmcy-header-control-bar-kiosk .fmcy-header-control-bar-inner .fmcy-header-bar-menu-items a {\n        cursor: pointer; }\n      .fmcy-header-control-bar-kiosk .fmcy-header-control-bar-inner .fmcy-header-bar-menu-items .fmcy-menu-button-item {\n        display: inline-block;\n        font-family: \"bebasneue\", \"Arial\", sans-serif;\n        letter-spacing: 1px;\n        color: #fff;\n        font-weight: normal;\n        font-style: normal;\n        text-transform: none;\n        line-height: 1.4;\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n        speak: none;\n        min-width: 100%;\n        font-size: 30px;\n        padding-left: 8px;\n        padding-right: 8px; }\n  .fmcy-header-control-bar-kiosk .btn-default {\n    letter-spacing: 1px !important;\n    position: relative;\n    padding: .3em 1em;\n    border: 2px solid;\n    -webkit-border-radius: 3px;\n    -moz-border-radius: 3px;\n    border-radius: 3px;\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 160%;\n    line-height: 1.7em !important; }\n  .fmcy-header-control-bar-kiosk .btn-primary {\n    width: 100%;\n    margin-top: 10px;\n    color: #ffffff !important;\n    border-color: #4cb8be !important;\n    letter-spacing: 1px !important;\n    background-color: #4cb8be !important;\n    position: relative;\n    border: 2px solid;\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 160%;\n    line-height: 1.7em !important; }\n", ""]);
	
	// exports


/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-header-control-bar {\n  background-color: #000;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  position: fixed;\n  height: 99px;\n  width: 100%;\n  top: 0;\n  background-color: #000;\n  z-index: 5000; }\n  .fmcy-header-control-bar.fmcy-header-bar-dark-theme {\n    background-color: #000; }\n  .fmcy-header-control-bar .fmcy-header-bar-left-region {\n    line-height: 70px; }\n  .fmcy-header-control-bar .fmcy-header-bar-left-column {\n    position: relative; }\n  .fmcy-header-control-bar .fmcy-header-bar-right-column {\n    position: relative; }\n  .fmcy-header-control-bar .fmcy-header-bar-nav-hamburger-region {\n    position: absolute;\n    top: 0px;\n    right: 160px;\n    height: 74px;\n    width: 54px; }\n    .fmcy-header-control-bar .fmcy-header-bar-nav-hamburger-region.fmcy-header-bar-nav-sidebar-active {\n      background-color: #2e302f; }\n    .fmcy-header-control-bar .fmcy-header-bar-nav-hamburger-region .fmcy-hamburger-button-icon {\n      top: 18px;\n      right: 11px;\n      position: absolute; }\n  .fmcy-header-control-bar .fmcy-header-bar-nav-search-region {\n    position: absolute;\n    top: 0px;\n    right: 272px;\n    height: 74px;\n    width: 54px; }\n    .fmcy-header-control-bar .fmcy-header-bar-nav-search-region.fmcy-header-bar-nav-sidebar-active {\n      background-color: #2e302f; }\n    .fmcy-header-control-bar .fmcy-header-bar-nav-search-region .fmcy-search-button-icon {\n      top: 18px;\n      right: 11px;\n      position: absolute; }\n  .fmcy-header-control-bar .fmcy-header-bar-nav-profile-region {\n    display: none;\n    position: absolute;\n    top: 0px;\n    right: 260px;\n    height: 74px;\n    width: 60px; }\n    .fmcy-header-control-bar .fmcy-header-bar-nav-profile-region.fmcy-header-bar-nav-sidebar-active {\n      background-color: #2e302f; }\n    .fmcy-header-control-bar .fmcy-header-bar-nav-profile-region .fmcy-profile-button-icon {\n      top: 18px; }\n  .fmcy-header-control-bar .fmcy-header-branding-region {\n    position: absolute;\n    left: 15px;\n    top: 7px; }\n  .fmcy-header-control-bar .fmcy-header-bar-shopping-cart-indicator-region {\n    position: absolute;\n    right: 235px;\n    top: 26px; }\n  @media only screen and (max-width: 1100px) {\n    .fmcy-header-control-bar .fmy-branding-logo-full {\n      height: 40px; } }\n  @media only screen and (max-width: 1100px) {\n    .fmcy-header-control-bar .fmcy-header-bar-nav-hamburger-region {\n      right: 0px;\n      width: 40px; }\n      .fmcy-header-control-bar .fmcy-header-bar-nav-hamburger-region .fmcy-hamburger-button-icon {\n        top: 9px;\n        right: 4px; }\n    .fmcy-header-control-bar .fmcy-header-bar-shopping-cart-indicator-region {\n      right: 58px;\n      top: 12px; }\n    .fmcy-header-control-bar .fmcy-header-bar-nav-search-region {\n      right: 97px;\n      width: 40px; }\n      .fmcy-header-control-bar .fmcy-header-bar-nav-search-region .fmcy-search-button-icon {\n        top: 8px;\n        right: 4px; }\n    .fmcy-header-control-bar .fmcy-header-bar-nav-profile-region {\n      right: 68px; }\n      .fmcy-header-control-bar .fmcy-header-bar-nav-profile-region .fmcy-profile-button-icon {\n        top: 2px; }\n    .fmcy-header-control-bar .fmcy-header-branding-region {\n      top: 7px; } }\n  .fmcy-header-control-bar .fmcy-header-control-bar-location-indicator-wrapper {\n    background-color: #75777a; }\n    .fmcy-header-control-bar .fmcy-header-control-bar-location-indicator-wrapper .fmcy-header-control-bar-location-indicator-container {\n      max-width: 1100px; }\n      .fmcy-header-control-bar .fmcy-header-control-bar-location-indicator-wrapper .fmcy-header-control-bar-location-indicator-container .fmcy-header-control-bar-location-indicator {\n        height: 25px;\n        font-size: 10px;\n        letter-spacing: 1px;\n        font-weight: bold;\n        color: #fff;\n        line-height: 25px;\n        text-transform: uppercase;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        cursor: pointer; }\n        .fmcy-header-control-bar .fmcy-header-control-bar-location-indicator-wrapper .fmcy-header-control-bar-location-indicator-container .fmcy-header-control-bar-location-indicator .fmcy-header-control-bar-location-indicator-inner {\n          text-align: left;\n          padding-left: 28px;\n          font-weight: bold; }\n  .fmcy-header-control-bar .fmcy-header-control-bar-inner {\n    margin: auto !important;\n    font-size: 90%;\n    max-width: 1100px;\n    color: #000;\n    position: relative; }\n    .fmcy-header-control-bar .fmcy-header-control-bar-inner .fmcy-header-bar-menu-items {\n      position: absolute;\n      left: 164px;\n      width: 100%;\n      top: 0;\n      max-width: 588px; }\n      .fmcy-header-control-bar .fmcy-header-control-bar-inner .fmcy-header-bar-menu-items .fmcy-header-bar-menu-items-inner .fmcy-header-bar-menu-item-column {\n        height: 73px;\n        min-width: 140px;\n        text-align: center;\n        padding-top: 22px;\n        cursor: pointer;\n        display: inline-block; }\n      .fmcy-header-control-bar .fmcy-header-control-bar-inner .fmcy-header-bar-menu-items a {\n        cursor: pointer; }\n      .fmcy-header-control-bar .fmcy-header-control-bar-inner .fmcy-header-bar-menu-items .fmcy-menu-button-item {\n        display: inline-block;\n        font-family: \"bebasneue\", \"Arial\", sans-serif;\n        letter-spacing: 1px;\n        color: #fff;\n        font-weight: normal;\n        font-style: normal;\n        text-transform: none;\n        line-height: 1.4;\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n        speak: none;\n        min-width: 100%;\n        font-size: 22px;\n        padding-left: 8px;\n        padding-right: 8px; }\n    @media only screen and (max-width: 1100px) {\n      .fmcy-header-control-bar .fmcy-header-control-bar-inner .fmcy-header-control-bar {\n        height: 110px; } }\n    @media only screen and (max-width: 1100px) {\n      .fmcy-header-control-bar .fmcy-header-control-bar-inner .fmcy-header-bar-menu-items {\n        left: 0px;\n        width: 100%;\n        top: 54px;\n        max-width: 100%;\n        background-color: #000; }\n        .fmcy-header-control-bar .fmcy-header-control-bar-inner .fmcy-header-bar-menu-items .fmcy-header-bar-menu-item-column {\n          width: 24%;\n          text-align: center;\n          border-top: solid 2px #141414;\n          border-left: solid 2px #141414;\n          border-right: solid 2px #141414; }\n        .fmcy-header-control-bar .fmcy-header-control-bar-inner .fmcy-header-bar-menu-items .fmcy-menu-button-item {\n          font-size: 18px;\n          padding-left: 5px;\n          padding-right: 5px; }\n        .fmcy-header-control-bar .fmcy-header-control-bar-inner .fmcy-header-bar-menu-items .fmcy-header-bar-menu-items-inner .fmcy-header-bar-menu-item-column {\n          min-width: 0px;\n          height: 30px;\n          padding-top: 5px;\n          padding-left: 0px !important;\n          padding-right: 0px !important;\n          display: inline-block; } }\n    @media only screen and (max-width: 430px) {\n      .fmcy-header-control-bar .fmcy-header-control-bar-inner .fmcy-header-bar-menu-items .fmcy-menu-button-item {\n        font-size: 12px;\n        padding-top: 2px;\n        padding-left: 5px;\n        padding-right: 5px; } }\n  .fmcy-header-control-bar .btn-default {\n    letter-spacing: 1px !important;\n    position: relative;\n    padding: .3em 1em;\n    border: 2px solid;\n    -webkit-border-radius: 3px;\n    -moz-border-radius: 3px;\n    border-radius: 3px;\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 160%;\n    line-height: 1.7em !important; }\n  .fmcy-header-control-bar .btn-primary {\n    width: 100%;\n    margin-top: 10px;\n    color: #ffffff !important;\n    border-color: #4cb8be !important;\n    letter-spacing: 1px !important;\n    background-color: #4cb8be !important;\n    position: relative;\n    border: 2px solid;\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 160%;\n    line-height: 1.7em !important; }\n\nBODY.admin-bar .fmcy-header-control-bar {\n  top: 32px !important; }\n\n@media only screen and (max-width: 782px) {\n  BODY.admin-bar .fmcy-header-control-bar {\n    top: 46px !important; } }\n", ""]);
	
	// exports


/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-loader-expanded {\n  background-color: #ffffff;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0; }\n  .fmcy-loader-expanded.dark {\n    background-color: #000000; }\n  .fmcy-loader-expanded .fmcy-loader-expanded-default-content-wrapper {\n    display: table;\n    margin: auto;\n    height: 80vh;\n    padding: 10px; }\n  .fmcy-loader-expanded .fmcy-loader-expanded-default-content {\n    max-width: 400px;\n    text-align: center;\n    display: table-cell;\n    vertical-align: middle; }\n", ""]);
	
	// exports


/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-mega-menu-modal {\n  min-height: 100px; }\n  .fmcy-mega-menu-modal .fmcy-mega-menu-btn-close {\n    cursor: pointer;\n    background-image: url(" + escape(__webpack_require__(991)) + ");\n    background-repeat: no-repeat;\n    background-position: top right;\n    background-size: cover;\n    width: 32px;\n    height: 32px;\n    z-index: 1000;\n    position: fixed;\n    right: 28px;\n    top: 106px;\n    opacity: 0; }\n  .fmcy-mega-menu-modal .mega-menu-child-region {\n    border-top: solid 3px #00afb4; }\n\nbody.fmcy-showing-footer-controlbar .mega-menu-child-region {\n  padding-bottom: 110px; }\n\n@media only screen and (max-width: 1100px) {\n  .fmcy-mega-menu-modal .fmcy-mega-menu-btn-close {\n    top: 120px;\n    right: 20px; } }\n\nBODY.admin-bar .fmcy-mega-menu-modal .fmcy-mega-menu-btn-close {\n  top: 138px; }\n\n@media only screen and (max-width: 782px) {\n  BODY.admin-bar .fmcy-mega-menu-modal .fmcy-mega-menu-btn-close {\n    top: 164px; } }\n\n@media only screen and (max-width: 1100px) {\n  BODY.admin-bar .fmcy-mega-menu-modal .fmcy-mega-menu-btn-close {\n    top: 151px; } }\n", ""]);
	
	// exports


/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-menu-item-expanded {\n  font-size: 3vw;\n  line-height: 3vw;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  width: 100%; }\n  .fmcy-menu-item-expanded .fmcy-menu-item-thumb-selector-region {\n    position: absolute;\n    top: 220px;\n    right: 40px;\n    width: 70px;\n    z-index: 2; }\n  .fmcy-menu-item-expanded .fmcy-item-expanded-videos-container {\n    width: 100%;\n    margin: auto; }\n  .fmcy-menu-item-expanded .fmcy-item-expanded-videos-container-inner {\n    width: 100%;\n    max-width: 1400px; }\n    @media only screen and (min-width: 960px) {\n      .fmcy-menu-item-expanded .fmcy-item-expanded-videos-container-inner {\n        padding: 30px;\n        padding-top: 50px; } }\n  .fmcy-menu-item-expanded.fmcy-product-tile-theme-dark .fmcy-item-expanded-videos-container-inner {\n    background-color: #444545; }\n  .fmcy-menu-item-expanded.fmcy-product-tile-theme-dark .fmcy-item-expanded-videos-container {\n    background-color: #444545; }\n  @media only screen and (min-width: 1079px) {\n    .fmcy-menu-item-expanded {\n      font-size: 1vw;\n      line-height: 1vw; } }\n  .fmcy-menu-item-expanded .fmcy-menu-item-col-no-padding {\n    padding-left: 0px !important;\n    padding-right: 0px !important; }\n  @media only screen and (max-width: 1100px) {\n    .fmcy-menu-item-expanded .fmcy-menu-item-col-no-padding-mobile {\n      padding-left: 0px !important;\n      padding-right: 0px !important; } }\n  .fmcy-menu-item-expanded .fmcy-menu-item-thumb-image {\n    height: 25vw;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center; }\n  @media only screen and (min-width: 1100px) {\n    .fmcy-menu-item-expanded .fmcy-menu-item-thumb-image {\n      min-height: 600px;\n      background-size: cover;\n      background-repeat: no-repeat;\n      background-position: left; } }\n  @media only screen and (max-width: 1100px) {\n    .fmcy-menu-item-expanded .fmcy-menu-item-thumb-image {\n      height: 70vw; } }\n  .fmcy-menu-item-expanded .fmcy-menu-product-info-container {\n    padding-left: 0px;\n    padding-right: 0px; }\n  @media only screen and (min-width: 1100px) {\n    .fmcy-menu-item-expanded .fmcy-menu-item-thumb-image:hover {\n      cursor: zoom-in; }\n    .fmcy-menu-item-expanded .fmcy-menu-product-info-container {\n      padding-top: 10px;\n      padding-left: 50px !important; }\n    .fmcy-menu-item-expanded .fmcy-menu-column-container {\n      margin-top: 2px;\n      padding-right: 0px;\n      padding-left: 0px; }\n      .fmcy-menu-item-expanded .fmcy-menu-column-container .fmcy-menu-column-container-col {\n        padding: 0px; } }\n  .fmcy-menu-item-expanded .fmcy-menu-item-strain-title-row {\n    background-color: #fff; }\n    .fmcy-menu-item-expanded .fmcy-menu-item-strain-title-row .fmcy-menu-item-strain-title {\n      background-repeat: no-repeat;\n      height: 30px;\n      background-size: contain;\n      background-position: center;\n      text-align: center;\n      margin-top: 18px; }\n    .fmcy-menu-item-expanded .fmcy-menu-item-strain-title-row .fmcy-menu-item-thumb-category-indica-title {\n      background-image: url(" + escape(__webpack_require__(782)) + "); }\n    .fmcy-menu-item-expanded .fmcy-menu-item-strain-title-row .fmcy-menu-item-thumb-category-sativa-title {\n      background-image: url(" + escape(__webpack_require__(783)) + "); }\n    .fmcy-menu-item-expanded .fmcy-menu-item-strain-title-row .fmcy-menu-item-thumb-category-hybrid-title {\n      background-image: url(" + escape(__webpack_require__(781)) + "); }\n    .fmcy-menu-item-expanded .fmcy-menu-item-strain-title-row .fmcy-menu-item-thumb-category-concentrates-title {\n      background-image: url(" + escape(__webpack_require__(995)) + "); }\n    .fmcy-menu-item-expanded .fmcy-menu-item-strain-title-row .fmcy-menu-item-thumb-category-other-title {\n      background-image: url(" + escape(__webpack_require__(997)) + "); }\n    .fmcy-menu-item-expanded .fmcy-menu-item-strain-title-row .fmcy-menu-item-thumb-category-edibles-title {\n      background-image: url(" + escape(__webpack_require__(996)) + "); }\n    .fmcy-menu-item-expanded .fmcy-menu-item-strain-title-row .fmcy-menu-item-thumb-category-pre-rolls-title {\n      background-image: url(" + escape(__webpack_require__(998)) + "); }\n  .fmcy-menu-item-expanded .fmcy-product-strain-name {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    max-width: 100%;\n    white-space: nowrap;\n    text-align: left; }\n    @media only screen and (max-width: 1100px) {\n      .fmcy-menu-item-expanded .fmcy-product-strain-name {\n        text-align: center; } }\n  .fmcy-menu-item-expanded .fmcy-potency-display {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    max-width: 100%;\n    white-space: nowrap;\n    text-align: left; }\n    @media only screen and (max-width: 1100px) {\n      .fmcy-menu-item-expanded .fmcy-potency-display {\n        text-align: center; } }\n  .fmcy-menu-item-expanded .fmcy-item-add-to-cart-region {\n    height: 35px; }\n  .fmcy-menu-item-expanded .fmcy-menu-item-banner-wrapper {\n    position: absolute;\n    right: 0;\n    top: 0;\n    z-index: 1000;\n    width: 40%; }\n    .fmcy-menu-item-expanded .fmcy-menu-item-banner-wrapper .fmcy-menu-item-banner-inner-wrapper {\n      position: relative;\n      width: 100%;\n      padding-bottom: 56.25%;\n      height: 0; }\n  .fmcy-menu-item-expanded .fmcy-menu-item-banner {\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: top right;\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0; }\n  .fmcy-menu-item-expanded .fmcy-menu-item-weekly-sale-banner {\n    background-image: url(" + escape(__webpack_require__(994)) + "); }\n  .fmcy-menu-item-expanded .fmcy-menu-item-is-new-banner {\n    background-image: url(" + escape(__webpack_require__(993)) + "); }\n  .fmcy-menu-item-expanded .fmcy-menu-item-clearance-banner {\n    background-image: url(" + escape(__webpack_require__(992)) + "); }\n  .fmcy-menu-item-expanded .fmcy-menu-strain-indica-title {\n    background-image: url(" + escape(__webpack_require__(782)) + ");\n    background-repeat: no-repeat;\n    height: 24px;\n    background-color: #fff;\n    background-size: 110px;\n    padding-bottom: 10px;\n    margin-bottom: 7px;\n    background-position: center; }\n  .fmcy-menu-item-expanded .fmcy-item-prices-region .fmcy-menu-item-prices {\n    font-size: 2em; }\n  .fmcy-menu-item-expanded .fmcy-item-prices-region .fmcy-menu-item-prices-location-table {\n    font-size: 0.9em;\n    padding-top: 2em; }\n    .fmcy-menu-item-expanded .fmcy-item-prices-region .fmcy-menu-item-prices-location-table .fmcy-menu-item-prices {\n      font-size: 0.9em; }\n  .fmcy-menu-item-expanded .fmcy-menu-item-price-actual {\n    padding-top: 0.2em !important;\n    padding-bottom: 0.2em !important; }\n  .fmcy-menu-item-expanded .fmcy-available-at-locations-region {\n    font-size: 1.2em;\n    line-height: 3em; }\n  @media only screen and (max-width: 1100px) {\n    .fmcy-menu-item-expanded .fmcy-item-prices-region {\n      padding-top: 0.5em;\n      padding-left: 0px !important;\n      padding-right: 0px !important; }\n    .fmcy-menu-item-expanded .fmcy-available-at-locations-region {\n      line-height: 1.5em; } }\n  .fmcy-menu-item-expanded .fmcy-item-description-text {\n    padding-top: 30px;\n    text-align: left;\n    color: #000;\n    font-size: 1.2em;\n    line-height: 2em;\n    padding-bottom: 50px; }\n    .fmcy-menu-item-expanded .fmcy-item-description-text .fmcy-item-description-text-label {\n      color: #000; }\n    .fmcy-menu-item-expanded .fmcy-item-description-text .fmcy-item-description-text-description {\n      color: #000; }\n  .fmcy-menu-item-expanded .fmcy-menu-strain-sativa-title {\n    background-image: url(" + escape(__webpack_require__(783)) + ");\n    background-repeat: no-repeat;\n    height: 24px;\n    background-color: #fff;\n    background-size: 110px;\n    padding-bottom: 10px;\n    margin-bottom: 7px;\n    background-position: center; }\n  .fmcy-menu-item-expanded .fmcy-menu-strain-hybrid-title {\n    background-image: url(" + escape(__webpack_require__(781)) + ");\n    background-repeat: no-repeat;\n    height: 24px;\n    background-color: #fff;\n    background-size: 110px;\n    padding-bottom: 10px;\n    margin-bottom: 7px;\n    background-position: center; }\n  .fmcy-menu-item-expanded .fmcy-menu-wrapper {\n    background-color: #fff;\n    padding-top: 0;\n    padding-bottom: 0; }\n  .fmcy-menu-item-expanded .fmcy-menu-title {\n    text-align: left;\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    color: #000;\n    font-size: 4.5em;\n    line-height: 1.2em; }\n  .fmcy-menu-item-expanded .fmcy-product-strain-name {\n    text-align: left;\n    font-family: \"avril\", \"Arial\", sans-serif;\n    color: #000;\n    font-size: 2em;\n    line-height: 1.2em; }\n  .fmcy-menu-item-expanded .fmcy-potency-display {\n    text-align: left;\n    font-family: 'droid_serif' !important;\n    color: #000;\n    font-size: 1em;\n    line-height: 1.2em; }\n  @media only screen and (max-width: 1100px) {\n    .fmcy-menu-item-expanded .fmcy-menu-title {\n      text-align: center; }\n    .fmcy-menu-item-expanded .fmcy-product-strain-name {\n      text-align: center; }\n    .fmcy-menu-item-expanded .fmcy-potency-display {\n      text-align: center; } }\n  .fmcy-menu-item-expanded .fmcy-menu-content-container {\n    padding-top: 60px;\n    padding-bottom: 60px;\n    max-width: 1100px;\n    height: 480px;\n    padding-left: 0;\n    padding-right: 0;\n    margin: auto; }\n  .fmcy-menu-item-expanded .fmcy-menu-container {\n    position: relative;\n    padding-top: 0;\n    margin: auto;\n    margin-bottom: 50px; }\n    .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-container-columns-row {\n      width: 100%; }\n    .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-top-border-line {\n      position: fixed;\n      z-index: 1000;\n      width: 100%;\n      height: 2px;\n      top: 99px;\n      left: 0;\n      right: 0;\n      background-color: #1b1b1b; }\n    .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-tag-bar-region {\n      position: fixed;\n      right: 0;\n      z-index: 1000;\n      left: 0;\n      top: 101px; }\n    .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-tag-bar {\n      position: absolute;\n      right: 0;\n      max-width: 50%;\n      font-size: 18px;\n      line-height: 18px; }\n    .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-product-tag {\n      padding-right: 20px; }\n    @media only screen and (min-width: 1100px) {\n      .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-tag-bar {\n        font-size: 25px;\n        line-height: 25px; } }\n    .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-item-btn-close {\n      cursor: pointer;\n      background-image: url(" + escape(__webpack_require__(189)) + ");\n      background-repeat: no-repeat;\n      background-position: top right;\n      background-size: cover;\n      width: 32px;\n      height: 32px;\n      z-index: 1000;\n      position: fixed;\n      right: 74px;\n      top: 161px;\n      opacity: 1; }\n    .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-item-magnify-icon {\n      cursor: pointer;\n      background-image: url(" + escape(__webpack_require__(999)) + ");\n      background-repeat: no-repeat;\n      background-position: center;\n      background-size: cover;\n      width: 32px;\n      height: 32px;\n      z-index: 500;\n      position: fixed;\n      top: 202px;\n      right: 74px;\n      opacity: 1; }\n    .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-vendor-icon-region {\n      z-index: 500; }\n      @media only screen and (min-width: 1100px) {\n        .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-vendor-icon-region {\n          padding-top: 20px;\n          padding-left: 20px; } }\n      @media only screen and (max-width: 1100px) {\n        .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-vendor-icon-region {\n          position: absolute;\n          top: 15px;\n          left: 30px; } }\n      .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-vendor-icon-region .fmcy-vendor-icon .fmcy-image {\n        height: 14vw;\n        width: 14vw;\n        margin: unset; }\n      @media only screen and (max-width: 1100px) {\n        .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-vendor-icon-region .fmcy-vendor-icon .fmcy-image {\n          height: 22vw;\n          width: 22vw; } }\n    .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-favourite-button-region {\n      position: fixed;\n      top: 260px;\n      right: 21px;\n      z-index: 1000; }\n      .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-favourite-button-region .fmcy-favourite-button .farm-favourite-button-inner {\n        width: 30px;\n        height: 26px; }\n    @media only screen and (min-width: 768px) {\n      .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-favourite-button-region {\n        top: 260px;\n        right: 75px; }\n        .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-favourite-button-region .fmcy-favourite-button .farm-favourite-button-inner {\n          width: 30px;\n          height: 26px; } }\n    .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-item-thumb-image-large {\n      position: absolute;\n      right: 0px;\n      top: 100px;\n      background-size: contain;\n      z-index: 1; }\n    .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-image-container {\n      background-size: contain;\n      background-repeat: no-repeat;\n      background-position: center bottom;\n      height: 400px;\n      background-color: #fff; }\n      @media (min-width: 1600px) {\n        .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-image-container {\n          height: 683px; } }\n    .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-image-container-magnified {\n      width: 175px;\n      height: 175px;\n      position: absolute;\n      border-radius: 100%;\n      /*Multiple box shadows to achieve the glass effect*/\n      box-shadow: 0 0 0 7px rgba(255, 255, 255, 0.85), 0 0 7px 7px rgba(0, 0, 0, 0.25), inset 0 0 40px 2px rgba(0, 0, 0, 0.25);\n      display: none;\n      background-repeat: no-repeat; }\n    .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-tile-container {\n      background-size: contain;\n      background-repeat: no-repeat;\n      background-position: center 15px;\n      height: 134px;\n      position: absolute;\n      left: 10px;\n      bottom: 70px;\n      z-index: 49; }\n      .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-tile-container .fmcy-menu-tile-image {\n        max-width: 120px; }\n    .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-item-zoom-toggle-region {\n      position: absolute;\n      left: 66px;\n      top: 10px;\n      z-index: 1001; }\n    .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-item-quality-region {\n      position: absolute;\n      left: 20px;\n      top: 100px;\n      z-index: 1002; }\n    .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-effects-row {\n      font-family: \"droid_serif\", \"times\", serif;\n      background-color: #fff;\n      font-size: 20px;\n      background-color: #93743f;\n      color: #fff;\n      text-align: center;\n      min-height: 50px;\n      vertical-align: middle;\n      line-height: 50px; }\n      .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-effects-row.indica {\n        background-color: #0080FF; }\n      .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-effects-row.hybrid {\n        background-color: #818285; }\n      .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-effects-row.sativa {\n        background-color: #93753E; }\n    .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-add-text-row {\n      font-family: \"droid_serif\", \"times\", serif;\n      font-size: 90%;\n      text-align: left; }\n      .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-add-text-row .fmcy-menu-add-text {\n        padding-bottom: 10px;\n        padding-top: 10px;\n        line-height: 2; }\n    .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-medical-row {\n      font-family: \"droid_serif\", \"times\", serif;\n      background-color: #6f5830;\n      font-size: 20px;\n      color: #fff;\n      text-align: center;\n      min-height: 50px;\n      vertical-align: middle;\n      line-height: 50px; }\n      .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-medical-row.indica {\n        background-color: #0066cc; }\n      .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-medical-row.hybrid {\n        background-color: #67696b; }\n      .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-medical-row.sativa {\n        background-color: #6f5830; }\n    .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-item-expanded-prices-row {\n      color: #000000;\n      background-color: #ffffff; }\n  .fmcy-menu-item-expanded.fmcy-product-tile-theme-dark {\n    background-color: #000; }\n    .fmcy-menu-item-expanded.fmcy-product-tile-theme-dark .fmcy-menu-wrapper {\n      background-color: #000000; }\n    .fmcy-menu-item-expanded.fmcy-product-tile-theme-dark .fmcy-menu-item-expanded-prices-row {\n      background-color: #000000;\n      color: #979696; }\n    .fmcy-menu-item-expanded.fmcy-product-tile-theme-dark .fmcy-menu-title {\n      color: #ffffff; }\n    .fmcy-menu-item-expanded.fmcy-product-tile-theme-dark .fmcy-menu-item-price {\n      color: #fff !important; }\n    .fmcy-menu-item-expanded.fmcy-product-tile-theme-dark .fmcy-menu-item-price-quantity {\n      border: 2px solid #fff !important;\n      color: #fff !important; }\n    .fmcy-menu-item-expanded.fmcy-product-tile-theme-dark .fmcy-menu-item-price-actual {\n      color: #fff !important; }\n    .fmcy-menu-item-expanded.fmcy-product-tile-theme-dark .fmcy-item-description-text {\n      color: #fff; }\n      .fmcy-menu-item-expanded.fmcy-product-tile-theme-dark .fmcy-item-description-text .fmcy-item-description-text-label {\n        color: #fff; }\n      .fmcy-menu-item-expanded.fmcy-product-tile-theme-dark .fmcy-item-description-text .fmcy-item-description-text-description {\n        color: #fff; }\n  .fmcy-menu-item-expanded.fmcy-product-high-cbd .fmcy-top-border-line {\n    background: #52b7be; }\n  .fmcy-menu-item-expanded.fmcy-product-high-cbd .fmcy-pointy::after {\n    background: #52b7be; }\n  .fmcy-menu-item-expanded.fmcy-product-high-cbn-cbg .fmcy-top-border-line {\n    background: #A28DB3; }\n  .fmcy-menu-item-expanded.fmcy-product-high-cbn-cbg .fmcy-pointy::after {\n    background: #A28DB3; }\n  .fmcy-menu-item-expanded.fmcy-product-is-organic .fmcy-top-border-line {\n    background: #56b593; }\n  .fmcy-menu-item-expanded.fmcy-product-is-organic .fmcy-pointy::after {\n    background: #56b593; }\n  .fmcy-menu-item-expanded.fmcy-product-is-bc-grown .fmcy-top-border-line {\n    background: #001a70; }\n  .fmcy-menu-item-expanded.fmcy-product-is-bc-grown .fmcy-pointy::after {\n    background: #001a70; }\n  .fmcy-menu-item-expanded.fmcy-product-is-farm-exclusive .fmcy-top-border-line {\n    background: #221F20; }\n  .fmcy-menu-item-expanded.fmcy-product-is-farm-exclusive .fmcy-pointy::after {\n    background: #221F20; }\n  .fmcy-menu-item-expanded.fmcy-product-is-vegan .fmcy-top-border-line {\n    background: #14b47b; }\n  .fmcy-menu-item-expanded.fmcy-product-is-vegan .fmcy-pointy::after {\n    background: #14b47b; }\n  .fmcy-menu-item-expanded.indica .fmcy-top-border-line {\n    background-color: #0080FF; }\n  .fmcy-menu-item-expanded.indica .fmcy-tag-bar .fmcy-inner-tag {\n    background-color: #0080FF; }\n  .fmcy-menu-item-expanded.indica .fmcy-tag-bar .fmcy-pointy::after {\n    background: #0080FF; }\n  .fmcy-menu-item-expanded.sativa .fmcy-top-border-line {\n    background-color: #93753E; }\n  .fmcy-menu-item-expanded.sativa .fmcy-tag-bar .fmcy-inner-tag {\n    background-color: #93753E; }\n  .fmcy-menu-item-expanded.sativa .fmcy-tag-bar .fmcy-pointy::after {\n    background: #93753E; }\n  .fmcy-menu-item-expanded.hybrid .fmcy-top-border-line {\n    background-color: #818285; }\n  .fmcy-menu-item-expanded.hybrid .fmcy-tag-bar .fmcy-inner-tag {\n    background-color: #818285; }\n  .fmcy-menu-item-expanded.hybrid .fmcy-tag-bar .fmcy-pointy::after {\n    background: #818285; }\n\n@media only screen and (max-width: 1100px) {\n  .fmcy-menu-title {\n    padding: 5;\n    text-align: center; } }\n\n/* Small Devices, Tablets */\n@media only screen and (max-width: 1100px) {\n  .fmcy-menu-item-expanded .fmcy-menu-item-banner-wrapper {\n    width: 30%; }\n  .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-item-btn-close {\n    top: 151px;\n    right: 20px; }\n  .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-item-magnify-icon {\n    right: 20px;\n    top: 192px; }\n  .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-image-container {\n    height: 400px; }\n  .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-top-border-line {\n    top: 110px; }\n  .fmcy-menu-item-expanded .fmcy-menu-container .fmcy-tag-bar-region {\n    top: 110px; } }\n\nBODY.admin-bar .fmcy-menu-expanded-product .fmcy-favourite-button-region {\n  top: 290px;\n  right: 21px; }\n\n@media only screen and (min-width: 768px) {\n  BODY.admin-bar .fmcy-menu-expanded-product .fmcy-favourite-button-region {\n    top: 290px;\n    right: 75px; } }\n\nBODY.admin-bar .fmcy-menu-container {\n  margin-top: 32px; }\n  BODY.admin-bar .fmcy-menu-container .fmcy-top-border-line {\n    top: 131px; }\n  BODY.admin-bar .fmcy-menu-container .fmcy-tag-bar-region {\n    top: 133px; }\n  BODY.admin-bar .fmcy-menu-container .fmcy-menu-item-btn-close {\n    top: 193px; }\n  BODY.admin-bar .fmcy-menu-container .fmcy-menu-item-magnify-icon {\n    top: 234px; }\n\n@media only screen and (max-width: 1100px) {\n  BODY.admin-bar .fmcy-menu-container {\n    margin-top: 32px; }\n    BODY.admin-bar .fmcy-menu-container .fmcy-menu-item-btn-close {\n      top: 183px; }\n    BODY.admin-bar .fmcy-menu-container .fmcy-menu-item-magnify-icon {\n      top: 222px; }\n    BODY.admin-bar .fmcy-menu-container .fmcy-top-border-line {\n      top: 142px; }\n    BODY.admin-bar .fmcy-menu-container .fmcy-tag-bar-region {\n      top: 142px; } }\n\n@media only screen and (max-width: 782px) {\n  BODY.admin-bar .fmcy-menu-container {\n    margin-top: 46px; }\n    BODY.admin-bar .fmcy-menu-container .fmcy-menu-item-btn-close {\n      top: 197px; }\n    BODY.admin-bar .fmcy-menu-container .fmcy-menu-item-magnify-icon {\n      top: 236px; }\n    BODY.admin-bar .fmcy-menu-container .fmcy-top-border-line {\n      top: 156px; }\n    BODY.admin-bar .fmcy-menu-container .fmcy-tag-bar-region {\n      top: 156px; } }\n", ""]);
	
	// exports


/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-product-zoomer-modal .fmcy-menu-item-btn-close {\n  cursor: pointer;\n  background-image: url(" + escape(__webpack_require__(189)) + ");\n  background-repeat: no-repeat;\n  background-position: top right;\n  background-size: cover;\n  width: 32px;\n  height: 32px;\n  z-index: 1000;\n  position: absolute;\n  right: 5px;\n  top: 5px;\n  opacity: 1; }\n\n.fmcy-product-zoomer-modal .fmcy-zoomer-branding-region {\n  position: absolute;\n  bottom: 10px;\n  left: 12px;\n  z-index: 1000;\n  opacity: 0.7; }\n  .fmcy-product-zoomer-modal .fmcy-zoomer-branding-region .fmy-branding-f {\n    width: 53px;\n    height: 75px; }\n", ""]);
	
	// exports


/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, "html.fmcy-showing-menu-overlay {\n  overflow: hidden !important; }\n\nbody.fmcy-showing-menu-overlay {\n  overflow: hidden; }\n  body.fmcy-showing-menu-overlay.fmcy-product-tile-theme-dark #et-main-area-modal {\n    background-color: #000000; }\n  body.fmcy-showing-menu-overlay #page-container {\n    overflow: scroll; }\n  @media only screen and (min-width: 1100px) {\n    body.fmcy-showing-menu-overlay .fmcy-scroll-adjust-left {\n      left: -8px !important; }\n    body.fmcy-showing-menu-overlay .fmcy-scroll-adjust-margin {\n      margin-right: 15px !important; }\n    body.fmcy-showing-menu-overlay .fmcy-header-control-bar-location-indicator {\n      margin-left: -11px !important; }\n    body.fmcy-showing-menu-overlay .fmcy-sub-category-filter-row {\n      margin-left: -15px !important; }\n    body.fmcy-showing-menu-overlay .fmcy-footer-control-bar {\n      left: -15px !important;\n      padding-left: 15px !important; } }\n\n.fmcy-menu {\n  background-color: #000000; }\n  .fmcy-menu.container-fluid {\n    padding-left: 0;\n    padding-right: 0; }\n  .fmcy-menu.fmcy-menu-mode-menu .fmcy-menu-items {\n    overflow: hidden;\n    background-color: #e5e3e3; }\n  .fmcy-menu.fmcy-menu-mode-menu .fmcy-menu-filter-region {\n    background-color: #e5e3e3;\n    /*\n          top: 95px;\n          left: 0px;\n          right: 0px;\n          */\n    z-index: 1001; }\n  .fmcy-menu.fmcy-menu-mode-menu .fmcy-menu-items-region {\n    background-color: #e5e3e3; }\n  .fmcy-menu.fmcy-menu-mode-embedded.fmcy-menu-thumbstyle-full .fmcy-menu-item-thumb {\n    margin-bottom: 60px; }\n  .fmcy-menu.fmcy-menu-mode-slider, .fmcy-menu.fmcy-menu-mode-embedded {\n    background-color: transparent; }\n", ""]);
	
	// exports


/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-page-loading {\n  text-align: center;\n  background-color: #fff;\n  border-top: 2px solid #ecebeb;\n  min-height: 75px;\n  padding: 25px; }\n  .fmcy-page-loading.page-loading-theme-dark {\n    border-top: 2px solid #000; }\n", ""]);
	
	// exports


/***/ },
/* 977 */,
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-modal {\n  background-color: #121212; }\n  .fmcy-modal .fmcy-menu-item-btn-close {\n    cursor: pointer;\n    background-image: url(" + escape(__webpack_require__(189)) + ");\n    background-repeat: no-repeat;\n    background-position: top right;\n    background-size: cover;\n    width: 32px;\n    height: 32px;\n    z-index: 1000;\n    position: absolute;\n    right: 28px;\n    top: 10px;\n    opacity: 1; }\n  .fmcy-modal .fmcy-modal-default-content-wrapper {\n    display: table;\n    margin: auto;\n    height: 80vh;\n    padding: 10px; }\n  .fmcy-modal .fmcy-modal-default-content {\n    color: #fff;\n    max-width: 400px;\n    text-align: center;\n    display: table-cell;\n    vertical-align: middle; }\n    .fmcy-modal .fmcy-modal-default-content .fmcy-modal-default-content-icon {\n      background-image: url(" + escape(__webpack_require__(1000)) + ");\n      background-repeat: no-repeat;\n      background-size: cover;\n      width: 90px;\n      height: 90px;\n      margin: auto;\n      margin-bottom: 20px; }\n    .fmcy-modal .fmcy-modal-default-content .fmcy-modal-default-title-text {\n      font-family: \"bebasneue\", \"Arial\", sans-serif;\n      font-size: 20px; }\n\n@media only screen and (max-width: 1100px) {\n  .fmcy-modal .fmcy-menu-item-btn-close {\n    top: 20px; } }\n\n@media only screen and (max-width: 1100px) {\n  BODY.admin-bar .fmcy-modal .fmcy-menu-item-btn-close {\n    top: 50px !important; } }\n", ""]);
	
	// exports


/***/ },
/* 979 */,
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, "#fmcy-search-modal {\n  /*width: 290px;*/ }\n\n.fmcy-search-modal {\n  /*width: 290px; */\n  font-family: \"bebasneue\", \"Arial\", sans-serif;\n  -webkit-touch-callout: none;\n  /* iOS Safari */\n  -webkit-user-select: none;\n  /* Safari */\n  -khtml-user-select: none;\n  /* Konqueror HTML */\n  -moz-user-select: none;\n  /* Old versions of Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n  user-select: none;\n  /* Non-prefixed version, currently\n                                  supported by Chrome, Opera and Firefox */ }\n  .fmcy-search-modal .container-fluid {\n    padding-right: 0px !important;\n    padding-left: 0px !important;\n    width: 100%; }\n  .fmcy-search-modal .row.no-gutters {\n    margin-right: 0;\n    margin-left: 0; }\n    .fmcy-search-modal .row.no-gutters > [class^=\"col-\"],\n    .fmcy-search-modal .row.no-gutters > [class*=\" col-\"] {\n      padding-right: 0;\n      padding-left: 0; }\n  .fmcy-search-modal .select2-selection__arrow {\n    display: none !important; }\n  .fmcy-search-modal .fmcy-search-menu-wrapper {\n    position: absolute;\n    right: 0px; }\n    .fmcy-search-modal .fmcy-search-menu-wrapper .fmcy-search-menu-inner-area {\n      width: 410px;\n      background-color: #2e302f;\n      min-height: 480px; }\n  .fmcy-search-modal .select2-container--default .select2-selection--single {\n    background-color: #2e302f !important;\n    border: 1px solid #2e302f !important;\n    border-radius: 4px; }\n  .fmcy-search-modal .select2-container--default .select2-selection--single .select2-selection__placeholder,\n  .fmcy-search-modal .select2-container--default .select2-selection--single .select2-selection__rendered {\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    color: #fff !important;\n    font-size: 20px;\n    line-height: 36px;\n    font-weight: normal;\n    font-style: normal;\n    text-transform: none;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    speak: none; }\n\n.fmcy-menu-search-dropdown {\n  font-family: \"bebasneue\", \"Arial\", sans-serif;\n  font-size: 20px;\n  line-height: 12px;\n  font-weight: normal;\n  font-style: normal;\n  text-transform: none;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  speak: none; }\n  .fmcy-menu-search-dropdown .select2-results__options {\n    max-height: 410px !important; }\n  .fmcy-menu-search-dropdown .select2-results__message {\n    color: #fff !important; }\n  .fmcy-menu-search-dropdown .select2-results__option--highlighted {\n    background-color: #0fb1b5 !important; }\n  .fmcy-menu-search-dropdown .select2-results__option[aria-selected=true] {\n    background-color: #000 !important; }\n  .fmcy-menu-search-dropdown .select2-search--dropdown .select2-search__field {\n    padding: 6px !important;\n    font-size: 20px; }\n  .fmcy-menu-search-dropdown .select2-results .tl-wrapper.tl-show-icon .tl-text-wrapper {\n    color: #fff;\n    max-width: 221px;\n    line-height: 20px; }\n  .fmcy-menu-search-dropdown .select2-results .tl-icon-wrapper {\n    width: 49px !important; }\n\n.select2-dropdown {\n  font-family: \"bebasneue\", \"Arial\", sans-serif;\n  font-size: 20px;\n  line-height: 12px;\n  font-weight: normal;\n  font-style: normal;\n  text-transform: none;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  speak: none;\n  background-color: #2e302f !important;\n  border: 1px solid #2e302f !important; }\n", ""]);
	
	// exports


/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, "#fmcy-sidebar-modal {\n  /*width: 290px;*/ }\n\n.fmcy-sidebar-modal {\n  /*width: 290px;*/\n  font-family: \"bebasneue\", \"Arial\", sans-serif;\n  -webkit-touch-callout: none;\n  /* iOS Safari */\n  -webkit-user-select: none;\n  /* Safari */\n  -khtml-user-select: none;\n  /* Konqueror HTML */\n  -moz-user-select: none;\n  /* Old versions of Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n  user-select: none;\n  /* Non-prefixed version, currently\n                                  supported by Chrome, Opera and Firefox */ }\n  .fmcy-sidebar-modal .container-fluid {\n    padding-right: 0px !important;\n    padding-left: 0px !important;\n    width: 100%; }\n  .fmcy-sidebar-modal .row.no-gutters {\n    margin-right: 0;\n    margin-left: 0; }\n    .fmcy-sidebar-modal .row.no-gutters > [class^=\"col-\"],\n    .fmcy-sidebar-modal .row.no-gutters > [class*=\" col-\"] {\n      padding-right: 0;\n      padding-left: 0; }\n  .fmcy-sidebar-modal .fmcy-side-bar-menu-wrapper {\n    position: absolute;\n    right: 0px; }\n    .fmcy-sidebar-modal .fmcy-side-bar-menu-wrapper .fmcy-side-bar-menu-left-area {\n      min-width: 290px;\n      background-color: #2e302f;\n      min-height: 480px;\n      padding-bottom: 300px; }\n      .fmcy-sidebar-modal .fmcy-side-bar-menu-wrapper .fmcy-side-bar-menu-left-area .fmcy-menu-button-group {\n        font-size: 20px;\n        color: #fff;\n        font-family: 'bebasneue','Arial',sans-serif;\n        padding-bottom: 15px;\n        border-top: solid 1px black;\n        padding-top: 15px;\n        padding-left: 50px; }\n        .fmcy-sidebar-modal .fmcy-side-bar-menu-wrapper .fmcy-side-bar-menu-left-area .fmcy-menu-button-group.fmcy-menu-button-group-profile {\n          padding-left: 0px; }\n          .fmcy-sidebar-modal .fmcy-side-bar-menu-wrapper .fmcy-side-bar-menu-left-area .fmcy-menu-button-group.fmcy-menu-button-group-profile .fmcy-menu-account-info-display-name {\n            position: relative;\n            padding-left: 50px;\n            padding-bottom: 10px; }\n            .fmcy-sidebar-modal .fmcy-side-bar-menu-wrapper .fmcy-side-bar-menu-left-area .fmcy-menu-button-group.fmcy-menu-button-group-profile .fmcy-menu-account-info-display-name .fmcy-menu-account-info-display-name-icon {\n              position: absolute;\n              left: 11px;\n              top: 1px;\n              background-image: url(" + escape(__webpack_require__(1001)) + ");\n              width: 23px;\n              height: 24px;\n              background-size: cover; }\n        .fmcy-sidebar-modal .fmcy-side-bar-menu-wrapper .fmcy-side-bar-menu-left-area .fmcy-menu-button-group .fmcy-menu-button-item {\n          line-height: 1.5em; }\n          .fmcy-sidebar-modal .fmcy-side-bar-menu-wrapper .fmcy-side-bar-menu-left-area .fmcy-menu-button-group .fmcy-menu-button-item a, .fmcy-sidebar-modal .fmcy-side-bar-menu-wrapper .fmcy-side-bar-menu-left-area .fmcy-menu-button-group .fmcy-menu-button-item.lrm-login, .fmcy-sidebar-modal .fmcy-side-bar-menu-wrapper .fmcy-side-bar-menu-left-area .fmcy-menu-button-group .fmcy-menu-button-item.lrm-register, .fmcy-sidebar-modal .fmcy-side-bar-menu-wrapper .fmcy-side-bar-menu-left-area .fmcy-menu-button-group .fmcy-menu-button-item.login-button, .fmcy-sidebar-modal .fmcy-side-bar-menu-wrapper .fmcy-side-bar-menu-left-area .fmcy-menu-button-group .fmcy-menu-button-item.register-button {\n            cursor: pointer;\n            color: #fff !important; }\n            .fmcy-sidebar-modal .fmcy-side-bar-menu-wrapper .fmcy-side-bar-menu-left-area .fmcy-menu-button-group .fmcy-menu-button-item a:hover, .fmcy-sidebar-modal .fmcy-side-bar-menu-wrapper .fmcy-side-bar-menu-left-area .fmcy-menu-button-group .fmcy-menu-button-item.lrm-login:hover, .fmcy-sidebar-modal .fmcy-side-bar-menu-wrapper .fmcy-side-bar-menu-left-area .fmcy-menu-button-group .fmcy-menu-button-item.lrm-register:hover, .fmcy-sidebar-modal .fmcy-side-bar-menu-wrapper .fmcy-side-bar-menu-left-area .fmcy-menu-button-group .fmcy-menu-button-item.login-button:hover, .fmcy-sidebar-modal .fmcy-side-bar-menu-wrapper .fmcy-side-bar-menu-left-area .fmcy-menu-button-group .fmcy-menu-button-item.register-button:hover {\n              text-decoration: none;\n              color: #d09f19 !important; }\n          .fmcy-sidebar-modal .fmcy-side-bar-menu-wrapper .fmcy-side-bar-menu-left-area .fmcy-menu-button-group .fmcy-menu-button-item.lrm-register, .fmcy-sidebar-modal .fmcy-side-bar-menu-wrapper .fmcy-side-bar-menu-left-area .fmcy-menu-button-group .fmcy-menu-button-item.register-button {\n            padding-left: 50px; }\n        .fmcy-sidebar-modal .fmcy-side-bar-menu-wrapper .fmcy-side-bar-menu-left-area .fmcy-menu-button-group.fmcy-menu-account-info {\n          border-top: none; }\n", ""]);
	
	// exports


/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-video-expanded-modal .fmcy-menu-item-btn-close {\n  cursor: pointer;\n  background-image: url(" + escape(__webpack_require__(189)) + ");\n  background-repeat: no-repeat;\n  background-position: top right;\n  background-size: cover;\n  width: 32px;\n  height: 32px;\n  z-index: 1000;\n  position: absolute;\n  right: 5px;\n  top: 5px;\n  opacity: 1; }\n", ""]);
	
	// exports


/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-kiosk-intro-overlay {\n  position: relative;\n  background-image: url(" + escape(__webpack_require__(669)) + ");\n  background-size: cover;\n  height: 1920px; }\n  .fmcy-kiosk-intro-overlay .kiosk-intro-overlay-f-logo-region {\n    position: absolute;\n    left: 50%;\n    bottom: 100px;\n    margin-left: -74px; }\n  .fmcy-kiosk-intro-overlay .kiosk-intro-overlay-text-click-continue-icon {\n    background-image: url(" + escape(__webpack_require__(670)) + ");\n    background-size: cover;\n    position: absolute;\n    left: 50%;\n    width: 500px;\n    height: 366px;\n    bottom: 250px;\n    margin-left: -300px; }\n  .fmcy-kiosk-intro-overlay .kiosk-intro-overlay-content-wrapper {\n    text-align: center;\n    text-transform: uppercase;\n    font-family: 'avril', 'Arial', sans-serif;\n    color: #fff;\n    font-size: 6em;\n    line-height: 2em;\n    padding-top: 100px; }\n  .fmcy-kiosk-intro-overlay .kiosk-intro-title {\n    background-image: url(" + escape(__webpack_require__(1011)) + ");\n    background-size: cover;\n    width: 554px;\n    height: 94px;\n    margin: auto;\n    margin-bottom: 68px; }\n  .fmcy-kiosk-intro-overlay .kiosk-menu-intro-cat-icon {\n    background-size: contain;\n    width: 237px;\n    height: 244px;\n    margin: auto;\n    background-repeat: no-repeat;\n    margin-bottom: 50px;\n    cursor: pointer; }\n    .fmcy-kiosk-intro-overlay .kiosk-menu-intro-cat-icon#flowers {\n      background-image: url(" + escape(__webpack_require__(1006)) + "); }\n    .fmcy-kiosk-intro-overlay .kiosk-menu-intro-cat-icon#prerolls {\n      background-image: url(" + escape(__webpack_require__(1007)) + "); }\n    .fmcy-kiosk-intro-overlay .kiosk-menu-intro-cat-icon#tinctures {\n      background-image: url(" + escape(__webpack_require__(1008)) + "); }\n    .fmcy-kiosk-intro-overlay .kiosk-menu-intro-cat-icon#capsules {\n      background-image: url(" + escape(__webpack_require__(1003)) + "); }\n    .fmcy-kiosk-intro-overlay .kiosk-menu-intro-cat-icon#vaping {\n      background-image: url(" + escape(__webpack_require__(1010)) + "); }\n    .fmcy-kiosk-intro-overlay .kiosk-menu-intro-cat-icon#concentrates {\n      background-image: url(" + escape(__webpack_require__(1004)) + "); }\n    .fmcy-kiosk-intro-overlay .kiosk-menu-intro-cat-icon#edibles {\n      background-image: url(" + escape(__webpack_require__(1005)) + "); }\n    .fmcy-kiosk-intro-overlay .kiosk-menu-intro-cat-icon#topicals {\n      background-image: url(" + escape(__webpack_require__(1009)) + "); }\n    .fmcy-kiosk-intro-overlay .kiosk-menu-intro-cat-icon#accessories {\n      background-image: url(" + escape(__webpack_require__(1002)) + "); }\n  .fmcy-kiosk-intro-overlay .kiosk-menu-intro-cat-icon-container {\n    margin: auto;\n    max-width: 800px; }\n", ""]);
	
	// exports


/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(38);
	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-session-timeout-overlay {\n  position: relative;\n  background-image: url(" + escape(__webpack_require__(669)) + ");\n  background-size: cover;\n  height: 1920px; }\n  .fmcy-session-timeout-overlay .session-timeout-overlay-f-logo-region {\n    position: absolute;\n    left: 50%;\n    bottom: 100px;\n    margin-left: -74px; }\n  .fmcy-session-timeout-overlay .session-timeout-overlay-text-click-continue-icon {\n    background-image: url(" + escape(__webpack_require__(670)) + ");\n    background-size: cover;\n    position: absolute;\n    left: 50%;\n    width: 500px;\n    height: 366px;\n    bottom: 250px;\n    margin-left: -300px; }\n  .fmcy-session-timeout-overlay .session-timeout-overlay-content-wrapper {\n    text-align: center;\n    text-transform: uppercase;\n    font-family: 'avril', 'Arial', sans-serif;\n    color: #fff;\n    font-size: 6em;\n    line-height: 2em;\n    padding-top: 400px; }\n    .fmcy-session-timeout-overlay .session-timeout-overlay-content-wrapper .fmcy-countdown {\n      color: #A71C20; }\n    .fmcy-session-timeout-overlay .session-timeout-overlay-content-wrapper .session-timeout-overlay-text-you-there {\n      padding-top: 50px;\n      font-family: \"bebasneue\",\"Arial\",sans-serif;\n      line-height: 2em; }\n    .fmcy-session-timeout-overlay .session-timeout-overlay-content-wrapper .session-timeout-overlay-text-click-continue {\n      font-size: 0.75em;\n      line-height: 2em; }\n    .fmcy-session-timeout-overlay .session-timeout-overlay-content-wrapper .session-timeout-overlay-text-reset-in {\n      font-size: 0.75em;\n      line-height: 1em; }\n    .fmcy-session-timeout-overlay .session-timeout-overlay-content-wrapper .fmcy-countdown {\n      font-size: 2em;\n      line-height: 2em; }\n", ""]);
	
	// exports


/***/ },
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */
189,
/* 992 */
151,
/* 993 */
152,
/* 994 */
153,
/* 995 */
154,
/* 996 */
155,
/* 997 */
156,
/* 998 */
157,
/* 999 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/magnify-icon-06781488e7d60ede489777366baee17f.png";

/***/ },
/* 1000 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/indica_moon_icon-d5adb7bb83827e423254a249942d1157.png";

/***/ },
/* 1001 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/account-profile-icon-3aa897fae0f7594d065042addf624bc3.png";

/***/ },
/* 1002 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/menu-accessories-icon-2-c51b8c0d9d158a16a2c151ba01d2e841.svg";

/***/ },
/* 1003 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/menu-capsules-icon-2-7516aa213ff2ea33d2dfe0ba054be841.svg";

/***/ },
/* 1004 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/menu-concentrates-icon-2-b6bf63e07973851e324a953ad99d7820.svg";

/***/ },
/* 1005 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/menu-edibles-icon-2-f6c7ab83136759aa8e671918e80886af.svg";

/***/ },
/* 1006 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/menu-flowers-icon-2-5d017e2045eab10d55542be16d970472.svg";

/***/ },
/* 1007 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/menu-prerolls-icon-2-a24fe3236b8446bc539793741ba5a0fe.svg";

/***/ },
/* 1008 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/menu-tinctures-oils-icon-3-226a63cfef3194084257286ce96bb976.svg";

/***/ },
/* 1009 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/menu-topicals-icon-2-8096a76d4d8da56070f0b87fff0746c3.svg";

/***/ },
/* 1010 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/menu-vaping-icon-2-fdaa48d0f340dce38567ad5d2e53d9aa.svg";

/***/ },
/* 1011 */
/***/ function(module, exports) {

	module.exports = "/wp-content/plugins/farmacy/assets/js/images/title_the_menu-37f600a97b040e37c35a335f4fd19fc4.svg";

/***/ },
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(965);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-expanded-modal.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./cart-expanded-modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(966);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./click-blocker-modal.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./click-blocker-modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(967);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./entry-flow.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./entry-flow.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(968);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./footer-control-bar.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./footer-control-bar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(969);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./header-control-bar-kiosk.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./header-control-bar-kiosk.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(970);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./header-control-bar.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./header-control-bar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(971);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./loader-expanded.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./loader-expanded.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(972);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./mega-menu-modal.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./mega-menu-modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(973);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./menu-item-expanded.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./menu-item-expanded.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(974);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./product-zoomer-modal.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./product-zoomer-modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(975);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./menu.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./menu.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(976);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./page-loading.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./page-loading.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1039 */,
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(978);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./modal.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1041 */,
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(980);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./search-modal.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./search-modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(981);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./sidebar-modal.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./sidebar-modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(982);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./video-expanded-modal.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./video-expanded-modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(983);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./kiosk-intro-overlay.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./kiosk-intro-overlay.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(984);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./session-timeout-overlay.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./session-timeout-overlay.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="container-fluid">\n    <div class="row no-gutters">\n        <div class="col-xs-12">\n          <div class="fmcy-menu-item-btn-close"></div>\n          <div class="fmcy-cart-step-region"></div>\n          <div class="fmcy-location-map-region"></div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 1061 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	}
	return __p;
	};


/***/ },
/* 1062 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-entry-flow-step-region-wrapper">\n	<div class="fmcy-entry-flow-step-region"></div>\n</div>';
	}
	return __p;
	};


/***/ },
/* 1063 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-footer-control-bar-inner row">\n  <div id="fmcy-footer-bar-left-column">\n    <div class="fmcy-footer-bar-left-region"></div>\n  </div>\n  <div id="fmcy-footer-bar-right-column">\n    <div class="fmcy-footer-bar-right-region"></div>\n  </div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 1064 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<div class="fmcy-header-control-bar-inner row fmcy-scroll-adjust-left">\n  <div class="col-xs-3 fmcy-header-bar-left-column">\n    <div class="fmcy-header-branding-region"></div>\n  </div>\n  <div class="col-xs-9 fmcy-header-bar-right-column">\n    <div class="fmcy-header-bar-nav-search-region"></div>\n    <div class="fmcy-header-bar-nav-hamburger-region"></div>\n  </div>\n</div>\n<div class="fmcy-header-control-bar-inner row fmcy-scroll-adjust-left">\n  <div class="fmcy-header-bar-menu-items">\n    <div class="fmcy-header-bar-menu-items-inner">\n      <div class="fmcy-header-bar-menu-item-column cannabis-button-column"><div class="cannabis-button"><div class="fmcy-menu-button-item fmcy-menu-button-item-cannabis">CANNABIS</div></div></div>\n      <div class="fmcy-header-bar-menu-item-column cbd-button-column"><div class="cbd-button"><div class="fmcy-menu-button-item fmcy-menu-button-item-cbd">CBD</div></div></div>\n      <div class="fmcy-header-bar-menu-item-column accessories-button-column"><div class="accessories-button"><div class="fmcy-menu-button-item fmcy-menu-button-item-accessories">ACCESSORIES</div></div></div>\n      <div class="fmcy-header-bar-menu-item-column sales-button-column"><div class="fmcy-menu-button-item fmcy-menu-button-item-sales">WEEKLY SALE</div></div>\n    </div>\n  </div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 1065 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="row ">\n  <div class="col-xs-12 fmcy-header-control-bar-location-indicator-wrapper">\n    <div class="fmcy-header-control-bar-location-indicator-container container-fluid">\n      <div class="fmcy-header-control-bar-location-indicator row fmcy-scroll-adjust-margin">\n        <div class="col-xs-12 fmcy-header-control-bar-location-indicator">\n            <span class="fmcy-header-control-bar-location-indicator-text">'+
	((__t=(shoppingLocationText))==null?'':__t)+
	'</span>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class="fmcy-header-control-bar-inner row fmcy-scroll-adjust-left">\n  <div class="col-xs-3 fmcy-header-bar-left-column">\n    <div class="fmcy-header-branding-region"></div>\n  </div>\n  <div class="col-xs-9 fmcy-header-bar-right-column">\n    <div class="fmcy-header-bar-nav-profile-region"></div>\n    <div class="fmcy-header-bar-nav-search-region"></div>\n    <div class="fmcy-header-bar-shopping-cart-indicator-region"></div>\n    <div class="fmcy-header-bar-nav-hamburger-region"></div>\n  </div>\n</div>\n<div class="fmcy-header-control-bar-inner row fmcy-scroll-adjust-left">\n  <div class="fmcy-header-bar-menu-items">\n    ';
	 if (isUserLoggedIn === false) { 
	__p+='\n    ';
	 } 
	__p+='\n    <div class="fmcy-header-bar-menu-items-inner">\n      <div class="fmcy-header-bar-menu-item-column cannabis-button-column"><div class="cannabis-button"><div class="fmcy-menu-button-item fmcy-menu-button-item-cannabis">CANNABIS</div></div></div>\n      <div class="fmcy-header-bar-menu-item-column cbd-button-column"><div class="cbd-button"><div class="fmcy-menu-button-item fmcy-menu-button-item-cbd">CBD</div></div></div>\n      <div class="fmcy-header-bar-menu-item-column accessories-button-column"><div class="accessories-button"><div class="fmcy-menu-button-item fmcy-menu-button-item-accessories">ACCESSORIES</div></div></div>\n      <div class="fmcy-header-bar-menu-item-column sales-button-column"><a href="'+
	((__t=(rootUrl))==null?'':__t)+
	'/promotions-members/"><div class="fmcy-menu-button-item fmcy-menu-button-item-sales">WEEKLY SALE</div></a></div>\n    </div>\n  </div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 1066 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="container-fluid">\n    <div class="row">\n        <div class="col-xs-12">\n          <div class="fmcy-loader-expanded-default-content-wrapper">\n            <div class="fmcy-loader-expanded-default-content">\n              <div class="fmcy-loader-expanded-spinner-region"></div>\n            </div>\n          </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 1067 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="mega-menu-child-region"></div>\n<div class="fmcy-mega-menu-btn-close"></div>\n';
	}
	return __p;
	};


/***/ },
/* 1068 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-menu-wrapper fmcy-plugin-bootstrap">\n    <div class="container-fluid fmcy-menu-container">\n        <div class="fmcy-vendor-icon-region"></div>\n        <div class="fmcy-favourite-button-region"></div>\n        <div class="fmcy-tag-bar-region"></div>\n        ';
	 if (mode !== 'kiosk') { 
	__p+='\n        <div class="fmcy-menu-item-row fmcy-menu-item-thumb-image fmcy-menu-item-image-region visible-xs-block visible-md-block visible-sm-block"></div>\n        ';
	 } 
	__p+='\n        <div class="fmcy-menu-item-thumb-image-large fmcy-menu-item-thumb-image fmcy-menu-item-large-image-region visible-lg-block"></div>\n        <div class="fmcy-menu-item-thumb-selector-region visible-md-block visible-lg-block"></div>\n        ';
	 if (bannerClassName) { 
	__p+='\n        <div class="fmcy-menu-item-banner-wrapper">\n            <div class="fmcy-menu-item-banner-inner-wrapper">\n                <div class="fmcy-menu-item-banner  '+
	((__t=( bannerClassName ))==null?'':__t)+
	'"></div>\n            </div>\n        </div>\n        ';
	 } 
	__p+='\n        <div class="fmcy-top-border-line"></div>\n        <div class="fmcy-menu-item-magnify-icon"></div>\n        <div class="fmcy-menu-item-btn-close"></div>\n        <div class="row">\n            <div class="col-xs-12 fmcy-menu-item-col-no-padding">\n                <div class="container-fluid fmcy-menu-column-container">\n                  <div class="row">\n                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-5 fmcy-menu-column-container-col">\n                      <div class="container-fluid fmcy-menu-product-info-container fmcy-no-gutter">\n                        <div class="row">\n                            <div class="col-xs-12">\n                                <div class="fmcy-menu-title">'+
	((__t=( itemName ))==null?'':__t)+
	'</div>\n                            </div>\n                        </div>\n                        ';
	 if (strainName) { 
	__p+='\n                          <div class="row">\n                              <div class="col-xs-12">\n                                <div class="fmcy-product-strain-name">\n                                    '+
	((__t=( strainName ))==null?'':__t)+
	'\n                                </div>\n                              </div>\n                          </div>\n                        ';
	 } 
	__p+='\n                        <div class="fmcy-potency-region"></div>\n                        ';
	 if (strainTitleImgClass) { 
	__p+='\n                        <div class="row fmcy-menu-item-strain-title-row">\n                            <div class="fmcy-menu-item-strain-title col-xs-12 '+
	((__t=( strainTitleImgClass ))==null?'':__t)+
	'"></div>\n                        </div>\n                        ';
	 } 
	__p+='\n                        <div class="row fmcy-menu-item-expanded-prices-row '+
	((__t=( strain ))==null?'':__t)+
	'">\n                            <div class="fmcy-item-prices-region col-xs-12"></div>\n                        </div>\n                        ';
	 if (onlinePurchaseEnabled) { 
	__p+='\n                        <div class="row fmcy-menu-add-text-row '+
	((__t=( strain ))==null?'':__t)+
	'">\n                            <div class="col-xs-12">\n                                <div class="fmcy-menu-add-text">- click prices above to add to cart -</div>\n                            </div>\n                        </div>\n                        ';
	 } 
	__p+='\n                        ';
	 if (shouldRenderProductLocations) { 
	__p+='\n                        <div class="row">\n                            <div class="col-xs-12">\n                                <div class="fmcy-available-at-locations-region"></div>\n                            </div>\n                        </div>\n                        ';
	 } 
	__p+='\n                        <div class="row fmcy-menu-effects-row '+
	((__t=( strain ))==null?'':__t)+
	'">\n                            <div class="col-xs-12">\n                                '+
	((__t=( effectsAttrs ))==null?'':__t)+
	'\n                            </div>\n                        </div>\n                        <div class="row fmcy-menu-medical-row '+
	((__t=( strain ))==null?'':__t)+
	'">\n                            <div class="col-xs-12">\n                                '+
	((__t=( medicalAttrs ))==null?'':__t)+
	'\n                            </div>\n                        </div>\n                        ';
	 if (itemDescription) { 
	__p+='\n                        <div class="row fmcy-item-description-text-row">\n                            <div class="col-xs-12 fmcy-menu-item-col-no-padding-mobile">\n                                <div class="fmcy-item-description-text">\n                                    <div class="fmcy-item-description-text-label">Description:</div>\n                                    <div class="fmcy-item-description-text-description">'+
	((__t=( itemDescription ))==null?'':__t)+
	'</div>\n                                </div>\n                            </div>\n                        </div>\n                        ';
	 } 
	__p+='\n\n                      </div>\n                    </div>\n                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-7" style="pointer-events: none">\n                    </div>\n                  </div>\n                </div>\n            </div>\n        </div>\n        ';
	 if (mode == 'kiosk') { 
	__p+='\n        <div class="fmcy-menu-item-row fmcy-menu-item-thumb-image fmcy-menu-item-image-region visible-xs-block visible-md-block visible-sm-block"></div>\n        ';
	 } 
	__p+='\n    </div>\n</div>\n';
	 if (hasVideos) { 
	__p+='\n<div class="fmcy-item-expanded-videos-container">\n  <div class="container fmcy-item-expanded-videos-container-inner">\n    <div class="row fmcy-item-videos-row">\n        <div class="col-xs-12 fmcy-menu-item-col-no-padding-mobile">\n            <div class="fmcy-item-videos-group-region"></div>\n        </div>\n    </div>\n  </div>\n</div>\n';
	 } 
	__p+='\n';
	}
	return __p;
	};


/***/ },
/* 1069 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="container-fluid">\n    <div class="row">\n        <div class="col-xs-12">\n          <div class="fmcy-menu-item-btn-close"></div>\n          <div class="fmcy-zoomer-branding-region"></div>\n          <div class="fmcy-item-zoomer-region"></div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 1070 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="row">\n    <div class="fmcy-menu-location-display-region col-xs-12"></div>\n</div>\n<div class="row">\n    <div class="fmcy-menu-search-region col-xs-12 hide"></div>\n</div>\n<div class="row">\n    <div class="fmcy-menu-filter-region hide"></div>\n</div>\n<div class="row">\n    <div class="fmcy-menu-items-region col-xs-12 hide"></div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 1071 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-spinner-region fmcy-spinner"></div>';
	}
	return __p;
	};


/***/ },
/* 1072 */,
/* 1073 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="container-fluid">\n    <div class="row">\n        <div class="col-xs-12">\n          <div class="fmcy-menu-item-btn-close"></div>\n          <div class="fmcy-modal-content-region">\n            <div class="fmcy-modal-default-content-wrapper">\n              <div class="fmcy-modal-default-content">\n                <div class="fmcy-modal-default-content-icon">\n\n                </div>\n                <div class="fmcy-modal-default-title-text">\n                  '+
	((__t=(title))==null?'':__t)+
	'\n                </div>\n                <div class="fmcy-modal-default-content-text">\n                  '+
	((__t=(description))==null?'':__t)+
	'\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 1074 */,
/* 1075 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-search-menu-wrapper">\n  <div class="fmcy-search-menu-inner-area">\n    <div class="fmcy-search-region"></div>\n  </div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 1076 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="fmcy-side-bar-menu-wrapper">\n  <div class="fmcy-side-bar-menu-left-area">\n    <div class="fmcy-menu-button-group fmcy-menu-button-group-profile fmcy-menu-account-info">\n      ';
	 if (isUserLoggedIn === true) { 
	__p+='\n      <div class="fmcy-menu-button-item fmcy-menu-account-info-display-name">\n        <div class="fmcy-menu-account-info-display-name-icon"></div> Hi, <a href="'+
	((__t=(rootUrl))==null?'':__t)+
	'/my-account"><span class="display-name">'+
	((__t=(displayName))==null?'':__t)+
	'</span></a>\n      </div>\n      <div class="fmcy-customer-my-orders-region"></div>\n      ';
	 } else { 
	__p+='\n        <div class="fmcy-menu-button-item fmcy-menu-account-info-display-name login-button">\n          <div class="fmcy-menu-account-info-display-name-icon"></div> Login\n        </div>\n        <div class="fmcy-menu-button-item register-button">Join</div>\n      ';
	 } 
	__p+='\n    </div>\n    <div class="fmcy-menu-button-group">\n      <div class="fmcy-menu-button-item"><a href="'+
	((__t=(rootUrl))==null?'':__t)+
	'/menu-intro">Menu</a></div>\n      ';
	 if (isUserLoggedIn === true) { 
	__p+='\n      <div class="fmcy-menu-button-item"><a href="'+
	((__t=(rootUrl))==null?'':__t)+
	'/my-account/#account-details">My Account</a></div>\n      <div class="fmcy-menu-button-item"><a href="'+
	((__t=(rootUrl))==null?'':__t)+
	'/my-favourites/">My Favourites</a></div>\n      <div class="fmcy-menu-button-item"><a href="'+
	((__t=(rootUrl))==null?'':__t)+
	'/my-account/#orders">Order History</a></div>\n      ';
	 } 
	__p+='\n      <div class="fmcy-menu-button-item"><a href="'+
	((__t=(rootUrl))==null?'':__t)+
	'/promotions-members/">Weekly Sale</a></div>\n      <div class="fmcy-menu-button-item"><a href="'+
	((__t=(rootUrl))==null?'':__t)+
	'/click-and-collect/">Click and Collect</a></div>\n      <div class="fmcy-menu-button-item"><a href="'+
	((__t=(rootUrl))==null?'':__t)+
	'/locations/">Locations</a></div>\n      <div class="fmcy-menu-button-item"><a href="'+
	((__t=(rootUrl))==null?'':__t)+
	'/gallery/">Gallery</a></div>\n      <div class="fmcy-menu-button-item"><a href="'+
	((__t=(rootUrl))==null?'':__t)+
	'/contact/">Contact</a></div>\n    </div>\n    <div class="fmcy-menu-button-group">\n      <div class="fmcy-menu-button-item"><a href="'+
	((__t=(rootUrl))==null?'':__t)+
	'/bookconsultation/">Book a Consultation</a></div>\n      <div class="fmcy-menu-button-item"><a href="'+
	((__t=(rootUrl))==null?'':__t)+
	'/frequently-asked-questions/">FAQ</a></div>\n      <div class="fmcy-menu-button-item"><a href="'+
	((__t=(rootUrl))==null?'':__t)+
	'/licensed-producers/">Licensed Producers</a></div>\n      <div class="fmcy-menu-button-item"><a href="'+
	((__t=(rootUrl))==null?'':__t)+
	'/the-original-farm-about-us/">About</a></div>\n      <div class="fmcy-menu-button-item"><a href="'+
	((__t=(rootUrl))==null?'':__t)+
	'/careers/">Careers</a></div>\n      <div class="fmcy-menu-button-item"><a href="'+
	((__t=(rootUrl))==null?'':__t)+
	'/psa/">COVID 19</a></div>\n      <div class="fmcy-menu-button-item"><a href="'+
	((__t=(rootUrl))==null?'':__t)+
	'">Home</a></div>\n    </div>\n    ';
	 if (isUserLoggedIn === true) { 
	__p+='\n      <div class="fmcy-menu-button-group">\n        <div class="fmcy-menu-button-item"><a href="'+
	((__t=(rootUrl))==null?'':__t)+
	'/?lrm_logout=1">Logout</a></div>\n      </div>\n    ';
	 } 
	__p+='\n  </div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 1077 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="container-fluid">\n    <div class="row">\n        <div class="col-xs-12">\n          <div class="fmcy-menu-item-btn-close"></div>\n          <div class="fmcy-video-region"></div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};


/***/ },
/* 1078 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class=\'kiosk-intro-overlay-content-wrapper\'>\n  <div class="kiosk-intro-overlay-f-logo-region"></div>\n  <div class="kiosk-intro-overlay-text-click-continue-icon"></div>\n  <div class="kiosk-intro-title"></div>\n  <div class="kiosk-menu-intro-cat-icon-container container-fluid">\n      <div class="row">\n          <div class="col-xs-4">\n            <div class="kiosk-menu-intro-cat-icon" id="flowers"></div>\n          </div>\n          <div class="col-xs-4">\n            <div class="kiosk-menu-intro-cat-icon" id="prerolls"></div>\n          </div>\n          <div class="col-xs-4">\n            <div class="kiosk-menu-intro-cat-icon" id="tinctures"></div>\n          </div>\n      </div>\n      <div class="row">\n          <div class="col-xs-4">\n            <div class="kiosk-menu-intro-cat-icon" id="capsules"></div>\n          </div>\n          <div class="col-xs-4">\n            <div class="kiosk-menu-intro-cat-icon" id="vaping"></div>\n          </div>\n          <div class="col-xs-4">\n            <div class="kiosk-menu-intro-cat-icon" id="concentrates"></div>\n          </div>\n      </div>\n      <div class="row">\n          <div class="col-xs-4">\n            <div class="kiosk-menu-intro-cat-icon" id="edibles"></div>\n          </div>\n          <div class="col-xs-4">\n            <div class="kiosk-menu-intro-cat-icon" id="topicals"></div>\n          </div>\n          <div class="col-xs-4">\n            <div class="kiosk-menu-intro-cat-icon" id="accessories"></div>\n          </div>\n      </div>\n  </div>\n<div>\n';
	}
	return __p;
	};


/***/ },
/* 1079 */
/***/ function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class=\'session-timeout-overlay-content-wrapper\'>\n  <div class="session-timeout-overlay-f-logo-region"></div>\n  <div class="session-timeout-overlay-text-click-continue-icon"></div>\n  <div class="session-timeout-overlay-text-you-there">Are you still there?</div>\n  <div class="session-timeout-overlay-text-reset-in"> Your session will reset in</div>\n  <div class=\'session-timeout-overlay-countdown-region\'><div>\n<div>\n';
	}
	return __p;
	};


/***/ },
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, Marionette, _, Backbone) {'use strict';
	
	var _stringify = __webpack_require__(46);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	$(function () {
	  __webpack_require__(261);
	  __webpack_require__(274);
	  __webpack_require__(1786);
	  var Moment = __webpack_require__(8);
	  var MomentRange = __webpack_require__(22);
	  var moment = MomentRange.extendMoment(Moment);
	  var MapboxClient = __webpack_require__(1725);
	  // TODO, obv store these keys in config for each env. and lock down to domain...
	  var mbxBaseClient = new MapboxClient('pk.eyJ1Ijoib2dmYXJtIiwiYSI6ImNrcTcyOW5jdjAwamsydXBnOHB1eTU0bG0ifQ.gJU9G9adyvvv8X4UBdUGhw');
	  var NodeGeocoder = __webpack_require__(1690);
	  var MenuProductEntities = __webpack_require__(61);
	  var LocationEntities = __webpack_require__(59);
	  var ProductVendorEntities = __webpack_require__(42);
	  var EntitiesBase = __webpack_require__(17);
	  var CartEntities = __webpack_require__(235);
	  var CustomerEntities = __webpack_require__(287);
	  var UIUtils = __webpack_require__(145);
	  var URLUtils = __webpack_require__(728);
	  var DateUtils = __webpack_require__(10);
	  var StringUtils = __webpack_require__(9);
	  var DynamicRegion = __webpack_require__(701);
	  var HeaderDynamicRegion = __webpack_require__(920);
	  var FooterDynamicRegion = __webpack_require__(917);
	  var MenuItemExpanded = __webpack_require__(924);
	  var ProductZoomerModal = __webpack_require__(925);
	  var VideoExpandedModal = __webpack_require__(933);
	  var Modal = __webpack_require__(929);
	  var LoaderExpanded = __webpack_require__(921);
	  var LocationExpandedModal = __webpack_require__(663);
	  var MegaMenuModal = __webpack_require__(922);
	  var CartExpandedModal = __webpack_require__(913);
	  var OrderComplete = __webpack_require__(457);
	  var SidebarModal = __webpack_require__(932);
	  var SearchModal = __webpack_require__(931);
	  var ClickBlockerModal = __webpack_require__(914);
	  var SessionTimoutOverlay = __webpack_require__(935);
	  var KioskIntroOverlay = __webpack_require__(934);
	  var PageLoading = __webpack_require__(926);
	  var Menu = __webpack_require__(923);
	  var FooterControlBar = __webpack_require__(916);
	  var HeaderControlBar = __webpack_require__(919);
	  var HeaderControlBarKiosk = __webpack_require__(918);
	  var EntryFlow = __webpack_require__(915);
	
	  var DORMANT_MINUTES = 5;
	  var DORMANT_MILLISECONDS = DORMANT_MINUTES * 60 * 1000;
	  // TODO, store in settings..
	  var GEOCODER_OPTIONS = {
	    key: 'AIzaSyBQeJ_Keec7S3We-bZ0rt4NMytIfBCkCtY'
	  };
	  var lsCache = __webpack_require__(77);
	  var Router = Marionette.AppRouter.extend({
	    _navigationHistory: null,
	    appRoutes: {
	      '': 'handleCategoryRoute',
	      'products/:productID': 'handleProductRoute',
	      ':categorySlug(/:subCategorySlug)(/location/:location)(/brand/:vendor)': 'handleCategoryRoute',
	      '*path': 'renderPageNotFoundPage'
	    }
	  });
	  var PublicMenuApp = Marionette.Application.extend({
	    _searchPanelEnabledForModes: ['kiosk'],
	    _filterPanelEnabledForModes: ['menu', 'kiosk'],
	    _addToCartEnabledForModes: ['menu', 'embedded'],
	    _routerEnabledForModes: ['menu', 'kiosk'],
	    _pageLoaderEnabledForModes: ['menu', 'kiosk', 'embedded'],
	    _scrollFetchingEnabledForModes: ['menu', 'kiosk'],
	    _locationSwitchingEnabledForModes: ['menu', 'embedded'],
	    _locationMapEnabledForModes: ['menu'],
	    _dormantTimerEnabledForModes: ['kiosk'],
	    _navigationHistory: [],
	    _menuState: null,
	    _settings: null,
	    _menuItems: null,
	    _initialRoute: true,
	    _showingIntro: true,
	    _menuItemCategories: null,
	    _menuRouter: null,
	    _menu: null,
	    _appChannel: null,
	    _previousQuery: null,
	    _fetchingCategoryProductsXHR: null,
	    _fetchingProductXHR: null,
	    _expandedProductDialog: null,
	    _expandedProductDialogLoader: null,
	    initialize: function initialize(options) {
	      var self = this;
	
	      if ('scrollRestoration' in history) {
	        history.scrollRestoration = 'manual';
	      }
	      self.options = _.defaults(options || {}, {
	        instanceId: self.cid,
	        sort: 'alpha_asc',
	        saleItemsFilterEnabled: false,
	        filterVendor: null,
	        delivery_method: null,
	        menuHomeUrl: null,
	        clearanceItemsFilterEnabled: false,
	        newItemsFilterEnabled: false,
	        thumbStyle: 'thumb', // thumb|full
	        menuItemHash: window.location.hash,
	        redirectURL: URLUtils.getQueryStringValue('redirect'),
	        mode: 'menu', // menu, embedded, slider, kiosk, global
	        isUserLoggedIn: false,
	        userId: 0,
	        multiLocationsSupportEnabled: false,
	        reloadOnSessionTimeout: false
	      });
	
	      this._settings = new Backbone.Model(farmacy.settings);
	
	      self._appChannel = Backbone.Radio.channel('menu:' + self.options.instanceId);
	      self._globalChannel = Backbone.Radio.channel('global');
	
	      self._locations = new LocationEntities.PageableLocationCollection(self.options.locations);
	
	      if (!self.options.filterLocation) {
	        var userSavedLocation = LocationEntities.getUserSavedLocation();
	        var userSavedLocationExists = false;
	
	        self._locations.each(function (model) {
	          if (model.get('slug') === userSavedLocation) {
	            userSavedLocationExists = true;
	          }
	        });
	
	        if (userSavedLocation !== null && userSavedLocationExists === true) {
	          self.options.filterLocation = userSavedLocation;
	        } else {
	          //TODO: figure out a better way... maybe by IP??
	          if (self._locations.findWhere({ slug: self._settings.get('defaultLocationSlug') })) {
	            self.options.filterLocation = self._settings.get('defaultLocationSlug');
	          } else {
	            self.options.filterLocation = 'hillsidevictoria';
	          }
	        }
	      }
	
	      self._menuItemCategories = new EntitiesBase.CollectionBase(self.options.productCategories);
	
	      self._vendors = new ProductVendorEntities.PageableProductVendorsCollection(self.options.productVendors);
	
	      self._menuItemCategories.unshift({
	        name: 'All',
	        slug: 'all',
	        parent_id: 0,
	        id: 'all'
	      });
	
	      self._menuItems = new MenuProductEntities.PageableMenuProductsCollectionLegacy([], {
	        productCategories: self._menuItemCategories
	      });
	
	      var slug;
	      if (self.options.menuItemHash) {
	        slug = self.options.menuItemHash.replace(/^#/, '').toLowerCase();
	      } else {
	        slug = self.options.filter.toLowerCase();
	      }
	
	      self._menuState = new Backbone.Model({
	        menuItems: self._menuItems,
	        menuItemCategories: self._menuItemCategories,
	        productIDs: self.options.productIDs,
	        filterCategorySlugs: self.options.filterCategorySlugs,
	        mode: self.options.mode,
	        filterSaleItems: self.options.saleItemsFilterEnabled,
	        filterNewItems: self.options.newItemsFilterEnabled,
	        filterSort: self.options.sort,
	        filterVendor: self.options.filterVendor,
	        filterClearanceItems: self.options.clearanceItemsFilterEnabled,
	        filterLocation: self.options.filterLocation,
	        currentPage: 1,
	        itemsPerPage: self.calculateNextPageFetchNum(),
	        slug: slug,
	        sideBarOpen: false,
	        retrievingPageData: false,
	        displayedProduct: null,
	        loadingProduct: false,
	        isUserLoggedIn: self.options.isUserLoggedIn,
	        userId: self.options.userId,
	        multiLocationsSupportEnabled: self.options.multiLocationsSupportEnabled,
	        activeViews: new Backbone.Collection([{
	          id: 'thumbs' // thumbs, cartReview, checkoutComplete, productEnlarged, productZoomer, productVideo, sessionTimeoutOverlay, mapLocations
	        }])
	      });
	
	      self._globalChannel.on('load:category', function (categorySlug, subCategorySlug, options) {
	        self._hideMegaMenu();
	
	        if (self.options.mode === 'kiosk') {
	          if (options && options.weeklysales === true) {
	            options.filterSaleItems = true;
	            options.filterClearanceItems = true;
	            self._menuState.set('filterSaleItems', true);
	            self._menuState.set('filterClearanceItems', true);
	          } else {
	            if (!options) {
	              var options = {};
	            }
	            options.filterSaleItems = false;
	            options.filterClearanceItems = false;
	            self._menuState.set('filterSaleItems', false);
	            self._menuState.set('filterClearanceItems', false);
	          }
	        }
	
	        if (self.options.mode == 'global') {
	          // close mega menu...
	          if (window.location.pathname !== '/menu/') {
	            if (!options) {
	              var options = {};
	              options.loadUrl = true;
	            }
	            self.loadCategory(categorySlug, subCategorySlug, options);
	          }
	        } else {
	          // full menu, kiosk... load category...
	          if (self.options.mode != 'embedded') {
	            if (options) {
	              options.mode = self.options.mode;
	            } else {
	              var options = {
	                mode: self.options.mode
	              };
	            }
	            self.loadCategory(categorySlug, subCategorySlug, options);
	          }
	        }
	      });
	
	      self._globalChannel.on('location:selected', function (slug, referrer, fromLocationSlug) {
	        if (self.options.mode == 'global') {
	          var currentFilterLocation = self._menuState.get('filterLocation');
	          var requestedFilterLocation = slug;
	          var currentLocationCartCount = self._appChannel.request('cart:get:items:count');
	
	          var changeLocation = function changeLocation(slug) {
	            self._menuState.set('filterLocation', slug);
	            self._globalChannel.trigger('search:options:changed', {
	              location: slug
	            });
	            lsCache.set('farmUserSavedLocation', slug, 31556952000);
	          };
	
	          if (currentFilterLocation == requestedFilterLocation && referrer !== 'temp_closed') {
	            // dont do anything if the same location was selected...
	            return;
	          }
	
	          // if its the triggered from the cart move items....
	          if (referrer == 'cart') {
	            // move cart items...
	            self._cart.moveCartItemsToLocation(self.options.userId, currentFilterLocation, requestedFilterLocation).then(function (response) {
	              changeLocation(slug);
	              // show cart...
	              self._appChannel.trigger('cart:view');
	            });
	            return;
	          }
	
	          // temp closed...
	          if (referrer == 'temp_closed') {
	            var fromLocationModel = self._locations.findWhere({ slug: fromLocationSlug });
	            var toLocationModel = self._locations.findWhere({ slug: requestedFilterLocation });
	            if (parseInt(fromLocationModel.get('temp_closed')) === 1 || fromLocationModel.get('temp_closed') == true) {
	              self._cart.moveCartItemsToLocation(self.options.userId, currentFilterLocation, requestedFilterLocation).then(function (response) {
	                _.delay(function () {
	                  changeLocation(slug);
	                  _.delay(function () {
	
	                    self._displayModal({
	                      title: 'IMPORTANT INFORMATION!',
	                      description: fromLocationModel.get('name') + ' is temporarily closed. You have been transferred to the Hillside Victoria menu. <br><br>Thanks for understanding. Click to close this message.'
	                    });
	                  }, 500);
	                }, 1500);
	              });
	            }
	            return;
	          }
	
	          if (referrer == 'locationSelectEmbedded') {
	            // move cart items...
	            self._cart.moveCartItemsToLocation(self.options.userId, currentFilterLocation, requestedFilterLocation).then(function (response) {
	              changeLocation(slug);
	              window.stop();
	              $(location).prop('href', window.location.protocol + '//' + window.location.hostname + '/' + '/menu/#all/location/' + slug);
	            });
	            return;
	          }
	
	          // cart has items in it trigger dialog to see if the customer wants to transfer the items.
	          if (currentLocationCartCount && currentLocationCartCount > 0) {
	            self._appChannel.trigger('show:confirm:dialog', {
	              showCancelButton: true,
	              cancelButtonLabel: 'No, Thanks',
	              confirmText: 'You have ' + currentLocationCartCount + ' item(s) in your cart, did you want to move them to the selected location? Some things may not be in stock at the selected location.',
	              confirmButtonLabel: 'Yes, Please',
	              confirmedCallback: function confirmedCallback() {
	                // move cart items...
	                self._cart.moveCartItemsToLocation(self.options.userId, currentFilterLocation, requestedFilterLocation).then(function (response) {
	                  changeLocation(slug);
	                });
	              },
	              cancelledCallback: function cancelledCallback() {
	                changeLocation(slug);
	              }
	            });
	          } else {
	            // nothing in cart change location...
	            changeLocation(slug);
	          }
	        } // end if self.options.mode == 'menu'
	      });
	
	      self._globalChannel.on('menu:overlay:view:close', function (view) {
	        self._appChannel.trigger('menu:overlay:view:close', view);
	      });
	
	      self._globalChannel.on('search:options:changed', function (searchOptions) {
	        if (self.options.mode == 'menu' || self.options.mode == 'embedded' && searchOptions.location) {
	          var categorySlug = null;
	          if (searchOptions.categorySlug) {
	            categorySlug = searchOptions.categorySlug;
	          }
	
	          var subCategorySlug = null;
	          if (searchOptions.subCategorySlug) {
	            subCategorySlug = searchOptions.subCategorySlug;
	          }
	
	          return self.loadCategory(categorySlug, subCategorySlug, searchOptions);
	        }
	      });
	
	      self._globalChannel.on('active:view:add', function (id) {
	        if (id !== 'paymentCart') {
	          if (self._cart) {
	            self._cart.clearCardDetails();
	          }
	        }
	        if (id !== 'reviewCart' && id !== 'paymentCart' && id !== 'successCart' && id !== 'challengeCart') {
	          self._hideExpandedCart();
	        }
	        if (id !== 'sidebar') {
	          self._hideSideBarMenu();
	        }
	        self._menuState.get('activeViews').add(new Backbone.Model({
	          id: id
	        }));
	
	        if (self._menuState.get('activeViews').length > 1) {
	          $('body').addClass('fmcy-showing-menu-overlay');
	          $('html').addClass('fmcy-showing-menu-overlay');
	        }
	
	        self._appChannel.trigger('active:view:updated', self._menuState.get('activeViews'));
	      });
	
	      self._globalChannel.on('active:view:remove', function (id) {
	        var model = self._menuState.get('activeViews').findWhere({
	          id: id
	        });
	        if (model) {
	          self._menuState.get('activeViews').remove(model);
	        }
	        if (self._menuState.get('activeViews').length === 1) {
	          $('body').removeClass('fmcy-showing-menu-overlay');
	          $('html').removeClass('fmcy-showing-menu-overlay');
	          if ($('body').hasClass('fmcy-product-tile-theme-dark')) {
	            $('body').removeClass('fmcy-product-tile-theme-dark');
	          }
	        }
	
	        self._appChannel.trigger('active:view:updated', self._menuState.get('activeViews'));
	      });
	
	      // local...
	      self._appChannel.reply('active:view:check', function (id) {
	        var active = false;
	        self._menuState.get('activeViews').each(function (model) {
	          if (id === model.get('id')) {
	            active = true;
	          }
	        });
	        return active;
	      });
	
	      self._appChannel.on('active:view:add', function (id) {
	        self._globalChannel.trigger('active:view:add', id);
	      });
	
	      self._appChannel.on('active:view:remove', function (id) {
	        self._globalChannel.trigger('active:view:remove', id);
	      });
	
	      self._appChannel.on('show:login:dialog', function (model) {
	        window.jQuery(window.document).trigger('lrm_show_signin');
	      });
	
	      self._appChannel.on('show:register:dialog', function (model) {
	        window.jQuery(window.document).trigger('lrm_show_register');
	      });
	
	      self._appChannel.on('cart:add:item', function (variantModel, menuItemModel) {
	        self._globalChannel.trigger('cart:add:item', variantModel, menuItemModel);
	      });
	
	      self._appChannel.on('gtag:event', function (eventName, eventObject) {
	        // only log this event on production...
	        if (window.location.host == 'originalfarm.com') {
	          gtag('event', eventName, eventObject);
	        }
	      });
	
	      self._appChannel.on('gtag:page:view', function (page_title, page_path) {
	        if (window.location.host == 'originalfarm.com') {
	          gtag('config', 'UA-80125340-1', {
	            'page_path': page_path
	          });
	          gtag('config', 'G-RQS96HQHRY', {
	            'page_path': page_path
	          });
	        }
	      });
	
	      self._appChannel.reply('get:filter:location', function () {
	        return self._menuState.get('filterLocation');
	      });
	
	      self._appChannel.reply('get:filter:location:details', function () {
	        var currentLocationModel = null;
	        self._locations.each(function (location) {
	          if (self._menuState.get('filterLocation') === location.get('slug')) {
	            currentLocationModel = location;
	          }
	        });
	        if (currentLocationModel === null) {
	          currentLocationModel = self._locations.at(0);
	          self._menuState.set('filterLocation', currentLocationModel.get('slug'));
	        }
	        return currentLocationModel;
	      });
	
	      self._globalChannel.on('filterLocationChanged', function (filterLocation) {
	        if (self._menuState.get('filterLocation') !== filterLocation) {
	          self._menuState.set('filterLocation', filterLocation);
	        }
	      });
	
	      self._menuState.on('change:filterLocation', function (model) {
	        self._appChannel.trigger('cart:items:updated');
	        self._globalChannel.trigger('filterLocationChanged', model.get('filterLocation'));
	      });
	
	      self._appChannel.on('menu:sidebar:view', function () {
	        if (self._menuState.get('sideBarOpen') == true) {
	          self._hideSideBarMenu();
	        } else {
	          self._displaySideBarMenu({
	            isUserLoggedIn: self.options.isUserLoggedIn
	          });
	        }
	      });
	
	      self._appChannel.on('menu:overlay:view:close', function (except) {
	        if (except !== 'sidebar') {
	          self._hideSideBarMenu();
	        }
	        if (except !== 'search') {
	          self._hideSearchMenu();
	        }
	        if (except !== 'megamenu') {
	          self._hideMegaMenu();
	        }
	      });
	
	      self._appChannel.on('show:confirm:dialog', function (options) {
	        self._globalChannel.trigger('show:confirm:dialog', options);
	      });
	
	      self._appChannel.on('menu:search:view', function (options) {
	        self._globalChannel.trigger('menu:search:view', options);
	      });
	
	      self._appChannel.on('menu:search:view:close', function () {
	        self._globalChannel.trigger('menu:search:view:close');
	      });
	
	      self._appChannel.reply('cart:get:delivery:model', function () {
	        return self._globalChannel.request('cart:get:delivery:model');
	      });
	
	      self._appChannel.reply('validate:address:geocode', function (address) {
	        return self._globalChannel.request('validate:address:geocode', address);
	      });
	
	      self._appChannel.reply('validate:postal:code:delivery:area', function (postalCode) {
	        return self._globalChannel.request('validate:postal:code:delivery:area', postalCode);
	      });
	
	      self._appChannel.reply('validate:is:delivery:available:anywhere', function () {
	        return self._globalChannel.request('validate:is:delivery:available:anywhere');
	      });
	
	      self._appChannel.reply('validate:is:delivery:available:at:this:time', function () {
	        return self._globalChannel.request('validate:is:delivery:available:at:this:time');
	      });
	
	      self._globalChannel.on('update:favourite', function (productId, isFavourite) {
	        var channelName = 'update:favourite:' + productId;
	        self._appChannel.trigger(channelName, isFavourite);
	      });
	
	      self._customer = null;
	
	      if (self.options.mode == 'global' || self.options.mode == 'kiosk') {
	        if (self.options.isUserLoggedIn) {
	          self._customer = CustomerEntities.CustomerModel(self.options.userData);
	          self._pubsub = new (__webpack_require__(303))({
	            subscribeKey: this._settings.get('pubnub').subscribeKey,
	            publishKey: this._settings.get('pubnub').publishKey,
	            uuid: self._customer.get('pubnubuuid')
	          });
	          self._addPubSubListeners(self._customer.get('orders').get_active_order_channels());
	
	          // set user id in google analytics...
	          gtag('config', 'UA-80125340-1', {
	            'user_id': self.options.userId
	          });
	          gtag('config', 'G-RQS96HQHRY', {
	            'user_id': self.options.userId
	          });
	        } // end if user logged in...
	
	        new (__webpack_require__(724))({
	          defaultIconUrl: 'https://farm-email-content.s3-us-west-2.amazonaws.com/common/f_logo_small.png'
	        });
	
	        self._appChannel.reply('customer:get:data', function () {
	          return self._customer;
	        });
	
	        self._cart = CartEntities.Cart();
	
	        self._appChannel.reply('cart:get:payment:model', function () {
	          return self._cart.paymentModel;
	        });
	
	        self._globalChannel.reply('toggle:favourite', function (productModel, isFavourite) {
	          self._globalChannel.trigger('update:favourite', productModel.get('id'), isFavourite);
	          var $deferred = $.Deferred();
	          Backbone.Radio.channel('global').request('ajax', 'farmacyajaxv2-favourite-product', {
	            productId: productModel.get('id'),
	            isFavourite: isFavourite
	          }).success(function (response) {
	            if (response.error == false) {
	              if (isFavourite == true) {
	                self._customer.get('favourite_products').add(response.data);
	              } else {
	                var favModel = self._customer.get('favourite_products').findWhere({ 'product_id': productModel.get('id') });
	                if (favModel) {
	                  self._customer.get('favourite_products').remove(favModel);
	                }
	              }
	            }
	            $deferred.resolve({
	              error: response.error
	            });
	          }).fail(function (error) {
	            $deferred.resolve({
	              error: true
	            });
	          });
	          return $deferred.promise();
	        });
	
	        self._globalChannel.reply('get:customer:favourites', function () {
	          return self._customer.get('favourite_products');
	        });
	
	        self._globalChannel.reply('is:favourite', function (productModel) {
	          var isFavourite = false;
	          var $deferred = $.Deferred();
	          if (self._customer && self._customer.get('favourite_products').length) {
	            var favModel = self._customer.get('favourite_products').findWhere({ 'product_id': productModel.get('id') });
	            if (favModel) {
	              isFavourite = true;
	            }
	          }
	
	          $deferred.resolve(isFavourite);
	          return $deferred.promise();
	        });
	
	        self._globalChannel.reply('cart:get:delivery:model', function () {
	          return self._cart.deliveryModel;
	        });
	
	        self._globalChannel.reply('validate:is:delivery:available:anywhere', function () {
	          var delivery_available = false;
	          self._locations = self._appChannel.request('get:locations');
	          self._locations.forEach(function (location, index) {
	            if ((parseInt(location.get('delivery_active')) == 1 || location.get('delivery_active') == true) && (location.get('delivery_area_postal_codes') || location.get('delivery_area_geojson')) && (location.get('delivery_area_postal_codes').length > 1 || location.get('delivery_area_geojson').length > 1)) {
	              delivery_available = true;
	            }
	          });
	          return delivery_available;
	        });
	
	        self._globalChannel.reply('validate:is:delivery:available:at:this:time', function () {
	          var delivery_available_at_this_time = true;
	          var delivery_next_available = false;
	          var currentSelectedLocation = self._appChannel.request('get:filter:location:details');
	          var isDeliveryAvailableAtCurrentTime = currentSelectedLocation.isDeliveryAvailableAtCurrentTime();
	          if (parseInt(currentSelectedLocation.get('delivery_active')) == 0 || currentSelectedLocation.get('delivery_active') == false) {
	            delivery_available_at_this_time = false;
	          } else {
	            if (isDeliveryAvailableAtCurrentTime.available == false && parseInt(currentSelectedLocation.get('delivery_active')) !== 0 && currentSelectedLocation.get('delivery_active') !== false && currentSelectedLocation.get('delivery_area_postal_codes') !== null && currentSelectedLocation.get('delivery_area_postal_codes') != '' && farmacy.settings.payments.creditCardPaymentEnabled == true) {
	              // delivery, payments and has a delivery area just not within delivery hours
	              // check is delivery available in the future....
	              var deliveryNextAvailable = currentSelectedLocation.deliveryNextAvailable();
	              if (deliveryNextAvailable.available) {
	                delivery_available_at_this_time = false;
	                delivery_next_available = deliveryNextAvailable;
	              }
	            }
	          }
	          return {
	            deliveryAvailableAtThisTime: delivery_available_at_this_time,
	            deliveryNextAvailable: delivery_next_available
	          };
	        });
	
	        self._globalChannel.reply('validate:postal:code:delivery:area', function (postalCode) {
	          var $deferred = $.Deferred();
	          var geocoder = NodeGeocoder(GEOCODER_OPTIONS);
	          var withinDeliveryArea = false;
	          var withinCurrentFarmLocation = false;
	          var withinDeliveryAreaSlug = null;
	          var withinDeliveryAreaLocation = null;
	          var response = {};
	
	          // check postal code against array of postal codes for location
	          self._locations = self._appChannel.request('get:locations');
	          self._locations.forEach(function (location, index) {
	            var deliveryAreaPostalCodes = null;
	            if ((parseInt(location.get('delivery_active')) == 1 || location.get('delivery_active') == true) && location.get('delivery_area_postal_codes') && location.get('delivery_area_postal_codes') !== '') {
	              deliveryAreaPostalCodes = location.get('delivery_area_postal_codes');
	            }
	            if (deliveryAreaPostalCodes) {
	              var deliveryAreaPostalCodesArray = deliveryAreaPostalCodes.split(',');
	              var postCodeCompare = postalCode.replace(' ', '').replace(/\W/g, '');
	
	              deliveryAreaPostalCodesArray.forEach(function (deliveryAreaPostalCode) {
	                if (StringUtils.matchWildCard(postCodeCompare.toLowerCase(), deliveryAreaPostalCode.toLowerCase().replace(' ', ''))) {
	                  withinDeliveryArea = true;
	                  withinDeliveryAreaSlug = location.get('slug');
	                  withinDeliveryAreaLocation = location;
	                }
	              });
	            }
	          }); // end locations foreach
	
	          if (withinDeliveryArea == true) {
	            // fire and forget postal code logging
	            self._globalChannel.trigger('save:postal:code:to:log', postalCode, 1);
	
	            var deliveryAddressModel = self._cart.deliveryModel.get('cartDeliveryAddressModel');
	            deliveryAddressModel.set('local_delivery_postal_code', postalCode);
	            deliveryAddressModel.set('local_delivery_postal_code_verified', postalCode);
	            deliveryAddressModel.set('local_delivery_confirmed_farm_location_slug', withinDeliveryAreaSlug);
	            deliveryAddressModel.set('local_delivery_street_address_geocoded_apartment', null);
	            deliveryAddressModel.set('local_delivery_street_address_geocoded_city', null);
	            deliveryAddressModel.set('local_delivery_street_address_geocoded_country', null);
	            deliveryAddressModel.set('local_delivery_street_address_geocoded_lat', null);
	            deliveryAddressModel.set('local_delivery_street_address_geocoded_lon', null);
	            deliveryAddressModel.set('local_delivery_street_address_geocoded_postal_code', null);
	            deliveryAddressModel.set('local_delivery_street_address_geocoded_state', null);
	            deliveryAddressModel.set('local_delivery_street_address_geocoded_street_address', null);
	            deliveryAddressModel.set('local_delivery_street_address_geocoded_street_name', null);
	            deliveryAddressModel.set('local_delivery_street_address_geocoded_response', null);
	            deliveryAddressModel.set('local_delivery_street_address_verified', null);
	
	            // save the address to local storage...
	            lsCache.set('cartDeliveryAddressModel', deliveryAddressModel.toJSON(), 14400000);
	
	            $deferred.resolve({
	              error: false,
	              response: {
	                withinDeliveryAreaSlug: withinDeliveryAreaSlug
	              }
	            });
	          } else {
	            self._globalChannel.trigger('save:postal:code:to:log', postalCode, 0);
	            self._locations = self._appChannel.request('get:locations');
	            var anyLocationHasGeoJSON = false;
	            self._locations.forEach(function (location, index) {
	              var deliveryAreaGeoJson = null;
	              if ((parseInt(location.get('delivery_active')) == 1 || location.get('delivery_active') == true) && location.get('delivery_area_geojson') && location.get('delivery_area_geojson') !== '') {
	                deliveryAreaGeoJson = JSON.parse(location.get('delivery_area_geojson'));
	              }
	              if (deliveryAreaGeoJson && deliveryAreaGeoJson.features) {
	                anyLocationHasGeoJSON = true;
	              }
	            }); // end locations foreach
	
	            if (!anyLocationHasGeoJSON) {
	              var deliveryAddressModel = self._cart.deliveryModel.get('cartDeliveryAddressModel');
	              deliveryAddressModel.set('local_delivery_postal_code_verified', false);
	              deliveryAddressModel.set('local_delivery_confirmed_farm_location_slug', null);
	              lsCache.set('cartDeliveryAddressModel', deliveryAddressModel.toJSON(), 14400000);
	
	              $deferred.resolve({
	                error: true,
	                response: response
	              });
	            } else {
	              // if we get here a location has geojson, geocode...
	              geocoder.find(postalCode, function (err, res) {
	                // process response object
	                var error = false;
	                var response = {};
	
	                if (res && res.length) {
	                  var geocode = res[0];
	                  // first check if the response is in BC
	                  if (geocode.administrative_area_level_1 && geocode.administrative_area_level_1.short_name !== 'BC') {
	                    // not BC
	                    error = true;
	                  } else {
	                    //within BC....
	                    response = {
	                      place_name: null,
	                      latLng: null,
	                      state: null,
	                      postalCode: null,
	                      country: 'Canada',
	                      city: null,
	                      street_address: null,
	                      street_name: null,
	                      apartment: null
	                    };
	                    if (geocode.formatted_address) {
	                      response.place_name = geocode.formatted_address;
	                    }
	                    if (geocode.location) {
	                      response.latLng = [geocode.location.lat, geocode.location.lng];
	                    }
	                    if (geocode.administrative_area_level_1) {
	                      response.state = geocode.administrative_area_level_1.long_name;
	                    }
	                    if (geocode.postal_code) {
	                      response.postalCode = geocode.postal_code.long_name;
	                    }
	                    if (geocode.city) {
	                      response.city = geocode.city.long_name;
	                    }
	                    if (geocode.street_number) {
	                      response.street_address = geocode.street_number.long_name;
	                    }
	                    if (geocode.route) {
	                      response.street_name = geocode.route.short_name;
	                    }
	                    if (geocode.subpremise) {
	                      response.apartment = geocode.subpremise.long_name;
	                    }
	
	                    if (response.latLng == null) {
	                      error = true;
	                    }
	                  }
	                } else {
	                  error = true;
	                }
	                if (error) {
	                  $deferred.resolve({
	                    error: true,
	                    response: response
	                  });
	                } else {
	
	                  var points = turf.points([[response.latLng[1], response.latLng[0]]]);
	
	                  self._locations.forEach(function (location, index) {
	                    var deliveryAreaGeoJson = null;
	                    if ((parseInt(location.get('delivery_active')) == 1 || location.get('delivery_active') == true) && location.get('delivery_area_geojson') && location.get('delivery_area_geojson') !== '') {
	                      deliveryAreaGeoJson = JSON.parse(location.get('delivery_area_geojson'));
	                    }
	                    if (deliveryAreaGeoJson && deliveryAreaGeoJson.features) {
	                      deliveryAreaGeoJson.features.forEach(function (feature, index) {
	                        var searchWithin = turf.polygon(feature.geometry.coordinates);
	                        var ptsWithin = turf.pointsWithinPolygon(points, searchWithin);
	                        if (ptsWithin.features.length > 0) {
	                          withinDeliveryArea = true;
	                          withinDeliveryAreaSlug = location.get('slug');
	                          withinDeliveryAreaLocation = location;
	                        }
	                      });
	                    }
	                  }); // end locations foreach
	
	
	                  if (withinDeliveryArea == true) {
	                    var deliveryAddressModel = self._cart.deliveryModel.get('cartDeliveryAddressModel');
	                    deliveryAddressModel.set('local_delivery_postal_code', postalCode);
	                    deliveryAddressModel.set('local_delivery_street_address_geocoded_lat', response.latLng[0]);
	                    deliveryAddressModel.set('local_delivery_street_address_geocoded_lon', response.latLng[1]);
	                    deliveryAddressModel.set('local_delivery_street_address_geocoded_response', response.place_name);
	                    deliveryAddressModel.set('local_delivery_street_address_geocoded_state', response.state);
	                    deliveryAddressModel.set('local_delivery_street_address_geocoded_postal_code', response.postalCode);
	                    deliveryAddressModel.set('local_delivery_street_address_geocoded_country', response.country);
	                    deliveryAddressModel.set('local_delivery_street_address_geocoded_city', response.city);
	                    deliveryAddressModel.set('local_delivery_postal_code_verified', postalCode);
	                    deliveryAddressModel.set('local_delivery_confirmed_farm_location_slug', withinDeliveryAreaSlug);
	
	                    deliveryAddressModel.set('local_delivery_street_address', null);
	                    deliveryAddressModel.set('local_delivery_street_address_geocoded_street_name', null);
	                    deliveryAddressModel.set('local_delivery_street_address_geocoded_street_address', null);
	                    deliveryAddressModel.set('local_delivery_street_address_geocoded_apartment', null);
	                    deliveryAddressModel.set('local_delivery_street_address_verified', false);
	
	                    // save the address to local storage...
	                    lsCache.set('cartDeliveryAddressModel', deliveryAddressModel.toJSON(), 14400000);
	
	                    $deferred.resolve({
	                      error: false,
	                      response: {
	                        withinDeliveryAreaSlug: withinDeliveryAreaSlug
	                      }
	                    });
	                  } else {
	
	                    var deliveryAddressModel = self._cart.deliveryModel.get('cartDeliveryAddressModel');
	                    deliveryAddressModel.set('local_delivery_postal_code_verified', false);
	                    deliveryAddressModel.set('local_delivery_confirmed_farm_location_slug', null);
	                    lsCache.set('cartDeliveryAddressModel', deliveryAddressModel.toJSON(), 14400000);
	
	                    $deferred.resolve({
	                      error: true,
	                      response: response
	                    });
	                  }
	                } //end if else error
	              }); // end geocode
	            }
	          }
	
	          return $deferred.promise();
	        });
	
	        self._globalChannel.reply('validate:address:geocode', function (address) {
	          var $deferred = $.Deferred();
	          var geocoder = NodeGeocoder(GEOCODER_OPTIONS);
	          geocoder.find(address, function (err, res) {
	            // process response object
	            var error = false;
	            var response = {};
	            if (res.length) {
	              var geocode = res[0];
	              // first check if the response is in BC
	              if (geocode.administrative_area_level_1 && geocode.administrative_area_level_1.short_name !== 'BC') {
	                // not BC
	                error = true;
	              } else {
	                //within BC....
	                response = {
	                  place_name: null,
	                  latLng: null,
	                  state: null,
	                  postalCode: null,
	                  country: 'Canada',
	                  city: null,
	                  street_address: null,
	                  street_name: null,
	                  apartment: null
	                };
	                if (geocode.formatted_address) {
	                  response.place_name = geocode.formatted_address;
	                }
	                if (geocode.location) {
	                  response.latLng = [geocode.location.lat, geocode.location.lng];
	                }
	                if (geocode.administrative_area_level_1) {
	                  response.state = geocode.administrative_area_level_1.long_name;
	                }
	                if (geocode.postal_code) {
	                  response.postalCode = geocode.postal_code.long_name;
	                }
	                if (geocode.city) {
	                  response.city = geocode.city.long_name;
	                }
	                if (geocode.street_number) {
	                  response.street_address = geocode.street_number.long_name;
	                }
	                if (geocode.route) {
	                  response.street_name = geocode.route.short_name;
	                }
	                if (geocode.subpremise) {
	                  response.apartment = geocode.subpremise.long_name;
	                }
	
	                if (response.street_address == null || response.street_name == null || response.city == null || response.latLng == null) {
	                  error = true;
	                }
	              }
	            } else {
	              error = true;
	            }
	            if (error) {
	              $deferred.resolve({
	                error: true,
	                response: response
	              });
	            } else {
	              $deferred.resolve({
	                error: false,
	                response: response
	              });
	            }
	          });
	          return $deferred.promise();
	        });
	
	        self._globalChannel.on('save:postal:code:to:log', function (postalCode, withinDeliveryArea) {
	          if (self._settings && self._settings.get('aws') && self._settings.get('aws').api_url) {
	            var url = self._settings.get('aws').api_url + 'postalcode';
	            var headers = {
	              'Accept': 'application/json',
	              'Content-Type': 'application/json'
	            };
	            $.ajax({
	              url: url,
	              type: 'POST',
	              data: (0, _stringify2.default)({
	                postalCode: postalCode,
	                existsWithinDeliveryArea: withinDeliveryArea
	              }),
	              headers: headers,
	              contentType: 'application/json',
	              dataType: 'json'
	            });
	          }
	        });
	
	        self._appChannel.reply('cart:get:payment:method:model', function () {
	          // TODO, make this a function and get the correct model based on payment method...
	          return self._cart.paymentModel.get('paymentCreditCardModel');
	        });
	
	        self._appChannel.on('cart:set:payment:method', function (paymentMethod) {
	          self._cart.paymentModel.set('paymentMethod', paymentMethod);
	        });
	
	        self._appChannel.on('cart:set:delivery:method', function (deliveryMethod) {
	          self._cart.deliveryModel.set('deliveryMethod', deliveryMethod);
	        });
	
	        self._appChannel.on('cart:remove:item', function (model) {
	          self._cart.findWhere({
	            variant_id: model.get('variant_id'),
	            location: model.get('location'),
	            user_id: model.get('user_id')
	          }).destroy();
	
	          self._appChannel.trigger('cart:items:updated');
	        });
	
	        self._globalChannel.on('member:joined:club', function () {
	          if (self._customer) {
	            self._customer.set('is_club_member', '1');
	          }
	        });
	
	        self._globalChannel.on('member:name:updated', function (model) {
	          if (self._customer) {
	            self._customer.set('first_name', model.get('first_name'));
	            self._customer.set('last_name', model.get('last_name'));
	            self._customer.set('display_name', model.get('first_name') + ' ' + model.get('last_name'));
	          }
	        });
	
	        self._globalChannel.reply('order:cancel', function (model) {
	          return self._customer.get('orders').cancel_order(model);
	        });
	
	        self._globalChannel.reply('get:navigation:history', function () {
	          return self._navigationHistory;
	        });
	
	        self._globalChannel.on('add:navigation:history:entry', function (entry) {
	          if (self._navigationHistory) {
	            if (self._navigationHistory.length == 0 || self._navigationHistory[self._navigationHistory.length - 1].fragment !== entry.fragment) {
	              self._navigationHistory.push(entry);
	              self._appChannel.trigger('gtag:page:view', '', window.location.pathname + '#' + entry.fragment);
	            }
	          }
	        });
	
	        self._globalChannel.on('menu:search:view', function (options) {
	          if (self._menuState.get('searchOpen') == true) {
	            self._hideSearchMenu();
	          } else {
	            self._displaySearchMenu(_.extend(options, {
	              isUserLoggedIn: self.options.isUserLoggedIn
	            }));
	          }
	        });
	
	        self._globalChannel.reply('load:product', function (productSlug, productId, productModel) {
	          return self.loadProduct(productSlug, productId, productModel);
	        });
	
	        self._globalChannel.on('menu:search:view:close', function () {
	          if (self._menuState.get('searchOpen') == true) {
	            self._hideSearchMenu();
	          }
	        });
	
	        self._globalChannel.on('cart:add:item', function (variantModel, menuItemModel) {
	          if (!self._menuState.get('isUserLoggedIn')) {
	            self._appChannel.trigger('show:login:dialog');
	            return;
	          }
	          self._cart.addCartItem(self._menuState.get('filterLocation'), self.options.userId, variantModel, menuItemModel);
	          self._appChannel.trigger('cart:items:update:subtotals');
	          self._appChannel.trigger('cart:items:updated');
	          return self._cart;
	        });
	
	        self._appChannel.on('cart:items:update:subtotals', function () {
	          self._cart.updateSubTotals(self._menuState.get('filterLocation'), self.options.userId);
	        });
	
	        self._appChannel.reply('cart:get:items', function () {
	          return self._cart.itemsByUserLocation(self._menuState.get('filterLocation'), self.options.userId);
	        });
	
	        self._appChannel.reply('cart:get:items:count', function () {
	          return self._cart.totalCountByUserLocation(self._menuState.get('filterLocation'), self.options.userId);
	        });
	
	        self._appChannel.reply('cart:get:curent:order', function () {
	          return self._cart.paymentModel.get('currentOrder');
	        });
	
	        self._appChannel.reply('cart:get:total:cost', function () {
	          var filteredLocationDetails = self._appChannel.request('get:filter:location:details');
	          return self._cart.totalCostByUserLocation(self.options.userId, self._menuState.get('filterLocation'), filteredLocationDetails);
	        });
	
	        self._appChannel.reply('cart:get:total:weight', function () {
	          return self._cart.totalCartWeight({
	            filterLocation: self._menuState.get('filterLocation'),
	            userId: self.options.userId
	          });
	        });
	
	        self._appChannel.reply('cart:validate:prices', function () {
	          return self._cart.checkCartItemsForPriceChanges(self._menuState.get('filterLocation'), self.options.userId);
	        });
	
	        self._appChannel.on('cart:pay', function () {
	          self._displayClickBlocker();
	
	          self._locations.fetch().then(function () {
	            var filteredLocationDetails = self._appChannel.request('get:filter:location:details');
	            // validate cart once more before paying if they left the payment view open for awhile...
	            self._cart.validateCartContents(self.options.userId, self._menuState.get('filterLocation'), filteredLocationDetails).then(function (response) {
	              if (response.errors && response.errors.length > 0) {
	                // errors go back a step....
	                self._displayExpandedCart({
	                  errors: response.errors
	                });
	                self._hideClickBlocker();
	              } else {
	                // no errors... lets pay.
	                var creditCardModelValidationFields = self._cart.paymentModel.get('paymentCreditCardModel').validationFields();
	                var cartValid = self._cart.paymentModel.get('paymentCreditCardModel').isValid(creditCardModelValidationFields);
	                if (cartValid) {
	                  self._orderPay();
	                } else {
	                  self._hideClickBlocker();
	                  self._appChannel.trigger('cart:display:errors');
	                }
	              }
	            });
	          });
	        }); // end cart:pay
	
	        self._appChannel.on('cart:close', function () {
	          self._hideExpandedCart();
	        });
	
	        self._appChannel.on('cart:validate', function () {
	          self._displayClickBlocker();
	
	          if (farmacy.settings.giftEnabled) {
	            //check gift form is valid...
	            var giftModelValidationFields = self._cart.paymentModel.get('cartGiftModel').validationFields();
	            var shouldValidateGiftForm = self._cart.paymentModel.get('cartGiftModel').shouldValidateGiftForm();
	            if (shouldValidateGiftForm) {
	              var giftFormValid = self._cart.paymentModel.get('cartGiftModel').isValid(giftModelValidationFields);
	              if (giftFormValid == false) {
	                self._displayExpandedCart({
	                  errorMessage: 'Please review the gift form below:',
	                  errors: [{
	                    code: 'giftform'
	                  }]
	                });
	                self._hideClickBlocker();
	                return;
	              }
	            }
	          }
	
	          // double check cart prices in the case someone has left the cart open overnight and the prices have changed...
	          self._appChannel.request('cart:validate:prices').then(function (response) {
	            if (response.changeCount > 0) {
	              // priced have changed, so cart and error message...
	              self._displayExpandedCart({
	                errorMessage: 'Some prices have changed. Please review.',
	                errors: [{
	                  code: 'pricechanges'
	                }]
	              });
	              self._hideClickBlocker();
	            } else {
	
	              self._locations.fetch().then(function () {
	                var filteredLocationDetails = self._appChannel.request('get:filter:location:details');
	                self._cart.validateCartContents(self.options.userId, self._menuState.get('filterLocation'), filteredLocationDetails).then(function (response) {
	                  if (response.errors && response.errors.length > 0) {
	                    self._displayExpandedCart({
	                      errors: response.errors
	                    });
	                    self._hideClickBlocker();
	                  } else {
	                    self._submitOrder();
	                  }
	                }).fail(function (response) {
	                  console.log(response);
	                }); // end cart _cart.validateCartContents
	              }).fail(function (response) {
	                self._displayExpandedCart({
	                  errorMessage: 'Problem, please try again.',
	                  errors: [{
	                    code: 'fetcherror'
	                  }]
	                });
	                self._hideClickBlocker();
	              }); // end locations fetch  
	            } // end no price change count...
	          });
	        });
	
	        self._appChannel.on('cart:view', function () {
	          if (!self._menuState.get('isUserLoggedIn')) {
	            self._appChannel.trigger('show:login:dialog');
	            return;
	          }
	          self._displayExpandedCart();
	        });
	
	        self._appChannel.on('location:selection:view', function (options) {
	          self._displayEntryDialog(options);
	          //self._displayExpandedLocationSelection(options);
	        });
	
	        self._globalChannel.on('location:selection:view', function (options) {
	          //self._displayExpandedLocationSelection(options);
	          self._displayEntryDialog(options);
	        });
	
	        self._globalChannel.on('display:mega:menu', function (options) {
	          self._displayMegaMenu(options);
	        });
	      } // end if global...
	
	      self._appChannel.on('display:mega:menu', function (options) {
	        return self._globalChannel.trigger('display:mega:menu', options);
	      });
	
	      self._appChannel.reply('order:cancel', function (model) {
	        return self._customer.get('orders').cancel_order(model);
	      });
	
	      self._appChannel.reply('order:update:status', function (order) {
	        var model = self._customer.get('orders').update_status(order.order_id, order.order_status, order.order_payment_status);
	        self._appChannel.trigger('orders:updated');
	        return model;
	      });
	
	      self._appChannel.reply('orders:ready:count', function () {
	        if (self._customer !== null) {
	          return self._customer.get('orders').get_ready_count();
	        } else {
	          return 0;
	        }
	      });
	
	      self._appChannel.reply('is:user:logged:in', function () {
	        return self._menuState.get('isUserLoggedIn');
	      });
	
	      self._appChannel.reply('get:locations', function () {
	        return self._locations;
	      });
	
	      self._appChannel.reply('get:vendors', function () {
	        return self._vendors;
	      });
	
	      self._appChannel.reply('get:filter:vendor', function () {
	        return self._menuState.get('filterVendor');
	      });
	
	      self._appChannel.reply('get:navigation:history', function () {
	        return self._globalChannel.request('get:navigation:history');
	      });
	
	      self._appChannel.reply('scroll:to:page:top', function () {
	        if (self._appChannel.request('active:view:check', 'paymentCart')) {
	          UIUtils.scrollToPageTop(self._expandedCartModal.$el);
	        } else {
	          UIUtils.scrollToPageTop();
	        }
	      });
	
	      self._appChannel.reply('load:category', function (categorySlug, subCategorySlug, options) {
	        if (options && options.mode && options.mode === 'embedded') {
	          self.loadCategory(categorySlug, subCategorySlug, options);
	        } else {
	          self._globalChannel.trigger('load:category', categorySlug, subCategorySlug, options);
	        }
	      });
	      self._appChannel.reply('load:product', function (productSlug, productId, productModel) {
	        return self.loadProduct(productSlug, productId, productModel);
	      });
	
	      self._appChannel.reply('load:product:url', function (productSlug) {
	        if (!window.location.origin) {
	          window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
	        }
	        var productURL = window.location.origin + '/menu/' + '#products/' + productSlug;
	        try {
	          window.stop();
	        } catch (exception) {
	          document.execCommand('Stop');
	        }
	        $(location).prop('href', productURL);
	        return;
	      });
	
	      self._appChannel.reply('load:product:zoomer', function (product) {
	        return self._displayProductZoomer(product);
	      });
	
	      self._appChannel.reply('load:enlarged:video', function (video, collection) {
	        return self._displayEnlargedVideo(video, collection);
	      });
	
	      self._appChannel.on('search:options:changed', function (searchOptions) {
	        self._globalChannel.trigger('search:options:changed', searchOptions);
	      });
	
	      self._appChannel.on('location:selected', function (slug, referrer) {
	        self._globalChannel.trigger('location:selected', slug, referrer);
	      });
	
	      self._appChannel.on('age:yes:clicked', function () {
	        var serverUnixTime = self._serverUnixTime();
	        var lastAgeGateYesClickedTime = lsCache.get('lastAgeGateYesClickedTime');
	        var serverDateTimeString = DateUtils.getFormattedTimestamp(serverUnixTime, {
	          format: 'YYYY-MM-DD H:mmA'
	        });
	        var endOfDayUnixTime = moment(serverDateTimeString, 'YYYY-MM-DD H:mmA').endOf('day').unix();
	        var secondsToMidnight = (endOfDayUnixTime - serverUnixTime) / 60;
	
	        // expire this cache at midnight, which will show the modal.
	        lsCache.set('lastAgeGateYesClickedTime', serverUnixTime, secondsToMidnight);
	      });
	
	      self._appChannel.reply('toggle:favourite', function (productModel, isFavourite) {
	        return self._globalChannel.request('toggle:favourite', productModel, isFavourite);
	      });
	
	      self._appChannel.reply('is:favourite', function (productModel) {
	        return self._globalChannel.request('is:favourite', productModel);
	      });
	
	      self._appChannel.reply('navigate:to', function (fragment, options) {
	
	        self._globalChannel.trigger('add:navigation:history:entry', {
	          name: '',
	          args: fragment.split('/'),
	          fragment: fragment
	        });
	
	        if (self.shouldRoutingBeEnabled() && self._menuRouter) {
	          if (self.shouldDormantTimerBeEnabled()) {
	            self._resetDormantTimer();
	          }
	          self._menuRouter.navigate(fragment, options);
	        }
	      });
	
	      self._appChannel.on('kiosk:show:intro', function () {
	        self._showIntro();
	      });
	
	      // Helper for making ajax calls (provides all the necessary security info)
	      // TODO: leaving global for the moment, but should change potentially if we have any collisions...
	      Backbone.Radio.channel('global').reply('ajax', function (action, params) {
	        return jQuery.post(FarmacyPluginAjax.ajaxurl, _.extend({}, params, {
	          action: action,
	          security: FarmacyPluginAjax.FarmacyNonce
	        }), function onPostSuccess(data, status, xhr) {
	          var nonce = xhr.getResponseHeader('X-WP-FarmacyNonce');
	          if (nonce) {
	            console.log('new nonce passed: ' + nonce);
	            FarmacyPluginAjax.FarmacyNonce = nonce;
	          }
	        });
	      });
	
	      self.addRegions({
	        mainRegion: '#farmacy-menu-' + self.options.instanceId,
	        overlayRegion: '#farmacy-menu-overlay-' + self.options.instanceId
	      });
	
	      if (self.options.mode === 'global') {
	        self._displayFooterControlBar();
	        self._displayHeaderControlBar();
	        self._setupDialog();
	        self._maybeDisplayEntryDialog();
	      }
	
	      if (self.options.mode === 'kiosk') {
	        self._displayKioskControlBar();
	      }
	
	      self._addGlobalAjaxErrorHandler();
	      if (self.options.mode == 'global') {
	        self._checkLocationtTempClosed(self.options.filterLocation);
	      }
	    },
	    _checkLocationtTempClosed: function _checkLocationtTempClosed(locationSlug, routing) {
	      var self = this;
	      var currentLocationModel = self._locations.findWhere({ slug: locationSlug });
	      if (currentLocationModel && (parseInt(currentLocationModel.get('temp_closed')) === 1 || currentLocationModel.get('temp_closed') == true)) {
	        var fallbackLocation = 'hillsidevictoria';
	        self._globalChannel.trigger('location:selected', fallbackLocation, 'temp_closed', currentLocationModel.get('slug'));
	        return fallbackLocation;
	      } else {
	        return false;
	      }
	    },
	    _addPubSubListeners: function _addPubSubListeners(channels) {
	      var self = this;
	      if (typeof unsubscribeCallback === 'function') {
	        unsubscribeCallback();
	      }
	      var unsubscribeCallback = Backbone.Radio.channel('pubsub').request('subscribe', channels, {
	        notificationsHandler: {
	          message: function message(resp) {
	            if (!resp || !resp.message || !resp.message.eventName) {
	              return;
	            }
	            switch (resp.message.eventName) {
	              case 'order:status:updated':
	                var order = resp.message.order;
	                var updatedModel = self._appChannel.request('order:update:status', order);
	                if (updatedModel && updatedModel.get('order_status') == 'ready') {
	                  if (updatedModel.get('order_delivery_method') == 'pickup') {
	                    // send notification to browser if its pickup.
	                    Backbone.Radio.channel('global').request('show:notification', 'Order ' + updatedModel.get('order_code') + ' is ready for pickup.', {
	                      onClickedCallback: function onClickedCallback() {
	                        // goto order on click eventually...
	                      }
	                    });
	                  }
	                }
	                Backbone.Radio.channel('global').trigger('order:updated', updatedModel);
	                break;
	            }
	          }
	        }
	      });
	
	      this.on('destroy', function () {
	        unsubscribeCallback();
	      });
	    },
	    _orderSubmitted: function _orderSubmitted(orderId, order) {
	      var self = this;
	      var filteredLocationDetails = self._appChannel.request('get:filter:location:details');
	      var cartCost = self._cart.totalCostByUserLocation(self.options.userId, self._menuState.get('filterLocation'), filteredLocationDetails);
	      var cartItems = self._cart.itemsByUserLocation(self._menuState.get('filterLocation'), self.options.userId);
	
	      var gtagItemArray = [];
	      cartItems.each(function (model) {
	        gtagItemArray.push({
	          id: model.get('id_pos'),
	          name: model.get('title'),
	          brand: model.get('vendor_name'),
	          quantity: model.get('cartCount'),
	          price: model.get('price')
	        });
	      });
	
	      // clear cart
	      self._cart.clearCart(self._menuState.get('filterLocation'), self.options.userId);
	      self._appChannel.trigger('cart:items:updated');
	
	      // show success state...
	      self._displayExpandedCart({
	        state: 'success',
	        orderId: orderId,
	        order: order,
	        _appChannel: self._appChannel
	      });
	
	      self._appChannel.trigger('active:view:add', 'successCart');
	
	      self._hideClickBlocker();
	
	      self._appChannel.trigger('gtag:event', 'purchase', {
	        'transaction_id': orderId,
	        "affiliation": self._menuState.get('filterLocation'),
	        'value': parseFloat(cartCost.total),
	        'currency': 'CAD',
	        'tax': parseFloat(cartCost.tax),
	        'items': gtagItemArray
	      });
	
	      self._appChannel.trigger('gtag:event', 'Ordered Created', {
	        'event_category': 'User',
	        'event_label': 'Ordered Created',
	        'value': parseFloat(cartCost.subTotal)
	      });
	    },
	    _orderPay: function _orderPay() {
	      var self = this;
	      self._cart.payOrder({
	        _appChannel: self._appChannel,
	        filterLocation: self._menuState.get('filterLocation')
	      }).then(function (response) {
	        if (response.error == false) {
	          if (response.message && response.message.order_id) {
	            var updatedModel = self._appChannel.request('order:update:status', response.message);
	            self._orderSubmitted(response.message.order_id, response.message);
	          } else {
	            self._displayChallengeModal(response);
	          }
	        } else {
	          self._expandedCartChangeState({
	            state: 'payment',
	            _appChannel: self._appChannel,
	            errorMessage: response.message,
	            errorField: response.errorField,
	            errors: [{
	              code: 'paymentfailed'
	            }]
	          });
	          self._hideClickBlocker();
	        }
	      }).fail(function (response) {
	        self._expandedCartChangeState({
	          state: 'payment',
	          _appChannel: self._appChannel,
	          errorMessage: 'Payment failed',
	          errorField: 'cc_number',
	          errors: [{
	            code: 'paymentfailed'
	          }]
	        });
	      });
	    },
	    _displayChallengeModal: function _displayChallengeModal(response) {
	      var self = this;
	
	      // setup websocket listener for challenge response...
	      var _unsubscribeChallengeCallback = Backbone.Radio.channel('pubsub').request('subscribe', 'orders.' + self._cart.paymentModel.get('currentOrder').get('order_unique_id'), {
	        notificationsHandler: {
	          message: function message(resp) {
	            if (!resp || !resp.message || !resp.message.eventName) {
	              return;
	            }
	            switch (resp.message.eventName) {
	              case 'challenge:response':
	                if (resp.message.response && resp.message.response.error == false) {
	                  // success...
	                  var order = JSON.parse(resp.message.response.order);
	                  var orderModel = new CustomerEntities.OrderModel(order);
	                  if (self._customer.get('orders').check_exists(orderModel.get('order_id'))) {
	                    self._customer.get('orders').remove_by_order_id(orderModel.get('order_id'));
	                  }
	                  self._customer.get('orders').unshift(orderModel);
	                  self._orderSubmitted(order.order_id, order);
	                } else {
	                  self._expandedCartChangeState({
	                    state: 'payment',
	                    _appChannel: self._appChannel,
	                    errorMessage: resp.message.response.message,
	                    errorField: 'cc_number',
	                    errors: [{
	                      code: 'paymentfailed'
	                    }]
	                  });
	                }
	                break;
	            }
	          }
	        }
	      });
	
	      // show challenge state...
	      self._displayExpandedCart({
	        state: 'challenge',
	        showCloseButton: false,
	        challengeData: response,
	        _appChannel: self._appChannel
	      });
	
	      self._appChannel.trigger('active:view:add', 'challengeCart');
	      self._hideClickBlocker();
	    },
	    _submitOrder: function _submitOrder() {
	      var self = this;
	
	      var filteredLocationDetails = self._appChannel.request('get:filter:location:details');
	
	      self._cart.submitOrder(self.options.userId, self._menuState.get('filterLocation'), filteredLocationDetails).then(function (response) {
	        self._hideClickBlocker();
	        if (response.error === false && response.message.order_id !== null) {
	          var orderModel = new CustomerEntities.OrderModel(response.message);
	          // if it exists remove
	          if (self._customer.get('orders').check_exists(orderModel.get('order_id'))) {
	            self._customer.get('orders').remove_by_order_id(orderModel.get('order_id'));
	          }
	          self._customer.get('orders').unshift(orderModel);
	
	          self._addPubSubListeners(self._customer.get('orders').get_active_order_channels());
	          if (self._cart.paymentModel.get('paymentMethod') == 'instore') {
	            self._orderSubmitted(response.message.order_id, response.message);
	          } else {
	            self._setCurrentOrderAndDisplayPaymentView(orderModel);
	          }
	        } else {
	          self._displayExpandedCart({
	            errorMessage: response.message,
	            errors: [{
	              code: 'tomanyopenorders'
	            }]
	          });
	          self._hideClickBlocker();
	        }
	      }).fail(function (response) {
	        // failed... should do something...
	      });
	    },
	    _setCurrentOrderAndDisplayPaymentView: function _setCurrentOrderAndDisplayPaymentView(model) {
	      this._cart.paymentModel.set('currentOrder', model);
	      this._cart.paymentModel.set('paymentMethod', model.get('order_payment_method'));
	
	      // need to set gift model if its set...
	      this._expandedCartChangeState({
	        state: 'payment',
	        _appChannel: this._appChannel
	      });
	      this._hideClickBlocker();
	    },
	    shouldRoutingBeEnabled: function shouldRoutingBeEnabled() {
	      return this._routerEnabledForModes.indexOf(this.options.mode) !== -1;
	    },
	    shouldSearchPanelBeEnabled: function shouldSearchPanelBeEnabled() {
	      return this._searchPanelEnabledForModes.indexOf(this.options.mode) !== -1;
	    },
	    shouldFilterPanelBeEnabled: function shouldFilterPanelBeEnabled() {
	      return this._filterPanelEnabledForModes.indexOf(this.options.mode) !== -1;
	    },
	    shouldAddToCartBeEnabled: function shouldAddToCartBeEnabled() {
	      return this._addToCartEnabledForModes.indexOf(this.options.mode) !== -1;
	    },
	    shouldPageLoaderBeEnabled: function shouldPageLoaderBeEnabled() {
	      return this._pageLoaderEnabledForModes.indexOf(this.options.mode) !== -1;
	    },
	    shouldScrollFetchingBeEnabled: function shouldScrollFetchingBeEnabled() {
	      return this._scrollFetchingEnabledForModes.indexOf(this.options.mode) !== -1;
	    },
	    shouldLocationSwitchingBeEnabled: function shouldLocationSwitchingBeEnabled() {
	      return this._locationSwitchingEnabledForModes.indexOf(this.options.mode) !== -1;
	    },
	    shouldLocationMapBeEnabled: function shouldLocationMapBeEnabled() {
	      return this._locationMapEnabledForModes.indexOf(this.options.mode) !== -1;
	    },
	    shouldDormantTimerBeEnabled: function shouldDormantTimerBeEnabled() {
	      return this._dormantTimerEnabledForModes.indexOf(this.options.mode) !== -1;
	    },
	    onStart: function onStart() {
	      var self = this;
	      if (self.shouldRoutingBeEnabled()) {
	        self.setupRouter();
	      } else {
	        self.loadCategory('all');
	      }
	      if (this.shouldPageLoaderBeEnabled()) {
	        this._renderPageLoader();
	        if (self.shouldDormantTimerBeEnabled()) {
	          $(window).scroll(function () {
	            self._resetDormantTimer();
	          });
	          $(window).on('mousemove', function (e) {
	            self._resetDormantTimer();
	          });
	        }
	      }
	    },
	    _initializeDormantTimer: function _initializeDormantTimer() {
	      this._startDormantTimer();
	    },
	    _clearDormantTimer: function _clearDormantTimer() {
	      clearTimeout(this.dormantTimer);
	      self.dormantTimer = null;
	    },
	    _resetDormantTimer: function _resetDormantTimer() {
	      clearTimeout(this.dormantTimer);
	      this.dormantTimer = null;
	      this._startDormantTimer();
	    },
	    _startDormantTimer: function _startDormantTimer() {
	      var self = this;
	      this.dormantTimer = _.delay(function () {
	        clearTimeout(self.dormantTimer);
	        self.dormantTimer = null;
	        self._displaySessionTimoutOverlay();
	      }, DORMANT_MILLISECONDS);
	    },
	    calculateNextPageFetchNum: function calculateNextPageFetchNum() {
	      if (this.options.mode == 'embedded' || this.options.mode == 'slider') {
	        // TODO, try this...
	        return 100;
	      }
	      if (UIUtils.isAccessoriesKioskWidth() && UIUtils.isAccessoriesKioskHeight()) {
	        return 20;
	      } else if (UIUtils.isPhone()) {
	        return 4; // 1 column 4 rows
	      } else if (UIUtils.isTablet()) {
	        return 8; // 2 columns 4 rows
	      } else if (UIUtils.isDesktop() || UIUtils.isLargeDesktop()) {
	        return 12; // 3 columns 4 rows
	      } else {
	        return 16; // 4 columns 4 rows
	      }
	    },
	    _renderMenuItems: function _renderMenuItems() {
	      var self = this;
	      if (self._menu && self._menu.isRendered) {
	        return self._menu;
	      }
	      self._menu = new Menu({
	        appChannel: self._appChannel,
	        model: self._menuState,
	        mode: self.options.mode,
	        thumbStyle: self.options.thumbStyle,
	        searchPanelEnabled: self.shouldSearchPanelBeEnabled(),
	        filterPanelEnabled: self.shouldFilterPanelBeEnabled(),
	        scrollFetchingEnabled: self.shouldScrollFetchingBeEnabled(),
	        locationMapEnabled: self.shouldLocationMapBeEnabled(),
	        locationSwitchingEnabled: self.shouldLocationSwitchingBeEnabled(),
	        shouldEnableOnlinePurhaseCallback: self._shouldEnableOnlinePurchaseForProduct.bind(self),
	        redirectURL: self.options.redirectURL
	      });
	
	      self._menu.on('next:page', function () {
	        self.getNextPageData();
	      });
	
	      self.mainRegion.show(self._menu);
	      $(document.body).addClass('fmcy-showing-menu');
	      return self._menu;
	    },
	    _renderPageLoader: function _renderPageLoader() {
	      var pageLoadingDisplayViewRegion = new Marionette.Region({
	        el: '#farmacy-footer-message-region'
	      });
	
	      if (this.options.mode === 'kiosk') {
	        pageLoadingDisplayViewRegion.show(new PageLoading({
	          model: this._menuState,
	          backgroundColor: '#000000',
	          theme: 'dark'
	        }));
	      } else {
	        pageLoadingDisplayViewRegion.show(new PageLoading({
	          model: this._menuState
	        }));
	      }
	    },
	    loadProduct: function loadProduct(productSlug, productId, productModel) {
	      var self = this;
	      self._hideExpandedProduct();
	      self._displayExpandedProductLoader(productModel);
	      self._menuState.set('loadingProduct', true);
	      function displayProduct(model) {
	        self._menuState.set('loadingProduct', false);
	        self._displayExpandedProduct(productModel);
	        if (!model) {
	          return;
	        }
	
	        self._appChannel.trigger('product:loaded', model);
	
	        self._appChannel.request('navigate:to', 'products/' + model.get('slug'));
	      }
	
	      if (productModel) {
	        displayProduct(productModel);
	      } else {
	        if (self._fetchingProductXHR && typeof self._fetchingProductXHR.abort === 'function') {
	          self._fetchingProductXHR.abort();
	          self._fetchingProductXHR = null;
	        }
	
	        self._menuState.set('retrievingPageData', true);
	        productModel = new MenuProductEntities.MenuProductModelLegacy({}, {
	          productCategories: self._menuItemCategories
	
	        });
	
	        var fetchParams = {
	          remove_out_stock_variation: false,
	          customer_ordering: true
	        };
	        if (productId) {
	          fetchParams.product_ids = productId;
	        } else {
	          fetchParams.product_slug = productSlug;
	        }
	
	        fetchParams.filter_location = self._appChannel.request('get:filter:location');
	
	        fetchParams.display_even_if_no_stock_at_location = true;
	
	        self._fetchingProductXHR = productModel.fetch({
	          data: fetchParams
	        }).then(function (response) {
	          self._menuState.set('retrievingPageData', false);
	          self._menuState.set('loadingProduct', false);
	          if (_.isArray(response) && response.length) {
	            self._menuItems.add(productModel, { merge: true });
	            displayProduct(productModel);
	          } else {
	            self._hideExpandedProductLoader();
	            self._displayModal();
	          }
	        }).fail(function () {
	          self._menuState.set('retrievingPageData', false);
	          self._menuState.set('loadingProduct', false);
	        });
	      }
	    },
	    loadCategory: function loadCategory(categorySlug, subCategorySlug, options) {
	      var self = this;
	      var foundCategoryModel;
	      var foundSubCategoryModel;
	      options = _.defaults(options || {}, {
	        fetch: true,
	        loadUrl: false
	      });
	
	      if (options.filterVendor === null) {
	        self._menuState.set('filterVendor', null);
	      }
	
	      var vendorModel;
	      if (options.vendor) {
	        vendorModel = self._vendors.findWhere({ code: options.vendor });
	        if (vendorModel) {
	          options.filterVendor = vendorModel.get('id');
	        }
	      } else if (options.vendor === undefined && options.filterVendor) {
	        vendorModel = self._vendors.findWhere({ id: options.filterVendor });
	        if (vendorModel) {
	          options.vendor = vendorModel.get('code');
	        }
	      } else if (self._menuState.get('filterVendor') !== null) {
	        vendorModel = self._vendors.findWhere({ id: self._menuState.get('filterVendor') });
	        if (vendorModel) {
	          options.vendor = vendorModel.get('code');
	          options.filterVendor = self._menuState.get('filterVendor');
	        }
	      }
	
	      if (options.filterVendor !== null) {
	        self._menuState.set('filterVendor', options.filterVendor || this._menuState.get('filterVendor'));
	      }
	
	      categorySlug = categorySlug ? categorySlug : self._menuState.get('filterCategory');
	
	      subCategorySlug = subCategorySlug ? subCategorySlug : self._menuState.get('filterSubCategory');
	
	      foundCategoryModel = self._menuItemCategories.findWhere({
	        slug: categorySlug
	      });
	
	      if (foundCategoryModel) {
	        if (subCategorySlug) {
	          foundSubCategoryModel = self._menuItemCategories.findWhere({
	            slug: subCategorySlug
	          });
	        }
	      }
	
	      var filterCategory = foundCategoryModel ? foundCategoryModel.get('slug') : 'all';
	
	      var filterSubCategory = foundSubCategoryModel ? foundSubCategoryModel.get('slug') : 'all';
	
	      if (filterSubCategory && filterSubCategory !== 'all') {
	        self._menuState.set('slug', filterSubCategory);
	      } else {
	        self._menuState.set('slug', filterCategory);
	      }
	
	      self._menuState.set('filterCategory', filterCategory);
	
	      self._menuState.set('filterSubCategory', filterSubCategory);
	
	      self._menuState.set('filterSort', options.sort || this._menuState.get('filterSort'));
	
	      var filterLocation = options.location || this._menuState.get('filterLocation');
	
	      self._menuState.set('filterLocation', filterLocation);
	
	      LocationEntities.saveUserLocation(filterLocation);
	
	      self._menuState.set('filterSearch', options.searchTerm || this._menuState.get('filterSearch'));
	
	      self._menuState.set('filterSaleItems', options.filterSaleItems || this._menuState.get('filterSaleItems'));
	
	      self._menuState.set('filterNewItems', options.filterNewItems || this._menuState.get('filterNewItems'));
	
	      self._menuState.set('filterClearanceItems', options.filterClearanceItems || this._menuState.get('filterClearanceItems'));
	
	      var updateURLParts = [filterCategory];
	      if (filterSubCategory && filterSubCategory !== 'all') {
	        updateURLParts.push(filterSubCategory);
	      }
	
	      if (filterLocation && filterLocation !== 'all') {
	        updateURLParts.push('location/' + filterLocation);
	      }
	
	      if (options.vendor && options.filterVendor) {
	        updateURLParts.push('brand/' + options.vendor);
	      }
	      if (!window.location.origin) {
	        window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
	      }
	      var fullURL;
	
	      if (self.options.mode === 'kiosk') {
	        fullURL = window.location.origin + window.location.pathname + '#' + updateURLParts.join('/');
	      } else {
	        fullURL = window.location.origin + '/menu' + '#' + updateURLParts.join('/');
	      }
	      if (options.loadUrl === true && options.fetch === true) {
	        try {
	          window.stop();
	        } catch (exception) {
	          document.execCommand('Stop');
	        }
	        $(location).prop('href', fullURL);
	        return;
	      }
	
	      self._appChannel.request('navigate:to', updateURLParts.join('/'));
	
	      if (self.options.mode !== 'global') {
	        self._hideExpandedProduct();
	        var menu = self._renderMenuItems();
	        menu.showItems();
	        menu.maybeShowSearch();
	        menu.maybeShowFilters();
	        if (options.fetch) {
	          self._menuState.set('currentPage', 1);
	          self._menuState.set('retrievingPageData', false);
	          if (self._fetchingCategoryProductsXHR) {
	            self._fetchingCategoryProductsXHR.abort();
	            self._fetchingCategoryProductsXHR = null;
	          }
	          self.getCategoryProducts();
	          UIUtils.scrollToPageTop();
	        }
	        self._appChannel.trigger('active:view:add', 'thumbs');
	      }
	    },
	    setupRouter: function setupRouter() {
	      var self = this;
	      self._menuRouter = new Router({
	        controller: self
	      });
	
	      self._menuRouter.on('route', function (routeName, routePath, routeArgs) {
	        self._globalChannel.trigger('add:navigation:history:entry', {
	          name: routeName,
	          args: routeArgs,
	          fragment: Backbone.history.fragment
	        });
	      });
	
	      if (!Backbone.History.started) {
	        Backbone.history.start({
	          root: '/'
	        });
	      }
	    },
	    handleCategoryRoute: function handleCategoryRoute(categorySlug, subCategorySlug, location, vendor) {
	
	      var _checkLocationtTempClosed = this._checkLocationtTempClosed(location);
	      if (_checkLocationtTempClosed) {
	        location = _checkLocationtTempClosed;
	      }
	
	      if (categorySlug) {
	        categorySlug = categorySlug.toLowerCase().replace(' ', '-');
	      }
	      if (subCategorySlug) {
	        subCategorySlug = subCategorySlug.toLowerCase().replace(' ', '-');
	      }
	
	      if (this.options.mode === 'kiosk') {
	        if (this._initialRoute == true) {
	          this._showIntro();
	        }
	      }
	
	      var navigationHistory = this._appChannel.request('get:navigation:history');
	
	      if (navigationHistory.length >= 2 && navigationHistory[navigationHistory.length - 1].args && navigationHistory[navigationHistory.length - 1].args[0] == 'products') {
	
	        var navigationHistoryLastEntry = navigationHistory[navigationHistory.length - 2];
	        if (navigationHistoryLastEntry) {
	          if (navigationHistoryLastEntry.args == undefined) {
	            navigationHistoryLastEntry.args = navigationHistoryLastEntry.fragment.split('/');
	          }
	          if (navigationHistoryLastEntry.args[0] == 'all' && navigationHistoryLastEntry.args[0] == categorySlug || navigationHistoryLastEntry.args[0] == categorySlug && navigationHistoryLastEntry.args[1] == subCategorySlug || navigationHistoryLastEntry.args[0] == categorySlug && subCategorySlug == null) {
	            if (this.options.mode !== 'global') {
	              this._hideExpandedProduct();
	              if (this._menu && this._menu.isRendered) {
	                this._menu.showItems();
	                this._menu.maybeShowSearch();
	                this._menu.maybeShowFilters();
	              }
	              this._appChannel.trigger('active:view:add', 'thumbs');
	            }
	            return;
	          }
	        }
	      } // end if navigationHistory.length >= 2
	
	      this._initialRoute = false;
	      this.loadCategory(categorySlug, subCategorySlug, { location: location, vendor: vendor });
	    },
	    handleProductRoute: function handleProductRoute(productSlug) {
	      this.loadProduct(productSlug);
	    },
	    getNextPageData: function getNextPageData() {
	      if (this._menuState.get('lastPage') || this._menuState.get('retrievingPageData')) {
	        return;
	      }
	      var currentPage = this._menuState.get('currentPage') + 1;
	      this._menuState.set('currentPage', currentPage);
	      this.getCategoryProducts();
	    },
	    getCategoryProducts: function getCategoryProducts() {
	      var self = this;
	
	      var searchAttrs = ['itemsPerPage', 'currentPage', 'slug', 'filterSearch', 'filterLocation', 'filterSort', 'filterVendor', 'filterSaleItems', 'filterNewItems', 'filterClearanceItems'];
	
	      if (self.shouldDormantTimerBeEnabled()) {
	        self._resetDormantTimer();
	      }
	
	      if (self._menuState.get('retrievingPageData')) {
	        return;
	      }
	      if (self._previousQuery && _.isEqual(self._menuState.pick(searchAttrs), self._previousQuery.pick(searchAttrs))) {
	        return;
	      }
	      self._menuState.set('retrievingPageData', true);
	
	      self._previousQuery = new Backbone.Model(self._menuState.pick(searchAttrs));
	
	      if (self._menuState.get('currentPage') == 1) {
	        self._menuItems.reset();
	      }
	
	      var filterLocation = self._menuState.get('filterLocation');
	      var filterVendor = self._menuState.get('filterVendor');
	
	      var filterSubCategory = self._menuState.get('filterSubCategory');
	      var filterCategory = self._menuState.get('filterCategory');
	      var filterCategorySlugs = self._menuState.get('filterCategorySlugs');
	      var filterCategorySlug = null;
	      if (filterCategorySlugs && filterCategory === 'all') {
	        filterCategorySlug = filterCategorySlugs;
	      } else if (filterSubCategory && filterSubCategory !== 'all') {
	        filterCategorySlug = filterSubCategory;
	      } else if (filterCategory && filterCategory !== 'all') {
	        filterCategorySlug = filterCategory;
	      }
	
	      self._fetchingCategoryProductsXHR = self._menuItems.fetch({
	        remove: self._menuState.get('currentPage') == 1 ? true : false,
	        data: {
	          per_page: self.calculateNextPageFetchNum(),
	          in_stock: true,
	          page: self._menuState.get('currentPage'),
	          product_ids: self._menuState.get('productIDs'),
	          search_term: self._menuState.get('filterSearch'),
	          category_slug: filterCategorySlug,
	          remove_out_stock_variation: false,
	          customer_ordering: true,
	          filter_location: filterLocation === 'all' ? null : filterLocation,
	          vendor_id: isNaN(filterVendor) ? null : filterVendor,
	          orderby: self._menuState.get('filterSort'),
	          filter_vendor: self._menuState.get('filterVendor'),
	          filter_sale_items: self._menuState.get('filterSaleItems'),
	          filter_clearance_items: self._menuState.get('filterClearanceItems'),
	          filter_new_items: self._menuState.get('filterNewItems')
	        },
	        success: function success(collection, response, options) {
	          self._menuState.set('retrievingPageData', false);
	          var numPages = parseInt(options.xhr.getResponseHeader('X-WP-TotalPages'), 10);
	          var page = parseInt(options.xhr.getResponseHeader('X-WP-Page'), 10);
	
	          self._menuState.set('lastPage', page === numPages);
	        },
	        error: function error(collection, response, options) {
	          self._menuState.set('retrievingPageData', false);
	        }
	      });
	    },
	    _addGlobalAjaxErrorHandler: function _addGlobalAjaxErrorHandler() {
	      var self = this;
	      $(document).ajaxError(function (e, xhr, options) {
	        if (xhr.status == 403) {
	          location.reload();
	          //todo: figure out why the dialog isn't showing...
	          /*
	          self._appChannel.trigger(
	              'show:confirm:dialog',
	              {
	                  showCancelButton: false,
	                  confirmText: 'The security for this page has expired. Please refresh.',
	                  confirmButtonLabel: 'Refresh',
	                  confirmedCallback: function () {
	                      location.reload();
	                  }
	              }
	          );
	          */
	        }
	      });
	    },
	    renderPageNotFoundPage: function renderPageNotFoundPage() {
	      this._hideExpandedProduct();
	      this._appChannel.request('scroll:to:page:top');
	      this.mainRegion.show(new (__webpack_require__(715))({}));
	    },
	    _setupDialog: function _setupDialog() {
	      var self = this;
	      var DialogController = __webpack_require__(456).Controller;
	      new DialogController({
	        container: this.overlayRegion,
	        channel: Backbone.Radio.channel('dialog')
	      });
	      self._globalChannel.on('show:confirm:dialog', function (options) {
	        var ConfirmDialog = __webpack_require__(676).View;
	        new ConfirmDialog(_.extend(options, {
	          channel: Backbone.Radio.channel('dialog')
	        }));
	      });
	    },
	    _serverUnixTime: function _serverUnixTime() {
	      var currentSelectedLocation = this._appChannel.request('get:filter:location:details');
	      if (currentSelectedLocation && currentSelectedLocation.get('server_client_time_offset')) {
	        return moment().unix() + currentSelectedLocation.get('server_client_time_offset');
	      } else {
	        return null;
	      }
	    },
	    _displayEntryDialog: function _displayEntryDialog(options) {
	      var self = this;
	      var options = _.defaults(options || {}, {
	        skipAgeGate: false,
	        referrer: 'entry',
	        view: 'entry' // entry, order_success
	      });
	
	      var elementId = '#farm-complete-overlay-modal';
	
	      var modal = self._entryModal;
	      if (!modal) {
	        modal = self._entryModal = new DynamicRegion({
	          el: elementId
	        });
	        modal.on('show', function () {
	          modal.$el.addClass('enableClick');
	          modal.$el.css({ 'overflow-y': 'hidden' });
	          modal.$el.addClass('darkTheme');
	          modal.$el.css({ opacity: 1 });
	        });
	        modal.on('empty', function () {
	          modal.$el.removeClass('enableClick');
	          modal.$el.css({ 'overflow-y': 'scroll' });
	          modal.$el.removeClass('darkTheme');
	          modal.$el.css({ opacity: 0 });
	          self._appChannel.trigger('active:view:remove', 'entryModal');
	        });
	      }
	
	      var view = new EntryFlow({
	        _appChannel: self._appChannel,
	        _menuState: self._menuState,
	        skipAgeGate: options.skipAgeGate,
	        referrer: options.referrer,
	        delivery_method: self.options.delivery_method
	      });
	
	      view.on('close:clicked', function () {
	        modal.empty();
	      });
	
	      modal.show(view);
	      self._appChannel.trigger('active:view:add', 'entryModal');
	    },
	    _maybeDisplayEntryDialog: function _maybeDisplayEntryDialog() {
	      var self = this;
	      lsCache.flushExpired();
	      var lastAgeGateYesClicked = lsCache.get('lastAgeGateYesClickedTime');
	      if (!lastAgeGateYesClicked) {
	        this._displayEntryDialog();
	        return;
	      }
	      if (this.options.delivery_method !== null) {
	        this._displayEntryDialog({
	          skipAgeGate: true
	        });
	      }
	    },
	    _hideSideBarMenu: function _hideSideBarMenu() {
	      var self = this;
	      if (self._sideBarModal) {
	        self._sideBarModal.empty();
	        self._appChannel.trigger('active:view:remove', 'sidebar');
	      }
	    },
	    _displaySideBarMenu: function _displaySideBarMenu(options) {
	      var self = this;
	      self._sideBarModal = self._sideBarMenu;
	
	      if (!self._sideBarModal) {
	        self._sideBarModal = self._sideBarMenu = new DynamicRegion({
	          el: '#farm-sidebar-modal'
	        });
	        self._sideBarModal.on('show', function () {
	          self._sideBarModal.$el.css({ 'overflow-y': 'scroll' });
	          self._sideBarModal.$el.addClass('enableClick');
	          self._sideBarModal.$el.css({ opacity: 1 });
	          self._menuState.set('sideBarOpen', true);
	        });
	        self._sideBarModal.on('empty', function () {
	          self._menuState.set('sideBarOpen', false);
	          self._sideBarModal.$el.css({ 'overflow-y': 'hidden' });
	          self._sideBarModal.$el.removeClass('enableClick');
	          self._sideBarModal.$el.css({ opacity: 0 });
	          self._appChannel.trigger('active:view:remove', 'sidebar');
	        });
	      }
	
	      var view = new SidebarModal(_.extend({
	        _appChannel: self._appChannel,
	        isUserLoggedIn: self.options.isUserLoggedIn,
	        customerData: self._appChannel.request('customer:get:data')
	      }, options));
	
	      view.on('close:clicked', function () {
	        self._sideBarModal.empty();
	      });
	
	      self._sideBarModal.show(view);
	      self._appChannel.trigger('active:view:add', 'sidebar');
	    },
	    _hideSearchMenu: function _hideSearchMenu() {
	      var self = this;
	      if (self._searchModal) {
	        self._searchModal.empty();
	        self._appChannel.trigger('active:view:remove', 'search');
	      }
	    },
	    _displaySearchMenu: function _displaySearchMenu(options) {
	      var self = this;
	      self._searchModal = self._searchMenu;
	
	      if (!self._searchModal) {
	        self._searchModal = self._searchMenu = new DynamicRegion({
	          el: '#farm-search-modal'
	        });
	        self._searchModal.on('show', function () {
	          self._searchModal.$el.css({ 'overflow-y': 'scroll' });
	          self._searchModal.$el.addClass('enableClick');
	          self._searchModal.$el.css({ opacity: 1 });
	          self._menuState.set('searchOpen', true);
	        });
	        self._searchModal.on('empty', function () {
	          self._menuState.set('searchOpen', false);
	          self._searchModal.$el.css({ 'overflow-y': 'hidden' });
	          self._searchModal.$el.removeClass('enableClick');
	          self._searchModal.$el.css({ opacity: 0 });
	          self._appChannel.trigger('active:view:remove', 'search');
	        });
	      }
	
	      var view = new SearchModal(_.extend({
	        _appChannel: self._appChannel,
	        _menuState: self._menuState,
	        isUserLoggedIn: self.options.isUserLoggedIn,
	        searchType: self.options.searchType,
	        customerData: self._appChannel.request('customer:get:data')
	      }, options));
	
	      view.on('close:clicked', function () {
	        self._searchModal.empty();
	      });
	
	      self._searchModal.show(view);
	      self._appChannel.trigger('active:view:add', 'search');
	    },
	    _hideExpandedCart: function _hideExpandedCart() {
	      var self = this;
	      if (self._expandedCartModal) {
	        self._expandedCartModal.empty();
	        self._appChannel.trigger('active:view:remove', 'sidebar');
	      }
	    },
	    _displayExpandedCart: function _displayExpandedCart(options) {
	      var self = this;
	
	      var options = _.defaults(options || {}, {
	        state: 'review',
	        order: null
	      });
	
	      self._appChannel.trigger('menu:overlay:view:close');
	      self._expandedCartModal = self._expandedCart;
	
	      if (!self._expandedCartModal) {
	        self._expandedCartModal = self._expandedCart = new DynamicRegion({
	          el: '#farm-inline-modal'
	        });
	        self._expandedCartModal.on('show', function () {
	          self._expandedCartModal.$el.css({ 'overflow-y': 'scroll' });
	          self._expandedCartModal.$el.addClass('enableClick');
	          self._expandedCartModal.$el.css({ opacity: 1 });
	        });
	        self._expandedCartModal.on('empty', function () {
	          self._expandedCartModal.$el.css({ 'overflow-y': 'hidden' });
	          self._expandedCartModal.$el.removeClass('enableClick');
	          self._expandedCartModal.$el.css({ opacity: 0 });
	          self._appChannel.trigger('active:view:remove', 'reviewCart');
	          self._appChannel.trigger('active:view:remove', 'paymentCart');
	          self._appChannel.trigger('active:view:remove', 'successCart');
	          self._appChannel.trigger('active:view:remove', 'challengeCart');
	          if (self._cart) {
	            self._cart.clearCardDetails();
	          }
	        });
	      }
	
	      var view = new CartExpandedModal(_.extend({
	        _appChannel: self._appChannel
	      }, options));
	
	      view.on('close:clicked', function () {
	        self._expandedCartModal.empty();
	      });
	
	      self._expandedCartModal.show(view);
	      self._appChannel.trigger('active:view:add', options.state + 'Cart');
	    },
	    _expandedCartChangeState: function _expandedCartChangeState(options) {
	      this._appChannel.trigger('active:view:remove', 'reviewCart');
	      this._appChannel.trigger('active:view:remove', 'paymentCart');
	      if (this._expandedCartModal && this._expandedCartModal.currentView) {
	        this._expandedCartModal.currentView.ChangeState(options);
	        this._appChannel.trigger('active:view:add', options.state + 'Cart');
	      } else {
	        this._displayExpandedCart(options);
	      }
	    },
	    _hideExpandedLocationSelection: function _hideExpandedLocationSelection() {
	      var self = this;
	      if (self._expandedLocationDisplayModal) {
	        self._expandedLocationDisplayModal.empty();
	        self._appChannel.trigger('active:view:remove', 'locationSelect');
	      }
	    },
	    _displayExpandedLocationSelection: function _displayExpandedLocationSelection(options) {
	      var self = this;
	
	      self._expandedLocationDisplayModal = self._expandedLocationDisplay;
	
	      if (!self._expandedLocationDisplayModal) {
	        self._expandedLocationDisplayModal = self._expandedLocationDisplay = new DynamicRegion({
	          el: '#farm-inline-modal'
	        });
	        self._expandedLocationDisplayModal.on('show', function () {
	          self._expandedLocationDisplayModal.$el.css({ 'overflow-y': 'scroll' });
	          self._expandedLocationDisplayModal.$el.addClass('enableClick');
	          self._expandedLocationDisplayModal.$el.css({ opacity: 1 });
	        });
	        self._expandedLocationDisplayModal.on('empty', function () {
	          self._expandedLocationDisplayModal.$el.css({ 'overflow-y': 'hidden' });
	          self._expandedLocationDisplayModal.$el.removeClass('enableClick');
	          self._expandedLocationDisplayModal.$el.css({ opacity: 0 });
	          self._appChannel.trigger('active:view:remove', 'locationSelect');
	        });
	      }
	
	      var view = new LocationExpandedModal(_.extend({
	        _appChannel: self._appChannel,
	        _menuState: self._menuState
	      }, options));
	
	      view.on('close:clicked', function () {
	        self._expandedLocationDisplayModal.empty();
	      });
	
	      self._expandedLocationDisplayModal.show(view);
	
	      self._appChannel.trigger('active:view:add', 'locationSelect');
	    },
	    _hideMegaMenu: function _hideMegaMenu() {
	      var self = this;
	      if (self._megaMenuModal) {
	        self._megaMenuModal.empty();
	        // doubling up, maybe...
	        self._appChannel.trigger('active:view:remove', 'megaMenu');
	      }
	    },
	    _displayMegaMenu: function _displayMegaMenu(options) {
	      var self = this;
	
	      self._megaMenuModal = self._megaMenu;
	
	      if (!self._megaMenuModal) {
	        self._megaMenuModal = self._megaMenu = new DynamicRegion({
	          el: '#farm-mega-menu-modal'
	        });
	        self._megaMenuModal.on('show', function () {
	          self._megaMenuModal.$el.css({ 'overflow-y': 'scroll' });
	          self._megaMenuModal.$el.addClass('enableClick');
	          self._megaMenuModal.$el.css({ opacity: 1 });
	        });
	        self._megaMenuModal.on('empty', function () {
	          self._megaMenuModal.$el.css({ 'overflow-y': 'hidden' });
	          self._megaMenuModal.$el.removeClass('enableClick');
	          self._megaMenuModal.$el.css({ opacity: 0 });
	          self._appChannel.trigger('active:view:remove', 'megaMenu');
	          self._appChannel.trigger('menu:overlay:view:close', 'megamenu');
	          self._globalChannel.trigger('menu:overlay:view:close', 'megamenu');
	        });
	      }
	
	      var view = new MegaMenuModal(_.extend({
	        _menuState: self._menuState,
	        _appChannel: self._appChannel
	      }, options));
	
	      view.on('close:clicked', function () {
	        self._megaMenuModal.empty();
	      });
	
	      self._megaMenuModal.show(view);
	
	      self._appChannel.trigger('active:view:add', 'megaMenu');
	    },
	    _hideClickBlocker: function _hideClickBlocker() {
	      var self = this;
	      if (self._clickBlockerModal) {
	        self._clickBlockerModal.empty();
	      }
	    },
	    _displayClickBlocker: function _displayClickBlocker() {
	      var self = this;
	      self._clickBlockerModal = self._clickBlocker;
	      if (!self._clickBlockerModal) {
	        self._clickBlockerModal = self._clickBlocker = new DynamicRegion({
	          el: '#farm-complete-overlay-modal'
	        });
	        self._clickBlockerModal.on('show', function () {
	          self._clickBlockerModal.$el.addClass('enableClick');
	          self._clickBlockerModal.$el.css({ opacity: 0 });
	        });
	        self._clickBlockerModal.on('empty', function () {
	          self._clickBlockerModal.$el.removeClass('enableClick');
	          self._clickBlockerModal.$el.css({ opacity: 0 });
	        });
	      }
	
	      var view = new ClickBlockerModal({
	        appChannel: self._appChannel
	      });
	
	      view.on('close:clicked', function () {
	        self._clickBlockerModal.empty();
	      });
	
	      self._clickBlockerModal.show(view);
	    },
	    _displayProductZoomer: function _displayProductZoomer(model) {
	      var self = this;
	      var modal = self._expandedProductZoomer;
	      if (!modal) {
	        modal = self._expandedProductZoomer = new DynamicRegion({
	          el: '#farm-complete-overlay-modal'
	        });
	        modal.on('show', function () {
	          modal.$el.addClass('enableClick');
	          modal.$el.css({ 'overflow-y': 'hidden' });
	          if (model.get('theme') === 'dark') {
	            modal.$el.addClass('darkTheme');
	          }
	          modal.$el.css({ opacity: 1 });
	        });
	        modal.on('empty', function () {
	          modal.$el.removeClass('enableClick');
	          modal.$el.css({ 'overflow-y': 'scroll' });
	
	          if (modal.$el.hasClass('darkTheme')) {
	            modal.$el.removeClass('darkTheme');
	          }
	          modal.$el.css({ opacity: 0 });
	          self._appChannel.trigger('active:view:remove', 'productZoomer');
	        });
	      }
	
	      var view = new ProductZoomerModal({
	        theme: model.get('theme'),
	        model: model,
	        appChannel: self._appChannel
	      });
	
	      view.on('close:clicked', function () {
	        modal.empty();
	      });
	
	      modal.show(view);
	      self._appChannel.trigger('active:view:add', 'productZoomer');
	    },
	    _displayEnlargedVideo: function _displayEnlargedVideo(model, collection) {
	      var self = this;
	      var modal = self._expandedVideo;
	
	      if (!modal) {
	        modal = self._expandedVideo = new DynamicRegion({
	          el: '#farm-complete-overlay-modal'
	        });
	        modal.on('show', function () {
	          modal.$el.css({ 'overflow-y': 'hidden' });
	          modal.$el.addClass('enableClick');
	          modal.$el.addClass('darkTheme');
	          modal.$el.css({ opacity: 1 });
	        });
	        modal.on('empty', function () {
	          modal.$el.css({ 'overflow-y': 'scroll' });
	          modal.$el.removeClass('enableClick');
	          modal.$el.removeClass('darkTheme');
	          modal.$el.css({ opacity: 0 });
	          self._appChannel.trigger('active:view:remove', 'productVideo');
	        });
	      }
	
	      var view = new VideoExpandedModal({
	        model: model,
	        collection: collection,
	        appChannel: self._appChannel
	      });
	
	      view.on('close:clicked', function () {
	        modal.empty();
	      });
	
	      modal.show(view);
	      self._appChannel.trigger('active:view:add', 'productVideo');
	    },
	    _displayModal: function _displayModal(options) {
	      var self = this;
	      self.modal = self._expandedModal;
	
	      var options = _.defaults(options || {}, {
	        appChannel: self._appChannel
	      });
	
	      if (!self.modal) {
	        self.modal = self._expandedModal = new DynamicRegion({
	          el: '#farm-inline-modal'
	        });
	        self.modal.on('show', function () {
	          self.modal.$el.css({ 'overflow-y': 'hidden' });
	          self.modal.$el.addClass('enableClick');
	          self.modal.$el.addClass('darkTheme');
	          self.modal.$el.css({ opacity: 1 });
	        });
	        self.modal.on('empty', function () {
	          self.modal.$el.css({ 'overflow-y': 'scroll' });
	          self.modal.$el.removeClass('enableClick');
	          self.modal.$el.removeClass('darkTheme');
	          self.modal.$el.css({ opacity: 0 });
	          self._appChannel.trigger('active:view:remove', 'modal');
	          if (self._menu && self._menu.isRendered) {
	            self._menu.showItems();
	            self._menu.maybeShowSearch();
	            self._menu.maybeShowFilters();
	          }
	        });
	      }
	
	      var view = new Modal(options);
	
	      view.on('close:clicked', function () {
	        self.modal.empty();
	      });
	
	      self.modal.show(view);
	      self._appChannel.trigger('active:view:add', 'modal');
	    },
	    _displayFooterControlBar: function _displayFooterControlBar() {
	      var self = this;
	      this._footerBarRegion = new FooterDynamicRegion({
	        el: '#farm-complete-overlay-tools'
	      });
	
	      this._footerControlBar = new FooterControlBar({
	        _appChannel: this._appChannel,
	        _menuState: this._menuState
	      });
	
	      this._footerBarRegion.show(this._footerControlBar);
	    },
	    _displayKioskControlBar: function _displayKioskControlBar() {
	      var self = this;
	      this._headerBarRegion = new HeaderDynamicRegion({
	        el: '#farm-kiosk-header'
	      });
	
	      this._headerControlBarKiosk = new HeaderControlBarKiosk({
	        isUserLoggedIn: self.options.isUserLoggedIn,
	        _appChannel: this._appChannel,
	        _menuState: this._menuState
	      });
	
	      this._headerBarRegion.show(this._headerControlBarKiosk);
	    },
	    _displayHeaderControlBar: function _displayHeaderControlBar() {
	      var self = this;
	      this._headerBarRegion = new HeaderDynamicRegion({
	        el: '#farm-header-tools'
	      });
	
	      this._headerControlBar = new HeaderControlBar({
	        isUserLoggedIn: self.options.isUserLoggedIn,
	        _appChannel: this._appChannel,
	        _menuState: this._menuState
	      });
	
	      this._headerBarRegion.show(this._headerControlBar);
	    },
	
	    _displaySessionTimoutOverlay: function _displaySessionTimoutOverlay() {
	
	      if (this._showingIntro !== null && this._showingIntro == true) {
	        return;
	      }
	
	      var self = this;
	      var modal = self._sessionTimoutOverlay;
	
	      if (!modal) {
	        modal = self._sessionTimoutOverlay = new DynamicRegion({
	          el: '#farm-complete-overlay-modal'
	        });
	        modal.on('show', function () {
	          modal.$el.css({ 'overflow-y': 'scroll' });
	          modal.$el.addClass('enableClick');
	          modal.$el.addClass('darkTheme');
	          modal.$el.css({ opacity: 1, paddingBottom: 0 });
	        });
	        modal.on('empty', function () {
	          modal.$el.css({ 'overflow-y': 'hidden' });
	          modal.$el.removeClass('enableClick');
	          modal.$el.removeClass('darkTheme');
	          modal.$el.css({ opacity: 0, paddingBottom: 74 });
	          if (self.shouldDormantTimerBeEnabled()) {
	            self._resetDormantTimer();
	          }
	          self._appChannel.trigger('active:view:remove', 'sessionTimeoutOverlay');
	        });
	      }
	
	      var view = new SessionTimoutOverlay({
	        appChannel: self._appChannel
	      });
	
	      view.on('finished', function () {
	        if (self.options.reloadOnSessionTimeout) {
	          self._hideExpandedProduct();
	          modal.empty();
	          self._appChannel.request('navigate:to', '/');
	          _.delay(function () {
	            location.reload();
	          }, 100);
	        } else {
	          self._hideExpandedProduct();
	          modal.empty();
	          self._showIntro();
	        }
	        self._appChannel.trigger('active:view:remove', 'sessionTimeoutOverlay');
	      });
	
	      view.on('close:clicked', function () {
	        modal.empty();
	      });
	
	      modal.show(view);
	      self._appChannel.trigger('active:view:add', 'sessionTimeoutOverlay');
	    },
	    _showIntro: function _showIntro() {
	      var self = this;
	      this._showingIntro = true;
	      var self = this;
	      var modal = self._kioskIntroOverlay;
	
	      if (!modal) {
	        modal = self._kioskIntroOverlay = new DynamicRegion({
	          el: '#farm-complete-overlay-modal'
	        });
	        modal.on('show', function () {
	          modal.$el.css({ 'overflow-y': 'scroll' });
	          modal.$el.addClass('enableClick');
	          modal.$el.addClass('darkTheme');
	          modal.$el.css({ opacity: 1, paddingBottom: 0 });
	        });
	        modal.on('empty', function () {
	          modal.$el.css({ 'overflow-y': 'hidden' });
	          modal.$el.removeClass('enableClick');
	          modal.$el.removeClass('darkTheme');
	          modal.$el.css({ opacity: 0, paddingBottom: 74 });
	          self._appChannel.trigger('active:view:remove', 'kioskIntro');
	        });
	      }
	
	      var view = new KioskIntroOverlay({
	        appChannel: self._appChannel
	      });
	
	      view.on('menu:show:category', function (cat) {
	        self._appChannel.request('load:category', cat, 'all', {
	          mode: 'kiosk'
	        });
	        modal.empty();
	        self._showingIntro = false;
	      });
	
	      modal.show(view);
	      self._appChannel.trigger('active:view:add', 'kioskIntro');
	    },
	    _hideExpandedProductLoader: function _hideExpandedProductLoader() {
	      if (this._expandedProductDialogLoader) {
	        this._expandedProductDialogLoader.empty();
	      }
	    },
	    _displayExpandedProductLoader: function _displayExpandedProductLoader(productModel) {
	      var self = this;
	      var dialog = self._expandedProductDialogLoader;
	
	      if (!dialog) {
	        dialog = self._expandedProductDialogLoader = new DynamicRegion({
	          el: '#et-main-area-modal'
	        });
	        dialog.on('show', function () {
	          dialog.$el.addClass('enableClick');
	          dialog.$el.css({ 'overflow-y': 'hidden' });
	          dialog.$el.css({ opacity: 1 });
	        });
	        dialog.on('empty', function () {
	          dialog.$el.removeClass('enableClick');
	          dialog.$el.css({ 'overflow-y': 'hidden' });
	          dialog.$el.css({ opacity: 0 });
	        });
	      }
	      var theme = 'light';
	      if (productModel) {
	        if (productModel.get('theme') === 'dark') {
	          theme = 'dark';
	        }
	      }
	      var loaderExpanded = new LoaderExpanded({
	        theme: theme
	      });
	      dialog.show(loaderExpanded);
	    },
	    _displayExpandedProduct: function _displayExpandedProduct(model) {
	      var self = this;
	      self._menuState.set('displayingExpandedView', true);
	      self._menuState.set('displayedProduct', model);
	
	      if (self.shouldDormantTimerBeEnabled()) {
	        self._resetDormantTimer();
	      }
	
	      var dialog = self._expandedProductDialog;
	      if (!dialog) {
	        dialog = self._expandedProductDialog = new DynamicRegion({
	          el: '#et-main-area-modal'
	        });
	        dialog.on('show', function () {
	          dialog.$el.addClass('enableClick');
	          dialog.$el.css({ 'overflow-y': 'scroll' });
	          if (self._menuState.get('displayedProduct').get('theme') === 'dark') {
	            $('body').addClass('fmcy-product-tile-theme-dark');
	          } else {
	            if ($('body').hasClass('fmcy-product-tile-theme-dark')) {
	              $('body').removeClass('fmcy-product-tile-theme-dark');
	            }
	          }
	          dialog.$el.css({ opacity: 1 });
	        });
	        dialog.on('empty', function () {
	          dialog.$el.removeClass('enableClick');
	          dialog.$el.css({ 'overflow-y': 'hidden' });
	          dialog.$el.css({ opacity: 0 });
	          self._appChannel.trigger('active:view:remove', 'productEnlarged');
	          if (self.options.mode == 'embedded') {
	            if (self._menu && self._menu.isRendered) {
	              self._menu.showItems();
	              self._menu.maybeShowSearch();
	              self._menu.maybeShowFilters();
	            }
	          }
	        });
	      }
	
	      var view = new MenuItemExpanded({
	        locations: self._locations,
	        model: model,
	        mode: self.options.mode,
	        isUserLoggedIn: self._menuState.get('isUserLoggedIn'),
	        filterLocation: self._menuState.get('filterLocation'),
	        shouldRenderProductLocations: false,
	        customClassName: 'fmcy-menu-expanded-product',
	        appChannel: self._appChannel,
	        onlinePurchaseEnabled: self._shouldEnableOnlinePurchaseForProduct(model),
	        showProductLocations: self._menuState.get('multiLocationsSupportEnabled'),
	        showOnlineProductLocations: self._menuState.get('isUserLoggedIn')
	      });
	
	      view.on('close:clicked', function () {
	        dialog.empty();
	        if (self.options.redirectURL) {
	          if (self._appChannel.request('get:navigation:history').length) {
	            window.history.back();
	          } else {
	            try {
	              window.stop();
	            } catch (exception) {
	              document.execCommand('Stop');
	            }
	            $(location).prop('href', self.options.redirectURL);
	          }
	        } else {
	          var category = self._menuState.get('filterCategory');
	          if (category) {
	            self._appChannel.request('load:category', null, null, {
	              fetch: false
	            });
	          } else {
	            var productCategory = model.get('category');
	            var productSubCategory = model.get('subCategory');
	            self._appChannel.request('load:category', productCategory ? productCategory.toLowerCase() : null, productSubCategory ? productSubCategory.toLowerCase() : null);
	          }
	        }
	      });
	      dialog.show(view);
	      self._appChannel.trigger('active:view:add', 'productEnlarged');
	    },
	    _hideExpandedProduct: function _hideExpandedProduct() {
	      this._menuState.set('displayedProduct', null);
	      if (this._expandedProductDialog) {
	        this._expandedProductDialog.empty();
	        this._menuState.set('displayingExpandedView', false);
	      }
	    },
	    _shouldEnableOnlinePurchaseForProduct: function _shouldEnableOnlinePurchaseForProduct(product) {
	      if (this.shouldAddToCartBeEnabled()) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  });
	
	  $('.farmacy-menu').each(function (index) {
	    renderMenu(this);
	  });
	
	  function renderMenu(el) {
	    new PublicMenuApp({
	      el: el,
	      instanceId: $(el).data('instanceid'),
	      mode: $(el).data('mode'),
	      thumbStyle: $(el).data('thumbstyle'),
	      delivery_method: $(el).data('deliverymethod'),
	      filter: $(el).data('filter'),
	      filterLocation: $(el).data('filterlocation'),
	      filterVendor: parseInt($(el).data('filtervendor')),
	      filterCategorySlugs: $(el).data('filtercategoryslugs'),
	      saleItemsFilterEnabled: $(el).data('saleitemsfilterenabled'),
	      newItemsFilterEnabled: $(el).data('newitemsfilterenabled'),
	      clearanceItemsFilterEnabled: $(el).data('clearanceitemsfilterenabled'),
	      sort: $(el).data('sort'),
	      locations: $(el).data('locations'),
	      productCategories: $(el).data('productcategories'),
	      productVendors: $(el).data('productvendors'),
	      productIDs: $(el).data('productids'),
	      isUserLoggedIn: $(el).data('isuserloggedin'),
	      userData: $(el).data('userdata'),
	      userId: $(el).data('userid'),
	      multiLocationsSupportEnabled: $(el).data('multilocationssupportenabled')
	    }).start();
	    if ($(el).data('mode') === 'kiosk') {
	      $('.fmcy-header-control-bar').hide();
	      $('.page-container-farm').attr('style', 'padding-top: 80px !important');
	      __webpack_require__(1785);
	    }
	  }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(15), __webpack_require__(1), __webpack_require__(4)))

/***/ },
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, ".fmcy-menu {\n  background-color: #000000;\n  padding-top: 0px !important; }\n\n.fmcy-menu-item-thumb-image-large {\n  background-position: top !important; }\n\n.fmcy-menu-location-display-region {\n  display: none; }\n\n.fmcy-menu-items {\n  background-color: #000 !important; }\n\n.fmcy-sort-panel-locations {\n  display: none !important; }\n\n.fmcy-sort-and-filter-row {\n  display: none !important; }\n\n.fmcy-sort-panel-vendors {\n  display: none !important; }\n\n.fmcy-sub-category-filter-row {\n  background-color: #1c1c1c !important; }\n\n.fmcy-search-caption {\n  color: #fff !important; }\n\n.fmcy-menu-items {\n  padding-top: 15px; }\n\n.fmcy-search-filters-item.sub-filters.active .fmcy-category-menu-item-text {\n  color: #fff;\n  background-color: #00BAC0;\n  border: 2px solid #00BAC0; }\n\n.fmcy-search-filters-item.sub-filters .fmcy-category-menu-item-text {\n  padding: 6px;\n  border: 2px solid #000;\n  color: #000; }\n\n.fmcy-category-filter-row {\n  min-height: 115px; }\n\n.select2-container--default .select2-selection--single {\n  background: none; }\n\n.select2-container--default .select2-selection--single .select2-selection__rendered {\n  color: #fff;\n  line-height: 28px; }\n\n.fmcy-search-filters-item.default .fmcy-category-menu-item-text {\n  font-family: \"bebasneue\", \"Arial\", sans-serif;\n  font-size: 255%;\n  color: #fff;\n  line-height: 1;\n  border-style: solid;\n  border-top: 3px solid #6D6E71;\n  border-bottom: 3px solid #6D6E71; }\n\n.fmcy-search-filters-item.default .fmcy-category-menu-item-text {\n  border-top: 3px solid #000;\n  border-bottom: none; }\n\n.fmcy-search-filters-item.default.active .fmcy-category-menu-item-text {\n  color: #FFFFFF;\n  border: 3px solid #00BAC0;\n  border-radius: 5px;\n  background-color: #00BAC0; }\n\n.fmcy-menu-item-expanded .fmcy-menu-container .fmcy-vendor-icon-region {\n  position: relative; }\n\n.fmcy-menu-item-expanded .fmcy-menu-title {\n  text-align: left; }\n\n.fmcy-menu-item-expanded.fmcy-product-tile-theme-dark .fmcy-item-description-text .fmcy-item-description-text-description {\n  max-width: 500px; }\n\n.fmcy-menu-item-expanded .fmcy-item-description-text {\n  font-size: 1.25em;\n  line-height: 1.5em; }\n\n.fmcy-menu-item-expanded .fmcy-menu-product-info-container {\n  padding-left: 60px !important;\n  padding-right: 60px !important; }\n\n.fmcy-menu-item-expanded .fmcy-menu-container .fmcy-vendor-icon-region {\n  max-width: 50%; }\n\n.fmcy-thumbnail-selector .fmcy-thumbnail-item .fmcy-thumbnail-item-image {\n  height: 60px; }\n\n.fmcy-menu-item-expanded .fmcy-menu-item-thumb-selector-region {\n  width: 100px; }\n\n.fmcy-thumbnail-item.thumbnail-item-selected .fmcy-thumbnail-item-inner {\n  border: solid #00BAC0 2px; }\n\n.fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-item-btn-close {\n  position: fixed;\n  right: 76px;\n  top: 156px;\n  width: 70px;\n  height: 70px; }\n\n.fmcy-menu-item-expanded .fmcy-menu-container .fmcy-menu-item-magnify-icon {\n  width: 70px;\n  height: 70px;\n  z-index: 500;\n  position: fixed;\n  right: 76px !important;\n  top: 240px !important; }\n\n.fmcy-product-zoomer-modal .fmcy-menu-item-btn-close {\n  position: absolute;\n  right: 76px;\n  top: 60px;\n  width: 70px;\n  height: 70px; }\n\n.fmcy-video-expanded-modal .fmcy-menu-item-btn-close {\n  position: absolute;\n  right: 76px;\n  top: 60px;\n  width: 70px;\n  height: 70px; }\n\n.fmcy-menu-item-expanded .fmcy-menu-item-thumb-selector-region {\n  position: fixed;\n  top: 300px;\n  right: 60px;\n  z-index: 2; }\n\n.fmcy-menu-item-expanded .fmcy-menu-title {\n  text-align: left;\n  font-family: \"bebasneue\", \"Arial\", sans-serif;\n  color: #000;\n  font-size: 6.5em;\n  line-height: 1.2em;\n  max-width: 75%; }\n\n.fmcy-menu-item-expanded .fmcy-item-prices-region .fmcy-menu-item-prices {\n  font-size: 4.5em; }\n\n.fmcy-thumbnail-item {\n  margin-bottom: 20px; }\n\n.leaflet-container .leaflet-control-attribution {\n  background: #fff;\n  background: rgba(255, 255, 255, 0.7);\n  margin: 0;\n  display: none; }\n\n.fmcy-menu-item-expanded .fmcy-product-strain-name {\n  text-align: left !important; }\n\n.et_pb_row {\n  background-color: #000; }\n\n.leaflet-control-zoom {\n  display: none; }\n\n.fmcy-menu-item-expanded .fmcy-potency-display {\n  font-size: 3em !important;\n  text-align: left !important; }\n\n.fmcy-menu-item-expanded .fmcy-item-description-text {\n  font-size: 2.25em !important;\n  line-height: 2em !important; }\n\n.fmcy-search-filters .fmcy-search-filter-caption {\n  font-size: 2.25em;\n  line-height: 2em;\n  padding-top: 36px;\n  color: #fff; }\n\n.fmcy-search-filters-item.sub-filters .fmcy-category-menu-item-text {\n  font-size: 1.25em; }\n\n.fmcy-menu-item-thumb .fmcy-menu-item-thumb-title {\n  font-size: 2em; }\n\n.fmcy-menu-item-thumb .fmcy-potency-display {\n  font-size: 1em; }\n\n.fmcy-menu-item-thumb .fmcy-product-strain-name {\n  font-size: 1em;\n  line-height: 1em; }\n\n.fmcy-menu-item-expanded .fmcy-menu-item-thumb-selector-region {\n  top: 350px !important; }\n\n.fmcy-menu-item-expanded .fmcy-product-strain-name {\n  font-size: 4em;\n  line-height: 2.2em; }\n\n.fmcy-menu-item-expanded .fmcy-menu-title {\n  padding-top: 140px; }\n\n#page-container {\n  padding-top: 80px !important; }\n\n.fmcy-category-header {\n  font-size: 2.75em !important;\n  line-height: 2em;\n  margin-top: 26px !important; }\n\n.fmcy-sub-category-item {\n  font-size: 2.25em !important;\n  line-height: 1.75em !important; }\n\n.fmcy-menu-items-region {\n  padding-top: 11px; }\n\n.fmcy-mega-menu-btn-close {\n  width: 78px !important;\n  height: 78px !important;\n  top: 130px !important;\n  right: 30px !important; }\n\n.fmcy-menu-item-expanded .fmcy-menu-container .fmcy-vendor-icon-region {\n  top: 120px !important; }\n", ""]);
	
	// exports


/***/ },
/* 1663 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)(false);
	// imports
	
	
	// module
	exports.push([module.id, "/*\n    IMPORTANT NOTES:\n\n    farmacy-menu-page-menu-section is a specific instance of the menu and this ID\n    is configured inside the DIVI theme editor\n\n*/\nbody .fmcy-plugin-bootstrap .modal {\n  background-color: rgba(0, 0, 0, 0.9); }\n  body .fmcy-plugin-bootstrap .modal .btn-primary {\n    color: #ffffff;\n    border-color: #4cb8be;\n    letter-spacing: 1px;\n    background-color: #4cb8be;\n    position: relative;\n    border: 2px solid #4cb8be;\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 160%; }\n  body .fmcy-plugin-bootstrap .modal .btn-default {\n    color: #ffffff;\n    border-color: #cccccc;\n    letter-spacing: 1px;\n    background-color: #cccccc;\n    position: relative;\n    border: 2px solid #cccccc;\n    font-family: \"bebasneue\", \"Arial\", sans-serif;\n    font-size: 160%; }\n  body .fmcy-plugin-bootstrap .modal .close {\n    background-color: #000 !important;\n    color: #fff;\n    width: 32px;\n    height: 32px;\n    opacity: 1;\n    border-radius: 5px;\n    font-size: 30px; }\n  body .fmcy-plugin-bootstrap .modal .modal-body {\n    padding-right: 50px; }\n  body .fmcy-plugin-bootstrap .modal .modal-content {\n    background-color: #2e302f;\n    color: #ffffff; }\n  body .fmcy-plugin-bootstrap .modal .modal-footer {\n    border-top: 1px solid #000 !important; }\n\nbody #et-main-area-modal {\n  position: fixed;\n  z-index: 2000;\n  height: 100%;\n  width: 100%;\n  pointer-events: none;\n  top: 0;\n  padding-top: 99px;\n  opacity: 0;\n  background-color: #000; }\n  body #et-main-area-modal.enableClick {\n    pointer-events: auto; }\n\n@media only screen and (max-width: 1100px) {\n  body #et-main-area-modal {\n    padding-top: 110px; } }\n\nbody #farm-complete-overlay-modal {\n  position: fixed;\n  z-index: 10000;\n  height: 100%;\n  width: 100%;\n  pointer-events: none;\n  top: 0;\n  opacity: 0;\n  background-color: #fff;\n  display: none;\n  padding-bottom: 74px; }\n  body #farm-complete-overlay-modal.enableClick {\n    pointer-events: auto; }\n  body #farm-complete-overlay-modal.darkTheme {\n    background-color: #000; }\n\nbody .farm-inline-modal-wrapper {\n  position: relative; }\n  body .farm-inline-modal-wrapper #farm-inline-modal {\n    position: fixed;\n    z-index: 5009;\n    height: 100%;\n    width: 100%;\n    pointer-events: none;\n    top: 99px;\n    opacity: 0;\n    display: none;\n    padding-bottom: 74px; }\n    body .farm-inline-modal-wrapper #farm-inline-modal.enableClick {\n      pointer-events: auto; }\n    body .farm-inline-modal-wrapper #farm-inline-modal.darkTheme {\n      background-color: #000; }\n  body .farm-inline-modal-wrapper #farm-sidebar-modal {\n    position: fixed;\n    z-index: 6000;\n    height: 100%;\n    width: 100%;\n    pointer-events: none;\n    top: 0;\n    opacity: 0;\n    display: none;\n    padding-bottom: 74px;\n    top: 99px; }\n    body .farm-inline-modal-wrapper #farm-sidebar-modal.enableClick {\n      pointer-events: auto; }\n  body .farm-inline-modal-wrapper #farm-search-modal {\n    position: fixed;\n    z-index: 6001;\n    height: 100%;\n    width: 100%;\n    pointer-events: none;\n    top: 99px;\n    opacity: 0;\n    display: none;\n    padding-bottom: 74px; }\n    body .farm-inline-modal-wrapper #farm-search-modal.enableClick {\n      pointer-events: auto; }\n  body .farm-inline-modal-wrapper #farm-mega-menu-modal {\n    position: fixed;\n    z-index: 6002;\n    height: 100%;\n    width: 100%;\n    pointer-events: none;\n    top: 99px;\n    opacity: 0;\n    display: none;\n    /*padding-bottom: 150px;*/ }\n    body .farm-inline-modal-wrapper #farm-mega-menu-modal.enableClick {\n      pointer-events: auto; }\n\n@media only screen and (max-width: 1100px) {\n  body .farm-inline-modal-wrapper #farm-search-modal {\n    top: 80px !important; }\n  body .farm-inline-modal-wrapper #farm-sidebar-modal {\n    top: 80px !important; }\n  body .farm-inline-modal-wrapper #farm-inline-modal {\n    top: 80px !important; }\n  body .farm-inline-modal-wrapper #farm-mega-menu-modal {\n    top: 110px !important; } }\n\n.farmacy-menu-overlay .tl-dialog {\n  z-index: 50001 !important; }\n\n.fmcy-page-not-found {\n  margin-bottom: 60px; }\n\n#wpadminbar.mobile #wp-admin-bar-new_draft {\n  display: none; }\n\n#wpadminbar.mobile #wp-admin-bar-my-account {\n  display: none; }\n\nBODY.admin-bar #farm-sidebar-modal {\n  top: 131px !important; }\n\nBODY.admin-bar #farm-search-modal {\n  top: 131px !important; }\n\nBODY.admin-bar #farm-inline-modal {\n  top: 131px !important; }\n\nBODY.admin-bar #farm-mega-menu-modal {\n  top: 131px !important; }\n\n@media only screen and (max-width: 1100px) {\n  BODY.admin-bar #farm-sidebar-modal {\n    top: 113px !important; }\n  BODY.admin-bar #farm-search-modal {\n    top: 113px !important; }\n  BODY.admin-bar #farm-inline-modal {\n    top: 113px !important; }\n  BODY.admin-bar #farm-mega-menu-modal {\n    top: 142px !important; } }\n\n@media only screen and (max-width: 782px) {\n  BODY.admin-bar #farm-sidebar-modal {\n    top: 125px !important; }\n  BODY.admin-bar #farm-search-modal {\n    top: 125px !important; }\n  BODY.admin-bar #farm-inline-modal {\n    top: 125px !important; }\n  BODY.admin-bar #farm-mega-menu-modal {\n    top: 156px !important; } }\n", ""]);
	
	// exports


/***/ },
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1662);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./elo-app.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./elo-app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1786 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1663);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./public-menu-app.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./public-menu-app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }
]);


/** WEBPACK FOOTER **
 ** public-menu-app-5345377819f9c58b1767.js
 **/